var DuckDB = (() => {
    var _scriptName = typeof document != 'undefined' ? document.currentScript?.src : undefined;
    if (typeof __filename != 'undefined') _scriptName = _scriptName || __filename;
    return (
        function(moduleArg = {}) {
            var moduleRtn;

            var Module = moduleArg;
            var readyPromiseResolve, readyPromiseReject;
            var readyPromise = new Promise((resolve, reject) => {
                readyPromiseResolve = resolve;
                readyPromiseReject = reject
            });
            var ENVIRONMENT_IS_WEB = typeof window == "object";
            var ENVIRONMENT_IS_WORKER = typeof WorkerGlobalScope != "undefined";
            var ENVIRONMENT_IS_NODE = typeof process == "object" && typeof process.versions == "object" && typeof process.versions.node == "string" && process.type != "renderer";
            var ENVIRONMENT_IS_SHELL = !ENVIRONMENT_IS_WEB && !ENVIRONMENT_IS_NODE && !ENVIRONMENT_IS_WORKER;
            if (ENVIRONMENT_IS_NODE) {}
            var moduleOverrides = Object.assign({}, Module);
            var arguments_ = [];
            var thisProgram = "./this.program";
            var quit_ = (status, toThrow) => {
                throw toThrow
            };
            var scriptDirectory = "";

            function locateFile(path) {
                if (Module["locateFile"]) {
                    return Module["locateFile"](path, scriptDirectory)
                }
                return scriptDirectory + path
            }
            var readAsync, readBinary;
            if (ENVIRONMENT_IS_NODE) {
                var fs = require("fs");
                var nodePath = require("path");
                scriptDirectory = __dirname + "/";
                readBinary = filename => {
                    filename = isFileURI(filename) ? new URL(filename) : nodePath.normalize(filename);
                    var ret = fs.readFileSync(filename);
                    return ret
                };
                readAsync = (filename, binary = true) => {
                    filename = isFileURI(filename) ? new URL(filename) : nodePath.normalize(filename);
                    return new Promise((resolve, reject) => {
                        fs.readFile(filename, binary ? undefined : "utf8", (err, data) => {
                            if (err) reject(err);
                            else resolve(binary ? data.buffer : data)
                        })
                    })
                };
                if (!Module["thisProgram"] && process.argv.length > 1) {
                    thisProgram = process.argv[1].replace(/\\/g, "/")
                }
                arguments_ = process.argv.slice(2);
                quit_ = (status, toThrow) => {
                    process.exitCode = status;
                    throw toThrow
                }
            } else if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
                if (ENVIRONMENT_IS_WORKER) {
                    scriptDirectory = self.location.href
                } else if (typeof document != "undefined" && document.currentScript) {
                    scriptDirectory = document.currentScript.src
                }
                if (_scriptName) {
                    scriptDirectory = _scriptName
                }
                if (scriptDirectory.startsWith("blob:")) {
                    scriptDirectory = ""
                } else {
                    scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, "").lastIndexOf("/") + 1)
                } {
                    if (ENVIRONMENT_IS_WORKER) {
                        readBinary = url => {
                            var xhr = new XMLHttpRequest;
                            xhr.open("GET", url, false);
                            xhr.responseType = "arraybuffer";
                            xhr.send(null);
                            return new Uint8Array(xhr.response)
                        }
                    }
                    readAsync = url => fetch(url, {
                        credentials: "same-origin"
                    }).then(response => {
                        if (response.ok) {
                            return response.arrayBuffer()
                        }
                        return Promise.reject(new Error(response.status + " : " + response.url))
                    })
                }
            } else {}
            var out = Module["print"] || console.log.bind(console);
            var err = Module["printErr"] || console.error.bind(console);
            Object.assign(Module, moduleOverrides);
            moduleOverrides = null;
            if (Module["arguments"]) arguments_ = Module["arguments"];
            if (Module["thisProgram"]) thisProgram = Module["thisProgram"];
            var dynamicLibraries = Module["dynamicLibraries"] || [];
            var wasmBinary = Module["wasmBinary"];
            var wasmMemory;
            var ABORT = false;
            var EXITSTATUS;

            function assert(condition, text) {
                if (!condition) {
                    abort(text)
                }
            }
            var HEAP, HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;

            function updateMemoryViews() {
                var b = wasmMemory.buffer;
                Module["HEAP8"] = HEAP8 = new Int8Array(b);
                Module["HEAP16"] = HEAP16 = new Int16Array(b);
                Module["HEAPU8"] = HEAPU8 = new Uint8Array(b);
                Module["HEAPU16"] = HEAPU16 = new Uint16Array(b);
                Module["HEAP32"] = HEAP32 = new Int32Array(b);
                Module["HEAPU32"] = HEAPU32 = new Uint32Array(b);
                Module["HEAPF32"] = HEAPF32 = new Float32Array(b);
                Module["HEAPF64"] = HEAPF64 = new Float64Array(b)
            }
            if (Module["wasmMemory"]) {
                wasmMemory = Module["wasmMemory"]
            } else {
                var INITIAL_MEMORY = Module["INITIAL_MEMORY"] || 16777216;
                wasmMemory = new WebAssembly.Memory({
                    initial: INITIAL_MEMORY / 65536,
                    maximum: 65536
                })
            }
            updateMemoryViews();
            var __ATPRERUN__ = [];
            var __ATINIT__ = [];
            var __ATMAIN__ = [];
            var __ATEXIT__ = [];
            var __ATPOSTRUN__ = [];
            var __RELOC_FUNCS__ = [];
            var runtimeInitialized = false;

            function preRun() {
                if (Module["preRun"]) {
                    if (typeof Module["preRun"] == "function") Module["preRun"] = [Module["preRun"]];
                    while (Module["preRun"].length) {
                        addOnPreRun(Module["preRun"].shift())
                    }
                }
                callRuntimeCallbacks(__ATPRERUN__)
            }

            function initRuntime() {
                runtimeInitialized = true;
                callRuntimeCallbacks(__RELOC_FUNCS__);
                if (!Module["noFSInit"] && !FS.initialized) FS.init();
                FS.ignorePermissions = false;
                TTY.init();
                SOCKFS.root = FS.mount(SOCKFS, {}, null);
                PIPEFS.root = FS.mount(PIPEFS, {}, null);
                callRuntimeCallbacks(__ATINIT__)
            }

            function preMain() {
                callRuntimeCallbacks(__ATMAIN__)
            }

            function postRun() {
                if (Module["postRun"]) {
                    if (typeof Module["postRun"] == "function") Module["postRun"] = [Module["postRun"]];
                    while (Module["postRun"].length) {
                        addOnPostRun(Module["postRun"].shift())
                    }
                }
                callRuntimeCallbacks(__ATPOSTRUN__)
            }

            function addOnPreRun(cb) {
                __ATPRERUN__.unshift(cb)
            }

            function addOnInit(cb) {
                __ATINIT__.unshift(cb)
            }

            function addOnPreMain(cb) {
                __ATMAIN__.unshift(cb)
            }

            function addOnExit(cb) {}

            function addOnPostRun(cb) {
                __ATPOSTRUN__.unshift(cb)
            }
            var runDependencies = 0;
            var runDependencyWatcher = null;
            var dependenciesFulfilled = null;

            function getUniqueRunDependency(id) {
                return id
            }

            function addRunDependency(id) {
                runDependencies++;
                Module["monitorRunDependencies"]?.(runDependencies)
            }

            function removeRunDependency(id) {
                runDependencies--;
                Module["monitorRunDependencies"]?.(runDependencies);
                if (runDependencies == 0) {
                    if (runDependencyWatcher !== null) {
                        clearInterval(runDependencyWatcher);
                        runDependencyWatcher = null
                    }
                    if (dependenciesFulfilled) {
                        var callback = dependenciesFulfilled;
                        dependenciesFulfilled = null;
                        callback()
                    }
                }
            }

            function abort(what) {
                Module["onAbort"]?.(what);
                what = "Aborted(" + what + ")";
                err(what);
                ABORT = true;
                what += ". Build with -sASSERTIONS for more info.";
                if (runtimeInitialized) {
                    ___trap()
                }
                var e = new WebAssembly.RuntimeError(what);
                readyPromiseReject(e);
                throw e
            }
            var dataURIPrefix = "data:application/octet-stream;base64,";
            var isDataURI = filename => filename.startsWith(dataURIPrefix);
            var isFileURI = filename => filename.startsWith("file://");

            function findWasmBinary() {
                var f = "./duckdb-eh.wasm";
                if (!isDataURI(f)) {
                    return locateFile(f)
                }
                return f
            }
            var wasmBinaryFile;

            function getBinarySync(file) {
                if (file == wasmBinaryFile && wasmBinary) {
                    return new Uint8Array(wasmBinary)
                }
                if (readBinary) {
                    return readBinary(file)
                }
                throw "both async and sync fetching of the wasm failed"
            }

            function getBinaryPromise(binaryFile) {
                if (!wasmBinary) {
                    return readAsync(binaryFile).then(response => new Uint8Array(response), () => getBinarySync(binaryFile))
                }
                return Promise.resolve().then(() => getBinarySync(binaryFile))
            }

            function instantiateArrayBuffer(binaryFile, imports, receiver) {
                return getBinaryPromise(binaryFile).then(binary => WebAssembly.instantiate(binary, imports)).then(receiver, reason => {
                    err(`failed to asynchronously prepare wasm: ${reason}`);
                    abort(reason)
                })
            }

            function instantiateAsync(binary, binaryFile, imports, callback) {
                if (!binary && typeof WebAssembly.instantiateStreaming == "function" && !isDataURI(binaryFile) && !ENVIRONMENT_IS_NODE && typeof fetch == "function") {
                    return fetch(binaryFile, {
                        credentials: "same-origin"
                    }).then(response => {
                        var result = WebAssembly.instantiateStreaming(response, imports);
                        return result.then(callback, function(reason) {
                            err(`wasm streaming compile failed: ${reason}`);
                            err("falling back to ArrayBuffer instantiation");
                            return instantiateArrayBuffer(binaryFile, imports, callback)
                        })
                    })
                }
                return instantiateArrayBuffer(binaryFile, imports, callback)
            }

            function getWasmImports() {
                return {
                    env: wasmImports,
                    wasi_snapshot_preview1: wasmImports,
                    "GOT.mem": new Proxy(wasmImports, GOTHandler),
                    "GOT.func": new Proxy(wasmImports, GOTHandler)
                }
            }

            function createWasm() {
                var info = getWasmImports();

                function receiveInstance(instance, module) {
                    wasmExports = instance.exports;
                    wasmExports = relocateExports(wasmExports, 1024);
                    var metadata = getDylinkMetadata(module);
                    if (metadata.neededDynlibs) {
                        dynamicLibraries = metadata.neededDynlibs.concat(dynamicLibraries)
                    }
                    mergeLibSymbols(wasmExports, "main");
                    LDSO.init();
                    loadDylibs();
                    wasmExports = applySignatureConversions(wasmExports);
                    addOnInit(wasmExports["__wasm_call_ctors"]);
                    __RELOC_FUNCS__.push(wasmExports["__wasm_apply_data_relocs"]);
                    removeRunDependency("wasm-instantiate");
                    return wasmExports
                }
                addRunDependency("wasm-instantiate");

                function receiveInstantiationResult(result) {
                    receiveInstance(result["instance"], result["module"])
                }
                if (Module["instantiateWasm"]) {
                    try {
                        return Module["instantiateWasm"](info, receiveInstance)
                    } catch (e) {
                        err(`Module.instantiateWasm callback failed with error: ${e}`);
                        readyPromiseReject(e)
                    }
                }
                wasmBinaryFile ??= findWasmBinary();
                instantiateAsync(wasmBinary, wasmBinaryFile, info, receiveInstantiationResult).catch(readyPromiseReject);
                return {}
            }
            var tempDouble;
            var tempI64;
            var ASM_CONSTS = {
                2538488: ($0, $1, $2, $3) => {
                    var url = UTF8ToString($0);
                    if (typeof XMLHttpRequest === "undefined") {
                        return 0
                    }
                    const xhr = new XMLHttpRequest;
                    if (false && url.startsWith("http://")) {
                        url = "https://" + url.substr(7)
                    }
                    xhr.open(UTF8ToString($3), url, false);
                    xhr.responseType = "arraybuffer";
                    var i = 0;
                    var len = $1;
                    while (i < len * 2) {
                        var ptr1 = HEAP32[$2 / 4 + i >>> 0];
                        var ptr2 = HEAP32[$2 / 4 + i + 1 >>> 0];
                        try {
                            var z = encodeURI(UTF8ToString(ptr1));
                            if (z === "Host") z = "X-Host-Override";
                            if (z === "User-Agent") {} else if (z === "Authorization") {
                                xhr.setRequestHeader(z, UTF8ToString(ptr2))
                            } else {
                                xhr.setRequestHeader(z, encodeURI(UTF8ToString(ptr2)))
                            }
                        } catch (error) {
                            console.warn("Error while performing XMLHttpRequest.setRequestHeader()", error)
                        }
                        i += 2
                    }
                    try {
                        xhr.send(null)
                    } catch {
                        return 0
                    }
                    if (xhr.status >= 400) return 0;
                    var uInt8Array = xhr.response;
                    var len = uInt8Array.byteLength;
                    var fileOnWasmHeap = _malloc(len + 8);
                    var properArray = new Uint8Array(uInt8Array);
                    for (var iii = 0; iii < len; iii++) {
                        Module.HEAPU8[iii + fileOnWasmHeap + 8] = properArray[iii]
                    }
                    var LEN123 = new Uint8Array(4);
                    LEN123[0] = len % 256;
                    len -= LEN123[0];
                    len /= 256;
                    LEN123[1] = len % 256;
                    len -= LEN123[1];
                    len /= 256;
                    LEN123[2] = len % 256;
                    len -= LEN123[2];
                    len /= 256;
                    LEN123[3] = len % 256;
                    len -= LEN123[3];
                    len /= 256;
                    Module.HEAPU8.set(LEN123, fileOnWasmHeap + 4);
                    var headers = Uint8Array.from(Array.from(xhr.getAllResponseHeaders()).map(letter => letter.charCodeAt(0)));
                    len = headers.byteLength;
                    var headersOnWasmHeap = _malloc(len + 8);
                    for (var iii = 0; iii < len; iii++) {
                        Module.HEAPU8[iii + headersOnWasmHeap + 8] = headers[iii]
                    }
                    LEN123 = new Uint8Array(4);
                    LEN123[0] = len % 256;
                    len -= LEN123[0];
                    len /= 256;
                    LEN123[1] = len % 256;
                    len -= LEN123[1];
                    len /= 256;
                    LEN123[2] = len % 256;
                    len -= LEN123[2];
                    len /= 256;
                    LEN123[3] = len % 256;
                    len -= LEN123[3];
                    len /= 256;
                    Module.HEAPU8.set(LEN123, headersOnWasmHeap + 4);
                    len = headersOnWasmHeap;
                    LEN123 = new Uint8Array(4);
                    LEN123[0] = len % 256;
                    len -= LEN123[0];
                    len /= 256;
                    LEN123[1] = len % 256;
                    len -= LEN123[1];
                    len /= 256;
                    LEN123[2] = len % 256;
                    len -= LEN123[2];
                    len /= 256;
                    LEN123[3] = len % 256;
                    len -= LEN123[3];
                    len /= 256;
                    Module.HEAPU8.set(LEN123, fileOnWasmHeap);
                    return fileOnWasmHeap
                },
                2540760: ($0, $1, $2, $3, $4, $5) => {
                    var url = UTF8ToString($0);
                    if (typeof XMLHttpRequest === "undefined") {
                        return 0
                    }
                    const xhr = new XMLHttpRequest;
                    if (false && url.startsWith("http://")) {
                        url = "https://" + url.substr(7)
                    }
                    xhr.open(UTF8ToString($3), url, false);
                    xhr.responseType = "arraybuffer";
                    var i = 0;
                    var len = $1;
                    while (i < len * 2) {
                        var ptr1 = HEAP32[$2 / 4 + i >>> 0];
                        var ptr2 = HEAP32[$2 / 4 + i + 1 >>> 0];
                        try {
                            var z = encodeURI(UTF8ToString(ptr1));
                            if (z === "Host") z = "X-Host-Override";
                            if (z === "User-Agent") {} else if (z === "Authorization") {
                                xhr.setRequestHeader(z, UTF8ToString(ptr2))
                            } else {
                                xhr.setRequestHeader(z, encodeURI(UTF8ToString(ptr2)))
                            }
                        } catch (error) {
                            console.warn("Error while performing XMLHttpRequest.setRequestHeader()", error)
                        }
                        i += 2
                    }
                    try {
                        var post_payload = new Uint8Array($5);
                        for (var iii = 0; iii < $5; iii++) {
                            post_payload[iii] = Module.HEAPU8[iii + $4]
                        }
                        xhr.send(post_payload)
                    } catch {
                        return 0
                    }
                    if (xhr.status >= 400) return 0;
                    var uInt8Array = Uint8Array.from(Array.from(xhr.getResponseHeader("Etag")).map(letter => letter.charCodeAt(0)));
                    var len = uInt8Array.byteLength;
                    var fileOnWasmHeap = _malloc(len + 4);
                    var properArray = new Uint8Array(uInt8Array);
                    for (var iii = 0; iii < len; iii++) {
                        Module.HEAPU8[iii + fileOnWasmHeap + 4] = properArray[iii]
                    }
                    var LEN123 = new Uint8Array(4);
                    LEN123[0] = len % 256;
                    len -= LEN123[0];
                    len /= 256;
                    LEN123[1] = len % 256;
                    len -= LEN123[1];
                    len /= 256;
                    LEN123[2] = len % 256;
                    len -= LEN123[2];
                    len /= 256;
                    LEN123[3] = len % 256;
                    len -= LEN123[3];
                    len /= 256;
                    Module.HEAPU8.set(LEN123, fileOnWasmHeap);
                    return fileOnWasmHeap
                },
                2542368: ($0, $1, $2, $3) => {
                    var url = UTF8ToString($0);
                    if (typeof XMLHttpRequest === "undefined") {
                        return 0
                    }
                    const xhr = new XMLHttpRequest;
                    if (false && url.startsWith("http://")) {
                        url = "https://" + url.substr(7)
                    }
                    xhr.open(UTF8ToString($3), url, false);
                    xhr.responseType = "arraybuffer";
                    var i = 0;
                    var len = $1;
                    while (i < len * 2) {
                        var ptr1 = HEAP32[$2 / 4 + i >>> 0];
                        var ptr2 = HEAP32[$2 / 4 + i + 1 >>> 0];
                        console.log("HEAD", UTF8ToString(ptr1), UTF8ToString(ptr2));
                        try {
                            var z = encodeURI(UTF8ToString(ptr1));
                            if (z === "Host") z = "X-Host-Override";
                            if (z === "User-Agent") {} else if (z === "Authorization") {
                                xhr.setRequestHeader(z, UTF8ToString(ptr2))
                            } else {
                                xhr.setRequestHeader(z, encodeURI(UTF8ToString(ptr2)))
                            }
                        } catch (error) {
                            console.warn("Error while performing XMLHttpRequest.setRequestHeader()", error)
                        }
                        i += 2
                    }
                    try {
                        xhr.send(null)
                    } catch {
                        return 0
                    }
                    if (xhr.status >= 400) return 0;
                    var uInt8Array = xhr.response;
                    var len = uInt8Array.byteLength;
                    var fileOnWasmHeap = _malloc(len + 8);
                    var properArray = new Uint8Array(uInt8Array);
                    for (var iii = 0; iii < len; iii++) {
                        Module.HEAPU8[iii + fileOnWasmHeap + 8] = properArray[iii]
                    }
                    var LEN123 = new Uint8Array(4);
                    LEN123[0] = len % 256;
                    len -= LEN123[0];
                    len /= 256;
                    LEN123[1] = len % 256;
                    len -= LEN123[1];
                    len /= 256;
                    LEN123[2] = len % 256;
                    len -= LEN123[2];
                    len /= 256;
                    LEN123[3] = len % 256;
                    len -= LEN123[3];
                    len /= 256;
                    Module.HEAPU8.set(LEN123, fileOnWasmHeap + 4);
                    var headers = Uint8Array.from(Array.from(xhr.getAllResponseHeaders()).map(letter => letter.charCodeAt(0)));
                    len = headers.byteLength;
                    var headersOnWasmHeap = _malloc(len + 8);
                    for (var iii = 0; iii < len; iii++) {
                        Module.HEAPU8[iii + headersOnWasmHeap + 8] = headers[iii]
                    }
                    LEN123 = new Uint8Array(4);
                    LEN123[0] = len % 256;
                    len -= LEN123[0];
                    len /= 256;
                    LEN123[1] = len % 256;
                    len -= LEN123[1];
                    len /= 256;
                    LEN123[2] = len % 256;
                    len -= LEN123[2];
                    len /= 256;
                    LEN123[3] = len % 256;
                    len -= LEN123[3];
                    len /= 256;
                    Module.HEAPU8.set(LEN123, headersOnWasmHeap + 4);
                    len = headersOnWasmHeap;
                    LEN123 = new Uint8Array(4);
                    LEN123[0] = len % 256;
                    len -= LEN123[0];
                    len /= 256;
                    LEN123[1] = len % 256;
                    len -= LEN123[1];
                    len /= 256;
                    LEN123[2] = len % 256;
                    len -= LEN123[2];
                    len /= 256;
                    LEN123[3] = len % 256;
                    len -= LEN123[3];
                    len /= 256;
                    Module.HEAPU8.set(LEN123, fileOnWasmHeap);
                    return fileOnWasmHeap
                },
                2544701: ($0, $1, $2, $3) => {
                    var url = UTF8ToString($0);
                    if (typeof XMLHttpRequest === "undefined") {
                        return 0
                    }
                    const xhr = new XMLHttpRequest;
                    if (false && url.startsWith("http://")) {
                        url = "https://" + url.substr(7)
                    }
                    xhr.open(UTF8ToString($3), url, false);
                    xhr.responseType = "arraybuffer";
                    var i = 0;
                    var len = $1;
                    while (i < len * 2) {
                        var ptr1 = HEAP32[$2 / 4 + i >>> 0];
                        var ptr2 = HEAP32[$2 / 4 + i + 1 >>> 0];
                        try {
                            var z = encodeURI(UTF8ToString(ptr1));
                            if (z === "Host") z = "X-Host-Override";
                            if (z === "User-Agent") {} else if (z === "Authorization") {
                                xhr.setRequestHeader(z, UTF8ToString(ptr2))
                            } else {
                                xhr.setRequestHeader(z, encodeURI(UTF8ToString(ptr2)))
                            }
                        } catch (error) {
                            console.warn("Error while performing XMLHttpRequest.setRequestHeader()", error)
                        }
                        i += 2
                    }
                    try {
                        xhr.send(null)
                    } catch {
                        return 0
                    }
                    if (xhr.status >= 400) return 0;
                    var uInt8Array = xhr.response;
                    var len = uInt8Array.byteLength;
                    var fileOnWasmHeap = _malloc(len + 4);
                    var properArray = new Uint8Array(uInt8Array);
                    for (var iii = 0; iii < len; iii++) {
                        Module.HEAPU8[iii + fileOnWasmHeap + 4] = properArray[iii]
                    }
                    var LEN123 = new Uint8Array(4);
                    LEN123[0] = len % 256;
                    len -= LEN123[0];
                    len /= 256;
                    LEN123[1] = len % 256;
                    len -= LEN123[1];
                    len /= 256;
                    LEN123[2] = len % 256;
                    len -= LEN123[2];
                    len /= 256;
                    LEN123[3] = len % 256;
                    len -= LEN123[3];
                    len /= 256;
                    Module.HEAPU8.set(LEN123, fileOnWasmHeap);
                    return fileOnWasmHeap
                },
                2546096: ($0, $1, $2, $3, $4, $5) => {
                    var url = UTF8ToString($0);
                    if (typeof XMLHttpRequest === "undefined") {
                        return 0
                    }
                    const xhr = new XMLHttpRequest;
                    if (false && url.startsWith("http://")) {
                        url = "https://" + url.substr(7)
                    }
                    xhr.open(UTF8ToString($3), url, false);
                    xhr.responseType = "arraybuffer";
                    var i = 0;
                    var len = $1;
                    while (i < len * 2) {
                        var ptr1 = HEAP32[$2 / 4 + i >>> 0];
                        var ptr2 = HEAP32[$2 / 4 + i + 1 >>> 0];
                        try {
                            var z = encodeURI(UTF8ToString(ptr1));
                            if (z === "Host") z = "X-Host-Override";
                            if (z === "User-Agent") {} else if (z === "Authorization") {
                                xhr.setRequestHeader(z, UTF8ToString(ptr2))
                            } else {
                                xhr.setRequestHeader(z, encodeURI(UTF8ToString(ptr2)))
                            }
                        } catch (error) {
                            console.warn("Error while performing XMLHttpRequest.setRequestHeader()", error)
                        }
                        i += 2
                    }
                    try {
                        var post_payload = new Uint8Array($5);
                        for (var iii = 0; iii < $5; iii++) {
                            post_payload[iii] = Module.HEAPU8[iii + $4]
                        }
                        xhr.send(post_payload)
                    } catch {
                        return 0
                    }
                    if (xhr.status >= 400) return 0;
                    var uInt8Array = xhr.response;
                    var len = uInt8Array.byteLength;
                    var fileOnWasmHeap = _malloc(len + 4);
                    var properArray = new Uint8Array(uInt8Array);
                    for (var iii = 0; iii < len; iii++) {
                        Module.HEAPU8[iii + fileOnWasmHeap + 4] = properArray[iii]
                    }
                    var LEN123 = new Uint8Array(4);
                    LEN123[0] = len % 256;
                    len -= LEN123[0];
                    len /= 256;
                    LEN123[1] = len % 256;
                    len -= LEN123[1];
                    len /= 256;
                    LEN123[2] = len % 256;
                    len -= LEN123[2];
                    len /= 256;
                    LEN123[3] = len % 256;
                    len -= LEN123[3];
                    len /= 256;
                    Module.HEAPU8.set(LEN123, fileOnWasmHeap);
                    return fileOnWasmHeap
                },
                2547622: ($0, $1) => {
                    var jsString = typeof runtime == "object" && runtime && typeof runtime.whereToLoad == "function" && runtime.whereToLoad ? runtime.whereToLoad(UTF8ToString($0)) : UTF8ToString($1);
                    var lengthBytes = lengthBytesUTF8(jsString) + 1;
                    var stringOnWasmHeap = _malloc(lengthBytes);
                    stringToUTF8(jsString, stringOnWasmHeap, lengthBytes);
                    return stringOnWasmHeap
                },
                2547988: ($0, $1) => {
                    var url = UTF8ToString($0);
                    if (typeof XMLHttpRequest === "undefined") {
                        const os = require("os");
                        const path = require("path");
                        const fs = require("fs");
                        var array = url.split("/");
                        var l = array.length;
                        var folder = path.join(os.homedir(), ".duckdb/extensions/" + array[l - 4] + "/" + array[l - 3] + "/" + array[l - 2] + "/");
                        var filePath = path.join(folder, array[l - 1]);
                        try {
                            if (!fs.existsSync(folder)) {
                                fs.mkdirSync(folder, {
                                    recursive: true
                                })
                            }
                            if (!fs.existsSync(filePath)) {
                                const int32 = new Int32Array(new SharedArrayBuffer(8));
                                var Worker = require("node:worker_threads").Worker;
                                var worker = new Worker("const {Worker,isMainThread,parentPort,workerData,} = require('node:worker_threads');var times = 0;var SAB = 23;var Z = 0; async function ZZZ(e) {var x = await fetch(e);var res = await x.arrayBuffer();Atomics.store(SAB, 1, res.byteLength);Atomics.store(SAB, 0, 1);Atomics.notify(SAB, 1);Atomics.notify(SAB, 0);Z = res;};parentPort.on('message', function(event) {if (times == 0) {times++;SAB = event;} else if (times == 1) {times++; ZZZ(event);} else {const a = new Uint8Array(Z);const b = new Uint8Array(event.buffer);var K = Z.byteLength;for (var i = 0; i < K; i++) {b[i] = a[i];}Atomics.notify(event, 0);Atomics.store(SAB, 0, 2);Atomics.notify(SAB, 0);}});", {
                                    eval: true
                                });
                                var uInt8Array;
                                int32[0] = 0;
                                int32[2] = 4;
                                worker.postMessage(int32);
                                worker.postMessage(url);
                                Atomics.wait(int32, 0, 0);
                                const int32_2 = new Int32Array(new SharedArrayBuffer(int32[1] + 3 - (int32[1] + 3) % 4));
                                worker.postMessage(int32_2);
                                Atomics.wait(int32, 0, 1);
                                var x = new Uint8Array(int32_2.buffer, 0, int32[1]);
                                uInt8Array = x;
                                worker.terminate();
                                fs.writeFileSync(filePath, uInt8Array)
                            } else {
                                uInt8Array = fs.readFileSync(filePath)
                            }
                        } catch (e) {
                            console.log("Error fetching module", e);
                            return 0
                        }
                    } else {
                        const xhr = new XMLHttpRequest;
                        xhr.open("GET", url, false);
                        xhr.responseType = "arraybuffer";
                        xhr.send(null);
                        if (xhr.status != 200) return 0;
                        uInt8Array = xhr.response
                    }
                    var valid = WebAssembly.validate(uInt8Array);
                    var len = uInt8Array.byteLength;
                    var fileOnWasmHeap = _malloc(len + 4);
                    var properArray = new Uint8Array(uInt8Array);
                    for (var iii = 0; iii < len; iii++) {
                        Module.HEAPU8[iii + fileOnWasmHeap + 4] = properArray[iii]
                    }
                    var LEN123 = new Uint8Array(4);
                    LEN123[0] = len % 256;
                    len -= LEN123[0];
                    len /= 256;
                    LEN123[1] = len % 256;
                    len -= LEN123[1];
                    len /= 256;
                    LEN123[2] = len % 256;
                    len -= LEN123[2];
                    len /= 256;
                    LEN123[3] = len % 256;
                    len -= LEN123[3];
                    len /= 256;
                    Module.HEAPU8.set(LEN123, fileOnWasmHeap);
                    FS.writeFile(UTF8ToString($1), new Uint8Array(uInt8Array));
                    return fileOnWasmHeap
                },
                2550629: $0 => {
                    if (!$0) {
                        AL.alcErr = 40964;
                        return 1
                    }
                },
                2550677: $0 => {
                    if (!AL.currentCtx) {
                        err("alGetProcAddress() called without a valid context");
                        return 1
                    }
                    if (!$0) {
                        AL.currentCtx.err = 40963;
                        return 1
                    }
                }
            };
            class ExitStatus {
                name = "ExitStatus";
                constructor(status) {
                    this.message = `Program terminated with exit(${status})`;
                    this.status = status
                }
            }
            var GOT = {};
            var currentModuleWeakSymbols = new Set([]);
            var GOTHandler = {
                get(obj, symName) {
                    var rtn = GOT[symName];
                    if (!rtn) {
                        rtn = GOT[symName] = new WebAssembly.Global({
                            value: "i32",
                            mutable: true
                        })
                    }
                    if (!currentModuleWeakSymbols.has(symName)) {
                        rtn.required = true
                    }
                    return rtn
                }
            };
            var callRuntimeCallbacks = callbacks => {
                while (callbacks.length > 0) {
                    callbacks.shift()(Module)
                }
            };
            var UTF8Decoder = typeof TextDecoder != "undefined" ? new TextDecoder : undefined;
            var UTF8ArrayToString = (heapOrArray, idx = 0, maxBytesToRead = NaN) => {
                idx >>>= 0;
                var endIdx = idx + maxBytesToRead;
                var endPtr = idx;
                while (heapOrArray[endPtr] && !(endPtr >= endIdx)) ++endPtr;
                if (endPtr - idx > 16 && heapOrArray.buffer && UTF8Decoder) {
                    return UTF8Decoder.decode(heapOrArray.subarray(idx, endPtr))
                }
                var str = "";
                while (idx < endPtr) {
                    var u0 = heapOrArray[idx++];
                    if (!(u0 & 128)) {
                        str += String.fromCharCode(u0);
                        continue
                    }
                    var u1 = heapOrArray[idx++] & 63;
                    if ((u0 & 224) == 192) {
                        str += String.fromCharCode((u0 & 31) << 6 | u1);
                        continue
                    }
                    var u2 = heapOrArray[idx++] & 63;
                    if ((u0 & 240) == 224) {
                        u0 = (u0 & 15) << 12 | u1 << 6 | u2
                    } else {
                        u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | heapOrArray[idx++] & 63
                    }
                    if (u0 < 65536) {
                        str += String.fromCharCode(u0)
                    } else {
                        var ch = u0 - 65536;
                        str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023)
                    }
                }
                return str
            };
            var getDylinkMetadata = binary => {
                var offset = 0;
                var end = 0;

                function getU8() {
                    return binary[offset++]
                }

                function getLEB() {
                    var ret = 0;
                    var mul = 1;
                    while (1) {
                        var byte = binary[offset++];
                        ret += (byte & 127) * mul;
                        mul *= 128;
                        if (!(byte & 128)) break
                    }
                    return ret
                }

                function getString() {
                    var len = getLEB();
                    offset += len;
                    return UTF8ArrayToString(binary, offset - len, len)
                }

                function failIf(condition, message) {
                    if (condition) throw new Error(message)
                }
                var name = "dylink.0";
                if (binary instanceof WebAssembly.Module) {
                    var dylinkSection = WebAssembly.Module.customSections(binary, name);
                    if (dylinkSection.length === 0) {
                        name = "dylink";
                        dylinkSection = WebAssembly.Module.customSections(binary, name)
                    }
                    failIf(dylinkSection.length === 0, "need dylink section");
                    binary = new Uint8Array(dylinkSection[0]);
                    end = binary.length
                } else {
                    var int32View = new Uint32Array(new Uint8Array(binary.subarray(0, 24)).buffer);
                    var magicNumberFound = int32View[0] == 1836278016;
                    failIf(!magicNumberFound, "need to see wasm magic number");
                    failIf(binary[8] !== 0, "need the dylink section to be first");
                    offset = 9;
                    var section_size = getLEB();
                    end = offset + section_size;
                    name = getString()
                }
                var customSection = {
                    neededDynlibs: [],
                    tlsExports: new Set,
                    weakImports: new Set
                };
                if (name == "dylink") {
                    customSection.memorySize = getLEB();
                    customSection.memoryAlign = getLEB();
                    customSection.tableSize = getLEB();
                    customSection.tableAlign = getLEB();
                    var neededDynlibsCount = getLEB();
                    for (var i = 0; i < neededDynlibsCount; ++i) {
                        var libname = getString();
                        customSection.neededDynlibs.push(libname)
                    }
                } else {
                    failIf(name !== "dylink.0");
                    var WASM_DYLINK_MEM_INFO = 1;
                    var WASM_DYLINK_NEEDED = 2;
                    var WASM_DYLINK_EXPORT_INFO = 3;
                    var WASM_DYLINK_IMPORT_INFO = 4;
                    var WASM_SYMBOL_TLS = 256;
                    var WASM_SYMBOL_BINDING_MASK = 3;
                    var WASM_SYMBOL_BINDING_WEAK = 1;
                    while (offset < end) {
                        var subsectionType = getU8();
                        var subsectionSize = getLEB();
                        if (subsectionType === WASM_DYLINK_MEM_INFO) {
                            customSection.memorySize = getLEB();
                            customSection.memoryAlign = getLEB();
                            customSection.tableSize = getLEB();
                            customSection.tableAlign = getLEB()
                        } else if (subsectionType === WASM_DYLINK_NEEDED) {
                            var neededDynlibsCount = getLEB();
                            for (var i = 0; i < neededDynlibsCount; ++i) {
                                libname = getString();
                                customSection.neededDynlibs.push(libname)
                            }
                        } else if (subsectionType === WASM_DYLINK_EXPORT_INFO) {
                            var count = getLEB();
                            while (count--) {
                                var symname = getString();
                                var flags = getLEB();
                                if (flags & WASM_SYMBOL_TLS) {
                                    customSection.tlsExports.add(symname)
                                }
                            }
                        } else if (subsectionType === WASM_DYLINK_IMPORT_INFO) {
                            var count = getLEB();
                            while (count--) {
                                var modname = getString();
                                var symname = getString();
                                var flags = getLEB();
                                if ((flags & WASM_SYMBOL_BINDING_MASK) == WASM_SYMBOL_BINDING_WEAK) {
                                    customSection.weakImports.add(symname)
                                }
                            }
                        } else {
                            offset += subsectionSize
                        }
                    }
                }
                return customSection
            };

            function getValue(ptr, type = "i8") {
                if (type.endsWith("*")) type = "*";
                switch (type) {
                    case "i1":
                        return HEAP8[ptr >>> 0];
                    case "i8":
                        return HEAP8[ptr >>> 0];
                    case "i16":
                        return HEAP16[ptr >>> 1 >>> 0];
                    case "i32":
                        return HEAP32[ptr >>> 2 >>> 0];
                    case "i64":
                        abort("to do getValue(i64) use WASM_BIGINT");
                    case "float":
                        return HEAPF32[ptr >>> 2 >>> 0];
                    case "double":
                        return HEAPF64[ptr >>> 3 >>> 0];
                    case "*":
                        return HEAPU32[ptr >>> 2 >>> 0];
                    default:
                        abort(`invalid type for getValue: ${type}`)
                }
            }
            var newDSO = (name, handle, syms) => {
                var dso = {
                    refcount: Infinity,
                    name,
                    exports: syms,
                    global: true
                };
                LDSO.loadedLibsByName[name] = dso;
                if (handle != undefined) {
                    LDSO.loadedLibsByHandle[handle] = dso
                }
                return dso
            };
            var LDSO = {
                loadedLibsByName: {},
                loadedLibsByHandle: {},
                init() {
                    newDSO("__main__", 0, wasmImports)
                }
            };
            var ___heap_base = 3689088;
            var alignMemory = (size, alignment) => Math.ceil(size / alignment) * alignment;
            var getMemory = size => {
                if (runtimeInitialized) {
                    return _calloc(size, 1)
                }
                var ret = ___heap_base;
                var end = ret + alignMemory(size, 16);
                ___heap_base = end;
                GOT["__heap_base"].value = end;
                return ret
            };
            var isInternalSym = symName => ["__cpp_exception", "__c_longjmp", "__wasm_apply_data_relocs", "__dso_handle", "__tls_size", "__tls_align", "__set_stack_limits", "_emscripten_tls_init", "__wasm_init_tls", "__wasm_call_ctors", "__start_em_asm", "__stop_em_asm", "__start_em_js", "__stop_em_js"].includes(symName) || symName.startsWith("__em_js__");
            var uleb128Encode = (n, target) => {
                if (n < 128) {
                    target.push(n)
                } else {
                    target.push(n % 128 | 128, n >> 7)
                }
            };
            var sigToWasmTypes = sig => {
                var typeNames = {
                    i: "i32",
                    j: "i64",
                    f: "f32",
                    d: "f64",
                    e: "externref",
                    p: "i32"
                };
                var type = {
                    parameters: [],
                    results: sig[0] == "v" ? [] : [typeNames[sig[0]]]
                };
                for (var i = 1; i < sig.length; ++i) {
                    type.parameters.push(typeNames[sig[i]])
                }
                return type
            };
            var generateFuncType = (sig, target) => {
                var sigRet = sig.slice(0, 1);
                var sigParam = sig.slice(1);
                var typeCodes = {
                    i: 127,
                    p: 127,
                    j: 126,
                    f: 125,
                    d: 124,
                    e: 111
                };
                target.push(96);
                uleb128Encode(sigParam.length, target);
                for (var i = 0; i < sigParam.length; ++i) {
                    target.push(typeCodes[sigParam[i]])
                }
                if (sigRet == "v") {
                    target.push(0)
                } else {
                    target.push(1, typeCodes[sigRet])
                }
            };
            var convertJsFunctionToWasm = (func, sig) => {
                if (typeof WebAssembly.Function == "function") {
                    return new WebAssembly.Function(sigToWasmTypes(sig), func)
                }
                var typeSectionBody = [1];
                generateFuncType(sig, typeSectionBody);
                var bytes = [0, 97, 115, 109, 1, 0, 0, 0, 1];
                uleb128Encode(typeSectionBody.length, bytes);
                bytes.push(...typeSectionBody);
                bytes.push(2, 7, 1, 1, 101, 1, 102, 0, 0, 7, 5, 1, 1, 102, 0, 0);
                var module = new WebAssembly.Module(new Uint8Array(bytes));
                var instance = new WebAssembly.Instance(module, {
                    e: {
                        f: func
                    }
                });
                var wrappedFunc = instance.exports["f"];
                return wrappedFunc
            };
            var wasmTable = new WebAssembly.Table({
                initial: 25636,
                element: "anyfunc"
            });
            var getWasmTableEntry = funcPtr => wasmTable.get(funcPtr);
            var updateTableMap = (offset, count) => {
                if (functionsInTableMap) {
                    for (var i = offset; i < offset + count; i++) {
                        var item = getWasmTableEntry(i);
                        if (item) {
                            functionsInTableMap.set(item, i)
                        }
                    }
                }
            };
            var functionsInTableMap;
            var getFunctionAddress = func => {
                if (!functionsInTableMap) {
                    functionsInTableMap = new WeakMap;
                    updateTableMap(0, wasmTable.length)
                }
                return functionsInTableMap.get(func) || 0
            };
            var freeTableIndexes = [];
            var getEmptyTableSlot = () => {
                if (freeTableIndexes.length) {
                    return freeTableIndexes.pop()
                }
                try {
                    wasmTable.grow(1)
                } catch (err) {
                    if (!(err instanceof RangeError)) {
                        throw err
                    }
                    throw "Unable to grow wasm table. Set ALLOW_TABLE_GROWTH."
                }
                return wasmTable.length - 1
            };
            var setWasmTableEntry = (idx, func) => wasmTable.set(idx, func);
            var addFunction = (func, sig) => {
                var rtn = getFunctionAddress(func);
                if (rtn) {
                    return rtn
                }
                var ret = getEmptyTableSlot();
                try {
                    setWasmTableEntry(ret, func)
                } catch (err) {
                    if (!(err instanceof TypeError)) {
                        throw err
                    }
                    var wrapped = convertJsFunctionToWasm(func, sig);
                    setWasmTableEntry(ret, wrapped)
                }
                functionsInTableMap.set(func, ret);
                return ret
            };
            var updateGOT = (exports, replace) => {
                for (var symName in exports) {
                    if (isInternalSym(symName)) {
                        continue
                    }
                    var value = exports[symName];
                    if (symName.startsWith("orig$")) {
                        symName = symName.split("$")[1];
                        replace = true
                    }
                    GOT[symName] ||= new WebAssembly.Global({
                        value: "i32",
                        mutable: true
                    });
                    if (replace || GOT[symName].value == 0) {
                        if (typeof value == "function") {
                            GOT[symName].value = addFunction(value)
                        } else if (typeof value == "number") {
                            GOT[symName].value = value
                        } else {
                            err(`unhandled export type for '${symName}': ${typeof value}`)
                        }
                    }
                }
            };
            var relocateExports = (exports, memoryBase, replace) => {
                var relocated = {};
                for (var e in exports) {
                    var value = exports[e];
                    if (typeof value == "object") {
                        value = value.value
                    }
                    if (typeof value == "number") {
                        value += memoryBase
                    }
                    relocated[e] = value
                }
                updateGOT(relocated, replace);
                return relocated
            };
            var isSymbolDefined = symName => {
                var existing = wasmImports[symName];
                if (!existing || existing.stub) {
                    return false
                }
                return true
            };
            var resolveGlobalSymbol = (symName, direct = false) => {
                var sym;
                if (direct && "orig$" + symName in wasmImports) {
                    symName = "orig$" + symName
                }
                if (isSymbolDefined(symName)) {
                    sym = wasmImports[symName]
                }
                return {
                    sym,
                    name: symName
                }
            };
            var UTF8ToString = (ptr, maxBytesToRead) => {
                ptr >>>= 0;
                return ptr ? UTF8ArrayToString(HEAPU8, ptr, maxBytesToRead) : ""
            };
            var loadWebAssemblyModule = (binary, flags, libName, localScope, handle) => {
                var metadata = getDylinkMetadata(binary);
                currentModuleWeakSymbols = metadata.weakImports;

                function loadModule() {
                    var firstLoad = !handle || !HEAP8[handle + 8 >>> 0];
                    if (firstLoad) {
                        var memAlign = Math.pow(2, metadata.memoryAlign);
                        var memoryBase = metadata.memorySize ? alignMemory(getMemory(metadata.memorySize + memAlign), memAlign) : 0;
                        var tableBase = metadata.tableSize ? wasmTable.length : 0;
                        if (handle) {
                            HEAP8[handle + 8 >>> 0] = 1;
                            HEAPU32[handle + 12 >>> 2 >>> 0] = memoryBase;
                            HEAP32[handle + 16 >>> 2 >>> 0] = metadata.memorySize;
                            HEAPU32[handle + 20 >>> 2 >>> 0] = tableBase;
                            HEAP32[handle + 24 >>> 2 >>> 0] = metadata.tableSize
                        }
                    } else {
                        memoryBase = HEAPU32[handle + 12 >>> 2 >>> 0];
                        tableBase = HEAPU32[handle + 20 >>> 2 >>> 0]
                    }
                    var tableGrowthNeeded = tableBase + metadata.tableSize - wasmTable.length;
                    if (tableGrowthNeeded > 0) {
                        wasmTable.grow(tableGrowthNeeded)
                    }
                    var moduleExports;

                    function resolveSymbol(sym) {
                        var resolved = resolveGlobalSymbol(sym).sym;
                        if (!resolved && localScope) {
                            resolved = localScope[sym]
                        }
                        if (!resolved) {
                            resolved = moduleExports[sym]
                        }
                        return resolved
                    }
                    var proxyHandler = {
                        get(stubs,prop) { if (prop.startsWith("invoke_")) {return createDyncallWrapper(prop.substring(7));}
                            switch (prop) {
                                case "__memory_base":
                                    return memoryBase;
                                case "getTempRet0": return getTempRet0;   case "__table_base":
                                    return tableBase
                            }
                            if (prop in wasmImports && !wasmImports[prop].stub) {
                                return wasmImports[prop]
                            }
                            if (!(prop in stubs)) {
                                var resolved;
                                stubs[prop] = (...args) => {
                                    resolved ||= resolveSymbol(prop);
                                    return resolved(...args)
                                }
                            }
                            return stubs[prop]
                        }
                    };
                    var proxy = new Proxy({}, proxyHandler);
                    var info = {
                        "GOT.mem": new Proxy({}, GOTHandler),
                        "GOT.func": new Proxy({}, GOTHandler),
                        env: proxy,
                        wasi_snapshot_preview1: proxy
                    };

                    function postInstantiation(module, instance) {
                        updateTableMap(tableBase, metadata.tableSize);
                        moduleExports = relocateExports(instance.exports, memoryBase);
                        if (!flags.allowUndefined) {
                            reportUndefinedSymbols()
                        }

                        function addEmAsm(addr, body) {
                            var args = [];
                            var arity = 0;
                            for (; arity < 16; arity++) {
                                if (body.indexOf("$" + arity) != -1) {
                                    args.push("$" + arity)
                                } else {
                                    break
                                }
                            }
                            args = args.join(",");
                            var func = `(${args}) => { ${body} };`;
                            ASM_CONSTS[start] = eval(func)
                        }
                        if ("__start_em_asm" in moduleExports) {
                            var start = moduleExports["__start_em_asm"];
                            var stop = moduleExports["__stop_em_asm"];
                            while (start < stop) {
                                var jsString = UTF8ToString(start);
                                addEmAsm(start, jsString);
                                start = HEAPU8.indexOf(0, start) + 1
                            }
                        }

                        function addEmJs(name, cSig, body) {
                            var jsArgs = [];
                            cSig = cSig.slice(1, -1);
                            if (cSig != "void") {
                                cSig = cSig.split(",");
                                for (var i in cSig) {
                                    var jsArg = cSig[i].split(" ").pop();
                                    jsArgs.push(jsArg.replace("*", ""))
                                }
                            }
                            var func = `(${jsArgs}) => ${body};`;
                            moduleExports[name] = eval(func)
                        }
                        for (var name in moduleExports) {
                            if (name.startsWith("__em_js__")) {
                                var start = moduleExports[name];
                                var jsString = UTF8ToString(start);
                                var parts = jsString.split("<::>");
                                addEmJs(name.replace("__em_js__", ""), parts[0], parts[1]);
                                delete moduleExports[name]
                            }
                        }
                        var applyRelocs = moduleExports["__wasm_apply_data_relocs"];
                        if (applyRelocs) {
                            if (runtimeInitialized) {
                                applyRelocs()
                            } else {
                                __RELOC_FUNCS__.push(applyRelocs)
                            }
                        }
                        var init = moduleExports["__wasm_call_ctors"];
                        if (init) {
                            if (runtimeInitialized) {
                                init()
                            } else {
                                __ATINIT__.push(init)
                            }
                        }
                        return moduleExports
                    }
                    if (flags.loadAsync) {
                        if (binary instanceof WebAssembly.Module) {
                            var instance = new WebAssembly.Instance(binary, info);
                            return Promise.resolve(postInstantiation(binary, instance))
                        }
                        return WebAssembly.instantiate(binary, info).then(result => postInstantiation(result.module, result.instance))
                    }
                    var module = binary instanceof WebAssembly.Module ? binary : new WebAssembly.Module(binary);
                    var instance = new WebAssembly.Instance(module, info);
                    return postInstantiation(module, instance)
                }
                if (flags.loadAsync) {
                    return metadata.neededDynlibs.reduce((chain, dynNeeded) => chain.then(() => loadDynamicLibrary(dynNeeded, flags, localScope)), Promise.resolve()).then(loadModule)
                }
                metadata.neededDynlibs.forEach(needed => loadDynamicLibrary(needed, flags, localScope));
                return loadModule()
            };
            var mergeLibSymbols = (exports, libName) => {
                registerDynCallSymbols(exports);
                for (var [sym, exp] of Object.entries(exports)) {
                    const setImport = target => {
                        if (!isSymbolDefined(target)) {
                            wasmImports[target] = exp
                        }
                    };
                    setImport(sym)
                }
            };
            var asyncLoad = (url, onload, onerror, noRunDep) => {
                var dep = !noRunDep ? getUniqueRunDependency(`al ${url}`) : "";
                readAsync(url).then(arrayBuffer => {
                    onload(new Uint8Array(arrayBuffer));
                    if (dep) removeRunDependency(dep)
                }, err => {
                    if (onerror) {
                        onerror()
                    } else {
                        throw `Loading data file "${url}" failed.`
                    }
                });
                if (dep) addRunDependency(dep)
            };
            var preloadPlugins = Module["preloadPlugins"] || [];
            var registerWasmPlugin = () => {
                var wasmPlugin = {
                    promiseChainEnd: Promise.resolve(),
                    canHandle: name => !Module["noWasmDecoding"] && name.endsWith(".so"),
                    handle: (byteArray, name, onload, onerror) => {
                        wasmPlugin["promiseChainEnd"] = wasmPlugin["promiseChainEnd"].then(() => loadWebAssemblyModule(byteArray, {
                            loadAsync: true,
                            nodelete: true
                        }, name, {})).then(exports => {
                            preloadedWasm[name] = exports;
                            onload(byteArray)
                        }, error => {
                            err(`failed to instantiate wasm: ${name}: ${error}`);
                            onerror()
                        })
                    }
                };
                preloadPlugins.push(wasmPlugin)
            };
            var preloadedWasm = {};
            var registerDynCallSymbols = exports => {
                for (var [sym, exp] of Object.entries(exports)) {
                    if (sym.startsWith("dynCall_") && !Module.hasOwnProperty(sym)) {
                        Module[sym] = exp
                    }
                }
            };

            function loadDynamicLibrary(libName, flags = {
                global: true,
                nodelete: true
            }, localScope, handle) {
                var dso = LDSO.loadedLibsByName[libName];
                if (dso) {
                    if (!flags.global) {
                        if (localScope) {
                            Object.assign(localScope, dso.exports)
                        }
                        registerDynCallSymbols(dso.exports)
                    } else if (!dso.global) {
                        dso.global = true;
                        mergeLibSymbols(dso.exports, libName)
                    }
                    if (flags.nodelete && dso.refcount !== Infinity) {
                        dso.refcount = Infinity
                    }
                    dso.refcount++;
                    if (handle) {
                        LDSO.loadedLibsByHandle[handle] = dso
                    }
                    return flags.loadAsync ? Promise.resolve(true) : true
                }
                dso = newDSO(libName, handle, "loading");
                dso.refcount = flags.nodelete ? Infinity : 1;
                dso.global = flags.global;

                function loadLibData() {
                    if (handle) {
                        var data = HEAPU32[handle + 28 >>> 2 >>> 0];
                        var dataSize = HEAPU32[handle + 32 >>> 2 >>> 0];
                        if (data && dataSize) {
                            var libData = HEAP8.slice(data, data + dataSize);
                            return flags.loadAsync ? Promise.resolve(libData) : libData
                        }
                    }
                    var libFile = locateFile(libName);
                    if (flags.loadAsync) {
                        return new Promise((resolve, reject) => asyncLoad(libFile, resolve, reject))
                    }
                    if (!readBinary) {
                        throw new Error(`${libFile}: file not found, and synchronous loading of external files is not available`)
                    }
                    return readBinary(libFile)
                }

                function getExports() {
                    var preloaded = preloadedWasm[libName];
                    if (preloaded) {
                        return flags.loadAsync ? Promise.resolve(preloaded) : preloaded
                    }
                    if (flags.loadAsync) {
                        return loadLibData().then(libData => loadWebAssemblyModule(libData, flags, libName, localScope, handle))
                    }
                    return loadWebAssemblyModule(loadLibData(), flags, libName, localScope, handle)
                }

                function moduleLoaded(exports) {
                    if (dso.global) {
                        mergeLibSymbols(exports, libName)
                    } else if (localScope) {
                        Object.assign(localScope, exports);
                        registerDynCallSymbols(exports)
                    }
                    dso.exports = exports
                }
                if (flags.loadAsync) {
                    return getExports().then(exports => {
                        moduleLoaded(exports);
                        return true
                    })
                }
                moduleLoaded(getExports());
                return true
            }
            var reportUndefinedSymbols = () => {
                for (var [symName, entry] of Object.entries(GOT)) {
                    if (entry.value == 0) {
                        var value = resolveGlobalSymbol(symName, true).sym;
                        if (!value && !entry.required) {
                            continue
                        }
                        if (typeof value == "function") {
                            entry.value = addFunction(value, value.sig)
                        } else if (typeof value == "number") {
                            entry.value = value
                        } else {
                            throw new Error(`bad export type for '${symName}': ${typeof value}`)
                        }
                    }
                }
            };
            var loadDylibs = () => {
                if (!dynamicLibraries.length) {
                    reportUndefinedSymbols();
                    return
                }
                addRunDependency("loadDylibs");
                dynamicLibraries.reduce((chain, lib) => chain.then(() => loadDynamicLibrary(lib, {
                    loadAsync: true,
                    global: true,
                    nodelete: true,
                    allowUndefined: true
                })), Promise.resolve()).then(() => {
                    reportUndefinedSymbols();
                    removeRunDependency("loadDylibs")
                })
            };
            var noExitRuntime = Module["noExitRuntime"] || true;

            function setValue(ptr, value, type = "i8") {
                if (type.endsWith("*")) type = "*";
                switch (type) {
                    case "i1":
                        HEAP8[ptr >>> 0] = value;
                        break;
                    case "i8":
                        HEAP8[ptr >>> 0] = value;
                        break;
                    case "i16":
                        HEAP16[ptr >>> 1 >>> 0] = value;
                        break;
                    case "i32":
                        HEAP32[ptr >>> 2 >>> 0] = value;
                        break;
                    case "i64":
                        abort("to do setValue(i64) use WASM_BIGINT");
                    case "float":
                        HEAPF32[ptr >>> 2 >>> 0] = value;
                        break;
                    case "double":
                        HEAPF64[ptr >>> 3 >>> 0] = value;
                        break;
                    case "*":
                        HEAPU32[ptr >>> 2 >>> 0] = value;
                        break;
                    default:
                        abort(`invalid type for setValue: ${type}`)
                }
            }
            var convertI32PairToI53Checked = (lo, hi) => hi + 2097152 >>> 0 < 4194305 - !!lo ? (lo >>> 0) + hi * 4294967296 : NaN;

            function ___assert_fail(condition, filename, line, func) {
                condition >>>= 0;
                filename >>>= 0;
                func >>>= 0;
                abort(`Assertion failed: ${UTF8ToString(condition)}, at: ` + [filename ? UTF8ToString(filename) : "unknown filename", line, func ? UTF8ToString(func) : "unknown function"])
            }
            ___assert_fail.sig = "vppip";
            var ___c_longjmp = new WebAssembly.Tag({
                parameters: ["i32"]
            });

            function ___call_sighandler(fp, sig) {
                fp >>>= 0;
                return getWasmTableEntry(fp)(sig)
            }
            ___call_sighandler.sig = "vpi";
            var ___cpp_exception = new WebAssembly.Tag({
                parameters: ["i32"]
            });
            var ___memory_base = new WebAssembly.Global({
                value: "i32",
                mutable: false
            }, 1024);
            var ___stack_high = 3689088;
            var ___stack_low = 2640512;
            var ___stack_pointer = new WebAssembly.Global({
                value: "i32",
                mutable: true
            }, 3689088);
            var PATH = {
                isAbs: path => path.charAt(0) === "/",
                splitPath: filename => {
                    var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
                    return splitPathRe.exec(filename).slice(1)
                },
                normalizeArray: (parts, allowAboveRoot) => {
                    var up = 0;
                    for (var i = parts.length - 1; i >= 0; i--) {
                        var last = parts[i];
                        if (last === ".") {
                            parts.splice(i, 1)
                        } else if (last === "..") {
                            parts.splice(i, 1);
                            up++
                        } else if (up) {
                            parts.splice(i, 1);
                            up--
                        }
                    }
                    if (allowAboveRoot) {
                        for (; up; up--) {
                            parts.unshift("..")
                        }
                    }
                    return parts
                },
                normalize: path => {
                    var isAbsolute = PATH.isAbs(path),
                        trailingSlash = path.substr(-1) === "/";
                    path = PATH.normalizeArray(path.split("/").filter(p => !!p), !isAbsolute).join("/");
                    if (!path && !isAbsolute) {
                        path = "."
                    }
                    if (path && trailingSlash) {
                        path += "/"
                    }
                    return (isAbsolute ? "/" : "") + path
                },
                dirname: path => {
                    var result = PATH.splitPath(path),
                        root = result[0],
                        dir = result[1];
                    if (!root && !dir) {
                        return "."
                    }
                    if (dir) {
                        dir = dir.substr(0, dir.length - 1)
                    }
                    return root + dir
                },
                basename: path => {
                    if (path === "/") return "/";
                    path = PATH.normalize(path);
                    path = path.replace(/\/$/, "");
                    var lastSlash = path.lastIndexOf("/");
                    if (lastSlash === -1) return path;
                    return path.substr(lastSlash + 1)
                },
                join: (...paths) => PATH.normalize(paths.join("/")),
                join2: (l, r) => PATH.normalize(l + "/" + r)
            };
            var initRandomFill = () => {
                if (typeof crypto == "object" && typeof crypto["getRandomValues"] == "function") {
                    return view => crypto.getRandomValues(view)
                } else if (ENVIRONMENT_IS_NODE) {
                    try {
                        var crypto_module = require("crypto");
                        var randomFillSync = crypto_module["randomFillSync"];
                        if (randomFillSync) {
                            return view => crypto_module["randomFillSync"](view)
                        }
                        var randomBytes = crypto_module["randomBytes"];
                        return view => (view.set(randomBytes(view.byteLength)), view)
                    } catch (e) {}
                }
                abort("initRandomDevice")
            };
            var randomFill = view => (randomFill = initRandomFill())(view);
            var PATH_FS = {
                resolve: (...args) => {
                    var resolvedPath = "",
                        resolvedAbsolute = false;
                    for (var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
                        var path = i >= 0 ? args[i] : FS.cwd();
                        if (typeof path != "string") {
                            throw new TypeError("Arguments to path.resolve must be strings")
                        } else if (!path) {
                            return ""
                        }
                        resolvedPath = path + "/" + resolvedPath;
                        resolvedAbsolute = PATH.isAbs(path)
                    }
                    resolvedPath = PATH.normalizeArray(resolvedPath.split("/").filter(p => !!p), !resolvedAbsolute).join("/");
                    return (resolvedAbsolute ? "/" : "") + resolvedPath || "."
                },
                relative: (from, to) => {
                    from = PATH_FS.resolve(from).substr(1);
                    to = PATH_FS.resolve(to).substr(1);

                    function trim(arr) {
                        var start = 0;
                        for (; start < arr.length; start++) {
                            if (arr[start] !== "") break
                        }
                        var end = arr.length - 1;
                        for (; end >= 0; end--) {
                            if (arr[end] !== "") break
                        }
                        if (start > end) return [];
                        return arr.slice(start, end - start + 1)
                    }
                    var fromParts = trim(from.split("/"));
                    var toParts = trim(to.split("/"));
                    var length = Math.min(fromParts.length, toParts.length);
                    var samePartsLength = length;
                    for (var i = 0; i < length; i++) {
                        if (fromParts[i] !== toParts[i]) {
                            samePartsLength = i;
                            break
                        }
                    }
                    var outputParts = [];
                    for (var i = samePartsLength; i < fromParts.length; i++) {
                        outputParts.push("..")
                    }
                    outputParts = outputParts.concat(toParts.slice(samePartsLength));
                    return outputParts.join("/")
                }
            };
            var FS_stdin_getChar_buffer = [];
            var lengthBytesUTF8 = str => {
                var len = 0;
                for (var i = 0; i < str.length; ++i) {
                    var c = str.charCodeAt(i);
                    if (c <= 127) {
                        len++
                    } else if (c <= 2047) {
                        len += 2
                    } else if (c >= 55296 && c <= 57343) {
                        len += 4;
                        ++i
                    } else {
                        len += 3
                    }
                }
                return len
            };
            Module["lengthBytesUTF8"] = lengthBytesUTF8;
            var stringToUTF8Array = (str, heap, outIdx, maxBytesToWrite) => {
                outIdx >>>= 0;
                if (!(maxBytesToWrite > 0)) return 0;
                var startIdx = outIdx;
                var endIdx = outIdx + maxBytesToWrite - 1;
                for (var i = 0; i < str.length; ++i) {
                    var u = str.charCodeAt(i);
                    if (u >= 55296 && u <= 57343) {
                        var u1 = str.charCodeAt(++i);
                        u = 65536 + ((u & 1023) << 10) | u1 & 1023
                    }
                    if (u <= 127) {
                        if (outIdx >= endIdx) break;
                        heap[outIdx++ >>> 0] = u
                    } else if (u <= 2047) {
                        if (outIdx + 1 >= endIdx) break;
                        heap[outIdx++ >>> 0] = 192 | u >> 6;
                        heap[outIdx++ >>> 0] = 128 | u & 63
                    } else if (u <= 65535) {
                        if (outIdx + 2 >= endIdx) break;
                        heap[outIdx++ >>> 0] = 224 | u >> 12;
                        heap[outIdx++ >>> 0] = 128 | u >> 6 & 63;
                        heap[outIdx++ >>> 0] = 128 | u & 63
                    } else {
                        if (outIdx + 3 >= endIdx) break;
                        heap[outIdx++ >>> 0] = 240 | u >> 18;
                        heap[outIdx++ >>> 0] = 128 | u >> 12 & 63;
                        heap[outIdx++ >>> 0] = 128 | u >> 6 & 63;
                        heap[outIdx++ >>> 0] = 128 | u & 63
                    }
                }
                heap[outIdx >>> 0] = 0;
                return outIdx - startIdx
            };

            function intArrayFromString(stringy, dontAddNull, length) {
                var len = length > 0 ? length : lengthBytesUTF8(stringy) + 1;
                var u8array = new Array(len);
                var numBytesWritten = stringToUTF8Array(stringy, u8array, 0, u8array.length);
                if (dontAddNull) u8array.length = numBytesWritten;
                return u8array
            }
            var FS_stdin_getChar = () => {
                if (!FS_stdin_getChar_buffer.length) {
                    var result = null;
                    if (ENVIRONMENT_IS_NODE) {
                        var BUFSIZE = 256;
                        var buf = Buffer.alloc(BUFSIZE);
                        var bytesRead = 0;
                        var fd = process.stdin.fd;
                        try {
                            bytesRead = fs.readSync(fd, buf, 0, BUFSIZE)
                        } catch (e) {
                            if (e.toString().includes("EOF")) bytesRead = 0;
                            else throw e
                        }
                        if (bytesRead > 0) {
                            result = buf.slice(0, bytesRead).toString("utf-8")
                        }
                    } else if (typeof window != "undefined" && typeof window.prompt == "function") {
                        result = window.prompt("Input: ");
                        if (result !== null) {
                            result += "\n"
                        }
                    } else {}
                    if (!result) {
                        return null
                    }
                    FS_stdin_getChar_buffer = intArrayFromString(result, true)
                }
                return FS_stdin_getChar_buffer.shift()
            };
            var TTY = {
                ttys: [],
                init() {},
                shutdown() {},
                register(dev, ops) {
                    TTY.ttys[dev] = {
                        input: [],
                        output: [],
                        ops
                    };
                    FS.registerDevice(dev, TTY.stream_ops)
                },
                stream_ops: {
                    open(stream) {
                        var tty = TTY.ttys[stream.node.rdev];
                        if (!tty) {
                            throw new FS.ErrnoError(43)
                        }
                        stream.tty = tty;
                        stream.seekable = false
                    },
                    close(stream) {
                        stream.tty.ops.fsync(stream.tty)
                    },
                    fsync(stream) {
                        stream.tty.ops.fsync(stream.tty)
                    },
                    read(stream, buffer, offset, length, pos) {
                        if (!stream.tty || !stream.tty.ops.get_char) {
                            throw new FS.ErrnoError(60)
                        }
                        var bytesRead = 0;
                        for (var i = 0; i < length; i++) {
                            var result;
                            try {
                                result = stream.tty.ops.get_char(stream.tty)
                            } catch (e) {
                                throw new FS.ErrnoError(29)
                            }
                            if (result === undefined && bytesRead === 0) {
                                throw new FS.ErrnoError(6)
                            }
                            if (result === null || result === undefined) break;
                            bytesRead++;
                            buffer[offset + i] = result
                        }
                        if (bytesRead) {
                            stream.node.timestamp = Date.now()
                        }
                        return bytesRead
                    },
                    write(stream, buffer, offset, length, pos) {
                        if (!stream.tty || !stream.tty.ops.put_char) {
                            throw new FS.ErrnoError(60)
                        }
                        try {
                            for (var i = 0; i < length; i++) {
                                stream.tty.ops.put_char(stream.tty, buffer[offset + i])
                            }
                        } catch (e) {
                            throw new FS.ErrnoError(29)
                        }
                        if (length) {
                            stream.node.timestamp = Date.now()
                        }
                        return i
                    }
                },
                default_tty_ops: {
                    get_char(tty) {
                        return FS_stdin_getChar()
                    },
                    put_char(tty, val) {
                        if (val === null || val === 10) {
                            out(UTF8ArrayToString(tty.output));
                            tty.output = []
                        } else {
                            if (val != 0) tty.output.push(val)
                        }
                    },
                    fsync(tty) {
                        if (tty.output && tty.output.length > 0) {
                            out(UTF8ArrayToString(tty.output));
                            tty.output = []
                        }
                    },
                    ioctl_tcgets(tty) {
                        return {
                            c_iflag: 25856,
                            c_oflag: 5,
                            c_cflag: 191,
                            c_lflag: 35387,
                            c_cc: [3, 28, 127, 21, 4, 0, 1, 0, 17, 19, 26, 0, 18, 15, 23, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                        }
                    },
                    ioctl_tcsets(tty, optional_actions, data) {
                        return 0
                    },
                    ioctl_tiocgwinsz(tty) {
                        return [24, 80]
                    }
                },
                default_tty1_ops: {
                    put_char(tty, val) {
                        if (val === null || val === 10) {
                            err(UTF8ArrayToString(tty.output));
                            tty.output = []
                        } else {
                            if (val != 0) tty.output.push(val)
                        }
                    },
                    fsync(tty) {
                        if (tty.output && tty.output.length > 0) {
                            err(UTF8ArrayToString(tty.output));
                            tty.output = []
                        }
                    }
                }
            };
            var zeroMemory = (address, size) => {
                HEAPU8.fill(0, address, address + size)
            };
            var mmapAlloc = size => {
                size = alignMemory(size, 65536);
                var ptr = _emscripten_builtin_memalign(65536, size);
                if (ptr) zeroMemory(ptr, size);
                return ptr
            };
            var MEMFS = {
                ops_table: null,
                mount(mount) {
                    return MEMFS.createNode(null, "/", 16384 | 511, 0)
                },
                createNode(parent, name, mode, dev) {
                    if (FS.isBlkdev(mode) || FS.isFIFO(mode)) {
                        throw new FS.ErrnoError(63)
                    }
                    MEMFS.ops_table ||= {
                        dir: {
                            node: {
                                getattr: MEMFS.node_ops.getattr,
                                setattr: MEMFS.node_ops.setattr,
                                lookup: MEMFS.node_ops.lookup,
                                mknod: MEMFS.node_ops.mknod,
                                rename: MEMFS.node_ops.rename,
                                unlink: MEMFS.node_ops.unlink,
                                rmdir: MEMFS.node_ops.rmdir,
                                readdir: MEMFS.node_ops.readdir,
                                symlink: MEMFS.node_ops.symlink
                            },
                            stream: {
                                llseek: MEMFS.stream_ops.llseek
                            }
                        },
                        file: {
                            node: {
                                getattr: MEMFS.node_ops.getattr,
                                setattr: MEMFS.node_ops.setattr
                            },
                            stream: {
                                llseek: MEMFS.stream_ops.llseek,
                                read: MEMFS.stream_ops.read,
                                write: MEMFS.stream_ops.write,
                                allocate: MEMFS.stream_ops.allocate,
                                mmap: MEMFS.stream_ops.mmap,
                                msync: MEMFS.stream_ops.msync
                            }
                        },
                        link: {
                            node: {
                                getattr: MEMFS.node_ops.getattr,
                                setattr: MEMFS.node_ops.setattr,
                                readlink: MEMFS.node_ops.readlink
                            },
                            stream: {}
                        },
                        chrdev: {
                            node: {
                                getattr: MEMFS.node_ops.getattr,
                                setattr: MEMFS.node_ops.setattr
                            },
                            stream: FS.chrdev_stream_ops
                        }
                    };
                    var node = FS.createNode(parent, name, mode, dev);
                    if (FS.isDir(node.mode)) {
                        node.node_ops = MEMFS.ops_table.dir.node;
                        node.stream_ops = MEMFS.ops_table.dir.stream;
                        node.contents = {}
                    } else if (FS.isFile(node.mode)) {
                        node.node_ops = MEMFS.ops_table.file.node;
                        node.stream_ops = MEMFS.ops_table.file.stream;
                        node.usedBytes = 0;
                        node.contents = null
                    } else if (FS.isLink(node.mode)) {
                        node.node_ops = MEMFS.ops_table.link.node;
                        node.stream_ops = MEMFS.ops_table.link.stream
                    } else if (FS.isChrdev(node.mode)) {
                        node.node_ops = MEMFS.ops_table.chrdev.node;
                        node.stream_ops = MEMFS.ops_table.chrdev.stream
                    }
                    node.timestamp = Date.now();
                    if (parent) {
                        parent.contents[name] = node;
                        parent.timestamp = node.timestamp
                    }
                    return node
                },
                getFileDataAsTypedArray(node) {
                    if (!node.contents) return new Uint8Array(0);
                    if (node.contents.subarray) return node.contents.subarray(0, node.usedBytes);
                    return new Uint8Array(node.contents)
                },
                expandFileStorage(node, newCapacity) {
                    var prevCapacity = node.contents ? node.contents.length : 0;
                    if (prevCapacity >= newCapacity) return;
                    var CAPACITY_DOUBLING_MAX = 1024 * 1024;
                    newCapacity = Math.max(newCapacity, prevCapacity * (prevCapacity < CAPACITY_DOUBLING_MAX ? 2 : 1.125) >>> 0);
                    if (prevCapacity != 0) newCapacity = Math.max(newCapacity, 256);
                    var oldContents = node.contents;
                    node.contents = new Uint8Array(newCapacity);
                    if (node.usedBytes > 0) node.contents.set(oldContents.subarray(0, node.usedBytes), 0)
                },
                resizeFileStorage(node, newSize) {
                    if (node.usedBytes == newSize) return;
                    if (newSize == 0) {
                        node.contents = null;
                        node.usedBytes = 0
                    } else {
                        var oldContents = node.contents;
                        node.contents = new Uint8Array(newSize);
                        if (oldContents) {
                            node.contents.set(oldContents.subarray(0, Math.min(newSize, node.usedBytes)))
                        }
                        node.usedBytes = newSize
                    }
                },
                node_ops: {
                    getattr(node) {
                        var attr = {};
                        attr.dev = FS.isChrdev(node.mode) ? node.id : 1;
                        attr.ino = node.id;
                        attr.mode = node.mode;
                        attr.nlink = 1;
                        attr.uid = 0;
                        attr.gid = 0;
                        attr.rdev = node.rdev;
                        if (FS.isDir(node.mode)) {
                            attr.size = 4096
                        } else if (FS.isFile(node.mode)) {
                            attr.size = node.usedBytes
                        } else if (FS.isLink(node.mode)) {
                            attr.size = node.link.length
                        } else {
                            attr.size = 0
                        }
                        attr.atime = new Date(node.timestamp);
                        attr.mtime = new Date(node.timestamp);
                        attr.ctime = new Date(node.timestamp);
                        attr.blksize = 4096;
                        attr.blocks = Math.ceil(attr.size / attr.blksize);
                        return attr
                    },
                    setattr(node, attr) {
                        if (attr.mode !== undefined) {
                            node.mode = attr.mode
                        }
                        if (attr.timestamp !== undefined) {
                            node.timestamp = attr.timestamp
                        }
                        if (attr.size !== undefined) {
                            MEMFS.resizeFileStorage(node, attr.size)
                        }
                    },
                    lookup(parent, name) {
                        throw FS.genericErrors[44]
                    },
                    mknod(parent, name, mode, dev) {
                        return MEMFS.createNode(parent, name, mode, dev)
                    },
                    rename(old_node, new_dir, new_name) {
                        if (FS.isDir(old_node.mode)) {
                            var new_node;
                            try {
                                new_node = FS.lookupNode(new_dir, new_name)
                            } catch (e) {}
                            if (new_node) {
                                for (var i in new_node.contents) {
                                    throw new FS.ErrnoError(55)
                                }
                            }
                        }
                        delete old_node.parent.contents[old_node.name];
                        old_node.parent.timestamp = Date.now();
                        old_node.name = new_name;
                        new_dir.contents[new_name] = old_node;
                        new_dir.timestamp = old_node.parent.timestamp
                    },
                    unlink(parent, name) {
                        delete parent.contents[name];
                        parent.timestamp = Date.now()
                    },
                    rmdir(parent, name) {
                        var node = FS.lookupNode(parent, name);
                        for (var i in node.contents) {
                            throw new FS.ErrnoError(55)
                        }
                        delete parent.contents[name];
                        parent.timestamp = Date.now()
                    },
                    readdir(node) {
                        var entries = [".", ".."];
                        for (var key of Object.keys(node.contents)) {
                            entries.push(key)
                        }
                        return entries
                    },
                    symlink(parent, newname, oldpath) {
                        var node = MEMFS.createNode(parent, newname, 511 | 40960, 0);
                        node.link = oldpath;
                        return node
                    },
                    readlink(node) {
                        if (!FS.isLink(node.mode)) {
                            throw new FS.ErrnoError(28)
                        }
                        return node.link
                    }
                },
                stream_ops: {
                    read(stream, buffer, offset, length, position) {
                        var contents = stream.node.contents;
                        if (position >= stream.node.usedBytes) return 0;
                        var size = Math.min(stream.node.usedBytes - position, length);
                        if (size > 8 && contents.subarray) {
                            buffer.set(contents.subarray(position, position + size), offset)
                        } else {
                            for (var i = 0; i < size; i++) buffer[offset + i] = contents[position + i]
                        }
                        return size
                    },
                    write(stream, buffer, offset, length, position, canOwn) {
                        if (buffer.buffer === HEAP8.buffer) {
                            canOwn = false
                        }
                        if (!length) return 0;
                        var node = stream.node;
                        node.timestamp = Date.now();
                        if (buffer.subarray && (!node.contents || node.contents.subarray)) {
                            if (canOwn) {
                                node.contents = buffer.subarray(offset, offset + length);
                                node.usedBytes = length;
                                return length
                            } else if (node.usedBytes === 0 && position === 0) {
                                node.contents = buffer.slice(offset, offset + length);
                                node.usedBytes = length;
                                return length
                            } else if (position + length <= node.usedBytes) {
                                node.contents.set(buffer.subarray(offset, offset + length), position);
                                return length
                            }
                        }
                        MEMFS.expandFileStorage(node, position + length);
                        if (node.contents.subarray && buffer.subarray) {
                            node.contents.set(buffer.subarray(offset, offset + length), position)
                        } else {
                            for (var i = 0; i < length; i++) {
                                node.contents[position + i] = buffer[offset + i]
                            }
                        }
                        node.usedBytes = Math.max(node.usedBytes, position + length);
                        return length
                    },
                    llseek(stream, offset, whence) {
                        var position = offset;
                        if (whence === 1) {
                            position += stream.position
                        } else if (whence === 2) {
                            if (FS.isFile(stream.node.mode)) {
                                position += stream.node.usedBytes
                            }
                        }
                        if (position < 0) {
                            throw new FS.ErrnoError(28)
                        }
                        return position
                    },
                    allocate(stream, offset, length) {
                        MEMFS.expandFileStorage(stream.node, offset + length);
                        stream.node.usedBytes = Math.max(stream.node.usedBytes, offset + length)
                    },
                    mmap(stream, length, position, prot, flags) {
                        if (!FS.isFile(stream.node.mode)) {
                            throw new FS.ErrnoError(43)
                        }
                        var ptr;
                        var allocated;
                        var contents = stream.node.contents;
                        if (!(flags & 2) && contents && contents.buffer === HEAP8.buffer) {
                            allocated = false;
                            ptr = contents.byteOffset
                        } else {
                            allocated = true;
                            ptr = mmapAlloc(length);
                            if (!ptr) {
                                throw new FS.ErrnoError(48)
                            }
                            if (contents) {
                                if (position > 0 || position + length < contents.length) {
                                    if (contents.subarray) {
                                        contents = contents.subarray(position, position + length)
                                    } else {
                                        contents = Array.prototype.slice.call(contents, position, position + length)
                                    }
                                }
                                HEAP8.set(contents, ptr >>> 0)
                            }
                        }
                        return {
                            ptr,
                            allocated
                        }
                    },
                    msync(stream, buffer, offset, length, mmapFlags) {
                        MEMFS.stream_ops.write(stream, buffer, 0, length, offset, false);
                        return 0
                    }
                }
            };
            var FS_createDataFile = (parent, name, fileData, canRead, canWrite, canOwn) => {
                FS.createDataFile(parent, name, fileData, canRead, canWrite, canOwn)
            };
            var FS_handledByPreloadPlugin = (byteArray, fullname, finish, onerror) => {
                if (typeof Browser != "undefined") Browser.init();
                var handled = false;
                preloadPlugins.forEach(plugin => {
                    if (handled) return;
                    if (plugin["canHandle"](fullname)) {
                        plugin["handle"](byteArray, fullname, finish, onerror);
                        handled = true
                    }
                });
                return handled
            };
            var FS_createPreloadedFile = (parent, name, url, canRead, canWrite, onload, onerror, dontCreateFile, canOwn, preFinish) => {
                var fullname = name ? PATH_FS.resolve(PATH.join2(parent, name)) : parent;
                var dep = getUniqueRunDependency(`cp ${fullname}`);

                function processData(byteArray) {
                    function finish(byteArray) {
                        preFinish?.();
                        if (!dontCreateFile) {
                            FS_createDataFile(parent, name, byteArray, canRead, canWrite, canOwn)
                        }
                        onload?.();
                        removeRunDependency(dep)
                    }
                    if (FS_handledByPreloadPlugin(byteArray, fullname, finish, () => {
                            onerror?.();
                            removeRunDependency(dep)
                        })) {
                        return
                    }
                    finish(byteArray)
                }
                addRunDependency(dep);
                if (typeof url == "string") {
                    asyncLoad(url, processData, onerror)
                } else {
                    processData(url)
                }
            };
            var FS_modeStringToFlags = str => {
                var flagModes = {
                    r: 0,
                    "r+": 2,
                    w: 512 | 64 | 1,
                    "w+": 512 | 64 | 2,
                    a: 1024 | 64 | 1,
                    "a+": 1024 | 64 | 2
                };
                var flags = flagModes[str];
                if (typeof flags == "undefined") {
                    throw new Error(`Unknown file open mode: ${str}`)
                }
                return flags
            };
            var FS_getMode = (canRead, canWrite) => {
                var mode = 0;
                if (canRead) mode |= 292 | 73;
                if (canWrite) mode |= 146;
                return mode
            };
            var FS = {
                root: null,
                mounts: [],
                devices: {},
                streams: [],
                nextInode: 1,
                nameTable: null,
                currentPath: "/",
                initialized: false,
                ignorePermissions: true,
                ErrnoError: class {
                    name = "ErrnoError";
                    constructor(errno) {
                        this.errno = errno
                    }
                },
                genericErrors: {},
                filesystems: null,
                syncFSRequests: 0,
                readFiles: {},
                FSStream: class {
                    shared = {};
                    get object() {
                        return this.node
                    }
                    set object(val) {
                        this.node = val
                    }
                    get isRead() {
                        return (this.flags & 2097155) !== 1
                    }
                    get isWrite() {
                        return (this.flags & 2097155) !== 0
                    }
                    get isAppend() {
                        return this.flags & 1024
                    }
                    get flags() {
                        return this.shared.flags
                    }
                    set flags(val) {
                        this.shared.flags = val
                    }
                    get position() {
                        return this.shared.position
                    }
                    set position(val) {
                        this.shared.position = val
                    }
                },
                FSNode: class {
                    node_ops = {};
                    stream_ops = {};
                    readMode = 292 | 73;
                    writeMode = 146;
                    mounted = null;
                    constructor(parent, name, mode, rdev) {
                        if (!parent) {
                            parent = this
                        }
                        this.parent = parent;
                        this.mount = parent.mount;
                        this.id = FS.nextInode++;
                        this.name = name;
                        this.mode = mode;
                        this.rdev = rdev
                    }
                    get read() {
                        return (this.mode & this.readMode) === this.readMode
                    }
                    set read(val) {
                        val ? this.mode |= this.readMode : this.mode &= ~this.readMode
                    }
                    get write() {
                        return (this.mode & this.writeMode) === this.writeMode
                    }
                    set write(val) {
                        val ? this.mode |= this.writeMode : this.mode &= ~this.writeMode
                    }
                    get isFolder() {
                        return FS.isDir(this.mode)
                    }
                    get isDevice() {
                        return FS.isChrdev(this.mode)
                    }
                },
                lookupPath(path, opts = {}) {
                    path = PATH_FS.resolve(path);
                    if (!path) return {
                        path: "",
                        node: null
                    };
                    var defaults = {
                        follow_mount: true,
                        recurse_count: 0
                    };
                    opts = Object.assign(defaults, opts);
                    if (opts.recurse_count > 8) {
                        throw new FS.ErrnoError(32)
                    }
                    var parts = path.split("/").filter(p => !!p);
                    var current = FS.root;
                    var current_path = "/";
                    for (var i = 0; i < parts.length; i++) {
                        var islast = i === parts.length - 1;
                        if (islast && opts.parent) {
                            break
                        }
                        current = FS.lookupNode(current, parts[i]);
                        current_path = PATH.join2(current_path, parts[i]);
                        if (FS.isMountpoint(current)) {
                            if (!islast || islast && opts.follow_mount) {
                                current = current.mounted.root
                            }
                        }
                        if (!islast || opts.follow) {
                            var count = 0;
                            while (FS.isLink(current.mode)) {
                                var link = FS.readlink(current_path);
                                current_path = PATH_FS.resolve(PATH.dirname(current_path), link);
                                var lookup = FS.lookupPath(current_path, {
                                    recurse_count: opts.recurse_count + 1
                                });
                                current = lookup.node;
                                if (count++ > 40) {
                                    throw new FS.ErrnoError(32)
                                }
                            }
                        }
                    }
                    return {
                        path: current_path,
                        node: current
                    }
                },
                getPath(node) {
                    var path;
                    while (true) {
                        if (FS.isRoot(node)) {
                            var mount = node.mount.mountpoint;
                            if (!path) return mount;
                            return mount[mount.length - 1] !== "/" ? `${mount}/${path}` : mount + path
                        }
                        path = path ? `${node.name}/${path}` : node.name;
                        node = node.parent
                    }
                },
                hashName(parentid, name) {
                    var hash = 0;
                    for (var i = 0; i < name.length; i++) {
                        hash = (hash << 5) - hash + name.charCodeAt(i) | 0
                    }
                    return (parentid + hash >>> 0) % FS.nameTable.length
                },
                hashAddNode(node) {
                    var hash = FS.hashName(node.parent.id, node.name);
                    node.name_next = FS.nameTable[hash];
                    FS.nameTable[hash] = node
                },
                hashRemoveNode(node) {
                    var hash = FS.hashName(node.parent.id, node.name);
                    if (FS.nameTable[hash] === node) {
                        FS.nameTable[hash] = node.name_next
                    } else {
                        var current = FS.nameTable[hash];
                        while (current) {
                            if (current.name_next === node) {
                                current.name_next = node.name_next;
                                break
                            }
                            current = current.name_next
                        }
                    }
                },
                lookupNode(parent, name) {
                    var errCode = FS.mayLookup(parent);
                    if (errCode) {
                        throw new FS.ErrnoError(errCode)
                    }
                    var hash = FS.hashName(parent.id, name);
                    for (var node = FS.nameTable[hash]; node; node = node.name_next) {
                        var nodeName = node.name;
                        if (node.parent.id === parent.id && nodeName === name) {
                            return node
                        }
                    }
                    return FS.lookup(parent, name)
                },
                createNode(parent, name, mode, rdev) {
                    var node = new FS.FSNode(parent, name, mode, rdev);
                    FS.hashAddNode(node);
                    return node
                },
                destroyNode(node) {
                    FS.hashRemoveNode(node)
                },
                isRoot(node) {
                    return node === node.parent
                },
                isMountpoint(node) {
                    return !!node.mounted
                },
                isFile(mode) {
                    return (mode & 61440) === 32768
                },
                isDir(mode) {
                    return (mode & 61440) === 16384
                },
                isLink(mode) {
                    return (mode & 61440) === 40960
                },
                isChrdev(mode) {
                    return (mode & 61440) === 8192
                },
                isBlkdev(mode) {
                    return (mode & 61440) === 24576
                },
                isFIFO(mode) {
                    return (mode & 61440) === 4096
                },
                isSocket(mode) {
                    return (mode & 49152) === 49152
                },
                flagsToPermissionString(flag) {
                    var perms = ["r", "w", "rw"][flag & 3];
                    if (flag & 512) {
                        perms += "w"
                    }
                    return perms
                },
                nodePermissions(node, perms) {
                    if (FS.ignorePermissions) {
                        return 0
                    }
                    if (perms.includes("r") && !(node.mode & 292)) {
                        return 2
                    } else if (perms.includes("w") && !(node.mode & 146)) {
                        return 2
                    } else if (perms.includes("x") && !(node.mode & 73)) {
                        return 2
                    }
                    return 0
                },
                mayLookup(dir) {
                    if (!FS.isDir(dir.mode)) return 54;
                    var errCode = FS.nodePermissions(dir, "x");
                    if (errCode) return errCode;
                    if (!dir.node_ops.lookup) return 2;
                    return 0
                },
                mayCreate(dir, name) {
                    try {
                        var node = FS.lookupNode(dir, name);
                        return 20
                    } catch (e) {}
                    return FS.nodePermissions(dir, "wx")
                },
                mayDelete(dir, name, isdir) {
                    var node;
                    try {
                        node = FS.lookupNode(dir, name)
                    } catch (e) {
                        return e.errno
                    }
                    var errCode = FS.nodePermissions(dir, "wx");
                    if (errCode) {
                        return errCode
                    }
                    if (isdir) {
                        if (!FS.isDir(node.mode)) {
                            return 54
                        }
                        if (FS.isRoot(node) || FS.getPath(node) === FS.cwd()) {
                            return 10
                        }
                    } else {
                        if (FS.isDir(node.mode)) {
                            return 31
                        }
                    }
                    return 0
                },
                mayOpen(node, flags) {
                    if (!node) {
                        return 44
                    }
                    if (FS.isLink(node.mode)) {
                        return 32
                    } else if (FS.isDir(node.mode)) {
                        if (FS.flagsToPermissionString(flags) !== "r" || flags & 512) {
                            return 31
                        }
                    }
                    return FS.nodePermissions(node, FS.flagsToPermissionString(flags))
                },
                MAX_OPEN_FDS: 4096,
                nextfd() {
                    for (var fd = 0; fd <= FS.MAX_OPEN_FDS; fd++) {
                        if (!FS.streams[fd]) {
                            return fd
                        }
                    }
                    throw new FS.ErrnoError(33)
                },
                getStreamChecked(fd) {
                    var stream = FS.getStream(fd);
                    if (!stream) {
                        throw new FS.ErrnoError(8)
                    }
                    return stream
                },
                getStream: fd => FS.streams[fd],
                createStream(stream, fd = -1) {
                    stream = Object.assign(new FS.FSStream, stream);
                    if (fd == -1) {
                        fd = FS.nextfd()
                    }
                    stream.fd = fd;
                    FS.streams[fd] = stream;
                    return stream
                },
                closeStream(fd) {
                    FS.streams[fd] = null
                },
                dupStream(origStream, fd = -1) {
                    var stream = FS.createStream(origStream, fd);
                    stream.stream_ops?.dup?.(stream);
                    return stream
                },
                chrdev_stream_ops: {
                    open(stream) {
                        var device = FS.getDevice(stream.node.rdev);
                        stream.stream_ops = device.stream_ops;
                        stream.stream_ops.open?.(stream)
                    },
                    llseek() {
                        throw new FS.ErrnoError(70)
                    }
                },
                major: dev => dev >> 8,
                minor: dev => dev & 255,
                makedev: (ma, mi) => ma << 8 | mi,
                registerDevice(dev, ops) {
                    FS.devices[dev] = {
                        stream_ops: ops
                    }
                },
                getDevice: dev => FS.devices[dev],
                getMounts(mount) {
                    var mounts = [];
                    var check = [mount];
                    while (check.length) {
                        var m = check.pop();
                        mounts.push(m);
                        check.push(...m.mounts)
                    }
                    return mounts
                },
                syncfs(populate, callback) {
                    if (typeof populate == "function") {
                        callback = populate;
                        populate = false
                    }
                    FS.syncFSRequests++;
                    if (FS.syncFSRequests > 1) {
                        err(`warning: ${FS.syncFSRequests} FS.syncfs operations in flight at once, probably just doing extra work`)
                    }
                    var mounts = FS.getMounts(FS.root.mount);
                    var completed = 0;

                    function doCallback(errCode) {
                        FS.syncFSRequests--;
                        return callback(errCode)
                    }

                    function done(errCode) {
                        if (errCode) {
                            if (!done.errored) {
                                done.errored = true;
                                return doCallback(errCode)
                            }
                            return
                        }
                        if (++completed >= mounts.length) {
                            doCallback(null)
                        }
                    }
                    mounts.forEach(mount => {
                        if (!mount.type.syncfs) {
                            return done(null)
                        }
                        mount.type.syncfs(mount, populate, done)
                    })
                },
                mount(type, opts, mountpoint) {
                    var root = mountpoint === "/";
                    var pseudo = !mountpoint;
                    var node;
                    if (root && FS.root) {
                        throw new FS.ErrnoError(10)
                    } else if (!root && !pseudo) {
                        var lookup = FS.lookupPath(mountpoint, {
                            follow_mount: false
                        });
                        mountpoint = lookup.path;
                        node = lookup.node;
                        if (FS.isMountpoint(node)) {
                            throw new FS.ErrnoError(10)
                        }
                        if (!FS.isDir(node.mode)) {
                            throw new FS.ErrnoError(54)
                        }
                    }
                    var mount = {
                        type,
                        opts,
                        mountpoint,
                        mounts: []
                    };
                    var mountRoot = type.mount(mount);
                    mountRoot.mount = mount;
                    mount.root = mountRoot;
                    if (root) {
                        FS.root = mountRoot
                    } else if (node) {
                        node.mounted = mount;
                        if (node.mount) {
                            node.mount.mounts.push(mount)
                        }
                    }
                    return mountRoot
                },
                unmount(mountpoint) {
                    var lookup = FS.lookupPath(mountpoint, {
                        follow_mount: false
                    });
                    if (!FS.isMountpoint(lookup.node)) {
                        throw new FS.ErrnoError(28)
                    }
                    var node = lookup.node;
                    var mount = node.mounted;
                    var mounts = FS.getMounts(mount);
                    Object.keys(FS.nameTable).forEach(hash => {
                        var current = FS.nameTable[hash];
                        while (current) {
                            var next = current.name_next;
                            if (mounts.includes(current.mount)) {
                                FS.destroyNode(current)
                            }
                            current = next
                        }
                    });
                    node.mounted = null;
                    var idx = node.mount.mounts.indexOf(mount);
                    node.mount.mounts.splice(idx, 1)
                },
                lookup(parent, name) {
                    return parent.node_ops.lookup(parent, name)
                },
                mknod(path, mode, dev) {
                    var lookup = FS.lookupPath(path, {
                        parent: true
                    });
                    var parent = lookup.node;
                    var name = PATH.basename(path);
                    if (!name || name === "." || name === "..") {
                        throw new FS.ErrnoError(28)
                    }
                    var errCode = FS.mayCreate(parent, name);
                    if (errCode) {
                        throw new FS.ErrnoError(errCode)
                    }
                    if (!parent.node_ops.mknod) {
                        throw new FS.ErrnoError(63)
                    }
                    return parent.node_ops.mknod(parent, name, mode, dev)
                },
                create(path, mode) {
                    mode = mode !== undefined ? mode : 438;
                    mode &= 4095;
                    mode |= 32768;
                    return FS.mknod(path, mode, 0)
                },
                mkdir(path, mode) {
                    mode = mode !== undefined ? mode : 511;
                    mode &= 511 | 512;
                    mode |= 16384;
                    return FS.mknod(path, mode, 0)
                },
                mkdirTree(path, mode) {
                    var dirs = path.split("/");
                    var d = "";
                    for (var i = 0; i < dirs.length; ++i) {
                        if (!dirs[i]) continue;
                        d += "/" + dirs[i];
                        try {
                            FS.mkdir(d, mode)
                        } catch (e) {
                            if (e.errno != 20) throw e
                        }
                    }
                },
                mkdev(path, mode, dev) {
                    if (typeof dev == "undefined") {
                        dev = mode;
                        mode = 438
                    }
                    mode |= 8192;
                    return FS.mknod(path, mode, dev)
                },
                symlink(oldpath, newpath) {
                    if (!PATH_FS.resolve(oldpath)) {
                        throw new FS.ErrnoError(44)
                    }
                    var lookup = FS.lookupPath(newpath, {
                        parent: true
                    });
                    var parent = lookup.node;
                    if (!parent) {
                        throw new FS.ErrnoError(44)
                    }
                    var newname = PATH.basename(newpath);
                    var errCode = FS.mayCreate(parent, newname);
                    if (errCode) {
                        throw new FS.ErrnoError(errCode)
                    }
                    if (!parent.node_ops.symlink) {
                        throw new FS.ErrnoError(63)
                    }
                    return parent.node_ops.symlink(parent, newname, oldpath)
                },
                rename(old_path, new_path) {
                    var old_dirname = PATH.dirname(old_path);
                    var new_dirname = PATH.dirname(new_path);
                    var old_name = PATH.basename(old_path);
                    var new_name = PATH.basename(new_path);
                    var lookup, old_dir, new_dir;
                    lookup = FS.lookupPath(old_path, {
                        parent: true
                    });
                    old_dir = lookup.node;
                    lookup = FS.lookupPath(new_path, {
                        parent: true
                    });
                    new_dir = lookup.node;
                    if (!old_dir || !new_dir) throw new FS.ErrnoError(44);
                    if (old_dir.mount !== new_dir.mount) {
                        throw new FS.ErrnoError(75)
                    }
                    var old_node = FS.lookupNode(old_dir, old_name);
                    var relative = PATH_FS.relative(old_path, new_dirname);
                    if (relative.charAt(0) !== ".") {
                        throw new FS.ErrnoError(28)
                    }
                    relative = PATH_FS.relative(new_path, old_dirname);
                    if (relative.charAt(0) !== ".") {
                        throw new FS.ErrnoError(55)
                    }
                    var new_node;
                    try {
                        new_node = FS.lookupNode(new_dir, new_name)
                    } catch (e) {}
                    if (old_node === new_node) {
                        return
                    }
                    var isdir = FS.isDir(old_node.mode);
                    var errCode = FS.mayDelete(old_dir, old_name, isdir);
                    if (errCode) {
                        throw new FS.ErrnoError(errCode)
                    }
                    errCode = new_node ? FS.mayDelete(new_dir, new_name, isdir) : FS.mayCreate(new_dir, new_name);
                    if (errCode) {
                        throw new FS.ErrnoError(errCode)
                    }
                    if (!old_dir.node_ops.rename) {
                        throw new FS.ErrnoError(63)
                    }
                    if (FS.isMountpoint(old_node) || new_node && FS.isMountpoint(new_node)) {
                        throw new FS.ErrnoError(10)
                    }
                    if (new_dir !== old_dir) {
                        errCode = FS.nodePermissions(old_dir, "w");
                        if (errCode) {
                            throw new FS.ErrnoError(errCode)
                        }
                    }
                    FS.hashRemoveNode(old_node);
                    try {
                        old_dir.node_ops.rename(old_node, new_dir, new_name);
                        old_node.parent = new_dir
                    } catch (e) {
                        throw e
                    } finally {
                        FS.hashAddNode(old_node)
                    }
                },
                rmdir(path) {
                    var lookup = FS.lookupPath(path, {
                        parent: true
                    });
                    var parent = lookup.node;
                    var name = PATH.basename(path);
                    var node = FS.lookupNode(parent, name);
                    var errCode = FS.mayDelete(parent, name, true);
                    if (errCode) {
                        throw new FS.ErrnoError(errCode)
                    }
                    if (!parent.node_ops.rmdir) {
                        throw new FS.ErrnoError(63)
                    }
                    if (FS.isMountpoint(node)) {
                        throw new FS.ErrnoError(10)
                    }
                    parent.node_ops.rmdir(parent, name);
                    FS.destroyNode(node)
                },
                readdir(path) {
                    var lookup = FS.lookupPath(path, {
                        follow: true
                    });
                    var node = lookup.node;
                    if (!node.node_ops.readdir) {
                        throw new FS.ErrnoError(54)
                    }
                    return node.node_ops.readdir(node)
                },
                unlink(path) {
                    var lookup = FS.lookupPath(path, {
                        parent: true
                    });
                    var parent = lookup.node;
                    if (!parent) {
                        throw new FS.ErrnoError(44)
                    }
                    var name = PATH.basename(path);
                    var node = FS.lookupNode(parent, name);
                    var errCode = FS.mayDelete(parent, name, false);
                    if (errCode) {
                        throw new FS.ErrnoError(errCode)
                    }
                    if (!parent.node_ops.unlink) {
                        throw new FS.ErrnoError(63)
                    }
                    if (FS.isMountpoint(node)) {
                        throw new FS.ErrnoError(10)
                    }
                    parent.node_ops.unlink(parent, name);
                    FS.destroyNode(node)
                },
                readlink(path) {
                    var lookup = FS.lookupPath(path);
                    var link = lookup.node;
                    if (!link) {
                        throw new FS.ErrnoError(44)
                    }
                    if (!link.node_ops.readlink) {
                        throw new FS.ErrnoError(28)
                    }
                    return PATH_FS.resolve(FS.getPath(link.parent), link.node_ops.readlink(link))
                },
                stat(path, dontFollow) {
                    var lookup = FS.lookupPath(path, {
                        follow: !dontFollow
                    });
                    var node = lookup.node;
                    if (!node) {
                        throw new FS.ErrnoError(44)
                    }
                    if (!node.node_ops.getattr) {
                        throw new FS.ErrnoError(63)
                    }
                    return node.node_ops.getattr(node)
                },
                lstat(path) {
                    return FS.stat(path, true)
                },
                chmod(path, mode, dontFollow) {
                    var node;
                    if (typeof path == "string") {
                        var lookup = FS.lookupPath(path, {
                            follow: !dontFollow
                        });
                        node = lookup.node
                    } else {
                        node = path
                    }
                    if (!node.node_ops.setattr) {
                        throw new FS.ErrnoError(63)
                    }
                    node.node_ops.setattr(node, {
                        mode: mode & 4095 | node.mode & ~4095,
                        timestamp: Date.now()
                    })
                },
                lchmod(path, mode) {
                    FS.chmod(path, mode, true)
                },
                fchmod(fd, mode) {
                    var stream = FS.getStreamChecked(fd);
                    FS.chmod(stream.node, mode)
                },
                chown(path, uid, gid, dontFollow) {
                    var node;
                    if (typeof path == "string") {
                        var lookup = FS.lookupPath(path, {
                            follow: !dontFollow
                        });
                        node = lookup.node
                    } else {
                        node = path
                    }
                    if (!node.node_ops.setattr) {
                        throw new FS.ErrnoError(63)
                    }
                    node.node_ops.setattr(node, {
                        timestamp: Date.now()
                    })
                },
                lchown(path, uid, gid) {
                    FS.chown(path, uid, gid, true)
                },
                fchown(fd, uid, gid) {
                    var stream = FS.getStreamChecked(fd);
                    FS.chown(stream.node, uid, gid)
                },
                truncate(path, len) {
                    if (len < 0) {
                        throw new FS.ErrnoError(28)
                    }
                    var node;
                    if (typeof path == "string") {
                        var lookup = FS.lookupPath(path, {
                            follow: true
                        });
                        node = lookup.node
                    } else {
                        node = path
                    }
                    if (!node.node_ops.setattr) {
                        throw new FS.ErrnoError(63)
                    }
                    if (FS.isDir(node.mode)) {
                        throw new FS.ErrnoError(31)
                    }
                    if (!FS.isFile(node.mode)) {
                        throw new FS.ErrnoError(28)
                    }
                    var errCode = FS.nodePermissions(node, "w");
                    if (errCode) {
                        throw new FS.ErrnoError(errCode)
                    }
                    node.node_ops.setattr(node, {
                        size: len,
                        timestamp: Date.now()
                    })
                },
                ftruncate(fd, len) {
                    var stream = FS.getStreamChecked(fd);
                    if ((stream.flags & 2097155) === 0) {
                        throw new FS.ErrnoError(28)
                    }
                    FS.truncate(stream.node, len)
                },
                utime(path, atime, mtime) {
                    var lookup = FS.lookupPath(path, {
                        follow: true
                    });
                    var node = lookup.node;
                    node.node_ops.setattr(node, {
                        timestamp: Math.max(atime, mtime)
                    })
                },
                open(path, flags, mode) {
                    if (path === "") {
                        throw new FS.ErrnoError(44)
                    }
                    flags = typeof flags == "string" ? FS_modeStringToFlags(flags) : flags;
                    if (flags & 64) {
                        mode = typeof mode == "undefined" ? 438 : mode;
                        mode = mode & 4095 | 32768
                    } else {
                        mode = 0
                    }
                    var node;
                    if (typeof path == "object") {
                        node = path
                    } else {
                        path = PATH.normalize(path);
                        try {
                            var lookup = FS.lookupPath(path, {
                                follow: !(flags & 131072)
                            });
                            node = lookup.node
                        } catch (e) {}
                    }
                    var created = false;
                    if (flags & 64) {
                        if (node) {
                            if (flags & 128) {
                                throw new FS.ErrnoError(20)
                            }
                        } else {
                            node = FS.mknod(path, mode, 0);
                            created = true
                        }
                    }
                    if (!node) {
                        throw new FS.ErrnoError(44)
                    }
                    if (FS.isChrdev(node.mode)) {
                        flags &= ~512
                    }
                    if (flags & 65536 && !FS.isDir(node.mode)) {
                        throw new FS.ErrnoError(54)
                    }
                    if (!created) {
                        var errCode = FS.mayOpen(node, flags);
                        if (errCode) {
                            throw new FS.ErrnoError(errCode)
                        }
                    }
                    if (flags & 512 && !created) {
                        FS.truncate(node, 0)
                    }
                    flags &= ~(128 | 512 | 131072);
                    var stream = FS.createStream({
                        node,
                        path: FS.getPath(node),
                        flags,
                        seekable: true,
                        position: 0,
                        stream_ops: node.stream_ops,
                        ungotten: [],
                        error: false
                    });
                    if (stream.stream_ops.open) {
                        stream.stream_ops.open(stream)
                    }
                    if (Module["logReadFiles"] && !(flags & 1)) {
                        if (!(path in FS.readFiles)) {
                            FS.readFiles[path] = 1
                        }
                    }
                    return stream
                },
                close(stream) {
                    if (FS.isClosed(stream)) {
                        throw new FS.ErrnoError(8)
                    }
                    if (stream.getdents) stream.getdents = null;
                    try {
                        if (stream.stream_ops.close) {
                            stream.stream_ops.close(stream)
                        }
                    } catch (e) {
                        throw e
                    } finally {
                        FS.closeStream(stream.fd)
                    }
                    stream.fd = null
                },
                isClosed(stream) {
                    return stream.fd === null
                },
                llseek(stream, offset, whence) {
                    if (FS.isClosed(stream)) {
                        throw new FS.ErrnoError(8)
                    }
                    if (!stream.seekable || !stream.stream_ops.llseek) {
                        throw new FS.ErrnoError(70)
                    }
                    if (whence != 0 && whence != 1 && whence != 2) {
                        throw new FS.ErrnoError(28)
                    }
                    stream.position = stream.stream_ops.llseek(stream, offset, whence);
                    stream.ungotten = [];
                    return stream.position
                },
                read(stream, buffer, offset, length, position) {
                    if (length < 0 || position < 0) {
                        throw new FS.ErrnoError(28)
                    }
                    if (FS.isClosed(stream)) {
                        throw new FS.ErrnoError(8)
                    }
                    if ((stream.flags & 2097155) === 1) {
                        throw new FS.ErrnoError(8)
                    }
                    if (FS.isDir(stream.node.mode)) {
                        throw new FS.ErrnoError(31)
                    }
                    if (!stream.stream_ops.read) {
                        throw new FS.ErrnoError(28)
                    }
                    var seeking = typeof position != "undefined";
                    if (!seeking) {
                        position = stream.position
                    } else if (!stream.seekable) {
                        throw new FS.ErrnoError(70)
                    }
                    var bytesRead = stream.stream_ops.read(stream, buffer, offset, length, position);
                    if (!seeking) stream.position += bytesRead;
                    return bytesRead
                },
                write(stream, buffer, offset, length, position, canOwn) {
                    if (length < 0 || position < 0) {
                        throw new FS.ErrnoError(28)
                    }
                    if (FS.isClosed(stream)) {
                        throw new FS.ErrnoError(8)
                    }
                    if ((stream.flags & 2097155) === 0) {
                        throw new FS.ErrnoError(8)
                    }
                    if (FS.isDir(stream.node.mode)) {
                        throw new FS.ErrnoError(31)
                    }
                    if (!stream.stream_ops.write) {
                        throw new FS.ErrnoError(28)
                    }
                    if (stream.seekable && stream.flags & 1024) {
                        FS.llseek(stream, 0, 2)
                    }
                    var seeking = typeof position != "undefined";
                    if (!seeking) {
                        position = stream.position
                    } else if (!stream.seekable) {
                        throw new FS.ErrnoError(70)
                    }
                    var bytesWritten = stream.stream_ops.write(stream, buffer, offset, length, position, canOwn);
                    if (!seeking) stream.position += bytesWritten;
                    return bytesWritten
                },
                allocate(stream, offset, length) {
                    if (FS.isClosed(stream)) {
                        throw new FS.ErrnoError(8)
                    }
                    if (offset < 0 || length <= 0) {
                        throw new FS.ErrnoError(28)
                    }
                    if ((stream.flags & 2097155) === 0) {
                        throw new FS.ErrnoError(8)
                    }
                    if (!FS.isFile(stream.node.mode) && !FS.isDir(stream.node.mode)) {
                        throw new FS.ErrnoError(43)
                    }
                    if (!stream.stream_ops.allocate) {
                        throw new FS.ErrnoError(138)
                    }
                    stream.stream_ops.allocate(stream, offset, length)
                },
                mmap(stream, length, position, prot, flags) {
                    if ((prot & 2) !== 0 && (flags & 2) === 0 && (stream.flags & 2097155) !== 2) {
                        throw new FS.ErrnoError(2)
                    }
                    if ((stream.flags & 2097155) === 1) {
                        throw new FS.ErrnoError(2)
                    }
                    if (!stream.stream_ops.mmap) {
                        throw new FS.ErrnoError(43)
                    }
                    if (!length) {
                        throw new FS.ErrnoError(28)
                    }
                    return stream.stream_ops.mmap(stream, length, position, prot, flags)
                },
                msync(stream, buffer, offset, length, mmapFlags) {
                    if (!stream.stream_ops.msync) {
                        return 0
                    }
                    return stream.stream_ops.msync(stream, buffer, offset, length, mmapFlags)
                },
                ioctl(stream, cmd, arg) {
                    if (!stream.stream_ops.ioctl) {
                        throw new FS.ErrnoError(59)
                    }
                    return stream.stream_ops.ioctl(stream, cmd, arg)
                },
                readFile(path, opts = {}) {
                    opts.flags = opts.flags || 0;
                    opts.encoding = opts.encoding || "binary";
                    if (opts.encoding !== "utf8" && opts.encoding !== "binary") {
                        throw new Error(`Invalid encoding type "${opts.encoding}"`)
                    }
                    var ret;
                    var stream = FS.open(path, opts.flags);
                    var stat = FS.stat(path);
                    var length = stat.size;
                    var buf = new Uint8Array(length);
                    FS.read(stream, buf, 0, length, 0);
                    if (opts.encoding === "utf8") {
                        ret = UTF8ArrayToString(buf)
                    } else if (opts.encoding === "binary") {
                        ret = buf
                    }
                    FS.close(stream);
                    return ret
                },
                writeFile(path, data, opts = {}) {
                    opts.flags = opts.flags || 577;
                    var stream = FS.open(path, opts.flags, opts.mode);
                    if (typeof data == "string") {
                        var buf = new Uint8Array(lengthBytesUTF8(data) + 1);
                        var actualNumBytes = stringToUTF8Array(data, buf, 0, buf.length);
                        FS.write(stream, buf, 0, actualNumBytes, undefined, opts.canOwn)
                    } else if (ArrayBuffer.isView(data)) {
                        FS.write(stream, data, 0, data.byteLength, undefined, opts.canOwn)
                    } else {
                        throw new Error("Unsupported data type")
                    }
                    FS.close(stream)
                },
                cwd: () => FS.currentPath,
                chdir(path) {
                    var lookup = FS.lookupPath(path, {
                        follow: true
                    });
                    if (lookup.node === null) {
                        throw new FS.ErrnoError(44)
                    }
                    if (!FS.isDir(lookup.node.mode)) {
                        throw new FS.ErrnoError(54)
                    }
                    var errCode = FS.nodePermissions(lookup.node, "x");
                    if (errCode) {
                        throw new FS.ErrnoError(errCode)
                    }
                    FS.currentPath = lookup.path
                },
                createDefaultDirectories() {
                    FS.mkdir("/tmp");
                    FS.mkdir("/home");
                    FS.mkdir("/home/web_user")
                },
                createDefaultDevices() {
                    FS.mkdir("/dev");
                    FS.registerDevice(FS.makedev(1, 3), {
                        read: () => 0,
                        write: (stream, buffer, offset, length, pos) => length
                    });
                    FS.mkdev("/dev/null", FS.makedev(1, 3));
                    TTY.register(FS.makedev(5, 0), TTY.default_tty_ops);
                    TTY.register(FS.makedev(6, 0), TTY.default_tty1_ops);
                    FS.mkdev("/dev/tty", FS.makedev(5, 0));
                    FS.mkdev("/dev/tty1", FS.makedev(6, 0));
                    var randomBuffer = new Uint8Array(1024),
                        randomLeft = 0;
                    var randomByte = () => {
                        if (randomLeft === 0) {
                            randomLeft = randomFill(randomBuffer).byteLength
                        }
                        return randomBuffer[--randomLeft]
                    };
                    FS.createDevice("/dev", "random", randomByte);
                    FS.createDevice("/dev", "urandom", randomByte);
                    FS.mkdir("/dev/shm");
                    FS.mkdir("/dev/shm/tmp")
                },
                createSpecialDirectories() {
                    FS.mkdir("/proc");
                    var proc_self = FS.mkdir("/proc/self");
                    FS.mkdir("/proc/self/fd");
                    FS.mount({
                        mount() {
                            var node = FS.createNode(proc_self, "fd", 16384 | 511, 73);
                            node.node_ops = {
                                lookup(parent, name) {
                                    var fd = +name;
                                    var stream = FS.getStreamChecked(fd);
                                    var ret = {
                                        parent: null,
                                        mount: {
                                            mountpoint: "fake"
                                        },
                                        node_ops: {
                                            readlink: () => stream.path
                                        }
                                    };
                                    ret.parent = ret;
                                    return ret
                                }
                            };
                            return node
                        }
                    }, {}, "/proc/self/fd")
                },
                createStandardStreams(input, output, error) {
                    if (input) {
                        FS.createDevice("/dev", "stdin", input)
                    } else {
                        FS.symlink("/dev/tty", "/dev/stdin")
                    }
                    if (output) {
                        FS.createDevice("/dev", "stdout", null, output)
                    } else {
                        FS.symlink("/dev/tty", "/dev/stdout")
                    }
                    if (error) {
                        FS.createDevice("/dev", "stderr", null, error)
                    } else {
                        FS.symlink("/dev/tty1", "/dev/stderr")
                    }
                    var stdin = FS.open("/dev/stdin", 0);
                    var stdout = FS.open("/dev/stdout", 1);
                    var stderr = FS.open("/dev/stderr", 1)
                },
                staticInit() {
                    [44].forEach(code => {
                        FS.genericErrors[code] = new FS.ErrnoError(code);
                        FS.genericErrors[code].stack = "<generic error, no stack>"
                    });
                    FS.nameTable = new Array(4096);
                    FS.mount(MEMFS, {}, "/");
                    FS.createDefaultDirectories();
                    FS.createDefaultDevices();
                    FS.createSpecialDirectories();
                    FS.filesystems = {
                        MEMFS
                    }
                },
                init(input, output, error) {
                    FS.initialized = true;
                    input ??= Module["stdin"];
                    output ??= Module["stdout"];
                    error ??= Module["stderr"];
                    FS.createStandardStreams(input, output, error)
                },
                quit() {
                    FS.initialized = false;
                    for (var i = 0; i < FS.streams.length; i++) {
                        var stream = FS.streams[i];
                        if (!stream) {
                            continue
                        }
                        FS.close(stream)
                    }
                },
                findObject(path, dontResolveLastLink) {
                    var ret = FS.analyzePath(path, dontResolveLastLink);
                    if (!ret.exists) {
                        return null
                    }
                    return ret.object
                },
                analyzePath(path, dontResolveLastLink) {
                    try {
                        var lookup = FS.lookupPath(path, {
                            follow: !dontResolveLastLink
                        });
                        path = lookup.path
                    } catch (e) {}
                    var ret = {
                        isRoot: false,
                        exists: false,
                        error: 0,
                        name: null,
                        path: null,
                        object: null,
                        parentExists: false,
                        parentPath: null,
                        parentObject: null
                    };
                    try {
                        var lookup = FS.lookupPath(path, {
                            parent: true
                        });
                        ret.parentExists = true;
                        ret.parentPath = lookup.path;
                        ret.parentObject = lookup.node;
                        ret.name = PATH.basename(path);
                        lookup = FS.lookupPath(path, {
                            follow: !dontResolveLastLink
                        });
                        ret.exists = true;
                        ret.path = lookup.path;
                        ret.object = lookup.node;
                        ret.name = lookup.node.name;
                        ret.isRoot = lookup.path === "/"
                    } catch (e) {
                        ret.error = e.errno
                    }
                    return ret
                },
                createPath(parent, path, canRead, canWrite) {
                    parent = typeof parent == "string" ? parent : FS.getPath(parent);
                    var parts = path.split("/").reverse();
                    while (parts.length) {
                        var part = parts.pop();
                        if (!part) continue;
                        var current = PATH.join2(parent, part);
                        try {
                            FS.mkdir(current)
                        } catch (e) {}
                        parent = current
                    }
                    return current
                },
                createFile(parent, name, properties, canRead, canWrite) {
                    var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
                    var mode = FS_getMode(canRead, canWrite);
                    return FS.create(path, mode)
                },
                createDataFile(parent, name, data, canRead, canWrite, canOwn) {
                    var path = name;
                    if (parent) {
                        parent = typeof parent == "string" ? parent : FS.getPath(parent);
                        path = name ? PATH.join2(parent, name) : parent
                    }
                    var mode = FS_getMode(canRead, canWrite);
                    var node = FS.create(path, mode);
                    if (data) {
                        if (typeof data == "string") {
                            var arr = new Array(data.length);
                            for (var i = 0, len = data.length; i < len; ++i) arr[i] = data.charCodeAt(i);
                            data = arr
                        }
                        FS.chmod(node, mode | 146);
                        var stream = FS.open(node, 577);
                        FS.write(stream, data, 0, data.length, 0, canOwn);
                        FS.close(stream);
                        FS.chmod(node, mode)
                    }
                },
                createDevice(parent, name, input, output) {
                    var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
                    var mode = FS_getMode(!!input, !!output);
                    FS.createDevice.major ??= 64;
                    var dev = FS.makedev(FS.createDevice.major++, 0);
                    FS.registerDevice(dev, {
                        open(stream) {
                            stream.seekable = false
                        },
                        close(stream) {
                            if (output?.buffer?.length) {
                                output(10)
                            }
                        },
                        read(stream, buffer, offset, length, pos) {
                            var bytesRead = 0;
                            for (var i = 0; i < length; i++) {
                                var result;
                                try {
                                    result = input()
                                } catch (e) {
                                    throw new FS.ErrnoError(29)
                                }
                                if (result === undefined && bytesRead === 0) {
                                    throw new FS.ErrnoError(6)
                                }
                                if (result === null || result === undefined) break;
                                bytesRead++;
                                buffer[offset + i] = result
                            }
                            if (bytesRead) {
                                stream.node.timestamp = Date.now()
                            }
                            return bytesRead
                        },
                        write(stream, buffer, offset, length, pos) {
                            for (var i = 0; i < length; i++) {
                                try {
                                    output(buffer[offset + i])
                                } catch (e) {
                                    throw new FS.ErrnoError(29)
                                }
                            }
                            if (length) {
                                stream.node.timestamp = Date.now()
                            }
                            return i
                        }
                    });
                    return FS.mkdev(path, mode, dev)
                },
                forceLoadFile(obj) {
                    if (obj.isDevice || obj.isFolder || obj.link || obj.contents) return true;
                    if (typeof XMLHttpRequest != "undefined") {
                        throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.")
                    } else {
                        try {
                            obj.contents = readBinary(obj.url);
                            obj.usedBytes = obj.contents.length
                        } catch (e) {
                            throw new FS.ErrnoError(29)
                        }
                    }
                },
                createLazyFile(parent, name, url, canRead, canWrite) {
                    class LazyUint8Array {
                        lengthKnown = false;
                        chunks = [];
                        get(idx) {
                            if (idx > this.length - 1 || idx < 0) {
                                return undefined
                            }
                            var chunkOffset = idx % this.chunkSize;
                            var chunkNum = idx / this.chunkSize | 0;
                            return this.getter(chunkNum)[chunkOffset]
                        }
                        setDataGetter(getter) {
                            this.getter = getter
                        }
                        cacheLength() {
                            var xhr = new XMLHttpRequest;
                            xhr.open("HEAD", url, false);
                            xhr.send(null);
                            if (!(xhr.status >= 200 && xhr.status < 300 || xhr.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr.status);
                            var datalength = Number(xhr.getResponseHeader("Content-length"));
                            var header;
                            var hasByteServing = (header = xhr.getResponseHeader("Accept-Ranges")) && header === "bytes";
                            var usesGzip = (header = xhr.getResponseHeader("Content-Encoding")) && header === "gzip";
                            var chunkSize = 1024 * 1024;
                            if (!hasByteServing) chunkSize = datalength;
                            var doXHR = (from, to) => {
                                if (from > to) throw new Error("invalid range (" + from + ", " + to + ") or no bytes requested!");
                                if (to > datalength - 1) throw new Error("only " + datalength + " bytes available! programmer error!");
                                var xhr = new XMLHttpRequest;
                                xhr.open("GET", url, false);
                                if (datalength !== chunkSize) xhr.setRequestHeader("Range", "bytes=" + from + "-" + to);
                                xhr.responseType = "arraybuffer";
                                if (xhr.overrideMimeType) {
                                    xhr.overrideMimeType("text/plain; charset=x-user-defined")
                                }
                                xhr.send(null);
                                if (!(xhr.status >= 200 && xhr.status < 300 || xhr.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr.status);
                                if (xhr.response !== undefined) {
                                    return new Uint8Array(xhr.response || [])
                                }
                                return intArrayFromString(xhr.responseText || "", true)
                            };
                            var lazyArray = this;
                            lazyArray.setDataGetter(chunkNum => {
                                var start = chunkNum * chunkSize;
                                var end = (chunkNum + 1) * chunkSize - 1;
                                end = Math.min(end, datalength - 1);
                                if (typeof lazyArray.chunks[chunkNum] == "undefined") {
                                    lazyArray.chunks[chunkNum] = doXHR(start, end)
                                }
                                if (typeof lazyArray.chunks[chunkNum] == "undefined") throw new Error("doXHR failed!");
                                return lazyArray.chunks[chunkNum]
                            });
                            if (usesGzip || !datalength) {
                                chunkSize = datalength = 1;
                                datalength = this.getter(0).length;
                                chunkSize = datalength;
                                out("LazyFiles on gzip forces download of the whole file when length is accessed")
                            }
                            this._length = datalength;
                            this._chunkSize = chunkSize;
                            this.lengthKnown = true
                        }
                        get length() {
                            if (!this.lengthKnown) {
                                this.cacheLength()
                            }
                            return this._length
                        }
                        get chunkSize() {
                            if (!this.lengthKnown) {
                                this.cacheLength()
                            }
                            return this._chunkSize
                        }
                    }
                    if (typeof XMLHttpRequest != "undefined") {
                        if (!ENVIRONMENT_IS_WORKER) throw "Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";
                        var lazyArray = new LazyUint8Array;
                        var properties = {
                            isDevice: false,
                            contents: lazyArray
                        }
                    } else {
                        var properties = {
                            isDevice: false,
                            url
                        }
                    }
                    var node = FS.createFile(parent, name, properties, canRead, canWrite);
                    if (properties.contents) {
                        node.contents = properties.contents
                    } else if (properties.url) {
                        node.contents = null;
                        node.url = properties.url
                    }
                    Object.defineProperties(node, {
                        usedBytes: {
                            get: function() {
                                return this.contents.length
                            }
                        }
                    });
                    var stream_ops = {};
                    var keys = Object.keys(node.stream_ops);
                    keys.forEach(key => {
                        var fn = node.stream_ops[key];
                        stream_ops[key] = (...args) => {
                            FS.forceLoadFile(node);
                            return fn(...args)
                        }
                    });

                    function writeChunks(stream, buffer, offset, length, position) {
                        var contents = stream.node.contents;
                        if (position >= contents.length) return 0;
                        var size = Math.min(contents.length - position, length);
                        if (contents.slice) {
                            for (var i = 0; i < size; i++) {
                                buffer[offset + i] = contents[position + i]
                            }
                        } else {
                            for (var i = 0; i < size; i++) {
                                buffer[offset + i] = contents.get(position + i)
                            }
                        }
                        return size
                    }
                    stream_ops.read = (stream, buffer, offset, length, position) => {
                        FS.forceLoadFile(node);
                        return writeChunks(stream, buffer, offset, length, position)
                    };
                    stream_ops.mmap = (stream, length, position, prot, flags) => {
                        FS.forceLoadFile(node);
                        var ptr = mmapAlloc(length);
                        if (!ptr) {
                            throw new FS.ErrnoError(48)
                        }
                        writeChunks(stream, HEAP8, ptr, length, position);
                        return {
                            ptr,
                            allocated: true
                        }
                    };
                    node.stream_ops = stream_ops;
                    return node
                }
            };
            var SYSCALLS = {
                DEFAULT_POLLMASK: 5,
                calculateAt(dirfd, path, allowEmpty) {
                    if (PATH.isAbs(path)) {
                        return path
                    }
                    var dir;
                    if (dirfd === -100) {
                        dir = FS.cwd()
                    } else {
                        var dirstream = SYSCALLS.getStreamFromFD(dirfd);
                        dir = dirstream.path
                    }
                    if (path.length == 0) {
                        if (!allowEmpty) {
                            throw new FS.ErrnoError(44)
                        }
                        return dir
                    }
                    return PATH.join2(dir, path)
                },
                doStat(func, path, buf) {
                    var stat = func(path);
                    HEAP32[buf >>> 2 >>> 0] = stat.dev;
                    HEAP32[buf + 4 >>> 2 >>> 0] = stat.mode;
                    HEAPU32[buf + 8 >>> 2 >>> 0] = stat.nlink;
                    HEAP32[buf + 12 >>> 2 >>> 0] = stat.uid;
                    HEAP32[buf + 16 >>> 2 >>> 0] = stat.gid;
                    HEAP32[buf + 20 >>> 2 >>> 0] = stat.rdev;
                    tempI64 = [stat.size >>> 0, (tempDouble = stat.size, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[buf + 24 >>> 2 >>> 0] = tempI64[0], HEAP32[buf + 28 >>> 2 >>> 0] = tempI64[1];
                    HEAP32[buf + 32 >>> 2 >>> 0] = 4096;
                    HEAP32[buf + 36 >>> 2 >>> 0] = stat.blocks;
                    var atime = stat.atime.getTime();
                    var mtime = stat.mtime.getTime();
                    var ctime = stat.ctime.getTime();
                    tempI64 = [Math.floor(atime / 1e3) >>> 0, (tempDouble = Math.floor(atime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[buf + 40 >>> 2 >>> 0] = tempI64[0], HEAP32[buf + 44 >>> 2 >>> 0] = tempI64[1];
                    HEAPU32[buf + 48 >>> 2 >>> 0] = atime % 1e3 * 1e3 * 1e3;
                    tempI64 = [Math.floor(mtime / 1e3) >>> 0, (tempDouble = Math.floor(mtime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[buf + 56 >>> 2 >>> 0] = tempI64[0], HEAP32[buf + 60 >>> 2 >>> 0] = tempI64[1];
                    HEAPU32[buf + 64 >>> 2 >>> 0] = mtime % 1e3 * 1e3 * 1e3;
                    tempI64 = [Math.floor(ctime / 1e3) >>> 0, (tempDouble = Math.floor(ctime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[buf + 72 >>> 2 >>> 0] = tempI64[0], HEAP32[buf + 76 >>> 2 >>> 0] = tempI64[1];
                    HEAPU32[buf + 80 >>> 2 >>> 0] = ctime % 1e3 * 1e3 * 1e3;
                    tempI64 = [stat.ino >>> 0, (tempDouble = stat.ino, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[buf + 88 >>> 2 >>> 0] = tempI64[0], HEAP32[buf + 92 >>> 2 >>> 0] = tempI64[1];
                    return 0
                },
                doMsync(addr, stream, len, flags, offset) {
                    if (!FS.isFile(stream.node.mode)) {
                        throw new FS.ErrnoError(43)
                    }
                    if (flags & 2) {
                        return 0
                    }
                    var buffer = HEAPU8.slice(addr, addr + len);
                    FS.msync(stream, buffer, offset, len, flags)
                },
                getStreamFromFD(fd) {
                    var stream = FS.getStreamChecked(fd);
                    return stream
                },
                varargs: undefined,
                getStr(ptr) {
                    var ret = UTF8ToString(ptr);
                    return ret
                }
            };
            var ___syscall__newselect = function(nfds, readfds, writefds, exceptfds, timeout) {
                readfds >>>= 0;
                writefds >>>= 0;
                exceptfds >>>= 0;
                timeout >>>= 0;
                try {
                    var total = 0;
                    var srcReadLow = readfds ? HEAP32[readfds >>> 2 >>> 0] : 0,
                        srcReadHigh = readfds ? HEAP32[readfds + 4 >>> 2 >>> 0] : 0;
                    var srcWriteLow = writefds ? HEAP32[writefds >>> 2 >>> 0] : 0,
                        srcWriteHigh = writefds ? HEAP32[writefds + 4 >>> 2 >>> 0] : 0;
                    var srcExceptLow = exceptfds ? HEAP32[exceptfds >>> 2 >>> 0] : 0,
                        srcExceptHigh = exceptfds ? HEAP32[exceptfds + 4 >>> 2 >>> 0] : 0;
                    var dstReadLow = 0,
                        dstReadHigh = 0;
                    var dstWriteLow = 0,
                        dstWriteHigh = 0;
                    var dstExceptLow = 0,
                        dstExceptHigh = 0;
                    var allLow = (readfds ? HEAP32[readfds >>> 2 >>> 0] : 0) | (writefds ? HEAP32[writefds >>> 2 >>> 0] : 0) | (exceptfds ? HEAP32[exceptfds >>> 2 >>> 0] : 0);
                    var allHigh = (readfds ? HEAP32[readfds + 4 >>> 2 >>> 0] : 0) | (writefds ? HEAP32[writefds + 4 >>> 2 >>> 0] : 0) | (exceptfds ? HEAP32[exceptfds + 4 >>> 2 >>> 0] : 0);
                    var check = (fd, low, high, val) => fd < 32 ? low & val : high & val;
                    for (var fd = 0; fd < nfds; fd++) {
                        var mask = 1 << fd % 32;
                        if (!check(fd, allLow, allHigh, mask)) {
                            continue
                        }
                        var stream = SYSCALLS.getStreamFromFD(fd);
                        var flags = SYSCALLS.DEFAULT_POLLMASK;
                        if (stream.stream_ops.poll) {
                            var timeoutInMillis = -1;
                            if (timeout) {
                                var tv_sec = readfds ? HEAP32[timeout >>> 2 >>> 0] : 0,
                                    tv_usec = readfds ? HEAP32[timeout + 4 >>> 2 >>> 0] : 0;
                                timeoutInMillis = (tv_sec + tv_usec / 1e6) * 1e3
                            }
                            flags = stream.stream_ops.poll(stream, timeoutInMillis)
                        }
                        if (flags & 1 && check(fd, srcReadLow, srcReadHigh, mask)) {
                            fd < 32 ? dstReadLow = dstReadLow | mask : dstReadHigh = dstReadHigh | mask;
                            total++
                        }
                        if (flags & 4 && check(fd, srcWriteLow, srcWriteHigh, mask)) {
                            fd < 32 ? dstWriteLow = dstWriteLow | mask : dstWriteHigh = dstWriteHigh | mask;
                            total++
                        }
                        if (flags & 2 && check(fd, srcExceptLow, srcExceptHigh, mask)) {
                            fd < 32 ? dstExceptLow = dstExceptLow | mask : dstExceptHigh = dstExceptHigh | mask;
                            total++
                        }
                    }
                    if (readfds) {
                        HEAP32[readfds >>> 2 >>> 0] = dstReadLow;
                        HEAP32[readfds + 4 >>> 2 >>> 0] = dstReadHigh
                    }
                    if (writefds) {
                        HEAP32[writefds >>> 2 >>> 0] = dstWriteLow;
                        HEAP32[writefds + 4 >>> 2 >>> 0] = dstWriteHigh
                    }
                    if (exceptfds) {
                        HEAP32[exceptfds >>> 2 >>> 0] = dstExceptLow;
                        HEAP32[exceptfds + 4 >>> 2 >>> 0] = dstExceptHigh
                    }
                    return total
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            };
            ___syscall__newselect.sig = "iipppp";
            var SOCKFS = {
                websocketArgs: {},
                callbacks: {},
                on(event, callback) {
                    SOCKFS.callbacks[event] = callback
                },
                emit(event, param) {
                    SOCKFS.callbacks[event]?.(param)
                },
                mount(mount) {
                    SOCKFS.websocketArgs = Module["websocket"] || {};
                    (Module["websocket"] ??= {})["on"] = SOCKFS.on;
                    return FS.createNode(null, "/", 16384 | 511, 0)
                },
                createSocket(family, type, protocol) {
                    type &= ~526336;
                    var streaming = type == 1;
                    if (streaming && protocol && protocol != 6) {
                        throw new FS.ErrnoError(66)
                    }
                    var sock = {
                        family,
                        type,
                        protocol,
                        server: null,
                        error: null,
                        peers: {},
                        pending: [],
                        recv_queue: [],
                        sock_ops: SOCKFS.websocket_sock_ops
                    };
                    var name = SOCKFS.nextname();
                    var node = FS.createNode(SOCKFS.root, name, 49152, 0);
                    node.sock = sock;
                    var stream = FS.createStream({
                        path: name,
                        node,
                        flags: 2,
                        seekable: false,
                        stream_ops: SOCKFS.stream_ops
                    });
                    sock.stream = stream;
                    return sock
                },
                getSocket(fd) {
                    var stream = FS.getStream(fd);
                    if (!stream || !FS.isSocket(stream.node.mode)) {
                        return null
                    }
                    return stream.node.sock
                },
                stream_ops: {
                    poll(stream) {
                        var sock = stream.node.sock;
                        return sock.sock_ops.poll(sock)
                    },
                    ioctl(stream, request, varargs) {
                        var sock = stream.node.sock;
                        return sock.sock_ops.ioctl(sock, request, varargs)
                    },
                    read(stream, buffer, offset, length, position) {
                        var sock = stream.node.sock;
                        var msg = sock.sock_ops.recvmsg(sock, length);
                        if (!msg) {
                            return 0
                        }
                        buffer.set(msg.buffer, offset);
                        return msg.buffer.length
                    },
                    write(stream, buffer, offset, length, position) {
                        var sock = stream.node.sock;
                        return sock.sock_ops.sendmsg(sock, buffer, offset, length)
                    },
                    close(stream) {
                        var sock = stream.node.sock;
                        sock.sock_ops.close(sock)
                    }
                },
                nextname() {
                    if (!SOCKFS.nextname.current) {
                        SOCKFS.nextname.current = 0
                    }
                    return "socket[" + SOCKFS.nextname.current++ + "]"
                },
                websocket_sock_ops: {
                    createPeer(sock, addr, port) {
                        var ws;
                        if (typeof addr == "object") {
                            ws = addr;
                            addr = null;
                            port = null
                        }
                        if (ws) {
                            if (ws._socket) {
                                addr = ws._socket.remoteAddress;
                                port = ws._socket.remotePort
                            } else {
                                var result = /ws[s]?:\/\/([^:]+):(\d+)/.exec(ws.url);
                                if (!result) {
                                    throw new Error("WebSocket URL must be in the format ws(s)://address:port")
                                }
                                addr = result[1];
                                port = parseInt(result[2], 10)
                            }
                        } else {
                            try {
                                var url = "ws:#".replace("#", "//");
                                var subProtocols = "binary";
                                var opts = undefined;
                                if (SOCKFS.websocketArgs["url"]) {
                                    url = SOCKFS.websocketArgs["url"]
                                }
                                if (SOCKFS.websocketArgs["subprotocol"]) {
                                    subProtocols = SOCKFS.websocketArgs["subprotocol"]
                                } else if (SOCKFS.websocketArgs["subprotocol"] === null) {
                                    subProtocols = "null"
                                }
                                if (url === "ws://" || url === "wss://") {
                                    var parts = addr.split("/");
                                    url = url + parts[0] + ":" + port + "/" + parts.slice(1).join("/")
                                }
                                if (subProtocols !== "null") {
                                    subProtocols = subProtocols.replace(/^ +| +$/g, "").split(/ *, */);
                                    opts = subProtocols
                                }
                                var WebSocketConstructor;
                                if (ENVIRONMENT_IS_NODE) {
                                    WebSocketConstructor = require("ws")
                                } else {
                                    WebSocketConstructor = WebSocket
                                }
                                ws = new WebSocketConstructor(url, opts);
                                ws.binaryType = "arraybuffer"
                            } catch (e) {
                                throw new FS.ErrnoError(23)
                            }
                        }
                        var peer = {
                            addr,
                            port,
                            socket: ws,
                            msg_send_queue: []
                        };
                        SOCKFS.websocket_sock_ops.addPeer(sock, peer);
                        SOCKFS.websocket_sock_ops.handlePeerEvents(sock, peer);
                        if (sock.type === 2 && typeof sock.sport != "undefined") {
                            peer.msg_send_queue.push(new Uint8Array([255, 255, 255, 255, "p".charCodeAt(0), "o".charCodeAt(0), "r".charCodeAt(0), "t".charCodeAt(0), (sock.sport & 65280) >> 8, sock.sport & 255]))
                        }
                        return peer
                    },
                    getPeer(sock, addr, port) {
                        return sock.peers[addr + ":" + port]
                    },
                    addPeer(sock, peer) {
                        sock.peers[peer.addr + ":" + peer.port] = peer
                    },
                    removePeer(sock, peer) {
                        delete sock.peers[peer.addr + ":" + peer.port]
                    },
                    handlePeerEvents(sock, peer) {
                        var first = true;
                        var handleOpen = function() {
                            sock.connecting = false;
                            SOCKFS.emit("open", sock.stream.fd);
                            try {
                                var queued = peer.msg_send_queue.shift();
                                while (queued) {
                                    peer.socket.send(queued);
                                    queued = peer.msg_send_queue.shift()
                                }
                            } catch (e) {
                                peer.socket.close()
                            }
                        };

                        function handleMessage(data) {
                            if (typeof data == "string") {
                                var encoder = new TextEncoder;
                                data = encoder.encode(data)
                            } else {
                                assert(data.byteLength !== undefined);
                                if (data.byteLength == 0) {
                                    return
                                }
                                data = new Uint8Array(data)
                            }
                            var wasfirst = first;
                            first = false;
                            if (wasfirst && data.length === 10 && data[0] === 255 && data[1] === 255 && data[2] === 255 && data[3] === 255 && data[4] === "p".charCodeAt(0) && data[5] === "o".charCodeAt(0) && data[6] === "r".charCodeAt(0) && data[7] === "t".charCodeAt(0)) {
                                var newport = data[8] << 8 | data[9];
                                SOCKFS.websocket_sock_ops.removePeer(sock, peer);
                                peer.port = newport;
                                SOCKFS.websocket_sock_ops.addPeer(sock, peer);
                                return
                            }
                            sock.recv_queue.push({
                                addr: peer.addr,
                                port: peer.port,
                                data
                            });
                            SOCKFS.emit("message", sock.stream.fd)
                        }
                        if (ENVIRONMENT_IS_NODE) {
                            peer.socket.on("open", handleOpen);
                            peer.socket.on("message", function(data, isBinary) {
                                if (!isBinary) {
                                    return
                                }
                                handleMessage(new Uint8Array(data).buffer)
                            });
                            peer.socket.on("close", function() {
                                SOCKFS.emit("close", sock.stream.fd)
                            });
                            peer.socket.on("error", function(error) {
                                sock.error = 14;
                                SOCKFS.emit("error", [sock.stream.fd, sock.error, "ECONNREFUSED: Connection refused"])
                            })
                        } else {
                            peer.socket.onopen = handleOpen;
                            peer.socket.onclose = function() {
                                SOCKFS.emit("close", sock.stream.fd)
                            };
                            peer.socket.onmessage = function peer_socket_onmessage(event) {
                                handleMessage(event.data)
                            };
                            peer.socket.onerror = function(error) {
                                sock.error = 14;
                                SOCKFS.emit("error", [sock.stream.fd, sock.error, "ECONNREFUSED: Connection refused"])
                            }
                        }
                    },
                    poll(sock) {
                        if (sock.type === 1 && sock.server) {
                            return sock.pending.length ? 64 | 1 : 0
                        }
                        var mask = 0;
                        var dest = sock.type === 1 ? SOCKFS.websocket_sock_ops.getPeer(sock, sock.daddr, sock.dport) : null;
                        if (sock.recv_queue.length || !dest || dest && dest.socket.readyState === dest.socket.CLOSING || dest && dest.socket.readyState === dest.socket.CLOSED) {
                            mask |= 64 | 1
                        }
                        if (!dest || dest && dest.socket.readyState === dest.socket.OPEN) {
                            mask |= 4
                        }
                        if (dest && dest.socket.readyState === dest.socket.CLOSING || dest && dest.socket.readyState === dest.socket.CLOSED) {
                            if (sock.connecting) {
                                mask |= 4
                            } else {
                                mask |= 16
                            }
                        }
                        return mask
                    },
                    ioctl(sock, request, arg) {
                        switch (request) {
                            case 21531:
                                var bytes = 0;
                                if (sock.recv_queue.length) {
                                    bytes = sock.recv_queue[0].data.length
                                }
                                HEAP32[arg >>> 2 >>> 0] = bytes;
                                return 0;
                            default:
                                return 28
                        }
                    },
                    close(sock) {
                        if (sock.server) {
                            try {
                                sock.server.close()
                            } catch (e) {}
                            sock.server = null
                        }
                        var peers = Object.keys(sock.peers);
                        for (var i = 0; i < peers.length; i++) {
                            var peer = sock.peers[peers[i]];
                            try {
                                peer.socket.close()
                            } catch (e) {}
                            SOCKFS.websocket_sock_ops.removePeer(sock, peer)
                        }
                        return 0
                    },
                    bind(sock, addr, port) {
                        if (typeof sock.saddr != "undefined" || typeof sock.sport != "undefined") {
                            throw new FS.ErrnoError(28)
                        }
                        sock.saddr = addr;
                        sock.sport = port;
                        if (sock.type === 2) {
                            if (sock.server) {
                                sock.server.close();
                                sock.server = null
                            }
                            try {
                                sock.sock_ops.listen(sock, 0)
                            } catch (e) {
                                if (!(e.name === "ErrnoError")) throw e;
                                if (e.errno !== 138) throw e
                            }
                        }
                    },
                    connect(sock, addr, port) {
                        if (sock.server) {
                            throw new FS.ErrnoError(138)
                        }
                        if (typeof sock.daddr != "undefined" && typeof sock.dport != "undefined") {
                            var dest = SOCKFS.websocket_sock_ops.getPeer(sock, sock.daddr, sock.dport);
                            if (dest) {
                                if (dest.socket.readyState === dest.socket.CONNECTING) {
                                    throw new FS.ErrnoError(7)
                                } else {
                                    throw new FS.ErrnoError(30)
                                }
                            }
                        }
                        var peer = SOCKFS.websocket_sock_ops.createPeer(sock, addr, port);
                        sock.daddr = peer.addr;
                        sock.dport = peer.port;
                        sock.connecting = true
                    },
                    listen(sock, backlog) {
                        if (!ENVIRONMENT_IS_NODE) {
                            throw new FS.ErrnoError(138)
                        }
                        if (sock.server) {
                            throw new FS.ErrnoError(28)
                        }
                        var WebSocketServer = require("ws").Server;
                        var host = sock.saddr;
                        sock.server = new WebSocketServer({
                            host,
                            port: sock.sport
                        });
                        SOCKFS.emit("listen", sock.stream.fd);
                        sock.server.on("connection", function(ws) {
                            if (sock.type === 1) {
                                var newsock = SOCKFS.createSocket(sock.family, sock.type, sock.protocol);
                                var peer = SOCKFS.websocket_sock_ops.createPeer(newsock, ws);
                                newsock.daddr = peer.addr;
                                newsock.dport = peer.port;
                                sock.pending.push(newsock);
                                SOCKFS.emit("connection", newsock.stream.fd)
                            } else {
                                SOCKFS.websocket_sock_ops.createPeer(sock, ws);
                                SOCKFS.emit("connection", sock.stream.fd)
                            }
                        });
                        sock.server.on("close", function() {
                            SOCKFS.emit("close", sock.stream.fd);
                            sock.server = null
                        });
                        sock.server.on("error", function(error) {
                            sock.error = 23;
                            SOCKFS.emit("error", [sock.stream.fd, sock.error, "EHOSTUNREACH: Host is unreachable"])
                        })
                    },
                    accept(listensock) {
                        if (!listensock.server || !listensock.pending.length) {
                            throw new FS.ErrnoError(28)
                        }
                        var newsock = listensock.pending.shift();
                        newsock.stream.flags = listensock.stream.flags;
                        return newsock
                    },
                    getname(sock, peer) {
                        var addr, port;
                        if (peer) {
                            if (sock.daddr === undefined || sock.dport === undefined) {
                                throw new FS.ErrnoError(53)
                            }
                            addr = sock.daddr;
                            port = sock.dport
                        } else {
                            addr = sock.saddr || 0;
                            port = sock.sport || 0
                        }
                        return {
                            addr,
                            port
                        }
                    },
                    sendmsg(sock, buffer, offset, length, addr, port) {
                        if (sock.type === 2) {
                            if (addr === undefined || port === undefined) {
                                addr = sock.daddr;
                                port = sock.dport
                            }
                            if (addr === undefined || port === undefined) {
                                throw new FS.ErrnoError(17)
                            }
                        } else {
                            addr = sock.daddr;
                            port = sock.dport
                        }
                        var dest = SOCKFS.websocket_sock_ops.getPeer(sock, addr, port);
                        if (sock.type === 1) {
                            if (!dest || dest.socket.readyState === dest.socket.CLOSING || dest.socket.readyState === dest.socket.CLOSED) {
                                throw new FS.ErrnoError(53)
                            }
                        }
                        if (ArrayBuffer.isView(buffer)) {
                            offset += buffer.byteOffset;
                            buffer = buffer.buffer
                        }
                        var data;
                        data = buffer.slice(offset, offset + length);
                        if (!dest || dest.socket.readyState !== dest.socket.OPEN) {
                            if (sock.type === 2) {
                                if (!dest || dest.socket.readyState === dest.socket.CLOSING || dest.socket.readyState === dest.socket.CLOSED) {
                                    dest = SOCKFS.websocket_sock_ops.createPeer(sock, addr, port)
                                }
                            }
                            dest.msg_send_queue.push(data);
                            return length
                        }
                        try {
                            dest.socket.send(data);
                            return length
                        } catch (e) {
                            throw new FS.ErrnoError(28)
                        }
                    },
                    recvmsg(sock, length) {
                        if (sock.type === 1 && sock.server) {
                            throw new FS.ErrnoError(53)
                        }
                        var queued = sock.recv_queue.shift();
                        if (!queued) {
                            if (sock.type === 1) {
                                var dest = SOCKFS.websocket_sock_ops.getPeer(sock, sock.daddr, sock.dport);
                                if (!dest) {
                                    throw new FS.ErrnoError(53)
                                }
                                if (dest.socket.readyState === dest.socket.CLOSING || dest.socket.readyState === dest.socket.CLOSED) {
                                    return null
                                }
                                throw new FS.ErrnoError(6)
                            }
                            throw new FS.ErrnoError(6)
                        }
                        var queuedLength = queued.data.byteLength || queued.data.length;
                        var queuedOffset = queued.data.byteOffset || 0;
                        var queuedBuffer = queued.data.buffer || queued.data;
                        var bytesRead = Math.min(length, queuedLength);
                        var res = {
                            buffer: new Uint8Array(queuedBuffer, queuedOffset, bytesRead),
                            addr: queued.addr,
                            port: queued.port
                        };
                        if (sock.type === 1 && bytesRead < queuedLength) {
                            var bytesRemaining = queuedLength - bytesRead;
                            queued.data = new Uint8Array(queuedBuffer, queuedOffset + bytesRead, bytesRemaining);
                            sock.recv_queue.unshift(queued)
                        }
                        return res
                    }
                }
            };
            var getSocketFromFD = fd => {
                var socket = SOCKFS.getSocket(fd);
                if (!socket) throw new FS.ErrnoError(8);
                return socket
            };
            var Sockets = {
                BUFFER_SIZE: 10240,
                MAX_BUFFER_SIZE: 10485760,
                nextFd: 1,
                fds: {},
                nextport: 1,
                maxport: 65535,
                peer: null,
                connections: {},
                portmap: {},
                localAddr: 4261412874,
                addrPool: [33554442, 50331658, 67108874, 83886090, 100663306, 117440522, 134217738, 150994954, 167772170, 184549386, 201326602, 218103818, 234881034]
            };
            var inetPton4 = str => {
                var b = str.split(".");
                for (var i = 0; i < 4; i++) {
                    var tmp = Number(b[i]);
                    if (isNaN(tmp)) return null;
                    b[i] = tmp
                }
                return (b[0] | b[1] << 8 | b[2] << 16 | b[3] << 24) >>> 0
            };
            var jstoi_q = str => parseInt(str);
            var inetPton6 = str => {
                var words;
                var w, offset, z, i;
                var valid6regx = /^((?=.*::)(?!.*::.+::)(::)?([\dA-F]{1,4}:(:|\b)|){5}|([\dA-F]{1,4}:){6})((([\dA-F]{1,4}((?!\3)::|:\b|$))|(?!\2\3)){2}|(((2[0-4]|1\d|[1-9])?\d|25[0-5])\.?\b){4})$/i;
                var parts = [];
                if (!valid6regx.test(str)) {
                    return null
                }
                if (str === "::") {
                    return [0, 0, 0, 0, 0, 0, 0, 0]
                }
                if (str.startsWith("::")) {
                    str = str.replace("::", "Z:")
                } else {
                    str = str.replace("::", ":Z:")
                }
                if (str.indexOf(".") > 0) {
                    str = str.replace(new RegExp("[.]", "g"), ":");
                    words = str.split(":");
                    words[words.length - 4] = jstoi_q(words[words.length - 4]) + jstoi_q(words[words.length - 3]) * 256;
                    words[words.length - 3] = jstoi_q(words[words.length - 2]) + jstoi_q(words[words.length - 1]) * 256;
                    words = words.slice(0, words.length - 2)
                } else {
                    words = str.split(":")
                }
                offset = 0;
                z = 0;
                for (w = 0; w < words.length; w++) {
                    if (typeof words[w] == "string") {
                        if (words[w] === "Z") {
                            for (z = 0; z < 8 - words.length + 1; z++) {
                                parts[w + z] = 0
                            }
                            offset = z - 1
                        } else {
                            parts[w + offset] = _htons(parseInt(words[w], 16))
                        }
                    } else {
                        parts[w + offset] = words[w]
                    }
                }
                return [parts[1] << 16 | parts[0], parts[3] << 16 | parts[2], parts[5] << 16 | parts[4], parts[7] << 16 | parts[6]]
            };
            var writeSockaddr = (sa, family, addr, port, addrlen) => {
                switch (family) {
                    case 2:
                        addr = inetPton4(addr);
                        zeroMemory(sa, 16);
                        if (addrlen) {
                            HEAP32[addrlen >>> 2 >>> 0] = 16
                        }
                        HEAP16[sa >>> 1 >>> 0] = family;
                        HEAP32[sa + 4 >>> 2 >>> 0] = addr;
                        HEAP16[sa + 2 >>> 1 >>> 0] = _htons(port);
                        break;
                    case 10:
                        addr = inetPton6(addr);
                        zeroMemory(sa, 28);
                        if (addrlen) {
                            HEAP32[addrlen >>> 2 >>> 0] = 28
                        }
                        HEAP32[sa >>> 2 >>> 0] = family;
                        HEAP32[sa + 8 >>> 2 >>> 0] = addr[0];
                        HEAP32[sa + 12 >>> 2 >>> 0] = addr[1];
                        HEAP32[sa + 16 >>> 2 >>> 0] = addr[2];
                        HEAP32[sa + 20 >>> 2 >>> 0] = addr[3];
                        HEAP16[sa + 2 >>> 1 >>> 0] = _htons(port);
                        break;
                    default:
                        return 5
                }
                return 0
            };
            var DNS = {
                address_map: {
                    id: 1,
                    addrs: {},
                    names: {}
                },
                lookup_name(name) {
                    var res = inetPton4(name);
                    if (res !== null) {
                        return name
                    }
                    res = inetPton6(name);
                    if (res !== null) {
                        return name
                    }
                    var addr;
                    if (DNS.address_map.addrs[name]) {
                        addr = DNS.address_map.addrs[name]
                    } else {
                        var id = DNS.address_map.id++;
                        assert(id < 65535, "exceeded max address mappings of 65535");
                        addr = "172.29." + (id & 255) + "." + (id & 65280);
                        DNS.address_map.names[addr] = name;
                        DNS.address_map.addrs[name] = addr
                    }
                    return addr
                },
                lookup_addr(addr) {
                    if (DNS.address_map.names[addr]) {
                        return DNS.address_map.names[addr]
                    }
                    return null
                }
            };

            function ___syscall_accept4(fd, addr, addrlen, flags, d1, d2) {
                addr >>>= 0;
                addrlen >>>= 0;
                try {
                    var sock = getSocketFromFD(fd);
                    var newsock = sock.sock_ops.accept(sock);
                    if (addr) {
                        var errno = writeSockaddr(addr, newsock.family, DNS.lookup_name(newsock.daddr), newsock.dport, addrlen)
                    }
                    return newsock.stream.fd
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_accept4.sig = "iippiii";
            var inetNtop4 = addr => (addr & 255) + "." + (addr >> 8 & 255) + "." + (addr >> 16 & 255) + "." + (addr >> 24 & 255);
            var inetNtop6 = ints => {
                var str = "";
                var word = 0;
                var longest = 0;
                var lastzero = 0;
                var zstart = 0;
                var len = 0;
                var i = 0;
                var parts = [ints[0] & 65535, ints[0] >> 16, ints[1] & 65535, ints[1] >> 16, ints[2] & 65535, ints[2] >> 16, ints[3] & 65535, ints[3] >> 16];
                var hasipv4 = true;
                var v4part = "";
                for (i = 0; i < 5; i++) {
                    if (parts[i] !== 0) {
                        hasipv4 = false;
                        break
                    }
                }
                if (hasipv4) {
                    v4part = inetNtop4(parts[6] | parts[7] << 16);
                    if (parts[5] === -1) {
                        str = "::ffff:";
                        str += v4part;
                        return str
                    }
                    if (parts[5] === 0) {
                        str = "::";
                        if (v4part === "0.0.0.0") v4part = "";
                        if (v4part === "0.0.0.1") v4part = "1";
                        str += v4part;
                        return str
                    }
                }
                for (word = 0; word < 8; word++) {
                    if (parts[word] === 0) {
                        if (word - lastzero > 1) {
                            len = 0
                        }
                        lastzero = word;
                        len++
                    }
                    if (len > longest) {
                        longest = len;
                        zstart = word - longest + 1
                    }
                }
                for (word = 0; word < 8; word++) {
                    if (longest > 1) {
                        if (parts[word] === 0 && word >= zstart && word < zstart + longest) {
                            if (word === zstart) {
                                str += ":";
                                if (zstart === 0) str += ":"
                            }
                            continue
                        }
                    }
                    str += Number(_ntohs(parts[word] & 65535)).toString(16);
                    str += word < 7 ? ":" : ""
                }
                return str
            };
            var readSockaddr = (sa, salen) => {
                var family = HEAP16[sa >>> 1 >>> 0];
                var port = _ntohs(HEAPU16[sa + 2 >>> 1 >>> 0]);
                var addr;
                switch (family) {
                    case 2:
                        if (salen !== 16) {
                            return {
                                errno: 28
                            }
                        }
                        addr = HEAP32[sa + 4 >>> 2 >>> 0];
                        addr = inetNtop4(addr);
                        break;
                    case 10:
                        if (salen !== 28) {
                            return {
                                errno: 28
                            }
                        }
                        addr = [HEAP32[sa + 8 >>> 2 >>> 0], HEAP32[sa + 12 >>> 2 >>> 0], HEAP32[sa + 16 >>> 2 >>> 0], HEAP32[sa + 20 >>> 2 >>> 0]];
                        addr = inetNtop6(addr);
                        break;
                    default:
                        return {
                            errno: 5
                        }
                }
                return {
                    family,
                    addr,
                    port
                }
            };
            var getSocketAddress = (addrp, addrlen) => {
                var info = readSockaddr(addrp, addrlen);
                if (info.errno) throw new FS.ErrnoError(info.errno);
                info.addr = DNS.lookup_addr(info.addr) || info.addr;
                return info
            };

            function ___syscall_bind(fd, addr, addrlen, d1, d2, d3) {
                addr >>>= 0;
                addrlen >>>= 0;
                try {
                    var sock = getSocketFromFD(fd);
                    var info = getSocketAddress(addr, addrlen);
                    sock.sock_ops.bind(sock, info.addr, info.port);
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_bind.sig = "iippiii";

            function ___syscall_chdir(path) {
                path >>>= 0;
                try {
                    path = SYSCALLS.getStr(path);
                    FS.chdir(path);
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_chdir.sig = "ip";

            function ___syscall_chmod(path, mode) {
                path >>>= 0;
                try {
                    path = SYSCALLS.getStr(path);
                    FS.chmod(path, mode);
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_chmod.sig = "ipi";

            function ___syscall_connect(fd, addr, addrlen, d1, d2, d3) {
                addr >>>= 0;
                addrlen >>>= 0;
                try {
                    var sock = getSocketFromFD(fd);
                    var info = getSocketAddress(addr, addrlen);
                    sock.sock_ops.connect(sock, info.addr, info.port);
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_connect.sig = "iippiii";

            function ___syscall_dup(fd) {
                try {
                    var old = SYSCALLS.getStreamFromFD(fd);
                    return FS.dupStream(old).fd
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_dup.sig = "ii";

            function ___syscall_dup3(fd, newfd, flags) {
                try {
                    var old = SYSCALLS.getStreamFromFD(fd);
                    if (old.fd === newfd) return -28;
                    if (newfd < 0 || newfd >= FS.MAX_OPEN_FDS) return -8;
                    var existing = FS.getStream(newfd);
                    if (existing) FS.close(existing);
                    return FS.dupStream(old, newfd).fd
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_dup3.sig = "iiii";

            function ___syscall_faccessat(dirfd, path, amode, flags) {
                path >>>= 0;
                try {
                    path = SYSCALLS.getStr(path);
                    path = SYSCALLS.calculateAt(dirfd, path);
                    if (amode & ~7) {
                        return -28
                    }
                    var lookup = FS.lookupPath(path, {
                        follow: true
                    });
                    var node = lookup.node;
                    if (!node) {
                        return -44
                    }
                    var perms = "";
                    if (amode & 4) perms += "r";
                    if (amode & 2) perms += "w";
                    if (amode & 1) perms += "x";
                    if (perms && FS.nodePermissions(node, perms)) {
                        return -2
                    }
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_faccessat.sig = "iipii";
            var ___syscall_fadvise64 = (fd, offset, len, advice) => 0;
            ___syscall_fadvise64.sig = "iiiiiii";

            function ___syscall_fallocate(fd, mode, offset_low, offset_high, len_low, len_high) {
                var offset = convertI32PairToI53Checked(offset_low, offset_high);
                var len = convertI32PairToI53Checked(len_low, len_high);
                try {
                    if (isNaN(offset)) return 61;
                    var stream = SYSCALLS.getStreamFromFD(fd);
                    FS.allocate(stream, offset, len);
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_fallocate.sig = "iiiiiii";

            function ___syscall_fchdir(fd) {
                try {
                    var stream = SYSCALLS.getStreamFromFD(fd);
                    FS.chdir(stream.path);
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_fchdir.sig = "ii";

            function ___syscall_fchmod(fd, mode) {
                try {
                    FS.fchmod(fd, mode);
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_fchmod.sig = "iii";

            function ___syscall_fchmodat2(dirfd, path, mode, flags) {
                path >>>= 0;
                try {
                    var nofollow = flags & 256;
                    path = SYSCALLS.getStr(path);
                    path = SYSCALLS.calculateAt(dirfd, path);
                    FS.chmod(path, mode, nofollow);
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_fchmodat2.sig = "iipii";

            function ___syscall_fchown32(fd, owner, group) {
                try {
                    FS.fchown(fd, owner, group);
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_fchown32.sig = "iiii";

            function ___syscall_fchownat(dirfd, path, owner, group, flags) {
                path >>>= 0;
                try {
                    path = SYSCALLS.getStr(path);
                    var nofollow = flags & 256;
                    flags = flags & ~256;
                    path = SYSCALLS.calculateAt(dirfd, path);
                    (nofollow ? FS.lchown : FS.chown)(path, owner, group);
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_fchownat.sig = "iipiii";
            var syscallGetVarargI = () => {
                var ret = HEAP32[+SYSCALLS.varargs >>> 2 >>> 0];
                SYSCALLS.varargs += 4;
                return ret
            };
            var syscallGetVarargP = syscallGetVarargI;

            function ___syscall_fcntl64(fd, cmd, varargs) {
                varargs >>>= 0;
                SYSCALLS.varargs = varargs;
                try {
                    var stream = SYSCALLS.getStreamFromFD(fd);
                    switch (cmd) {
                        case 0: {
                            var arg = syscallGetVarargI();
                            if (arg < 0) {
                                return -28
                            }
                            while (FS.streams[arg]) {
                                arg++
                            }
                            var newStream;
                            newStream = FS.dupStream(stream, arg);
                            return newStream.fd
                        }
                        case 1:
                        case 2:
                            return 0;
                        case 3:
                            return stream.flags;
                        case 4: {
                            var arg = syscallGetVarargI();
                            stream.flags |= arg;
                            return 0
                        }
                        case 12: {
                            var arg = syscallGetVarargP();
                            var offset = 0;
                            HEAP16[arg + offset >>> 1 >>> 0] = 2;
                            return 0
                        }
                        case 13:
                        case 14:
                            return 0
                    }
                    return -28
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_fcntl64.sig = "iiip";

            function ___syscall_fdatasync(fd) {
                try {
                    var stream = SYSCALLS.getStreamFromFD(fd);
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_fdatasync.sig = "ii";

            function ___syscall_fstat64(fd, buf) {
                buf >>>= 0;
                try {
                    var stream = SYSCALLS.getStreamFromFD(fd);
                    return SYSCALLS.doStat(FS.stat, stream.path, buf)
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_fstat64.sig = "iip";

            function ___syscall_statfs64(path, size, buf) {
                path >>>= 0;
                size >>>= 0;
                buf >>>= 0;
                try {
                    path = SYSCALLS.getStr(path);
                    HEAP32[buf + 4 >>> 2 >>> 0] = 4096;
                    HEAP32[buf + 40 >>> 2 >>> 0] = 4096;
                    HEAP32[buf + 8 >>> 2 >>> 0] = 1e6;
                    HEAP32[buf + 12 >>> 2 >>> 0] = 5e5;
                    HEAP32[buf + 16 >>> 2 >>> 0] = 5e5;
                    HEAP32[buf + 20 >>> 2 >>> 0] = FS.nextInode;
                    HEAP32[buf + 24 >>> 2 >>> 0] = 1e6;
                    HEAP32[buf + 28 >>> 2 >>> 0] = 42;
                    HEAP32[buf + 44 >>> 2 >>> 0] = 2;
                    HEAP32[buf + 36 >>> 2 >>> 0] = 255;
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_statfs64.sig = "ippp";

            function ___syscall_fstatfs64(fd, size, buf) {
                size >>>= 0;
                buf >>>= 0;
                try {
                    var stream = SYSCALLS.getStreamFromFD(fd);
                    return ___syscall_statfs64(0, size, buf)
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_fstatfs64.sig = "iipp";

            function ___syscall_ftruncate64(fd, length_low, length_high) {
                var length = convertI32PairToI53Checked(length_low, length_high);
                try {
                    if (isNaN(length)) return 61;
                    FS.ftruncate(fd, length);
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_ftruncate64.sig = "iiii";
            var stringToUTF8 = (str, outPtr, maxBytesToWrite) => stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);
            Module["stringToUTF8"] = stringToUTF8;

            function ___syscall_getcwd(buf, size) {
                buf >>>= 0;
                size >>>= 0;
                try {
                    if (size === 0) return -28;
                    var cwd = FS.cwd();
                    var cwdLengthInBytes = lengthBytesUTF8(cwd) + 1;
                    if (size < cwdLengthInBytes) return -68;
                    stringToUTF8(cwd, buf, size);
                    return cwdLengthInBytes
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_getcwd.sig = "ipp";

            function ___syscall_getdents64(fd, dirp, count) {
                dirp >>>= 0;
                count >>>= 0;
                try {
                    var stream = SYSCALLS.getStreamFromFD(fd);
                    stream.getdents ||= FS.readdir(stream.path);
                    var struct_size = 280;
                    var pos = 0;
                    var off = FS.llseek(stream, 0, 1);
                    var idx = Math.floor(off / struct_size);
                    while (idx < stream.getdents.length && pos + struct_size <= count) {
                        var id;
                        var type;
                        var name = stream.getdents[idx];
                        if (name === ".") {
                            id = stream.node.id;
                            type = 4
                        } else if (name === "..") {
                            var lookup = FS.lookupPath(stream.path, {
                                parent: true
                            });
                            id = lookup.node.id;
                            type = 4
                        } else {
                            var child = FS.lookupNode(stream.node, name);
                            id = child.id;
                            type = FS.isChrdev(child.mode) ? 2 : FS.isDir(child.mode) ? 4 : FS.isLink(child.mode) ? 10 : 8
                        }
                        tempI64 = [id >>> 0, (tempDouble = id, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[dirp + pos >>> 2 >>> 0] = tempI64[0], HEAP32[dirp + pos + 4 >>> 2 >>> 0] = tempI64[1];
                        tempI64 = [(idx + 1) * struct_size >>> 0, (tempDouble = (idx + 1) * struct_size, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[dirp + pos + 8 >>> 2 >>> 0] = tempI64[0], HEAP32[dirp + pos + 12 >>> 2 >>> 0] = tempI64[1];
                        HEAP16[dirp + pos + 16 >>> 1 >>> 0] = 280;
                        HEAP8[dirp + pos + 18 >>> 0] = type;
                        stringToUTF8(name, dirp + pos + 19, 256);
                        pos += struct_size;
                        idx += 1
                    }
                    FS.llseek(stream, idx * struct_size, 0);
                    return pos
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_getdents64.sig = "iipp";

            function ___syscall_getpeername(fd, addr, addrlen, d1, d2, d3) {
                addr >>>= 0;
                addrlen >>>= 0;
                try {
                    var sock = getSocketFromFD(fd);
                    if (!sock.daddr) {
                        return -53
                    }
                    var errno = writeSockaddr(addr, sock.family, DNS.lookup_name(sock.daddr), sock.dport, addrlen);
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_getpeername.sig = "iippiii";

            function ___syscall_getsockname(fd, addr, addrlen, d1, d2, d3) {
                addr >>>= 0;
                addrlen >>>= 0;
                try {
                    var sock = getSocketFromFD(fd);
                    var errno = writeSockaddr(addr, sock.family, DNS.lookup_name(sock.saddr || "0.0.0.0"), sock.sport, addrlen);
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_getsockname.sig = "iippiii";

            function ___syscall_getsockopt(fd, level, optname, optval, optlen, d1) {
                optval >>>= 0;
                optlen >>>= 0;
                try {
                    var sock = getSocketFromFD(fd);
                    if (level === 1) {
                        if (optname === 4) {
                            HEAP32[optval >>> 2 >>> 0] = sock.error;
                            HEAP32[optlen >>> 2 >>> 0] = 4;
                            sock.error = null;
                            return 0
                        }
                    }
                    return -50
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_getsockopt.sig = "iiiippi";

            function ___syscall_ioctl(fd, op, varargs) {
                varargs >>>= 0;
                SYSCALLS.varargs = varargs;
                try {
                    var stream = SYSCALLS.getStreamFromFD(fd);
                    switch (op) {
                        case 21509: {
                            if (!stream.tty) return -59;
                            return 0
                        }
                        case 21505: {
                            if (!stream.tty) return -59;
                            if (stream.tty.ops.ioctl_tcgets) {
                                var termios = stream.tty.ops.ioctl_tcgets(stream);
                                var argp = syscallGetVarargP();
                                HEAP32[argp >>> 2 >>> 0] = termios.c_iflag || 0;
                                HEAP32[argp + 4 >>> 2 >>> 0] = termios.c_oflag || 0;
                                HEAP32[argp + 8 >>> 2 >>> 0] = termios.c_cflag || 0;
                                HEAP32[argp + 12 >>> 2 >>> 0] = termios.c_lflag || 0;
                                for (var i = 0; i < 32; i++) {
                                    HEAP8[argp + i + 17 >>> 0] = termios.c_cc[i] || 0
                                }
                                return 0
                            }
                            return 0
                        }
                        case 21510:
                        case 21511:
                        case 21512: {
                            if (!stream.tty) return -59;
                            return 0
                        }
                        case 21506:
                        case 21507:
                        case 21508: {
                            if (!stream.tty) return -59;
                            if (stream.tty.ops.ioctl_tcsets) {
                                var argp = syscallGetVarargP();
                                var c_iflag = HEAP32[argp >>> 2 >>> 0];
                                var c_oflag = HEAP32[argp + 4 >>> 2 >>> 0];
                                var c_cflag = HEAP32[argp + 8 >>> 2 >>> 0];
                                var c_lflag = HEAP32[argp + 12 >>> 2 >>> 0];
                                var c_cc = [];
                                for (var i = 0; i < 32; i++) {
                                    c_cc.push(HEAP8[argp + i + 17 >>> 0])
                                }
                                return stream.tty.ops.ioctl_tcsets(stream.tty, op, {
                                    c_iflag,
                                    c_oflag,
                                    c_cflag,
                                    c_lflag,
                                    c_cc
                                })
                            }
                            return 0
                        }
                        case 21519: {
                            if (!stream.tty) return -59;
                            var argp = syscallGetVarargP();
                            HEAP32[argp >>> 2 >>> 0] = 0;
                            return 0
                        }
                        case 21520: {
                            if (!stream.tty) return -59;
                            return -28
                        }
                        case 21531: {
                            var argp = syscallGetVarargP();
                            return FS.ioctl(stream, op, argp)
                        }
                        case 21523: {
                            if (!stream.tty) return -59;
                            if (stream.tty.ops.ioctl_tiocgwinsz) {
                                var winsize = stream.tty.ops.ioctl_tiocgwinsz(stream.tty);
                                var argp = syscallGetVarargP();
                                HEAP16[argp >>> 1 >>> 0] = winsize[0];
                                HEAP16[argp + 2 >>> 1 >>> 0] = winsize[1]
                            }
                            return 0
                        }
                        case 21524: {
                            if (!stream.tty) return -59;
                            return 0
                        }
                        case 21515: {
                            if (!stream.tty) return -59;
                            return 0
                        }
                        default:
                            return -28
                    }
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_ioctl.sig = "iiip";

            function ___syscall_listen(fd, backlog) {
                try {
                    var sock = getSocketFromFD(fd);
                    sock.sock_ops.listen(sock, backlog);
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_listen.sig = "iiiiiii";

            function ___syscall_lstat64(path, buf) {
                path >>>= 0;
                buf >>>= 0;
                try {
                    path = SYSCALLS.getStr(path);
                    return SYSCALLS.doStat(FS.lstat, path, buf)
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_lstat64.sig = "ipp";

            function ___syscall_mkdirat(dirfd, path, mode) {
                path >>>= 0;
                try {
                    path = SYSCALLS.getStr(path);
                    path = SYSCALLS.calculateAt(dirfd, path);
                    path = PATH.normalize(path);
                    if (path[path.length - 1] === "/") path = path.substr(0, path.length - 1);
                    FS.mkdir(path, mode, 0);
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_mkdirat.sig = "iipi";

            function ___syscall_mknodat(dirfd, path, mode, dev) {
                path >>>= 0;
                try {
                    path = SYSCALLS.getStr(path);
                    path = SYSCALLS.calculateAt(dirfd, path);
                    switch (mode & 61440) {
                        case 32768:
                        case 8192:
                        case 24576:
                        case 4096:
                        case 49152:
                            break;
                        default:
                            return -28
                    }
                    FS.mknod(path, mode, dev);
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_mknodat.sig = "iipii";

            function ___syscall_newfstatat(dirfd, path, buf, flags) {
                path >>>= 0;
                buf >>>= 0;
                try {
                    path = SYSCALLS.getStr(path);
                    var nofollow = flags & 256;
                    var allowEmpty = flags & 4096;
                    flags = flags & ~6400;
                    path = SYSCALLS.calculateAt(dirfd, path, allowEmpty);
                    return SYSCALLS.doStat(nofollow ? FS.lstat : FS.stat, path, buf)
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_newfstatat.sig = "iippi";

            function ___syscall_openat(dirfd, path, flags, varargs) {
                path >>>= 0;
                varargs >>>= 0;
                SYSCALLS.varargs = varargs;
                try {
                    path = SYSCALLS.getStr(path);
                    path = SYSCALLS.calculateAt(dirfd, path);
                    var mode = varargs ? syscallGetVarargI() : 0;
                    return FS.open(path, flags, mode).fd
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_openat.sig = "iipip";
            var PIPEFS = {
                BUCKET_BUFFER_SIZE: 8192,
                mount(mount) {
                    return FS.createNode(null, "/", 16384 | 511, 0)
                },
                createPipe() {
                    var pipe = {
                        buckets: [],
                        refcnt: 2
                    };
                    pipe.buckets.push({
                        buffer: new Uint8Array(PIPEFS.BUCKET_BUFFER_SIZE),
                        offset: 0,
                        roffset: 0
                    });
                    var rName = PIPEFS.nextname();
                    var wName = PIPEFS.nextname();
                    var rNode = FS.createNode(PIPEFS.root, rName, 4096, 0);
                    var wNode = FS.createNode(PIPEFS.root, wName, 4096, 0);
                    rNode.pipe = pipe;
                    wNode.pipe = pipe;
                    var readableStream = FS.createStream({
                        path: rName,
                        node: rNode,
                        flags: 0,
                        seekable: false,
                        stream_ops: PIPEFS.stream_ops
                    });
                    rNode.stream = readableStream;
                    var writableStream = FS.createStream({
                        path: wName,
                        node: wNode,
                        flags: 1,
                        seekable: false,
                        stream_ops: PIPEFS.stream_ops
                    });
                    wNode.stream = writableStream;
                    return {
                        readable_fd: readableStream.fd,
                        writable_fd: writableStream.fd
                    }
                },
                stream_ops: {
                    poll(stream) {
                        var pipe = stream.node.pipe;
                        if ((stream.flags & 2097155) === 1) {
                            return 256 | 4
                        }
                        if (pipe.buckets.length > 0) {
                            for (var i = 0; i < pipe.buckets.length; i++) {
                                var bucket = pipe.buckets[i];
                                if (bucket.offset - bucket.roffset > 0) {
                                    return 64 | 1
                                }
                            }
                        }
                        return 0
                    },
                    ioctl(stream, request, varargs) {
                        return 28
                    },
                    fsync(stream) {
                        return 28
                    },
                    read(stream, buffer, offset, length, position) {
                        var pipe = stream.node.pipe;
                        var currentLength = 0;
                        for (var i = 0; i < pipe.buckets.length; i++) {
                            var bucket = pipe.buckets[i];
                            currentLength += bucket.offset - bucket.roffset
                        }
                        var data = buffer.subarray(offset, offset + length);
                        if (length <= 0) {
                            return 0
                        }
                        if (currentLength == 0) {
                            throw new FS.ErrnoError(6)
                        }
                        var toRead = Math.min(currentLength, length);
                        var totalRead = toRead;
                        var toRemove = 0;
                        for (var i = 0; i < pipe.buckets.length; i++) {
                            var currBucket = pipe.buckets[i];
                            var bucketSize = currBucket.offset - currBucket.roffset;
                            if (toRead <= bucketSize) {
                                var tmpSlice = currBucket.buffer.subarray(currBucket.roffset, currBucket.offset);
                                if (toRead < bucketSize) {
                                    tmpSlice = tmpSlice.subarray(0, toRead);
                                    currBucket.roffset += toRead
                                } else {
                                    toRemove++
                                }
                                data.set(tmpSlice);
                                break
                            } else {
                                var tmpSlice = currBucket.buffer.subarray(currBucket.roffset, currBucket.offset);
                                data.set(tmpSlice);
                                data = data.subarray(tmpSlice.byteLength);
                                toRead -= tmpSlice.byteLength;
                                toRemove++
                            }
                        }
                        if (toRemove && toRemove == pipe.buckets.length) {
                            toRemove--;
                            pipe.buckets[toRemove].offset = 0;
                            pipe.buckets[toRemove].roffset = 0
                        }
                        pipe.buckets.splice(0, toRemove);
                        return totalRead
                    },
                    write(stream, buffer, offset, length, position) {
                        var pipe = stream.node.pipe;
                        var data = buffer.subarray(offset, offset + length);
                        var dataLen = data.byteLength;
                        if (dataLen <= 0) {
                            return 0
                        }
                        var currBucket = null;
                        if (pipe.buckets.length == 0) {
                            currBucket = {
                                buffer: new Uint8Array(PIPEFS.BUCKET_BUFFER_SIZE),
                                offset: 0,
                                roffset: 0
                            };
                            pipe.buckets.push(currBucket)
                        } else {
                            currBucket = pipe.buckets[pipe.buckets.length - 1]
                        }
                        assert(currBucket.offset <= PIPEFS.BUCKET_BUFFER_SIZE);
                        var freeBytesInCurrBuffer = PIPEFS.BUCKET_BUFFER_SIZE - currBucket.offset;
                        if (freeBytesInCurrBuffer >= dataLen) {
                            currBucket.buffer.set(data, currBucket.offset);
                            currBucket.offset += dataLen;
                            return dataLen
                        } else if (freeBytesInCurrBuffer > 0) {
                            currBucket.buffer.set(data.subarray(0, freeBytesInCurrBuffer), currBucket.offset);
                            currBucket.offset += freeBytesInCurrBuffer;
                            data = data.subarray(freeBytesInCurrBuffer, data.byteLength)
                        }
                        var numBuckets = data.byteLength / PIPEFS.BUCKET_BUFFER_SIZE | 0;
                        var remElements = data.byteLength % PIPEFS.BUCKET_BUFFER_SIZE;
                        for (var i = 0; i < numBuckets; i++) {
                            var newBucket = {
                                buffer: new Uint8Array(PIPEFS.BUCKET_BUFFER_SIZE),
                                offset: PIPEFS.BUCKET_BUFFER_SIZE,
                                roffset: 0
                            };
                            pipe.buckets.push(newBucket);
                            newBucket.buffer.set(data.subarray(0, PIPEFS.BUCKET_BUFFER_SIZE));
                            data = data.subarray(PIPEFS.BUCKET_BUFFER_SIZE, data.byteLength)
                        }
                        if (remElements > 0) {
                            var newBucket = {
                                buffer: new Uint8Array(PIPEFS.BUCKET_BUFFER_SIZE),
                                offset: data.byteLength,
                                roffset: 0
                            };
                            pipe.buckets.push(newBucket);
                            newBucket.buffer.set(data)
                        }
                        return dataLen
                    },
                    close(stream) {
                        var pipe = stream.node.pipe;
                        pipe.refcnt--;
                        if (pipe.refcnt === 0) {
                            pipe.buckets = null
                        }
                    }
                },
                nextname() {
                    if (!PIPEFS.nextname.current) {
                        PIPEFS.nextname.current = 0
                    }
                    return "pipe[" + PIPEFS.nextname.current++ + "]"
                }
            };

            function ___syscall_pipe(fdPtr) {
                fdPtr >>>= 0;
                try {
                    if (fdPtr == 0) {
                        throw new FS.ErrnoError(21)
                    }
                    var res = PIPEFS.createPipe();
                    HEAP32[fdPtr >>> 2 >>> 0] = res.readable_fd;
                    HEAP32[fdPtr + 4 >>> 2 >>> 0] = res.writable_fd;
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_pipe.sig = "ip";

            function ___syscall_poll(fds, nfds, timeout) {
                fds >>>= 0;
                try {
                    var nonzero = 0;
                    for (var i = 0; i < nfds; i++) {
                        var pollfd = fds + 8 * i;
                        var fd = HEAP32[pollfd >>> 2 >>> 0];
                        var events = HEAP16[pollfd + 4 >>> 1 >>> 0];
                        var mask = 32;
                        var stream = FS.getStream(fd);
                        if (stream) {
                            mask = SYSCALLS.DEFAULT_POLLMASK;
                            if (stream.stream_ops.poll) {
                                mask = stream.stream_ops.poll(stream, -1)
                            }
                        }
                        mask &= events | 8 | 16;
                        if (mask) nonzero++;
                        HEAP16[pollfd + 6 >>> 1 >>> 0] = mask
                    }
                    return nonzero
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_poll.sig = "ipii";

            function ___syscall_readlinkat(dirfd, path, buf, bufsize) {
                path >>>= 0;
                buf >>>= 0;
                bufsize >>>= 0;
                try {
                    path = SYSCALLS.getStr(path);
                    path = SYSCALLS.calculateAt(dirfd, path);
                    if (bufsize <= 0) return -28;
                    var ret = FS.readlink(path);
                    var len = Math.min(bufsize, lengthBytesUTF8(ret));
                    var endChar = HEAP8[buf + len >>> 0];
                    stringToUTF8(ret, buf, bufsize + 1);
                    HEAP8[buf + len >>> 0] = endChar;
                    return len
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_readlinkat.sig = "iippp";

            function ___syscall_recvfrom(fd, buf, len, flags, addr, addrlen) {
                buf >>>= 0;
                len >>>= 0;
                addr >>>= 0;
                addrlen >>>= 0;
                try {
                    var sock = getSocketFromFD(fd);
                    var msg = sock.sock_ops.recvmsg(sock, len);
                    if (!msg) return 0;
                    if (addr) {
                        var errno = writeSockaddr(addr, sock.family, DNS.lookup_name(msg.addr), msg.port, addrlen)
                    }
                    HEAPU8.set(msg.buffer, buf >>> 0);
                    return msg.buffer.byteLength
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_recvfrom.sig = "iippipp";

            function ___syscall_recvmsg(fd, message, flags, d1, d2, d3) {
                message >>>= 0;
                try {
                    var sock = getSocketFromFD(fd);
                    var iov = HEAPU32[message + 8 >>> 2 >>> 0];
                    var num = HEAP32[message + 12 >>> 2 >>> 0];
                    var total = 0;
                    for (var i = 0; i < num; i++) {
                        total += HEAP32[iov + (8 * i + 4) >>> 2 >>> 0]
                    }
                    var msg = sock.sock_ops.recvmsg(sock, total);
                    if (!msg) return 0;
                    var name = HEAPU32[message >>> 2 >>> 0];
                    if (name) {
                        var errno = writeSockaddr(name, sock.family, DNS.lookup_name(msg.addr), msg.port)
                    }
                    var bytesRead = 0;
                    var bytesRemaining = msg.buffer.byteLength;
                    for (var i = 0; bytesRemaining > 0 && i < num; i++) {
                        var iovbase = HEAPU32[iov + (8 * i + 0) >>> 2 >>> 0];
                        var iovlen = HEAP32[iov + (8 * i + 4) >>> 2 >>> 0];
                        if (!iovlen) {
                            continue
                        }
                        var length = Math.min(iovlen, bytesRemaining);
                        var buf = msg.buffer.subarray(bytesRead, bytesRead + length);
                        HEAPU8.set(buf, iovbase + bytesRead >>> 0);
                        bytesRead += length;
                        bytesRemaining -= length
                    }
                    return bytesRead
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_recvmsg.sig = "iipiiii";

            function ___syscall_renameat(olddirfd, oldpath, newdirfd, newpath) {
                oldpath >>>= 0;
                newpath >>>= 0;
                try {
                    oldpath = SYSCALLS.getStr(oldpath);
                    newpath = SYSCALLS.getStr(newpath);
                    oldpath = SYSCALLS.calculateAt(olddirfd, oldpath);
                    newpath = SYSCALLS.calculateAt(newdirfd, newpath);
                    FS.rename(oldpath, newpath);
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_renameat.sig = "iipip";

            function ___syscall_rmdir(path) {
                path >>>= 0;
                try {
                    path = SYSCALLS.getStr(path);
                    FS.rmdir(path);
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_rmdir.sig = "ip";

            function ___syscall_sendmsg(fd, message, flags, d1, d2, d3) {
                message >>>= 0;
                d1 >>>= 0;
                d2 >>>= 0;
                try {
                    var sock = getSocketFromFD(fd);
                    var iov = HEAPU32[message + 8 >>> 2 >>> 0];
                    var num = HEAP32[message + 12 >>> 2 >>> 0];
                    var addr, port;
                    var name = HEAPU32[message >>> 2 >>> 0];
                    var namelen = HEAP32[message + 4 >>> 2 >>> 0];
                    if (name) {
                        var info = getSocketAddress(name, namelen);
                        port = info.port;
                        addr = info.addr
                    }
                    var total = 0;
                    for (var i = 0; i < num; i++) {
                        total += HEAP32[iov + (8 * i + 4) >>> 2 >>> 0]
                    }
                    var view = new Uint8Array(total);
                    var offset = 0;
                    for (var i = 0; i < num; i++) {
                        var iovbase = HEAPU32[iov + (8 * i + 0) >>> 2 >>> 0];
                        var iovlen = HEAP32[iov + (8 * i + 4) >>> 2 >>> 0];
                        for (var j = 0; j < iovlen; j++) {
                            view[offset++] = HEAP8[iovbase + j >>> 0]
                        }
                    }
                    return sock.sock_ops.sendmsg(sock, view, 0, total, addr, port)
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_sendmsg.sig = "iipippi";

            function ___syscall_sendto(fd, message, length, flags, addr, addr_len) {
                message >>>= 0;
                length >>>= 0;
                addr >>>= 0;
                addr_len >>>= 0;
                try {
                    var sock = getSocketFromFD(fd);
                    if (!addr) {
                        return FS.write(sock.stream, HEAP8, message, length)
                    }
                    var dest = getSocketAddress(addr, addr_len);
                    return sock.sock_ops.sendmsg(sock, HEAP8, message, length, dest.addr, dest.port)
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_sendto.sig = "iippipp";

            function ___syscall_socket(domain, type, protocol) {
                try {
                    var sock = SOCKFS.createSocket(domain, type, protocol);
                    return sock.stream.fd
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_socket.sig = "iiiiiii";

            function ___syscall_stat64(path, buf) {
                path >>>= 0;
                buf >>>= 0;
                try {
                    path = SYSCALLS.getStr(path);
                    return SYSCALLS.doStat(FS.stat, path, buf)
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_stat64.sig = "ipp";

            function ___syscall_symlink(target, linkpath) {
                target >>>= 0;
                linkpath >>>= 0;
                try {
                    target = SYSCALLS.getStr(target);
                    linkpath = SYSCALLS.getStr(linkpath);
                    FS.symlink(target, linkpath);
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_symlink.sig = "ipp";

            function ___syscall_symlinkat(target, newdirfd, linkpath) {
                target >>>= 0;
                linkpath >>>= 0;
                try {
                    linkpath = SYSCALLS.calculateAt(newdirfd, linkpath);
                    FS.symlink(target, linkpath);
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_symlinkat.sig = "ipip";

            function ___syscall_truncate64(path, length_low, length_high) {
                path >>>= 0;
                var length = convertI32PairToI53Checked(length_low, length_high);
                try {
                    if (isNaN(length)) return 61;
                    path = SYSCALLS.getStr(path);
                    FS.truncate(path, length);
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_truncate64.sig = "ipii";

            function ___syscall_unlinkat(dirfd, path, flags) {
                path >>>= 0;
                try {
                    path = SYSCALLS.getStr(path);
                    path = SYSCALLS.calculateAt(dirfd, path);
                    if (flags === 0) {
                        FS.unlink(path)
                    } else if (flags === 512) {
                        FS.rmdir(path)
                    } else {
                        abort("Invalid flags passed to unlinkat")
                    }
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_unlinkat.sig = "iipi";
            var readI53FromI64 = ptr => HEAPU32[ptr >>> 2 >>> 0] + HEAP32[ptr + 4 >>> 2 >>> 0] * 4294967296;

            function ___syscall_utimensat(dirfd, path, times, flags) {
                path >>>= 0;
                times >>>= 0;
                try {
                    path = SYSCALLS.getStr(path);
                    path = SYSCALLS.calculateAt(dirfd, path, true);
                    var now = Date.now(),
                        atime, mtime;
                    if (!times) {
                        atime = now;
                        mtime = now
                    } else {
                        var seconds = readI53FromI64(times);
                        var nanoseconds = HEAP32[times + 8 >>> 2 >>> 0];
                        if (nanoseconds == 1073741823) {
                            atime = now
                        } else if (nanoseconds == 1073741822) {
                            atime = -1
                        } else {
                            atime = seconds * 1e3 + nanoseconds / (1e3 * 1e3)
                        }
                        times += 16;
                        seconds = readI53FromI64(times);
                        nanoseconds = HEAP32[times + 8 >>> 2 >>> 0];
                        if (nanoseconds == 1073741823) {
                            mtime = now
                        } else if (nanoseconds == 1073741822) {
                            mtime = -1
                        } else {
                            mtime = seconds * 1e3 + nanoseconds / (1e3 * 1e3)
                        }
                    }
                    if (mtime != -1 || atime != -1) {
                        FS.utime(path, atime, mtime)
                    }
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            ___syscall_utimensat.sig = "iippi";
            var ___table_base = new WebAssembly.Global({
                value: "i32",
                mutable: false
            }, 1);
            var __abort_js = () => {
                abort("")
            };
            __abort_js.sig = "v";
            var ENV = {};
            var stackAlloc = sz => __emscripten_stack_alloc(sz);
            Module["stackAlloc"] = stackAlloc;
            var stringToUTF8OnStack = str => {
                var size = lengthBytesUTF8(str) + 1;
                var ret = stackAlloc(size);
                stringToUTF8(str, ret, size);
                return ret
            };
            var stackSave = () => _emscripten_stack_get_current();
            var stackRestore = val => __emscripten_stack_restore(val);
            var dlSetError = msg => {
                var sp = stackSave();
                var cmsg = stringToUTF8OnStack(msg);
                ___dl_seterr(cmsg, 0);
                stackRestore(sp)
            };
            var dlopenInternal = (handle, jsflags) => {
                var filename = UTF8ToString(handle + 36);
                var flags = HEAP32[handle + 4 >>> 2 >>> 0];
                filename = PATH.normalize(filename);
                var searchpaths = [];
                var global = Boolean(flags & 256);
                var localScope = global ? null : {};
                var combinedFlags = {
                    global,
                    nodelete: Boolean(flags & 4096),
                    loadAsync: jsflags.loadAsync
                };
                if (jsflags.loadAsync) {
                    return loadDynamicLibrary(filename, combinedFlags, localScope, handle)
                }
                try {
                    return loadDynamicLibrary(filename, combinedFlags, localScope, handle)
                } catch (e) {
                    dlSetError(`Could not load dynamic lib: ${filename}\n${e}`);
                    return 0
                }
            };

            function __dlopen_js(handle) {
                handle >>>= 0;
                return dlopenInternal(handle, {
                    loadAsync: false
                })
            }
            __dlopen_js.sig = "pp";

            function __dlsym_js(handle, symbol, symbolIndex) {
                handle >>>= 0;
                symbol >>>= 0;
                symbolIndex >>>= 0;
                symbol = UTF8ToString(symbol);
                var result;
                var newSymIndex;
                var lib = LDSO.loadedLibsByHandle[handle];
                if (!lib.exports.hasOwnProperty(symbol) || lib.exports[symbol].stub) {
                    dlSetError(`Tried to lookup unknown symbol "${symbol}" in dynamic lib: ${lib.name}`);
                    return 0
                }
                newSymIndex = Object.keys(lib.exports).indexOf(symbol);
                var origSym = "orig$" + symbol;
                result = lib.exports[origSym];
                if (result) {
                    newSymIndex = Object.keys(lib.exports).indexOf(origSym)
                } else result = lib.exports[symbol];
                if (typeof result == "function") {
                    var addr = getFunctionAddress(result);
                    if (addr) {
                        result = addr
                    } else {
                        result = addFunction(result, result.sig);
                        HEAPU32[symbolIndex >>> 2 >>> 0] = newSymIndex
                    }
                }
                return result
            }
            __dlsym_js.sig = "pppp";

            function __embind_register_bigint(primitiveType, name, size, minRange, maxRange) {
                primitiveType >>>= 0;
                name >>>= 0;
                size >>>= 0
            }
            __embind_register_bigint.sig = "vpppiiii";
            var embind_init_charCodes = () => {
                var codes = new Array(256);
                for (var i = 0; i < 256; ++i) {
                    codes[i] = String.fromCharCode(i)
                }
                embind_charCodes = codes
            };
            var embind_charCodes;
            var readLatin1String = ptr => {
                var ret = "";
                var c = ptr;
                while (HEAPU8[c >>> 0]) {
                    ret += embind_charCodes[HEAPU8[c++ >>> 0]]
                }
                return ret
            };
            var awaitingDependencies = {};
            var registeredTypes = {};
            var typeDependencies = {};
            var BindingError;
            var throwBindingError = message => {
                throw new BindingError(message)
            };
            var InternalError;
            var throwInternalError = message => {
                throw new InternalError(message)
            };
            var whenDependentTypesAreResolved = (myTypes, dependentTypes, getTypeConverters) => {
                myTypes.forEach(type => typeDependencies[type] = dependentTypes);

                function onComplete(typeConverters) {
                    var myTypeConverters = getTypeConverters(typeConverters);
                    if (myTypeConverters.length !== myTypes.length) {
                        throwInternalError("Mismatched type converter count")
                    }
                    for (var i = 0; i < myTypes.length; ++i) {
                        registerType(myTypes[i], myTypeConverters[i])
                    }
                }
                var typeConverters = new Array(dependentTypes.length);
                var unregisteredTypes = [];
                var registered = 0;
                dependentTypes.forEach((dt, i) => {
                    if (registeredTypes.hasOwnProperty(dt)) {
                        typeConverters[i] = registeredTypes[dt]
                    } else {
                        unregisteredTypes.push(dt);
                        if (!awaitingDependencies.hasOwnProperty(dt)) {
                            awaitingDependencies[dt] = []
                        }
                        awaitingDependencies[dt].push(() => {
                            typeConverters[i] = registeredTypes[dt];
                            ++registered;
                            if (registered === unregisteredTypes.length) {
                                onComplete(typeConverters)
                            }
                        })
                    }
                });
                if (0 === unregisteredTypes.length) {
                    onComplete(typeConverters)
                }
            };

            function sharedRegisterType(rawType, registeredInstance, options = {}) {
                var name = registeredInstance.name;
                if (!rawType) {
                    throwBindingError(`type "${name}" must have a positive integer typeid pointer`)
                }
                if (registeredTypes.hasOwnProperty(rawType)) {
                    if (options.ignoreDuplicateRegistrations) {
                        return
                    } else {
                        throwBindingError(`Cannot register type '${name}' twice`)
                    }
                }
                registeredTypes[rawType] = registeredInstance;
                delete typeDependencies[rawType];
                if (awaitingDependencies.hasOwnProperty(rawType)) {
                    var callbacks = awaitingDependencies[rawType];
                    delete awaitingDependencies[rawType];
                    callbacks.forEach(cb => cb())
                }
            }

            function registerType(rawType, registeredInstance, options = {}) {
                return sharedRegisterType(rawType, registeredInstance, options)
            }
            var GenericWireTypeSize = 8;

            function __embind_register_bool(rawType, name, trueValue, falseValue) {
                rawType >>>= 0;
                name >>>= 0;
                name = readLatin1String(name);
                registerType(rawType, {
                    name,
                    fromWireType: function(wt) {
                        return !!wt
                    },
                    toWireType: function(destructors, o) {
                        return o ? trueValue : falseValue
                    },
                    argPackAdvance: GenericWireTypeSize,
                    readValueFromPointer: function(pointer) {
                        return this["fromWireType"](HEAPU8[pointer >>> 0])
                    },
                    destructorFunction: null
                })
            }
            __embind_register_bool.sig = "vppii";
            var emval_freelist = [];
            var emval_handles = [];

            function __emval_decref(handle) {
                handle >>>= 0;
                if (handle > 9 && 0 === --emval_handles[handle + 1]) {
                    emval_handles[handle] = undefined;
                    emval_freelist.push(handle)
                }
            }
            __emval_decref.sig = "vp";
            var count_emval_handles = () => emval_handles.length / 2 - 5 - emval_freelist.length;
            var init_emval = () => {
                emval_handles.push(0, 1, undefined, 1, null, 1, true, 1, false, 1);
                Module["count_emval_handles"] = count_emval_handles
            };
            var Emval = {
                toValue: handle => {
                    if (!handle) {
                        throwBindingError("Cannot use deleted val. handle = " + handle)
                    }
                    return emval_handles[handle]
                },
                toHandle: value => {
                    switch (value) {
                        case undefined:
                            return 2;
                        case null:
                            return 4;
                        case true:
                            return 6;
                        case false:
                            return 8;
                        default: {
                            const handle = emval_freelist.pop() || emval_handles.length;
                            emval_handles[handle] = value;
                            emval_handles[handle + 1] = 1;
                            return handle
                        }
                    }
                }
            };

            function readPointer(pointer) {
                return this["fromWireType"](HEAPU32[pointer >>> 2 >>> 0])
            }
            var EmValType = {
                name: "emscripten::val",
                fromWireType: handle => {
                    var rv = Emval.toValue(handle);
                    __emval_decref(handle);
                    return rv
                },
                toWireType: (destructors, value) => Emval.toHandle(value),
                argPackAdvance: GenericWireTypeSize,
                readValueFromPointer: readPointer,
                destructorFunction: null
            };

            function __embind_register_emval(rawType) {
                rawType >>>= 0;
                return registerType(rawType, EmValType)
            }
            __embind_register_emval.sig = "vp";
            var embindRepr = v => {
                if (v === null) {
                    return "null"
                }
                var t = typeof v;
                if (t === "object" || t === "array" || t === "function") {
                    return v.toString()
                } else {
                    return "" + v
                }
            };
            var floatReadValueFromPointer = (name, width) => {
                switch (width) {
                    case 4:
                        return function(pointer) {
                            return this["fromWireType"](HEAPF32[pointer >>> 2 >>> 0])
                        };
                    case 8:
                        return function(pointer) {
                            return this["fromWireType"](HEAPF64[pointer >>> 3 >>> 0])
                        };
                    default:
                        throw new TypeError(`invalid float width (${width}): ${name}`)
                }
            };
            var __embind_register_float = function(rawType, name, size) {
                rawType >>>= 0;
                name >>>= 0;
                size >>>= 0;
                name = readLatin1String(name);
                registerType(rawType, {
                    name,
                    fromWireType: value => value,
                    toWireType: (destructors, value) => value,
                    argPackAdvance: GenericWireTypeSize,
                    readValueFromPointer: floatReadValueFromPointer(name, size),
                    destructorFunction: null
                })
            };
            __embind_register_float.sig = "vppp";
            var integerReadValueFromPointer = (name, width, signed) => {
                switch (width) {
                    case 1:
                        return signed ? pointer => HEAP8[pointer >>> 0] : pointer => HEAPU8[pointer >>> 0];
                    case 2:
                        return signed ? pointer => HEAP16[pointer >>> 1 >>> 0] : pointer => HEAPU16[pointer >>> 1 >>> 0];
                    case 4:
                        return signed ? pointer => HEAP32[pointer >>> 2 >>> 0] : pointer => HEAPU32[pointer >>> 2 >>> 0];
                    default:
                        throw new TypeError(`invalid integer width (${width}): ${name}`)
                }
            };

            function __embind_register_integer(primitiveType, name, size, minRange, maxRange) {
                primitiveType >>>= 0;
                name >>>= 0;
                size >>>= 0;
                name = readLatin1String(name);
                if (maxRange === -1) {
                    maxRange = 4294967295
                }
                var fromWireType = value => value;
                if (minRange === 0) {
                    var bitshift = 32 - 8 * size;
                    fromWireType = value => value << bitshift >>> bitshift
                }
                var isUnsignedType = name.includes("unsigned");
                var checkAssertions = (value, toTypeName) => {};
                var toWireType;
                if (isUnsignedType) {
                    toWireType = function(destructors, value) {
                        checkAssertions(value, this.name);
                        return value >>> 0
                    }
                } else {
                    toWireType = function(destructors, value) {
                        checkAssertions(value, this.name);
                        return value
                    }
                }
                registerType(primitiveType, {
                    name,
                    fromWireType,
                    toWireType,
                    argPackAdvance: GenericWireTypeSize,
                    readValueFromPointer: integerReadValueFromPointer(name, size, minRange !== 0),
                    destructorFunction: null
                })
            }
            __embind_register_integer.sig = "vpppii";

            function __embind_register_memory_view(rawType, dataTypeIndex, name) {
                rawType >>>= 0;
                name >>>= 0;
                var typeMapping = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array];
                var TA = typeMapping[dataTypeIndex];

                function decodeMemoryView(handle) {
                    var size = HEAPU32[handle >>> 2 >>> 0];
                    var data = HEAPU32[handle + 4 >>> 2 >>> 0];
                    return new TA(HEAP8.buffer, data, size)
                }
                name = readLatin1String(name);
                registerType(rawType, {
                    name,
                    fromWireType: decodeMemoryView,
                    argPackAdvance: GenericWireTypeSize,
                    readValueFromPointer: decodeMemoryView
                }, {
                    ignoreDuplicateRegistrations: true
                })
            }
            __embind_register_memory_view.sig = "vpip";

            function __embind_register_std_string(rawType, name) {
                rawType >>>= 0;
                name >>>= 0;
                name = readLatin1String(name);
                var stdStringIsUTF8 = name === "std::string";
                registerType(rawType, {
                    name,
                    fromWireType(value) {
                        var length = HEAPU32[value >>> 2 >>> 0];
                        var payload = value + 4;
                        var str;
                        if (stdStringIsUTF8) {
                            var decodeStartPtr = payload;
                            for (var i = 0; i <= length; ++i) {
                                var currentBytePtr = payload + i;
                                if (i == length || HEAPU8[currentBytePtr >>> 0] == 0) {
                                    var maxRead = currentBytePtr - decodeStartPtr;
                                    var stringSegment = UTF8ToString(decodeStartPtr, maxRead);
                                    if (str === undefined) {
                                        str = stringSegment
                                    } else {
                                        str += String.fromCharCode(0);
                                        str += stringSegment
                                    }
                                    decodeStartPtr = currentBytePtr + 1
                                }
                            }
                        } else {
                            var a = new Array(length);
                            for (var i = 0; i < length; ++i) {
                                a[i] = String.fromCharCode(HEAPU8[payload + i >>> 0])
                            }
                            str = a.join("")
                        }
                        _free(value);
                        return str
                    },
                    toWireType(destructors, value) {
                        if (value instanceof ArrayBuffer) {
                            value = new Uint8Array(value)
                        }
                        var length;
                        var valueIsOfTypeString = typeof value == "string";
                        if (!(valueIsOfTypeString || value instanceof Uint8Array || value instanceof Uint8ClampedArray || value instanceof Int8Array)) {
                            throwBindingError("Cannot pass non-string to std::string")
                        }
                        if (stdStringIsUTF8 && valueIsOfTypeString) {
                            length = lengthBytesUTF8(value)
                        } else {
                            length = value.length
                        }
                        var base = _malloc(4 + length + 1);
                        var ptr = base + 4;
                        HEAPU32[base >>> 2 >>> 0] = length;
                        if (stdStringIsUTF8 && valueIsOfTypeString) {
                            stringToUTF8(value, ptr, length + 1)
                        } else {
                            if (valueIsOfTypeString) {
                                for (var i = 0; i < length; ++i) {
                                    var charCode = value.charCodeAt(i);
                                    if (charCode > 255) {
                                        _free(ptr);
                                        throwBindingError("String has UTF-16 code units that do not fit in 8 bits")
                                    }
                                    HEAPU8[ptr + i >>> 0] = charCode
                                }
                            } else {
                                for (var i = 0; i < length; ++i) {
                                    HEAPU8[ptr + i >>> 0] = value[i]
                                }
                            }
                        }
                        if (destructors !== null) {
                            destructors.push(_free, base)
                        }
                        return base
                    },
                    argPackAdvance: GenericWireTypeSize,
                    readValueFromPointer: readPointer,
                    destructorFunction(ptr) {
                        _free(ptr)
                    }
                })
            }
            __embind_register_std_string.sig = "vpp";
            var UTF16Decoder = typeof TextDecoder != "undefined" ? new TextDecoder("utf-16le") : undefined;
            var UTF16ToString = (ptr, maxBytesToRead) => {
                var endPtr = ptr;
                var idx = endPtr >> 1;
                var maxIdx = idx + maxBytesToRead / 2;
                while (!(idx >= maxIdx) && HEAPU16[idx >>> 0]) ++idx;
                endPtr = idx << 1;
                if (endPtr - ptr > 32 && UTF16Decoder) return UTF16Decoder.decode(HEAPU8.subarray(ptr >>> 0, endPtr >>> 0));
                var str = "";
                for (var i = 0; !(i >= maxBytesToRead / 2); ++i) {
                    var codeUnit = HEAP16[ptr + i * 2 >>> 1 >>> 0];
                    if (codeUnit == 0) break;
                    str += String.fromCharCode(codeUnit)
                }
                return str
            };
            var stringToUTF16 = (str, outPtr, maxBytesToWrite) => {
                maxBytesToWrite ??= 2147483647;
                if (maxBytesToWrite < 2) return 0;
                maxBytesToWrite -= 2;
                var startPtr = outPtr;
                var numCharsToWrite = maxBytesToWrite < str.length * 2 ? maxBytesToWrite / 2 : str.length;
                for (var i = 0; i < numCharsToWrite; ++i) {
                    var codeUnit = str.charCodeAt(i);
                    HEAP16[outPtr >>> 1 >>> 0] = codeUnit;
                    outPtr += 2
                }
                HEAP16[outPtr >>> 1 >>> 0] = 0;
                return outPtr - startPtr
            };
            var lengthBytesUTF16 = str => str.length * 2;
            var UTF32ToString = (ptr, maxBytesToRead) => {
                var i = 0;
                var str = "";
                while (!(i >= maxBytesToRead / 4)) {
                    var utf32 = HEAP32[ptr + i * 4 >>> 2 >>> 0];
                    if (utf32 == 0) break;
                    ++i;
                    if (utf32 >= 65536) {
                        var ch = utf32 - 65536;
                        str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023)
                    } else {
                        str += String.fromCharCode(utf32)
                    }
                }
                return str
            };
            var stringToUTF32 = (str, outPtr, maxBytesToWrite) => {
                outPtr >>>= 0;
                maxBytesToWrite ??= 2147483647;
                if (maxBytesToWrite < 4) return 0;
                var startPtr = outPtr;
                var endPtr = startPtr + maxBytesToWrite - 4;
                for (var i = 0; i < str.length; ++i) {
                    var codeUnit = str.charCodeAt(i);
                    if (codeUnit >= 55296 && codeUnit <= 57343) {
                        var trailSurrogate = str.charCodeAt(++i);
                        codeUnit = 65536 + ((codeUnit & 1023) << 10) | trailSurrogate & 1023
                    }
                    HEAP32[outPtr >>> 2 >>> 0] = codeUnit;
                    outPtr += 4;
                    if (outPtr + 4 > endPtr) break
                }
                HEAP32[outPtr >>> 2 >>> 0] = 0;
                return outPtr - startPtr
            };
            var lengthBytesUTF32 = str => {
                var len = 0;
                for (var i = 0; i < str.length; ++i) {
                    var codeUnit = str.charCodeAt(i);
                    if (codeUnit >= 55296 && codeUnit <= 57343) ++i;
                    len += 4
                }
                return len
            };
            var __embind_register_std_wstring = function(rawType, charSize, name) {
                rawType >>>= 0;
                charSize >>>= 0;
                name >>>= 0;
                name = readLatin1String(name);
                var decodeString, encodeString, readCharAt, lengthBytesUTF;
                if (charSize === 2) {
                    decodeString = UTF16ToString;
                    encodeString = stringToUTF16;
                    lengthBytesUTF = lengthBytesUTF16;
                    readCharAt = pointer => HEAPU16[pointer >>> 1 >>> 0]
                } else if (charSize === 4) {
                    decodeString = UTF32ToString;
                    encodeString = stringToUTF32;
                    lengthBytesUTF = lengthBytesUTF32;
                    readCharAt = pointer => HEAPU32[pointer >>> 2 >>> 0]
                }
                registerType(rawType, {
                    name,
                    fromWireType: value => {
                        var length = HEAPU32[value >>> 2 >>> 0];
                        var str;
                        var decodeStartPtr = value + 4;
                        for (var i = 0; i <= length; ++i) {
                            var currentBytePtr = value + 4 + i * charSize;
                            if (i == length || readCharAt(currentBytePtr) == 0) {
                                var maxReadBytes = currentBytePtr - decodeStartPtr;
                                var stringSegment = decodeString(decodeStartPtr, maxReadBytes);
                                if (str === undefined) {
                                    str = stringSegment
                                } else {
                                    str += String.fromCharCode(0);
                                    str += stringSegment
                                }
                                decodeStartPtr = currentBytePtr + charSize
                            }
                        }
                        _free(value);
                        return str
                    },
                    toWireType: (destructors, value) => {
                        if (!(typeof value == "string")) {
                            throwBindingError(`Cannot pass non-string to C++ string type ${name}`)
                        }
                        var length = lengthBytesUTF(value);
                        var ptr = _malloc(4 + length + charSize);
                        HEAPU32[ptr >>> 2 >>> 0] = length / charSize;
                        encodeString(value, ptr + 4, length + charSize);
                        if (destructors !== null) {
                            destructors.push(_free, ptr)
                        }
                        return ptr
                    },
                    argPackAdvance: GenericWireTypeSize,
                    readValueFromPointer: readPointer,
                    destructorFunction(ptr) {
                        _free(ptr)
                    }
                })
            };
            __embind_register_std_wstring.sig = "vppp";
            var __embind_register_void = function(rawType, name) {
                rawType >>>= 0;
                name >>>= 0;
                name = readLatin1String(name);
                registerType(rawType, {
                    isVoid: true,
                    name,
                    argPackAdvance: 0,
                    fromWireType: () => undefined,
                    toWireType: (destructors, o) => undefined
                })
            };
            __embind_register_void.sig = "vpp";
            var handleException = e => {
                if (e instanceof ExitStatus || e == "unwind") {
                    return EXITSTATUS
                }
                quit_(1, e)
            };
            var runtimeKeepaliveCounter = 0;
            var keepRuntimeAlive = () => noExitRuntime || runtimeKeepaliveCounter > 0;
            var _proc_exit = code => {
                EXITSTATUS = code;
                if (!keepRuntimeAlive()) {
                    Module["onExit"]?.(code);
                    ABORT = true
                }
                quit_(code, new ExitStatus(code))
            };
            _proc_exit.sig = "vi";
            var exitJS = (status, implicit) => {
                EXITSTATUS = status;
                _proc_exit(status)
            };
            var _exit = exitJS;
            _exit.sig = "vi";
            var maybeExit = () => {
                if (!keepRuntimeAlive()) {
                    try {
                        _exit(EXITSTATUS)
                    } catch (e) {
                        handleException(e)
                    }
                }
            };
            var callUserCallback = func => {
                if (ABORT) {
                    return
                }
                try {
                    func();
                    maybeExit()
                } catch (e) {
                    handleException(e)
                }
            };

            function __emscripten_dlopen_js(handle, onsuccess, onerror, user_data) {
                handle >>>= 0;
                onsuccess >>>= 0;
                onerror >>>= 0;
                user_data >>>= 0;

                function errorCallback(e) {
                    var filename = UTF8ToString(handle + 36);
                    dlSetError(`'Could not load dynamic lib: ${filename}\n${e}`);
                    callUserCallback(() => getWasmTableEntry(onerror)(handle, user_data))
                }

                function successCallback() {
                    callUserCallback(() => getWasmTableEntry(onsuccess)(handle, user_data))
                }
                var promise = dlopenInternal(handle, {
                    loadAsync: true
                });
                if (promise) {
                    promise.then(successCallback, errorCallback)
                } else {
                    errorCallback()
                }
            }
            __emscripten_dlopen_js.sig = "vpppp";
            var nowIsMonotonic = 1;
            var __emscripten_get_now_is_monotonic = () => nowIsMonotonic;
            __emscripten_get_now_is_monotonic.sig = "i";
            var getExecutableName = () => thisProgram || "./this.program";

            function __emscripten_get_progname(str, len) {
                str >>>= 0;
                stringToUTF8(getExecutableName(), str, len)
            }
            __emscripten_get_progname.sig = "vpi";

            function __emscripten_lookup_name(name) {
                name >>>= 0;
                var nameString = UTF8ToString(name);
                return inetPton4(DNS.lookup_name(nameString))
            }
            __emscripten_lookup_name.sig = "ip";

            function __emscripten_memcpy_js(dest, src, num) {
                dest >>>= 0;
                src >>>= 0;
                num >>>= 0;
                return HEAPU8.copyWithin(dest >>> 0, src >>> 0, src + num >>> 0)
            }
            __emscripten_memcpy_js.sig = "vppp";
            var __emscripten_runtime_keepalive_clear = () => {
                noExitRuntime = false;
                runtimeKeepaliveCounter = 0
            };
            __emscripten_runtime_keepalive_clear.sig = "v";

            function __emscripten_set_offscreencanvas_size(target, width, height) {
                target >>>= 0;
                return -1
            }
            __emscripten_set_offscreencanvas_size.sig = "ipii";

            function __emscripten_system(command) {
                command >>>= 0;
                if (ENVIRONMENT_IS_NODE) {
                    if (!command) return 1;
                    var cmdstr = UTF8ToString(command);
                    if (!cmdstr.length) return 0;
                    var cp = ["child_process"].map(require);
                    var ret = cp.spawnSync(cmdstr, [], {
                        shell: true,
                        stdio: "inherit"
                    });
                    var _W_EXITCODE = (ret, sig) => ret << 8 | sig;
                    if (ret.status === null) {
                        var signalToNumber = sig => {
                            switch (sig) {
                                case "SIGHUP":
                                    return 1;
                                case "SIGQUIT":
                                    return 3;
                                case "SIGFPE":
                                    return 8;
                                case "SIGKILL":
                                    return 9;
                                case "SIGALRM":
                                    return 14;
                                case "SIGTERM":
                                    return 15;
                                default:
                                    return 2
                            }
                        };
                        return _W_EXITCODE(0, signalToNumber(ret.signal))
                    }
                    return _W_EXITCODE(ret.status, 0)
                }
                if (!command) return 0;
                return -52
            }
            __emscripten_system.sig = "ip";
            var emval_symbols = {};
            var getStringOrSymbol = address => {
                var symbol = emval_symbols[address];
                if (symbol === undefined) {
                    return readLatin1String(address)
                }
                return symbol
            };
            var emval_methodCallers = [];

            function __emval_call_method(caller, objHandle, methodName, destructorsRef, args) {
                caller >>>= 0;
                objHandle >>>= 0;
                methodName >>>= 0;
                destructorsRef >>>= 0;
                args >>>= 0;
                caller = emval_methodCallers[caller];
                objHandle = Emval.toValue(objHandle);
                methodName = getStringOrSymbol(methodName);
                return caller(objHandle, objHandle[methodName], destructorsRef, args)
            }
            __emval_call_method.sig = "dppppp";
            var emval_get_global = () => {
                if (typeof globalThis == "object") {
                    return globalThis
                }
                return function() {
                    return Function
                }()("return this")()
            };

            function __emval_get_global(name) {
                name >>>= 0;
                if (name === 0) {
                    return Emval.toHandle(emval_get_global())
                } else {
                    name = getStringOrSymbol(name);
                    return Emval.toHandle(emval_get_global()[name])
                }
            }
            __emval_get_global.sig = "pp";
            var emval_addMethodCaller = caller => {
                var id = emval_methodCallers.length;
                emval_methodCallers.push(caller);
                return id
            };
            var getTypeName = type => {
                var ptr = ___getTypeName(type);
                var rv = readLatin1String(ptr);
                _free(ptr);
                return rv
            };
            var requireRegisteredType = (rawType, humanName) => {
                var impl = registeredTypes[rawType];
                if (undefined === impl) {
                    throwBindingError(`${humanName} has unknown type ${getTypeName(rawType)}`)
                }
                return impl
            };
            var emval_lookupTypes = (argCount, argTypes) => {
                var a = new Array(argCount);
                for (var i = 0; i < argCount; ++i) {
                    a[i] = requireRegisteredType(HEAPU32[argTypes + i * 4 >>> 2 >>> 0], "parameter " + i)
                }
                return a
            };
            var createNamedFunction = (name, body) => Object.defineProperty(body, "name", {
                value: name
            });
            var reflectConstruct = Reflect.construct;
            var emval_returnValue = (returnType, destructorsRef, handle) => {
                var destructors = [];
                var result = returnType["toWireType"](destructors, handle);
                if (destructors.length) {
                    HEAPU32[destructorsRef >>> 2 >>> 0] = Emval.toHandle(destructors)
                }
                return result
            };

            function newFunc(constructor, argumentList) {
                if (!(constructor instanceof Function)) {
                    throw new TypeError(`new_ called with constructor type ${typeof constructor} which is not a function`)
                }
                var dummy = createNamedFunction(constructor.name || "unknownFunctionName", function() {});
                dummy.prototype = constructor.prototype;
                var obj = new dummy;
                var r = constructor.apply(obj, argumentList);
                return r instanceof Object ? r : obj
            }

            function __emval_get_method_caller(argCount, argTypes, kind) {
                argTypes >>>= 0;
                var types = emval_lookupTypes(argCount, argTypes);
                var retType = types.shift();
                argCount--;
                var functionBody = `return function (obj, func, destructorsRef, args) {\n`;
                var offset = 0;
                var argsList = [];
                if (kind === 0) {
                    argsList.push("obj")
                }
                var params = ["retType"];
                var args = [retType];
                for (var i = 0; i < argCount; ++i) {
                    argsList.push("arg" + i);
                    params.push("argType" + i);
                    args.push(types[i]);
                    functionBody += `  var arg${i} = argType${i}.readValueFromPointer(args${offset?"+"+offset:""});\n`;
                    offset += types[i].argPackAdvance
                }
                var invoker = kind === 1 ? "new func" : "func.call";
                functionBody += `  var rv = ${invoker}(${argsList.join(", ")});\n`;
                if (!retType.isVoid) {
                    params.push("emval_returnValue");
                    args.push(emval_returnValue);
                    functionBody += "  return emval_returnValue(retType, destructorsRef, rv);\n"
                }
                functionBody += "};\n";
                params.push(functionBody);
                var invokerFunction = newFunc(Function, params)(...args);
                var functionName = `methodCaller<(${types.map(t=>t.name).join(", ")}) => ${retType.name}>`;
                return emval_addMethodCaller(createNamedFunction(functionName, invokerFunction))
            }
            __emval_get_method_caller.sig = "pipi";
            var runDestructors = destructors => {
                while (destructors.length) {
                    var ptr = destructors.pop();
                    var del = destructors.pop();
                    del(ptr)
                }
            };

            function __emval_run_destructors(handle) {
                handle >>>= 0;
                var destructors = Emval.toValue(handle);
                runDestructors(destructors);
                __emval_decref(handle)
            }
            __emval_run_destructors.sig = "vp";

            function __gmtime_js(time_low, time_high, tmPtr) {
                var time = convertI32PairToI53Checked(time_low, time_high);
                tmPtr >>>= 0;
                var date = new Date(time * 1e3);
                HEAP32[tmPtr >>> 2 >>> 0] = date.getUTCSeconds();
                HEAP32[tmPtr + 4 >>> 2 >>> 0] = date.getUTCMinutes();
                HEAP32[tmPtr + 8 >>> 2 >>> 0] = date.getUTCHours();
                HEAP32[tmPtr + 12 >>> 2 >>> 0] = date.getUTCDate();
                HEAP32[tmPtr + 16 >>> 2 >>> 0] = date.getUTCMonth();
                HEAP32[tmPtr + 20 >>> 2 >>> 0] = date.getUTCFullYear() - 1900;
                HEAP32[tmPtr + 24 >>> 2 >>> 0] = date.getUTCDay();
                var start = Date.UTC(date.getUTCFullYear(), 0, 1, 0, 0, 0, 0);
                var yday = (date.getTime() - start) / (1e3 * 60 * 60 * 24) | 0;
                HEAP32[tmPtr + 28 >>> 2 >>> 0] = yday
            }
            __gmtime_js.sig = "viip";
            var isLeapYear = year => year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
            var MONTH_DAYS_LEAP_CUMULATIVE = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
            var MONTH_DAYS_REGULAR_CUMULATIVE = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
            var ydayFromDate = date => {
                var leap = isLeapYear(date.getFullYear());
                var monthDaysCumulative = leap ? MONTH_DAYS_LEAP_CUMULATIVE : MONTH_DAYS_REGULAR_CUMULATIVE;
                var yday = monthDaysCumulative[date.getMonth()] + date.getDate() - 1;
                return yday
            };

            function __localtime_js(time_low, time_high, tmPtr) {
                var time = convertI32PairToI53Checked(time_low, time_high);
                tmPtr >>>= 0;
                var date = new Date(time * 1e3);
                HEAP32[tmPtr >>> 2 >>> 0] = date.getSeconds();
                HEAP32[tmPtr + 4 >>> 2 >>> 0] = date.getMinutes();
                HEAP32[tmPtr + 8 >>> 2 >>> 0] = date.getHours();
                HEAP32[tmPtr + 12 >>> 2 >>> 0] = date.getDate();
                HEAP32[tmPtr + 16 >>> 2 >>> 0] = date.getMonth();
                HEAP32[tmPtr + 20 >>> 2 >>> 0] = date.getFullYear() - 1900;
                HEAP32[tmPtr + 24 >>> 2 >>> 0] = date.getDay();
                var yday = ydayFromDate(date) | 0;
                HEAP32[tmPtr + 28 >>> 2 >>> 0] = yday;
                HEAP32[tmPtr + 36 >>> 2 >>> 0] = -(date.getTimezoneOffset() * 60);
                var start = new Date(date.getFullYear(), 0, 1);
                var summerOffset = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();
                var winterOffset = start.getTimezoneOffset();
                var dst = (summerOffset != winterOffset && date.getTimezoneOffset() == Math.min(winterOffset, summerOffset)) | 0;
                HEAP32[tmPtr + 32 >>> 2 >>> 0] = dst
            }
            __localtime_js.sig = "viip";
            var setTempRet0 = val => __emscripten_tempret_set(val);
            var _setTempRet0 = setTempRet0;
            Module["_setTempRet0"] = _setTempRet0;
            var __mktime_js = function(tmPtr) {
                tmPtr >>>= 0;
                var ret = (() => {
                    var date = new Date(HEAP32[tmPtr + 20 >>> 2 >>> 0] + 1900, HEAP32[tmPtr + 16 >>> 2 >>> 0], HEAP32[tmPtr + 12 >>> 2 >>> 0], HEAP32[tmPtr + 8 >>> 2 >>> 0], HEAP32[tmPtr + 4 >>> 2 >>> 0], HEAP32[tmPtr >>> 2 >>> 0], 0);
                    var dst = HEAP32[tmPtr + 32 >>> 2 >>> 0];
                    var guessedOffset = date.getTimezoneOffset();
                    var start = new Date(date.getFullYear(), 0, 1);
                    var summerOffset = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();
                    var winterOffset = start.getTimezoneOffset();
                    var dstOffset = Math.min(winterOffset, summerOffset);
                    if (dst < 0) {
                        HEAP32[tmPtr + 32 >>> 2 >>> 0] = Number(summerOffset != winterOffset && dstOffset == guessedOffset)
                    } else if (dst > 0 != (dstOffset == guessedOffset)) {
                        var nonDstOffset = Math.max(winterOffset, summerOffset);
                        var trueOffset = dst > 0 ? dstOffset : nonDstOffset;
                        date.setTime(date.getTime() + (trueOffset - guessedOffset) * 6e4)
                    }
                    HEAP32[tmPtr + 24 >>> 2 >>> 0] = date.getDay();
                    var yday = ydayFromDate(date) | 0;
                    HEAP32[tmPtr + 28 >>> 2 >>> 0] = yday;
                    HEAP32[tmPtr >>> 2 >>> 0] = date.getSeconds();
                    HEAP32[tmPtr + 4 >>> 2 >>> 0] = date.getMinutes();
                    HEAP32[tmPtr + 8 >>> 2 >>> 0] = date.getHours();
                    HEAP32[tmPtr + 12 >>> 2 >>> 0] = date.getDate();
                    HEAP32[tmPtr + 16 >>> 2 >>> 0] = date.getMonth();
                    HEAP32[tmPtr + 20 >>> 2 >>> 0] = date.getYear();
                    var timeMs = date.getTime();
                    if (isNaN(timeMs)) {
                        return -1
                    }
                    return timeMs / 1e3
                })();
                return setTempRet0((tempDouble = ret, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)), ret >>> 0
            };
            __mktime_js.sig = "ip";

            function __mmap_js(len, prot, flags, fd, offset_low, offset_high, allocated, addr) {
                len >>>= 0;
                var offset = convertI32PairToI53Checked(offset_low, offset_high);
                allocated >>>= 0;
                addr >>>= 0;
                try {
                    if (isNaN(offset)) return 61;
                    var stream = SYSCALLS.getStreamFromFD(fd);
                    var res = FS.mmap(stream, len, offset, prot, flags);
                    var ptr = res.ptr;
                    HEAP32[allocated >>> 2 >>> 0] = res.allocated;
                    HEAPU32[addr >>> 2 >>> 0] = ptr;
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            __mmap_js.sig = "ipiiiiipp";

            function __msync_js(addr, len, prot, flags, fd, offset_low, offset_high) {
                addr >>>= 0;
                len >>>= 0;
                var offset = convertI32PairToI53Checked(offset_low, offset_high);
                try {
                    if (isNaN(offset)) return 61;
                    SYSCALLS.doMsync(addr, SYSCALLS.getStreamFromFD(fd), len, flags, offset);
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            __msync_js.sig = "ippiiiii";

            function __munmap_js(addr, len, prot, flags, fd, offset_low, offset_high) {
                addr >>>= 0;
                len >>>= 0;
                var offset = convertI32PairToI53Checked(offset_low, offset_high);
                try {
                    var stream = SYSCALLS.getStreamFromFD(fd);
                    if (prot & 2) {
                        SYSCALLS.doMsync(addr, stream, len, flags, offset)
                    }
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            __munmap_js.sig = "ippiiiii";
            var timers = {};
            var _emscripten_get_now = () => performance.now();
            _emscripten_get_now.sig = "d";
            var __setitimer_js = (which, timeout_ms) => {
                if (timers[which]) {
                    clearTimeout(timers[which].id);
                    delete timers[which]
                }
                if (!timeout_ms) return 0;
                var id = setTimeout(() => {
                    delete timers[which];
                    callUserCallback(() => __emscripten_timeout(which, _emscripten_get_now()))
                }, timeout_ms);
                timers[which] = {
                    id,
                    timeout_ms
                };
                return 0
            };
            __setitimer_js.sig = "iid";
            var __timegm_js = function(tmPtr) {
                tmPtr >>>= 0;
                var ret = (() => {
                    var time = Date.UTC(HEAP32[tmPtr + 20 >>> 2 >>> 0] + 1900, HEAP32[tmPtr + 16 >>> 2 >>> 0], HEAP32[tmPtr + 12 >>> 2 >>> 0], HEAP32[tmPtr + 8 >>> 2 >>> 0], HEAP32[tmPtr + 4 >>> 2 >>> 0], HEAP32[tmPtr >>> 2 >>> 0], 0);
                    var date = new Date(time);
                    HEAP32[tmPtr + 24 >>> 2 >>> 0] = date.getUTCDay();
                    var start = Date.UTC(date.getUTCFullYear(), 0, 1, 0, 0, 0, 0);
                    var yday = (date.getTime() - start) / (1e3 * 60 * 60 * 24) | 0;
                    HEAP32[tmPtr + 28 >>> 2 >>> 0] = yday;
                    return date.getTime() / 1e3
                })();
                return setTempRet0((tempDouble = ret, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)), ret >>> 0
            };
            __timegm_js.sig = "ip";
            var __tzset_js = function(timezone, daylight, std_name, dst_name) {
                timezone >>>= 0;
                daylight >>>= 0;
                std_name >>>= 0;
                dst_name >>>= 0;
                var currentYear = (new Date).getFullYear();
                var winter = new Date(currentYear, 0, 1);
                var summer = new Date(currentYear, 6, 1);
                var winterOffset = winter.getTimezoneOffset();
                var summerOffset = summer.getTimezoneOffset();
                var stdTimezoneOffset = Math.max(winterOffset, summerOffset);
                HEAPU32[timezone >>> 2 >>> 0] = stdTimezoneOffset * 60;
                HEAP32[daylight >>> 2 >>> 0] = Number(winterOffset != summerOffset);
                var extractZone = timezoneOffset => {
                    var sign = timezoneOffset >= 0 ? "-" : "+";
                    var absOffset = Math.abs(timezoneOffset);
                    var hours = String(Math.floor(absOffset / 60)).padStart(2, "0");
                    var minutes = String(absOffset % 60).padStart(2, "0");
                    return `UTC${sign}${hours}${minutes}`
                };
                var winterName = extractZone(winterOffset);
                var summerName = extractZone(summerOffset);
                if (summerOffset < winterOffset) {
                    stringToUTF8(winterName, std_name, 17);
                    stringToUTF8(summerName, dst_name, 17)
                } else {
                    stringToUTF8(winterName, dst_name, 17);
                    stringToUTF8(summerName, std_name, 17)
                }
            };
            __tzset_js.sig = "vpppp";
            var _emscripten_set_main_loop_timing = (mode, value) => {
                MainLoop.timingMode = mode;
                MainLoop.timingValue = value;
                if (!MainLoop.func) {
                    return 1
                }
                if (!MainLoop.running) {
                    MainLoop.running = true
                }
                if (mode == 0) {
                    MainLoop.scheduler = function MainLoop_scheduler_setTimeout() {
                        var timeUntilNextTick = Math.max(0, MainLoop.tickStartTime + value - _emscripten_get_now()) | 0;
                        setTimeout(MainLoop.runner, timeUntilNextTick)
                    };
                    MainLoop.method = "timeout"
                } else if (mode == 1) {
                    MainLoop.scheduler = function MainLoop_scheduler_rAF() {
                        MainLoop.requestAnimationFrame(MainLoop.runner)
                    };
                    MainLoop.method = "rAF"
                } else if (mode == 2) {
                    if (typeof MainLoop.setImmediate == "undefined") {
                        if (typeof setImmediate == "undefined") {
                            var setImmediates = [];
                            var emscriptenMainLoopMessageId = "setimmediate";
                            var MainLoop_setImmediate_messageHandler = event => {
                                if (event.data === emscriptenMainLoopMessageId || event.data.target === emscriptenMainLoopMessageId) {
                                    event.stopPropagation();
                                    setImmediates.shift()()
                                }
                            };
                            addEventListener("message", MainLoop_setImmediate_messageHandler, true);
                            MainLoop.setImmediate = func => {
                                setImmediates.push(func);
                                if (ENVIRONMENT_IS_WORKER) {
                                    Module["setImmediates"] ??= [];
                                    Module["setImmediates"].push(func);
                                    postMessage({
                                        target: emscriptenMainLoopMessageId
                                    })
                                } else postMessage(emscriptenMainLoopMessageId, "*")
                            }
                        } else {
                            MainLoop.setImmediate = setImmediate
                        }
                    }
                    MainLoop.scheduler = function MainLoop_scheduler_setImmediate() {
                        MainLoop.setImmediate(MainLoop.runner)
                    };
                    MainLoop.method = "immediate"
                }
                return 0
            };
            _emscripten_set_main_loop_timing.sig = "iii";
            var setMainLoop = (iterFunc, fps, simulateInfiniteLoop, arg, noSetTiming) => {
                MainLoop.func = iterFunc;
                MainLoop.arg = arg;
                var thisMainLoopId = MainLoop.currentlyRunningMainloop;

                function checkIsRunning() {
                    if (thisMainLoopId < MainLoop.currentlyRunningMainloop) {
                        maybeExit();
                        return false
                    }
                    return true
                }
                MainLoop.running = false;
                MainLoop.runner = function MainLoop_runner() {
                    if (ABORT) return;
                    if (MainLoop.queue.length > 0) {
                        var start = Date.now();
                        var blocker = MainLoop.queue.shift();
                        blocker.func(blocker.arg);
                        if (MainLoop.remainingBlockers) {
                            var remaining = MainLoop.remainingBlockers;
                            var next = remaining % 1 == 0 ? remaining - 1 : Math.floor(remaining);
                            if (blocker.counted) {
                                MainLoop.remainingBlockers = next
                            } else {
                                next = next + .5;
                                MainLoop.remainingBlockers = (8 * remaining + next) / 9
                            }
                        }
                        MainLoop.updateStatus();
                        if (!checkIsRunning()) return;
                        setTimeout(MainLoop.runner, 0);
                        return
                    }
                    if (!checkIsRunning()) return;
                    MainLoop.currentFrameNumber = MainLoop.currentFrameNumber + 1 | 0;
                    if (MainLoop.timingMode == 1 && MainLoop.timingValue > 1 && MainLoop.currentFrameNumber % MainLoop.timingValue != 0) {
                        MainLoop.scheduler();
                        return
                    } else if (MainLoop.timingMode == 0) {
                        MainLoop.tickStartTime = _emscripten_get_now()
                    }
                    MainLoop.runIter(iterFunc);
                    if (!checkIsRunning()) return;
                    MainLoop.scheduler()
                };
                if (!noSetTiming) {
                    if (fps && fps > 0) {
                        _emscripten_set_main_loop_timing(0, 1e3 / fps)
                    } else {
                        _emscripten_set_main_loop_timing(1, 1)
                    }
                    MainLoop.scheduler()
                }
                if (simulateInfiniteLoop) {
                    throw "unwind"
                }
            };
            var MainLoop = {
                running: false,
                scheduler: null,
                method: "",
                currentlyRunningMainloop: 0,
                func: null,
                arg: 0,
                timingMode: 0,
                timingValue: 0,
                currentFrameNumber: 0,
                queue: [],
                preMainLoop: [],
                postMainLoop: [],
                pause() {
                    MainLoop.scheduler = null;
                    MainLoop.currentlyRunningMainloop++
                },
                resume() {
                    MainLoop.currentlyRunningMainloop++;
                    var timingMode = MainLoop.timingMode;
                    var timingValue = MainLoop.timingValue;
                    var func = MainLoop.func;
                    MainLoop.func = null;
                    setMainLoop(func, 0, false, MainLoop.arg, true);
                    _emscripten_set_main_loop_timing(timingMode, timingValue);
                    MainLoop.scheduler()
                },
                updateStatus() {
                    if (Module["setStatus"]) {
                        var message = Module["statusMessage"] || "Please wait...";
                        var remaining = MainLoop.remainingBlockers ?? 0;
                        var expected = MainLoop.expectedBlockers ?? 0;
                        if (remaining) {
                            if (remaining < expected) {
                                Module["setStatus"](`{message} ({expected - remaining}/{expected})`)
                            } else {
                                Module["setStatus"](message)
                            }
                        } else {
                            Module["setStatus"]("")
                        }
                    }
                },
                init() {
                    Module["preMainLoop"] && MainLoop.preMainLoop.push(Module["preMainLoop"]);
                    Module["postMainLoop"] && MainLoop.postMainLoop.push(Module["postMainLoop"])
                },
                runIter(func) {
                    if (ABORT) return;
                    for (var pre of MainLoop.preMainLoop) {
                        if (pre() === false) {
                            return
                        }
                    }
                    callUserCallback(func);
                    for (var post of MainLoop.postMainLoop) {
                        post()
                    }
                },
                nextRAF: 0,
                fakeRequestAnimationFrame(func) {
                    var now = Date.now();
                    if (MainLoop.nextRAF === 0) {
                        MainLoop.nextRAF = now + 1e3 / 60
                    } else {
                        while (now + 2 >= MainLoop.nextRAF) {
                            MainLoop.nextRAF += 1e3 / 60
                        }
                    }
                    var delay = Math.max(MainLoop.nextRAF - now, 0);
                    setTimeout(func, delay)
                },
                requestAnimationFrame(func) {
                    if (typeof requestAnimationFrame == "function") {
                        requestAnimationFrame(func);
                        return
                    }
                    var RAF = MainLoop.fakeRequestAnimationFrame;
                    RAF(func)
                }
            };
            var AL = {
                QUEUE_INTERVAL: 25,
                QUEUE_LOOKAHEAD: .1,
                DEVICE_NAME: "Emscripten OpenAL",
                CAPTURE_DEVICE_NAME: "Emscripten OpenAL capture",
                ALC_EXTENSIONS: {
                    ALC_SOFT_pause_device: true,
                    ALC_SOFT_HRTF: true
                },
                AL_EXTENSIONS: {
                    AL_EXT_float32: true,
                    AL_SOFT_loop_points: true,
                    AL_SOFT_source_length: true,
                    AL_EXT_source_distance_model: true,
                    AL_SOFT_source_spatialize: true
                },
                _alcErr: 0,
                alcErr: 0,
                deviceRefCounts: {},
                alcStringCache: {},
                paused: false,
                stringCache: {},
                contexts: {},
                currentCtx: null,
                buffers: {
                    0: {
                        id: 0,
                        refCount: 0,
                        audioBuf: null,
                        frequency: 0,
                        bytesPerSample: 2,
                        channels: 1,
                        length: 0
                    }
                },
                paramArray: [],
                _nextId: 1,
                newId: () => AL.freeIds.length > 0 ? AL.freeIds.pop() : AL._nextId++,
                freeIds: [],
                scheduleContextAudio: ctx => {
                    if (MainLoop.timingMode === 1 && document["visibilityState"] != "visible") {
                        return
                    }
                    for (var i in ctx.sources) {
                        AL.scheduleSourceAudio(ctx.sources[i])
                    }
                },
                scheduleSourceAudio: (src, lookahead) => {
                    if (MainLoop.timingMode === 1 && document["visibilityState"] != "visible") {
                        return
                    }
                    if (src.state !== 4114) {
                        return
                    }
                    var currentTime = AL.updateSourceTime(src);
                    var startTime = src.bufStartTime;
                    var startOffset = src.bufOffset;
                    var bufCursor = src.bufsProcessed;
                    for (var i = 0; i < src.audioQueue.length; i++) {
                        var audioSrc = src.audioQueue[i];
                        startTime = audioSrc._startTime + audioSrc._duration;
                        startOffset = 0;
                        bufCursor += audioSrc._skipCount + 1
                    }
                    if (!lookahead) {
                        lookahead = AL.QUEUE_LOOKAHEAD
                    }
                    var lookaheadTime = currentTime + lookahead;
                    var skipCount = 0;
                    while (startTime < lookaheadTime) {
                        if (bufCursor >= src.bufQueue.length) {
                            if (src.looping) {
                                bufCursor %= src.bufQueue.length
                            } else {
                                break
                            }
                        }
                        var buf = src.bufQueue[bufCursor % src.bufQueue.length];
                        if (buf.length === 0) {
                            skipCount++;
                            if (skipCount === src.bufQueue.length) {
                                break
                            }
                        } else {
                            var audioSrc = src.context.audioCtx.createBufferSource();
                            audioSrc.buffer = buf.audioBuf;
                            audioSrc.playbackRate.value = src.playbackRate;
                            if (buf.audioBuf._loopStart || buf.audioBuf._loopEnd) {
                                audioSrc.loopStart = buf.audioBuf._loopStart;
                                audioSrc.loopEnd = buf.audioBuf._loopEnd
                            }
                            var duration = 0;
                            if (src.type === 4136 && src.looping) {
                                duration = Number.POSITIVE_INFINITY;
                                audioSrc.loop = true;
                                if (buf.audioBuf._loopStart) {
                                    audioSrc.loopStart = buf.audioBuf._loopStart
                                }
                                if (buf.audioBuf._loopEnd) {
                                    audioSrc.loopEnd = buf.audioBuf._loopEnd
                                }
                            } else {
                                duration = (buf.audioBuf.duration - startOffset) / src.playbackRate
                            }
                            audioSrc._startOffset = startOffset;
                            audioSrc._duration = duration;
                            audioSrc._skipCount = skipCount;
                            skipCount = 0;
                            audioSrc.connect(src.gain);
                            if (typeof audioSrc.start != "undefined") {
                                startTime = Math.max(startTime, src.context.audioCtx.currentTime);
                                audioSrc.start(startTime, startOffset)
                            } else if (typeof audioSrc.noteOn != "undefined") {
                                startTime = Math.max(startTime, src.context.audioCtx.currentTime);
                                audioSrc.noteOn(startTime)
                            }
                            audioSrc._startTime = startTime;
                            src.audioQueue.push(audioSrc);
                            startTime += duration
                        }
                        startOffset = 0;
                        bufCursor++
                    }
                },
                updateSourceTime: src => {
                    var currentTime = src.context.audioCtx.currentTime;
                    if (src.state !== 4114) {
                        return currentTime
                    }
                    if (!isFinite(src.bufStartTime)) {
                        src.bufStartTime = currentTime - src.bufOffset / src.playbackRate;
                        src.bufOffset = 0
                    }
                    var nextStartTime = 0;
                    while (src.audioQueue.length) {
                        var audioSrc = src.audioQueue[0];
                        src.bufsProcessed += audioSrc._skipCount;
                        nextStartTime = audioSrc._startTime + audioSrc._duration;
                        if (currentTime < nextStartTime) {
                            break
                        }
                        src.audioQueue.shift();
                        src.bufStartTime = nextStartTime;
                        src.bufOffset = 0;
                        src.bufsProcessed++
                    }
                    if (src.bufsProcessed >= src.bufQueue.length && !src.looping) {
                        AL.setSourceState(src, 4116)
                    } else if (src.type === 4136 && src.looping) {
                        var buf = src.bufQueue[0];
                        if (buf.length === 0) {
                            src.bufOffset = 0
                        } else {
                            var delta = (currentTime - src.bufStartTime) * src.playbackRate;
                            var loopStart = buf.audioBuf._loopStart || 0;
                            var loopEnd = buf.audioBuf._loopEnd || buf.audioBuf.duration;
                            if (loopEnd <= loopStart) {
                                loopEnd = buf.audioBuf.duration
                            }
                            if (delta < loopEnd) {
                                src.bufOffset = delta
                            } else {
                                src.bufOffset = loopStart + (delta - loopStart) % (loopEnd - loopStart)
                            }
                        }
                    } else if (src.audioQueue[0]) {
                        src.bufOffset = (currentTime - src.audioQueue[0]._startTime) * src.playbackRate
                    } else {
                        if (src.type !== 4136 && src.looping) {
                            var srcDuration = AL.sourceDuration(src) / src.playbackRate;
                            if (srcDuration > 0) {
                                src.bufStartTime += Math.floor((currentTime - src.bufStartTime) / srcDuration) * srcDuration
                            }
                        }
                        for (var i = 0; i < src.bufQueue.length; i++) {
                            if (src.bufsProcessed >= src.bufQueue.length) {
                                if (src.looping) {
                                    src.bufsProcessed %= src.bufQueue.length
                                } else {
                                    AL.setSourceState(src, 4116);
                                    break
                                }
                            }
                            var buf = src.bufQueue[src.bufsProcessed];
                            if (buf.length > 0) {
                                nextStartTime = src.bufStartTime + buf.audioBuf.duration / src.playbackRate;
                                if (currentTime < nextStartTime) {
                                    src.bufOffset = (currentTime - src.bufStartTime) * src.playbackRate;
                                    break
                                }
                                src.bufStartTime = nextStartTime
                            }
                            src.bufOffset = 0;
                            src.bufsProcessed++
                        }
                    }
                    return currentTime
                },
                cancelPendingSourceAudio: src => {
                    AL.updateSourceTime(src);
                    for (var i = 1; i < src.audioQueue.length; i++) {
                        var audioSrc = src.audioQueue[i];
                        audioSrc.stop()
                    }
                    if (src.audioQueue.length > 1) {
                        src.audioQueue.length = 1
                    }
                },
                stopSourceAudio: src => {
                    for (var i = 0; i < src.audioQueue.length; i++) {
                        src.audioQueue[i].stop()
                    }
                    src.audioQueue.length = 0
                },
                setSourceState: (src, state) => {
                    if (state === 4114) {
                        if (src.state === 4114 || src.state == 4116) {
                            src.bufsProcessed = 0;
                            src.bufOffset = 0
                        } else {}
                        AL.stopSourceAudio(src);
                        src.state = 4114;
                        src.bufStartTime = Number.NEGATIVE_INFINITY;
                        AL.scheduleSourceAudio(src)
                    } else if (state === 4115) {
                        if (src.state === 4114) {
                            AL.updateSourceTime(src);
                            AL.stopSourceAudio(src);
                            src.state = 4115
                        }
                    } else if (state === 4116) {
                        if (src.state !== 4113) {
                            src.state = 4116;
                            src.bufsProcessed = src.bufQueue.length;
                            src.bufStartTime = Number.NEGATIVE_INFINITY;
                            src.bufOffset = 0;
                            AL.stopSourceAudio(src)
                        }
                    } else if (state === 4113) {
                        if (src.state !== 4113) {
                            src.state = 4113;
                            src.bufsProcessed = 0;
                            src.bufStartTime = Number.NEGATIVE_INFINITY;
                            src.bufOffset = 0;
                            AL.stopSourceAudio(src)
                        }
                    }
                },
                initSourcePanner: src => {
                    if (src.type === 4144) {
                        return
                    }
                    var templateBuf = AL.buffers[0];
                    for (var i = 0; i < src.bufQueue.length; i++) {
                        if (src.bufQueue[i].id !== 0) {
                            templateBuf = src.bufQueue[i];
                            break
                        }
                    }
                    if (src.spatialize === 1 || src.spatialize === 2 && templateBuf.channels === 1) {
                        if (src.panner) {
                            return
                        }
                        src.panner = src.context.audioCtx.createPanner();
                        AL.updateSourceGlobal(src);
                        AL.updateSourceSpace(src);
                        src.panner.connect(src.context.gain);
                        src.gain.disconnect();
                        src.gain.connect(src.panner)
                    } else {
                        if (!src.panner) {
                            return
                        }
                        src.panner.disconnect();
                        src.gain.disconnect();
                        src.gain.connect(src.context.gain);
                        src.panner = null
                    }
                },
                updateContextGlobal: ctx => {
                    for (var i in ctx.sources) {
                        AL.updateSourceGlobal(ctx.sources[i])
                    }
                },
                updateSourceGlobal: src => {
                    var panner = src.panner;
                    if (!panner) {
                        return
                    }
                    panner.refDistance = src.refDistance;
                    panner.maxDistance = src.maxDistance;
                    panner.rolloffFactor = src.rolloffFactor;
                    panner.panningModel = src.context.hrtf ? "HRTF" : "equalpower";
                    var distanceModel = src.context.sourceDistanceModel ? src.distanceModel : src.context.distanceModel;
                    switch (distanceModel) {
                        case 0:
                            panner.distanceModel = "inverse";
                            panner.refDistance = 340282e33;
                            break;
                        case 53249:
                        case 53250:
                            panner.distanceModel = "inverse";
                            break;
                        case 53251:
                        case 53252:
                            panner.distanceModel = "linear";
                            break;
                        case 53253:
                        case 53254:
                            panner.distanceModel = "exponential";
                            break
                    }
                },
                updateListenerSpace: ctx => {
                    var listener = ctx.audioCtx.listener;
                    if (listener.positionX) {
                        listener.positionX.value = ctx.listener.position[0];
                        listener.positionY.value = ctx.listener.position[1];
                        listener.positionZ.value = ctx.listener.position[2]
                    } else {
                        listener.setPosition(ctx.listener.position[0], ctx.listener.position[1], ctx.listener.position[2])
                    }
                    if (listener.forwardX) {
                        listener.forwardX.value = ctx.listener.direction[0];
                        listener.forwardY.value = ctx.listener.direction[1];
                        listener.forwardZ.value = ctx.listener.direction[2];
                        listener.upX.value = ctx.listener.up[0];
                        listener.upY.value = ctx.listener.up[1];
                        listener.upZ.value = ctx.listener.up[2]
                    } else {
                        listener.setOrientation(ctx.listener.direction[0], ctx.listener.direction[1], ctx.listener.direction[2], ctx.listener.up[0], ctx.listener.up[1], ctx.listener.up[2])
                    }
                    for (var i in ctx.sources) {
                        AL.updateSourceSpace(ctx.sources[i])
                    }
                },
                updateSourceSpace: src => {
                    if (!src.panner) {
                        return
                    }
                    var panner = src.panner;
                    var posX = src.position[0];
                    var posY = src.position[1];
                    var posZ = src.position[2];
                    var dirX = src.direction[0];
                    var dirY = src.direction[1];
                    var dirZ = src.direction[2];
                    var listener = src.context.listener;
                    var lPosX = listener.position[0];
                    var lPosY = listener.position[1];
                    var lPosZ = listener.position[2];
                    if (src.relative) {
                        var lBackX = -listener.direction[0];
                        var lBackY = -listener.direction[1];
                        var lBackZ = -listener.direction[2];
                        var lUpX = listener.up[0];
                        var lUpY = listener.up[1];
                        var lUpZ = listener.up[2];
                        var inverseMagnitude = (x, y, z) => {
                            var length = Math.sqrt(x * x + y * y + z * z);
                            if (length < Number.EPSILON) {
                                return 0
                            }
                            return 1 / length
                        };
                        var invMag = inverseMagnitude(lBackX, lBackY, lBackZ);
                        lBackX *= invMag;
                        lBackY *= invMag;
                        lBackZ *= invMag;
                        invMag = inverseMagnitude(lUpX, lUpY, lUpZ);
                        lUpX *= invMag;
                        lUpY *= invMag;
                        lUpZ *= invMag;
                        var lRightX = lUpY * lBackZ - lUpZ * lBackY;
                        var lRightY = lUpZ * lBackX - lUpX * lBackZ;
                        var lRightZ = lUpX * lBackY - lUpY * lBackX;
                        invMag = inverseMagnitude(lRightX, lRightY, lRightZ);
                        lRightX *= invMag;
                        lRightY *= invMag;
                        lRightZ *= invMag;
                        lUpX = lBackY * lRightZ - lBackZ * lRightY;
                        lUpY = lBackZ * lRightX - lBackX * lRightZ;
                        lUpZ = lBackX * lRightY - lBackY * lRightX;
                        var oldX = dirX;
                        var oldY = dirY;
                        var oldZ = dirZ;
                        dirX = oldX * lRightX + oldY * lUpX + oldZ * lBackX;
                        dirY = oldX * lRightY + oldY * lUpY + oldZ * lBackY;
                        dirZ = oldX * lRightZ + oldY * lUpZ + oldZ * lBackZ;
                        oldX = posX;
                        oldY = posY;
                        oldZ = posZ;
                        posX = oldX * lRightX + oldY * lUpX + oldZ * lBackX;
                        posY = oldX * lRightY + oldY * lUpY + oldZ * lBackY;
                        posZ = oldX * lRightZ + oldY * lUpZ + oldZ * lBackZ;
                        posX += lPosX;
                        posY += lPosY;
                        posZ += lPosZ
                    }
                    if (panner.positionX) {
                        if (posX != panner.positionX.value) panner.positionX.value = posX;
                        if (posY != panner.positionY.value) panner.positionY.value = posY;
                        if (posZ != panner.positionZ.value) panner.positionZ.value = posZ
                    } else {
                        panner.setPosition(posX, posY, posZ)
                    }
                    if (panner.orientationX) {
                        if (dirX != panner.orientationX.value) panner.orientationX.value = dirX;
                        if (dirY != panner.orientationY.value) panner.orientationY.value = dirY;
                        if (dirZ != panner.orientationZ.value) panner.orientationZ.value = dirZ
                    } else {
                        panner.setOrientation(dirX, dirY, dirZ)
                    }
                    var oldShift = src.dopplerShift;
                    var velX = src.velocity[0];
                    var velY = src.velocity[1];
                    var velZ = src.velocity[2];
                    var lVelX = listener.velocity[0];
                    var lVelY = listener.velocity[1];
                    var lVelZ = listener.velocity[2];
                    if (posX === lPosX && posY === lPosY && posZ === lPosZ || velX === lVelX && velY === lVelY && velZ === lVelZ) {
                        src.dopplerShift = 1
                    } else {
                        var speedOfSound = src.context.speedOfSound;
                        var dopplerFactor = src.context.dopplerFactor;
                        var slX = lPosX - posX;
                        var slY = lPosY - posY;
                        var slZ = lPosZ - posZ;
                        var magSl = Math.sqrt(slX * slX + slY * slY + slZ * slZ);
                        var vls = (slX * lVelX + slY * lVelY + slZ * lVelZ) / magSl;
                        var vss = (slX * velX + slY * velY + slZ * velZ) / magSl;
                        vls = Math.min(vls, speedOfSound / dopplerFactor);
                        vss = Math.min(vss, speedOfSound / dopplerFactor);
                        src.dopplerShift = (speedOfSound - dopplerFactor * vls) / (speedOfSound - dopplerFactor * vss)
                    }
                    if (src.dopplerShift !== oldShift) {
                        AL.updateSourceRate(src)
                    }
                },
                updateSourceRate: src => {
                    if (src.state === 4114) {
                        AL.cancelPendingSourceAudio(src);
                        var audioSrc = src.audioQueue[0];
                        if (!audioSrc) {
                            return
                        }
                        var duration;
                        if (src.type === 4136 && src.looping) {
                            duration = Number.POSITIVE_INFINITY
                        } else {
                            duration = (audioSrc.buffer.duration - audioSrc._startOffset) / src.playbackRate
                        }
                        audioSrc._duration = duration;
                        audioSrc.playbackRate.value = src.playbackRate;
                        AL.scheduleSourceAudio(src)
                    }
                },
                sourceDuration: src => {
                    var length = 0;
                    for (var i = 0; i < src.bufQueue.length; i++) {
                        var audioBuf = src.bufQueue[i].audioBuf;
                        length += audioBuf ? audioBuf.duration : 0
                    }
                    return length
                },
                sourceTell: src => {
                    AL.updateSourceTime(src);
                    var offset = 0;
                    for (var i = 0; i < src.bufsProcessed; i++) {
                        if (src.bufQueue[i].audioBuf) {
                            offset += src.bufQueue[i].audioBuf.duration
                        }
                    }
                    offset += src.bufOffset;
                    return offset
                },
                sourceSeek: (src, offset) => {
                    var playing = src.state == 4114;
                    if (playing) {
                        AL.setSourceState(src, 4113)
                    }
                    if (src.bufQueue[src.bufsProcessed].audioBuf !== null) {
                        src.bufsProcessed = 0;
                        while (offset > src.bufQueue[src.bufsProcessed].audioBuf.duration) {
                            offset -= src.bufQueue[src.bufsProcessed].audioBuf.duration;
                            src.bufsProcessed++
                        }
                        src.bufOffset = offset
                    }
                    if (playing) {
                        AL.setSourceState(src, 4114)
                    }
                },
                getGlobalParam: (funcname, param) => {
                    if (!AL.currentCtx) {
                        return null
                    }
                    switch (param) {
                        case 49152:
                            return AL.currentCtx.dopplerFactor;
                        case 49155:
                            return AL.currentCtx.speedOfSound;
                        case 53248:
                            return AL.currentCtx.distanceModel;
                        default:
                            AL.currentCtx.err = 40962;
                            return null
                    }
                },
                setGlobalParam: (funcname, param, value) => {
                    if (!AL.currentCtx) {
                        return
                    }
                    switch (param) {
                        case 49152:
                            if (!Number.isFinite(value) || value < 0) {
                                AL.currentCtx.err = 40963;
                                return
                            }
                            AL.currentCtx.dopplerFactor = value;
                            AL.updateListenerSpace(AL.currentCtx);
                            break;
                        case 49155:
                            if (!Number.isFinite(value) || value <= 0) {
                                AL.currentCtx.err = 40963;
                                return
                            }
                            AL.currentCtx.speedOfSound = value;
                            AL.updateListenerSpace(AL.currentCtx);
                            break;
                        case 53248:
                            switch (value) {
                                case 0:
                                case 53249:
                                case 53250:
                                case 53251:
                                case 53252:
                                case 53253:
                                case 53254:
                                    AL.currentCtx.distanceModel = value;
                                    AL.updateContextGlobal(AL.currentCtx);
                                    break;
                                default:
                                    AL.currentCtx.err = 40963;
                                    return
                            }
                            break;
                        default:
                            AL.currentCtx.err = 40962;
                            return
                    }
                },
                getListenerParam: (funcname, param) => {
                    if (!AL.currentCtx) {
                        return null
                    }
                    switch (param) {
                        case 4100:
                            return AL.currentCtx.listener.position;
                        case 4102:
                            return AL.currentCtx.listener.velocity;
                        case 4111:
                            return AL.currentCtx.listener.direction.concat(AL.currentCtx.listener.up);
                        case 4106:
                            return AL.currentCtx.gain.gain.value;
                        default:
                            AL.currentCtx.err = 40962;
                            return null
                    }
                },
                setListenerParam: (funcname, param, value) => {
                    if (!AL.currentCtx) {
                        return
                    }
                    if (value === null) {
                        AL.currentCtx.err = 40962;
                        return
                    }
                    var listener = AL.currentCtx.listener;
                    switch (param) {
                        case 4100:
                            if (!Number.isFinite(value[0]) || !Number.isFinite(value[1]) || !Number.isFinite(value[2])) {
                                AL.currentCtx.err = 40963;
                                return
                            }
                            listener.position[0] = value[0];
                            listener.position[1] = value[1];
                            listener.position[2] = value[2];
                            AL.updateListenerSpace(AL.currentCtx);
                            break;
                        case 4102:
                            if (!Number.isFinite(value[0]) || !Number.isFinite(value[1]) || !Number.isFinite(value[2])) {
                                AL.currentCtx.err = 40963;
                                return
                            }
                            listener.velocity[0] = value[0];
                            listener.velocity[1] = value[1];
                            listener.velocity[2] = value[2];
                            AL.updateListenerSpace(AL.currentCtx);
                            break;
                        case 4106:
                            if (!Number.isFinite(value) || value < 0) {
                                AL.currentCtx.err = 40963;
                                return
                            }
                            AL.currentCtx.gain.gain.value = value;
                            break;
                        case 4111:
                            if (!Number.isFinite(value[0]) || !Number.isFinite(value[1]) || !Number.isFinite(value[2]) || !Number.isFinite(value[3]) || !Number.isFinite(value[4]) || !Number.isFinite(value[5])) {
                                AL.currentCtx.err = 40963;
                                return
                            }
                            listener.direction[0] = value[0];
                            listener.direction[1] = value[1];
                            listener.direction[2] = value[2];
                            listener.up[0] = value[3];
                            listener.up[1] = value[4];
                            listener.up[2] = value[5];
                            AL.updateListenerSpace(AL.currentCtx);
                            break;
                        default:
                            AL.currentCtx.err = 40962;
                            return
                    }
                },
                getBufferParam: (funcname, bufferId, param) => {
                    if (!AL.currentCtx) {
                        return
                    }
                    var buf = AL.buffers[bufferId];
                    if (!buf || bufferId === 0) {
                        AL.currentCtx.err = 40961;
                        return
                    }
                    switch (param) {
                        case 8193:
                            return buf.frequency;
                        case 8194:
                            return buf.bytesPerSample * 8;
                        case 8195:
                            return buf.channels;
                        case 8196:
                            return buf.length * buf.bytesPerSample * buf.channels;
                        case 8213:
                            if (buf.length === 0) {
                                return [0, 0]
                            }
                            return [(buf.audioBuf._loopStart || 0) * buf.frequency, (buf.audioBuf._loopEnd || buf.length) * buf.frequency];
                        default:
                            AL.currentCtx.err = 40962;
                            return null
                    }
                },
                setBufferParam: (funcname, bufferId, param, value) => {
                    if (!AL.currentCtx) {
                        return
                    }
                    var buf = AL.buffers[bufferId];
                    if (!buf || bufferId === 0) {
                        AL.currentCtx.err = 40961;
                        return
                    }
                    if (value === null) {
                        AL.currentCtx.err = 40962;
                        return
                    }
                    switch (param) {
                        case 8196:
                            if (value !== 0) {
                                AL.currentCtx.err = 40963;
                                return
                            }
                            break;
                        case 8213:
                            if (value[0] < 0 || value[0] > buf.length || value[1] < 0 || value[1] > buf.Length || value[0] >= value[1]) {
                                AL.currentCtx.err = 40963;
                                return
                            }
                            if (buf.refCount > 0) {
                                AL.currentCtx.err = 40964;
                                return
                            }
                            if (buf.audioBuf) {
                                buf.audioBuf._loopStart = value[0] / buf.frequency;
                                buf.audioBuf._loopEnd = value[1] / buf.frequency
                            }
                            break;
                        default:
                            AL.currentCtx.err = 40962;
                            return
                    }
                },
                getSourceParam: (funcname, sourceId, param) => {
                    if (!AL.currentCtx) {
                        return null
                    }
                    var src = AL.currentCtx.sources[sourceId];
                    if (!src) {
                        AL.currentCtx.err = 40961;
                        return null
                    }
                    switch (param) {
                        case 514:
                            return src.relative;
                        case 4097:
                            return src.coneInnerAngle;
                        case 4098:
                            return src.coneOuterAngle;
                        case 4099:
                            return src.pitch;
                        case 4100:
                            return src.position;
                        case 4101:
                            return src.direction;
                        case 4102:
                            return src.velocity;
                        case 4103:
                            return src.looping;
                        case 4105:
                            if (src.type === 4136) {
                                return src.bufQueue[0].id
                            }
                            return 0;
                        case 4106:
                            return src.gain.gain.value;
                        case 4109:
                            return src.minGain;
                        case 4110:
                            return src.maxGain;
                        case 4112:
                            return src.state;
                        case 4117:
                            if (src.bufQueue.length === 1 && src.bufQueue[0].id === 0) {
                                return 0
                            }
                            return src.bufQueue.length;
                        case 4118:
                            if (src.bufQueue.length === 1 && src.bufQueue[0].id === 0 || src.looping) {
                                return 0
                            }
                            return src.bufsProcessed;
                        case 4128:
                            return src.refDistance;
                        case 4129:
                            return src.rolloffFactor;
                        case 4130:
                            return src.coneOuterGain;
                        case 4131:
                            return src.maxDistance;
                        case 4132:
                            return AL.sourceTell(src);
                        case 4133:
                            var offset = AL.sourceTell(src);
                            if (offset > 0) {
                                offset *= src.bufQueue[0].frequency
                            }
                            return offset;
                        case 4134:
                            var offset = AL.sourceTell(src);
                            if (offset > 0) {
                                offset *= src.bufQueue[0].frequency * src.bufQueue[0].bytesPerSample
                            }
                            return offset;
                        case 4135:
                            return src.type;
                        case 4628:
                            return src.spatialize;
                        case 8201:
                            var length = 0;
                            var bytesPerFrame = 0;
                            for (var i = 0; i < src.bufQueue.length; i++) {
                                length += src.bufQueue[i].length;
                                if (src.bufQueue[i].id !== 0) {
                                    bytesPerFrame = src.bufQueue[i].bytesPerSample * src.bufQueue[i].channels
                                }
                            }
                            return length * bytesPerFrame;
                        case 8202:
                            var length = 0;
                            for (var i = 0; i < src.bufQueue.length; i++) {
                                length += src.bufQueue[i].length
                            }
                            return length;
                        case 8203:
                            return AL.sourceDuration(src);
                        case 53248:
                            return src.distanceModel;
                        default:
                            AL.currentCtx.err = 40962;
                            return null
                    }
                },
                setSourceParam: (funcname, sourceId, param, value) => {
                    if (!AL.currentCtx) {
                        return
                    }
                    var src = AL.currentCtx.sources[sourceId];
                    if (!src) {
                        AL.currentCtx.err = 40961;
                        return
                    }
                    if (value === null) {
                        AL.currentCtx.err = 40962;
                        return
                    }
                    switch (param) {
                        case 514:
                            if (value === 1) {
                                src.relative = true;
                                AL.updateSourceSpace(src)
                            } else if (value === 0) {
                                src.relative = false;
                                AL.updateSourceSpace(src)
                            } else {
                                AL.currentCtx.err = 40963;
                                return
                            }
                            break;
                        case 4097:
                            if (!Number.isFinite(value)) {
                                AL.currentCtx.err = 40963;
                                return
                            }
                            src.coneInnerAngle = value;
                            if (src.panner) {
                                src.panner.coneInnerAngle = value % 360
                            }
                            break;
                        case 4098:
                            if (!Number.isFinite(value)) {
                                AL.currentCtx.err = 40963;
                                return
                            }
                            src.coneOuterAngle = value;
                            if (src.panner) {
                                src.panner.coneOuterAngle = value % 360
                            }
                            break;
                        case 4099:
                            if (!Number.isFinite(value) || value <= 0) {
                                AL.currentCtx.err = 40963;
                                return
                            }
                            if (src.pitch === value) {
                                break
                            }
                            src.pitch = value;
                            AL.updateSourceRate(src);
                            break;
                        case 4100:
                            if (!Number.isFinite(value[0]) || !Number.isFinite(value[1]) || !Number.isFinite(value[2])) {
                                AL.currentCtx.err = 40963;
                                return
                            }
                            src.position[0] = value[0];
                            src.position[1] = value[1];
                            src.position[2] = value[2];
                            AL.updateSourceSpace(src);
                            break;
                        case 4101:
                            if (!Number.isFinite(value[0]) || !Number.isFinite(value[1]) || !Number.isFinite(value[2])) {
                                AL.currentCtx.err = 40963;
                                return
                            }
                            src.direction[0] = value[0];
                            src.direction[1] = value[1];
                            src.direction[2] = value[2];
                            AL.updateSourceSpace(src);
                            break;
                        case 4102:
                            if (!Number.isFinite(value[0]) || !Number.isFinite(value[1]) || !Number.isFinite(value[2])) {
                                AL.currentCtx.err = 40963;
                                return
                            }
                            src.velocity[0] = value[0];
                            src.velocity[1] = value[1];
                            src.velocity[2] = value[2];
                            AL.updateSourceSpace(src);
                            break;
                        case 4103:
                            if (value === 1) {
                                src.looping = true;
                                AL.updateSourceTime(src);
                                if (src.type === 4136 && src.audioQueue.length > 0) {
                                    var audioSrc = src.audioQueue[0];
                                    audioSrc.loop = true;
                                    audioSrc._duration = Number.POSITIVE_INFINITY
                                }
                            } else if (value === 0) {
                                src.looping = false;
                                var currentTime = AL.updateSourceTime(src);
                                if (src.type === 4136 && src.audioQueue.length > 0) {
                                    var audioSrc = src.audioQueue[0];
                                    audioSrc.loop = false;
                                    audioSrc._duration = src.bufQueue[0].audioBuf.duration / src.playbackRate;
                                    audioSrc._startTime = currentTime - src.bufOffset / src.playbackRate
                                }
                            } else {
                                AL.currentCtx.err = 40963;
                                return
                            }
                            break;
                        case 4105:
                            if (src.state === 4114 || src.state === 4115) {
                                AL.currentCtx.err = 40964;
                                return
                            }
                            if (value === 0) {
                                for (var i in src.bufQueue) {
                                    src.bufQueue[i].refCount--
                                }
                                src.bufQueue.length = 1;
                                src.bufQueue[0] = AL.buffers[0];
                                src.bufsProcessed = 0;
                                src.type = 4144
                            } else {
                                var buf = AL.buffers[value];
                                if (!buf) {
                                    AL.currentCtx.err = 40963;
                                    return
                                }
                                for (var i in src.bufQueue) {
                                    src.bufQueue[i].refCount--
                                }
                                src.bufQueue.length = 0;
                                buf.refCount++;
                                src.bufQueue = [buf];
                                src.bufsProcessed = 0;
                                src.type = 4136
                            }
                            AL.initSourcePanner(src);
                            AL.scheduleSourceAudio(src);
                            break;
                        case 4106:
                            if (!Number.isFinite(value) || value < 0) {
                                AL.currentCtx.err = 40963;
                                return
                            }
                            src.gain.gain.value = value;
                            break;
                        case 4109:
                            if (!Number.isFinite(value) || value < 0 || value > Math.min(src.maxGain, 1)) {
                                AL.currentCtx.err = 40963;
                                return
                            }
                            src.minGain = value;
                            break;
                        case 4110:
                            if (!Number.isFinite(value) || value < Math.max(0, src.minGain) || value > 1) {
                                AL.currentCtx.err = 40963;
                                return
                            }
                            src.maxGain = value;
                            break;
                        case 4128:
                            if (!Number.isFinite(value) || value < 0) {
                                AL.currentCtx.err = 40963;
                                return
                            }
                            src.refDistance = value;
                            if (src.panner) {
                                src.panner.refDistance = value
                            }
                            break;
                        case 4129:
                            if (!Number.isFinite(value) || value < 0) {
                                AL.currentCtx.err = 40963;
                                return
                            }
                            src.rolloffFactor = value;
                            if (src.panner) {
                                src.panner.rolloffFactor = value
                            }
                            break;
                        case 4130:
                            if (!Number.isFinite(value) || value < 0 || value > 1) {
                                AL.currentCtx.err = 40963;
                                return
                            }
                            src.coneOuterGain = value;
                            if (src.panner) {
                                src.panner.coneOuterGain = value
                            }
                            break;
                        case 4131:
                            if (!Number.isFinite(value) || value < 0) {
                                AL.currentCtx.err = 40963;
                                return
                            }
                            src.maxDistance = value;
                            if (src.panner) {
                                src.panner.maxDistance = value
                            }
                            break;
                        case 4132:
                            if (value < 0 || value > AL.sourceDuration(src)) {
                                AL.currentCtx.err = 40963;
                                return
                            }
                            AL.sourceSeek(src, value);
                            break;
                        case 4133:
                            var srcLen = AL.sourceDuration(src);
                            if (srcLen > 0) {
                                var frequency;
                                for (var bufId in src.bufQueue) {
                                    if (bufId) {
                                        frequency = src.bufQueue[bufId].frequency;
                                        break
                                    }
                                }
                                value /= frequency
                            }
                            if (value < 0 || value > srcLen) {
                                AL.currentCtx.err = 40963;
                                return
                            }
                            AL.sourceSeek(src, value);
                            break;
                        case 4134:
                            var srcLen = AL.sourceDuration(src);
                            if (srcLen > 0) {
                                var bytesPerSec;
                                for (var bufId in src.bufQueue) {
                                    if (bufId) {
                                        var buf = src.bufQueue[bufId];
                                        bytesPerSec = buf.frequency * buf.bytesPerSample * buf.channels;
                                        break
                                    }
                                }
                                value /= bytesPerSec
                            }
                            if (value < 0 || value > srcLen) {
                                AL.currentCtx.err = 40963;
                                return
                            }
                            AL.sourceSeek(src, value);
                            break;
                        case 4628:
                            if (value !== 0 && value !== 1 && value !== 2) {
                                AL.currentCtx.err = 40963;
                                return
                            }
                            src.spatialize = value;
                            AL.initSourcePanner(src);
                            break;
                        case 8201:
                        case 8202:
                        case 8203:
                            AL.currentCtx.err = 40964;
                            break;
                        case 53248:
                            switch (value) {
                                case 0:
                                case 53249:
                                case 53250:
                                case 53251:
                                case 53252:
                                case 53253:
                                case 53254:
                                    src.distanceModel = value;
                                    if (AL.currentCtx.sourceDistanceModel) {
                                        AL.updateContextGlobal(AL.currentCtx)
                                    }
                                    break;
                                default:
                                    AL.currentCtx.err = 40963;
                                    return
                            }
                            break;
                        default:
                            AL.currentCtx.err = 40962;
                            return
                    }
                },
                captures: {},
                sharedCaptureAudioCtx: null,
                requireValidCaptureDevice: (deviceId, funcname) => {
                    if (deviceId === 0) {
                        AL.alcErr = 40961;
                        return null
                    }
                    var c = AL.captures[deviceId];
                    if (!c) {
                        AL.alcErr = 40961;
                        return null
                    }
                    var err = c.mediaStreamError;
                    if (err) {
                        AL.alcErr = 40961;
                        return null
                    }
                    return c
                }
            };
            var _alBuffer3f = (bufferId, param, value0, value1, value2) => {
                AL.setBufferParam("alBuffer3f", bufferId, param, null)
            };
            _alBuffer3f.sig = "viifff";
            var _alBuffer3i = (bufferId, param, value0, value1, value2) => {
                AL.setBufferParam("alBuffer3i", bufferId, param, null)
            };
            _alBuffer3i.sig = "viiiii";

            function _alBufferData(bufferId, format, pData, size, freq) {
                pData >>>= 0;
                if (!AL.currentCtx) {
                    return
                }
                var buf = AL.buffers[bufferId];
                if (!buf) {
                    AL.currentCtx.err = 40963;
                    return
                }
                if (freq <= 0) {
                    AL.currentCtx.err = 40963;
                    return
                }
                var audioBuf = null;
                try {
                    switch (format) {
                        case 4352:
                            if (size > 0) {
                                audioBuf = AL.currentCtx.audioCtx.createBuffer(1, size, freq);
                                var channel0 = audioBuf.getChannelData(0);
                                for (var i = 0; i < size; ++i) {
                                    channel0[i] = HEAPU8[pData++ >>> 0] * .0078125 - 1
                                }
                            }
                            buf.bytesPerSample = 1;
                            buf.channels = 1;
                            buf.length = size;
                            break;
                        case 4353:
                            if (size > 0) {
                                audioBuf = AL.currentCtx.audioCtx.createBuffer(1, size >> 1, freq);
                                var channel0 = audioBuf.getChannelData(0);
                                pData >>= 1;
                                for (var i = 0; i < size >> 1; ++i) {
                                    channel0[i] = HEAP16[pData++ >>> 0] * 30517578125e-15
                                }
                            }
                            buf.bytesPerSample = 2;
                            buf.channels = 1;
                            buf.length = size >> 1;
                            break;
                        case 4354:
                            if (size > 0) {
                                audioBuf = AL.currentCtx.audioCtx.createBuffer(2, size >> 1, freq);
                                var channel0 = audioBuf.getChannelData(0);
                                var channel1 = audioBuf.getChannelData(1);
                                for (var i = 0; i < size >> 1; ++i) {
                                    channel0[i] = HEAPU8[pData++ >>> 0] * .0078125 - 1;
                                    channel1[i] = HEAPU8[pData++ >>> 0] * .0078125 - 1
                                }
                            }
                            buf.bytesPerSample = 1;
                            buf.channels = 2;
                            buf.length = size >> 1;
                            break;
                        case 4355:
                            if (size > 0) {
                                audioBuf = AL.currentCtx.audioCtx.createBuffer(2, size >> 2, freq);
                                var channel0 = audioBuf.getChannelData(0);
                                var channel1 = audioBuf.getChannelData(1);
                                pData >>= 1;
                                for (var i = 0; i < size >> 2; ++i) {
                                    channel0[i] = HEAP16[pData++ >>> 0] * 30517578125e-15;
                                    channel1[i] = HEAP16[pData++ >>> 0] * 30517578125e-15
                                }
                            }
                            buf.bytesPerSample = 2;
                            buf.channels = 2;
                            buf.length = size >> 2;
                            break;
                        case 65552:
                            if (size > 0) {
                                audioBuf = AL.currentCtx.audioCtx.createBuffer(1, size >> 2, freq);
                                var channel0 = audioBuf.getChannelData(0);
                                pData >>= 2;
                                for (var i = 0; i < size >> 2; ++i) {
                                    channel0[i] = HEAPF32[pData++ >>> 0]
                                }
                            }
                            buf.bytesPerSample = 4;
                            buf.channels = 1;
                            buf.length = size >> 2;
                            break;
                        case 65553:
                            if (size > 0) {
                                audioBuf = AL.currentCtx.audioCtx.createBuffer(2, size >> 3, freq);
                                var channel0 = audioBuf.getChannelData(0);
                                var channel1 = audioBuf.getChannelData(1);
                                pData >>= 2;
                                for (var i = 0; i < size >> 3; ++i) {
                                    channel0[i] = HEAPF32[pData++ >>> 0];
                                    channel1[i] = HEAPF32[pData++ >>> 0]
                                }
                            }
                            buf.bytesPerSample = 4;
                            buf.channels = 2;
                            buf.length = size >> 3;
                            break;
                        default:
                            AL.currentCtx.err = 40963;
                            return
                    }
                    buf.frequency = freq;
                    buf.audioBuf = audioBuf
                } catch (e) {
                    AL.currentCtx.err = 40963;
                    return
                }
            }
            _alBufferData.sig = "viipii";
            var _alBufferf = (bufferId, param, value) => {
                AL.setBufferParam("alBufferf", bufferId, param, null)
            };
            _alBufferf.sig = "viif";

            function _alBufferfv(bufferId, param, pValues) {
                pValues >>>= 0;
                if (!AL.currentCtx) {
                    return
                }
                if (!pValues) {
                    AL.currentCtx.err = 40963;
                    return
                }
                AL.setBufferParam("alBufferfv", bufferId, param, null)
            }
            _alBufferfv.sig = "viip";
            var _alBufferi = (bufferId, param, value) => {
                AL.setBufferParam("alBufferi", bufferId, param, null)
            };
            _alBufferi.sig = "viii";

            function _alBufferiv(bufferId, param, pValues) {
                pValues >>>= 0;
                if (!AL.currentCtx) {
                    return
                }
                if (!pValues) {
                    AL.currentCtx.err = 40963;
                    return
                }
                switch (param) {
                    case 8213:
                        AL.paramArray[0] = HEAP32[pValues >>> 2 >>> 0];
                        AL.paramArray[1] = HEAP32[pValues + 4 >>> 2 >>> 0];
                        AL.setBufferParam("alBufferiv", bufferId, param, AL.paramArray);
                        break;
                    default:
                        AL.setBufferParam("alBufferiv", bufferId, param, null);
                        break
                }
            }
            _alBufferiv.sig = "viip";

            function _alDeleteBuffers(count, pBufferIds) {
                pBufferIds >>>= 0;
                if (!AL.currentCtx) {
                    return
                }
                for (var i = 0; i < count; ++i) {
                    var bufId = HEAP32[pBufferIds + i * 4 >>> 2 >>> 0];
                    if (bufId === 0) {
                        continue
                    }
                    if (!AL.buffers[bufId]) {
                        AL.currentCtx.err = 40961;
                        return
                    }
                    if (AL.buffers[bufId].refCount) {
                        AL.currentCtx.err = 40964;
                        return
                    }
                }
                for (var i = 0; i < count; ++i) {
                    var bufId = HEAP32[pBufferIds + i * 4 >>> 2 >>> 0];
                    if (bufId === 0) {
                        continue
                    }
                    AL.deviceRefCounts[AL.buffers[bufId].deviceId]--;
                    delete AL.buffers[bufId];
                    AL.freeIds.push(bufId)
                }
            }
            _alDeleteBuffers.sig = "vip";
            var _alSourcei = (sourceId, param, value) => {
                switch (param) {
                    case 514:
                    case 4097:
                    case 4098:
                    case 4103:
                    case 4105:
                    case 4128:
                    case 4129:
                    case 4131:
                    case 4132:
                    case 4133:
                    case 4134:
                    case 4628:
                    case 8201:
                    case 8202:
                    case 53248:
                        AL.setSourceParam("alSourcei", sourceId, param, value);
                        break;
                    default:
                        AL.setSourceParam("alSourcei", sourceId, param, null);
                        break
                }
            };
            _alSourcei.sig = "viii";

            function _alDeleteSources(count, pSourceIds) {
                pSourceIds >>>= 0;
                if (!AL.currentCtx) {
                    return
                }
                for (var i = 0; i < count; ++i) {
                    var srcId = HEAP32[pSourceIds + i * 4 >>> 2 >>> 0];
                    if (!AL.currentCtx.sources[srcId]) {
                        AL.currentCtx.err = 40961;
                        return
                    }
                }
                for (var i = 0; i < count; ++i) {
                    var srcId = HEAP32[pSourceIds + i * 4 >>> 2 >>> 0];
                    AL.setSourceState(AL.currentCtx.sources[srcId], 4116);
                    _alSourcei(srcId, 4105, 0);
                    delete AL.currentCtx.sources[srcId];
                    AL.freeIds.push(srcId)
                }
            }
            _alDeleteSources.sig = "vip";
            var _alDisable = param => {
                if (!AL.currentCtx) {
                    return
                }
                switch (param) {
                    case 512:
                        AL.currentCtx.sourceDistanceModel = false;
                        AL.updateContextGlobal(AL.currentCtx);
                        break;
                    default:
                        AL.currentCtx.err = 40962;
                        return
                }
            };
            _alDisable.sig = "vi";
            var _alDistanceModel = model => {
                AL.setGlobalParam("alDistanceModel", 53248, model)
            };
            _alDistanceModel.sig = "vi";
            var _alDopplerFactor = value => {
                AL.setGlobalParam("alDopplerFactor", 49152, value)
            };
            _alDopplerFactor.sig = "vf";
            var _alDopplerVelocity = value => {
                warnOnce("alDopplerVelocity() is deprecated, and only kept for compatibility with OpenAL 1.0. Use alSpeedOfSound() instead.");
                if (!AL.currentCtx) {
                    return
                }
                if (value <= 0) {
                    AL.currentCtx.err = 40963;
                    return
                }
            };
            _alDopplerVelocity.sig = "vf";
            var _alEnable = param => {
                if (!AL.currentCtx) {
                    return
                }
                switch (param) {
                    case 512:
                        AL.currentCtx.sourceDistanceModel = true;
                        AL.updateContextGlobal(AL.currentCtx);
                        break;
                    default:
                        AL.currentCtx.err = 40962;
                        return
                }
            };
            _alEnable.sig = "vi";

            function _alGenBuffers(count, pBufferIds) {
                pBufferIds >>>= 0;
                if (!AL.currentCtx) {
                    return
                }
                for (var i = 0; i < count; ++i) {
                    var buf = {
                        deviceId: AL.currentCtx.deviceId,
                        id: AL.newId(),
                        refCount: 0,
                        audioBuf: null,
                        frequency: 0,
                        bytesPerSample: 2,
                        channels: 1,
                        length: 0
                    };
                    AL.deviceRefCounts[buf.deviceId]++;
                    AL.buffers[buf.id] = buf;
                    HEAP32[pBufferIds + i * 4 >>> 2 >>> 0] = buf.id
                }
            }
            _alGenBuffers.sig = "vip";

            function _alGenSources(count, pSourceIds) {
                pSourceIds >>>= 0;
                if (!AL.currentCtx) {
                    return
                }
                for (var i = 0; i < count; ++i) {
                    var gain = AL.currentCtx.audioCtx.createGain();
                    gain.connect(AL.currentCtx.gain);
                    var src = {
                        context: AL.currentCtx,
                        id: AL.newId(),
                        type: 4144,
                        state: 4113,
                        bufQueue: [AL.buffers[0]],
                        audioQueue: [],
                        looping: false,
                        pitch: 1,
                        dopplerShift: 1,
                        gain,
                        minGain: 0,
                        maxGain: 1,
                        panner: null,
                        bufsProcessed: 0,
                        bufStartTime: Number.NEGATIVE_INFINITY,
                        bufOffset: 0,
                        relative: false,
                        refDistance: 1,
                        maxDistance: 340282e33,
                        rolloffFactor: 1,
                        position: [0, 0, 0],
                        velocity: [0, 0, 0],
                        direction: [0, 0, 0],
                        coneOuterGain: 0,
                        coneInnerAngle: 360,
                        coneOuterAngle: 360,
                        distanceModel: 53250,
                        spatialize: 2,
                        get playbackRate() {
                            return this.pitch * this.dopplerShift
                        }
                    };
                    AL.currentCtx.sources[src.id] = src;
                    HEAP32[pSourceIds + i * 4 >>> 2 >>> 0] = src.id
                }
            }
            _alGenSources.sig = "vip";
            var _alGetBoolean = param => {
                var val = AL.getGlobalParam("alGetBoolean", param);
                if (val === null) {
                    return 0
                }
                switch (param) {
                    case 49152:
                    case 49155:
                    case 53248:
                        return val !== 0 ? 1 : 0;
                    default:
                        AL.currentCtx.err = 40962;
                        return 0
                }
            };
            _alGetBoolean.sig = "ii";

            function _alGetBooleanv(param, pValues) {
                pValues >>>= 0;
                var val = AL.getGlobalParam("alGetBooleanv", param);
                if (val === null || !pValues) {
                    return
                }
                switch (param) {
                    case 49152:
                    case 49155:
                    case 53248:
                        HEAP8[pValues >>> 0] = val;
                        break;
                    default:
                        AL.currentCtx.err = 40962;
                        return
                }
            }
            _alGetBooleanv.sig = "vip";

            function _alGetBuffer3f(bufferId, param, pValue0, pValue1, pValue2) {
                pValue0 >>>= 0;
                pValue1 >>>= 0;
                pValue2 >>>= 0;
                var val = AL.getBufferParam("alGetBuffer3f", bufferId, param);
                if (val === null) {
                    return
                }
                if (!pValue0 || !pValue1 || !pValue2) {
                    AL.currentCtx.err = 40963;
                    return
                }
                AL.currentCtx.err = 40962
            }
            _alGetBuffer3f.sig = "viippp";

            function _alGetBuffer3i(bufferId, param, pValue0, pValue1, pValue2) {
                pValue0 >>>= 0;
                pValue1 >>>= 0;
                pValue2 >>>= 0;
                var val = AL.getBufferParam("alGetBuffer3i", bufferId, param);
                if (val === null) {
                    return
                }
                if (!pValue0 || !pValue1 || !pValue2) {
                    AL.currentCtx.err = 40963;
                    return
                }
                AL.currentCtx.err = 40962
            }
            _alGetBuffer3i.sig = "viippp";

            function _alGetBufferf(bufferId, param, pValue) {
                pValue >>>= 0;
                var val = AL.getBufferParam("alGetBufferf", bufferId, param);
                if (val === null) {
                    return
                }
                if (!pValue) {
                    AL.currentCtx.err = 40963;
                    return
                }
                AL.currentCtx.err = 40962
            }
            _alGetBufferf.sig = "viip";

            function _alGetBufferfv(bufferId, param, pValues) {
                pValues >>>= 0;
                var val = AL.getBufferParam("alGetBufferfv", bufferId, param);
                if (val === null) {
                    return
                }
                if (!pValues) {
                    AL.currentCtx.err = 40963;
                    return
                }
                AL.currentCtx.err = 40962
            }
            _alGetBufferfv.sig = "viip";

            function _alGetBufferi(bufferId, param, pValue) {
                pValue >>>= 0;
                var val = AL.getBufferParam("alGetBufferi", bufferId, param);
                if (val === null) {
                    return
                }
                if (!pValue) {
                    AL.currentCtx.err = 40963;
                    return
                }
                switch (param) {
                    case 8193:
                    case 8194:
                    case 8195:
                    case 8196:
                        HEAP32[pValue >>> 2 >>> 0] = val;
                        break;
                    default:
                        AL.currentCtx.err = 40962;
                        return
                }
            }
            _alGetBufferi.sig = "viip";

            function _alGetBufferiv(bufferId, param, pValues) {
                pValues >>>= 0;
                var val = AL.getBufferParam("alGetBufferiv", bufferId, param);
                if (val === null) {
                    return
                }
                if (!pValues) {
                    AL.currentCtx.err = 40963;
                    return
                }
                switch (param) {
                    case 8193:
                    case 8194:
                    case 8195:
                    case 8196:
                        HEAP32[pValues >>> 2 >>> 0] = val;
                        break;
                    case 8213:
                        HEAP32[pValues >>> 2 >>> 0] = val[0];
                        HEAP32[pValues + 4 >>> 2 >>> 0] = val[1];
                        break;
                    default:
                        AL.currentCtx.err = 40962;
                        return
                }
            }
            _alGetBufferiv.sig = "viip";
            var _alGetDouble = param => {
                var val = AL.getGlobalParam("alGetDouble", param);
                if (val === null) {
                    return 0
                }
                switch (param) {
                    case 49152:
                    case 49155:
                    case 53248:
                        return val;
                    default:
                        AL.currentCtx.err = 40962;
                        return 0
                }
            };
            _alGetDouble.sig = "di";

            function _alGetDoublev(param, pValues) {
                pValues >>>= 0;
                var val = AL.getGlobalParam("alGetDoublev", param);
                if (val === null || !pValues) {
                    return
                }
                switch (param) {
                    case 49152:
                    case 49155:
                    case 53248:
                        HEAPF64[pValues >>> 3 >>> 0] = val;
                        break;
                    default:
                        AL.currentCtx.err = 40962;
                        return
                }
            }
            _alGetDoublev.sig = "vip";

            function _alGetEnumValue(pEnumName) {
                pEnumName >>>= 0;
                if (!AL.currentCtx) {
                    return 0
                }
                if (!pEnumName) {
                    AL.currentCtx.err = 40963;
                    return 0
                }
                var name = UTF8ToString(pEnumName);
                switch (name) {
                    case "AL_BITS":
                        return 8194;
                    case "AL_BUFFER":
                        return 4105;
                    case "AL_BUFFERS_PROCESSED":
                        return 4118;
                    case "AL_BUFFERS_QUEUED":
                        return 4117;
                    case "AL_BYTE_OFFSET":
                        return 4134;
                    case "AL_CHANNELS":
                        return 8195;
                    case "AL_CONE_INNER_ANGLE":
                        return 4097;
                    case "AL_CONE_OUTER_ANGLE":
                        return 4098;
                    case "AL_CONE_OUTER_GAIN":
                        return 4130;
                    case "AL_DIRECTION":
                        return 4101;
                    case "AL_DISTANCE_MODEL":
                        return 53248;
                    case "AL_DOPPLER_FACTOR":
                        return 49152;
                    case "AL_DOPPLER_VELOCITY":
                        return 49153;
                    case "AL_EXPONENT_DISTANCE":
                        return 53253;
                    case "AL_EXPONENT_DISTANCE_CLAMPED":
                        return 53254;
                    case "AL_EXTENSIONS":
                        return 45060;
                    case "AL_FORMAT_MONO16":
                        return 4353;
                    case "AL_FORMAT_MONO8":
                        return 4352;
                    case "AL_FORMAT_STEREO16":
                        return 4355;
                    case "AL_FORMAT_STEREO8":
                        return 4354;
                    case "AL_FREQUENCY":
                        return 8193;
                    case "AL_GAIN":
                        return 4106;
                    case "AL_INITIAL":
                        return 4113;
                    case "AL_INVALID":
                        return -1;
                    case "AL_ILLEGAL_ENUM":
                    case "AL_INVALID_ENUM":
                        return 40962;
                    case "AL_INVALID_NAME":
                        return 40961;
                    case "AL_ILLEGAL_COMMAND":
                    case "AL_INVALID_OPERATION":
                        return 40964;
                    case "AL_INVALID_VALUE":
                        return 40963;
                    case "AL_INVERSE_DISTANCE":
                        return 53249;
                    case "AL_INVERSE_DISTANCE_CLAMPED":
                        return 53250;
                    case "AL_LINEAR_DISTANCE":
                        return 53251;
                    case "AL_LINEAR_DISTANCE_CLAMPED":
                        return 53252;
                    case "AL_LOOPING":
                        return 4103;
                    case "AL_MAX_DISTANCE":
                        return 4131;
                    case "AL_MAX_GAIN":
                        return 4110;
                    case "AL_MIN_GAIN":
                        return 4109;
                    case "AL_NONE":
                        return 0;
                    case "AL_NO_ERROR":
                        return 0;
                    case "AL_ORIENTATION":
                        return 4111;
                    case "AL_OUT_OF_MEMORY":
                        return 40965;
                    case "AL_PAUSED":
                        return 4115;
                    case "AL_PENDING":
                        return 8209;
                    case "AL_PITCH":
                        return 4099;
                    case "AL_PLAYING":
                        return 4114;
                    case "AL_POSITION":
                        return 4100;
                    case "AL_PROCESSED":
                        return 8210;
                    case "AL_REFERENCE_DISTANCE":
                        return 4128;
                    case "AL_RENDERER":
                        return 45059;
                    case "AL_ROLLOFF_FACTOR":
                        return 4129;
                    case "AL_SAMPLE_OFFSET":
                        return 4133;
                    case "AL_SEC_OFFSET":
                        return 4132;
                    case "AL_SIZE":
                        return 8196;
                    case "AL_SOURCE_RELATIVE":
                        return 514;
                    case "AL_SOURCE_STATE":
                        return 4112;
                    case "AL_SOURCE_TYPE":
                        return 4135;
                    case "AL_SPEED_OF_SOUND":
                        return 49155;
                    case "AL_STATIC":
                        return 4136;
                    case "AL_STOPPED":
                        return 4116;
                    case "AL_STREAMING":
                        return 4137;
                    case "AL_UNDETERMINED":
                        return 4144;
                    case "AL_UNUSED":
                        return 8208;
                    case "AL_VELOCITY":
                        return 4102;
                    case "AL_VENDOR":
                        return 45057;
                    case "AL_VERSION":
                        return 45058;
                    case "AL_AUTO_SOFT":
                        return 2;
                    case "AL_SOURCE_DISTANCE_MODEL":
                        return 512;
                    case "AL_SOURCE_SPATIALIZE_SOFT":
                        return 4628;
                    case "AL_LOOP_POINTS_SOFT":
                        return 8213;
                    case "AL_BYTE_LENGTH_SOFT":
                        return 8201;
                    case "AL_SAMPLE_LENGTH_SOFT":
                        return 8202;
                    case "AL_SEC_LENGTH_SOFT":
                        return 8203;
                    case "AL_FORMAT_MONO_FLOAT32":
                        return 65552;
                    case "AL_FORMAT_STEREO_FLOAT32":
                        return 65553;
                    default:
                        AL.currentCtx.err = 40963;
                        return 0
                }
            }
            _alGetEnumValue.sig = "ip";
            var _alGetError = () => {
                if (!AL.currentCtx) {
                    return 40964
                }
                var err = AL.currentCtx.err;
                AL.currentCtx.err = 0;
                return err
            };
            _alGetError.sig = "i";
            var _alGetFloat = param => {
                var val = AL.getGlobalParam("alGetFloat", param);
                if (val === null) {
                    return 0
                }
                switch (param) {
                    case 49152:
                    case 49155:
                    case 53248:
                        return val;
                    default:
                        return 0
                }
            };
            _alGetFloat.sig = "fi";

            function _alGetFloatv(param, pValues) {
                pValues >>>= 0;
                var val = AL.getGlobalParam("alGetFloatv", param);
                if (val === null || !pValues) {
                    return
                }
                switch (param) {
                    case 49152:
                    case 49155:
                    case 53248:
                        HEAPF32[pValues >>> 2 >>> 0] = val;
                        break;
                    default:
                        AL.currentCtx.err = 40962;
                        return
                }
            }
            _alGetFloatv.sig = "vip";
            var _alGetInteger = param => {
                var val = AL.getGlobalParam("alGetInteger", param);
                if (val === null) {
                    return 0
                }
                switch (param) {
                    case 49152:
                    case 49155:
                    case 53248:
                        return val;
                    default:
                        AL.currentCtx.err = 40962;
                        return 0
                }
            };
            _alGetInteger.sig = "ii";

            function _alGetIntegerv(param, pValues) {
                pValues >>>= 0;
                var val = AL.getGlobalParam("alGetIntegerv", param);
                if (val === null || !pValues) {
                    return
                }
                switch (param) {
                    case 49152:
                    case 49155:
                    case 53248:
                        HEAP32[pValues >>> 2 >>> 0] = val;
                        break;
                    default:
                        AL.currentCtx.err = 40962;
                        return
                }
            }
            _alGetIntegerv.sig = "vip";

            function _alGetListener3f(param, pValue0, pValue1, pValue2) {
                pValue0 >>>= 0;
                pValue1 >>>= 0;
                pValue2 >>>= 0;
                var val = AL.getListenerParam("alGetListener3f", param);
                if (val === null) {
                    return
                }
                if (!pValue0 || !pValue1 || !pValue2) {
                    AL.currentCtx.err = 40963;
                    return
                }
                switch (param) {
                    case 4100:
                    case 4102:
                        HEAPF32[pValue0 >>> 2 >>> 0] = val[0];
                        HEAPF32[pValue1 >>> 2 >>> 0] = val[1];
                        HEAPF32[pValue2 >>> 2 >>> 0] = val[2];
                        break;
                    default:
                        AL.currentCtx.err = 40962;
                        return
                }
            }
            _alGetListener3f.sig = "vippp";

            function _alGetListener3i(param, pValue0, pValue1, pValue2) {
                pValue0 >>>= 0;
                pValue1 >>>= 0;
                pValue2 >>>= 0;
                var val = AL.getListenerParam("alGetListener3i", param);
                if (val === null) {
                    return
                }
                if (!pValue0 || !pValue1 || !pValue2) {
                    AL.currentCtx.err = 40963;
                    return
                }
                switch (param) {
                    case 4100:
                    case 4102:
                        HEAP32[pValue0 >>> 2 >>> 0] = val[0];
                        HEAP32[pValue1 >>> 2 >>> 0] = val[1];
                        HEAP32[pValue2 >>> 2 >>> 0] = val[2];
                        break;
                    default:
                        AL.currentCtx.err = 40962;
                        return
                }
            }
            _alGetListener3i.sig = "vippp";

            function _alGetListenerf(param, pValue) {
                pValue >>>= 0;
                var val = AL.getListenerParam("alGetListenerf", param);
                if (val === null) {
                    return
                }
                if (!pValue) {
                    AL.currentCtx.err = 40963;
                    return
                }
                switch (param) {
                    case 4106:
                        HEAPF32[pValue >>> 2 >>> 0] = val;
                        break;
                    default:
                        AL.currentCtx.err = 40962;
                        return
                }
            }
            _alGetListenerf.sig = "vip";

            function _alGetListenerfv(param, pValues) {
                pValues >>>= 0;
                var val = AL.getListenerParam("alGetListenerfv", param);
                if (val === null) {
                    return
                }
                if (!pValues) {
                    AL.currentCtx.err = 40963;
                    return
                }
                switch (param) {
                    case 4100:
                    case 4102:
                        HEAPF32[pValues >>> 2 >>> 0] = val[0];
                        HEAPF32[pValues + 4 >>> 2 >>> 0] = val[1];
                        HEAPF32[pValues + 8 >>> 2 >>> 0] = val[2];
                        break;
                    case 4111:
                        HEAPF32[pValues >>> 2 >>> 0] = val[0];
                        HEAPF32[pValues + 4 >>> 2 >>> 0] = val[1];
                        HEAPF32[pValues + 8 >>> 2 >>> 0] = val[2];
                        HEAPF32[pValues + 12 >>> 2 >>> 0] = val[3];
                        HEAPF32[pValues + 16 >>> 2 >>> 0] = val[4];
                        HEAPF32[pValues + 20 >>> 2 >>> 0] = val[5];
                        break;
                    default:
                        AL.currentCtx.err = 40962;
                        return
                }
            }
            _alGetListenerfv.sig = "vip";

            function _alGetListeneri(param, pValue) {
                pValue >>>= 0;
                var val = AL.getListenerParam("alGetListeneri", param);
                if (val === null) {
                    return
                }
                if (!pValue) {
                    AL.currentCtx.err = 40963;
                    return
                }
                AL.currentCtx.err = 40962
            }
            _alGetListeneri.sig = "vip";

            function _alGetListeneriv(param, pValues) {
                pValues >>>= 0;
                var val = AL.getListenerParam("alGetListeneriv", param);
                if (val === null) {
                    return
                }
                if (!pValues) {
                    AL.currentCtx.err = 40963;
                    return
                }
                switch (param) {
                    case 4100:
                    case 4102:
                        HEAP32[pValues >>> 2 >>> 0] = val[0];
                        HEAP32[pValues + 4 >>> 2 >>> 0] = val[1];
                        HEAP32[pValues + 8 >>> 2 >>> 0] = val[2];
                        break;
                    case 4111:
                        HEAP32[pValues >>> 2 >>> 0] = val[0];
                        HEAP32[pValues + 4 >>> 2 >>> 0] = val[1];
                        HEAP32[pValues + 8 >>> 2 >>> 0] = val[2];
                        HEAP32[pValues + 12 >>> 2 >>> 0] = val[3];
                        HEAP32[pValues + 16 >>> 2 >>> 0] = val[4];
                        HEAP32[pValues + 20 >>> 2 >>> 0] = val[5];
                        break;
                    default:
                        AL.currentCtx.err = 40962;
                        return
                }
            }
            _alGetListeneriv.sig = "vip";

            function _alGetSource3f(sourceId, param, pValue0, pValue1, pValue2) {
                pValue0 >>>= 0;
                pValue1 >>>= 0;
                pValue2 >>>= 0;
                var val = AL.getSourceParam("alGetSource3f", sourceId, param);
                if (val === null) {
                    return
                }
                if (!pValue0 || !pValue1 || !pValue2) {
                    AL.currentCtx.err = 40963;
                    return
                }
                switch (param) {
                    case 4100:
                    case 4101:
                    case 4102:
                        HEAPF32[pValue0 >>> 2 >>> 0] = val[0];
                        HEAPF32[pValue1 >>> 2 >>> 0] = val[1];
                        HEAPF32[pValue2 >>> 2 >>> 0] = val[2];
                        break;
                    default:
                        AL.currentCtx.err = 40962;
                        return
                }
            }
            _alGetSource3f.sig = "viippp";

            function _alGetSource3i(sourceId, param, pValue0, pValue1, pValue2) {
                pValue0 >>>= 0;
                pValue1 >>>= 0;
                pValue2 >>>= 0;
                var val = AL.getSourceParam("alGetSource3i", sourceId, param);
                if (val === null) {
                    return
                }
                if (!pValue0 || !pValue1 || !pValue2) {
                    AL.currentCtx.err = 40963;
                    return
                }
                switch (param) {
                    case 4100:
                    case 4101:
                    case 4102:
                        HEAP32[pValue0 >>> 2 >>> 0] = val[0];
                        HEAP32[pValue1 >>> 2 >>> 0] = val[1];
                        HEAP32[pValue2 >>> 2 >>> 0] = val[2];
                        break;
                    default:
                        AL.currentCtx.err = 40962;
                        return
                }
            }
            _alGetSource3i.sig = "viippp";

            function _alGetSourcef(sourceId, param, pValue) {
                pValue >>>= 0;
                var val = AL.getSourceParam("alGetSourcef", sourceId, param);
                if (val === null) {
                    return
                }
                if (!pValue) {
                    AL.currentCtx.err = 40963;
                    return
                }
                switch (param) {
                    case 4097:
                    case 4098:
                    case 4099:
                    case 4106:
                    case 4109:
                    case 4110:
                    case 4128:
                    case 4129:
                    case 4130:
                    case 4131:
                    case 4132:
                    case 4133:
                    case 4134:
                    case 8203:
                        HEAPF32[pValue >>> 2 >>> 0] = val;
                        break;
                    default:
                        AL.currentCtx.err = 40962;
                        return
                }
            }
            _alGetSourcef.sig = "viip";

            function _alGetSourcefv(sourceId, param, pValues) {
                pValues >>>= 0;
                var val = AL.getSourceParam("alGetSourcefv", sourceId, param);
                if (val === null) {
                    return
                }
                if (!pValues) {
                    AL.currentCtx.err = 40963;
                    return
                }
                switch (param) {
                    case 4097:
                    case 4098:
                    case 4099:
                    case 4106:
                    case 4109:
                    case 4110:
                    case 4128:
                    case 4129:
                    case 4130:
                    case 4131:
                    case 4132:
                    case 4133:
                    case 4134:
                    case 8203:
                        HEAPF32[pValues >>> 2 >>> 0] = val[0];
                        break;
                    case 4100:
                    case 4101:
                    case 4102:
                        HEAPF32[pValues >>> 2 >>> 0] = val[0];
                        HEAPF32[pValues + 4 >>> 2 >>> 0] = val[1];
                        HEAPF32[pValues + 8 >>> 2 >>> 0] = val[2];
                        break;
                    default:
                        AL.currentCtx.err = 40962;
                        return
                }
            }
            _alGetSourcefv.sig = "viip";

            function _alGetSourcei(sourceId, param, pValue) {
                pValue >>>= 0;
                var val = AL.getSourceParam("alGetSourcei", sourceId, param);
                if (val === null) {
                    return
                }
                if (!pValue) {
                    AL.currentCtx.err = 40963;
                    return
                }
                switch (param) {
                    case 514:
                    case 4097:
                    case 4098:
                    case 4103:
                    case 4105:
                    case 4112:
                    case 4117:
                    case 4118:
                    case 4128:
                    case 4129:
                    case 4131:
                    case 4132:
                    case 4133:
                    case 4134:
                    case 4135:
                    case 4628:
                    case 8201:
                    case 8202:
                    case 53248:
                        HEAP32[pValue >>> 2 >>> 0] = val;
                        break;
                    default:
                        AL.currentCtx.err = 40962;
                        return
                }
            }
            _alGetSourcei.sig = "viip";

            function _alGetSourceiv(sourceId, param, pValues) {
                pValues >>>= 0;
                var val = AL.getSourceParam("alGetSourceiv", sourceId, param);
                if (val === null) {
                    return
                }
                if (!pValues) {
                    AL.currentCtx.err = 40963;
                    return
                }
                switch (param) {
                    case 514:
                    case 4097:
                    case 4098:
                    case 4103:
                    case 4105:
                    case 4112:
                    case 4117:
                    case 4118:
                    case 4128:
                    case 4129:
                    case 4131:
                    case 4132:
                    case 4133:
                    case 4134:
                    case 4135:
                    case 4628:
                    case 8201:
                    case 8202:
                    case 53248:
                        HEAP32[pValues >>> 2 >>> 0] = val;
                        break;
                    case 4100:
                    case 4101:
                    case 4102:
                        HEAP32[pValues >>> 2 >>> 0] = val[0];
                        HEAP32[pValues + 4 >>> 2 >>> 0] = val[1];
                        HEAP32[pValues + 8 >>> 2 >>> 0] = val[2];
                        break;
                    default:
                        AL.currentCtx.err = 40962;
                        return
                }
            }
            _alGetSourceiv.sig = "viip";
            var stringToNewUTF8 = str => {
                var size = lengthBytesUTF8(str) + 1;
                var ret = _malloc(size);
                if (ret) stringToUTF8(str, ret, size);
                return ret
            };

            function _alGetString(param) {
                if (AL.stringCache[param]) {
                    return AL.stringCache[param]
                }
                var ret;
                switch (param) {
                    case 0:
                        ret = "No Error";
                        break;
                    case 40961:
                        ret = "Invalid Name";
                        break;
                    case 40962:
                        ret = "Invalid Enum";
                        break;
                    case 40963:
                        ret = "Invalid Value";
                        break;
                    case 40964:
                        ret = "Invalid Operation";
                        break;
                    case 40965:
                        ret = "Out of Memory";
                        break;
                    case 45057:
                        ret = "Emscripten";
                        break;
                    case 45058:
                        ret = "1.1";
                        break;
                    case 45059:
                        ret = "WebAudio";
                        break;
                    case 45060:
                        ret = Object.keys(AL.AL_EXTENSIONS).join(" ");
                        break;
                    default:
                        if (AL.currentCtx) {
                            AL.currentCtx.err = 40962
                        } else {}
                        return 0
                }
                ret = stringToNewUTF8(ret);
                AL.stringCache[param] = ret;
                return ret
            }
            _alGetString.sig = "pi";
            var _alIsBuffer = bufferId => {
                if (!AL.currentCtx) {
                    return false
                }
                if (bufferId > AL.buffers.length) {
                    return false
                }
                if (!AL.buffers[bufferId]) {
                    return false
                }
                return true
            };
            _alIsBuffer.sig = "ii";
            var _alIsEnabled = param => {
                if (!AL.currentCtx) {
                    return 0
                }
                switch (param) {
                    case 512:
                        return AL.currentCtx.sourceDistanceModel ? 0 : 1;
                    default:
                        AL.currentCtx.err = 40962;
                        return 0
                }
            };
            _alIsEnabled.sig = "ii";

            function _alIsExtensionPresent(pExtName) {
                pExtName >>>= 0;
                var name = UTF8ToString(pExtName);
                return AL.AL_EXTENSIONS[name] ? 1 : 0
            }
            _alIsExtensionPresent.sig = "ip";
            var _alIsSource = sourceId => {
                if (!AL.currentCtx) {
                    return false
                }
                if (!AL.currentCtx.sources[sourceId]) {
                    return false
                }
                return true
            };
            _alIsSource.sig = "ii";
            var _alListener3f = (param, value0, value1, value2) => {
                switch (param) {
                    case 4100:
                    case 4102:
                        AL.paramArray[0] = value0;
                        AL.paramArray[1] = value1;
                        AL.paramArray[2] = value2;
                        AL.setListenerParam("alListener3f", param, AL.paramArray);
                        break;
                    default:
                        AL.setListenerParam("alListener3f", param, null);
                        break
                }
            };
            _alListener3f.sig = "vifff";
            var _alListener3i = (param, value0, value1, value2) => {
                switch (param) {
                    case 4100:
                    case 4102:
                        AL.paramArray[0] = value0;
                        AL.paramArray[1] = value1;
                        AL.paramArray[2] = value2;
                        AL.setListenerParam("alListener3i", param, AL.paramArray);
                        break;
                    default:
                        AL.setListenerParam("alListener3i", param, null);
                        break
                }
            };
            _alListener3i.sig = "viiii";
            var _alListenerf = (param, value) => {
                switch (param) {
                    case 4106:
                        AL.setListenerParam("alListenerf", param, value);
                        break;
                    default:
                        AL.setListenerParam("alListenerf", param, null);
                        break
                }
            };
            _alListenerf.sig = "vif";

            function _alListenerfv(param, pValues) {
                pValues >>>= 0;
                if (!AL.currentCtx) {
                    return
                }
                if (!pValues) {
                    AL.currentCtx.err = 40963;
                    return
                }
                switch (param) {
                    case 4100:
                    case 4102:
                        AL.paramArray[0] = HEAPF32[pValues >>> 2 >>> 0];
                        AL.paramArray[1] = HEAPF32[pValues + 4 >>> 2 >>> 0];
                        AL.paramArray[2] = HEAPF32[pValues + 8 >>> 2 >>> 0];
                        AL.setListenerParam("alListenerfv", param, AL.paramArray);
                        break;
                    case 4111:
                        AL.paramArray[0] = HEAPF32[pValues >>> 2 >>> 0];
                        AL.paramArray[1] = HEAPF32[pValues + 4 >>> 2 >>> 0];
                        AL.paramArray[2] = HEAPF32[pValues + 8 >>> 2 >>> 0];
                        AL.paramArray[3] = HEAPF32[pValues + 12 >>> 2 >>> 0];
                        AL.paramArray[4] = HEAPF32[pValues + 16 >>> 2 >>> 0];
                        AL.paramArray[5] = HEAPF32[pValues + 20 >>> 2 >>> 0];
                        AL.setListenerParam("alListenerfv", param, AL.paramArray);
                        break;
                    default:
                        AL.setListenerParam("alListenerfv", param, null);
                        break
                }
            }
            _alListenerfv.sig = "vip";
            var _alListeneri = (param, value) => {
                AL.setListenerParam("alListeneri", param, null)
            };
            _alListeneri.sig = "vii";

            function _alListeneriv(param, pValues) {
                pValues >>>= 0;
                if (!AL.currentCtx) {
                    return
                }
                if (!pValues) {
                    AL.currentCtx.err = 40963;
                    return
                }
                switch (param) {
                    case 4100:
                    case 4102:
                        AL.paramArray[0] = HEAP32[pValues >>> 2 >>> 0];
                        AL.paramArray[1] = HEAP32[pValues + 4 >>> 2 >>> 0];
                        AL.paramArray[2] = HEAP32[pValues + 8 >>> 2 >>> 0];
                        AL.setListenerParam("alListeneriv", param, AL.paramArray);
                        break;
                    case 4111:
                        AL.paramArray[0] = HEAP32[pValues >>> 2 >>> 0];
                        AL.paramArray[1] = HEAP32[pValues + 4 >>> 2 >>> 0];
                        AL.paramArray[2] = HEAP32[pValues + 8 >>> 2 >>> 0];
                        AL.paramArray[3] = HEAP32[pValues + 12 >>> 2 >>> 0];
                        AL.paramArray[4] = HEAP32[pValues + 16 >>> 2 >>> 0];
                        AL.paramArray[5] = HEAP32[pValues + 20 >>> 2 >>> 0];
                        AL.setListenerParam("alListeneriv", param, AL.paramArray);
                        break;
                    default:
                        AL.setListenerParam("alListeneriv", param, null);
                        break
                }
            }
            _alListeneriv.sig = "vip";
            var _alSource3f = (sourceId, param, value0, value1, value2) => {
                switch (param) {
                    case 4100:
                    case 4101:
                    case 4102:
                        AL.paramArray[0] = value0;
                        AL.paramArray[1] = value1;
                        AL.paramArray[2] = value2;
                        AL.setSourceParam("alSource3f", sourceId, param, AL.paramArray);
                        break;
                    default:
                        AL.setSourceParam("alSource3f", sourceId, param, null);
                        break
                }
            };
            _alSource3f.sig = "viifff";
            var _alSource3i = (sourceId, param, value0, value1, value2) => {
                switch (param) {
                    case 4100:
                    case 4101:
                    case 4102:
                        AL.paramArray[0] = value0;
                        AL.paramArray[1] = value1;
                        AL.paramArray[2] = value2;
                        AL.setSourceParam("alSource3i", sourceId, param, AL.paramArray);
                        break;
                    default:
                        AL.setSourceParam("alSource3i", sourceId, param, null);
                        break
                }
            };
            _alSource3i.sig = "viiiii";
            var _alSourcePause = sourceId => {
                if (!AL.currentCtx) {
                    return
                }
                var src = AL.currentCtx.sources[sourceId];
                if (!src) {
                    AL.currentCtx.err = 40961;
                    return
                }
                AL.setSourceState(src, 4115)
            };
            _alSourcePause.sig = "vi";

            function _alSourcePausev(count, pSourceIds) {
                pSourceIds >>>= 0;
                if (!AL.currentCtx) {
                    return
                }
                if (!pSourceIds) {
                    AL.currentCtx.err = 40963
                }
                for (var i = 0; i < count; ++i) {
                    if (!AL.currentCtx.sources[HEAP32[pSourceIds + i * 4 >>> 2 >>> 0]]) {
                        AL.currentCtx.err = 40961;
                        return
                    }
                }
                for (var i = 0; i < count; ++i) {
                    var srcId = HEAP32[pSourceIds + i * 4 >>> 2 >>> 0];
                    AL.setSourceState(AL.currentCtx.sources[srcId], 4115)
                }
            }
            _alSourcePausev.sig = "vip";
            var _alSourcePlay = sourceId => {
                if (!AL.currentCtx) {
                    return
                }
                var src = AL.currentCtx.sources[sourceId];
                if (!src) {
                    AL.currentCtx.err = 40961;
                    return
                }
                AL.setSourceState(src, 4114)
            };
            _alSourcePlay.sig = "vi";

            function _alSourcePlayv(count, pSourceIds) {
                pSourceIds >>>= 0;
                if (!AL.currentCtx) {
                    return
                }
                if (!pSourceIds) {
                    AL.currentCtx.err = 40963
                }
                for (var i = 0; i < count; ++i) {
                    if (!AL.currentCtx.sources[HEAP32[pSourceIds + i * 4 >>> 2 >>> 0]]) {
                        AL.currentCtx.err = 40961;
                        return
                    }
                }
                for (var i = 0; i < count; ++i) {
                    var srcId = HEAP32[pSourceIds + i * 4 >>> 2 >>> 0];
                    AL.setSourceState(AL.currentCtx.sources[srcId], 4114)
                }
            }
            _alSourcePlayv.sig = "vip";

            function _alSourceQueueBuffers(sourceId, count, pBufferIds) {
                pBufferIds >>>= 0;
                if (!AL.currentCtx) {
                    return
                }
                var src = AL.currentCtx.sources[sourceId];
                if (!src) {
                    AL.currentCtx.err = 40961;
                    return
                }
                if (src.type === 4136) {
                    AL.currentCtx.err = 40964;
                    return
                }
                if (count === 0) {
                    return
                }
                var templateBuf = AL.buffers[0];
                for (var i = 0; i < src.bufQueue.length; i++) {
                    if (src.bufQueue[i].id !== 0) {
                        templateBuf = src.bufQueue[i];
                        break
                    }
                }
                for (var i = 0; i < count; ++i) {
                    var bufId = HEAP32[pBufferIds + i * 4 >>> 2 >>> 0];
                    var buf = AL.buffers[bufId];
                    if (!buf) {
                        AL.currentCtx.err = 40961;
                        return
                    }
                    if (templateBuf.id !== 0 && (buf.frequency !== templateBuf.frequency || buf.bytesPerSample !== templateBuf.bytesPerSample || buf.channels !== templateBuf.channels)) {
                        AL.currentCtx.err = 40964
                    }
                }
                if (src.bufQueue.length === 1 && src.bufQueue[0].id === 0) {
                    src.bufQueue.length = 0
                }
                src.type = 4137;
                for (var i = 0; i < count; ++i) {
                    var bufId = HEAP32[pBufferIds + i * 4 >>> 2 >>> 0];
                    var buf = AL.buffers[bufId];
                    buf.refCount++;
                    src.bufQueue.push(buf)
                }
                if (src.looping) {
                    AL.cancelPendingSourceAudio(src)
                }
                AL.initSourcePanner(src);
                AL.scheduleSourceAudio(src)
            }
            _alSourceQueueBuffers.sig = "viip";
            var _alSourceRewind = sourceId => {
                if (!AL.currentCtx) {
                    return
                }
                var src = AL.currentCtx.sources[sourceId];
                if (!src) {
                    AL.currentCtx.err = 40961;
                    return
                }
                AL.setSourceState(src, 4116);
                AL.setSourceState(src, 4113)
            };
            _alSourceRewind.sig = "vi";

            function _alSourceRewindv(count, pSourceIds) {
                pSourceIds >>>= 0;
                if (!AL.currentCtx) {
                    return
                }
                if (!pSourceIds) {
                    AL.currentCtx.err = 40963
                }
                for (var i = 0; i < count; ++i) {
                    if (!AL.currentCtx.sources[HEAP32[pSourceIds + i * 4 >>> 2 >>> 0]]) {
                        AL.currentCtx.err = 40961;
                        return
                    }
                }
                for (var i = 0; i < count; ++i) {
                    var srcId = HEAP32[pSourceIds + i * 4 >>> 2 >>> 0];
                    AL.setSourceState(AL.currentCtx.sources[srcId], 4113)
                }
            }
            _alSourceRewindv.sig = "vip";
            var _alSourceStop = sourceId => {
                if (!AL.currentCtx) {
                    return
                }
                var src = AL.currentCtx.sources[sourceId];
                if (!src) {
                    AL.currentCtx.err = 40961;
                    return
                }
                AL.setSourceState(src, 4116)
            };
            _alSourceStop.sig = "vi";

            function _alSourceStopv(count, pSourceIds) {
                pSourceIds >>>= 0;
                if (!AL.currentCtx) {
                    return
                }
                if (!pSourceIds) {
                    AL.currentCtx.err = 40963
                }
                for (var i = 0; i < count; ++i) {
                    if (!AL.currentCtx.sources[HEAP32[pSourceIds + i * 4 >>> 2 >>> 0]]) {
                        AL.currentCtx.err = 40961;
                        return
                    }
                }
                for (var i = 0; i < count; ++i) {
                    var srcId = HEAP32[pSourceIds + i * 4 >>> 2 >>> 0];
                    AL.setSourceState(AL.currentCtx.sources[srcId], 4116)
                }
            }
            _alSourceStopv.sig = "vip";

            function _alSourceUnqueueBuffers(sourceId, count, pBufferIds) {
                pBufferIds >>>= 0;
                if (!AL.currentCtx) {
                    return
                }
                var src = AL.currentCtx.sources[sourceId];
                if (!src) {
                    AL.currentCtx.err = 40961;
                    return
                }
                if (count > (src.bufQueue.length === 1 && src.bufQueue[0].id === 0 ? 0 : src.bufsProcessed)) {
                    AL.currentCtx.err = 40963;
                    return
                }
                if (count === 0) {
                    return
                }
                for (var i = 0; i < count; i++) {
                    var buf = src.bufQueue.shift();
                    buf.refCount--;
                    HEAP32[pBufferIds + i * 4 >>> 2 >>> 0] = buf.id;
                    src.bufsProcessed--
                }
                if (src.bufQueue.length === 0) {
                    src.bufQueue.push(AL.buffers[0])
                }
                AL.initSourcePanner(src);
                AL.scheduleSourceAudio(src)
            }
            _alSourceUnqueueBuffers.sig = "viip";
            var _alSourcef = (sourceId, param, value) => {
                switch (param) {
                    case 4097:
                    case 4098:
                    case 4099:
                    case 4106:
                    case 4109:
                    case 4110:
                    case 4128:
                    case 4129:
                    case 4130:
                    case 4131:
                    case 4132:
                    case 4133:
                    case 4134:
                    case 8203:
                        AL.setSourceParam("alSourcef", sourceId, param, value);
                        break;
                    default:
                        AL.setSourceParam("alSourcef", sourceId, param, null);
                        break
                }
            };
            _alSourcef.sig = "viif";

            function _alSourcefv(sourceId, param, pValues) {
                pValues >>>= 0;
                if (!AL.currentCtx) {
                    return
                }
                if (!pValues) {
                    AL.currentCtx.err = 40963;
                    return
                }
                switch (param) {
                    case 4097:
                    case 4098:
                    case 4099:
                    case 4106:
                    case 4109:
                    case 4110:
                    case 4128:
                    case 4129:
                    case 4130:
                    case 4131:
                    case 4132:
                    case 4133:
                    case 4134:
                    case 8203:
                        var val = HEAPF32[pValues >>> 2 >>> 0];
                        AL.setSourceParam("alSourcefv", sourceId, param, val);
                        break;
                    case 4100:
                    case 4101:
                    case 4102:
                        AL.paramArray[0] = HEAPF32[pValues >>> 2 >>> 0];
                        AL.paramArray[1] = HEAPF32[pValues + 4 >>> 2 >>> 0];
                        AL.paramArray[2] = HEAPF32[pValues + 8 >>> 2 >>> 0];
                        AL.setSourceParam("alSourcefv", sourceId, param, AL.paramArray);
                        break;
                    default:
                        AL.setSourceParam("alSourcefv", sourceId, param, null);
                        break
                }
            }
            _alSourcefv.sig = "viip";

            function _alSourceiv(sourceId, param, pValues) {
                pValues >>>= 0;
                if (!AL.currentCtx) {
                    return
                }
                if (!pValues) {
                    AL.currentCtx.err = 40963;
                    return
                }
                switch (param) {
                    case 514:
                    case 4097:
                    case 4098:
                    case 4103:
                    case 4105:
                    case 4128:
                    case 4129:
                    case 4131:
                    case 4132:
                    case 4133:
                    case 4134:
                    case 4628:
                    case 8201:
                    case 8202:
                    case 53248:
                        var val = HEAP32[pValues >>> 2 >>> 0];
                        AL.setSourceParam("alSourceiv", sourceId, param, val);
                        break;
                    case 4100:
                    case 4101:
                    case 4102:
                        AL.paramArray[0] = HEAP32[pValues >>> 2 >>> 0];
                        AL.paramArray[1] = HEAP32[pValues + 4 >>> 2 >>> 0];
                        AL.paramArray[2] = HEAP32[pValues + 8 >>> 2 >>> 0];
                        AL.setSourceParam("alSourceiv", sourceId, param, AL.paramArray);
                        break;
                    default:
                        AL.setSourceParam("alSourceiv", sourceId, param, null);
                        break
                }
            }
            _alSourceiv.sig = "viip";
            var _alSpeedOfSound = value => {
                AL.setGlobalParam("alSpeedOfSound", 49155, value)
            };
            _alSpeedOfSound.sig = "vf";
            var _alcCaptureCloseDevice = function(deviceId) {
                deviceId >>>= 0;
                var c = AL.requireValidCaptureDevice(deviceId, "alcCaptureCloseDevice");
                if (!c) return false;
                delete AL.captures[deviceId];
                AL.freeIds.push(deviceId);
                c.mediaStreamSourceNode?.disconnect();
                c.mergerNode?.disconnect();
                c.splitterNode?.disconnect();
                c.scriptProcessorNode?.disconnect();
                if (c.mediaStream) {
                    c.mediaStream.getTracks().forEach(track => track.stop())
                }
                delete c.buffers;
                c.capturedFrameCount = 0;
                c.isCapturing = false;
                return true
            };
            _alcCaptureCloseDevice.sig = "ip";
            var listenOnce = (object, event, func) => {
                object.addEventListener(event, func, {
                    once: true
                })
            };
            var autoResumeAudioContext = (ctx, elements) => {
                if (!elements) {
                    elements = [document, document.getElementById("canvas")]
                } ["keydown", "mousedown", "touchstart"].forEach(event => {
                    elements.forEach(element => {
                        if (element) {
                            listenOnce(element, event, () => {
                                if (ctx.state === "suspended") ctx.resume()
                            })
                        }
                    })
                })
            };

            function _alcCaptureOpenDevice(pDeviceName, requestedSampleRate, format, bufferFrameCapacity) {
                pDeviceName >>>= 0;
                var resolvedDeviceName = AL.CAPTURE_DEVICE_NAME;
                if (pDeviceName !== 0) {
                    resolvedDeviceName = UTF8ToString(pDeviceName);
                    if (resolvedDeviceName !== AL.CAPTURE_DEVICE_NAME) {
                        AL.alcErr = 40965;
                        return 0
                    }
                }
                if (bufferFrameCapacity < 0) {
                    AL.alcErr = 40964;
                    return 0
                }
                navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
                var has_getUserMedia = navigator.getUserMedia || navigator.mediaDevices && navigator.mediaDevices.getUserMedia;
                if (!has_getUserMedia) {
                    AL.alcErr = 40965;
                    return 0
                }
                var AudioContext = window.AudioContext || window.webkitAudioContext;
                if (!AL.sharedCaptureAudioCtx) {
                    try {
                        AL.sharedCaptureAudioCtx = new AudioContext
                    } catch (e) {
                        AL.alcErr = 40965;
                        return 0
                    }
                }
                autoResumeAudioContext(AL.sharedCaptureAudioCtx);
                var outputChannelCount;
                switch (format) {
                    case 65552:
                    case 4353:
                    case 4352:
                        outputChannelCount = 1;
                        break;
                    case 65553:
                    case 4355:
                    case 4354:
                        outputChannelCount = 2;
                        break;
                    default:
                        AL.alcErr = 40964;
                        return 0
                }

                function newF32Array(cap) {
                    return new Float32Array(cap)
                }

                function newI16Array(cap) {
                    return new Int16Array(cap)
                }

                function newU8Array(cap) {
                    return new Uint8Array(cap)
                }
                var requestedSampleType;
                var newSampleArray;
                switch (format) {
                    case 65552:
                    case 65553:
                        requestedSampleType = "f32";
                        newSampleArray = newF32Array;
                        break;
                    case 4353:
                    case 4355:
                        requestedSampleType = "i16";
                        newSampleArray = newI16Array;
                        break;
                    case 4352:
                    case 4354:
                        requestedSampleType = "u8";
                        newSampleArray = newU8Array;
                        break
                }
                var buffers = [];
                try {
                    for (var chan = 0; chan < outputChannelCount; ++chan) {
                        buffers[chan] = newSampleArray(bufferFrameCapacity)
                    }
                } catch (e) {
                    AL.alcErr = 40965;
                    return 0
                }
                var newCapture = {
                    audioCtx: AL.sharedCaptureAudioCtx,
                    deviceName: resolvedDeviceName,
                    requestedSampleRate,
                    requestedSampleType,
                    outputChannelCount,
                    inputChannelCount: null,
                    mediaStreamError: null,
                    mediaStreamSourceNode: null,
                    mediaStream: null,
                    mergerNode: null,
                    splitterNode: null,
                    scriptProcessorNode: null,
                    isCapturing: false,
                    buffers,
                    get bufferFrameCapacity() {
                        return buffers[0].length
                    },
                    capturePlayhead: 0,
                    captureReadhead: 0,
                    capturedFrameCount: 0
                };
                var onError = mediaStreamError => {
                    newCapture.mediaStreamError = mediaStreamError
                };
                var onSuccess = mediaStream => {
                    newCapture.mediaStreamSourceNode = newCapture.audioCtx.createMediaStreamSource(mediaStream);
                    newCapture.mediaStream = mediaStream;
                    var inputChannelCount = 1;
                    switch (newCapture.mediaStreamSourceNode.channelCountMode) {
                        case "max":
                            inputChannelCount = outputChannelCount;
                            break;
                        case "clamped-max":
                            inputChannelCount = Math.min(outputChannelCount, newCapture.mediaStreamSourceNode.channelCount);
                            break;
                        case "explicit":
                            inputChannelCount = newCapture.mediaStreamSourceNode.channelCount;
                            break
                    }
                    newCapture.inputChannelCount = inputChannelCount;
                    var processorFrameCount = 512;
                    newCapture.scriptProcessorNode = newCapture.audioCtx.createScriptProcessor(processorFrameCount, inputChannelCount, outputChannelCount);
                    if (inputChannelCount > outputChannelCount) {
                        newCapture.mergerNode = newCapture.audioCtx.createChannelMerger(inputChannelCount);
                        newCapture.mediaStreamSourceNode.connect(newCapture.mergerNode);
                        newCapture.mergerNode.connect(newCapture.scriptProcessorNode)
                    } else if (inputChannelCount < outputChannelCount) {
                        newCapture.splitterNode = newCapture.audioCtx.createChannelSplitter(outputChannelCount);
                        newCapture.mediaStreamSourceNode.connect(newCapture.splitterNode);
                        newCapture.splitterNode.connect(newCapture.scriptProcessorNode)
                    } else {
                        newCapture.mediaStreamSourceNode.connect(newCapture.scriptProcessorNode)
                    }
                    newCapture.scriptProcessorNode.connect(newCapture.audioCtx.destination);
                    newCapture.scriptProcessorNode.onaudioprocess = audioProcessingEvent => {
                        if (!newCapture.isCapturing) {
                            return
                        }
                        var c = newCapture;
                        var srcBuf = audioProcessingEvent.inputBuffer;
                        switch (format) {
                            case 65552:
                                var channel0 = srcBuf.getChannelData(0);
                                for (var i = 0; i < srcBuf.length; ++i) {
                                    var wi = (c.capturePlayhead + i) % c.bufferFrameCapacity;
                                    c.buffers[0][wi] = channel0[i]
                                }
                                break;
                            case 65553:
                                var channel0 = srcBuf.getChannelData(0);
                                var channel1 = srcBuf.getChannelData(1);
                                for (var i = 0; i < srcBuf.length; ++i) {
                                    var wi = (c.capturePlayhead + i) % c.bufferFrameCapacity;
                                    c.buffers[0][wi] = channel0[i];
                                    c.buffers[1][wi] = channel1[i]
                                }
                                break;
                            case 4353:
                                var channel0 = srcBuf.getChannelData(0);
                                for (var i = 0; i < srcBuf.length; ++i) {
                                    var wi = (c.capturePlayhead + i) % c.bufferFrameCapacity;
                                    c.buffers[0][wi] = channel0[i] * 32767
                                }
                                break;
                            case 4355:
                                var channel0 = srcBuf.getChannelData(0);
                                var channel1 = srcBuf.getChannelData(1);
                                for (var i = 0; i < srcBuf.length; ++i) {
                                    var wi = (c.capturePlayhead + i) % c.bufferFrameCapacity;
                                    c.buffers[0][wi] = channel0[i] * 32767;
                                    c.buffers[1][wi] = channel1[i] * 32767
                                }
                                break;
                            case 4352:
                                var channel0 = srcBuf.getChannelData(0);
                                for (var i = 0; i < srcBuf.length; ++i) {
                                    var wi = (c.capturePlayhead + i) % c.bufferFrameCapacity;
                                    c.buffers[0][wi] = (channel0[i] + 1) * 127
                                }
                                break;
                            case 4354:
                                var channel0 = srcBuf.getChannelData(0);
                                var channel1 = srcBuf.getChannelData(1);
                                for (var i = 0; i < srcBuf.length; ++i) {
                                    var wi = (c.capturePlayhead + i) % c.bufferFrameCapacity;
                                    c.buffers[0][wi] = (channel0[i] + 1) * 127;
                                    c.buffers[1][wi] = (channel1[i] + 1) * 127
                                }
                                break
                        }
                        c.capturePlayhead += srcBuf.length;
                        c.capturePlayhead %= c.bufferFrameCapacity;
                        c.capturedFrameCount += srcBuf.length;
                        c.capturedFrameCount = Math.min(c.capturedFrameCount, c.bufferFrameCapacity)
                    }
                };
                if (navigator.mediaDevices?.getUserMedia) {
                    navigator.mediaDevices.getUserMedia({
                        audio: true
                    }).then(onSuccess).catch(onError)
                } else {
                    navigator.getUserMedia({
                        audio: true
                    }, onSuccess, onError)
                }
                var id = AL.newId();
                AL.captures[id] = newCapture;
                return id
            }
            _alcCaptureOpenDevice.sig = "ppiii";

            function _alcCaptureSamples(deviceId, pFrames, requestedFrameCount) {
                deviceId >>>= 0;
                pFrames >>>= 0;
                var c = AL.requireValidCaptureDevice(deviceId, "alcCaptureSamples");
                if (!c) return;
                var dstfreq = c.requestedSampleRate;
                var srcfreq = c.audioCtx.sampleRate;
                var fratio = srcfreq / dstfreq;
                if (requestedFrameCount < 0 || requestedFrameCount > c.capturedFrameCount / fratio) {
                    AL.alcErr = 40964;
                    return
                }

                function setF32Sample(i, sample) {
                    HEAPF32[pFrames + 4 * i >>> 2 >>> 0] = sample
                }

                function setI16Sample(i, sample) {
                    HEAP16[pFrames + 2 * i >>> 1 >>> 0] = sample
                }

                function setU8Sample(i, sample) {
                    HEAP8[pFrames + i >>> 0] = sample
                }
                var setSample;
                switch (c.requestedSampleType) {
                    case "f32":
                        setSample = setF32Sample;
                        break;
                    case "i16":
                        setSample = setI16Sample;
                        break;
                    case "u8":
                        setSample = setU8Sample;
                        break;
                    default:
                        return
                }
                if (Math.floor(fratio) == fratio) {
                    for (var i = 0, frame_i = 0; frame_i < requestedFrameCount; ++frame_i) {
                        for (var chan = 0; chan < c.buffers.length; ++chan, ++i) {
                            setSample(i, c.buffers[chan][c.captureReadhead])
                        }
                        c.captureReadhead = (fratio + c.captureReadhead) % c.bufferFrameCapacity
                    }
                } else {
                    for (var i = 0, frame_i = 0; frame_i < requestedFrameCount; ++frame_i) {
                        var lefti = Math.floor(c.captureReadhead);
                        var righti = Math.ceil(c.captureReadhead);
                        var d = c.captureReadhead - lefti;
                        for (var chan = 0; chan < c.buffers.length; ++chan, ++i) {
                            var lefts = c.buffers[chan][lefti];
                            var rights = c.buffers[chan][righti];
                            setSample(i, (1 - d) * lefts + d * rights)
                        }
                        c.captureReadhead = (c.captureReadhead + fratio) % c.bufferFrameCapacity
                    }
                }
                c.capturedFrameCount = 0
            }
            _alcCaptureSamples.sig = "vppi";

            function _alcCaptureStart(deviceId) {
                deviceId >>>= 0;
                var c = AL.requireValidCaptureDevice(deviceId, "alcCaptureStart");
                if (!c) return;
                if (c.isCapturing) {
                    return
                }
                c.isCapturing = true;
                c.capturedFrameCount = 0;
                c.capturePlayhead = 0
            }
            _alcCaptureStart.sig = "vp";

            function _alcCaptureStop(deviceId) {
                deviceId >>>= 0;
                var c = AL.requireValidCaptureDevice(deviceId, "alcCaptureStop");
                if (!c) return;
                c.isCapturing = false
            }
            _alcCaptureStop.sig = "vp";

            function _alcCloseDevice(deviceId) {
                deviceId >>>= 0;
                if (!(deviceId in AL.deviceRefCounts) || AL.deviceRefCounts[deviceId] > 0) {
                    return 0
                }
                delete AL.deviceRefCounts[deviceId];
                AL.freeIds.push(deviceId);
                return 1
            }
            _alcCloseDevice.sig = "ip";

            function _alcCreateContext(deviceId, pAttrList) {
                deviceId >>>= 0;
                pAttrList >>>= 0;
                if (!(deviceId in AL.deviceRefCounts)) {
                    AL.alcErr = 40961;
                    return 0
                }
                var options = null;
                var attrs = [];
                var hrtf = null;
                pAttrList >>= 2;
                if (pAttrList) {
                    var attr = 0;
                    var val = 0;
                    while (true) {
                        attr = HEAP32[pAttrList++ >>> 0];
                        attrs.push(attr);
                        if (attr === 0) {
                            break
                        }
                        val = HEAP32[pAttrList++ >>> 0];
                        attrs.push(val);
                        switch (attr) {
                            case 4103:
                                if (!options) {
                                    options = {}
                                }
                                options.sampleRate = val;
                                break;
                            case 4112:
                            case 4113:
                                break;
                            case 6546:
                                switch (val) {
                                    case 0:
                                        hrtf = false;
                                        break;
                                    case 1:
                                        hrtf = true;
                                        break;
                                    case 2:
                                        break;
                                    default:
                                        AL.alcErr = 40964;
                                        return 0
                                }
                                break;
                            case 6550:
                                if (val !== 0) {
                                    AL.alcErr = 40964;
                                    return 0
                                }
                                break;
                            default:
                                AL.alcErr = 40964;
                                return 0
                        }
                    }
                }
                var AudioContext = window.AudioContext || window.webkitAudioContext;
                var ac = null;
                try {
                    if (options) {
                        ac = new AudioContext(options)
                    } else {
                        ac = new AudioContext
                    }
                } catch (e) {
                    if (e.name === "NotSupportedError") {
                        AL.alcErr = 40964
                    } else {
                        AL.alcErr = 40961
                    }
                    return 0
                }
                autoResumeAudioContext(ac);
                if (typeof ac.createGain == "undefined") {
                    ac.createGain = ac.createGainNode
                }
                var gain = ac.createGain();
                gain.connect(ac.destination);
                var ctx = {
                    deviceId,
                    id: AL.newId(),
                    attrs,
                    audioCtx: ac,
                    listener: {
                        position: [0, 0, 0],
                        velocity: [0, 0, 0],
                        direction: [0, 0, 0],
                        up: [0, 0, 0]
                    },
                    sources: [],
                    interval: setInterval(() => AL.scheduleContextAudio(ctx), AL.QUEUE_INTERVAL),
                    gain,
                    distanceModel: 53250,
                    speedOfSound: 343.3,
                    dopplerFactor: 1,
                    sourceDistanceModel: false,
                    hrtf: hrtf || false,
                    _err: 0,
                    get err() {
                        return this._err
                    },
                    set err(val) {
                        if (this._err === 0 || val === 0) {
                            this._err = val
                        }
                    }
                };
                AL.deviceRefCounts[deviceId]++;
                AL.contexts[ctx.id] = ctx;
                if (hrtf !== null) {
                    for (var ctxId in AL.contexts) {
                        var c = AL.contexts[ctxId];
                        if (c.deviceId === deviceId) {
                            c.hrtf = hrtf;
                            AL.updateContextGlobal(c)
                        }
                    }
                }
                return ctx.id
            }
            _alcCreateContext.sig = "ppp";

            function _alcDestroyContext(contextId) {
                contextId >>>= 0;
                var ctx = AL.contexts[contextId];
                if (AL.currentCtx === ctx) {
                    AL.alcErr = 40962;
                    return
                }
                if (AL.contexts[contextId].interval) {
                    clearInterval(AL.contexts[contextId].interval)
                }
                AL.deviceRefCounts[ctx.deviceId]--;
                delete AL.contexts[contextId];
                AL.freeIds.push(contextId)
            }
            _alcDestroyContext.sig = "vp";

            function _alcGetContextsDevice(contextId) {
                contextId >>>= 0;
                if (contextId in AL.contexts) {
                    return AL.contexts[contextId].deviceId
                }
                return 0
            }
            _alcGetContextsDevice.sig = "pp";

            function _alcGetCurrentContext() {
                if (AL.currentCtx !== null) {
                    return AL.currentCtx.id
                }
                return 0
            }
            _alcGetCurrentContext.sig = "p";

            function _alcGetEnumValue(deviceId, pEnumName) {
                deviceId >>>= 0;
                pEnumName >>>= 0;
                if (deviceId !== 0 && !(deviceId in AL.deviceRefCounts)) {
                    return 0
                } else if (!pEnumName) {
                    AL.alcErr = 40964;
                    return 0
                }
                var name = UTF8ToString(pEnumName);
                switch (name) {
                    case "ALC_NO_ERROR":
                        return 0;
                    case "ALC_INVALID_DEVICE":
                        return 40961;
                    case "ALC_INVALID_CONTEXT":
                        return 40962;
                    case "ALC_INVALID_ENUM":
                        return 40963;
                    case "ALC_INVALID_VALUE":
                        return 40964;
                    case "ALC_OUT_OF_MEMORY":
                        return 40965;
                    case "ALC_MAJOR_VERSION":
                        return 4096;
                    case "ALC_MINOR_VERSION":
                        return 4097;
                    case "ALC_ATTRIBUTES_SIZE":
                        return 4098;
                    case "ALC_ALL_ATTRIBUTES":
                        return 4099;
                    case "ALC_DEFAULT_DEVICE_SPECIFIER":
                        return 4100;
                    case "ALC_DEVICE_SPECIFIER":
                        return 4101;
                    case "ALC_EXTENSIONS":
                        return 4102;
                    case "ALC_FREQUENCY":
                        return 4103;
                    case "ALC_REFRESH":
                        return 4104;
                    case "ALC_SYNC":
                        return 4105;
                    case "ALC_MONO_SOURCES":
                        return 4112;
                    case "ALC_STEREO_SOURCES":
                        return 4113;
                    case "ALC_CAPTURE_DEVICE_SPECIFIER":
                        return 784;
                    case "ALC_CAPTURE_DEFAULT_DEVICE_SPECIFIER":
                        return 785;
                    case "ALC_CAPTURE_SAMPLES":
                        return 786;
                    case "ALC_HRTF_SOFT":
                        return 6546;
                    case "ALC_HRTF_ID_SOFT":
                        return 6550;
                    case "ALC_DONT_CARE_SOFT":
                        return 2;
                    case "ALC_HRTF_STATUS_SOFT":
                        return 6547;
                    case "ALC_NUM_HRTF_SPECIFIERS_SOFT":
                        return 6548;
                    case "ALC_HRTF_SPECIFIER_SOFT":
                        return 6549;
                    case "ALC_HRTF_DISABLED_SOFT":
                        return 0;
                    case "ALC_HRTF_ENABLED_SOFT":
                        return 1;
                    case "ALC_HRTF_DENIED_SOFT":
                        return 2;
                    case "ALC_HRTF_REQUIRED_SOFT":
                        return 3;
                    case "ALC_HRTF_HEADPHONES_DETECTED_SOFT":
                        return 4;
                    case "ALC_HRTF_UNSUPPORTED_FORMAT_SOFT":
                        return 5;
                    default:
                        AL.alcErr = 40964;
                        return 0
                }
            }
            _alcGetEnumValue.sig = "ipp";

            function _alcGetError(deviceId) {
                deviceId >>>= 0;
                var err = AL.alcErr;
                AL.alcErr = 0;
                return err
            }
            _alcGetError.sig = "ip";

            function _alcGetIntegerv(deviceId, param, size, pValues) {
                deviceId >>>= 0;
                pValues >>>= 0;
                if (size === 0 || !pValues) {
                    return
                }
                switch (param) {
                    case 4096:
                        HEAP32[pValues >>> 2 >>> 0] = 1;
                        break;
                    case 4097:
                        HEAP32[pValues >>> 2 >>> 0] = 1;
                        break;
                    case 4098:
                        if (!(deviceId in AL.deviceRefCounts)) {
                            AL.alcErr = 40961;
                            return
                        }
                        if (!AL.currentCtx) {
                            AL.alcErr = 40962;
                            return
                        }
                        HEAP32[pValues >>> 2 >>> 0] = AL.currentCtx.attrs.length;
                        break;
                    case 4099:
                        if (!(deviceId in AL.deviceRefCounts)) {
                            AL.alcErr = 40961;
                            return
                        }
                        if (!AL.currentCtx) {
                            AL.alcErr = 40962;
                            return
                        }
                        for (var i = 0; i < AL.currentCtx.attrs.length; i++) {
                            HEAP32[pValues + i * 4 >>> 2 >>> 0] = AL.currentCtx.attrs[i]
                        }
                        break;
                    case 4103:
                        if (!(deviceId in AL.deviceRefCounts)) {
                            AL.alcErr = 40961;
                            return
                        }
                        if (!AL.currentCtx) {
                            AL.alcErr = 40962;
                            return
                        }
                        HEAP32[pValues >>> 2 >>> 0] = AL.currentCtx.audioCtx.sampleRate;
                        break;
                    case 4112:
                    case 4113:
                        if (!(deviceId in AL.deviceRefCounts)) {
                            AL.alcErr = 40961;
                            return
                        }
                        if (!AL.currentCtx) {
                            AL.alcErr = 40962;
                            return
                        }
                        HEAP32[pValues >>> 2 >>> 0] = 2147483647;
                        break;
                    case 6546:
                    case 6547:
                        if (!(deviceId in AL.deviceRefCounts)) {
                            AL.alcErr = 40961;
                            return
                        }
                        var hrtfStatus = 0;
                        for (var ctxId in AL.contexts) {
                            var ctx = AL.contexts[ctxId];
                            if (ctx.deviceId === deviceId) {
                                hrtfStatus = ctx.hrtf ? 1 : 0
                            }
                        }
                        HEAP32[pValues >>> 2 >>> 0] = hrtfStatus;
                        break;
                    case 6548:
                        if (!(deviceId in AL.deviceRefCounts)) {
                            AL.alcErr = 40961;
                            return
                        }
                        HEAP32[pValues >>> 2 >>> 0] = 1;
                        break;
                    case 131075:
                        if (!(deviceId in AL.deviceRefCounts)) {
                            AL.alcErr = 40961;
                            return
                        }
                        if (!AL.currentCtx) {
                            AL.alcErr = 40962;
                            return
                        }
                        HEAP32[pValues >>> 2 >>> 0] = 1;
                    case 786:
                        var c = AL.requireValidCaptureDevice(deviceId, "alcGetIntegerv");
                        if (!c) {
                            return
                        }
                        var n = c.capturedFrameCount;
                        var dstfreq = c.requestedSampleRate;
                        var srcfreq = c.audioCtx.sampleRate;
                        var nsamples = Math.floor(n * (dstfreq / srcfreq));
                        HEAP32[pValues >>> 2 >>> 0] = nsamples;
                        break;
                    default:
                        AL.alcErr = 40963;
                        return
                }
            }
            _alcGetIntegerv.sig = "vpiip";

            function _alcGetString(deviceId, param) {
                deviceId >>>= 0;
                if (AL.alcStringCache[param]) {
                    return AL.alcStringCache[param]
                }
                var ret;
                switch (param) {
                    case 0:
                        ret = "No Error";
                        break;
                    case 40961:
                        ret = "Invalid Device";
                        break;
                    case 40962:
                        ret = "Invalid Context";
                        break;
                    case 40963:
                        ret = "Invalid Enum";
                        break;
                    case 40964:
                        ret = "Invalid Value";
                        break;
                    case 40965:
                        ret = "Out of Memory";
                        break;
                    case 4100:
                        if (typeof AudioContext != "undefined" || typeof webkitAudioContext != "undefined") {
                            ret = AL.DEVICE_NAME
                        } else {
                            return 0
                        }
                        break;
                    case 4101:
                        if (typeof AudioContext != "undefined" || typeof webkitAudioContext != "undefined") {
                            ret = AL.DEVICE_NAME + "\0"
                        } else {
                            ret = "\0"
                        }
                        break;
                    case 785:
                        ret = AL.CAPTURE_DEVICE_NAME;
                        break;
                    case 784:
                        if (deviceId === 0) {
                            ret = AL.CAPTURE_DEVICE_NAME + "\0"
                        } else {
                            var c = AL.requireValidCaptureDevice(deviceId, "alcGetString");
                            if (!c) {
                                return 0
                            }
                            ret = c.deviceName
                        }
                        break;
                    case 4102:
                        if (!deviceId) {
                            AL.alcErr = 40961;
                            return 0
                        }
                        ret = Object.keys(AL.ALC_EXTENSIONS).join(" ");
                        break;
                    default:
                        AL.alcErr = 40963;
                        return 0
                }
                ret = stringToNewUTF8(ret);
                AL.alcStringCache[param] = ret;
                return ret
            }
            _alcGetString.sig = "ppi";

            function _alcIsExtensionPresent(deviceId, pExtName) {
                deviceId >>>= 0;
                pExtName >>>= 0;
                var name = UTF8ToString(pExtName);
                return AL.ALC_EXTENSIONS[name] ? 1 : 0
            }
            _alcIsExtensionPresent.sig = "ipp";

            function _alcMakeContextCurrent(contextId) {
                contextId >>>= 0;
                if (contextId === 0) {
                    AL.currentCtx = null
                } else {
                    AL.currentCtx = AL.contexts[contextId]
                }
                return 1
            }
            _alcMakeContextCurrent.sig = "ip";

            function _alcOpenDevice(pDeviceName) {
                pDeviceName >>>= 0;
                if (pDeviceName) {
                    var name = UTF8ToString(pDeviceName);
                    if (name !== AL.DEVICE_NAME) {
                        return 0
                    }
                }
                if (typeof AudioContext != "undefined" || typeof webkitAudioContext != "undefined") {
                    var deviceId = AL.newId();
                    AL.deviceRefCounts[deviceId] = 0;
                    return deviceId
                }
                return 0
            }
            _alcOpenDevice.sig = "pp";

            function _alcProcessContext(contextId) {
                contextId >>>= 0
            }
            _alcProcessContext.sig = "vp";

            function _alcSuspendContext(contextId) {
                contextId >>>= 0
            }
            _alcSuspendContext.sig = "vp";

            function _duckdb_web_fs_directory_create(path, pathLen) {
                path >>>= 0;
                return globalThis.DUCKDB_RUNTIME.createDirectory(Module, path, pathLen)
            }
            _duckdb_web_fs_directory_create.sig = "vpi";

            function _duckdb_web_fs_directory_exists(path, pathLen) {
                path >>>= 0;
                return globalThis.DUCKDB_RUNTIME.checkDirectory(Module, path, pathLen)
            }
            _duckdb_web_fs_directory_exists.sig = "ipi";

            function _duckdb_web_fs_directory_list_files(path, pathLen) {
                path >>>= 0;
                return globalThis.DUCKDB_RUNTIME.listDirectoryEntries(Module, path, pathLen)
            }
            _duckdb_web_fs_directory_list_files.sig = "ipi";

            function _duckdb_web_fs_directory_remove(path, pathLen) {
                path >>>= 0;
                return globalThis.DUCKDB_RUNTIME.removeDirectory(Module, path, pathLen)
            }
            _duckdb_web_fs_directory_remove.sig = "vpi";

            function _duckdb_web_fs_file_close(fileId) {
                return globalThis.DUCKDB_RUNTIME.closeFile(Module, fileId)
            }
            _duckdb_web_fs_file_close.sig = "vi";

            function _duckdb_web_fs_file_drop_file(fileName, fileNameLen) {
                fileName >>>= 0;
                return globalThis.DUCKDB_RUNTIME.dropFile(Module, fileName, fileNameLen)
            }
            _duckdb_web_fs_file_drop_file.sig = "vpi";

            function _duckdb_web_fs_file_exists(path, pathLen) {
                path >>>= 0;
                return globalThis.DUCKDB_RUNTIME.checkFile(Module, path, pathLen)
            }
            _duckdb_web_fs_file_exists.sig = "ipi";

            function _duckdb_web_fs_file_move(from, fromLen, to, toLen) {
                from >>>= 0;
                to >>>= 0;
                return globalThis.DUCKDB_RUNTIME.moveFile(Module, from, fromLen, to, toLen)
            }
            _duckdb_web_fs_file_move.sig = "vpipi";

            function _duckdb_web_fs_file_open(fileId, flags) {
                return globalThis.DUCKDB_RUNTIME.openFile(Module, fileId, flags)
            }
            _duckdb_web_fs_file_open.sig = "pii";

            function _duckdb_web_fs_file_read(fileId, buf, size, location) {
                buf >>>= 0;
                return globalThis.DUCKDB_RUNTIME.readFile(Module, fileId, buf, size, location)
            }
            _duckdb_web_fs_file_read.sig = "iipid";

            function _duckdb_web_fs_file_truncate(fileId, newSize) {
                return globalThis.DUCKDB_RUNTIME.truncateFile(Module, fileId, newSize)
            }
            _duckdb_web_fs_file_truncate.sig = "vid";

            function _duckdb_web_fs_file_write(fileId, buf, size, location) {
                buf >>>= 0;
                return globalThis.DUCKDB_RUNTIME.writeFile(Module, fileId, buf, size, location)
            }
            _duckdb_web_fs_file_write.sig = "iipid";

            function _duckdb_web_fs_get_default_data_protocol(Module) {
                return globalThis.DUCKDB_RUNTIME.getDefaultDataProtocol(Module)
            }
            _duckdb_web_fs_get_default_data_protocol.sig = "i";

            function _duckdb_web_fs_glob(path, pathLen) {
                path >>>= 0;
                return globalThis.DUCKDB_RUNTIME.glob(Module, path, pathLen)
            }
            _duckdb_web_fs_glob.sig = "vpi";

            function _duckdb_web_test_platform_feature(feature) {
                return globalThis.DUCKDB_RUNTIME.testPlatformFeature(Module, feature)
            }
            _duckdb_web_test_platform_feature.sig = "ii";

            function _duckdb_web_udf_scalar_call(funcId, descPtr, descSize, ptrsPtr, ptrsSize, response) {
                funcId >>>= 0;
                descSize >>>= 0;
                ptrsSize >>>= 0;
                return globalThis.DUCKDB_RUNTIME.callScalarUDF(Module, funcId, descPtr, descSize, ptrsPtr, ptrsSize, response)
            }
            _duckdb_web_udf_scalar_call.sig = "vpipipi";
            var _emscripten_alcDevicePauseSOFT = deviceId => {
                if (!(deviceId in AL.deviceRefCounts)) {
                    AL.alcErr = 40961;
                    return
                }
                if (AL.paused) {
                    return
                }
                AL.paused = true;
                for (var ctxId in AL.contexts) {
                    var ctx = AL.contexts[ctxId];
                    if (ctx.deviceId !== deviceId) {
                        continue
                    }
                    ctx.audioCtx.suspend();
                    clearInterval(ctx.interval);
                    ctx.interval = null
                }
            };
            _emscripten_alcDevicePauseSOFT.sig = "vi";
            var _emscripten_alcDeviceResumeSOFT = deviceId => {
                if (!(deviceId in AL.deviceRefCounts)) {
                    AL.alcErr = 40961;
                    return
                }
                if (!AL.paused) {
                    return
                }
                AL.paused = false;
                for (var ctxId in AL.contexts) {
                    var ctx = AL.contexts[ctxId];
                    if (ctx.deviceId !== deviceId) {
                        continue
                    }
                    ctx.interval = setInterval(() => AL.scheduleContextAudio(ctx), AL.QUEUE_INTERVAL);
                    ctx.audioCtx.resume()
                }
            };
            _emscripten_alcDeviceResumeSOFT.sig = "vi";
            var _emscripten_alcGetStringiSOFT = (deviceId, param, index) => {
                if (!(deviceId in AL.deviceRefCounts)) {
                    AL.alcErr = 40961;
                    return 0
                }
                if (AL.alcStringCache[param]) {
                    return AL.alcStringCache[param]
                }
                var ret;
                switch (param) {
                    case 6549:
                        if (index === 0) {
                            ret = "Web Audio HRTF"
                        } else {
                            AL.alcErr = 40964;
                            return 0
                        }
                        break;
                    default:
                        if (index !== 0) {
                            AL.alcErr = 40963;
                            return 0
                        }
                        return _alcGetString(deviceId, param)
                }
                ret = stringToNewUTF8(ret);
                AL.alcStringCache[param] = ret;
                return ret
            };
            _emscripten_alcGetStringiSOFT.sig = "iiii";
            var _emscripten_alcResetDeviceSOFT = (deviceId, pAttrList) => {
                if (!(deviceId in AL.deviceRefCounts)) {
                    AL.alcErr = 40961;
                    return 0
                }
                var hrtf = null;
                pAttrList >>= 2;
                if (pAttrList) {
                    var attr = 0;
                    var val = 0;
                    while (true) {
                        attr = HEAP32[pAttrList++ >>> 0];
                        if (attr === 0) {
                            break
                        }
                        val = HEAP32[pAttrList++ >>> 0];
                        switch (attr) {
                            case 6546:
                                if (val === 1) {
                                    hrtf = true
                                } else if (val === 0) {
                                    hrtf = false
                                }
                                break
                        }
                    }
                }
                if (hrtf !== null) {
                    for (var ctxId in AL.contexts) {
                        var ctx = AL.contexts[ctxId];
                        if (ctx.deviceId === deviceId) {
                            ctx.hrtf = hrtf;
                            AL.updateContextGlobal(ctx)
                        }
                    }
                }
                return 1
            };
            _emscripten_alcResetDeviceSOFT.sig = "iii";
            var readEmAsmArgsArray = [];
            var readEmAsmArgs = (sigPtr, buf) => {
                readEmAsmArgsArray.length = 0;
                var ch;
                while (ch = HEAPU8[sigPtr++ >>> 0]) {
                    var wide = ch != 105;
                    wide &= ch != 112;
                    buf += wide && buf % 8 ? 4 : 0;
                    readEmAsmArgsArray.push(ch == 112 ? HEAPU32[buf >>> 2 >>> 0] : ch == 105 ? HEAP32[buf >>> 2 >>> 0] : HEAPF64[buf >>> 3 >>> 0]);
                    buf += wide ? 8 : 4
                }
                return readEmAsmArgsArray
            };
            var runEmAsmFunction = (code, sigPtr, argbuf) => {
                var args = readEmAsmArgs(sigPtr, argbuf);
                return ASM_CONSTS[code](...args)
            };

            function _emscripten_asm_const_int(code, sigPtr, argbuf) {
                code >>>= 0;
                sigPtr >>>= 0;
                argbuf >>>= 0;
                return runEmAsmFunction(code, sigPtr, argbuf)
            }
            _emscripten_asm_const_int.sig = "ippp";

            function _emscripten_asm_const_ptr(code, sigPtr, argbuf) {
                code >>>= 0;
                sigPtr >>>= 0;
                argbuf >>>= 0;
                return runEmAsmFunction(code, sigPtr, argbuf)
            }
            _emscripten_asm_const_ptr.sig = "pppp";

            function _emscripten_console_error(str) {
                str >>>= 0;
                console.error(UTF8ToString(str))
            }
            _emscripten_console_error.sig = "vp";

            function _emscripten_console_log(str) {
                str >>>= 0;
                console.log(UTF8ToString(str))
            }
            _emscripten_console_log.sig = "vp";

            function _emscripten_console_trace(str) {
                str >>>= 0;
                console.trace(UTF8ToString(str))
            }
            _emscripten_console_trace.sig = "vp";

            function _emscripten_console_warn(str) {
                str >>>= 0;
                console.warn(UTF8ToString(str))
            }
            _emscripten_console_warn.sig = "vp";
            var _emscripten_date_now = () => Date.now();
            _emscripten_date_now.sig = "d";

            function _emscripten_err(str) {
                str >>>= 0;
                return err(UTF8ToString(str))
            }
            _emscripten_err.sig = "vp";
            var getHeapMax = () => 4294901760;

            function _emscripten_get_heap_max() {
                return getHeapMax()
            }
            _emscripten_get_heap_max.sig = "p";
            var _emscripten_get_now_res = () => {
                if (ENVIRONMENT_IS_NODE) {
                    return 1
                }
                return 1e3
            };
            _emscripten_get_now_res.sig = "d";
            var GLctx;
            var webgl_enable_ANGLE_instanced_arrays = ctx => {
                var ext = ctx.getExtension("ANGLE_instanced_arrays");
                if (ext) {
                    ctx["vertexAttribDivisor"] = (index, divisor) => ext["vertexAttribDivisorANGLE"](index, divisor);
                    ctx["drawArraysInstanced"] = (mode, first, count, primcount) => ext["drawArraysInstancedANGLE"](mode, first, count, primcount);
                    ctx["drawElementsInstanced"] = (mode, count, type, indices, primcount) => ext["drawElementsInstancedANGLE"](mode, count, type, indices, primcount);
                    return 1
                }
            };
            var webgl_enable_OES_vertex_array_object = ctx => {
                var ext = ctx.getExtension("OES_vertex_array_object");
                if (ext) {
                    ctx["createVertexArray"] = () => ext["createVertexArrayOES"]();
                    ctx["deleteVertexArray"] = vao => ext["deleteVertexArrayOES"](vao);
                    ctx["bindVertexArray"] = vao => ext["bindVertexArrayOES"](vao);
                    ctx["isVertexArray"] = vao => ext["isVertexArrayOES"](vao);
                    return 1
                }
            };
            var webgl_enable_WEBGL_draw_buffers = ctx => {
                var ext = ctx.getExtension("WEBGL_draw_buffers");
                if (ext) {
                    ctx["drawBuffers"] = (n, bufs) => ext["drawBuffersWEBGL"](n, bufs);
                    return 1
                }
            };
            var webgl_enable_EXT_polygon_offset_clamp = ctx => !!(ctx.extPolygonOffsetClamp = ctx.getExtension("EXT_polygon_offset_clamp"));
            var webgl_enable_EXT_clip_control = ctx => !!(ctx.extClipControl = ctx.getExtension("EXT_clip_control"));
            var webgl_enable_WEBGL_polygon_mode = ctx => !!(ctx.webglPolygonMode = ctx.getExtension("WEBGL_polygon_mode"));
            var webgl_enable_WEBGL_multi_draw = ctx => !!(ctx.multiDrawWebgl = ctx.getExtension("WEBGL_multi_draw"));
            var getEmscriptenSupportedExtensions = ctx => {
                var supportedExtensions = ["ANGLE_instanced_arrays", "EXT_blend_minmax", "EXT_disjoint_timer_query", "EXT_frag_depth", "EXT_shader_texture_lod", "EXT_sRGB", "OES_element_index_uint", "OES_fbo_render_mipmap", "OES_standard_derivatives", "OES_texture_float", "OES_texture_half_float", "OES_texture_half_float_linear", "OES_vertex_array_object", "WEBGL_color_buffer_float", "WEBGL_depth_texture", "WEBGL_draw_buffers", "EXT_clip_control", "EXT_color_buffer_half_float", "EXT_depth_clamp", "EXT_float_blend", "EXT_polygon_offset_clamp", "EXT_texture_compression_bptc", "EXT_texture_compression_rgtc", "EXT_texture_filter_anisotropic", "KHR_parallel_shader_compile", "OES_texture_float_linear", "WEBGL_blend_func_extended", "WEBGL_compressed_texture_astc", "WEBGL_compressed_texture_etc", "WEBGL_compressed_texture_etc1", "WEBGL_compressed_texture_s3tc", "WEBGL_compressed_texture_s3tc_srgb", "WEBGL_debug_renderer_info", "WEBGL_debug_shaders", "WEBGL_lose_context", "WEBGL_multi_draw", "WEBGL_polygon_mode"];
                return (ctx.getSupportedExtensions() || []).filter(ext => supportedExtensions.includes(ext))
            };
            var GL = {
                counter: 1,
                buffers: [],
                programs: [],
                framebuffers: [],
                renderbuffers: [],
                textures: [],
                shaders: [],
                vaos: [],
                contexts: [],
                offscreenCanvases: {},
                queries: [],
                stringCache: {},
                unpackAlignment: 4,
                unpackRowLength: 0,
                recordError: errorCode => {
                    if (!GL.lastError) {
                        GL.lastError = errorCode
                    }
                },
                getNewId: table => {
                    var ret = GL.counter++;
                    for (var i = table.length; i < ret; i++) {
                        table[i] = null
                    }
                    return ret
                },
                genObject: (n, buffers, createFunction, objectTable) => {
                    for (var i = 0; i < n; i++) {
                        var buffer = GLctx[createFunction]();
                        var id = buffer && GL.getNewId(objectTable);
                        if (buffer) {
                            buffer.name = id;
                            objectTable[id] = buffer
                        } else {
                            GL.recordError(1282)
                        }
                        HEAP32[buffers + i * 4 >>> 2 >>> 0] = id
                    }
                },
                getSource: (shader, count, string, length) => {
                    var source = "";
                    for (var i = 0; i < count; ++i) {
                        var len = length ? HEAPU32[length + i * 4 >>> 2 >>> 0] : undefined;
                        source += UTF8ToString(HEAPU32[string + i * 4 >>> 2 >>> 0], len)
                    }
                    return source
                },
                createContext: (canvas, webGLContextAttributes) => {
                    if (!canvas.getContextSafariWebGL2Fixed) {
                        canvas.getContextSafariWebGL2Fixed = canvas.getContext;

                        function fixedGetContext(ver, attrs) {
                            var gl = canvas.getContextSafariWebGL2Fixed(ver, attrs);
                            return ver == "webgl" == gl instanceof WebGLRenderingContext ? gl : null
                        }
                        canvas.getContext = fixedGetContext
                    }
                    var ctx = canvas.getContext("webgl", webGLContextAttributes);
                    if (!ctx) return 0;
                    var handle = GL.registerContext(ctx, webGLContextAttributes);
                    return handle
                },
                registerContext: (ctx, webGLContextAttributes) => {
                    var handle = GL.getNewId(GL.contexts);
                    var context = {
                        handle,
                        attributes: webGLContextAttributes,
                        version: webGLContextAttributes.majorVersion,
                        GLctx: ctx
                    };
                    if (ctx.canvas) ctx.canvas.GLctxObject = context;
                    GL.contexts[handle] = context;
                    if (typeof webGLContextAttributes.enableExtensionsByDefault == "undefined" || webGLContextAttributes.enableExtensionsByDefault) {
                        GL.initExtensions(context)
                    }
                    return handle
                },
                makeContextCurrent: contextHandle => {
                    GL.currentContext = GL.contexts[contextHandle];
                    Module.ctx = GLctx = GL.currentContext?.GLctx;
                    return !(contextHandle && !GLctx)
                },
                getContext: contextHandle => GL.contexts[contextHandle],
                deleteContext: contextHandle => {
                    if (GL.currentContext === GL.contexts[contextHandle]) {
                        GL.currentContext = null
                    }
                    if (typeof JSEvents == "object") {
                        JSEvents.removeAllHandlersOnTarget(GL.contexts[contextHandle].GLctx.canvas)
                    }
                    if (GL.contexts[contextHandle] && GL.contexts[contextHandle].GLctx.canvas) {
                        GL.contexts[contextHandle].GLctx.canvas.GLctxObject = undefined
                    }
                    GL.contexts[contextHandle] = null
                },
                initExtensions: context => {
                    context ||= GL.currentContext;
                    if (context.initExtensionsDone) return;
                    context.initExtensionsDone = true;
                    var GLctx = context.GLctx;
                    webgl_enable_WEBGL_multi_draw(GLctx);
                    webgl_enable_EXT_polygon_offset_clamp(GLctx);
                    webgl_enable_EXT_clip_control(GLctx);
                    webgl_enable_WEBGL_polygon_mode(GLctx);
                    webgl_enable_ANGLE_instanced_arrays(GLctx);
                    webgl_enable_OES_vertex_array_object(GLctx);
                    webgl_enable_WEBGL_draw_buffers(GLctx);
                    {
                        GLctx.disjointTimerQueryExt = GLctx.getExtension("EXT_disjoint_timer_query")
                    }
                    getEmscriptenSupportedExtensions(GLctx).forEach(ext => {
                        if (!ext.includes("lose_context") && !ext.includes("debug")) {
                            GLctx.getExtension(ext)
                        }
                    })
                }
            };
            var _glActiveTexture = x0 => GLctx.activeTexture(x0);
            _glActiveTexture.sig = "vi";
            var _emscripten_glActiveTexture = _glActiveTexture;
            _emscripten_glActiveTexture.sig = "vi";
            var _glAttachShader = (program, shader) => {
                GLctx.attachShader(GL.programs[program], GL.shaders[shader])
            };
            _glAttachShader.sig = "vii";
            var _emscripten_glAttachShader = _glAttachShader;
            _emscripten_glAttachShader.sig = "vii";
            var _glBeginQueryEXT = (target, id) => {
                GLctx.disjointTimerQueryExt["beginQueryEXT"](target, GL.queries[id])
            };
            _glBeginQueryEXT.sig = "vii";
            var _emscripten_glBeginQueryEXT = _glBeginQueryEXT;

            function _glBindAttribLocation(program, index, name) {
                name >>>= 0;
                GLctx.bindAttribLocation(GL.programs[program], index, UTF8ToString(name))
            }
            _glBindAttribLocation.sig = "viip";
            var _emscripten_glBindAttribLocation = _glBindAttribLocation;
            _emscripten_glBindAttribLocation.sig = "viip";
            var _glBindBuffer = (target, buffer) => {
                GLctx.bindBuffer(target, GL.buffers[buffer])
            };
            _glBindBuffer.sig = "vii";
            var _emscripten_glBindBuffer = _glBindBuffer;
            _emscripten_glBindBuffer.sig = "vii";
            var _glBindFramebuffer = (target, framebuffer) => {
                GLctx.bindFramebuffer(target, GL.framebuffers[framebuffer])
            };
            _glBindFramebuffer.sig = "vii";
            var _emscripten_glBindFramebuffer = _glBindFramebuffer;
            _emscripten_glBindFramebuffer.sig = "vii";
            var _glBindRenderbuffer = (target, renderbuffer) => {
                GLctx.bindRenderbuffer(target, GL.renderbuffers[renderbuffer])
            };
            _glBindRenderbuffer.sig = "vii";
            var _emscripten_glBindRenderbuffer = _glBindRenderbuffer;
            _emscripten_glBindRenderbuffer.sig = "vii";
            var _glBindTexture = (target, texture) => {
                GLctx.bindTexture(target, GL.textures[texture])
            };
            _glBindTexture.sig = "vii";
            var _emscripten_glBindTexture = _glBindTexture;
            _emscripten_glBindTexture.sig = "vii";
            var _glBindVertexArray = vao => {
                GLctx.bindVertexArray(GL.vaos[vao])
            };
            _glBindVertexArray.sig = "vi";
            var _glBindVertexArrayOES = _glBindVertexArray;
            _glBindVertexArrayOES.sig = "vi";
            var _emscripten_glBindVertexArrayOES = _glBindVertexArrayOES;
            _emscripten_glBindVertexArrayOES.sig = "vi";
            var _glBlendColor = (x0, x1, x2, x3) => GLctx.blendColor(x0, x1, x2, x3);
            _glBlendColor.sig = "vffff";
            var _emscripten_glBlendColor = _glBlendColor;
            _emscripten_glBlendColor.sig = "vffff";
            var _glBlendEquation = x0 => GLctx.blendEquation(x0);
            _glBlendEquation.sig = "vi";
            var _emscripten_glBlendEquation = _glBlendEquation;
            _emscripten_glBlendEquation.sig = "vi";
            var _glBlendEquationSeparate = (x0, x1) => GLctx.blendEquationSeparate(x0, x1);
            _glBlendEquationSeparate.sig = "vii";
            var _emscripten_glBlendEquationSeparate = _glBlendEquationSeparate;
            _emscripten_glBlendEquationSeparate.sig = "vii";
            var _glBlendFunc = (x0, x1) => GLctx.blendFunc(x0, x1);
            _glBlendFunc.sig = "vii";
            var _emscripten_glBlendFunc = _glBlendFunc;
            _emscripten_glBlendFunc.sig = "vii";
            var _glBlendFuncSeparate = (x0, x1, x2, x3) => GLctx.blendFuncSeparate(x0, x1, x2, x3);
            _glBlendFuncSeparate.sig = "viiii";
            var _emscripten_glBlendFuncSeparate = _glBlendFuncSeparate;
            _emscripten_glBlendFuncSeparate.sig = "viiii";

            function _glBufferData(target, size, data, usage) {
                size >>>= 0;
                data >>>= 0;
                GLctx.bufferData(target, data ? HEAPU8.subarray(data >>> 0, data + size >>> 0) : size, usage)
            }
            _glBufferData.sig = "vippi";
            var _emscripten_glBufferData = _glBufferData;
            _emscripten_glBufferData.sig = "vippi";

            function _glBufferSubData(target, offset, size, data) {
                offset >>>= 0;
                size >>>= 0;
                data >>>= 0;
                GLctx.bufferSubData(target, offset, HEAPU8.subarray(data >>> 0, data + size >>> 0))
            }
            _glBufferSubData.sig = "vippp";
            var _emscripten_glBufferSubData = _glBufferSubData;
            _emscripten_glBufferSubData.sig = "vippp";
            var _glCheckFramebufferStatus = x0 => GLctx.checkFramebufferStatus(x0);
            _glCheckFramebufferStatus.sig = "ii";
            var _emscripten_glCheckFramebufferStatus = _glCheckFramebufferStatus;
            _emscripten_glCheckFramebufferStatus.sig = "ii";
            var _glClear = x0 => GLctx.clear(x0);
            _glClear.sig = "vi";
            var _emscripten_glClear = _glClear;
            _emscripten_glClear.sig = "vi";
            var _glClearColor = (x0, x1, x2, x3) => GLctx.clearColor(x0, x1, x2, x3);
            _glClearColor.sig = "vffff";
            var _emscripten_glClearColor = _glClearColor;
            _emscripten_glClearColor.sig = "vffff";
            var _glClearDepthf = x0 => GLctx.clearDepth(x0);
            _glClearDepthf.sig = "vf";
            var _emscripten_glClearDepthf = _glClearDepthf;
            _emscripten_glClearDepthf.sig = "vf";
            var _glClearStencil = x0 => GLctx.clearStencil(x0);
            _glClearStencil.sig = "vi";
            var _emscripten_glClearStencil = _glClearStencil;
            _emscripten_glClearStencil.sig = "vi";
            var _glClipControlEXT = (origin, depth) => {
                GLctx.extClipControl["clipControlEXT"](origin, depth)
            };
            _glClipControlEXT.sig = "vii";
            var _emscripten_glClipControlEXT = _glClipControlEXT;
            var _glColorMask = (red, green, blue, alpha) => {
                GLctx.colorMask(!!red, !!green, !!blue, !!alpha)
            };
            _glColorMask.sig = "viiii";
            var _emscripten_glColorMask = _glColorMask;
            _emscripten_glColorMask.sig = "viiii";
            var _glCompileShader = shader => {
                GLctx.compileShader(GL.shaders[shader])
            };
            _glCompileShader.sig = "vi";
            var _emscripten_glCompileShader = _glCompileShader;
            _emscripten_glCompileShader.sig = "vi";

            function _glCompressedTexImage2D(target, level, internalFormat, width, height, border, imageSize, data) {
                data >>>= 0;
                GLctx.compressedTexImage2D(target, level, internalFormat, width, height, border, HEAPU8.subarray(data >>> 0, data + imageSize >>> 0))
            }
            _glCompressedTexImage2D.sig = "viiiiiiip";
            var _emscripten_glCompressedTexImage2D = _glCompressedTexImage2D;
            _emscripten_glCompressedTexImage2D.sig = "viiiiiiip";

            function _glCompressedTexSubImage2D(target, level, xoffset, yoffset, width, height, format, imageSize, data) {
                data >>>= 0;
                GLctx.compressedTexSubImage2D(target, level, xoffset, yoffset, width, height, format, HEAPU8.subarray(data >>> 0, data + imageSize >>> 0))
            }
            _glCompressedTexSubImage2D.sig = "viiiiiiiip";
            var _emscripten_glCompressedTexSubImage2D = _glCompressedTexSubImage2D;
            _emscripten_glCompressedTexSubImage2D.sig = "viiiiiiiip";
            var _glCopyTexImage2D = (x0, x1, x2, x3, x4, x5, x6, x7) => GLctx.copyTexImage2D(x0, x1, x2, x3, x4, x5, x6, x7);
            _glCopyTexImage2D.sig = "viiiiiiii";
            var _emscripten_glCopyTexImage2D = _glCopyTexImage2D;
            _emscripten_glCopyTexImage2D.sig = "viiiiiiii";
            var _glCopyTexSubImage2D = (x0, x1, x2, x3, x4, x5, x6, x7) => GLctx.copyTexSubImage2D(x0, x1, x2, x3, x4, x5, x6, x7);
            _glCopyTexSubImage2D.sig = "viiiiiiii";
            var _emscripten_glCopyTexSubImage2D = _glCopyTexSubImage2D;
            _emscripten_glCopyTexSubImage2D.sig = "viiiiiiii";
            var _glCreateProgram = () => {
                var id = GL.getNewId(GL.programs);
                var program = GLctx.createProgram();
                program.name = id;
                program.maxUniformLength = program.maxAttributeLength = program.maxUniformBlockNameLength = 0;
                program.uniformIdCounter = 1;
                GL.programs[id] = program;
                return id
            };
            _glCreateProgram.sig = "i";
            var _emscripten_glCreateProgram = _glCreateProgram;
            _emscripten_glCreateProgram.sig = "i";
            var _glCreateShader = shaderType => {
                var id = GL.getNewId(GL.shaders);
                GL.shaders[id] = GLctx.createShader(shaderType);
                return id
            };
            _glCreateShader.sig = "ii";
            var _emscripten_glCreateShader = _glCreateShader;
            _emscripten_glCreateShader.sig = "ii";
            var _glCullFace = x0 => GLctx.cullFace(x0);
            _glCullFace.sig = "vi";
            var _emscripten_glCullFace = _glCullFace;
            _emscripten_glCullFace.sig = "vi";

            function _glDeleteBuffers(n, buffers) {
                buffers >>>= 0;
                for (var i = 0; i < n; i++) {
                    var id = HEAP32[buffers + i * 4 >>> 2 >>> 0];
                    var buffer = GL.buffers[id];
                    if (!buffer) continue;
                    GLctx.deleteBuffer(buffer);
                    buffer.name = 0;
                    GL.buffers[id] = null
                }
            }
            _glDeleteBuffers.sig = "vip";
            var _emscripten_glDeleteBuffers = _glDeleteBuffers;
            _emscripten_glDeleteBuffers.sig = "vip";

            function _glDeleteFramebuffers(n, framebuffers) {
                framebuffers >>>= 0;
                for (var i = 0; i < n; ++i) {
                    var id = HEAP32[framebuffers + i * 4 >>> 2 >>> 0];
                    var framebuffer = GL.framebuffers[id];
                    if (!framebuffer) continue;
                    GLctx.deleteFramebuffer(framebuffer);
                    framebuffer.name = 0;
                    GL.framebuffers[id] = null
                }
            }
            _glDeleteFramebuffers.sig = "vip";
            var _emscripten_glDeleteFramebuffers = _glDeleteFramebuffers;
            _emscripten_glDeleteFramebuffers.sig = "vip";
            var _glDeleteProgram = id => {
                if (!id) return;
                var program = GL.programs[id];
                if (!program) {
                    GL.recordError(1281);
                    return
                }
                GLctx.deleteProgram(program);
                program.name = 0;
                GL.programs[id] = null
            };
            _glDeleteProgram.sig = "vi";
            var _emscripten_glDeleteProgram = _glDeleteProgram;
            _emscripten_glDeleteProgram.sig = "vi";

            function _glDeleteQueriesEXT(n, ids) {
                ids >>>= 0;
                for (var i = 0; i < n; i++) {
                    var id = HEAP32[ids + i * 4 >>> 2 >>> 0];
                    var query = GL.queries[id];
                    if (!query) continue;
                    GLctx.disjointTimerQueryExt["deleteQueryEXT"](query);
                    GL.queries[id] = null
                }
            }
            _glDeleteQueriesEXT.sig = "vip";
            var _emscripten_glDeleteQueriesEXT = _glDeleteQueriesEXT;

            function _glDeleteRenderbuffers(n, renderbuffers) {
                renderbuffers >>>= 0;
                for (var i = 0; i < n; i++) {
                    var id = HEAP32[renderbuffers + i * 4 >>> 2 >>> 0];
                    var renderbuffer = GL.renderbuffers[id];
                    if (!renderbuffer) continue;
                    GLctx.deleteRenderbuffer(renderbuffer);
                    renderbuffer.name = 0;
                    GL.renderbuffers[id] = null
                }
            }
            _glDeleteRenderbuffers.sig = "vip";
            var _emscripten_glDeleteRenderbuffers = _glDeleteRenderbuffers;
            _emscripten_glDeleteRenderbuffers.sig = "vip";
            var _glDeleteShader = id => {
                if (!id) return;
                var shader = GL.shaders[id];
                if (!shader) {
                    GL.recordError(1281);
                    return
                }
                GLctx.deleteShader(shader);
                GL.shaders[id] = null
            };
            _glDeleteShader.sig = "vi";
            var _emscripten_glDeleteShader = _glDeleteShader;
            _emscripten_glDeleteShader.sig = "vi";

            function _glDeleteTextures(n, textures) {
                textures >>>= 0;
                for (var i = 0; i < n; i++) {
                    var id = HEAP32[textures + i * 4 >>> 2 >>> 0];
                    var texture = GL.textures[id];
                    if (!texture) continue;
                    GLctx.deleteTexture(texture);
                    texture.name = 0;
                    GL.textures[id] = null
                }
            }
            _glDeleteTextures.sig = "vip";
            var _emscripten_glDeleteTextures = _glDeleteTextures;
            _emscripten_glDeleteTextures.sig = "vip";

            function _glDeleteVertexArrays(n, vaos) {
                vaos >>>= 0;
                for (var i = 0; i < n; i++) {
                    var id = HEAP32[vaos + i * 4 >>> 2 >>> 0];
                    GLctx.deleteVertexArray(GL.vaos[id]);
                    GL.vaos[id] = null
                }
            }
            _glDeleteVertexArrays.sig = "vip";
            var _glDeleteVertexArraysOES = _glDeleteVertexArrays;
            _glDeleteVertexArraysOES.sig = "vip";
            var _emscripten_glDeleteVertexArraysOES = _glDeleteVertexArraysOES;
            _emscripten_glDeleteVertexArraysOES.sig = "vip";
            var _glDepthFunc = x0 => GLctx.depthFunc(x0);
            _glDepthFunc.sig = "vi";
            var _emscripten_glDepthFunc = _glDepthFunc;
            _emscripten_glDepthFunc.sig = "vi";
            var _glDepthMask = flag => {
                GLctx.depthMask(!!flag)
            };
            _glDepthMask.sig = "vi";
            var _emscripten_glDepthMask = _glDepthMask;
            _emscripten_glDepthMask.sig = "vi";
            var _glDepthRangef = (x0, x1) => GLctx.depthRange(x0, x1);
            _glDepthRangef.sig = "vff";
            var _emscripten_glDepthRangef = _glDepthRangef;
            _emscripten_glDepthRangef.sig = "vff";
            var _glDetachShader = (program, shader) => {
                GLctx.detachShader(GL.programs[program], GL.shaders[shader])
            };
            _glDetachShader.sig = "vii";
            var _emscripten_glDetachShader = _glDetachShader;
            _emscripten_glDetachShader.sig = "vii";
            var _glDisable = x0 => GLctx.disable(x0);
            _glDisable.sig = "vi";
            var _emscripten_glDisable = _glDisable;
            _emscripten_glDisable.sig = "vi";
            var _glDisableVertexAttribArray = index => {
                GLctx.disableVertexAttribArray(index)
            };
            _glDisableVertexAttribArray.sig = "vi";
            var _emscripten_glDisableVertexAttribArray = _glDisableVertexAttribArray;
            _emscripten_glDisableVertexAttribArray.sig = "vi";
            var _glDrawArrays = (mode, first, count) => {
                GLctx.drawArrays(mode, first, count)
            };
            _glDrawArrays.sig = "viii";
            var _emscripten_glDrawArrays = _glDrawArrays;
            _emscripten_glDrawArrays.sig = "viii";
            var _glDrawArraysInstanced = (mode, first, count, primcount) => {
                GLctx.drawArraysInstanced(mode, first, count, primcount)
            };
            _glDrawArraysInstanced.sig = "viiii";
            var _glDrawArraysInstancedANGLE = _glDrawArraysInstanced;
            var _emscripten_glDrawArraysInstancedANGLE = _glDrawArraysInstancedANGLE;
            var tempFixedLengthArray = [];

            function _glDrawBuffers(n, bufs) {
                bufs >>>= 0;
                var bufArray = tempFixedLengthArray[n];
                for (var i = 0; i < n; i++) {
                    bufArray[i] = HEAP32[bufs + i * 4 >>> 2 >>> 0]
                }
                GLctx.drawBuffers(bufArray)
            }
            _glDrawBuffers.sig = "vip";
            var _glDrawBuffersWEBGL = _glDrawBuffers;
            var _emscripten_glDrawBuffersWEBGL = _glDrawBuffersWEBGL;

            function _glDrawElements(mode, count, type, indices) {
                indices >>>= 0;
                GLctx.drawElements(mode, count, type, indices)
            }
            _glDrawElements.sig = "viiip";
            var _emscripten_glDrawElements = _glDrawElements;
            _emscripten_glDrawElements.sig = "viiip";

            function _glDrawElementsInstanced(mode, count, type, indices, primcount) {
                indices >>>= 0;
                GLctx.drawElementsInstanced(mode, count, type, indices, primcount)
            }
            _glDrawElementsInstanced.sig = "viiipi";
            var _glDrawElementsInstancedANGLE = _glDrawElementsInstanced;
            var _emscripten_glDrawElementsInstancedANGLE = _glDrawElementsInstancedANGLE;
            var _glEnable = x0 => GLctx.enable(x0);
            _glEnable.sig = "vi";
            var _emscripten_glEnable = _glEnable;
            _emscripten_glEnable.sig = "vi";
            var _glEnableVertexAttribArray = index => {
                GLctx.enableVertexAttribArray(index)
            };
            _glEnableVertexAttribArray.sig = "vi";
            var _emscripten_glEnableVertexAttribArray = _glEnableVertexAttribArray;
            _emscripten_glEnableVertexAttribArray.sig = "vi";
            var _glEndQueryEXT = target => {
                GLctx.disjointTimerQueryExt["endQueryEXT"](target)
            };
            _glEndQueryEXT.sig = "vi";
            var _emscripten_glEndQueryEXT = _glEndQueryEXT;
            var _glFinish = () => GLctx.finish();
            _glFinish.sig = "v";
            var _emscripten_glFinish = _glFinish;
            _emscripten_glFinish.sig = "v";
            var _glFlush = () => GLctx.flush();
            _glFlush.sig = "v";
            var _emscripten_glFlush = _glFlush;
            _emscripten_glFlush.sig = "v";
            var _glFramebufferRenderbuffer = (target, attachment, renderbuffertarget, renderbuffer) => {
                GLctx.framebufferRenderbuffer(target, attachment, renderbuffertarget, GL.renderbuffers[renderbuffer])
            };
            _glFramebufferRenderbuffer.sig = "viiii";
            var _emscripten_glFramebufferRenderbuffer = _glFramebufferRenderbuffer;
            _emscripten_glFramebufferRenderbuffer.sig = "viiii";
            var _glFramebufferTexture2D = (target, attachment, textarget, texture, level) => {
                GLctx.framebufferTexture2D(target, attachment, textarget, GL.textures[texture], level)
            };
            _glFramebufferTexture2D.sig = "viiiii";
            var _emscripten_glFramebufferTexture2D = _glFramebufferTexture2D;
            _emscripten_glFramebufferTexture2D.sig = "viiiii";
            var _glFrontFace = x0 => GLctx.frontFace(x0);
            _glFrontFace.sig = "vi";
            var _emscripten_glFrontFace = _glFrontFace;
            _emscripten_glFrontFace.sig = "vi";

            function _glGenBuffers(n, buffers) {
                buffers >>>= 0;
                GL.genObject(n, buffers, "createBuffer", GL.buffers)
            }
            _glGenBuffers.sig = "vip";
            var _emscripten_glGenBuffers = _glGenBuffers;
            _emscripten_glGenBuffers.sig = "vip";

            function _glGenFramebuffers(n, ids) {
                ids >>>= 0;
                GL.genObject(n, ids, "createFramebuffer", GL.framebuffers)
            }
            _glGenFramebuffers.sig = "vip";
            var _emscripten_glGenFramebuffers = _glGenFramebuffers;
            _emscripten_glGenFramebuffers.sig = "vip";

            function _glGenQueriesEXT(n, ids) {
                ids >>>= 0;
                for (var i = 0; i < n; i++) {
                    var query = GLctx.disjointTimerQueryExt["createQueryEXT"]();
                    if (!query) {
                        GL.recordError(1282);
                        while (i < n) HEAP32[ids + i++ * 4 >>> 2 >>> 0] = 0;
                        return
                    }
                    var id = GL.getNewId(GL.queries);
                    query.name = id;
                    GL.queries[id] = query;
                    HEAP32[ids + i * 4 >>> 2 >>> 0] = id
                }
            }
            _glGenQueriesEXT.sig = "vip";
            var _emscripten_glGenQueriesEXT = _glGenQueriesEXT;

            function _glGenRenderbuffers(n, renderbuffers) {
                renderbuffers >>>= 0;
                GL.genObject(n, renderbuffers, "createRenderbuffer", GL.renderbuffers)
            }
            _glGenRenderbuffers.sig = "vip";
            var _emscripten_glGenRenderbuffers = _glGenRenderbuffers;
            _emscripten_glGenRenderbuffers.sig = "vip";

            function _glGenTextures(n, textures) {
                textures >>>= 0;
                GL.genObject(n, textures, "createTexture", GL.textures)
            }
            _glGenTextures.sig = "vip";
            var _emscripten_glGenTextures = _glGenTextures;
            _emscripten_glGenTextures.sig = "vip";

            function _glGenVertexArrays(n, arrays) {
                arrays >>>= 0;
                GL.genObject(n, arrays, "createVertexArray", GL.vaos)
            }
            _glGenVertexArrays.sig = "vip";
            var _glGenVertexArraysOES = _glGenVertexArrays;
            _glGenVertexArraysOES.sig = "vip";
            var _emscripten_glGenVertexArraysOES = _glGenVertexArraysOES;
            _emscripten_glGenVertexArraysOES.sig = "vip";
            var _glGenerateMipmap = x0 => GLctx.generateMipmap(x0);
            _glGenerateMipmap.sig = "vi";
            var _emscripten_glGenerateMipmap = _glGenerateMipmap;
            _emscripten_glGenerateMipmap.sig = "vi";
            var __glGetActiveAttribOrUniform = (funcName, program, index, bufSize, length, size, type, name) => {
                program = GL.programs[program];
                var info = GLctx[funcName](program, index);
                if (info) {
                    var numBytesWrittenExclNull = name && stringToUTF8(info.name, name, bufSize);
                    if (length) HEAP32[length >>> 2 >>> 0] = numBytesWrittenExclNull;
                    if (size) HEAP32[size >>> 2 >>> 0] = info.size;
                    if (type) HEAP32[type >>> 2 >>> 0] = info.type
                }
            };

            function _glGetActiveAttrib(program, index, bufSize, length, size, type, name) {
                length >>>= 0;
                size >>>= 0;
                type >>>= 0;
                name >>>= 0;
                __glGetActiveAttribOrUniform("getActiveAttrib", program, index, bufSize, length, size, type, name)
            }
            _glGetActiveAttrib.sig = "viiipppp";
            var _emscripten_glGetActiveAttrib = _glGetActiveAttrib;
            _emscripten_glGetActiveAttrib.sig = "viiipppp";

            function _glGetActiveUniform(program, index, bufSize, length, size, type, name) {
                length >>>= 0;
                size >>>= 0;
                type >>>= 0;
                name >>>= 0;
                __glGetActiveAttribOrUniform("getActiveUniform", program, index, bufSize, length, size, type, name)
            }
            _glGetActiveUniform.sig = "viiipppp";
            var _emscripten_glGetActiveUniform = _glGetActiveUniform;
            _emscripten_glGetActiveUniform.sig = "viiipppp";

            function _glGetAttachedShaders(program, maxCount, count, shaders) {
                count >>>= 0;
                shaders >>>= 0;
                var result = GLctx.getAttachedShaders(GL.programs[program]);
                var len = result.length;
                if (len > maxCount) {
                    len = maxCount
                }
                HEAP32[count >>> 2 >>> 0] = len;
                for (var i = 0; i < len; ++i) {
                    var id = GL.shaders.indexOf(result[i]);
                    HEAP32[shaders + i * 4 >>> 2 >>> 0] = id
                }
            }
            _glGetAttachedShaders.sig = "viipp";
            var _emscripten_glGetAttachedShaders = _glGetAttachedShaders;
            _emscripten_glGetAttachedShaders.sig = "viipp";

            function _glGetAttribLocation(program, name) {
                name >>>= 0;
                return GLctx.getAttribLocation(GL.programs[program], UTF8ToString(name))
            }
            _glGetAttribLocation.sig = "iip";
            var _emscripten_glGetAttribLocation = _glGetAttribLocation;
            _emscripten_glGetAttribLocation.sig = "iip";
            var writeI53ToI64 = (ptr, num) => {
                HEAPU32[ptr >>> 2 >>> 0] = num;
                var lower = HEAPU32[ptr >>> 2 >>> 0];
                HEAPU32[ptr + 4 >>> 2 >>> 0] = (num - lower) / 4294967296
            };
            var emscriptenWebGLGet = (name_, p, type) => {
                if (!p) {
                    GL.recordError(1281);
                    return
                }
                var ret = undefined;
                switch (name_) {
                    case 36346:
                        ret = 1;
                        break;
                    case 36344:
                        if (type != 0 && type != 1) {
                            GL.recordError(1280)
                        }
                        return;
                    case 36345:
                        ret = 0;
                        break;
                    case 34466:
                        var formats = GLctx.getParameter(34467);
                        ret = formats ? formats.length : 0;
                        break
                }
                if (ret === undefined) {
                    var result = GLctx.getParameter(name_);
                    switch (typeof result) {
                        case "number":
                            ret = result;
                            break;
                        case "boolean":
                            ret = result ? 1 : 0;
                            break;
                        case "string":
                            GL.recordError(1280);
                            return;
                        case "object":
                            if (result === null) {
                                switch (name_) {
                                    case 34964:
                                    case 35725:
                                    case 34965:
                                    case 36006:
                                    case 36007:
                                    case 32873:
                                    case 34229:
                                    case 34068: {
                                        ret = 0;
                                        break
                                    }
                                    default: {
                                        GL.recordError(1280);
                                        return
                                    }
                                }
                            } else if (result instanceof Float32Array || result instanceof Uint32Array || result instanceof Int32Array || result instanceof Array) {
                                for (var i = 0; i < result.length; ++i) {
                                    switch (type) {
                                        case 0:
                                            HEAP32[p + i * 4 >>> 2 >>> 0] = result[i];
                                            break;
                                        case 2:
                                            HEAPF32[p + i * 4 >>> 2 >>> 0] = result[i];
                                            break;
                                        case 4:
                                            HEAP8[p + i >>> 0] = result[i] ? 1 : 0;
                                            break
                                    }
                                }
                                return
                            } else {
                                try {
                                    ret = result.name | 0
                                } catch (e) {
                                    GL.recordError(1280);
                                    err(`GL_INVALID_ENUM in glGet${type}v: Unknown object returned from WebGL getParameter(${name_})! (error: ${e})`);
                                    return
                                }
                            }
                            break;
                        default:
                            GL.recordError(1280);
                            err(`GL_INVALID_ENUM in glGet${type}v: Native code calling glGet${type}v(${name_}) and it returns ${result} of type ${typeof result}!`);
                            return
                    }
                }
                switch (type) {
                    case 1:
                        writeI53ToI64(p, ret);
                        break;
                    case 0:
                        HEAP32[p >>> 2 >>> 0] = ret;
                        break;
                    case 2:
                        HEAPF32[p >>> 2 >>> 0] = ret;
                        break;
                    case 4:
                        HEAP8[p >>> 0] = ret ? 1 : 0;
                        break
                }
            };

            function _glGetBooleanv(name_, p) {
                p >>>= 0;
                return emscriptenWebGLGet(name_, p, 4)
            }
            _glGetBooleanv.sig = "vip";
            var _emscripten_glGetBooleanv = _glGetBooleanv;
            _emscripten_glGetBooleanv.sig = "vip";

            function _glGetBufferParameteriv(target, value, data) {
                data >>>= 0;
                if (!data) {
                    GL.recordError(1281);
                    return
                }
                HEAP32[data >>> 2 >>> 0] = GLctx.getBufferParameter(target, value)
            }
            _glGetBufferParameteriv.sig = "viip";
            var _emscripten_glGetBufferParameteriv = _glGetBufferParameteriv;
            _emscripten_glGetBufferParameteriv.sig = "viip";
            var _glGetError = () => {
                var error = GLctx.getError() || GL.lastError;
                GL.lastError = 0;
                return error
            };
            _glGetError.sig = "i";
            var _emscripten_glGetError = _glGetError;
            _emscripten_glGetError.sig = "i";

            function _glGetFloatv(name_, p) {
                p >>>= 0;
                return emscriptenWebGLGet(name_, p, 2)
            }
            _glGetFloatv.sig = "vip";
            var _emscripten_glGetFloatv = _glGetFloatv;
            _emscripten_glGetFloatv.sig = "vip";

            function _glGetFramebufferAttachmentParameteriv(target, attachment, pname, params) {
                params >>>= 0;
                var result = GLctx.getFramebufferAttachmentParameter(target, attachment, pname);
                if (result instanceof WebGLRenderbuffer || result instanceof WebGLTexture) {
                    result = result.name | 0
                }
                HEAP32[params >>> 2 >>> 0] = result
            }
            _glGetFramebufferAttachmentParameteriv.sig = "viiip";
            var _emscripten_glGetFramebufferAttachmentParameteriv = _glGetFramebufferAttachmentParameteriv;
            _emscripten_glGetFramebufferAttachmentParameteriv.sig = "viiip";

            function _glGetIntegerv(name_, p) {
                p >>>= 0;
                return emscriptenWebGLGet(name_, p, 0)
            }
            _glGetIntegerv.sig = "vip";
            var _emscripten_glGetIntegerv = _glGetIntegerv;
            _emscripten_glGetIntegerv.sig = "vip";

            function _glGetProgramInfoLog(program, maxLength, length, infoLog) {
                length >>>= 0;
                infoLog >>>= 0;
                var log = GLctx.getProgramInfoLog(GL.programs[program]);
                if (log === null) log = "(unknown error)";
                var numBytesWrittenExclNull = maxLength > 0 && infoLog ? stringToUTF8(log, infoLog, maxLength) : 0;
                if (length) HEAP32[length >>> 2 >>> 0] = numBytesWrittenExclNull
            }
            _glGetProgramInfoLog.sig = "viipp";
            var _emscripten_glGetProgramInfoLog = _glGetProgramInfoLog;
            _emscripten_glGetProgramInfoLog.sig = "viipp";

            function _glGetProgramiv(program, pname, p) {
                p >>>= 0;
                if (!p) {
                    GL.recordError(1281);
                    return
                }
                if (program >= GL.counter) {
                    GL.recordError(1281);
                    return
                }
                program = GL.programs[program];
                if (pname == 35716) {
                    var log = GLctx.getProgramInfoLog(program);
                    if (log === null) log = "(unknown error)";
                    HEAP32[p >>> 2 >>> 0] = log.length + 1
                } else if (pname == 35719) {
                    if (!program.maxUniformLength) {
                        var numActiveUniforms = GLctx.getProgramParameter(program, 35718);
                        for (var i = 0; i < numActiveUniforms; ++i) {
                            program.maxUniformLength = Math.max(program.maxUniformLength, GLctx.getActiveUniform(program, i).name.length + 1)
                        }
                    }
                    HEAP32[p >>> 2 >>> 0] = program.maxUniformLength
                } else if (pname == 35722) {
                    if (!program.maxAttributeLength) {
                        var numActiveAttributes = GLctx.getProgramParameter(program, 35721);
                        for (var i = 0; i < numActiveAttributes; ++i) {
                            program.maxAttributeLength = Math.max(program.maxAttributeLength, GLctx.getActiveAttrib(program, i).name.length + 1)
                        }
                    }
                    HEAP32[p >>> 2 >>> 0] = program.maxAttributeLength
                } else if (pname == 35381) {
                    if (!program.maxUniformBlockNameLength) {
                        var numActiveUniformBlocks = GLctx.getProgramParameter(program, 35382);
                        for (var i = 0; i < numActiveUniformBlocks; ++i) {
                            program.maxUniformBlockNameLength = Math.max(program.maxUniformBlockNameLength, GLctx.getActiveUniformBlockName(program, i).length + 1)
                        }
                    }
                    HEAP32[p >>> 2 >>> 0] = program.maxUniformBlockNameLength
                } else {
                    HEAP32[p >>> 2 >>> 0] = GLctx.getProgramParameter(program, pname)
                }
            }
            _glGetProgramiv.sig = "viip";
            var _emscripten_glGetProgramiv = _glGetProgramiv;
            _emscripten_glGetProgramiv.sig = "viip";

            function _glGetQueryObjecti64vEXT(id, pname, params) {
                params >>>= 0;
                if (!params) {
                    GL.recordError(1281);
                    return
                }
                var query = GL.queries[id];
                var param;
                {
                    param = GLctx.disjointTimerQueryExt["getQueryObjectEXT"](query, pname)
                }
                var ret;
                if (typeof param == "boolean") {
                    ret = param ? 1 : 0
                } else {
                    ret = param
                }
                writeI53ToI64(params, ret)
            }
            _glGetQueryObjecti64vEXT.sig = "viip";
            var _emscripten_glGetQueryObjecti64vEXT = _glGetQueryObjecti64vEXT;

            function _glGetQueryObjectivEXT(id, pname, params) {
                params >>>= 0;
                if (!params) {
                    GL.recordError(1281);
                    return
                }
                var query = GL.queries[id];
                var param = GLctx.disjointTimerQueryExt["getQueryObjectEXT"](query, pname);
                var ret;
                if (typeof param == "boolean") {
                    ret = param ? 1 : 0
                } else {
                    ret = param
                }
                HEAP32[params >>> 2 >>> 0] = ret
            }
            _glGetQueryObjectivEXT.sig = "viip";
            var _emscripten_glGetQueryObjectivEXT = _glGetQueryObjectivEXT;
            var _glGetQueryObjectui64vEXT = _glGetQueryObjecti64vEXT;
            var _emscripten_glGetQueryObjectui64vEXT = _glGetQueryObjectui64vEXT;
            var _glGetQueryObjectuivEXT = _glGetQueryObjectivEXT;
            var _emscripten_glGetQueryObjectuivEXT = _glGetQueryObjectuivEXT;

            function _glGetQueryivEXT(target, pname, params) {
                params >>>= 0;
                if (!params) {
                    GL.recordError(1281);
                    return
                }
                HEAP32[params >>> 2 >>> 0] = GLctx.disjointTimerQueryExt["getQueryEXT"](target, pname)
            }
            _glGetQueryivEXT.sig = "viip";
            var _emscripten_glGetQueryivEXT = _glGetQueryivEXT;

            function _glGetRenderbufferParameteriv(target, pname, params) {
                params >>>= 0;
                if (!params) {
                    GL.recordError(1281);
                    return
                }
                HEAP32[params >>> 2 >>> 0] = GLctx.getRenderbufferParameter(target, pname)
            }
            _glGetRenderbufferParameteriv.sig = "viip";
            var _emscripten_glGetRenderbufferParameteriv = _glGetRenderbufferParameteriv;
            _emscripten_glGetRenderbufferParameteriv.sig = "viip";

            function _glGetShaderInfoLog(shader, maxLength, length, infoLog) {
                length >>>= 0;
                infoLog >>>= 0;
                var log = GLctx.getShaderInfoLog(GL.shaders[shader]);
                if (log === null) log = "(unknown error)";
                var numBytesWrittenExclNull = maxLength > 0 && infoLog ? stringToUTF8(log, infoLog, maxLength) : 0;
                if (length) HEAP32[length >>> 2 >>> 0] = numBytesWrittenExclNull
            }
            _glGetShaderInfoLog.sig = "viipp";
            var _emscripten_glGetShaderInfoLog = _glGetShaderInfoLog;
            _emscripten_glGetShaderInfoLog.sig = "viipp";

            function _glGetShaderPrecisionFormat(shaderType, precisionType, range, precision) {
                range >>>= 0;
                precision >>>= 0;
                var result = GLctx.getShaderPrecisionFormat(shaderType, precisionType);
                HEAP32[range >>> 2 >>> 0] = result.rangeMin;
                HEAP32[range + 4 >>> 2 >>> 0] = result.rangeMax;
                HEAP32[precision >>> 2 >>> 0] = result.precision
            }
            _glGetShaderPrecisionFormat.sig = "viipp";
            var _emscripten_glGetShaderPrecisionFormat = _glGetShaderPrecisionFormat;
            _emscripten_glGetShaderPrecisionFormat.sig = "viipp";

            function _glGetShaderSource(shader, bufSize, length, source) {
                length >>>= 0;
                source >>>= 0;
                var result = GLctx.getShaderSource(GL.shaders[shader]);
                if (!result) return;
                var numBytesWrittenExclNull = bufSize > 0 && source ? stringToUTF8(result, source, bufSize) : 0;
                if (length) HEAP32[length >>> 2 >>> 0] = numBytesWrittenExclNull
            }
            _glGetShaderSource.sig = "viipp";
            var _emscripten_glGetShaderSource = _glGetShaderSource;
            _emscripten_glGetShaderSource.sig = "viipp";

            function _glGetShaderiv(shader, pname, p) {
                p >>>= 0;
                if (!p) {
                    GL.recordError(1281);
                    return
                }
                if (pname == 35716) {
                    var log = GLctx.getShaderInfoLog(GL.shaders[shader]);
                    if (log === null) log = "(unknown error)";
                    var logLength = log ? log.length + 1 : 0;
                    HEAP32[p >>> 2 >>> 0] = logLength
                } else if (pname == 35720) {
                    var source = GLctx.getShaderSource(GL.shaders[shader]);
                    var sourceLength = source ? source.length + 1 : 0;
                    HEAP32[p >>> 2 >>> 0] = sourceLength
                } else {
                    HEAP32[p >>> 2 >>> 0] = GLctx.getShaderParameter(GL.shaders[shader], pname)
                }
            }
            _glGetShaderiv.sig = "viip";
            var _emscripten_glGetShaderiv = _glGetShaderiv;
            _emscripten_glGetShaderiv.sig = "viip";
            var webglGetExtensions = function $webglGetExtensions() {
                var exts = getEmscriptenSupportedExtensions(GLctx);
                exts = exts.concat(exts.map(e => "GL_" + e));
                return exts
            };

            function _glGetString(name_) {
                var ret = GL.stringCache[name_];
                if (!ret) {
                    switch (name_) {
                        case 7939:
                            ret = stringToNewUTF8(webglGetExtensions().join(" "));
                            break;
                        case 7936:
                        case 7937:
                        case 37445:
                        case 37446:
                            var s = GLctx.getParameter(name_);
                            if (!s) {
                                GL.recordError(1280)
                            }
                            ret = s ? stringToNewUTF8(s) : 0;
                            break;
                        case 7938:
                            var webGLVersion = GLctx.getParameter(7938);
                            var glVersion = `OpenGL ES 2.0 (${webGLVersion})`;
                            ret = stringToNewUTF8(glVersion);
                            break;
                        case 35724:
                            var glslVersion = GLctx.getParameter(35724);
                            var ver_re = /^WebGL GLSL ES ([0-9]\.[0-9][0-9]?)(?:$| .*)/;
                            var ver_num = glslVersion.match(ver_re);
                            if (ver_num !== null) {
                                if (ver_num[1].length == 3) ver_num[1] = ver_num[1] + "0";
                                glslVersion = `OpenGL ES GLSL ES ${ver_num[1]} (${glslVersion})`
                            }
                            ret = stringToNewUTF8(glslVersion);
                            break;
                        default:
                            GL.recordError(1280)
                    }
                    GL.stringCache[name_] = ret
                }
                return ret
            }
            _glGetString.sig = "pi";
            var _emscripten_glGetString = _glGetString;
            _emscripten_glGetString.sig = "pi";

            function _glGetTexParameterfv(target, pname, params) {
                params >>>= 0;
                if (!params) {
                    GL.recordError(1281);
                    return
                }
                HEAPF32[params >>> 2 >>> 0] = GLctx.getTexParameter(target, pname)
            }
            _glGetTexParameterfv.sig = "viip";
            var _emscripten_glGetTexParameterfv = _glGetTexParameterfv;
            _emscripten_glGetTexParameterfv.sig = "viip";

            function _glGetTexParameteriv(target, pname, params) {
                params >>>= 0;
                if (!params) {
                    GL.recordError(1281);
                    return
                }
                HEAP32[params >>> 2 >>> 0] = GLctx.getTexParameter(target, pname)
            }
            _glGetTexParameteriv.sig = "viip";
            var _emscripten_glGetTexParameteriv = _glGetTexParameteriv;
            _emscripten_glGetTexParameteriv.sig = "viip";
            var webglGetLeftBracePos = name => name.slice(-1) == "]" && name.lastIndexOf("[");
            var webglPrepareUniformLocationsBeforeFirstUse = program => {
                var uniformLocsById = program.uniformLocsById,
                    uniformSizeAndIdsByName = program.uniformSizeAndIdsByName,
                    i, j;
                if (!uniformLocsById) {
                    program.uniformLocsById = uniformLocsById = {};
                    program.uniformArrayNamesById = {};
                    var numActiveUniforms = GLctx.getProgramParameter(program, 35718);
                    for (i = 0; i < numActiveUniforms; ++i) {
                        var u = GLctx.getActiveUniform(program, i);
                        var nm = u.name;
                        var sz = u.size;
                        var lb = webglGetLeftBracePos(nm);
                        var arrayName = lb > 0 ? nm.slice(0, lb) : nm;
                        var id = program.uniformIdCounter;
                        program.uniformIdCounter += sz;
                        uniformSizeAndIdsByName[arrayName] = [sz, id];
                        for (j = 0; j < sz; ++j) {
                            uniformLocsById[id] = j;
                            program.uniformArrayNamesById[id++] = arrayName
                        }
                    }
                }
            };

            function _glGetUniformLocation(program, name) {
                name >>>= 0;
                name = UTF8ToString(name);
                if (program = GL.programs[program]) {
                    webglPrepareUniformLocationsBeforeFirstUse(program);
                    var uniformLocsById = program.uniformLocsById;
                    var arrayIndex = 0;
                    var uniformBaseName = name;
                    var leftBrace = webglGetLeftBracePos(name);
                    if (leftBrace > 0) {
                        arrayIndex = jstoi_q(name.slice(leftBrace + 1)) >>> 0;
                        uniformBaseName = name.slice(0, leftBrace)
                    }
                    var sizeAndId = program.uniformSizeAndIdsByName[uniformBaseName];
                    if (sizeAndId && arrayIndex < sizeAndId[0]) {
                        arrayIndex += sizeAndId[1];
                        if (uniformLocsById[arrayIndex] = uniformLocsById[arrayIndex] || GLctx.getUniformLocation(program, name)) {
                            return arrayIndex
                        }
                    }
                } else {
                    GL.recordError(1281)
                }
                return -1
            }
            _glGetUniformLocation.sig = "iip";
            var _emscripten_glGetUniformLocation = _glGetUniformLocation;
            _emscripten_glGetUniformLocation.sig = "iip";
            var webglGetUniformLocation = location => {
                var p = GLctx.currentProgram;
                if (p) {
                    var webglLoc = p.uniformLocsById[location];
                    if (typeof webglLoc == "number") {
                        p.uniformLocsById[location] = webglLoc = GLctx.getUniformLocation(p, p.uniformArrayNamesById[location] + (webglLoc > 0 ? `[${webglLoc}]` : ""))
                    }
                    return webglLoc
                } else {
                    GL.recordError(1282)
                }
            };
            var emscriptenWebGLGetUniform = (program, location, params, type) => {
                if (!params) {
                    GL.recordError(1281);
                    return
                }
                program = GL.programs[program];
                webglPrepareUniformLocationsBeforeFirstUse(program);
                var data = GLctx.getUniform(program, webglGetUniformLocation(location));
                if (typeof data == "number" || typeof data == "boolean") {
                    switch (type) {
                        case 0:
                            HEAP32[params >>> 2 >>> 0] = data;
                            break;
                        case 2:
                            HEAPF32[params >>> 2 >>> 0] = data;
                            break
                    }
                } else {
                    for (var i = 0; i < data.length; i++) {
                        switch (type) {
                            case 0:
                                HEAP32[params + i * 4 >>> 2 >>> 0] = data[i];
                                break;
                            case 2:
                                HEAPF32[params + i * 4 >>> 2 >>> 0] = data[i];
                                break
                        }
                    }
                }
            };

            function _glGetUniformfv(program, location, params) {
                params >>>= 0;
                emscriptenWebGLGetUniform(program, location, params, 2)
            }
            _glGetUniformfv.sig = "viip";
            var _emscripten_glGetUniformfv = _glGetUniformfv;
            _emscripten_glGetUniformfv.sig = "viip";

            function _glGetUniformiv(program, location, params) {
                params >>>= 0;
                emscriptenWebGLGetUniform(program, location, params, 0)
            }
            _glGetUniformiv.sig = "viip";
            var _emscripten_glGetUniformiv = _glGetUniformiv;
            _emscripten_glGetUniformiv.sig = "viip";

            function _glGetVertexAttribPointerv(index, pname, pointer) {
                pointer >>>= 0;
                if (!pointer) {
                    GL.recordError(1281);
                    return
                }
                HEAP32[pointer >>> 2 >>> 0] = GLctx.getVertexAttribOffset(index, pname)
            }
            _glGetVertexAttribPointerv.sig = "viip";
            var _emscripten_glGetVertexAttribPointerv = _glGetVertexAttribPointerv;
            _emscripten_glGetVertexAttribPointerv.sig = "viip";
            var emscriptenWebGLGetVertexAttrib = (index, pname, params, type) => {
                if (!params) {
                    GL.recordError(1281);
                    return
                }
                var data = GLctx.getVertexAttrib(index, pname);
                if (pname == 34975) {
                    HEAP32[params >>> 2 >>> 0] = data && data["name"]
                } else if (typeof data == "number" || typeof data == "boolean") {
                    switch (type) {
                        case 0:
                            HEAP32[params >>> 2 >>> 0] = data;
                            break;
                        case 2:
                            HEAPF32[params >>> 2 >>> 0] = data;
                            break;
                        case 5:
                            HEAP32[params >>> 2 >>> 0] = Math.fround(data);
                            break
                    }
                } else {
                    for (var i = 0; i < data.length; i++) {
                        switch (type) {
                            case 0:
                                HEAP32[params + i * 4 >>> 2 >>> 0] = data[i];
                                break;
                            case 2:
                                HEAPF32[params + i * 4 >>> 2 >>> 0] = data[i];
                                break;
                            case 5:
                                HEAP32[params + i * 4 >>> 2 >>> 0] = Math.fround(data[i]);
                                break
                        }
                    }
                }
            };

            function _glGetVertexAttribfv(index, pname, params) {
                params >>>= 0;
                emscriptenWebGLGetVertexAttrib(index, pname, params, 2)
            }
            _glGetVertexAttribfv.sig = "viip";
            var _emscripten_glGetVertexAttribfv = _glGetVertexAttribfv;
            _emscripten_glGetVertexAttribfv.sig = "viip";

            function _glGetVertexAttribiv(index, pname, params) {
                params >>>= 0;
                emscriptenWebGLGetVertexAttrib(index, pname, params, 5)
            }
            _glGetVertexAttribiv.sig = "viip";
            var _emscripten_glGetVertexAttribiv = _glGetVertexAttribiv;
            _emscripten_glGetVertexAttribiv.sig = "viip";
            var _glHint = (x0, x1) => GLctx.hint(x0, x1);
            _glHint.sig = "vii";
            var _emscripten_glHint = _glHint;
            _emscripten_glHint.sig = "vii";
            var _glIsBuffer = buffer => {
                var b = GL.buffers[buffer];
                if (!b) return 0;
                return GLctx.isBuffer(b)
            };
            _glIsBuffer.sig = "ii";
            var _emscripten_glIsBuffer = _glIsBuffer;
            _emscripten_glIsBuffer.sig = "ii";
            var _glIsEnabled = x0 => GLctx.isEnabled(x0);
            _glIsEnabled.sig = "ii";
            var _emscripten_glIsEnabled = _glIsEnabled;
            _emscripten_glIsEnabled.sig = "ii";
            var _glIsFramebuffer = framebuffer => {
                var fb = GL.framebuffers[framebuffer];
                if (!fb) return 0;
                return GLctx.isFramebuffer(fb)
            };
            _glIsFramebuffer.sig = "ii";
            var _emscripten_glIsFramebuffer = _glIsFramebuffer;
            _emscripten_glIsFramebuffer.sig = "ii";
            var _glIsProgram = program => {
                program = GL.programs[program];
                if (!program) return 0;
                return GLctx.isProgram(program)
            };
            _glIsProgram.sig = "ii";
            var _emscripten_glIsProgram = _glIsProgram;
            _emscripten_glIsProgram.sig = "ii";
            var _glIsQueryEXT = id => {
                var query = GL.queries[id];
                if (!query) return 0;
                return GLctx.disjointTimerQueryExt["isQueryEXT"](query)
            };
            _glIsQueryEXT.sig = "ii";
            var _emscripten_glIsQueryEXT = _glIsQueryEXT;
            var _glIsRenderbuffer = renderbuffer => {
                var rb = GL.renderbuffers[renderbuffer];
                if (!rb) return 0;
                return GLctx.isRenderbuffer(rb)
            };
            _glIsRenderbuffer.sig = "ii";
            var _emscripten_glIsRenderbuffer = _glIsRenderbuffer;
            _emscripten_glIsRenderbuffer.sig = "ii";
            var _glIsShader = shader => {
                var s = GL.shaders[shader];
                if (!s) return 0;
                return GLctx.isShader(s)
            };
            _glIsShader.sig = "ii";
            var _emscripten_glIsShader = _glIsShader;
            _emscripten_glIsShader.sig = "ii";
            var _glIsTexture = id => {
                var texture = GL.textures[id];
                if (!texture) return 0;
                return GLctx.isTexture(texture)
            };
            _glIsTexture.sig = "ii";
            var _emscripten_glIsTexture = _glIsTexture;
            _emscripten_glIsTexture.sig = "ii";
            var _glIsVertexArray = array => {
                var vao = GL.vaos[array];
                if (!vao) return 0;
                return GLctx.isVertexArray(vao)
            };
            _glIsVertexArray.sig = "ii";
            var _glIsVertexArrayOES = _glIsVertexArray;
            _glIsVertexArrayOES.sig = "ii";
            var _emscripten_glIsVertexArrayOES = _glIsVertexArrayOES;
            _emscripten_glIsVertexArrayOES.sig = "ii";
            var _glLineWidth = x0 => GLctx.lineWidth(x0);
            _glLineWidth.sig = "vf";
            var _emscripten_glLineWidth = _glLineWidth;
            _emscripten_glLineWidth.sig = "vf";
            var _glLinkProgram = program => {
                program = GL.programs[program];
                GLctx.linkProgram(program);
                program.uniformLocsById = 0;
                program.uniformSizeAndIdsByName = {}
            };
            _glLinkProgram.sig = "vi";
            var _emscripten_glLinkProgram = _glLinkProgram;
            _emscripten_glLinkProgram.sig = "vi";
            var _glPixelStorei = (pname, param) => {
                if (pname == 3317) {
                    GL.unpackAlignment = param
                } else if (pname == 3314) {
                    GL.unpackRowLength = param
                }
                GLctx.pixelStorei(pname, param)
            };
            _glPixelStorei.sig = "vii";
            var _emscripten_glPixelStorei = _glPixelStorei;
            _emscripten_glPixelStorei.sig = "vii";
            var _glPolygonModeWEBGL = (face, mode) => {
                GLctx.webglPolygonMode["polygonModeWEBGL"](face, mode)
            };
            _glPolygonModeWEBGL.sig = "vii";
            var _emscripten_glPolygonModeWEBGL = _glPolygonModeWEBGL;
            var _glPolygonOffset = (x0, x1) => GLctx.polygonOffset(x0, x1);
            _glPolygonOffset.sig = "vff";
            var _emscripten_glPolygonOffset = _glPolygonOffset;
            _emscripten_glPolygonOffset.sig = "vff";
            var _glPolygonOffsetClampEXT = (factor, units, clamp) => {
                GLctx.extPolygonOffsetClamp["polygonOffsetClampEXT"](factor, units, clamp)
            };
            _glPolygonOffsetClampEXT.sig = "vfff";
            var _emscripten_glPolygonOffsetClampEXT = _glPolygonOffsetClampEXT;
            var _glQueryCounterEXT = (id, target) => {
                GLctx.disjointTimerQueryExt["queryCounterEXT"](GL.queries[id], target)
            };
            _glQueryCounterEXT.sig = "vii";
            var _emscripten_glQueryCounterEXT = _glQueryCounterEXT;
            var computeUnpackAlignedImageSize = (width, height, sizePerPixel) => {
                function roundedToNextMultipleOf(x, y) {
                    return x + y - 1 & -y
                }
                var plainRowSize = (GL.unpackRowLength || width) * sizePerPixel;
                var alignedRowSize = roundedToNextMultipleOf(plainRowSize, GL.unpackAlignment);
                return height * alignedRowSize
            };
            var colorChannelsInGlTextureFormat = format => {
                var colorChannels = {
                    5: 3,
                    6: 4,
                    8: 2,
                    29502: 3,
                    29504: 4
                };
                return colorChannels[format - 6402] || 1
            };
            var heapObjectForWebGLType = type => {
                type -= 5120;
                if (type == 1) return HEAPU8;
                if (type == 4) return HEAP32;
                if (type == 6) return HEAPF32;
                if (type == 5 || type == 28922) return HEAPU32;
                return HEAPU16
            };
            var toTypedArrayIndex = (pointer, heap) => pointer >>> 31 - Math.clz32(heap.BYTES_PER_ELEMENT);
            var emscriptenWebGLGetTexPixelData = (type, format, width, height, pixels, internalFormat) => {
                var heap = heapObjectForWebGLType(type);
                var sizePerPixel = colorChannelsInGlTextureFormat(format) * heap.BYTES_PER_ELEMENT;
                var bytes = computeUnpackAlignedImageSize(width, height, sizePerPixel);
                return heap.subarray(toTypedArrayIndex(pixels, heap) >>> 0, toTypedArrayIndex(pixels + bytes, heap) >>> 0)
            };

            function _glReadPixels(x, y, width, height, format, type, pixels) {
                pixels >>>= 0;
                var pixelData = emscriptenWebGLGetTexPixelData(type, format, width, height, pixels, format);
                if (!pixelData) {
                    GL.recordError(1280);
                    return
                }
                GLctx.readPixels(x, y, width, height, format, type, pixelData)
            }
            _glReadPixels.sig = "viiiiiip";
            var _emscripten_glReadPixels = _glReadPixels;
            _emscripten_glReadPixels.sig = "viiiiiip";
            var _glReleaseShaderCompiler = () => {};
            _glReleaseShaderCompiler.sig = "v";
            var _emscripten_glReleaseShaderCompiler = _glReleaseShaderCompiler;
            _emscripten_glReleaseShaderCompiler.sig = "v";
            var _glRenderbufferStorage = (x0, x1, x2, x3) => GLctx.renderbufferStorage(x0, x1, x2, x3);
            _glRenderbufferStorage.sig = "viiii";
            var _emscripten_glRenderbufferStorage = _glRenderbufferStorage;
            _emscripten_glRenderbufferStorage.sig = "viiii";
            var _glSampleCoverage = (value, invert) => {
                GLctx.sampleCoverage(value, !!invert)
            };
            _glSampleCoverage.sig = "vfi";
            var _emscripten_glSampleCoverage = _glSampleCoverage;
            _emscripten_glSampleCoverage.sig = "vfi";
            var _glScissor = (x0, x1, x2, x3) => GLctx.scissor(x0, x1, x2, x3);
            _glScissor.sig = "viiii";
            var _emscripten_glScissor = _glScissor;
            _emscripten_glScissor.sig = "viiii";

            function _glShaderBinary(count, shaders, binaryformat, binary, length) {
                shaders >>>= 0;
                binary >>>= 0;
                GL.recordError(1280)
            }
            _glShaderBinary.sig = "vipipi";
            var _emscripten_glShaderBinary = _glShaderBinary;
            _emscripten_glShaderBinary.sig = "vipipi";

            function _glShaderSource(shader, count, string, length) {
                string >>>= 0;
                length >>>= 0;
                var source = GL.getSource(shader, count, string, length);
                GLctx.shaderSource(GL.shaders[shader], source)
            }
            _glShaderSource.sig = "viipp";
            var _emscripten_glShaderSource = _glShaderSource;
            _emscripten_glShaderSource.sig = "viipp";
            var _glStencilFunc = (x0, x1, x2) => GLctx.stencilFunc(x0, x1, x2);
            _glStencilFunc.sig = "viii";
            var _emscripten_glStencilFunc = _glStencilFunc;
            _emscripten_glStencilFunc.sig = "viii";
            var _glStencilFuncSeparate = (x0, x1, x2, x3) => GLctx.stencilFuncSeparate(x0, x1, x2, x3);
            _glStencilFuncSeparate.sig = "viiii";
            var _emscripten_glStencilFuncSeparate = _glStencilFuncSeparate;
            _emscripten_glStencilFuncSeparate.sig = "viiii";
            var _glStencilMask = x0 => GLctx.stencilMask(x0);
            _glStencilMask.sig = "vi";
            var _emscripten_glStencilMask = _glStencilMask;
            _emscripten_glStencilMask.sig = "vi";
            var _glStencilMaskSeparate = (x0, x1) => GLctx.stencilMaskSeparate(x0, x1);
            _glStencilMaskSeparate.sig = "vii";
            var _emscripten_glStencilMaskSeparate = _glStencilMaskSeparate;
            _emscripten_glStencilMaskSeparate.sig = "vii";
            var _glStencilOp = (x0, x1, x2) => GLctx.stencilOp(x0, x1, x2);
            _glStencilOp.sig = "viii";
            var _emscripten_glStencilOp = _glStencilOp;
            _emscripten_glStencilOp.sig = "viii";
            var _glStencilOpSeparate = (x0, x1, x2, x3) => GLctx.stencilOpSeparate(x0, x1, x2, x3);
            _glStencilOpSeparate.sig = "viiii";
            var _emscripten_glStencilOpSeparate = _glStencilOpSeparate;
            _emscripten_glStencilOpSeparate.sig = "viiii";

            function _glTexImage2D(target, level, internalFormat, width, height, border, format, type, pixels) {
                pixels >>>= 0;
                var pixelData = pixels ? emscriptenWebGLGetTexPixelData(type, format, width, height, pixels, internalFormat) : null;
                GLctx.texImage2D(target, level, internalFormat, width, height, border, format, type, pixelData)
            }
            _glTexImage2D.sig = "viiiiiiiip";
            var _emscripten_glTexImage2D = _glTexImage2D;
            _emscripten_glTexImage2D.sig = "viiiiiiiip";
            var _glTexParameterf = (x0, x1, x2) => GLctx.texParameterf(x0, x1, x2);
            _glTexParameterf.sig = "viif";
            var _emscripten_glTexParameterf = _glTexParameterf;
            _emscripten_glTexParameterf.sig = "viif";

            function _glTexParameterfv(target, pname, params) {
                params >>>= 0;
                var param = HEAPF32[params >>> 2 >>> 0];
                GLctx.texParameterf(target, pname, param)
            }
            _glTexParameterfv.sig = "viip";
            var _emscripten_glTexParameterfv = _glTexParameterfv;
            _emscripten_glTexParameterfv.sig = "viip";
            var _glTexParameteri = (x0, x1, x2) => GLctx.texParameteri(x0, x1, x2);
            _glTexParameteri.sig = "viii";
            var _emscripten_glTexParameteri = _glTexParameteri;
            _emscripten_glTexParameteri.sig = "viii";

            function _glTexParameteriv(target, pname, params) {
                params >>>= 0;
                var param = HEAP32[params >>> 2 >>> 0];
                GLctx.texParameteri(target, pname, param)
            }
            _glTexParameteriv.sig = "viip";
            var _emscripten_glTexParameteriv = _glTexParameteriv;
            _emscripten_glTexParameteriv.sig = "viip";

            function _glTexSubImage2D(target, level, xoffset, yoffset, width, height, format, type, pixels) {
                pixels >>>= 0;
                var pixelData = pixels ? emscriptenWebGLGetTexPixelData(type, format, width, height, pixels, 0) : null;
                GLctx.texSubImage2D(target, level, xoffset, yoffset, width, height, format, type, pixelData)
            }
            _glTexSubImage2D.sig = "viiiiiiiip";
            var _emscripten_glTexSubImage2D = _glTexSubImage2D;
            _emscripten_glTexSubImage2D.sig = "viiiiiiiip";
            var _glUniform1f = (location, v0) => {
                GLctx.uniform1f(webglGetUniformLocation(location), v0)
            };
            _glUniform1f.sig = "vif";
            var _emscripten_glUniform1f = _glUniform1f;
            _emscripten_glUniform1f.sig = "vif";
            var miniTempWebGLFloatBuffers = [];

            function _glUniform1fv(location, count, value) {
                value >>>= 0;
                if (count <= 288) {
                    var view = miniTempWebGLFloatBuffers[count];
                    for (var i = 0; i < count; ++i) {
                        view[i] = HEAPF32[value + 4 * i >>> 2 >>> 0]
                    }
                } else {
                    var view = HEAPF32.subarray(value >>> 2 >>> 0, value + count * 4 >>> 2 >>> 0)
                }
                GLctx.uniform1fv(webglGetUniformLocation(location), view)
            }
            _glUniform1fv.sig = "viip";
            var _emscripten_glUniform1fv = _glUniform1fv;
            _emscripten_glUniform1fv.sig = "viip";
            var _glUniform1i = (location, v0) => {
                GLctx.uniform1i(webglGetUniformLocation(location), v0)
            };
            _glUniform1i.sig = "vii";
            var _emscripten_glUniform1i = _glUniform1i;
            _emscripten_glUniform1i.sig = "vii";
            var miniTempWebGLIntBuffers = [];

            function _glUniform1iv(location, count, value) {
                value >>>= 0;
                if (count <= 288) {
                    var view = miniTempWebGLIntBuffers[count];
                    for (var i = 0; i < count; ++i) {
                        view[i] = HEAP32[value + 4 * i >>> 2 >>> 0]
                    }
                } else {
                    var view = HEAP32.subarray(value >>> 2 >>> 0, value + count * 4 >>> 2 >>> 0)
                }
                GLctx.uniform1iv(webglGetUniformLocation(location), view)
            }
            _glUniform1iv.sig = "viip";
            var _emscripten_glUniform1iv = _glUniform1iv;
            _emscripten_glUniform1iv.sig = "viip";
            var _glUniform2f = (location, v0, v1) => {
                GLctx.uniform2f(webglGetUniformLocation(location), v0, v1)
            };
            _glUniform2f.sig = "viff";
            var _emscripten_glUniform2f = _glUniform2f;
            _emscripten_glUniform2f.sig = "viff";

            function _glUniform2fv(location, count, value) {
                value >>>= 0;
                if (count <= 144) {
                    count *= 2;
                    var view = miniTempWebGLFloatBuffers[count];
                    for (var i = 0; i < count; i += 2) {
                        view[i] = HEAPF32[value + 4 * i >>> 2 >>> 0];
                        view[i + 1] = HEAPF32[value + (4 * i + 4) >>> 2 >>> 0]
                    }
                } else {
                    var view = HEAPF32.subarray(value >>> 2 >>> 0, value + count * 8 >>> 2 >>> 0)
                }
                GLctx.uniform2fv(webglGetUniformLocation(location), view)
            }
            _glUniform2fv.sig = "viip";
            var _emscripten_glUniform2fv = _glUniform2fv;
            _emscripten_glUniform2fv.sig = "viip";
            var _glUniform2i = (location, v0, v1) => {
                GLctx.uniform2i(webglGetUniformLocation(location), v0, v1)
            };
            _glUniform2i.sig = "viii";
            var _emscripten_glUniform2i = _glUniform2i;
            _emscripten_glUniform2i.sig = "viii";

            function _glUniform2iv(location, count, value) {
                value >>>= 0;
                if (count <= 144) {
                    count *= 2;
                    var view = miniTempWebGLIntBuffers[count];
                    for (var i = 0; i < count; i += 2) {
                        view[i] = HEAP32[value + 4 * i >>> 2 >>> 0];
                        view[i + 1] = HEAP32[value + (4 * i + 4) >>> 2 >>> 0]
                    }
                } else {
                    var view = HEAP32.subarray(value >>> 2 >>> 0, value + count * 8 >>> 2 >>> 0)
                }
                GLctx.uniform2iv(webglGetUniformLocation(location), view)
            }
            _glUniform2iv.sig = "viip";
            var _emscripten_glUniform2iv = _glUniform2iv;
            _emscripten_glUniform2iv.sig = "viip";
            var _glUniform3f = (location, v0, v1, v2) => {
                GLctx.uniform3f(webglGetUniformLocation(location), v0, v1, v2)
            };
            _glUniform3f.sig = "vifff";
            var _emscripten_glUniform3f = _glUniform3f;
            _emscripten_glUniform3f.sig = "vifff";

            function _glUniform3fv(location, count, value) {
                value >>>= 0;
                if (count <= 96) {
                    count *= 3;
                    var view = miniTempWebGLFloatBuffers[count];
                    for (var i = 0; i < count; i += 3) {
                        view[i] = HEAPF32[value + 4 * i >>> 2 >>> 0];
                        view[i + 1] = HEAPF32[value + (4 * i + 4) >>> 2 >>> 0];
                        view[i + 2] = HEAPF32[value + (4 * i + 8) >>> 2 >>> 0]
                    }
                } else {
                    var view = HEAPF32.subarray(value >>> 2 >>> 0, value + count * 12 >>> 2 >>> 0)
                }
                GLctx.uniform3fv(webglGetUniformLocation(location), view)
            }
            _glUniform3fv.sig = "viip";
            var _emscripten_glUniform3fv = _glUniform3fv;
            _emscripten_glUniform3fv.sig = "viip";
            var _glUniform3i = (location, v0, v1, v2) => {
                GLctx.uniform3i(webglGetUniformLocation(location), v0, v1, v2)
            };
            _glUniform3i.sig = "viiii";
            var _emscripten_glUniform3i = _glUniform3i;
            _emscripten_glUniform3i.sig = "viiii";

            function _glUniform3iv(location, count, value) {
                value >>>= 0;
                if (count <= 96) {
                    count *= 3;
                    var view = miniTempWebGLIntBuffers[count];
                    for (var i = 0; i < count; i += 3) {
                        view[i] = HEAP32[value + 4 * i >>> 2 >>> 0];
                        view[i + 1] = HEAP32[value + (4 * i + 4) >>> 2 >>> 0];
                        view[i + 2] = HEAP32[value + (4 * i + 8) >>> 2 >>> 0]
                    }
                } else {
                    var view = HEAP32.subarray(value >>> 2 >>> 0, value + count * 12 >>> 2 >>> 0)
                }
                GLctx.uniform3iv(webglGetUniformLocation(location), view)
            }
            _glUniform3iv.sig = "viip";
            var _emscripten_glUniform3iv = _glUniform3iv;
            _emscripten_glUniform3iv.sig = "viip";
            var _glUniform4f = (location, v0, v1, v2, v3) => {
                GLctx.uniform4f(webglGetUniformLocation(location), v0, v1, v2, v3)
            };
            _glUniform4f.sig = "viffff";
            var _emscripten_glUniform4f = _glUniform4f;
            _emscripten_glUniform4f.sig = "viffff";

            function _glUniform4fv(location, count, value) {
                value >>>= 0;
                if (count <= 72) {
                    var view = miniTempWebGLFloatBuffers[4 * count];
                    var heap = HEAPF32;
                    value = value >>> 2;
                    count *= 4;
                    for (var i = 0; i < count; i += 4) {
                        var dst = value + i;
                        view[i] = heap[dst >>> 0];
                        view[i + 1] = heap[dst + 1 >>> 0];
                        view[i + 2] = heap[dst + 2 >>> 0];
                        view[i + 3] = heap[dst + 3 >>> 0]
                    }
                } else {
                    var view = HEAPF32.subarray(value >>> 2 >>> 0, value + count * 16 >>> 2 >>> 0)
                }
                GLctx.uniform4fv(webglGetUniformLocation(location), view)
            }
            _glUniform4fv.sig = "viip";
            var _emscripten_glUniform4fv = _glUniform4fv;
            _emscripten_glUniform4fv.sig = "viip";
            var _glUniform4i = (location, v0, v1, v2, v3) => {
                GLctx.uniform4i(webglGetUniformLocation(location), v0, v1, v2, v3)
            };
            _glUniform4i.sig = "viiiii";
            var _emscripten_glUniform4i = _glUniform4i;
            _emscripten_glUniform4i.sig = "viiiii";

            function _glUniform4iv(location, count, value) {
                value >>>= 0;
                if (count <= 72) {
                    count *= 4;
                    var view = miniTempWebGLIntBuffers[count];
                    for (var i = 0; i < count; i += 4) {
                        view[i] = HEAP32[value + 4 * i >>> 2 >>> 0];
                        view[i + 1] = HEAP32[value + (4 * i + 4) >>> 2 >>> 0];
                        view[i + 2] = HEAP32[value + (4 * i + 8) >>> 2 >>> 0];
                        view[i + 3] = HEAP32[value + (4 * i + 12) >>> 2 >>> 0]
                    }
                } else {
                    var view = HEAP32.subarray(value >>> 2 >>> 0, value + count * 16 >>> 2 >>> 0)
                }
                GLctx.uniform4iv(webglGetUniformLocation(location), view)
            }
            _glUniform4iv.sig = "viip";
            var _emscripten_glUniform4iv = _glUniform4iv;
            _emscripten_glUniform4iv.sig = "viip";

            function _glUniformMatrix2fv(location, count, transpose, value) {
                value >>>= 0;
                if (count <= 72) {
                    count *= 4;
                    var view = miniTempWebGLFloatBuffers[count];
                    for (var i = 0; i < count; i += 4) {
                        view[i] = HEAPF32[value + 4 * i >>> 2 >>> 0];
                        view[i + 1] = HEAPF32[value + (4 * i + 4) >>> 2 >>> 0];
                        view[i + 2] = HEAPF32[value + (4 * i + 8) >>> 2 >>> 0];
                        view[i + 3] = HEAPF32[value + (4 * i + 12) >>> 2 >>> 0]
                    }
                } else {
                    var view = HEAPF32.subarray(value >>> 2 >>> 0, value + count * 16 >>> 2 >>> 0)
                }
                GLctx.uniformMatrix2fv(webglGetUniformLocation(location), !!transpose, view)
            }
            _glUniformMatrix2fv.sig = "viiip";
            var _emscripten_glUniformMatrix2fv = _glUniformMatrix2fv;
            _emscripten_glUniformMatrix2fv.sig = "viiip";

            function _glUniformMatrix3fv(location, count, transpose, value) {
                value >>>= 0;
                if (count <= 32) {
                    count *= 9;
                    var view = miniTempWebGLFloatBuffers[count];
                    for (var i = 0; i < count; i += 9) {
                        view[i] = HEAPF32[value + 4 * i >>> 2 >>> 0];
                        view[i + 1] = HEAPF32[value + (4 * i + 4) >>> 2 >>> 0];
                        view[i + 2] = HEAPF32[value + (4 * i + 8) >>> 2 >>> 0];
                        view[i + 3] = HEAPF32[value + (4 * i + 12) >>> 2 >>> 0];
                        view[i + 4] = HEAPF32[value + (4 * i + 16) >>> 2 >>> 0];
                        view[i + 5] = HEAPF32[value + (4 * i + 20) >>> 2 >>> 0];
                        view[i + 6] = HEAPF32[value + (4 * i + 24) >>> 2 >>> 0];
                        view[i + 7] = HEAPF32[value + (4 * i + 28) >>> 2 >>> 0];
                        view[i + 8] = HEAPF32[value + (4 * i + 32) >>> 2 >>> 0]
                    }
                } else {
                    var view = HEAPF32.subarray(value >>> 2 >>> 0, value + count * 36 >>> 2 >>> 0)
                }
                GLctx.uniformMatrix3fv(webglGetUniformLocation(location), !!transpose, view)
            }
            _glUniformMatrix3fv.sig = "viiip";
            var _emscripten_glUniformMatrix3fv = _glUniformMatrix3fv;
            _emscripten_glUniformMatrix3fv.sig = "viiip";

            function _glUniformMatrix4fv(location, count, transpose, value) {
                value >>>= 0;
                if (count <= 18) {
                    var view = miniTempWebGLFloatBuffers[16 * count];
                    var heap = HEAPF32;
                    value = value >>> 2;
                    count *= 16;
                    for (var i = 0; i < count; i += 16) {
                        var dst = value + i;
                        view[i] = heap[dst >>> 0];
                        view[i + 1] = heap[dst + 1 >>> 0];
                        view[i + 2] = heap[dst + 2 >>> 0];
                        view[i + 3] = heap[dst + 3 >>> 0];
                        view[i + 4] = heap[dst + 4 >>> 0];
                        view[i + 5] = heap[dst + 5 >>> 0];
                        view[i + 6] = heap[dst + 6 >>> 0];
                        view[i + 7] = heap[dst + 7 >>> 0];
                        view[i + 8] = heap[dst + 8 >>> 0];
                        view[i + 9] = heap[dst + 9 >>> 0];
                        view[i + 10] = heap[dst + 10 >>> 0];
                        view[i + 11] = heap[dst + 11 >>> 0];
                        view[i + 12] = heap[dst + 12 >>> 0];
                        view[i + 13] = heap[dst + 13 >>> 0];
                        view[i + 14] = heap[dst + 14 >>> 0];
                        view[i + 15] = heap[dst + 15 >>> 0]
                    }
                } else {
                    var view = HEAPF32.subarray(value >>> 2 >>> 0, value + count * 64 >>> 2 >>> 0)
                }
                GLctx.uniformMatrix4fv(webglGetUniformLocation(location), !!transpose, view)
            }
            _glUniformMatrix4fv.sig = "viiip";
            var _emscripten_glUniformMatrix4fv = _glUniformMatrix4fv;
            _emscripten_glUniformMatrix4fv.sig = "viiip";
            var _glUseProgram = program => {
                program = GL.programs[program];
                GLctx.useProgram(program);
                GLctx.currentProgram = program
            };
            _glUseProgram.sig = "vi";
            var _emscripten_glUseProgram = _glUseProgram;
            _emscripten_glUseProgram.sig = "vi";
            var _glValidateProgram = program => {
                GLctx.validateProgram(GL.programs[program])
            };
            _glValidateProgram.sig = "vi";
            var _emscripten_glValidateProgram = _glValidateProgram;
            _emscripten_glValidateProgram.sig = "vi";
            var _glVertexAttrib1f = (x0, x1) => GLctx.vertexAttrib1f(x0, x1);
            _glVertexAttrib1f.sig = "vif";
            var _emscripten_glVertexAttrib1f = _glVertexAttrib1f;
            _emscripten_glVertexAttrib1f.sig = "vif";

            function _glVertexAttrib1fv(index, v) {
                v >>>= 0;
                GLctx.vertexAttrib1f(index, HEAPF32[v >>> 2])
            }
            _glVertexAttrib1fv.sig = "vip";
            var _emscripten_glVertexAttrib1fv = _glVertexAttrib1fv;
            _emscripten_glVertexAttrib1fv.sig = "vip";
            var _glVertexAttrib2f = (x0, x1, x2) => GLctx.vertexAttrib2f(x0, x1, x2);
            _glVertexAttrib2f.sig = "viff";
            var _emscripten_glVertexAttrib2f = _glVertexAttrib2f;
            _emscripten_glVertexAttrib2f.sig = "viff";

            function _glVertexAttrib2fv(index, v) {
                v >>>= 0;
                GLctx.vertexAttrib2f(index, HEAPF32[v >>> 2], HEAPF32[v + 4 >>> 2])
            }
            _glVertexAttrib2fv.sig = "vip";
            var _emscripten_glVertexAttrib2fv = _glVertexAttrib2fv;
            _emscripten_glVertexAttrib2fv.sig = "vip";
            var _glVertexAttrib3f = (x0, x1, x2, x3) => GLctx.vertexAttrib3f(x0, x1, x2, x3);
            _glVertexAttrib3f.sig = "vifff";
            var _emscripten_glVertexAttrib3f = _glVertexAttrib3f;
            _emscripten_glVertexAttrib3f.sig = "vifff";

            function _glVertexAttrib3fv(index, v) {
                v >>>= 0;
                GLctx.vertexAttrib3f(index, HEAPF32[v >>> 2], HEAPF32[v + 4 >>> 2], HEAPF32[v + 8 >>> 2])
            }
            _glVertexAttrib3fv.sig = "vip";
            var _emscripten_glVertexAttrib3fv = _glVertexAttrib3fv;
            _emscripten_glVertexAttrib3fv.sig = "vip";
            var _glVertexAttrib4f = (x0, x1, x2, x3, x4) => GLctx.vertexAttrib4f(x0, x1, x2, x3, x4);
            _glVertexAttrib4f.sig = "viffff";
            var _emscripten_glVertexAttrib4f = _glVertexAttrib4f;
            _emscripten_glVertexAttrib4f.sig = "viffff";

            function _glVertexAttrib4fv(index, v) {
                v >>>= 0;
                GLctx.vertexAttrib4f(index, HEAPF32[v >>> 2], HEAPF32[v + 4 >>> 2], HEAPF32[v + 8 >>> 2], HEAPF32[v + 12 >>> 2])
            }
            _glVertexAttrib4fv.sig = "vip";
            var _emscripten_glVertexAttrib4fv = _glVertexAttrib4fv;
            _emscripten_glVertexAttrib4fv.sig = "vip";
            var _glVertexAttribDivisor = (index, divisor) => {
                GLctx.vertexAttribDivisor(index, divisor)
            };
            _glVertexAttribDivisor.sig = "vii";
            var _glVertexAttribDivisorANGLE = _glVertexAttribDivisor;
            var _emscripten_glVertexAttribDivisorANGLE = _glVertexAttribDivisorANGLE;

            function _glVertexAttribPointer(index, size, type, normalized, stride, ptr) {
                ptr >>>= 0;
                GLctx.vertexAttribPointer(index, size, type, !!normalized, stride, ptr)
            }
            _glVertexAttribPointer.sig = "viiiiip";
            var _emscripten_glVertexAttribPointer = _glVertexAttribPointer;
            _emscripten_glVertexAttribPointer.sig = "viiiiip";
            var _glViewport = (x0, x1, x2, x3) => GLctx.viewport(x0, x1, x2, x3);
            _glViewport.sig = "viiii";
            var _emscripten_glViewport = _glViewport;
            _emscripten_glViewport.sig = "viiii";

            function _emscripten_out(str) {
                str >>>= 0;
                return out(UTF8ToString(str))
            }
            _emscripten_out.sig = "vp";
            class HandleAllocator {
                allocated = [undefined];
                freelist = [];
                get(id) {
                    return this.allocated[id]
                }
                has(id) {
                    return this.allocated[id] !== undefined
                }
                allocate(handle) {
                    var id = this.freelist.pop() || this.allocated.length;
                    this.allocated[id] = handle;
                    return id
                }
                free(id) {
                    this.allocated[id] = undefined;
                    this.freelist.push(id)
                }
            }
            var promiseMap = new HandleAllocator;
            var makePromise = () => {
                var promiseInfo = {};
                promiseInfo.promise = new Promise((resolve, reject) => {
                    promiseInfo.reject = reject;
                    promiseInfo.resolve = resolve
                });
                promiseInfo.id = promiseMap.allocate(promiseInfo);
                return promiseInfo
            };

            function _emscripten_promise_create() {
                return makePromise().id
            }
            _emscripten_promise_create.sig = "p";

            function _emscripten_promise_destroy(id) {
                id >>>= 0;
                promiseMap.free(id)
            }
            _emscripten_promise_destroy.sig = "vp";
            var getPromise = id => promiseMap.get(id).promise;

            function _emscripten_promise_resolve(id, result, value) {
                id >>>= 0;
                value >>>= 0;
                var info = promiseMap.get(id);
                switch (result) {
                    case 0:
                        info.resolve(value);
                        return;
                    case 1:
                        info.resolve(getPromise(value));
                        return;
                    case 2:
                        info.resolve(getPromise(value));
                        _emscripten_promise_destroy(value);
                        return;
                    case 3:
                        info.reject(value);
                        return
                }
            }
            _emscripten_promise_resolve.sig = "vpip";
            var growMemory = size => {
                var b = wasmMemory.buffer;
                var pages = (size - b.byteLength + 65535) / 65536 | 0;
                try {
                    wasmMemory.grow(pages);
                    updateMemoryViews();
                    return 1
                } catch (e) {}
            };

            function _emscripten_resize_heap(requestedSize) {
                requestedSize >>>= 0;
                var oldSize = HEAPU8.length;
                var maxHeapSize = getHeapMax();
                if (requestedSize > maxHeapSize) {
                    return false
                }
                for (var cutDown = 1; cutDown <= 4; cutDown *= 2) {
                    var overGrownHeapSize = oldSize * (1 + .2 / cutDown);
                    overGrownHeapSize = Math.min(overGrownHeapSize, requestedSize + 100663296);
                    var newSize = Math.min(maxHeapSize, alignMemory(Math.max(requestedSize, overGrownHeapSize), 65536));
                    var replacement = growMemory(newSize);
                    if (replacement) {
                        return true
                    }
                }
                return false
            }
            _emscripten_resize_heap.sig = "ip";

            function _emscripten_wget_data(url, pbuffer, pnum, perror) {
                url >>>= 0;
                pbuffer >>>= 0;
                pnum >>>= 0;
                perror >>>= 0;
                throw "Please compile your program with async support in order to use asynchronous operations like emscripten_wget_data"
            }
            _emscripten_wget_data.sig = "vpppp";
            var getEnvStrings = () => {
                if (!getEnvStrings.strings) {
                    var lang = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8";
                    var env = {
                        USER: "web_user",
                        LOGNAME: "web_user",
                        PATH: "/",
                        PWD: "/",
                        HOME: "/home/web_user",
                        LANG: lang,
                        _: getExecutableName()
                    };
                    for (var x in ENV) {
                        if (ENV[x] === undefined) delete env[x];
                        else env[x] = ENV[x]
                    }
                    var strings = [];
                    for (var x in env) {
                        strings.push(`${x}=${env[x]}`)
                    }
                    getEnvStrings.strings = strings
                }
                return getEnvStrings.strings
            };
            var stringToAscii = (str, buffer) => {
                for (var i = 0; i < str.length; ++i) {
                    HEAP8[buffer++ >>> 0] = str.charCodeAt(i)
                }
                HEAP8[buffer >>> 0] = 0
            };
            var _environ_get = function(__environ, environ_buf) {
                __environ >>>= 0;
                environ_buf >>>= 0;
                var bufSize = 0;
                getEnvStrings().forEach((string, i) => {
                    var ptr = environ_buf + bufSize;
                    HEAPU32[__environ + i * 4 >>> 2 >>> 0] = ptr;
                    stringToAscii(string, ptr);
                    bufSize += string.length + 1
                });
                return 0
            };
            _environ_get.sig = "ipp";
            var _environ_sizes_get = function(penviron_count, penviron_buf_size) {
                penviron_count >>>= 0;
                penviron_buf_size >>>= 0;
                var strings = getEnvStrings();
                HEAPU32[penviron_count >>> 2 >>> 0] = strings.length;
                var bufSize = 0;
                strings.forEach(string => bufSize += string.length + 1);
                HEAPU32[penviron_buf_size >>> 2 >>> 0] = bufSize;
                return 0
            };
            _environ_sizes_get.sig = "ipp";

            function _fd_close(fd) {
                try {
                    var stream = SYSCALLS.getStreamFromFD(fd);
                    FS.close(stream);
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return e.errno
                }
            }
            _fd_close.sig = "ii";

            function _fd_fdstat_get(fd, pbuf) {
                pbuf >>>= 0;
                try {
                    var rightsBase = 0;
                    var rightsInheriting = 0;
                    var flags = 0;
                    {
                        var stream = SYSCALLS.getStreamFromFD(fd);
                        var type = stream.tty ? 2 : FS.isDir(stream.mode) ? 3 : FS.isLink(stream.mode) ? 7 : 4
                    }
                    HEAP8[pbuf >>> 0] = type;
                    HEAP16[pbuf + 2 >>> 1 >>> 0] = flags;
                    tempI64 = [rightsBase >>> 0, (tempDouble = rightsBase, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[pbuf + 8 >>> 2 >>> 0] = tempI64[0], HEAP32[pbuf + 12 >>> 2 >>> 0] = tempI64[1];
                    tempI64 = [rightsInheriting >>> 0, (tempDouble = rightsInheriting, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[pbuf + 16 >>> 2 >>> 0] = tempI64[0], HEAP32[pbuf + 20 >>> 2 >>> 0] = tempI64[1];
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return e.errno
                }
            }
            _fd_fdstat_get.sig = "iip";
            var doReadv = (stream, iov, iovcnt, offset) => {
                var ret = 0;
                for (var i = 0; i < iovcnt; i++) {
                    var ptr = HEAPU32[iov >>> 2 >>> 0];
                    var len = HEAPU32[iov + 4 >>> 2 >>> 0];
                    iov += 8;
                    var curr = FS.read(stream, HEAP8, ptr, len, offset);
                    if (curr < 0) return -1;
                    ret += curr;
                    if (curr < len) break;
                    if (typeof offset != "undefined") {
                        offset += curr
                    }
                }
                return ret
            };

            function _fd_pread(fd, iov, iovcnt, offset_low, offset_high, pnum) {
                iov >>>= 0;
                iovcnt >>>= 0;
                var offset = convertI32PairToI53Checked(offset_low, offset_high);
                pnum >>>= 0;
                try {
                    if (isNaN(offset)) return 61;
                    var stream = SYSCALLS.getStreamFromFD(fd);
                    var num = doReadv(stream, iov, iovcnt, offset);
                    HEAPU32[pnum >>> 2 >>> 0] = num;
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return e.errno
                }
            }
            _fd_pread.sig = "iippiip";
            var doWritev = (stream, iov, iovcnt, offset) => {
                var ret = 0;
                for (var i = 0; i < iovcnt; i++) {
                    var ptr = HEAPU32[iov >>> 2 >>> 0];
                    var len = HEAPU32[iov + 4 >>> 2 >>> 0];
                    iov += 8;
                    var curr = FS.write(stream, HEAP8, ptr, len, offset);
                    if (curr < 0) return -1;
                    ret += curr;
                    if (curr < len) {
                        break
                    }
                    if (typeof offset != "undefined") {
                        offset += curr
                    }
                }
                return ret
            };

            function _fd_pwrite(fd, iov, iovcnt, offset_low, offset_high, pnum) {
                iov >>>= 0;
                iovcnt >>>= 0;
                var offset = convertI32PairToI53Checked(offset_low, offset_high);
                pnum >>>= 0;
                try {
                    if (isNaN(offset)) return 61;
                    var stream = SYSCALLS.getStreamFromFD(fd);
                    var num = doWritev(stream, iov, iovcnt, offset);
                    HEAPU32[pnum >>> 2 >>> 0] = num;
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return e.errno
                }
            }
            _fd_pwrite.sig = "iippiip";

            function _fd_read(fd, iov, iovcnt, pnum) {
                iov >>>= 0;
                iovcnt >>>= 0;
                pnum >>>= 0;
                try {
                    var stream = SYSCALLS.getStreamFromFD(fd);
                    var num = doReadv(stream, iov, iovcnt);
                    HEAPU32[pnum >>> 2 >>> 0] = num;
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return e.errno
                }
            }
            _fd_read.sig = "iippp";

            function _fd_seek(fd, offset_low, offset_high, whence, newOffset) {
                var offset = convertI32PairToI53Checked(offset_low, offset_high);
                newOffset >>>= 0;
                try {
                    if (isNaN(offset)) return 61;
                    var stream = SYSCALLS.getStreamFromFD(fd);
                    FS.llseek(stream, offset, whence);
                    tempI64 = [stream.position >>> 0, (tempDouble = stream.position, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[newOffset >>> 2 >>> 0] = tempI64[0], HEAP32[newOffset + 4 >>> 2 >>> 0] = tempI64[1];
                    if (stream.getdents && offset === 0 && whence === 0) stream.getdents = null;
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return e.errno
                }
            }
            _fd_seek.sig = "iiiiip";

            function _fd_sync(fd) {
                try {
                    var stream = SYSCALLS.getStreamFromFD(fd);
                    if (stream.stream_ops?.fsync) {
                        return stream.stream_ops.fsync(stream)
                    }
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return e.errno
                }
            }
            _fd_sync.sig = "ii";

            function _fd_write(fd, iov, iovcnt, pnum) {
                iov >>>= 0;
                iovcnt >>>= 0;
                pnum >>>= 0;
                try {
                    var stream = SYSCALLS.getStreamFromFD(fd);
                    var num = doWritev(stream, iov, iovcnt);
                    HEAPU32[pnum >>> 2 >>> 0] = num;
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return e.errno
                }
            }
            _fd_write.sig = "iippp";

            function _getaddrinfo(node, service, hint, out) {
                node >>>= 0;
                service >>>= 0;
                hint >>>= 0;
                out >>>= 0;
                var addrs = [];
                var canon = null;
                var addr = 0;
                var port = 0;
                var flags = 0;
                var family = 0;
                var type = 0;
                var proto = 0;
                var ai, last;

                function allocaddrinfo(family, type, proto, canon, addr, port) {
                    var sa, salen, ai;
                    var errno;
                    salen = family === 10 ? 28 : 16;
                    addr = family === 10 ? inetNtop6(addr) : inetNtop4(addr);
                    sa = _malloc(salen);
                    errno = writeSockaddr(sa, family, addr, port);
                    assert(!errno);
                    ai = _malloc(32);
                    HEAP32[ai + 4 >>> 2 >>> 0] = family;
                    HEAP32[ai + 8 >>> 2 >>> 0] = type;
                    HEAP32[ai + 12 >>> 2 >>> 0] = proto;
                    HEAPU32[ai + 24 >>> 2 >>> 0] = canon;
                    HEAPU32[ai + 20 >>> 2 >>> 0] = sa;
                    if (family === 10) {
                        HEAP32[ai + 16 >>> 2 >>> 0] = 28
                    } else {
                        HEAP32[ai + 16 >>> 2 >>> 0] = 16
                    }
                    HEAP32[ai + 28 >>> 2 >>> 0] = 0;
                    return ai
                }
                if (hint) {
                    flags = HEAP32[hint >>> 2 >>> 0];
                    family = HEAP32[hint + 4 >>> 2 >>> 0];
                    type = HEAP32[hint + 8 >>> 2 >>> 0];
                    proto = HEAP32[hint + 12 >>> 2 >>> 0]
                }
                if (type && !proto) {
                    proto = type === 2 ? 17 : 6
                }
                if (!type && proto) {
                    type = proto === 17 ? 2 : 1
                }
                if (proto === 0) {
                    proto = 6
                }
                if (type === 0) {
                    type = 1
                }
                if (!node && !service) {
                    return -2
                }
                if (flags & ~(1 | 2 | 4 | 1024 | 8 | 16 | 32)) {
                    return -1
                }
                if (hint !== 0 && HEAP32[hint >>> 2 >>> 0] & 2 && !node) {
                    return -1
                }
                if (flags & 32) {
                    return -2
                }
                if (type !== 0 && type !== 1 && type !== 2) {
                    return -7
                }
                if (family !== 0 && family !== 2 && family !== 10) {
                    return -6
                }
                if (service) {
                    service = UTF8ToString(service);
                    port = parseInt(service, 10);
                    if (isNaN(port)) {
                        if (flags & 1024) {
                            return -2
                        }
                        return -8
                    }
                }
                if (!node) {
                    if (family === 0) {
                        family = 2
                    }
                    if ((flags & 1) === 0) {
                        if (family === 2) {
                            addr = _htonl(2130706433)
                        } else {
                            addr = [0, 0, 0, _htonl(1)]
                        }
                    }
                    ai = allocaddrinfo(family, type, proto, null, addr, port);
                    HEAPU32[out >>> 2 >>> 0] = ai;
                    return 0
                }
                node = UTF8ToString(node);
                addr = inetPton4(node);
                if (addr !== null) {
                    if (family === 0 || family === 2) {
                        family = 2
                    } else if (family === 10 && flags & 8) {
                        addr = [0, 0, _htonl(65535), addr];
                        family = 10
                    } else {
                        return -2
                    }
                } else {
                    addr = inetPton6(node);
                    if (addr !== null) {
                        if (family === 0 || family === 10) {
                            family = 10
                        } else {
                            return -2
                        }
                    }
                }
                if (addr != null) {
                    ai = allocaddrinfo(family, type, proto, node, addr, port);
                    HEAPU32[out >>> 2 >>> 0] = ai;
                    return 0
                }
                if (flags & 4) {
                    return -2
                }
                node = DNS.lookup_name(node);
                addr = inetPton4(node);
                if (family === 0) {
                    family = 2
                } else if (family === 10) {
                    addr = [0, 0, _htonl(65535), addr]
                }
                ai = allocaddrinfo(family, type, proto, null, addr, port);
                HEAPU32[out >>> 2 >>> 0] = ai;
                return 0
            }
            _getaddrinfo.sig = "ipppp";

            function _getnameinfo(sa, salen, node, nodelen, serv, servlen, flags) {
                sa >>>= 0;
                node >>>= 0;
                serv >>>= 0;
                var info = readSockaddr(sa, salen);
                if (info.errno) {
                    return -6
                }
                var port = info.port;
                var addr = info.addr;
                var overflowed = false;
                if (node && nodelen) {
                    var lookup;
                    if (flags & 1 || !(lookup = DNS.lookup_addr(addr))) {
                        if (flags & 8) {
                            return -2
                        }
                    } else {
                        addr = lookup
                    }
                    var numBytesWrittenExclNull = stringToUTF8(addr, node, nodelen);
                    if (numBytesWrittenExclNull + 1 >= nodelen) {
                        overflowed = true
                    }
                }
                if (serv && servlen) {
                    port = "" + port;
                    var numBytesWrittenExclNull = stringToUTF8(port, serv, servlen);
                    if (numBytesWrittenExclNull + 1 >= servlen) {
                        overflowed = true
                    }
                }
                if (overflowed) {
                    return -12
                }
                return 0
            }
            _getnameinfo.sig = "ipipipii";

            function _pthread_kill(...args) {
                return wasmImports["pthread_kill"](...args)
            }
            _pthread_kill.stub = true;

            function _random_get(buffer, size) {
                buffer >>>= 0;
                size >>>= 0;
                try {
                    randomFill(HEAPU8.subarray(buffer >>> 0, buffer + size >>> 0));
                    return 0
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return e.errno
                }
            }
            _random_get.sig = "ipp";
            var arraySum = (array, index) => {
                var sum = 0;
                for (var i = 0; i <= index; sum += array[i++]) {}
                return sum
            };
            var MONTH_DAYS_LEAP = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            var MONTH_DAYS_REGULAR = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            var addDays = (date, days) => {
                var newDate = new Date(date.getTime());
                while (days > 0) {
                    var leap = isLeapYear(newDate.getFullYear());
                    var currentMonth = newDate.getMonth();
                    var daysInCurrentMonth = (leap ? MONTH_DAYS_LEAP : MONTH_DAYS_REGULAR)[currentMonth];
                    if (days > daysInCurrentMonth - newDate.getDate()) {
                        days -= daysInCurrentMonth - newDate.getDate() + 1;
                        newDate.setDate(1);
                        if (currentMonth < 11) {
                            newDate.setMonth(currentMonth + 1)
                        } else {
                            newDate.setMonth(0);
                            newDate.setFullYear(newDate.getFullYear() + 1)
                        }
                    } else {
                        newDate.setDate(newDate.getDate() + days);
                        return newDate
                    }
                }
                return newDate
            };

            function _strptime(buf, format, tm) {
                buf >>>= 0;
                format >>>= 0;
                tm >>>= 0;
                var pattern = UTF8ToString(format);
                var SPECIAL_CHARS = "\\!@#$^&*()+=-[]/{}|:<>?,.";
                for (var i = 0, ii = SPECIAL_CHARS.length; i < ii; ++i) {
                    pattern = pattern.replace(new RegExp("\\" + SPECIAL_CHARS[i], "g"), "\\" + SPECIAL_CHARS[i])
                }
                var EQUIVALENT_MATCHERS = {
                    A: "%a",
                    B: "%b",
                    c: "%a %b %d %H:%M:%S %Y",
                    D: "%m\\/%d\\/%y",
                    e: "%d",
                    F: "%Y-%m-%d",
                    h: "%b",
                    R: "%H\\:%M",
                    r: "%I\\:%M\\:%S\\s%p",
                    T: "%H\\:%M\\:%S",
                    x: "%m\\/%d\\/(?:%y|%Y)",
                    X: "%H\\:%M\\:%S"
                };
                var DATE_PATTERNS = {
                    a: "(?:Sun(?:day)?)|(?:Mon(?:day)?)|(?:Tue(?:sday)?)|(?:Wed(?:nesday)?)|(?:Thu(?:rsday)?)|(?:Fri(?:day)?)|(?:Sat(?:urday)?)",
                    b: "(?:Jan(?:uary)?)|(?:Feb(?:ruary)?)|(?:Mar(?:ch)?)|(?:Apr(?:il)?)|May|(?:Jun(?:e)?)|(?:Jul(?:y)?)|(?:Aug(?:ust)?)|(?:Sep(?:tember)?)|(?:Oct(?:ober)?)|(?:Nov(?:ember)?)|(?:Dec(?:ember)?)",
                    C: "\\d\\d",
                    d: "0[1-9]|[1-9](?!\\d)|1\\d|2\\d|30|31",
                    H: "\\d(?!\\d)|[0,1]\\d|20|21|22|23",
                    I: "\\d(?!\\d)|0\\d|10|11|12",
                    j: "00[1-9]|0?[1-9](?!\\d)|0?[1-9]\\d(?!\\d)|[1,2]\\d\\d|3[0-6]\\d",
                    m: "0[1-9]|[1-9](?!\\d)|10|11|12",
                    M: "0\\d|\\d(?!\\d)|[1-5]\\d",
                    n: " ",
                    p: "AM|am|PM|pm|A\\.M\\.|a\\.m\\.|P\\.M\\.|p\\.m\\.",
                    S: "0\\d|\\d(?!\\d)|[1-5]\\d|60",
                    U: "0\\d|\\d(?!\\d)|[1-4]\\d|50|51|52|53",
                    W: "0\\d|\\d(?!\\d)|[1-4]\\d|50|51|52|53",
                    w: "[0-6]",
                    y: "\\d\\d",
                    Y: "\\d\\d\\d\\d",
                    t: " ",
                    z: "Z|(?:[\\+\\-]\\d\\d:?(?:\\d\\d)?)"
                };
                var MONTH_NUMBERS = {
                    JAN: 0,
                    FEB: 1,
                    MAR: 2,
                    APR: 3,
                    MAY: 4,
                    JUN: 5,
                    JUL: 6,
                    AUG: 7,
                    SEP: 8,
                    OCT: 9,
                    NOV: 10,
                    DEC: 11
                };
                var DAY_NUMBERS_SUN_FIRST = {
                    SUN: 0,
                    MON: 1,
                    TUE: 2,
                    WED: 3,
                    THU: 4,
                    FRI: 5,
                    SAT: 6
                };
                var DAY_NUMBERS_MON_FIRST = {
                    MON: 0,
                    TUE: 1,
                    WED: 2,
                    THU: 3,
                    FRI: 4,
                    SAT: 5,
                    SUN: 6
                };
                var capture = [];
                var pattern_out = pattern.replace(/%(.)/g, (m, c) => EQUIVALENT_MATCHERS[c] || m).replace(/%(.)/g, (_, c) => {
                    let pat = DATE_PATTERNS[c];
                    if (pat) {
                        capture.push(c);
                        return `(${pat})`
                    } else {
                        return c
                    }
                }).replace(/\s+/g, "\\s*");
                var matches = new RegExp("^" + pattern_out, "i").exec(UTF8ToString(buf));

                function initDate() {
                    function fixup(value, min, max) {
                        return typeof value != "number" || isNaN(value) ? min : value >= min ? value <= max ? value : max : min
                    }
                    return {
                        year: fixup(HEAP32[tm + 20 >>> 2 >>> 0] + 1900, 1970, 9999),
                        month: fixup(HEAP32[tm + 16 >>> 2 >>> 0], 0, 11),
                        day: fixup(HEAP32[tm + 12 >>> 2 >>> 0], 1, 31),
                        hour: fixup(HEAP32[tm + 8 >>> 2 >>> 0], 0, 23),
                        min: fixup(HEAP32[tm + 4 >>> 2 >>> 0], 0, 59),
                        sec: fixup(HEAP32[tm >>> 2 >>> 0], 0, 59),
                        gmtoff: 0
                    }
                }
                if (matches) {
                    var date = initDate();
                    var value;
                    var getMatch = symbol => {
                        var pos = capture.indexOf(symbol);
                        if (pos >= 0) {
                            return matches[pos + 1]
                        }
                        return
                    };
                    if (value = getMatch("S")) {
                        date.sec = jstoi_q(value)
                    }
                    if (value = getMatch("M")) {
                        date.min = jstoi_q(value)
                    }
                    if (value = getMatch("H")) {
                        date.hour = jstoi_q(value)
                    } else if (value = getMatch("I")) {
                        var hour = jstoi_q(value);
                        if (value = getMatch("p")) {
                            hour += value.toUpperCase()[0] === "P" ? 12 : 0
                        }
                        date.hour = hour
                    }
                    if (value = getMatch("Y")) {
                        date.year = jstoi_q(value)
                    } else if (value = getMatch("y")) {
                        var year = jstoi_q(value);
                        if (value = getMatch("C")) {
                            year += jstoi_q(value) * 100
                        } else {
                            year += year < 69 ? 2e3 : 1900
                        }
                        date.year = year
                    }
                    if (value = getMatch("m")) {
                        date.month = jstoi_q(value) - 1
                    } else if (value = getMatch("b")) {
                        date.month = MONTH_NUMBERS[value.substring(0, 3).toUpperCase()] || 0
                    }
                    if (value = getMatch("d")) {
                        date.day = jstoi_q(value)
                    } else if (value = getMatch("j")) {
                        var day = jstoi_q(value);
                        var leapYear = isLeapYear(date.year);
                        for (var month = 0; month < 12; ++month) {
                            var daysUntilMonth = arraySum(leapYear ? MONTH_DAYS_LEAP : MONTH_DAYS_REGULAR, month - 1);
                            if (day <= daysUntilMonth + (leapYear ? MONTH_DAYS_LEAP : MONTH_DAYS_REGULAR)[month]) {
                                date.day = day - daysUntilMonth
                            }
                        }
                    } else if (value = getMatch("a")) {
                        var weekDay = value.substring(0, 3).toUpperCase();
                        if (value = getMatch("U")) {
                            var weekDayNumber = DAY_NUMBERS_SUN_FIRST[weekDay];
                            var weekNumber = jstoi_q(value);
                            var janFirst = new Date(date.year, 0, 1);
                            var endDate;
                            if (janFirst.getDay() === 0) {
                                endDate = addDays(janFirst, weekDayNumber + 7 * (weekNumber - 1))
                            } else {
                                endDate = addDays(janFirst, 7 - janFirst.getDay() + weekDayNumber + 7 * (weekNumber - 1))
                            }
                            date.day = endDate.getDate();
                            date.month = endDate.getMonth()
                        } else if (value = getMatch("W")) {
                            var weekDayNumber = DAY_NUMBERS_MON_FIRST[weekDay];
                            var weekNumber = jstoi_q(value);
                            var janFirst = new Date(date.year, 0, 1);
                            var endDate;
                            if (janFirst.getDay() === 1) {
                                endDate = addDays(janFirst, weekDayNumber + 7 * (weekNumber - 1))
                            } else {
                                endDate = addDays(janFirst, 7 - janFirst.getDay() + 1 + weekDayNumber + 7 * (weekNumber - 1))
                            }
                            date.day = endDate.getDate();
                            date.month = endDate.getMonth()
                        }
                    }
                    if (value = getMatch("z")) {
                        if (value.toLowerCase() === "z") {
                            date.gmtoff = 0
                        } else {
                            var match = value.match(/^((?:\-|\+)\d\d):?(\d\d)?/);
                            date.gmtoff = match[1] * 3600;
                            if (match[2]) {
                                date.gmtoff += date.gmtoff > 0 ? match[2] * 60 : -match[2] * 60
                            }
                        }
                    }
                    var fullDate = new Date(date.year, date.month, date.day, date.hour, date.min, date.sec, 0);
                    HEAP32[tm >>> 2 >>> 0] = fullDate.getSeconds();
                    HEAP32[tm + 4 >>> 2 >>> 0] = fullDate.getMinutes();
                    HEAP32[tm + 8 >>> 2 >>> 0] = fullDate.getHours();
                    HEAP32[tm + 12 >>> 2 >>> 0] = fullDate.getDate();
                    HEAP32[tm + 16 >>> 2 >>> 0] = fullDate.getMonth();
                    HEAP32[tm + 20 >>> 2 >>> 0] = fullDate.getFullYear() - 1900;
                    HEAP32[tm + 24 >>> 2 >>> 0] = fullDate.getDay();
                    HEAP32[tm + 28 >>> 2 >>> 0] = arraySum(isLeapYear(fullDate.getFullYear()) ? MONTH_DAYS_LEAP : MONTH_DAYS_REGULAR, fullDate.getMonth() - 1) + fullDate.getDate() - 1;
                    HEAP32[tm + 32 >>> 2 >>> 0] = 0;
                    HEAP32[tm + 36 >>> 2 >>> 0] = date.gmtoff;
                    return buf + intArrayFromString(matches[0]).length - 1
                }
                return 0
            }
            _strptime.sig = "pppp";
            var getCFunc = ident => {
                var func = Module["_" + ident];
                return func
            };
            var writeArrayToMemory = (array, buffer) => {
                HEAP8.set(array, buffer >>> 0)
            };
            var ccall = (ident, returnType, argTypes, args, opts) => {
                var toC = {
                    string: str => {
                        var ret = 0;
                        if (str !== null && str !== undefined && str !== 0) {
                            ret = stringToUTF8OnStack(str)
                        }
                        return ret
                    },
                    array: arr => {
                        var ret = stackAlloc(arr.length);
                        writeArrayToMemory(arr, ret);
                        return ret
                    }
                };

                function convertReturnValue(ret) {
                    if (returnType === "string") {
                        return UTF8ToString(ret)
                    }
                    if (returnType === "boolean") return Boolean(ret);
                    return ret
                }
                var func = getCFunc(ident);
                var cArgs = [];
                var stack = 0;
                if (args) {
                    for (var i = 0; i < args.length; i++) {
                        var converter = toC[argTypes[i]];
                        if (converter) {
                            if (stack === 0) stack = stackSave();
                            cArgs[i] = converter(args[i])
                        } else {
                            cArgs[i] = args[i]
                        }
                    }
                }
                var ret = func(...cArgs);

                function onDone(ret) {
                    if (stack !== 0) stackRestore(stack);
                    return convertReturnValue(ret)
                }
                ret = onDone(ret);
                return ret
            };
            var createDyncallWrapper = sig => {
                var sections = [];
                var prelude = [0, 97, 115, 109, 1, 0, 0, 0];
                sections.push(prelude);
                var wrappersig = [sig[0].replace("j", "i"), "i", sig.slice(1).replace(/j/g, "ii")].join("");
                var typeSectionBody = [3];
                generateFuncType(wrappersig, typeSectionBody);
                generateFuncType(sig, typeSectionBody);
                generateFuncType("vi", typeSectionBody);
                var typeSection = [1];
                uleb128Encode(typeSectionBody.length, typeSection);
                typeSection.push(...typeSectionBody);
                sections.push(typeSection);
                var importSection = [2, 15, 2, 1, 101, 1, 116, 1, 112, 0, 0, 1, 101, 1, 114, 0, 2];
                sections.push(importSection);
                var functionSection = [3, 2, 1, 0];
                sections.push(functionSection);
                var exportSection = [7, 5, 1, 1, 102, 0, 1];
                sections.push(exportSection);
                var convert_code = [];
                if (sig[0] === "j") {
                    convert_code = [1, 1, 126]
                } else {
                    convert_code.push(0)
                }

                function localGet(j) {
                    convert_code.push(32);
                    uleb128Encode(j, convert_code)
                }
                var j = 1;
                for (var i = 1; i < sig.length; i++) {
                    if (sig[i] == "j") {
                        localGet(j + 1);
                        convert_code.push(173, 66, 32, 134);
                        localGet(j);
                        convert_code.push(172, 132);
                        j += 2
                    } else {
                        localGet(j);
                        j++
                    }
                }
                convert_code.push(32, 0, 17, 1, 0);
                if (sig[0] === "j") {
                    convert_code.push(34);
                    uleb128Encode(j, convert_code);
                    convert_code.push(66, 32, 136, 167, 16, 0);
                    localGet(j);
                    convert_code.push(167)
                }
                convert_code.push(11);
                var codeBody = [1];
                uleb128Encode(convert_code.length, codeBody);
                codeBody.push(...convert_code);
                var codeSection = [10];
                uleb128Encode(codeBody.length, codeSection);
                codeSection.push(...codeBody);
                sections.push(codeSection);
                var bytes = new Uint8Array([].concat.apply([], sections));
                var module = new WebAssembly.Module(bytes);
                var instance = new WebAssembly.Instance(module, {
                    e: {
                        t: wasmTable,
                        r: setTempRet0
                    }
                });
                var wrappedFunc = instance.exports["f"];
                return wrappedFunc
            };
            var getTempRet0 = val => __emscripten_tempret_get();
            var writeI53ToI64Clamped = (ptr, num) => {
                if (num > 0x8000000000000000) {
                    HEAPU32[ptr >>> 2 >>> 0] = 4294967295;
                    HEAPU32[ptr + 4 >>> 2 >>> 0] = 2147483647
                } else if (num < -0x8000000000000000) {
                    HEAPU32[ptr >>> 2 >>> 0] = 0;
                    HEAPU32[ptr + 4 >>> 2 >>> 0] = 2147483648
                } else {
                    writeI53ToI64(ptr, num)
                }
            };
            var writeI53ToI64Signaling = (ptr, num) => {
                if (num > 0x8000000000000000 || num < -0x8000000000000000) {
                    throw `RangeError: ${num}`
                }
                writeI53ToI64(ptr, num)
            };
            var writeI53ToU64Clamped = (ptr, num) => {
                if (num > 0x10000000000000000) {
                    HEAPU32[ptr >>> 2 >>> 0] = 4294967295;
                    HEAPU32[ptr + 4 >>> 2 >>> 0] = 4294967295
                } else if (num < 0) {
                    HEAPU32[ptr >>> 2 >>> 0] = 0;
                    HEAPU32[ptr + 4 >>> 2 >>> 0] = 0
                } else {
                    writeI53ToI64(ptr, num)
                }
            };
            var writeI53ToU64Signaling = (ptr, num) => {
                if (num < 0 || num > 0x10000000000000000) {
                    throw `RangeError: ${num}`
                }
                writeI53ToI64(ptr, num)
            };
            var readI53FromU64 = ptr => HEAPU32[ptr >>> 2 >>> 0] + HEAPU32[ptr + 4 >>> 2 >>> 0] * 4294967296;
            var convertI32PairToI53 = (lo, hi) => (lo >>> 0) + hi * 4294967296;
            var convertU32PairToI53 = (lo, hi) => (lo >>> 0) + (hi >>> 0) * 4294967296;
            var _stackAlloc = stackAlloc;
            var _stackSave = stackSave;
            var _stackRestore = stackSave;
            var _getTempRet0 = getTempRet0;
            Module["_getTempRet0"] = _getTempRet0;
            var ptrToString = ptr => "0x" + ptr.toString(16).padStart(8, "0");

            function _emscripten_notify_memory_growth(memoryIndex) {
                memoryIndex >>>= 0;
                updateMemoryViews()
            }
            _emscripten_notify_memory_growth.sig = "vp";
            var withStackSave = f => {
                var stack = stackSave();
                var ret = f();
                stackRestore(stack);
                return ret
            };
            var ERRNO_CODES = {
                EPERM: 63,
                ENOENT: 44,
                ESRCH: 71,
                EINTR: 27,
                EIO: 29,
                ENXIO: 60,
                E2BIG: 1,
                ENOEXEC: 45,
                EBADF: 8,
                ECHILD: 12,
                EAGAIN: 6,
                EWOULDBLOCK: 6,
                ENOMEM: 48,
                EACCES: 2,
                EFAULT: 21,
                ENOTBLK: 105,
                EBUSY: 10,
                EEXIST: 20,
                EXDEV: 75,
                ENODEV: 43,
                ENOTDIR: 54,
                EISDIR: 31,
                EINVAL: 28,
                ENFILE: 41,
                EMFILE: 33,
                ENOTTY: 59,
                ETXTBSY: 74,
                EFBIG: 22,
                ENOSPC: 51,
                ESPIPE: 70,
                EROFS: 69,
                EMLINK: 34,
                EPIPE: 64,
                EDOM: 18,
                ERANGE: 68,
                ENOMSG: 49,
                EIDRM: 24,
                ECHRNG: 106,
                EL2NSYNC: 156,
                EL3HLT: 107,
                EL3RST: 108,
                ELNRNG: 109,
                EUNATCH: 110,
                ENOCSI: 111,
                EL2HLT: 112,
                EDEADLK: 16,
                ENOLCK: 46,
                EBADE: 113,
                EBADR: 114,
                EXFULL: 115,
                ENOANO: 104,
                EBADRQC: 103,
                EBADSLT: 102,
                EDEADLOCK: 16,
                EBFONT: 101,
                ENOSTR: 100,
                ENODATA: 116,
                ETIME: 117,
                ENOSR: 118,
                ENONET: 119,
                ENOPKG: 120,
                EREMOTE: 121,
                ENOLINK: 47,
                EADV: 122,
                ESRMNT: 123,
                ECOMM: 124,
                EPROTO: 65,
                EMULTIHOP: 36,
                EDOTDOT: 125,
                EBADMSG: 9,
                ENOTUNIQ: 126,
                EBADFD: 127,
                EREMCHG: 128,
                ELIBACC: 129,
                ELIBBAD: 130,
                ELIBSCN: 131,
                ELIBMAX: 132,
                ELIBEXEC: 133,
                ENOSYS: 52,
                ENOTEMPTY: 55,
                ENAMETOOLONG: 37,
                ELOOP: 32,
                EOPNOTSUPP: 138,
                EPFNOSUPPORT: 139,
                ECONNRESET: 15,
                ENOBUFS: 42,
                EAFNOSUPPORT: 5,
                EPROTOTYPE: 67,
                ENOTSOCK: 57,
                ENOPROTOOPT: 50,
                ESHUTDOWN: 140,
                ECONNREFUSED: 14,
                EADDRINUSE: 3,
                ECONNABORTED: 13,
                ENETUNREACH: 40,
                ENETDOWN: 38,
                ETIMEDOUT: 73,
                EHOSTDOWN: 142,
                EHOSTUNREACH: 23,
                EINPROGRESS: 26,
                EALREADY: 7,
                EDESTADDRREQ: 17,
                EMSGSIZE: 35,
                EPROTONOSUPPORT: 66,
                ESOCKTNOSUPPORT: 137,
                EADDRNOTAVAIL: 4,
                ENETRESET: 39,
                EISCONN: 30,
                ENOTCONN: 53,
                ETOOMANYREFS: 141,
                EUSERS: 136,
                EDQUOT: 19,
                ESTALE: 72,
                ENOTSUP: 138,
                ENOMEDIUM: 148,
                EILSEQ: 25,
                EOVERFLOW: 61,
                ECANCELED: 11,
                ENOTRECOVERABLE: 56,
                EOWNERDEAD: 62,
                ESTRPIPE: 135
            };
            var strError = errno => UTF8ToString(_strerror(errno));
            var Protocols = {
                list: [],
                map: {}
            };
            var _setprotoent = stayopen => {
                function allocprotoent(name, proto, aliases) {
                    var nameBuf = _malloc(name.length + 1);
                    stringToAscii(name, nameBuf);
                    var j = 0;
                    var length = aliases.length;
                    var aliasListBuf = _malloc((length + 1) * 4);
                    for (var i = 0; i < length; i++, j += 4) {
                        var alias = aliases[i];
                        var aliasBuf = _malloc(alias.length + 1);
                        stringToAscii(alias, aliasBuf);
                        HEAPU32[aliasListBuf + j >>> 2 >>> 0] = aliasBuf
                    }
                    HEAPU32[aliasListBuf + j >>> 2 >>> 0] = 0;
                    var pe = _malloc(12);
                    HEAPU32[pe >>> 2 >>> 0] = nameBuf;
                    HEAPU32[pe + 4 >>> 2 >>> 0] = aliasListBuf;
                    HEAP32[pe + 8 >>> 2 >>> 0] = proto;
                    return pe
                }
                var list = Protocols.list;
                var map = Protocols.map;
                if (list.length === 0) {
                    var entry = allocprotoent("tcp", 6, ["TCP"]);
                    list.push(entry);
                    map["tcp"] = map["6"] = entry;
                    entry = allocprotoent("udp", 17, ["UDP"]);
                    list.push(entry);
                    map["udp"] = map["17"] = entry
                }
                _setprotoent.index = 0
            };
            _setprotoent.sig = "vi";
            var _endprotoent = () => {};
            _endprotoent.sig = "v";

            function _getprotoent(number) {
                if (_setprotoent.index === Protocols.list.length) {
                    return 0
                }
                var result = Protocols.list[_setprotoent.index++];
                return result
            }
            _getprotoent.sig = "p";

            function _getprotobyname(name) {
                name >>>= 0;
                name = UTF8ToString(name);
                _setprotoent(true);
                var result = Protocols.map[name];
                return result
            }
            _getprotobyname.sig = "pp";

            function _getprotobynumber(number) {
                _setprotoent(true);
                var result = Protocols.map[number];
                return result
            }
            _getprotobynumber.sig = "pi";

            function _emscripten_run_script(ptr) {
                ptr >>>= 0;
                eval(UTF8ToString(ptr))
            }
            _emscripten_run_script.sig = "vp";

            function _emscripten_run_script_int(ptr) {
                ptr >>>= 0;
                return eval(UTF8ToString(ptr)) | 0
            }
            _emscripten_run_script_int.sig = "ip";

            function _emscripten_run_script_string(ptr) {
                ptr >>>= 0;
                var s = eval(UTF8ToString(ptr));
                if (s == null) {
                    return 0
                }
                s += "";
                var me = _emscripten_run_script_string;
                var len = lengthBytesUTF8(s);
                if (!me.bufferSize || me.bufferSize < len + 1) {
                    if (me.bufferSize) _free(me.buffer);
                    me.bufferSize = len + 1;
                    me.buffer = _malloc(me.bufferSize)
                }
                stringToUTF8(s, me.buffer, me.bufferSize);
                return me.buffer
            }
            _emscripten_run_script_string.sig = "pp";
            var _emscripten_random = () => Math.random();
            _emscripten_random.sig = "f";
            var warnOnce = text => {
                warnOnce.shown ||= {};
                if (!warnOnce.shown[text]) {
                    warnOnce.shown[text] = 1;
                    if (ENVIRONMENT_IS_NODE) text = "warning: " + text;
                    err(text)
                }
            };
            var jsStackTrace = () => (new Error).stack.toString();
            var getCallstack = flags => {
                var callstack = jsStackTrace();
                var iThisFunc = callstack.lastIndexOf("_emscripten_log");
                var iThisFunc2 = callstack.lastIndexOf("_emscripten_get_callstack");
                var iNextLine = callstack.indexOf("\n", Math.max(iThisFunc, iThisFunc2)) + 1;
                callstack = callstack.slice(iNextLine);
                if (flags & 8 && typeof emscripten_source_map == "undefined") {
                    warnOnce('Source map information is not available, emscripten_log with EM_LOG_C_STACK will be ignored. Build with "--pre-js $EMSCRIPTEN/src/emscripten-source-map.min.js" linker flag to add source map loading to code.');
                    flags ^= 8;
                    flags |= 16
                }
                var lines = callstack.split("\n");
                callstack = "";
                var newFirefoxRe = new RegExp("\\s*(.*?)@(.*?):([0-9]+):([0-9]+)");
                var firefoxRe = new RegExp("\\s*(.*?)@(.*):(.*)(:(.*))?");
                var chromeRe = new RegExp("\\s*at (.*?) \\((.*):(.*):(.*)\\)");
                for (var l in lines) {
                    var line = lines[l];
                    var symbolName = "";
                    var file = "";
                    var lineno = 0;
                    var column = 0;
                    var parts = chromeRe.exec(line);
                    if (parts && parts.length == 5) {
                        symbolName = parts[1];
                        file = parts[2];
                        lineno = parts[3];
                        column = parts[4]
                    } else {
                        parts = newFirefoxRe.exec(line) || firefoxRe.exec(line);
                        if (parts && parts.length >= 4) {
                            symbolName = parts[1];
                            file = parts[2];
                            lineno = parts[3];
                            column = parts[4] | 0
                        } else {
                            callstack += line + "\n";
                            continue
                        }
                    }
                    var haveSourceMap = false;
                    if (flags & 8) {
                        var orig = emscripten_source_map.originalPositionFor({
                            line: lineno,
                            column
                        });
                        haveSourceMap = orig?.source;
                        if (haveSourceMap) {
                            if (flags & 64) {
                                orig.source = orig.source.substring(orig.source.replace(/\\/g, "/").lastIndexOf("/") + 1)
                            }
                            callstack += `    at ${symbolName} (${orig.source}:${orig.line}:${orig.column})\n`
                        }
                    }
                    if (flags & 16 || !haveSourceMap) {
                        if (flags & 64) {
                            file = file.substring(file.replace(/\\/g, "/").lastIndexOf("/") + 1)
                        }
                        callstack += (haveSourceMap ? `     = ${symbolName}` : `    at ${symbolName}`) + ` (${file}:${lineno}:${column})\n`
                    }
                }
                callstack = callstack.replace(/\s+$/, "");
                return callstack
            };
            var emscriptenLog = (flags, str) => {
                if (flags & 24) {
                    str = str.replace(/\s+$/, "");
                    str += (str.length > 0 ? "\n" : "") + getCallstack(flags)
                }
                if (flags & 1) {
                    if (flags & 4) {
                        console.error(str)
                    } else if (flags & 2) {
                        console.warn(str)
                    } else if (flags & 512) {
                        console.info(str)
                    } else if (flags & 256) {
                        console.debug(str)
                    } else {
                        console.log(str)
                    }
                } else if (flags & 6) {
                    err(str)
                } else {
                    out(str)
                }
            };
            var reallyNegative = x => x < 0 || x === 0 && 1 / x === -Infinity;
            var reSign = (value, bits) => {
                if (value <= 0) {
                    return value
                }
                var half = bits <= 32 ? Math.abs(1 << bits - 1) : Math.pow(2, bits - 1);
                if (value >= half && (bits <= 32 || value > half)) {
                    value = -2 * half + value
                }
                return value
            };
            var unSign = (value, bits) => {
                if (value >= 0) {
                    return value
                }
                return bits <= 32 ? 2 * Math.abs(1 << bits - 1) + value : Math.pow(2, bits) + value
            };
            var strLen = ptr => {
                var end = ptr;
                while (HEAPU8[end >>> 0]) ++end;
                return end - ptr
            };
            var formatString = (format, varargs) => {
                var textIndex = format;
                var argIndex = varargs;

                function prepVararg(ptr, type) {
                    if (type === "double" || type === "i64") {
                        if (ptr & 7) {
                            ptr += 4
                        }
                    } else {}
                    return ptr
                }

                function getNextArg(type) {
                    var ret;
                    argIndex = prepVararg(argIndex, type);
                    if (type === "double") {
                        ret = HEAPF64[argIndex >>> 3 >>> 0];
                        argIndex += 8
                    } else if (type == "i64") {
                        ret = [HEAP32[argIndex >>> 2 >>> 0], HEAP32[argIndex + 4 >>> 2 >>> 0]];
                        argIndex += 8
                    } else {
                        type = "i32";
                        ret = HEAP32[argIndex >>> 2 >>> 0];
                        argIndex += 4
                    }
                    return ret
                }
                var ret = [];
                var curr, next, currArg;
                while (1) {
                    var startTextIndex = textIndex;
                    curr = HEAP8[textIndex >>> 0];
                    if (curr === 0) break;
                    next = HEAP8[textIndex + 1 >>> 0];
                    if (curr == 37) {
                        var flagAlwaysSigned = false;
                        var flagLeftAlign = false;
                        var flagAlternative = false;
                        var flagZeroPad = false;
                        var flagPadSign = false;
                        flagsLoop: while (1) {
                            switch (next) {
                                case 43:
                                    flagAlwaysSigned = true;
                                    break;
                                case 45:
                                    flagLeftAlign = true;
                                    break;
                                case 35:
                                    flagAlternative = true;
                                    break;
                                case 48:
                                    if (flagZeroPad) {
                                        break flagsLoop
                                    } else {
                                        flagZeroPad = true;
                                        break
                                    }
                                case 32:
                                    flagPadSign = true;
                                    break;
                                default:
                                    break flagsLoop
                            }
                            textIndex++;
                            next = HEAP8[textIndex + 1 >>> 0]
                        }
                        var width = 0;
                        if (next == 42) {
                            width = getNextArg("i32");
                            textIndex++;
                            next = HEAP8[textIndex + 1 >>> 0]
                        } else {
                            while (next >= 48 && next <= 57) {
                                width = width * 10 + (next - 48);
                                textIndex++;
                                next = HEAP8[textIndex + 1 >>> 0]
                            }
                        }
                        var precisionSet = false,
                            precision = -1;
                        if (next == 46) {
                            precision = 0;
                            precisionSet = true;
                            textIndex++;
                            next = HEAP8[textIndex + 1 >>> 0];
                            if (next == 42) {
                                precision = getNextArg("i32");
                                textIndex++
                            } else {
                                while (1) {
                                    var precisionChr = HEAP8[textIndex + 1 >>> 0];
                                    if (precisionChr < 48 || precisionChr > 57) break;
                                    precision = precision * 10 + (precisionChr - 48);
                                    textIndex++
                                }
                            }
                            next = HEAP8[textIndex + 1 >>> 0]
                        }
                        if (precision < 0) {
                            precision = 6;
                            precisionSet = false
                        }
                        var argSize;
                        switch (String.fromCharCode(next)) {
                            case "h":
                                var nextNext = HEAP8[textIndex + 2 >>> 0];
                                if (nextNext == 104) {
                                    textIndex++;
                                    argSize = 1
                                } else {
                                    argSize = 2
                                }
                                break;
                            case "l":
                                var nextNext = HEAP8[textIndex + 2 >>> 0];
                                if (nextNext == 108) {
                                    textIndex++;
                                    argSize = 8
                                } else {
                                    argSize = 4
                                }
                                break;
                            case "L":
                            case "q":
                            case "j":
                                argSize = 8;
                                break;
                            case "z":
                            case "t":
                            case "I":
                                argSize = 4;
                                break;
                            default:
                                argSize = null
                        }
                        if (argSize) textIndex++;
                        next = HEAP8[textIndex + 1 >>> 0];
                        switch (String.fromCharCode(next)) {
                            case "d":
                            case "i":
                            case "u":
                            case "o":
                            case "x":
                            case "X":
                            case "p": {
                                var signed = next == 100 || next == 105;
                                argSize = argSize || 4;
                                currArg = getNextArg("i" + argSize * 8);
                                var argText;
                                if (argSize == 8) {
                                    currArg = next == 117 ? convertU32PairToI53(currArg[0], currArg[1]) : convertI32PairToI53(currArg[0], currArg[1])
                                }
                                if (argSize <= 4) {
                                    var limit = Math.pow(256, argSize) - 1;
                                    currArg = (signed ? reSign : unSign)(currArg & limit, argSize * 8)
                                }
                                var currAbsArg = Math.abs(currArg);
                                var prefix = "";
                                if (next == 100 || next == 105) {
                                    argText = reSign(currArg, 8 * argSize).toString(10)
                                } else if (next == 117) {
                                    argText = unSign(currArg, 8 * argSize).toString(10);
                                    currArg = Math.abs(currArg)
                                } else if (next == 111) {
                                    argText = (flagAlternative ? "0" : "") + currAbsArg.toString(8)
                                } else if (next == 120 || next == 88) {
                                    prefix = flagAlternative && currArg != 0 ? "0x" : "";
                                    if (currArg < 0) {
                                        currArg = -currArg;
                                        argText = (currAbsArg - 1).toString(16);
                                        var buffer = [];
                                        for (var i = 0; i < argText.length; i++) {
                                            buffer.push((15 - parseInt(argText[i], 16)).toString(16))
                                        }
                                        argText = buffer.join("");
                                        while (argText.length < argSize * 2) argText = "f" + argText
                                    } else {
                                        argText = currAbsArg.toString(16)
                                    }
                                    if (next == 88) {
                                        prefix = prefix.toUpperCase();
                                        argText = argText.toUpperCase()
                                    }
                                } else if (next == 112) {
                                    if (currAbsArg === 0) {
                                        argText = "(nil)"
                                    } else {
                                        prefix = "0x";
                                        argText = currAbsArg.toString(16)
                                    }
                                }
                                if (precisionSet) {
                                    while (argText.length < precision) {
                                        argText = "0" + argText
                                    }
                                }
                                if (currArg >= 0) {
                                    if (flagAlwaysSigned) {
                                        prefix = "+" + prefix
                                    } else if (flagPadSign) {
                                        prefix = " " + prefix
                                    }
                                }
                                if (argText.charAt(0) == "-") {
                                    prefix = "-" + prefix;
                                    argText = argText.substr(1)
                                }
                                while (prefix.length + argText.length < width) {
                                    if (flagLeftAlign) {
                                        argText += " "
                                    } else {
                                        if (flagZeroPad) {
                                            argText = "0" + argText
                                        } else {
                                            prefix = " " + prefix
                                        }
                                    }
                                }
                                argText = prefix + argText;
                                argText.split("").forEach(chr => ret.push(chr.charCodeAt(0)));
                                break
                            }
                            case "f":
                            case "F":
                            case "e":
                            case "E":
                            case "g":
                            case "G": {
                                currArg = getNextArg("double");
                                var argText;
                                if (isNaN(currArg)) {
                                    argText = "nan";
                                    flagZeroPad = false
                                } else if (!isFinite(currArg)) {
                                    argText = (currArg < 0 ? "-" : "") + "inf";
                                    flagZeroPad = false
                                } else {
                                    var isGeneral = false;
                                    var effectivePrecision = Math.min(precision, 20);
                                    if (next == 103 || next == 71) {
                                        isGeneral = true;
                                        precision = precision || 1;
                                        var exponent = parseInt(currArg.toExponential(effectivePrecision).split("e")[1], 10);
                                        if (precision > exponent && exponent >= -4) {
                                            next = (next == 103 ? "f" : "F").charCodeAt(0);
                                            precision -= exponent + 1
                                        } else {
                                            next = (next == 103 ? "e" : "E").charCodeAt(0);
                                            precision--
                                        }
                                        effectivePrecision = Math.min(precision, 20)
                                    }
                                    if (next == 101 || next == 69) {
                                        argText = currArg.toExponential(effectivePrecision);
                                        if (/[eE][-+]\d$/.test(argText)) {
                                            argText = argText.slice(0, -1) + "0" + argText.slice(-1)
                                        }
                                    } else if (next == 102 || next == 70) {
                                        argText = currArg.toFixed(effectivePrecision);
                                        if (currArg === 0 && reallyNegative(currArg)) {
                                            argText = "-" + argText
                                        }
                                    }
                                    var parts = argText.split("e");
                                    if (isGeneral && !flagAlternative) {
                                        while (parts[0].length > 1 && parts[0].includes(".") && (parts[0].slice(-1) == "0" || parts[0].slice(-1) == ".")) {
                                            parts[0] = parts[0].slice(0, -1)
                                        }
                                    } else {
                                        if (flagAlternative && argText.indexOf(".") == -1) parts[0] += ".";
                                        while (precision > effectivePrecision++) parts[0] += "0"
                                    }
                                    argText = parts[0] + (parts.length > 1 ? "e" + parts[1] : "");
                                    if (next == 69) argText = argText.toUpperCase();
                                    if (currArg >= 0) {
                                        if (flagAlwaysSigned) {
                                            argText = "+" + argText
                                        } else if (flagPadSign) {
                                            argText = " " + argText
                                        }
                                    }
                                }
                                while (argText.length < width) {
                                    if (flagLeftAlign) {
                                        argText += " "
                                    } else {
                                        if (flagZeroPad && (argText[0] == "-" || argText[0] == "+")) {
                                            argText = argText[0] + "0" + argText.slice(1)
                                        } else {
                                            argText = (flagZeroPad ? "0" : " ") + argText
                                        }
                                    }
                                }
                                if (next < 97) argText = argText.toUpperCase();
                                argText.split("").forEach(chr => ret.push(chr.charCodeAt(0)));
                                break
                            }
                            case "s": {
                                var arg = getNextArg("i8*");
                                var argLength = arg ? strLen(arg) : "(null)".length;
                                if (precisionSet) argLength = Math.min(argLength, precision);
                                if (!flagLeftAlign) {
                                    while (argLength < width--) {
                                        ret.push(32)
                                    }
                                }
                                if (arg) {
                                    for (var i = 0; i < argLength; i++) {
                                        ret.push(HEAPU8[arg++ >>> 0])
                                    }
                                } else {
                                    ret = ret.concat(intArrayFromString("(null)".substr(0, argLength), true))
                                }
                                if (flagLeftAlign) {
                                    while (argLength < width--) {
                                        ret.push(32)
                                    }
                                }
                                break
                            }
                            case "c": {
                                if (flagLeftAlign) ret.push(getNextArg("i8"));
                                while (--width > 0) {
                                    ret.push(32)
                                }
                                if (!flagLeftAlign) ret.push(getNextArg("i8"));
                                break
                            }
                            case "n": {
                                var ptr = getNextArg("i32*");
                                HEAP32[ptr >>> 2 >>> 0] = ret.length;
                                break
                            }
                            case "%": {
                                ret.push(curr);
                                break
                            }
                            default: {
                                for (var i = startTextIndex; i < textIndex + 2; i++) {
                                    ret.push(HEAP8[i >>> 0])
                                }
                            }
                        }
                        textIndex += 2
                    } else {
                        ret.push(curr);
                        textIndex += 1
                    }
                }
                return ret
            };

            function _emscripten_log(flags, format, varargs) {
                format >>>= 0;
                varargs >>>= 0;
                var result = formatString(format, varargs);
                var str = UTF8ArrayToString(result);
                emscriptenLog(flags, str)
            }
            _emscripten_log.sig = "vipp";

            function _emscripten_get_compiler_setting(name) {
                name >>>= 0;
                throw "You must build with -sRETAIN_COMPILER_SETTINGS for getCompilerSetting or emscripten_get_compiler_setting to work"
            }
            _emscripten_get_compiler_setting.sig = "pp";
            var _emscripten_has_asyncify = () => 0;
            _emscripten_has_asyncify.sig = "i";
            var _emscripten_debugger = () => {
                debugger
            };
            _emscripten_debugger.sig = "v";

            function _emscripten_print_double(x, to, max) {
                to >>>= 0;
                var str = x + "";
                if (to) return stringToUTF8(str, to, max);
                else return lengthBytesUTF8(str)
            }
            _emscripten_print_double.sig = "idpi";

            function _emscripten_asm_const_double(code, sigPtr, argbuf) {
                code >>>= 0;
                sigPtr >>>= 0;
                argbuf >>>= 0;
                return runEmAsmFunction(code, sigPtr, argbuf)
            }
            _emscripten_asm_const_double.sig = "dppp";
            var runMainThreadEmAsm = (emAsmAddr, sigPtr, argbuf, sync) => {
                var args = readEmAsmArgs(sigPtr, argbuf);
                return ASM_CONSTS[emAsmAddr](...args)
            };

            function _emscripten_asm_const_int_sync_on_main_thread(emAsmAddr, sigPtr, argbuf) {
                emAsmAddr >>>= 0;
                sigPtr >>>= 0;
                argbuf >>>= 0;
                return runMainThreadEmAsm(emAsmAddr, sigPtr, argbuf, 1)
            }
            _emscripten_asm_const_int_sync_on_main_thread.sig = "ippp";

            function _emscripten_asm_const_ptr_sync_on_main_thread(emAsmAddr, sigPtr, argbuf) {
                emAsmAddr >>>= 0;
                sigPtr >>>= 0;
                argbuf >>>= 0;
                return runMainThreadEmAsm(emAsmAddr, sigPtr, argbuf, 1)
            }
            _emscripten_asm_const_ptr_sync_on_main_thread.sig = "pppp";
            var _emscripten_asm_const_double_sync_on_main_thread = _emscripten_asm_const_int_sync_on_main_thread;
            _emscripten_asm_const_double_sync_on_main_thread.sig = "dppp";

            function _emscripten_asm_const_async_on_main_thread(emAsmAddr, sigPtr, argbuf) {
                emAsmAddr >>>= 0;
                sigPtr >>>= 0;
                argbuf >>>= 0;
                return runMainThreadEmAsm(emAsmAddr, sigPtr, argbuf, 0)
            }
            _emscripten_asm_const_async_on_main_thread.sig = "vppp";
            var jstoi_s = Number;

            function __Unwind_Backtrace(func, arg) {
                func >>>= 0;
                arg >>>= 0;
                var trace = getCallstack();
                var parts = trace.split("\n");
                for (var i = 0; i < parts.length; i++) {
                    var ret = getWasmTableEntry(func)(0, arg);
                    if (ret !== 0) return
                }
            }
            __Unwind_Backtrace.sig = "ipp";

            function __Unwind_GetIPInfo(context, ipBefore) {
                context >>>= 0;
                ipBefore >>>= 0;
                return abort("Unwind_GetIPInfo")
            }
            __Unwind_GetIPInfo.sig = "ppp";

            function __Unwind_FindEnclosingFunction(ip) {
                ip >>>= 0;
                return 0
            }
            __Unwind_FindEnclosingFunction.sig = "pp";

            function __Unwind_RaiseException(ex) {
                ex >>>= 0;
                err("Warning: _Unwind_RaiseException is not correctly implemented");
                return ___cxa_throw(ex, 0, 0)
            }
            Module["__Unwind_RaiseException"] = __Unwind_RaiseException;
            __Unwind_RaiseException.sig = "ip";

            function __Unwind_DeleteException(ex) {
                ex >>>= 0;
                err("TODO: Unwind_DeleteException")
            }
            Module["__Unwind_DeleteException"] = __Unwind_DeleteException;
            __Unwind_DeleteException.sig = "vp";
            var dynCallLegacy = (sig, ptr, args) => {
                sig = sig.replace(/p/g, "i");
                if (!("dynCall_" + sig in Module)) {
                    Module["dynCall_" + sig] = createDyncallWrapper(sig)
                }
                var f = Module["dynCall_" + sig];
                return f(ptr, ...args)
            };
            var dynCall = (sig, ptr, args = []) => {
                if (sig.includes("j")) {
                    return dynCallLegacy(sig, ptr, args)
                }
                var rtn = getWasmTableEntry(ptr)(...args);
                return sig[0] == "p" ? rtn >>> 0 : rtn
            };
            var getDynCaller = (sig, ptr) => (...args) => dynCall(sig, ptr, args);
            var _emscripten_exit_with_live_runtime = () => {
                throw "unwind"
            };
            _emscripten_exit_with_live_runtime.sig = "v";
            var _emscripten_force_exit = status => {
                __emscripten_runtime_keepalive_clear();
                _exit(status)
            };
            _emscripten_force_exit.sig = "vi";

            function _emscripten_outn(str, len) {
                str >>>= 0;
                len >>>= 0;
                return out(UTF8ToString(str, len))
            }
            _emscripten_outn.sig = "vpp";

            function _emscripten_errn(str, len) {
                str >>>= 0;
                len >>>= 0;
                return err(UTF8ToString(str, len))
            }
            _emscripten_errn.sig = "vpp";
            var _emscripten_throw_number = number => {
                throw number
            };
            _emscripten_throw_number.sig = "vd";

            function _emscripten_throw_string(str) {
                str >>>= 0;
                throw UTF8ToString(str)
            }
            _emscripten_throw_string.sig = "vp";
            var runtimeKeepalivePush = () => {
                runtimeKeepaliveCounter += 1
            };
            runtimeKeepalivePush.sig = "v";
            var runtimeKeepalivePop = () => {
                runtimeKeepaliveCounter -= 1
            };
            runtimeKeepalivePop.sig = "v";
            var _emscripten_runtime_keepalive_push = runtimeKeepalivePush;
            _emscripten_runtime_keepalive_push.sig = "v";
            var _emscripten_runtime_keepalive_pop = runtimeKeepalivePop;
            _emscripten_runtime_keepalive_pop.sig = "v";
            var _emscripten_runtime_keepalive_check = keepRuntimeAlive;
            _emscripten_runtime_keepalive_check.sig = "i";
            var asmjsMangle = x => {
                if (x == "__main_argc_argv") {
                    x = "main"
                }
                return x.startsWith("dynCall_") ? x : "_" + x
            };
            var ___global_base = 1024;

            function __emscripten_fs_load_embedded_files(ptr) {
                ptr >>>= 0;
                do {
                    var name_addr = HEAPU32[ptr >>> 2 >>> 0];
                    ptr += 4;
                    var len = HEAPU32[ptr >>> 2 >>> 0];
                    ptr += 4;
                    var content = HEAPU32[ptr >>> 2 >>> 0];
                    ptr += 4;
                    var name = UTF8ToString(name_addr);
                    FS.createPath("/", PATH.dirname(name), true, true);
                    FS.createDataFile(name, null, HEAP8.subarray(content >>> 0, content + len >>> 0), true, true, true)
                } while (HEAPU32[ptr >>> 2 >>> 0])
            }
            __emscripten_fs_load_embedded_files.sig = "vp";
            var POINTER_SIZE = 4;

            function getNativeTypeSize(type) {
                switch (type) {
                    case "i1":
                    case "i8":
                    case "u8":
                        return 1;
                    case "i16":
                    case "u16":
                        return 2;
                    case "i32":
                    case "u32":
                        return 4;
                    case "i64":
                    case "u64":
                        return 8;
                    case "float":
                        return 4;
                    case "double":
                        return 8;
                    default: {
                        if (type[type.length - 1] === "*") {
                            return POINTER_SIZE
                        }
                        if (type[0] === "i") {
                            const bits = Number(type.substr(1));
                            assert(bits % 8 === 0, `getNativeTypeSize invalid bits ${bits}, ${type} type`);
                            return bits / 8
                        }
                        return 0
                    }
                }
            }
            var STACK_SIZE = 1048576;
            var STACK_ALIGN = 16;
            var ASSERTIONS = 0;
            var cwrap = (ident, returnType, argTypes, opts) => {
                var numericArgs = !argTypes || argTypes.every(type => type === "number" || type === "boolean");
                var numericRet = returnType !== "string";
                if (numericRet && numericArgs && !opts) {
                    return getCFunc(ident)
                }
                return (...args) => ccall(ident, returnType, argTypes, args, opts)
            };
            var removeFunction = index => {
                functionsInTableMap.delete(getWasmTableEntry(index));
                setWasmTableEntry(index, null);
                freeTableIndexes.push(index)
            };
            var _emscripten_math_cbrt = Math.cbrt;
            _emscripten_math_cbrt.sig = "dd";
            var _emscripten_math_pow = Math.pow;
            _emscripten_math_pow.sig = "ddd";
            var _emscripten_math_random = Math.random;
            _emscripten_math_random.sig = "d";
            var _emscripten_math_sign = Math.sign;
            _emscripten_math_sign.sig = "dd";
            var _emscripten_math_sqrt = Math.sqrt;
            _emscripten_math_sqrt.sig = "dd";
            var _emscripten_math_exp = Math.exp;
            _emscripten_math_exp.sig = "dd";
            var _emscripten_math_expm1 = Math.expm1;
            _emscripten_math_expm1.sig = "dd";
            var _emscripten_math_fmod = (x, y) => x % y;
            _emscripten_math_fmod.sig = "ddd";
            var _emscripten_math_log = Math.log;
            _emscripten_math_log.sig = "dd";
            var _emscripten_math_log1p = Math.log1p;
            _emscripten_math_log1p.sig = "dd";
            var _emscripten_math_log10 = Math.log10;
            _emscripten_math_log10.sig = "dd";
            var _emscripten_math_log2 = Math.log2;
            _emscripten_math_log2.sig = "dd";
            var _emscripten_math_round = Math.round;
            _emscripten_math_round.sig = "dd";
            var _emscripten_math_acos = Math.acos;
            _emscripten_math_acos.sig = "dd";
            var _emscripten_math_acosh = Math.acosh;
            _emscripten_math_acosh.sig = "dd";
            var _emscripten_math_asin = Math.asin;
            _emscripten_math_asin.sig = "dd";
            var _emscripten_math_asinh = Math.asinh;
            _emscripten_math_asinh.sig = "dd";
            var _emscripten_math_atan = Math.atan;
            _emscripten_math_atan.sig = "dd";
            var _emscripten_math_atanh = Math.atanh;
            _emscripten_math_atanh.sig = "dd";
            var _emscripten_math_atan2 = Math.atan2;
            _emscripten_math_atan2.sig = "ddd";
            var _emscripten_math_cos = Math.cos;
            _emscripten_math_cos.sig = "dd";
            var _emscripten_math_cosh = Math.cosh;
            _emscripten_math_cosh.sig = "dd";

            function _emscripten_math_hypot(count, varargs) {
                varargs >>>= 0;
                var args = [];
                for (var i = 0; i < count; ++i) {
                    args.push(HEAPF64[varargs + i * 8 >>> 3 >>> 0])
                }
                return Math.hypot(...args)
            }
            _emscripten_math_hypot.sig = "dip";
            var _emscripten_math_sin = Math.sin;
            _emscripten_math_sin.sig = "dd";
            var _emscripten_math_sinh = Math.sinh;
            _emscripten_math_sinh.sig = "dd";
            var _emscripten_math_tan = Math.tan;
            _emscripten_math_tan.sig = "dd";
            var _emscripten_math_tanh = Math.tanh;
            _emscripten_math_tanh.sig = "dd";

            function intArrayToString(array) {
                var ret = [];
                for (var i = 0; i < array.length; i++) {
                    var chr = array[i];
                    if (chr > 255) {
                        chr &= 255
                    }
                    ret.push(String.fromCharCode(chr))
                }
                return ret.join("")
            }
            var AsciiToString = ptr => {
                ptr >>>= 0;
                var str = "";
                while (1) {
                    var ch = HEAPU8[ptr++ >>> 0];
                    if (!ch) return str;
                    str += String.fromCharCode(ch)
                }
            };
            var JSEvents = {
                removeAllEventListeners() {
                    while (JSEvents.eventHandlers.length) {
                        JSEvents._removeHandler(JSEvents.eventHandlers.length - 1)
                    }
                    JSEvents.deferredCalls = []
                },
                inEventHandler: 0,
                deferredCalls: [],
                deferCall(targetFunction, precedence, argsList) {
                    function arraysHaveEqualContent(arrA, arrB) {
                        if (arrA.length != arrB.length) return false;
                        for (var i in arrA) {
                            if (arrA[i] != arrB[i]) return false
                        }
                        return true
                    }
                    for (var call of JSEvents.deferredCalls) {
                        if (call.targetFunction == targetFunction && arraysHaveEqualContent(call.argsList, argsList)) {
                            return
                        }
                    }
                    JSEvents.deferredCalls.push({
                        targetFunction,
                        precedence,
                        argsList
                    });
                    JSEvents.deferredCalls.sort((x, y) => x.precedence < y.precedence)
                },
                removeDeferredCalls(targetFunction) {
                    JSEvents.deferredCalls = JSEvents.deferredCalls.filter(call => call.targetFunction != targetFunction)
                },
                canPerformEventHandlerRequests() {
                    if (navigator.userActivation) {
                        return navigator.userActivation.isActive
                    }
                    return JSEvents.inEventHandler && JSEvents.currentEventHandler.allowsDeferredCalls
                },
                runDeferredCalls() {
                    if (!JSEvents.canPerformEventHandlerRequests()) {
                        return
                    }
                    var deferredCalls = JSEvents.deferredCalls;
                    JSEvents.deferredCalls = [];
                    for (var call of deferredCalls) {
                        call.targetFunction(...call.argsList)
                    }
                },
                eventHandlers: [],
                removeAllHandlersOnTarget: (target, eventTypeString) => {
                    for (var i = 0; i < JSEvents.eventHandlers.length; ++i) {
                        if (JSEvents.eventHandlers[i].target == target && (!eventTypeString || eventTypeString == JSEvents.eventHandlers[i].eventTypeString)) {
                            JSEvents._removeHandler(i--)
                        }
                    }
                },
                _removeHandler(i) {
                    var h = JSEvents.eventHandlers[i];
                    h.target.removeEventListener(h.eventTypeString, h.eventListenerFunc, h.useCapture);
                    JSEvents.eventHandlers.splice(i, 1)
                },
                registerOrRemoveHandler(eventHandler) {
                    if (!eventHandler.target) {
                        return -4
                    }
                    if (eventHandler.callbackfunc) {
                        eventHandler.eventListenerFunc = function(event) {
                            ++JSEvents.inEventHandler;
                            JSEvents.currentEventHandler = eventHandler;
                            JSEvents.runDeferredCalls();
                            eventHandler.handlerFunc(event);
                            JSEvents.runDeferredCalls();
                            --JSEvents.inEventHandler
                        };
                        eventHandler.target.addEventListener(eventHandler.eventTypeString, eventHandler.eventListenerFunc, eventHandler.useCapture);
                        JSEvents.eventHandlers.push(eventHandler)
                    } else {
                        for (var i = 0; i < JSEvents.eventHandlers.length; ++i) {
                            if (JSEvents.eventHandlers[i].target == eventHandler.target && JSEvents.eventHandlers[i].eventTypeString == eventHandler.eventTypeString) {
                                JSEvents._removeHandler(i--)
                            }
                        }
                    }
                    return 0
                },
                getNodeNameForTarget(target) {
                    if (!target) return "";
                    if (target == window) return "#window";
                    if (target == screen) return "#screen";
                    return target?.nodeName || ""
                },
                fullscreenEnabled() {
                    return document.fullscreenEnabled || document.webkitFullscreenEnabled
                }
            };
            var maybeCStringToJsString = cString => cString > 2 ? UTF8ToString(cString) : cString;
            var specialHTMLTargets = [0, typeof document != "undefined" ? document : 0, typeof window != "undefined" ? window : 0];
            var findEventTarget = target => {
                target = maybeCStringToJsString(target);
                var domElement = specialHTMLTargets[target] || (typeof document != "undefined" ? document.querySelector(target) : undefined);
                return domElement
            };
            var registerKeyEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString, targetThread) => {
                JSEvents.keyEvent ||= _malloc(160);
                var keyEventHandlerFunc = e => {
                    var keyEventData = JSEvents.keyEvent;
                    HEAPF64[keyEventData >>> 3 >>> 0] = e.timeStamp;
                    var idx = keyEventData >>> 2;
                    HEAP32[idx + 2 >>> 0] = e.location;
                    HEAP8[keyEventData + 12 >>> 0] = e.ctrlKey;
                    HEAP8[keyEventData + 13 >>> 0] = e.shiftKey;
                    HEAP8[keyEventData + 14 >>> 0] = e.altKey;
                    HEAP8[keyEventData + 15 >>> 0] = e.metaKey;
                    HEAP8[keyEventData + 16 >>> 0] = e.repeat;
                    HEAP32[idx + 5 >>> 0] = e.charCode;
                    HEAP32[idx + 6 >>> 0] = e.keyCode;
                    HEAP32[idx + 7 >>> 0] = e.which;
                    stringToUTF8(e.key || "", keyEventData + 32, 32);
                    stringToUTF8(e.code || "", keyEventData + 64, 32);
                    stringToUTF8(e.char || "", keyEventData + 96, 32);
                    stringToUTF8(e.locale || "", keyEventData + 128, 32);
                    if (getWasmTableEntry(callbackfunc)(eventTypeId, keyEventData, userData)) e.preventDefault()
                };
                var eventHandler = {
                    target: findEventTarget(target),
                    eventTypeString,
                    callbackfunc,
                    handlerFunc: keyEventHandlerFunc,
                    useCapture
                };
                return JSEvents.registerOrRemoveHandler(eventHandler)
            };
            var findCanvasEventTarget = findEventTarget;

            function _emscripten_set_keypress_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                return registerKeyEventCallback(target, userData, useCapture, callbackfunc, 1, "keypress", targetThread)
            }
            _emscripten_set_keypress_callback_on_thread.sig = "ippipp";

            function _emscripten_set_keydown_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                return registerKeyEventCallback(target, userData, useCapture, callbackfunc, 2, "keydown", targetThread)
            }
            _emscripten_set_keydown_callback_on_thread.sig = "ippipp";

            function _emscripten_set_keyup_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                return registerKeyEventCallback(target, userData, useCapture, callbackfunc, 3, "keyup", targetThread)
            }
            _emscripten_set_keyup_callback_on_thread.sig = "ippipp";
            var getBoundingClientRect = e => specialHTMLTargets.indexOf(e) < 0 ? e.getBoundingClientRect() : {
                left: 0,
                top: 0
            };
            var fillMouseEventData = (eventStruct, e, target) => {
                HEAPF64[eventStruct >>> 3 >>> 0] = e.timeStamp;
                var idx = eventStruct >>> 2;
                HEAP32[idx + 2 >>> 0] = e.screenX;
                HEAP32[idx + 3 >>> 0] = e.screenY;
                HEAP32[idx + 4 >>> 0] = e.clientX;
                HEAP32[idx + 5 >>> 0] = e.clientY;
                HEAP8[eventStruct + 24 >>> 0] = e.ctrlKey;
                HEAP8[eventStruct + 25 >>> 0] = e.shiftKey;
                HEAP8[eventStruct + 26 >>> 0] = e.altKey;
                HEAP8[eventStruct + 27 >>> 0] = e.metaKey;
                HEAP16[idx * 2 + 14 >>> 0] = e.button;
                HEAP16[idx * 2 + 15 >>> 0] = e.buttons;
                HEAP32[idx + 8 >>> 0] = e["movementX"];
                HEAP32[idx + 9 >>> 0] = e["movementY"];
                var rect = getBoundingClientRect(target);
                HEAP32[idx + 10 >>> 0] = e.clientX - (rect.left | 0);
                HEAP32[idx + 11 >>> 0] = e.clientY - (rect.top | 0)
            };
            var registerMouseEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString, targetThread) => {
                JSEvents.mouseEvent ||= _malloc(64);
                target = findEventTarget(target);
                var mouseEventHandlerFunc = (e = event) => {
                    fillMouseEventData(JSEvents.mouseEvent, e, target);
                    if (getWasmTableEntry(callbackfunc)(eventTypeId, JSEvents.mouseEvent, userData)) e.preventDefault()
                };
                var eventHandler = {
                    target,
                    allowsDeferredCalls: eventTypeString != "mousemove" && eventTypeString != "mouseenter" && eventTypeString != "mouseleave",
                    eventTypeString,
                    callbackfunc,
                    handlerFunc: mouseEventHandlerFunc,
                    useCapture
                };
                return JSEvents.registerOrRemoveHandler(eventHandler)
            };

            function _emscripten_set_click_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                return registerMouseEventCallback(target, userData, useCapture, callbackfunc, 4, "click", targetThread)
            }
            _emscripten_set_click_callback_on_thread.sig = "ippipp";

            function _emscripten_set_mousedown_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                return registerMouseEventCallback(target, userData, useCapture, callbackfunc, 5, "mousedown", targetThread)
            }
            _emscripten_set_mousedown_callback_on_thread.sig = "ippipp";

            function _emscripten_set_mouseup_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                return registerMouseEventCallback(target, userData, useCapture, callbackfunc, 6, "mouseup", targetThread)
            }
            _emscripten_set_mouseup_callback_on_thread.sig = "ippipp";

            function _emscripten_set_dblclick_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                return registerMouseEventCallback(target, userData, useCapture, callbackfunc, 7, "dblclick", targetThread)
            }
            _emscripten_set_dblclick_callback_on_thread.sig = "ippipp";

            function _emscripten_set_mousemove_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                return registerMouseEventCallback(target, userData, useCapture, callbackfunc, 8, "mousemove", targetThread)
            }
            _emscripten_set_mousemove_callback_on_thread.sig = "ippipp";

            function _emscripten_set_mouseenter_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                return registerMouseEventCallback(target, userData, useCapture, callbackfunc, 33, "mouseenter", targetThread)
            }
            _emscripten_set_mouseenter_callback_on_thread.sig = "ippipp";

            function _emscripten_set_mouseleave_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                return registerMouseEventCallback(target, userData, useCapture, callbackfunc, 34, "mouseleave", targetThread)
            }
            _emscripten_set_mouseleave_callback_on_thread.sig = "ippipp";

            function _emscripten_set_mouseover_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                return registerMouseEventCallback(target, userData, useCapture, callbackfunc, 35, "mouseover", targetThread)
            }
            _emscripten_set_mouseover_callback_on_thread.sig = "ippipp";

            function _emscripten_set_mouseout_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                return registerMouseEventCallback(target, userData, useCapture, callbackfunc, 36, "mouseout", targetThread)
            }
            _emscripten_set_mouseout_callback_on_thread.sig = "ippipp";

            function _emscripten_get_mouse_status(mouseState) {
                mouseState >>>= 0;
                if (!JSEvents.mouseEvent) return -7;
                HEAP8.set(HEAP8.subarray(JSEvents.mouseEvent >>> 0, JSEvents.mouseEvent + 64 >>> 0), mouseState >>> 0);
                return 0
            }
            _emscripten_get_mouse_status.sig = "ip";
            var registerWheelEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString, targetThread) => {
                JSEvents.wheelEvent ||= _malloc(96);
                var wheelHandlerFunc = (e = event) => {
                    var wheelEvent = JSEvents.wheelEvent;
                    fillMouseEventData(wheelEvent, e, target);
                    HEAPF64[wheelEvent + 64 >>> 3 >>> 0] = e["deltaX"];
                    HEAPF64[wheelEvent + 72 >>> 3 >>> 0] = e["deltaY"];
                    HEAPF64[wheelEvent + 80 >>> 3 >>> 0] = e["deltaZ"];
                    HEAP32[wheelEvent + 88 >>> 2 >>> 0] = e["deltaMode"];
                    if (getWasmTableEntry(callbackfunc)(eventTypeId, wheelEvent, userData)) e.preventDefault()
                };
                var eventHandler = {
                    target,
                    allowsDeferredCalls: true,
                    eventTypeString,
                    callbackfunc,
                    handlerFunc: wheelHandlerFunc,
                    useCapture
                };
                return JSEvents.registerOrRemoveHandler(eventHandler)
            };

            function _emscripten_set_wheel_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                target = findEventTarget(target);
                if (!target) return -4;
                if (typeof target.onwheel != "undefined") {
                    return registerWheelEventCallback(target, userData, useCapture, callbackfunc, 9, "wheel", targetThread)
                } else {
                    return -1
                }
            }
            _emscripten_set_wheel_callback_on_thread.sig = "ippipp";
            var registerUiEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString, targetThread) => {
                JSEvents.uiEvent ||= _malloc(36);
                target = findEventTarget(target);
                var uiEventHandlerFunc = (e = event) => {
                    if (e.target != target) {
                        return
                    }
                    var b = document.body;
                    if (!b) {
                        return
                    }
                    var uiEvent = JSEvents.uiEvent;
                    HEAP32[uiEvent >>> 2 >>> 0] = 0;
                    HEAP32[uiEvent + 4 >>> 2 >>> 0] = b.clientWidth;
                    HEAP32[uiEvent + 8 >>> 2 >>> 0] = b.clientHeight;
                    HEAP32[uiEvent + 12 >>> 2 >>> 0] = innerWidth;
                    HEAP32[uiEvent + 16 >>> 2 >>> 0] = innerHeight;
                    HEAP32[uiEvent + 20 >>> 2 >>> 0] = outerWidth;
                    HEAP32[uiEvent + 24 >>> 2 >>> 0] = outerHeight;
                    HEAP32[uiEvent + 28 >>> 2 >>> 0] = pageXOffset | 0;
                    HEAP32[uiEvent + 32 >>> 2 >>> 0] = pageYOffset | 0;
                    if (getWasmTableEntry(callbackfunc)(eventTypeId, uiEvent, userData)) e.preventDefault()
                };
                var eventHandler = {
                    target,
                    eventTypeString,
                    callbackfunc,
                    handlerFunc: uiEventHandlerFunc,
                    useCapture
                };
                return JSEvents.registerOrRemoveHandler(eventHandler)
            };

            function _emscripten_set_resize_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                return registerUiEventCallback(target, userData, useCapture, callbackfunc, 10, "resize", targetThread)
            }
            _emscripten_set_resize_callback_on_thread.sig = "ippipp";

            function _emscripten_set_scroll_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                return registerUiEventCallback(target, userData, useCapture, callbackfunc, 11, "scroll", targetThread)
            }
            _emscripten_set_scroll_callback_on_thread.sig = "ippipp";
            var registerFocusEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString, targetThread) => {
                JSEvents.focusEvent ||= _malloc(256);
                var focusEventHandlerFunc = (e = event) => {
                    var nodeName = JSEvents.getNodeNameForTarget(e.target);
                    var id = e.target.id ? e.target.id : "";
                    var focusEvent = JSEvents.focusEvent;
                    stringToUTF8(nodeName, focusEvent + 0, 128);
                    stringToUTF8(id, focusEvent + 128, 128);
                    if (getWasmTableEntry(callbackfunc)(eventTypeId, focusEvent, userData)) e.preventDefault()
                };
                var eventHandler = {
                    target: findEventTarget(target),
                    eventTypeString,
                    callbackfunc,
                    handlerFunc: focusEventHandlerFunc,
                    useCapture
                };
                return JSEvents.registerOrRemoveHandler(eventHandler)
            };

            function _emscripten_set_blur_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                return registerFocusEventCallback(target, userData, useCapture, callbackfunc, 12, "blur", targetThread)
            }
            _emscripten_set_blur_callback_on_thread.sig = "ippipp";

            function _emscripten_set_focus_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                return registerFocusEventCallback(target, userData, useCapture, callbackfunc, 13, "focus", targetThread)
            }
            _emscripten_set_focus_callback_on_thread.sig = "ippipp";

            function _emscripten_set_focusin_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                return registerFocusEventCallback(target, userData, useCapture, callbackfunc, 14, "focusin", targetThread)
            }
            _emscripten_set_focusin_callback_on_thread.sig = "ippipp";

            function _emscripten_set_focusout_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                return registerFocusEventCallback(target, userData, useCapture, callbackfunc, 15, "focusout", targetThread)
            }
            _emscripten_set_focusout_callback_on_thread.sig = "ippipp";
            var fillDeviceOrientationEventData = (eventStruct, e, target) => {
                HEAPF64[eventStruct >>> 3 >>> 0] = e.alpha;
                HEAPF64[eventStruct + 8 >>> 3 >>> 0] = e.beta;
                HEAPF64[eventStruct + 16 >>> 3 >>> 0] = e.gamma;
                HEAP8[eventStruct + 24 >>> 0] = e.absolute
            };
            var registerDeviceOrientationEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString, targetThread) => {
                JSEvents.deviceOrientationEvent ||= _malloc(32);
                var deviceOrientationEventHandlerFunc = (e = event) => {
                    fillDeviceOrientationEventData(JSEvents.deviceOrientationEvent, e, target);
                    if (getWasmTableEntry(callbackfunc)(eventTypeId, JSEvents.deviceOrientationEvent, userData)) e.preventDefault()
                };
                var eventHandler = {
                    target: findEventTarget(target),
                    eventTypeString,
                    callbackfunc,
                    handlerFunc: deviceOrientationEventHandlerFunc,
                    useCapture
                };
                return JSEvents.registerOrRemoveHandler(eventHandler)
            };

            function _emscripten_set_deviceorientation_callback_on_thread(userData, useCapture, callbackfunc, targetThread) {
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                return registerDeviceOrientationEventCallback(2, userData, useCapture, callbackfunc, 16, "deviceorientation", targetThread)
            }
            _emscripten_set_deviceorientation_callback_on_thread.sig = "ipipp";

            function _emscripten_get_deviceorientation_status(orientationState) {
                orientationState >>>= 0;
                if (!JSEvents.deviceOrientationEvent) return -7;
                HEAP32.set(HEAP32.subarray(JSEvents.deviceOrientationEvent >>> 0, 32 >>> 0), orientationState >>> 0);
                return 0
            }
            _emscripten_get_deviceorientation_status.sig = "ip";
            var fillDeviceMotionEventData = (eventStruct, e, target) => {
                var supportedFields = 0;
                var a = e["acceleration"];
                supportedFields |= a && 1;
                var ag = e["accelerationIncludingGravity"];
                supportedFields |= ag && 2;
                var rr = e["rotationRate"];
                supportedFields |= rr && 4;
                a = a || {};
                ag = ag || {};
                rr = rr || {};
                HEAPF64[eventStruct >>> 3 >>> 0] = a["x"];
                HEAPF64[eventStruct + 8 >>> 3 >>> 0] = a["y"];
                HEAPF64[eventStruct + 16 >>> 3 >>> 0] = a["z"];
                HEAPF64[eventStruct + 24 >>> 3 >>> 0] = ag["x"];
                HEAPF64[eventStruct + 32 >>> 3 >>> 0] = ag["y"];
                HEAPF64[eventStruct + 40 >>> 3 >>> 0] = ag["z"];
                HEAPF64[eventStruct + 48 >>> 3 >>> 0] = rr["alpha"];
                HEAPF64[eventStruct + 56 >>> 3 >>> 0] = rr["beta"];
                HEAPF64[eventStruct + 64 >>> 3 >>> 0] = rr["gamma"]
            };
            var registerDeviceMotionEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString, targetThread) => {
                JSEvents.deviceMotionEvent ||= _malloc(80);
                var deviceMotionEventHandlerFunc = (e = event) => {
                    fillDeviceMotionEventData(JSEvents.deviceMotionEvent, e, target);
                    if (getWasmTableEntry(callbackfunc)(eventTypeId, JSEvents.deviceMotionEvent, userData)) e.preventDefault()
                };
                var eventHandler = {
                    target: findEventTarget(target),
                    eventTypeString,
                    callbackfunc,
                    handlerFunc: deviceMotionEventHandlerFunc,
                    useCapture
                };
                return JSEvents.registerOrRemoveHandler(eventHandler)
            };

            function _emscripten_set_devicemotion_callback_on_thread(userData, useCapture, callbackfunc, targetThread) {
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                return registerDeviceMotionEventCallback(2, userData, useCapture, callbackfunc, 17, "devicemotion", targetThread)
            }
            _emscripten_set_devicemotion_callback_on_thread.sig = "ipipp";

            function _emscripten_get_devicemotion_status(motionState) {
                motionState >>>= 0;
                if (!JSEvents.deviceMotionEvent) return -7;
                HEAP32.set(HEAP32.subarray(JSEvents.deviceMotionEvent >>> 0, 80 >>> 0), motionState >>> 0);
                return 0
            }
            _emscripten_get_devicemotion_status.sig = "ip";
            var screenOrientation = () => {
                if (!window.screen) return undefined;
                return screen.orientation || screen["mozOrientation"] || screen["webkitOrientation"]
            };
            var fillOrientationChangeEventData = eventStruct => {
                var orientationsType1 = ["portrait-primary", "portrait-secondary", "landscape-primary", "landscape-secondary"];
                var orientationsType2 = ["portrait", "portrait", "landscape", "landscape"];
                var orientationIndex = 0;
                var orientationAngle = 0;
                var screenOrientObj = screenOrientation();
                if (typeof screenOrientObj === "object") {
                    orientationIndex = orientationsType1.indexOf(screenOrientObj.type);
                    if (orientationIndex < 0) {
                        orientationIndex = orientationsType2.indexOf(screenOrientObj.type)
                    }
                    if (orientationIndex >= 0) {
                        orientationIndex = 1 << orientationIndex
                    }
                    orientationAngle = screenOrientObj.angle
                } else {
                    orientationAngle = window.orientation
                }
                HEAP32[eventStruct >>> 2 >>> 0] = orientationIndex;
                HEAP32[eventStruct + 4 >>> 2 >>> 0] = orientationAngle
            };
            var registerOrientationChangeEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString, targetThread) => {
                JSEvents.orientationChangeEvent ||= _malloc(8);
                var orientationChangeEventHandlerFunc = (e = event) => {
                    var orientationChangeEvent = JSEvents.orientationChangeEvent;
                    fillOrientationChangeEventData(orientationChangeEvent);
                    if (getWasmTableEntry(callbackfunc)(eventTypeId, orientationChangeEvent, userData)) e.preventDefault()
                };
                var eventHandler = {
                    target,
                    eventTypeString,
                    callbackfunc,
                    handlerFunc: orientationChangeEventHandlerFunc,
                    useCapture
                };
                return JSEvents.registerOrRemoveHandler(eventHandler)
            };

            function _emscripten_set_orientationchange_callback_on_thread(userData, useCapture, callbackfunc, targetThread) {
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                if (!window.screen || !screen.orientation) return -1;
                return registerOrientationChangeEventCallback(screen.orientation, userData, useCapture, callbackfunc, 18, "change", targetThread)
            }
            _emscripten_set_orientationchange_callback_on_thread.sig = "ipipp";

            function _emscripten_get_orientation_status(orientationChangeEvent) {
                orientationChangeEvent >>>= 0;
                if (!screenOrientation() && typeof orientation == "undefined") return -1;
                fillOrientationChangeEventData(orientationChangeEvent);
                return 0
            }
            _emscripten_get_orientation_status.sig = "ip";
            var _emscripten_lock_orientation = allowedOrientations => {
                var orientations = [];
                if (allowedOrientations & 1) orientations.push("portrait-primary");
                if (allowedOrientations & 2) orientations.push("portrait-secondary");
                if (allowedOrientations & 4) orientations.push("landscape-primary");
                if (allowedOrientations & 8) orientations.push("landscape-secondary");
                var succeeded;
                if (screen.lockOrientation) {
                    succeeded = screen.lockOrientation(orientations)
                } else if (screen.mozLockOrientation) {
                    succeeded = screen.mozLockOrientation(orientations)
                } else if (screen.webkitLockOrientation) {
                    succeeded = screen.webkitLockOrientation(orientations)
                } else {
                    return -1
                }
                if (succeeded) {
                    return 0
                }
                return -6
            };
            _emscripten_lock_orientation.sig = "ii";
            var _emscripten_unlock_orientation = () => {
                if (screen.unlockOrientation) {
                    screen.unlockOrientation()
                } else if (screen.mozUnlockOrientation) {
                    screen.mozUnlockOrientation()
                } else if (screen.webkitUnlockOrientation) {
                    screen.webkitUnlockOrientation()
                } else {
                    return -1
                }
                return 0
            };
            _emscripten_unlock_orientation.sig = "i";
            var fillFullscreenChangeEventData = eventStruct => {
                var fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
                var isFullscreen = !!fullscreenElement;
                HEAP8[eventStruct >>> 0] = isFullscreen;
                HEAP8[eventStruct + 1 >>> 0] = JSEvents.fullscreenEnabled();
                var reportedElement = isFullscreen ? fullscreenElement : JSEvents.previousFullscreenElement;
                var nodeName = JSEvents.getNodeNameForTarget(reportedElement);
                var id = reportedElement?.id || "";
                stringToUTF8(nodeName, eventStruct + 2, 128);
                stringToUTF8(id, eventStruct + 130, 128);
                HEAP32[eventStruct + 260 >>> 2 >>> 0] = reportedElement ? reportedElement.clientWidth : 0;
                HEAP32[eventStruct + 264 >>> 2 >>> 0] = reportedElement ? reportedElement.clientHeight : 0;
                HEAP32[eventStruct + 268 >>> 2 >>> 0] = screen.width;
                HEAP32[eventStruct + 272 >>> 2 >>> 0] = screen.height;
                if (isFullscreen) {
                    JSEvents.previousFullscreenElement = fullscreenElement
                }
            };
            var registerFullscreenChangeEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString, targetThread) => {
                JSEvents.fullscreenChangeEvent ||= _malloc(276);
                var fullscreenChangeEventhandlerFunc = (e = event) => {
                    var fullscreenChangeEvent = JSEvents.fullscreenChangeEvent;
                    fillFullscreenChangeEventData(fullscreenChangeEvent);
                    if (getWasmTableEntry(callbackfunc)(eventTypeId, fullscreenChangeEvent, userData)) e.preventDefault()
                };
                var eventHandler = {
                    target,
                    eventTypeString,
                    callbackfunc,
                    handlerFunc: fullscreenChangeEventhandlerFunc,
                    useCapture
                };
                return JSEvents.registerOrRemoveHandler(eventHandler)
            };

            function _emscripten_set_fullscreenchange_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                if (!JSEvents.fullscreenEnabled()) return -1;
                target = findEventTarget(target);
                if (!target) return -4;
                registerFullscreenChangeEventCallback(target, userData, useCapture, callbackfunc, 19, "webkitfullscreenchange", targetThread);
                return registerFullscreenChangeEventCallback(target, userData, useCapture, callbackfunc, 19, "fullscreenchange", targetThread)
            }
            _emscripten_set_fullscreenchange_callback_on_thread.sig = "ippipp";

            function _emscripten_get_fullscreen_status(fullscreenStatus) {
                fullscreenStatus >>>= 0;
                if (!JSEvents.fullscreenEnabled()) return -1;
                fillFullscreenChangeEventData(fullscreenStatus);
                return 0
            }
            _emscripten_get_fullscreen_status.sig = "ip";

            function _emscripten_get_canvas_element_size(target, width, height) {
                target >>>= 0;
                width >>>= 0;
                height >>>= 0;
                var canvas = findCanvasEventTarget(target);
                if (!canvas) return -4;
                HEAP32[width >>> 2 >>> 0] = canvas.width;
                HEAP32[height >>> 2 >>> 0] = canvas.height
            }
            _emscripten_get_canvas_element_size.sig = "ippp";
            var getCanvasElementSize = target => {
                var sp = stackSave();
                var w = stackAlloc(8);
                var h = w + 4;
                var targetInt = stringToUTF8OnStack(target.id);
                var ret = _emscripten_get_canvas_element_size(targetInt, w, h);
                var size = [HEAP32[w >>> 2 >>> 0], HEAP32[h >>> 2 >>> 0]];
                stackRestore(sp);
                return size
            };

            function _emscripten_set_canvas_element_size(target, width, height) {
                target >>>= 0;
                var canvas = findCanvasEventTarget(target);
                if (!canvas) return -4;
                canvas.width = width;
                canvas.height = height;
                return 0
            }
            _emscripten_set_canvas_element_size.sig = "ipii";
            var setCanvasElementSize = (target, width, height) => {
                if (!target.controlTransferredOffscreen) {
                    target.width = width;
                    target.height = height
                } else {
                    var sp = stackSave();
                    var targetInt = stringToUTF8OnStack(target.id);
                    _emscripten_set_canvas_element_size(targetInt, width, height);
                    stackRestore(sp)
                }
            };
            var registerRestoreOldStyle = canvas => {
                var canvasSize = getCanvasElementSize(canvas);
                var oldWidth = canvasSize[0];
                var oldHeight = canvasSize[1];
                var oldCssWidth = canvas.style.width;
                var oldCssHeight = canvas.style.height;
                var oldBackgroundColor = canvas.style.backgroundColor;
                var oldDocumentBackgroundColor = document.body.style.backgroundColor;
                var oldPaddingLeft = canvas.style.paddingLeft;
                var oldPaddingRight = canvas.style.paddingRight;
                var oldPaddingTop = canvas.style.paddingTop;
                var oldPaddingBottom = canvas.style.paddingBottom;
                var oldMarginLeft = canvas.style.marginLeft;
                var oldMarginRight = canvas.style.marginRight;
                var oldMarginTop = canvas.style.marginTop;
                var oldMarginBottom = canvas.style.marginBottom;
                var oldDocumentBodyMargin = document.body.style.margin;
                var oldDocumentOverflow = document.documentElement.style.overflow;
                var oldDocumentScroll = document.body.scroll;
                var oldImageRendering = canvas.style.imageRendering;

                function restoreOldStyle() {
                    var fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement;
                    if (!fullscreenElement) {
                        document.removeEventListener("fullscreenchange", restoreOldStyle);
                        document.removeEventListener("webkitfullscreenchange", restoreOldStyle);
                        setCanvasElementSize(canvas, oldWidth, oldHeight);
                        canvas.style.width = oldCssWidth;
                        canvas.style.height = oldCssHeight;
                        canvas.style.backgroundColor = oldBackgroundColor;
                        if (!oldDocumentBackgroundColor) document.body.style.backgroundColor = "white";
                        document.body.style.backgroundColor = oldDocumentBackgroundColor;
                        canvas.style.paddingLeft = oldPaddingLeft;
                        canvas.style.paddingRight = oldPaddingRight;
                        canvas.style.paddingTop = oldPaddingTop;
                        canvas.style.paddingBottom = oldPaddingBottom;
                        canvas.style.marginLeft = oldMarginLeft;
                        canvas.style.marginRight = oldMarginRight;
                        canvas.style.marginTop = oldMarginTop;
                        canvas.style.marginBottom = oldMarginBottom;
                        document.body.style.margin = oldDocumentBodyMargin;
                        document.documentElement.style.overflow = oldDocumentOverflow;
                        document.body.scroll = oldDocumentScroll;
                        canvas.style.imageRendering = oldImageRendering;
                        if (canvas.GLctxObject) canvas.GLctxObject.GLctx.viewport(0, 0, oldWidth, oldHeight);
                        if (currentFullscreenStrategy.canvasResizedCallback) {
                            getWasmTableEntry(currentFullscreenStrategy.canvasResizedCallback)(37, 0, currentFullscreenStrategy.canvasResizedCallbackUserData)
                        }
                    }
                }
                document.addEventListener("fullscreenchange", restoreOldStyle);
                document.addEventListener("webkitfullscreenchange", restoreOldStyle);
                return restoreOldStyle
            };
            var setLetterbox = (element, topBottom, leftRight) => {
                element.style.paddingLeft = element.style.paddingRight = leftRight + "px";
                element.style.paddingTop = element.style.paddingBottom = topBottom + "px"
            };
            var JSEvents_resizeCanvasForFullscreen = (target, strategy) => {
                var restoreOldStyle = registerRestoreOldStyle(target);
                var cssWidth = strategy.softFullscreen ? innerWidth : screen.width;
                var cssHeight = strategy.softFullscreen ? innerHeight : screen.height;
                var rect = getBoundingClientRect(target);
                var windowedCssWidth = rect.width;
                var windowedCssHeight = rect.height;
                var canvasSize = getCanvasElementSize(target);
                var windowedRttWidth = canvasSize[0];
                var windowedRttHeight = canvasSize[1];
                if (strategy.scaleMode == 3) {
                    setLetterbox(target, (cssHeight - windowedCssHeight) / 2, (cssWidth - windowedCssWidth) / 2);
                    cssWidth = windowedCssWidth;
                    cssHeight = windowedCssHeight
                } else if (strategy.scaleMode == 2) {
                    if (cssWidth * windowedRttHeight < windowedRttWidth * cssHeight) {
                        var desiredCssHeight = windowedRttHeight * cssWidth / windowedRttWidth;
                        setLetterbox(target, (cssHeight - desiredCssHeight) / 2, 0);
                        cssHeight = desiredCssHeight
                    } else {
                        var desiredCssWidth = windowedRttWidth * cssHeight / windowedRttHeight;
                        setLetterbox(target, 0, (cssWidth - desiredCssWidth) / 2);
                        cssWidth = desiredCssWidth
                    }
                }
                target.style.backgroundColor ||= "black";
                document.body.style.backgroundColor ||= "black";
                target.style.width = cssWidth + "px";
                target.style.height = cssHeight + "px";
                if (strategy.filteringMode == 1) {
                    target.style.imageRendering = "optimizeSpeed";
                    target.style.imageRendering = "-moz-crisp-edges";
                    target.style.imageRendering = "-o-crisp-edges";
                    target.style.imageRendering = "-webkit-optimize-contrast";
                    target.style.imageRendering = "optimize-contrast";
                    target.style.imageRendering = "crisp-edges";
                    target.style.imageRendering = "pixelated"
                }
                var dpiScale = strategy.canvasResolutionScaleMode == 2 ? devicePixelRatio : 1;
                if (strategy.canvasResolutionScaleMode != 0) {
                    var newWidth = cssWidth * dpiScale | 0;
                    var newHeight = cssHeight * dpiScale | 0;
                    setCanvasElementSize(target, newWidth, newHeight);
                    if (target.GLctxObject) target.GLctxObject.GLctx.viewport(0, 0, newWidth, newHeight)
                }
                return restoreOldStyle
            };
            var JSEvents_requestFullscreen = (target, strategy) => {
                if (strategy.scaleMode != 0 || strategy.canvasResolutionScaleMode != 0) {
                    JSEvents_resizeCanvasForFullscreen(target, strategy)
                }
                if (target.requestFullscreen) {
                    target.requestFullscreen()
                } else if (target.webkitRequestFullscreen) {
                    target.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)
                } else {
                    return JSEvents.fullscreenEnabled() ? -3 : -1
                }
                currentFullscreenStrategy = strategy;
                if (strategy.canvasResizedCallback) {
                    getWasmTableEntry(strategy.canvasResizedCallback)(37, 0, strategy.canvasResizedCallbackUserData)
                }
                return 0
            };
            var hideEverythingExceptGivenElement = onlyVisibleElement => {
                var child = onlyVisibleElement;
                var parent = child.parentNode;
                var hiddenElements = [];
                while (child != document.body) {
                    var children = parent.children;
                    for (var i = 0; i < children.length; ++i) {
                        if (children[i] != child) {
                            hiddenElements.push({
                                node: children[i],
                                displayState: children[i].style.display
                            });
                            children[i].style.display = "none"
                        }
                    }
                    child = parent;
                    parent = parent.parentNode
                }
                return hiddenElements
            };
            var restoreHiddenElements = hiddenElements => {
                for (var elem of hiddenElements) {
                    elem.node.style.display = elem.displayState
                }
            };
            var currentFullscreenStrategy = {};
            var restoreOldWindowedStyle = null;
            var softFullscreenResizeWebGLRenderTarget = () => {
                var dpr = devicePixelRatio;
                var inHiDPIFullscreenMode = currentFullscreenStrategy.canvasResolutionScaleMode == 2;
                var inAspectRatioFixedFullscreenMode = currentFullscreenStrategy.scaleMode == 2;
                var inPixelPerfectFullscreenMode = currentFullscreenStrategy.canvasResolutionScaleMode != 0;
                var inCenteredWithoutScalingFullscreenMode = currentFullscreenStrategy.scaleMode == 3;
                var screenWidth = inHiDPIFullscreenMode ? Math.round(innerWidth * dpr) : innerWidth;
                var screenHeight = inHiDPIFullscreenMode ? Math.round(innerHeight * dpr) : innerHeight;
                var w = screenWidth;
                var h = screenHeight;
                var canvas = currentFullscreenStrategy.target;
                var canvasSize = getCanvasElementSize(canvas);
                var x = canvasSize[0];
                var y = canvasSize[1];
                var topMargin;
                if (inAspectRatioFixedFullscreenMode) {
                    if (w * y < x * h) h = w * y / x | 0;
                    else if (w * y > x * h) w = h * x / y | 0;
                    topMargin = (screenHeight - h) / 2 | 0
                }
                if (inPixelPerfectFullscreenMode) {
                    setCanvasElementSize(canvas, w, h);
                    if (canvas.GLctxObject) canvas.GLctxObject.GLctx.viewport(0, 0, w, h)
                }
                if (inHiDPIFullscreenMode) {
                    topMargin /= dpr;
                    w /= dpr;
                    h /= dpr;
                    w = Math.round(w * 1e4) / 1e4;
                    h = Math.round(h * 1e4) / 1e4;
                    topMargin = Math.round(topMargin * 1e4) / 1e4
                }
                if (inCenteredWithoutScalingFullscreenMode) {
                    var t = (innerHeight - jstoi_q(canvas.style.height)) / 2;
                    var b = (innerWidth - jstoi_q(canvas.style.width)) / 2;
                    setLetterbox(canvas, t, b)
                } else {
                    canvas.style.width = w + "px";
                    canvas.style.height = h + "px";
                    var b = (innerWidth - w) / 2;
                    setLetterbox(canvas, topMargin, b)
                }
                if (!inCenteredWithoutScalingFullscreenMode && currentFullscreenStrategy.canvasResizedCallback) {
                    getWasmTableEntry(currentFullscreenStrategy.canvasResizedCallback)(37, 0, currentFullscreenStrategy.canvasResizedCallbackUserData)
                }
            };
            var doRequestFullscreen = (target, strategy) => {
                if (!JSEvents.fullscreenEnabled()) return -1;
                target = findEventTarget(target);
                if (!target) return -4;
                if (!target.requestFullscreen && !target.webkitRequestFullscreen) {
                    return -3
                }
                if (!JSEvents.canPerformEventHandlerRequests()) {
                    if (strategy.deferUntilInEventHandler) {
                        JSEvents.deferCall(JSEvents_requestFullscreen, 1, [target, strategy]);
                        return 1
                    }
                    return -2
                }
                return JSEvents_requestFullscreen(target, strategy)
            };

            function _emscripten_request_fullscreen(target, deferUntilInEventHandler) {
                target >>>= 0;
                var strategy = {
                    scaleMode: 0,
                    canvasResolutionScaleMode: 0,
                    filteringMode: 0,
                    deferUntilInEventHandler,
                    canvasResizedCallbackTargetThread: 2
                };
                return doRequestFullscreen(target, strategy)
            }
            _emscripten_request_fullscreen.sig = "ipi";

            function _emscripten_request_fullscreen_strategy(target, deferUntilInEventHandler, fullscreenStrategy) {
                target >>>= 0;
                fullscreenStrategy >>>= 0;
                var strategy = {
                    scaleMode: HEAP32[fullscreenStrategy >>> 2 >>> 0],
                    canvasResolutionScaleMode: HEAP32[fullscreenStrategy + 4 >>> 2 >>> 0],
                    filteringMode: HEAP32[fullscreenStrategy + 8 >>> 2 >>> 0],
                    deferUntilInEventHandler,
                    canvasResizedCallback: HEAP32[fullscreenStrategy + 12 >>> 2 >>> 0],
                    canvasResizedCallbackUserData: HEAP32[fullscreenStrategy + 16 >>> 2 >>> 0]
                };
                return doRequestFullscreen(target, strategy)
            }
            _emscripten_request_fullscreen_strategy.sig = "ipip";

            function _emscripten_enter_soft_fullscreen(target, fullscreenStrategy) {
                target >>>= 0;
                fullscreenStrategy >>>= 0;
                target = findEventTarget(target);
                if (!target) return -4;
                var strategy = {
                    scaleMode: HEAP32[fullscreenStrategy >>> 2 >>> 0],
                    canvasResolutionScaleMode: HEAP32[fullscreenStrategy + 4 >>> 2 >>> 0],
                    filteringMode: HEAP32[fullscreenStrategy + 8 >>> 2 >>> 0],
                    canvasResizedCallback: HEAP32[fullscreenStrategy + 12 >>> 2 >>> 0],
                    canvasResizedCallbackUserData: HEAP32[fullscreenStrategy + 16 >>> 2 >>> 0],
                    target,
                    softFullscreen: true
                };
                var restoreOldStyle = JSEvents_resizeCanvasForFullscreen(target, strategy);
                document.documentElement.style.overflow = "hidden";
                document.body.scroll = "no";
                document.body.style.margin = "0px";
                var hiddenElements = hideEverythingExceptGivenElement(target);

                function restoreWindowedState() {
                    restoreOldStyle();
                    restoreHiddenElements(hiddenElements);
                    removeEventListener("resize", softFullscreenResizeWebGLRenderTarget);
                    if (strategy.canvasResizedCallback) {
                        getWasmTableEntry(strategy.canvasResizedCallback)(37, 0, strategy.canvasResizedCallbackUserData)
                    }
                    currentFullscreenStrategy = 0
                }
                restoreOldWindowedStyle = restoreWindowedState;
                currentFullscreenStrategy = strategy;
                addEventListener("resize", softFullscreenResizeWebGLRenderTarget);
                if (strategy.canvasResizedCallback) {
                    getWasmTableEntry(strategy.canvasResizedCallback)(37, 0, strategy.canvasResizedCallbackUserData)
                }
                return 0
            }
            _emscripten_enter_soft_fullscreen.sig = "ipp";
            var _emscripten_exit_soft_fullscreen = () => {
                restoreOldWindowedStyle?.();
                restoreOldWindowedStyle = null;
                return 0
            };
            _emscripten_exit_soft_fullscreen.sig = "i";
            var _emscripten_exit_fullscreen = () => {
                if (!JSEvents.fullscreenEnabled()) return -1;
                JSEvents.removeDeferredCalls(JSEvents_requestFullscreen);
                var d = specialHTMLTargets[1];
                if (d.exitFullscreen) {
                    d.fullscreenElement && d.exitFullscreen()
                } else if (d.webkitExitFullscreen) {
                    d.webkitFullscreenElement && d.webkitExitFullscreen()
                } else {
                    return -1
                }
                return 0
            };
            _emscripten_exit_fullscreen.sig = "i";
            var fillPointerlockChangeEventData = eventStruct => {
                var pointerLockElement = document.pointerLockElement || document.mozPointerLockElement || document.webkitPointerLockElement || document.msPointerLockElement;
                var isPointerlocked = !!pointerLockElement;
                HEAP8[eventStruct >>> 0] = isPointerlocked;
                var nodeName = JSEvents.getNodeNameForTarget(pointerLockElement);
                var id = pointerLockElement?.id || "";
                stringToUTF8(nodeName, eventStruct + 1, 128);
                stringToUTF8(id, eventStruct + 129, 128)
            };
            var registerPointerlockChangeEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString, targetThread) => {
                JSEvents.pointerlockChangeEvent ||= _malloc(257);
                var pointerlockChangeEventHandlerFunc = (e = event) => {
                    var pointerlockChangeEvent = JSEvents.pointerlockChangeEvent;
                    fillPointerlockChangeEventData(pointerlockChangeEvent);
                    if (getWasmTableEntry(callbackfunc)(eventTypeId, pointerlockChangeEvent, userData)) e.preventDefault()
                };
                var eventHandler = {
                    target,
                    eventTypeString,
                    callbackfunc,
                    handlerFunc: pointerlockChangeEventHandlerFunc,
                    useCapture
                };
                return JSEvents.registerOrRemoveHandler(eventHandler)
            };

            function _emscripten_set_pointerlockchange_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                if (!document || !document.body || !document.body.requestPointerLock && !document.body.mozRequestPointerLock && !document.body.webkitRequestPointerLock && !document.body.msRequestPointerLock) {
                    return -1
                }
                target = findEventTarget(target);
                if (!target) return -4;
                registerPointerlockChangeEventCallback(target, userData, useCapture, callbackfunc, 20, "mozpointerlockchange", targetThread);
                registerPointerlockChangeEventCallback(target, userData, useCapture, callbackfunc, 20, "webkitpointerlockchange", targetThread);
                registerPointerlockChangeEventCallback(target, userData, useCapture, callbackfunc, 20, "mspointerlockchange", targetThread);
                return registerPointerlockChangeEventCallback(target, userData, useCapture, callbackfunc, 20, "pointerlockchange", targetThread)
            }
            _emscripten_set_pointerlockchange_callback_on_thread.sig = "ippipp";
            var registerPointerlockErrorEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString, targetThread) => {
                var pointerlockErrorEventHandlerFunc = (e = event) => {
                    if (getWasmTableEntry(callbackfunc)(eventTypeId, 0, userData)) e.preventDefault()
                };
                var eventHandler = {
                    target,
                    eventTypeString,
                    callbackfunc,
                    handlerFunc: pointerlockErrorEventHandlerFunc,
                    useCapture
                };
                return JSEvents.registerOrRemoveHandler(eventHandler)
            };

            function _emscripten_set_pointerlockerror_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                if (!document || !document.body.requestPointerLock && !document.body.mozRequestPointerLock && !document.body.webkitRequestPointerLock && !document.body.msRequestPointerLock) {
                    return -1
                }
                target = findEventTarget(target);
                if (!target) return -4;
                registerPointerlockErrorEventCallback(target, userData, useCapture, callbackfunc, 38, "mozpointerlockerror", targetThread);
                registerPointerlockErrorEventCallback(target, userData, useCapture, callbackfunc, 38, "webkitpointerlockerror", targetThread);
                registerPointerlockErrorEventCallback(target, userData, useCapture, callbackfunc, 38, "mspointerlockerror", targetThread);
                return registerPointerlockErrorEventCallback(target, userData, useCapture, callbackfunc, 38, "pointerlockerror", targetThread)
            }
            _emscripten_set_pointerlockerror_callback_on_thread.sig = "ippipp";

            function _emscripten_get_pointerlock_status(pointerlockStatus) {
                pointerlockStatus >>>= 0;
                if (pointerlockStatus) fillPointerlockChangeEventData(pointerlockStatus);
                if (!document.body || !document.body.requestPointerLock && !document.body.mozRequestPointerLock && !document.body.webkitRequestPointerLock && !document.body.msRequestPointerLock) {
                    return -1
                }
                return 0
            }
            _emscripten_get_pointerlock_status.sig = "ip";
            var requestPointerLock = target => {
                if (target.requestPointerLock) {
                    target.requestPointerLock()
                } else {
                    if (document.body.requestPointerLock) {
                        return -3
                    }
                    return -1
                }
                return 0
            };

            function _emscripten_request_pointerlock(target, deferUntilInEventHandler) {
                target >>>= 0;
                target = findEventTarget(target);
                if (!target) return -4;
                if (!target.requestPointerLock) {
                    return -1
                }
                if (!JSEvents.canPerformEventHandlerRequests()) {
                    if (deferUntilInEventHandler) {
                        JSEvents.deferCall(requestPointerLock, 2, [target]);
                        return 1
                    }
                    return -2
                }
                return requestPointerLock(target)
            }
            _emscripten_request_pointerlock.sig = "ipi";
            var _emscripten_exit_pointerlock = () => {
                JSEvents.removeDeferredCalls(requestPointerLock);
                if (document.exitPointerLock) {
                    document.exitPointerLock()
                } else {
                    return -1
                }
                return 0
            };
            _emscripten_exit_pointerlock.sig = "i";
            var _emscripten_vibrate = msecs => {
                if (!navigator.vibrate) return -1;
                navigator.vibrate(msecs);
                return 0
            };
            _emscripten_vibrate.sig = "ii";

            function _emscripten_vibrate_pattern(msecsArray, numEntries) {
                msecsArray >>>= 0;
                if (!navigator.vibrate) return -1;
                var vibrateList = [];
                for (var i = 0; i < numEntries; ++i) {
                    var msecs = HEAP32[msecsArray + i * 4 >>> 2 >>> 0];
                    vibrateList.push(msecs)
                }
                navigator.vibrate(vibrateList);
                return 0
            }
            _emscripten_vibrate_pattern.sig = "ipi";
            var fillVisibilityChangeEventData = eventStruct => {
                var visibilityStates = ["hidden", "visible", "prerender", "unloaded"];
                var visibilityState = visibilityStates.indexOf(document.visibilityState);
                HEAP8[eventStruct >>> 0] = document.hidden;
                HEAP32[eventStruct + 4 >>> 2 >>> 0] = visibilityState
            };
            var registerVisibilityChangeEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString, targetThread) => {
                JSEvents.visibilityChangeEvent ||= _malloc(8);
                var visibilityChangeEventHandlerFunc = (e = event) => {
                    var visibilityChangeEvent = JSEvents.visibilityChangeEvent;
                    fillVisibilityChangeEventData(visibilityChangeEvent);
                    if (getWasmTableEntry(callbackfunc)(eventTypeId, visibilityChangeEvent, userData)) e.preventDefault()
                };
                var eventHandler = {
                    target,
                    eventTypeString,
                    callbackfunc,
                    handlerFunc: visibilityChangeEventHandlerFunc,
                    useCapture
                };
                return JSEvents.registerOrRemoveHandler(eventHandler)
            };

            function _emscripten_set_visibilitychange_callback_on_thread(userData, useCapture, callbackfunc, targetThread) {
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                if (!specialHTMLTargets[1]) {
                    return -4
                }
                return registerVisibilityChangeEventCallback(specialHTMLTargets[1], userData, useCapture, callbackfunc, 21, "visibilitychange", targetThread)
            }
            _emscripten_set_visibilitychange_callback_on_thread.sig = "ipipp";

            function _emscripten_get_visibility_status(visibilityStatus) {
                visibilityStatus >>>= 0;
                if (typeof document.visibilityState == "undefined" && typeof document.hidden == "undefined") {
                    return -1
                }
                fillVisibilityChangeEventData(visibilityStatus);
                return 0
            }
            _emscripten_get_visibility_status.sig = "ip";
            var registerTouchEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString, targetThread) => {
                JSEvents.touchEvent ||= _malloc(1552);
                target = findEventTarget(target);
                var touchEventHandlerFunc = e => {
                    var t, touches = {},
                        et = e.touches;
                    for (let t of et) {
                        t.isChanged = t.onTarget = 0;
                        touches[t.identifier] = t
                    }
                    for (let t of e.changedTouches) {
                        t.isChanged = 1;
                        touches[t.identifier] = t
                    }
                    for (let t of e.targetTouches) {
                        touches[t.identifier].onTarget = 1
                    }
                    var touchEvent = JSEvents.touchEvent;
                    HEAPF64[touchEvent >>> 3 >>> 0] = e.timeStamp;
                    HEAP8[touchEvent + 12 >>> 0] = e.ctrlKey;
                    HEAP8[touchEvent + 13 >>> 0] = e.shiftKey;
                    HEAP8[touchEvent + 14 >>> 0] = e.altKey;
                    HEAP8[touchEvent + 15 >>> 0] = e.metaKey;
                    var idx = touchEvent + 16;
                    var targetRect = getBoundingClientRect(target);
                    var numTouches = 0;
                    for (let t of Object.values(touches)) {
                        var idx32 = idx >>> 2;
                        HEAP32[idx32 + 0 >>> 0] = t.identifier;
                        HEAP32[idx32 + 1 >>> 0] = t.screenX;
                        HEAP32[idx32 + 2 >>> 0] = t.screenY;
                        HEAP32[idx32 + 3 >>> 0] = t.clientX;
                        HEAP32[idx32 + 4 >>> 0] = t.clientY;
                        HEAP32[idx32 + 5 >>> 0] = t.pageX;
                        HEAP32[idx32 + 6 >>> 0] = t.pageY;
                        HEAP8[idx + 28 >>> 0] = t.isChanged;
                        HEAP8[idx + 29 >>> 0] = t.onTarget;
                        HEAP32[idx32 + 8 >>> 0] = t.clientX - (targetRect.left | 0);
                        HEAP32[idx32 + 9 >>> 0] = t.clientY - (targetRect.top | 0);
                        idx += 48;
                        if (++numTouches > 31) {
                            break
                        }
                    }
                    HEAP32[touchEvent + 8 >>> 2 >>> 0] = numTouches;
                    if (getWasmTableEntry(callbackfunc)(eventTypeId, touchEvent, userData)) e.preventDefault()
                };
                var eventHandler = {
                    target,
                    allowsDeferredCalls: eventTypeString == "touchstart" || eventTypeString == "touchend",
                    eventTypeString,
                    callbackfunc,
                    handlerFunc: touchEventHandlerFunc,
                    useCapture
                };
                return JSEvents.registerOrRemoveHandler(eventHandler)
            };

            function _emscripten_set_touchstart_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                return registerTouchEventCallback(target, userData, useCapture, callbackfunc, 22, "touchstart", targetThread)
            }
            _emscripten_set_touchstart_callback_on_thread.sig = "ippipp";

            function _emscripten_set_touchend_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                return registerTouchEventCallback(target, userData, useCapture, callbackfunc, 23, "touchend", targetThread)
            }
            _emscripten_set_touchend_callback_on_thread.sig = "ippipp";

            function _emscripten_set_touchmove_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                return registerTouchEventCallback(target, userData, useCapture, callbackfunc, 24, "touchmove", targetThread)
            }
            _emscripten_set_touchmove_callback_on_thread.sig = "ippipp";

            function _emscripten_set_touchcancel_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                return registerTouchEventCallback(target, userData, useCapture, callbackfunc, 25, "touchcancel", targetThread)
            }
            _emscripten_set_touchcancel_callback_on_thread.sig = "ippipp";
            var fillGamepadEventData = (eventStruct, e) => {
                HEAPF64[eventStruct >>> 3 >>> 0] = e.timestamp;
                for (var i = 0; i < e.axes.length; ++i) {
                    HEAPF64[eventStruct + i * 8 + 16 >>> 3 >>> 0] = e.axes[i]
                }
                for (var i = 0; i < e.buttons.length; ++i) {
                    if (typeof e.buttons[i] == "object") {
                        HEAPF64[eventStruct + i * 8 + 528 >>> 3 >>> 0] = e.buttons[i].value
                    } else {
                        HEAPF64[eventStruct + i * 8 + 528 >>> 3 >>> 0] = e.buttons[i]
                    }
                }
                for (var i = 0; i < e.buttons.length; ++i) {
                    if (typeof e.buttons[i] == "object") {
                        HEAP8[eventStruct + i + 1040 >>> 0] = e.buttons[i].pressed
                    } else {
                        HEAP8[eventStruct + i + 1040 >>> 0] = e.buttons[i] == 1
                    }
                }
                HEAP8[eventStruct + 1104 >>> 0] = e.connected;
                HEAP32[eventStruct + 1108 >>> 2 >>> 0] = e.index;
                HEAP32[eventStruct + 8 >>> 2 >>> 0] = e.axes.length;
                HEAP32[eventStruct + 12 >>> 2 >>> 0] = e.buttons.length;
                stringToUTF8(e.id, eventStruct + 1112, 64);
                stringToUTF8(e.mapping, eventStruct + 1176, 64)
            };
            var registerGamepadEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString, targetThread) => {
                JSEvents.gamepadEvent ||= _malloc(1240);
                var gamepadEventHandlerFunc = (e = event) => {
                    var gamepadEvent = JSEvents.gamepadEvent;
                    fillGamepadEventData(gamepadEvent, e["gamepad"]);
                    if (getWasmTableEntry(callbackfunc)(eventTypeId, gamepadEvent, userData)) e.preventDefault()
                };
                var eventHandler = {
                    target: findEventTarget(target),
                    allowsDeferredCalls: true,
                    eventTypeString,
                    callbackfunc,
                    handlerFunc: gamepadEventHandlerFunc,
                    useCapture
                };
                return JSEvents.registerOrRemoveHandler(eventHandler)
            };
            var _emscripten_sample_gamepad_data = () => {
                try {
                    if (navigator.getGamepads) return (JSEvents.lastGamepadState = navigator.getGamepads()) ? 0 : -1
                } catch (e) {
                    navigator.getGamepads = null
                }
                return -1
            };
            _emscripten_sample_gamepad_data.sig = "i";

            function _emscripten_set_gamepadconnected_callback_on_thread(userData, useCapture, callbackfunc, targetThread) {
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                if (_emscripten_sample_gamepad_data()) return -1;
                return registerGamepadEventCallback(2, userData, useCapture, callbackfunc, 26, "gamepadconnected", targetThread)
            }
            _emscripten_set_gamepadconnected_callback_on_thread.sig = "ipipp";

            function _emscripten_set_gamepaddisconnected_callback_on_thread(userData, useCapture, callbackfunc, targetThread) {
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                if (_emscripten_sample_gamepad_data()) return -1;
                return registerGamepadEventCallback(2, userData, useCapture, callbackfunc, 27, "gamepaddisconnected", targetThread)
            }
            _emscripten_set_gamepaddisconnected_callback_on_thread.sig = "ipipp";
            var _emscripten_get_num_gamepads = () => JSEvents.lastGamepadState.length;
            _emscripten_get_num_gamepads.sig = "i";

            function _emscripten_get_gamepad_status(index, gamepadState) {
                gamepadState >>>= 0;
                if (index < 0 || index >= JSEvents.lastGamepadState.length) return -5;
                if (!JSEvents.lastGamepadState[index]) return -7;
                fillGamepadEventData(gamepadState, JSEvents.lastGamepadState[index]);
                return 0
            }
            _emscripten_get_gamepad_status.sig = "iip";
            var registerBeforeUnloadEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString) => {
                var beforeUnloadEventHandlerFunc = (e = event) => {
                    var confirmationMessage = getWasmTableEntry(callbackfunc)(eventTypeId, 0, userData);
                    if (confirmationMessage) {
                        confirmationMessage = UTF8ToString(confirmationMessage)
                    }
                    if (confirmationMessage) {
                        e.preventDefault();
                        e.returnValue = confirmationMessage;
                        return confirmationMessage
                    }
                };
                var eventHandler = {
                    target: findEventTarget(target),
                    eventTypeString,
                    callbackfunc,
                    handlerFunc: beforeUnloadEventHandlerFunc,
                    useCapture
                };
                return JSEvents.registerOrRemoveHandler(eventHandler)
            };

            function _emscripten_set_beforeunload_callback_on_thread(userData, callbackfunc, targetThread) {
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                if (typeof onbeforeunload == "undefined") return -1;
                if (targetThread !== 1) return -5;
                return registerBeforeUnloadEventCallback(2, userData, true, callbackfunc, 28, "beforeunload")
            }
            _emscripten_set_beforeunload_callback_on_thread.sig = "ippp";
            var fillBatteryEventData = (eventStruct, e) => {
                HEAPF64[eventStruct >>> 3 >>> 0] = e.chargingTime;
                HEAPF64[eventStruct + 8 >>> 3 >>> 0] = e.dischargingTime;
                HEAPF64[eventStruct + 16 >>> 3 >>> 0] = e.level;
                HEAP8[eventStruct + 24 >>> 0] = e.charging
            };
            var battery = () => navigator.battery || navigator.mozBattery || navigator.webkitBattery;
            var registerBatteryEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString, targetThread) => {
                JSEvents.batteryEvent ||= _malloc(32);
                var batteryEventHandlerFunc = (e = event) => {
                    var batteryEvent = JSEvents.batteryEvent;
                    fillBatteryEventData(batteryEvent, battery());
                    if (getWasmTableEntry(callbackfunc)(eventTypeId, batteryEvent, userData)) e.preventDefault()
                };
                var eventHandler = {
                    target: findEventTarget(target),
                    eventTypeString,
                    callbackfunc,
                    handlerFunc: batteryEventHandlerFunc,
                    useCapture
                };
                return JSEvents.registerOrRemoveHandler(eventHandler)
            };

            function _emscripten_set_batterychargingchange_callback_on_thread(userData, callbackfunc, targetThread) {
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                if (!battery()) return -1;
                return registerBatteryEventCallback(battery(), userData, true, callbackfunc, 29, "chargingchange", targetThread)
            }
            _emscripten_set_batterychargingchange_callback_on_thread.sig = "ippp";

            function _emscripten_set_batterylevelchange_callback_on_thread(userData, callbackfunc, targetThread) {
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                if (!battery()) return -1;
                return registerBatteryEventCallback(battery(), userData, true, callbackfunc, 30, "levelchange", targetThread)
            }
            _emscripten_set_batterylevelchange_callback_on_thread.sig = "ippp";

            function _emscripten_get_battery_status(batteryState) {
                batteryState >>>= 0;
                if (!battery()) return -1;
                fillBatteryEventData(batteryState, battery());
                return 0
            }
            _emscripten_get_battery_status.sig = "ip";

            function _emscripten_set_element_css_size(target, width, height) {
                target >>>= 0;
                target = findEventTarget(target);
                if (!target) return -4;
                target.style.width = width + "px";
                target.style.height = height + "px";
                return 0
            }
            _emscripten_set_element_css_size.sig = "ipdd";

            function _emscripten_get_element_css_size(target, width, height) {
                target >>>= 0;
                width >>>= 0;
                height >>>= 0;
                target = findEventTarget(target);
                if (!target) return -4;
                var rect = getBoundingClientRect(target);
                HEAPF64[width >>> 3 >>> 0] = rect.width;
                HEAPF64[height >>> 3 >>> 0] = rect.height;
                return 0
            }
            _emscripten_get_element_css_size.sig = "ippp";
            var _emscripten_html5_remove_all_event_listeners = () => JSEvents.removeAllEventListeners();
            _emscripten_html5_remove_all_event_listeners.sig = "v";
            var _emscripten_request_animation_frame = function(cb, userData) {
                cb >>>= 0;
                userData >>>= 0;
                return requestAnimationFrame(timeStamp => getWasmTableEntry(cb)(timeStamp, userData))
            };
            _emscripten_request_animation_frame.sig = "ipp";
            var _emscripten_cancel_animation_frame = id => cancelAnimationFrame(id);
            _emscripten_cancel_animation_frame.sig = "vi";

            function _emscripten_request_animation_frame_loop(cb, userData) {
                cb >>>= 0;
                userData >>>= 0;

                function tick(timeStamp) {
                    if (getWasmTableEntry(cb)(timeStamp, userData)) {
                        requestAnimationFrame(tick)
                    }
                }
                return requestAnimationFrame(tick)
            }
            _emscripten_request_animation_frame_loop.sig = "vpp";
            var _emscripten_performance_now = () => performance.now();
            _emscripten_performance_now.sig = "d";
            var _emscripten_get_device_pixel_ratio = () => typeof devicePixelRatio == "number" && devicePixelRatio || 1;
            _emscripten_get_device_pixel_ratio.sig = "d";

            function _emscripten_get_callstack(flags, str, maxbytes) {
                str >>>= 0;
                var callstack = getCallstack(flags);
                if (!str || maxbytes <= 0) {
                    return lengthBytesUTF8(callstack) + 1
                }
                var bytesWrittenExcludingNull = stringToUTF8(callstack, str, maxbytes);
                return bytesWrittenExcludingNull + 1
            }
            _emscripten_get_callstack.sig = "iipi";
            var convertFrameToPC = frame => {
                abort("Cannot use convertFrameToPC (needed by __builtin_return_address) without -sUSE_OFFSET_CONVERTER");
                return 0
            };

            function _emscripten_return_address(level) {
                var callstack = jsStackTrace().split("\n");
                if (callstack[0] == "Error") {
                    callstack.shift()
                }
                var caller = callstack[level + 3];
                return convertFrameToPC(caller)
            }
            _emscripten_return_address.sig = "pi";
            var UNWIND_CACHE = {};
            var saveInUnwindCache = callstack => {
                callstack.forEach(frame => {
                    var pc = convertFrameToPC(frame);
                    if (pc) {
                        UNWIND_CACHE[pc] = frame
                    }
                })
            };

            function _emscripten_stack_snapshot() {
                var callstack = jsStackTrace().split("\n");
                if (callstack[0] == "Error") {
                    callstack.shift()
                }
                saveInUnwindCache(callstack);
                UNWIND_CACHE.last_addr = convertFrameToPC(callstack[3]);
                UNWIND_CACHE.last_stack = callstack;
                return UNWIND_CACHE.last_addr
            }
            _emscripten_stack_snapshot.sig = "p";

            function _emscripten_stack_unwind_buffer(addr, buffer, count) {
                addr >>>= 0;
                buffer >>>= 0;
                var stack;
                if (UNWIND_CACHE.last_addr == addr) {
                    stack = UNWIND_CACHE.last_stack
                } else {
                    stack = jsStackTrace().split("\n");
                    if (stack[0] == "Error") {
                        stack.shift()
                    }
                    saveInUnwindCache(stack)
                }
                var offset = 3;
                while (stack[offset] && convertFrameToPC(stack[offset]) != addr) {
                    ++offset
                }
                for (var i = 0; i < count && stack[i + offset]; ++i) {
                    HEAP32[buffer + i * 4 >>> 2 >>> 0] = convertFrameToPC(stack[i + offset])
                }
                return i
            }
            _emscripten_stack_unwind_buffer.sig = "ippi";

            function _emscripten_pc_get_function(pc) {
                pc >>>= 0;
                abort("Cannot use emscripten_pc_get_function without -sUSE_OFFSET_CONVERTER");
                return 0
            }
            _emscripten_pc_get_function.sig = "pp";
            var convertPCtoSourceLocation = pc => {
                if (UNWIND_CACHE.last_get_source_pc == pc) return UNWIND_CACHE.last_source;
                var match;
                var source;
                if (!source) {
                    var frame = UNWIND_CACHE[pc];
                    if (!frame) return null;
                    if (match = /\((.*):(\d+):(\d+)\)$/.exec(frame)) {
                        source = {
                            file: match[1],
                            line: match[2],
                            column: match[3]
                        }
                    } else if (match = /@(.*):(\d+):(\d+)/.exec(frame)) {
                        source = {
                            file: match[1],
                            line: match[2],
                            column: match[3]
                        }
                    }
                }
                UNWIND_CACHE.last_get_source_pc = pc;
                UNWIND_CACHE.last_source = source;
                return source
            };

            function _emscripten_pc_get_file(pc) {
                pc >>>= 0;
                var result = convertPCtoSourceLocation(pc);
                if (!result) return 0;
                if (_emscripten_pc_get_file.ret) _free(_emscripten_pc_get_file.ret);
                _emscripten_pc_get_file.ret = stringToNewUTF8(result.file);
                return _emscripten_pc_get_file.ret
            }
            _emscripten_pc_get_file.sig = "pp";

            function _emscripten_pc_get_line(pc) {
                pc >>>= 0;
                var result = convertPCtoSourceLocation(pc);
                return result ? result.line : 0
            }
            _emscripten_pc_get_line.sig = "ip";

            function _emscripten_pc_get_column(pc) {
                pc >>>= 0;
                var result = convertPCtoSourceLocation(pc);
                return result ? result.column || 0 : 0
            }
            _emscripten_pc_get_column.sig = "ip";
            var _sched_yield = () => 0;
            Module["_sched_yield"] = _sched_yield;
            _sched_yield.sig = "i";
            var checkWasiClock = clock_id => clock_id == 0 || clock_id == 1 || clock_id == 2 || clock_id == 3;

            function _clock_time_get(clk_id, ignored_precision_low, ignored_precision_high, ptime) {
                var ignored_precision = convertI32PairToI53Checked(ignored_precision_low, ignored_precision_high);
                ptime >>>= 0;
                if (!checkWasiClock(clk_id)) {
                    return 28
                }
                var now;
                if (clk_id === 0) {
                    now = Date.now()
                } else if (nowIsMonotonic) {
                    now = _emscripten_get_now()
                } else {
                    return 52
                }
                var nsec = Math.round(now * 1e3 * 1e3);
                HEAP32[ptime >>> 2 >>> 0] = nsec >>> 0;
                HEAP32[ptime + 4 >>> 2 >>> 0] = nsec / Math.pow(2, 32) >>> 0;
                return 0
            }
            _clock_time_get.sig = "iiiip";

            function _clock_res_get(clk_id, pres) {
                pres >>>= 0;
                if (!checkWasiClock(clk_id)) {
                    return 28
                }
                var nsec;
                if (clk_id === 0) {
                    nsec = 1e3 * 1e3
                } else if (nowIsMonotonic) {
                    nsec = _emscripten_get_now_res()
                } else {
                    return 52
                }
                HEAP32[pres >>> 2 >>> 0] = nsec >>> 0;
                HEAP32[pres + 4 >>> 2 >>> 0] = nsec / Math.pow(2, 32) >>> 0;
                return 0
            }
            _clock_res_get.sig = "iip";
            var wasiRightsToMuslOFlags = rights => {
                if (rights & 2 && rights & 64) {
                    return 2
                }
                if (rights & 2) {
                    return 0
                }
                if (rights & 64) {
                    return 1
                }
                throw new FS.ErrnoError(28)
            };
            var wasiOFlagsToMuslOFlags = oflags => {
                var musl_oflags = 0;
                if (oflags & 1) {
                    musl_oflags |= 64
                }
                if (oflags & 8) {
                    musl_oflags |= 512
                }
                if (oflags & 2) {
                    musl_oflags |= 65536
                }
                if (oflags & 4) {
                    musl_oflags |= 128
                }
                return musl_oflags
            };
            var _emscripten_unwind_to_js_event_loop = () => {
                throw "unwind"
            };
            _emscripten_unwind_to_js_event_loop.sig = "v";
            var safeSetTimeout = (func, timeout) => setTimeout(() => {
                callUserCallback(func)
            }, timeout);
            var setImmediateWrapped = func => {
                setImmediateWrapped.mapping ||= [];
                var id = setImmediateWrapped.mapping.length;
                setImmediateWrapped.mapping[id] = setImmediate(() => {
                    setImmediateWrapped.mapping[id] = undefined;
                    func()
                });
                return id
            };
            var clearImmediateWrapped = id => {
                clearImmediate(setImmediateWrapped.mapping[id]);
                setImmediateWrapped.mapping[id] = undefined
            };
            var polyfillSetImmediate = () => {};
            var _emscripten_set_immediate = function(cb, userData) {
                cb >>>= 0;
                userData >>>= 0;
                return emSetImmediate(() => {
                    callUserCallback(() => getWasmTableEntry(cb)(userData))
                })
            };
            _emscripten_set_immediate.sig = "ipp";
            var _emscripten_clear_immediate = id => {
                emClearImmediate(id)
            };
            _emscripten_clear_immediate.sig = "vi";
            var _emscripten_set_immediate_loop = function(cb, userData) {
                cb >>>= 0;
                userData >>>= 0;

                function tick() {
                    callUserCallback(() => {
                        if (getWasmTableEntry(cb)(userData)) {
                            emSetImmediate(tick)
                        } else {}
                    })
                }
                emSetImmediate(tick)
            };
            _emscripten_set_immediate_loop.sig = "vpp";
            var _emscripten_set_timeout = function(cb, msecs, userData) {
                cb >>>= 0;
                userData >>>= 0;
                return safeSetTimeout(() => getWasmTableEntry(cb)(userData), msecs)
            };
            _emscripten_set_timeout.sig = "ipdp";
            var _emscripten_clear_timeout = clearTimeout;
            _emscripten_clear_timeout.sig = "vi";
            var _emscripten_set_timeout_loop = function(cb, msecs, userData) {
                cb >>>= 0;
                userData >>>= 0;

                function tick() {
                    var t = _emscripten_get_now();
                    var n = t + msecs;
                    callUserCallback(() => {
                        if (getWasmTableEntry(cb)(t, userData)) {
                            setTimeout(tick, n - _emscripten_get_now())
                        }
                    })
                }
                return setTimeout(tick, 0)
            };
            _emscripten_set_timeout_loop.sig = "vpdp";
            var _emscripten_set_interval = function(cb, msecs, userData) {
                cb >>>= 0;
                userData >>>= 0;
                return setInterval(() => {
                    callUserCallback(() => getWasmTableEntry(cb)(userData))
                }, msecs)
            };
            _emscripten_set_interval.sig = "ipdp";
            var _emscripten_clear_interval = id => {
                clearInterval(id)
            };
            _emscripten_clear_interval.sig = "vi";
            var registerPostMainLoop = f => {
                typeof MainLoop != "undefined" && MainLoop.postMainLoop.push(f)
            };
            var registerPreMainLoop = f => {
                typeof MainLoop != "undefined" && MainLoop.preMainLoop.push(f)
            };

            function _emscripten_get_main_loop_timing(mode, value) {
                mode >>>= 0;
                value >>>= 0;
                if (mode) HEAP32[mode >>> 2 >>> 0] = MainLoop.timingMode;
                if (value) HEAP32[value >>> 2 >>> 0] = MainLoop.timingValue
            }
            _emscripten_get_main_loop_timing.sig = "vpp";

            function _emscripten_set_main_loop(func, fps, simulateInfiniteLoop) {
                func >>>= 0;
                var iterFunc = getWasmTableEntry(func);
                setMainLoop(iterFunc, fps, simulateInfiniteLoop)
            }
            _emscripten_set_main_loop.sig = "vpii";
            var _emscripten_set_main_loop_arg = function(func, arg, fps, simulateInfiniteLoop) {
                func >>>= 0;
                arg >>>= 0;
                var iterFunc = () => getWasmTableEntry(func)(arg);
                setMainLoop(iterFunc, fps, simulateInfiniteLoop, arg)
            };
            _emscripten_set_main_loop_arg.sig = "vppii";
            var _emscripten_cancel_main_loop = () => {
                MainLoop.pause();
                MainLoop.func = null
            };
            _emscripten_cancel_main_loop.sig = "v";
            var _emscripten_pause_main_loop = () => {
                MainLoop.pause()
            };
            _emscripten_pause_main_loop.sig = "v";
            var _emscripten_resume_main_loop = () => {
                MainLoop.resume()
            };
            _emscripten_resume_main_loop.sig = "v";
            var __emscripten_push_main_loop_blocker = function(func, arg, name) {
                func >>>= 0;
                arg >>>= 0;
                name >>>= 0;
                MainLoop.queue.push({
                    func: () => {
                        getWasmTableEntry(func)(arg)
                    },
                    name: UTF8ToString(name),
                    counted: true
                });
                MainLoop.updateStatus()
            };
            __emscripten_push_main_loop_blocker.sig = "vppp";
            var __emscripten_push_uncounted_main_loop_blocker = function(func, arg, name) {
                func >>>= 0;
                arg >>>= 0;
                name >>>= 0;
                MainLoop.queue.push({
                    func: () => {
                        getWasmTableEntry(func)(arg)
                    },
                    name: UTF8ToString(name),
                    counted: false
                });
                MainLoop.updateStatus()
            };
            __emscripten_push_uncounted_main_loop_blocker.sig = "vppp";
            var _emscripten_set_main_loop_expected_blockers = num => {
                MainLoop.expectedBlockers = num;
                MainLoop.remainingBlockers = num;
                MainLoop.updateStatus()
            };
            _emscripten_set_main_loop_expected_blockers.sig = "vi";
            var idsToPromises = (idBuf, size) => {
                var promises = [];
                for (var i = 0; i < size; i++) {
                    var id = HEAP32[idBuf + i * 4 >>> 2 >>> 0];
                    promises[i] = getPromise(id)
                }
                return promises
            };
            var makePromiseCallback = (callback, userData) => value => {
                var stack = stackSave();
                var resultPtr = stackAlloc(POINTER_SIZE);
                HEAPU32[resultPtr >>> 2 >>> 0] = 0;
                try {
                    var result = getWasmTableEntry(callback)(resultPtr, userData, value);
                    var resultVal = HEAPU32[resultPtr >>> 2 >>> 0]
                } catch (e) {
                    if (typeof e != "number") {
                        throw 0
                    }
                    throw e
                } finally {
                    stackRestore(stack)
                }
                switch (result) {
                    case 0:
                        return resultVal;
                    case 1:
                        return getPromise(resultVal);
                    case 2:
                        var ret = getPromise(resultVal);
                        _emscripten_promise_destroy(resultVal);
                        return ret;
                    case 3:
                        throw resultVal
                }
            };

            function _emscripten_promise_then(id, onFulfilled, onRejected, userData) {
                id >>>= 0;
                onFulfilled >>>= 0;
                onRejected >>>= 0;
                userData >>>= 0;
                var promise = getPromise(id);
                var newId = promiseMap.allocate({
                    promise: promise.then(makePromiseCallback(onFulfilled, userData), makePromiseCallback(onRejected, userData))
                });
                return newId
            }
            _emscripten_promise_then.sig = "ppppp";
            var _emscripten_promise_all = function(idBuf, resultBuf, size) {
                idBuf >>>= 0;
                resultBuf >>>= 0;
                size >>>= 0;
                var promises = idsToPromises(idBuf, size);
                var id = promiseMap.allocate({
                    promise: Promise.all(promises).then(results => {
                        if (resultBuf) {
                            for (var i = 0; i < size; i++) {
                                var result = results[i];
                                HEAPU32[resultBuf + i * 4 >>> 2 >>> 0] = result
                            }
                        }
                        return resultBuf
                    })
                });
                return id
            };
            _emscripten_promise_all.sig = "pppp";
            var setPromiseResult = (ptr, fulfill, value) => {
                var result = fulfill ? 0 : 3;
                HEAP32[ptr >>> 2 >>> 0] = result;
                HEAPU32[ptr + 4 >>> 2 >>> 0] = value
            };
            var _emscripten_promise_all_settled = function(idBuf, resultBuf, size) {
                idBuf >>>= 0;
                resultBuf >>>= 0;
                size >>>= 0;
                var promises = idsToPromises(idBuf, size);
                var id = promiseMap.allocate({
                    promise: Promise.allSettled(promises).then(results => {
                        if (resultBuf) {
                            var offset = resultBuf;
                            for (var i = 0; i < size; i++, offset += 8) {
                                if (results[i].status === "fulfilled") {
                                    setPromiseResult(offset, true, results[i].value)
                                } else {
                                    setPromiseResult(offset, false, results[i].reason)
                                }
                            }
                        }
                        return resultBuf
                    })
                });
                return id
            };
            _emscripten_promise_all_settled.sig = "pppp";
            var _emscripten_promise_any = function(idBuf, errorBuf, size) {
                idBuf >>>= 0;
                errorBuf >>>= 0;
                size >>>= 0;
                var promises = idsToPromises(idBuf, size);
                var id = promiseMap.allocate({
                    promise: Promise.any(promises).catch(err => {
                        if (errorBuf) {
                            for (var i = 0; i < size; i++) {
                                HEAPU32[errorBuf + i * 4 >>> 2 >>> 0] = err.errors[i]
                            }
                        }
                        throw errorBuf
                    })
                });
                return id
            };
            _emscripten_promise_any.sig = "pppp";

            function _emscripten_promise_race(idBuf, size) {
                idBuf >>>= 0;
                size >>>= 0;
                var promises = idsToPromises(idBuf, size);
                var id = promiseMap.allocate({
                    promise: Promise.race(promises)
                });
                return id
            }
            _emscripten_promise_race.sig = "ppp";

            function _emscripten_promise_await(returnValuePtr, id) {
                returnValuePtr >>>= 0;
                id >>>= 0;
                abort("emscripten_promise_await is only available with ASYNCIFY")
            }
            _emscripten_promise_await.sig = "vpp";
            var getExceptionMessageCommon = ptr => {
                var sp = stackSave();
                var type_addr_addr = stackAlloc(4);
                var message_addr_addr = stackAlloc(4);
                ___get_exception_message(ptr, type_addr_addr, message_addr_addr);
                var type_addr = HEAPU32[type_addr_addr >>> 2 >>> 0];
                var message_addr = HEAPU32[message_addr_addr >>> 2 >>> 0];
                var type = UTF8ToString(type_addr);
                _free(type_addr);
                var message;
                if (message_addr) {
                    message = UTF8ToString(message_addr);
                    _free(message_addr)
                }
                stackRestore(sp);
                return [type, message]
            };
            var getCppExceptionTag = () => ___cpp_exception;
            var getCppExceptionThrownObjectFromWebAssemblyException = ex => {
                var unwind_header = ex.getArg(getCppExceptionTag(), 0);
                return ___thrown_object_from_unwind_exception(unwind_header)
            };
            var incrementExceptionRefcount = ex => {
                var ptr = getCppExceptionThrownObjectFromWebAssemblyException(ex);
                ___cxa_increment_exception_refcount(ptr)
            };
            var decrementExceptionRefcount = ex => {
                var ptr = getCppExceptionThrownObjectFromWebAssemblyException(ex);
                ___cxa_decrement_exception_refcount(ptr)
            };
            var getExceptionMessage = ex => {
                var ptr = getCppExceptionThrownObjectFromWebAssemblyException(ex);
                return getExceptionMessageCommon(ptr)
            };
            var Browser = {
                useWebGL: false,
                isFullscreen: false,
                pointerLock: false,
                moduleContextCreatedCallbacks: [],
                workers: [],
                init() {
                    if (Browser.initted) return;
                    Browser.initted = true;
                    var imagePlugin = {};
                    imagePlugin["canHandle"] = function imagePlugin_canHandle(name) {
                        return !Module["noImageDecoding"] && /\.(jpg|jpeg|png|bmp|webp)$/i.test(name)
                    };
                    imagePlugin["handle"] = function imagePlugin_handle(byteArray, name, onload, onerror) {
                        var b = new Blob([byteArray], {
                            type: Browser.getMimetype(name)
                        });
                        if (b.size !== byteArray.length) {
                            b = new Blob([new Uint8Array(byteArray).buffer], {
                                type: Browser.getMimetype(name)
                            })
                        }
                        var url = URL.createObjectURL(b);
                        var img = new Image;
                        img.onload = () => {
                            var canvas = document.createElement("canvas");
                            canvas.width = img.width;
                            canvas.height = img.height;
                            var ctx = canvas.getContext("2d");
                            ctx.drawImage(img, 0, 0);
                            preloadedImages[name] = canvas;
                            URL.revokeObjectURL(url);
                            onload?.(byteArray)
                        };
                        img.onerror = event => {
                            err(`Image ${url} could not be decoded`);
                            onerror?.()
                        };
                        img.src = url
                    };
                    preloadPlugins.push(imagePlugin);
                    var audioPlugin = {};
                    audioPlugin["canHandle"] = function audioPlugin_canHandle(name) {
                        return !Module["noAudioDecoding"] && name.substr(-4) in {
                            ".ogg": 1,
                            ".wav": 1,
                            ".mp3": 1
                        }
                    };
                    audioPlugin["handle"] = function audioPlugin_handle(byteArray, name, onload, onerror) {
                        var done = false;

                        function finish(audio) {
                            if (done) return;
                            done = true;
                            preloadedAudios[name] = audio;
                            onload?.(byteArray)
                        }

                        function fail() {
                            if (done) return;
                            done = true;
                            preloadedAudios[name] = new Audio;
                            onerror?.()
                        }
                        var b = new Blob([byteArray], {
                            type: Browser.getMimetype(name)
                        });
                        var url = URL.createObjectURL(b);
                        var audio = new Audio;
                        audio.addEventListener("canplaythrough", () => finish(audio), false);
                        audio.onerror = function audio_onerror(event) {
                            if (done) return;
                            err(`warning: browser could not fully decode audio ${name}, trying slower base64 approach`);

                            function encode64(data) {
                                var BASE = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
                                var PAD = "=";
                                var ret = "";
                                var leftchar = 0;
                                var leftbits = 0;
                                for (var i = 0; i < data.length; i++) {
                                    leftchar = leftchar << 8 | data[i];
                                    leftbits += 8;
                                    while (leftbits >= 6) {
                                        var curr = leftchar >> leftbits - 6 & 63;
                                        leftbits -= 6;
                                        ret += BASE[curr]
                                    }
                                }
                                if (leftbits == 2) {
                                    ret += BASE[(leftchar & 3) << 4];
                                    ret += PAD + PAD
                                } else if (leftbits == 4) {
                                    ret += BASE[(leftchar & 15) << 2];
                                    ret += PAD
                                }
                                return ret
                            }
                            audio.src = "data:audio/x-" + name.substr(-3) + ";base64," + encode64(byteArray);
                            finish(audio)
                        };
                        audio.src = url;
                        safeSetTimeout(() => {
                            finish(audio)
                        }, 1e4)
                    };
                    preloadPlugins.push(audioPlugin);

                    function pointerLockChange() {
                        Browser.pointerLock = document["pointerLockElement"] === Module["canvas"] || document["mozPointerLockElement"] === Module["canvas"] || document["webkitPointerLockElement"] === Module["canvas"] || document["msPointerLockElement"] === Module["canvas"]
                    }
                    var canvas = Module["canvas"];
                    if (canvas) {
                        canvas.requestPointerLock = canvas["requestPointerLock"] || canvas["mozRequestPointerLock"] || canvas["webkitRequestPointerLock"] || canvas["msRequestPointerLock"] || (() => {});
                        canvas.exitPointerLock = document["exitPointerLock"] || document["mozExitPointerLock"] || document["webkitExitPointerLock"] || document["msExitPointerLock"] || (() => {});
                        canvas.exitPointerLock = canvas.exitPointerLock.bind(document);
                        document.addEventListener("pointerlockchange", pointerLockChange, false);
                        document.addEventListener("mozpointerlockchange", pointerLockChange, false);
                        document.addEventListener("webkitpointerlockchange", pointerLockChange, false);
                        document.addEventListener("mspointerlockchange", pointerLockChange, false);
                        if (Module["elementPointerLock"]) {
                            canvas.addEventListener("click", ev => {
                                if (!Browser.pointerLock && Module["canvas"].requestPointerLock) {
                                    Module["canvas"].requestPointerLock();
                                    ev.preventDefault()
                                }
                            }, false)
                        }
                    }
                },
                createContext(canvas, useWebGL, setInModule, webGLContextAttributes) {
                    if (useWebGL && Module.ctx && canvas == Module.canvas) return Module.ctx;
                    var ctx;
                    var contextHandle;
                    if (useWebGL) {
                        var contextAttributes = {
                            antialias: false,
                            alpha: false,
                            majorVersion: 1
                        };
                        if (webGLContextAttributes) {
                            for (var attribute in webGLContextAttributes) {
                                contextAttributes[attribute] = webGLContextAttributes[attribute]
                            }
                        }
                        if (typeof GL != "undefined") {
                            contextHandle = GL.createContext(canvas, contextAttributes);
                            if (contextHandle) {
                                ctx = GL.getContext(contextHandle).GLctx
                            }
                        }
                    } else {
                        ctx = canvas.getContext("2d")
                    }
                    if (!ctx) return null;
                    if (setInModule) {
                        Module.ctx = ctx;
                        if (useWebGL) GL.makeContextCurrent(contextHandle);
                        Browser.useWebGL = useWebGL;
                        Browser.moduleContextCreatedCallbacks.forEach(callback => callback());
                        Browser.init()
                    }
                    return ctx
                },
                fullscreenHandlersInstalled: false,
                lockPointer: undefined,
                resizeCanvas: undefined,
                requestFullscreen(lockPointer, resizeCanvas) {
                    Browser.lockPointer = lockPointer;
                    Browser.resizeCanvas = resizeCanvas;
                    if (typeof Browser.lockPointer == "undefined") Browser.lockPointer = true;
                    if (typeof Browser.resizeCanvas == "undefined") Browser.resizeCanvas = false;
                    var canvas = Module["canvas"];

                    function fullscreenChange() {
                        Browser.isFullscreen = false;
                        var canvasContainer = canvas.parentNode;
                        if ((document["fullscreenElement"] || document["mozFullScreenElement"] || document["msFullscreenElement"] || document["webkitFullscreenElement"] || document["webkitCurrentFullScreenElement"]) === canvasContainer) {
                            canvas.exitFullscreen = Browser.exitFullscreen;
                            if (Browser.lockPointer) canvas.requestPointerLock();
                            Browser.isFullscreen = true;
                            if (Browser.resizeCanvas) {
                                Browser.setFullscreenCanvasSize()
                            } else {
                                Browser.updateCanvasDimensions(canvas)
                            }
                        } else {
                            canvasContainer.parentNode.insertBefore(canvas, canvasContainer);
                            canvasContainer.parentNode.removeChild(canvasContainer);
                            if (Browser.resizeCanvas) {
                                Browser.setWindowedCanvasSize()
                            } else {
                                Browser.updateCanvasDimensions(canvas)
                            }
                        }
                        Module["onFullScreen"]?.(Browser.isFullscreen);
                        Module["onFullscreen"]?.(Browser.isFullscreen)
                    }
                    if (!Browser.fullscreenHandlersInstalled) {
                        Browser.fullscreenHandlersInstalled = true;
                        document.addEventListener("fullscreenchange", fullscreenChange, false);
                        document.addEventListener("mozfullscreenchange", fullscreenChange, false);
                        document.addEventListener("webkitfullscreenchange", fullscreenChange, false);
                        document.addEventListener("MSFullscreenChange", fullscreenChange, false)
                    }
                    var canvasContainer = document.createElement("div");
                    canvas.parentNode.insertBefore(canvasContainer, canvas);
                    canvasContainer.appendChild(canvas);
                    canvasContainer.requestFullscreen = canvasContainer["requestFullscreen"] || canvasContainer["mozRequestFullScreen"] || canvasContainer["msRequestFullscreen"] || (canvasContainer["webkitRequestFullscreen"] ? () => canvasContainer["webkitRequestFullscreen"](Element["ALLOW_KEYBOARD_INPUT"]) : null) || (canvasContainer["webkitRequestFullScreen"] ? () => canvasContainer["webkitRequestFullScreen"](Element["ALLOW_KEYBOARD_INPUT"]) : null);
                    canvasContainer.requestFullscreen()
                },
                exitFullscreen() {
                    if (!Browser.isFullscreen) {
                        return false
                    }
                    var CFS = document["exitFullscreen"] || document["cancelFullScreen"] || document["mozCancelFullScreen"] || document["msExitFullscreen"] || document["webkitCancelFullScreen"] || (() => {});
                    CFS.apply(document, []);
                    return true
                },
                safeSetTimeout(func, timeout) {
                    return safeSetTimeout(func, timeout)
                },
                getMimetype(name) {
                    return {
                        jpg: "image/jpeg",
                        jpeg: "image/jpeg",
                        png: "image/png",
                        bmp: "image/bmp",
                        ogg: "audio/ogg",
                        wav: "audio/wav",
                        mp3: "audio/mpeg"
                    } [name.substr(name.lastIndexOf(".") + 1)]
                },
                getUserMedia(func) {
                    window.getUserMedia ||= navigator["getUserMedia"] || navigator["mozGetUserMedia"];
                    window.getUserMedia(func)
                },
                getMovementX(event) {
                    return event["movementX"] || event["mozMovementX"] || event["webkitMovementX"] || 0
                },
                getMovementY(event) {
                    return event["movementY"] || event["mozMovementY"] || event["webkitMovementY"] || 0
                },
                getMouseWheelDelta(event) {
                    var delta = 0;
                    switch (event.type) {
                        case "DOMMouseScroll":
                            delta = event.detail / 3;
                            break;
                        case "mousewheel":
                            delta = event.wheelDelta / 120;
                            break;
                        case "wheel":
                            delta = event.deltaY;
                            switch (event.deltaMode) {
                                case 0:
                                    delta /= 100;
                                    break;
                                case 1:
                                    delta /= 3;
                                    break;
                                case 2:
                                    delta *= 80;
                                    break;
                                default:
                                    throw "unrecognized mouse wheel delta mode: " + event.deltaMode
                            }
                            break;
                        default:
                            throw "unrecognized mouse wheel event: " + event.type
                    }
                    return delta
                },
                mouseX: 0,
                mouseY: 0,
                mouseMovementX: 0,
                mouseMovementY: 0,
                touches: {},
                lastTouches: {},
                calculateMouseCoords(pageX, pageY) {
                    var rect = Module["canvas"].getBoundingClientRect();
                    var cw = Module["canvas"].width;
                    var ch = Module["canvas"].height;
                    var scrollX = typeof window.scrollX != "undefined" ? window.scrollX : window.pageXOffset;
                    var scrollY = typeof window.scrollY != "undefined" ? window.scrollY : window.pageYOffset;
                    var adjustedX = pageX - (scrollX + rect.left);
                    var adjustedY = pageY - (scrollY + rect.top);
                    adjustedX = adjustedX * (cw / rect.width);
                    adjustedY = adjustedY * (ch / rect.height);
                    return {
                        x: adjustedX,
                        y: adjustedY
                    }
                },
                setMouseCoords(pageX, pageY) {
                    const {
                        x,
                        y
                    } = Browser.calculateMouseCoords(pageX, pageY);
                    Browser.mouseMovementX = x - Browser.mouseX;
                    Browser.mouseMovementY = y - Browser.mouseY;
                    Browser.mouseX = x;
                    Browser.mouseY = y
                },
                calculateMouseEvent(event) {
                    if (Browser.pointerLock) {
                        if (event.type != "mousemove" && "mozMovementX" in event) {
                            Browser.mouseMovementX = Browser.mouseMovementY = 0
                        } else {
                            Browser.mouseMovementX = Browser.getMovementX(event);
                            Browser.mouseMovementY = Browser.getMovementY(event)
                        }
                        Browser.mouseX += Browser.mouseMovementX;
                        Browser.mouseY += Browser.mouseMovementY
                    } else {
                        if (event.type === "touchstart" || event.type === "touchend" || event.type === "touchmove") {
                            var touch = event.touch;
                            if (touch === undefined) {
                                return
                            }
                            var coords = Browser.calculateMouseCoords(touch.pageX, touch.pageY);
                            if (event.type === "touchstart") {
                                Browser.lastTouches[touch.identifier] = coords;
                                Browser.touches[touch.identifier] = coords
                            } else if (event.type === "touchend" || event.type === "touchmove") {
                                var last = Browser.touches[touch.identifier];
                                last ||= coords;
                                Browser.lastTouches[touch.identifier] = last;
                                Browser.touches[touch.identifier] = coords
                            }
                            return
                        }
                        Browser.setMouseCoords(event.pageX, event.pageY)
                    }
                },
                resizeListeners: [],
                updateResizeListeners() {
                    var canvas = Module["canvas"];
                    Browser.resizeListeners.forEach(listener => listener(canvas.width, canvas.height))
                },
                setCanvasSize(width, height, noUpdates) {
                    var canvas = Module["canvas"];
                    Browser.updateCanvasDimensions(canvas, width, height);
                    if (!noUpdates) Browser.updateResizeListeners()
                },
                windowedWidth: 0,
                windowedHeight: 0,
                setFullscreenCanvasSize() {
                    if (typeof SDL != "undefined") {
                        var flags = HEAPU32[SDL.screen >>> 2 >>> 0];
                        flags = flags | 8388608;
                        HEAP32[SDL.screen >>> 2 >>> 0] = flags
                    }
                    Browser.updateCanvasDimensions(Module["canvas"]);
                    Browser.updateResizeListeners()
                },
                setWindowedCanvasSize() {
                    if (typeof SDL != "undefined") {
                        var flags = HEAPU32[SDL.screen >>> 2 >>> 0];
                        flags = flags & ~8388608;
                        HEAP32[SDL.screen >>> 2 >>> 0] = flags
                    }
                    Browser.updateCanvasDimensions(Module["canvas"]);
                    Browser.updateResizeListeners()
                },
                updateCanvasDimensions(canvas, wNative, hNative) {
                    if (wNative && hNative) {
                        canvas.widthNative = wNative;
                        canvas.heightNative = hNative
                    } else {
                        wNative = canvas.widthNative;
                        hNative = canvas.heightNative
                    }
                    var w = wNative;
                    var h = hNative;
                    if (Module["forcedAspectRatio"] && Module["forcedAspectRatio"] > 0) {
                        if (w / h < Module["forcedAspectRatio"]) {
                            w = Math.round(h * Module["forcedAspectRatio"])
                        } else {
                            h = Math.round(w / Module["forcedAspectRatio"])
                        }
                    }
                    if ((document["fullscreenElement"] || document["mozFullScreenElement"] || document["msFullscreenElement"] || document["webkitFullscreenElement"] || document["webkitCurrentFullScreenElement"]) === canvas.parentNode && typeof screen != "undefined") {
                        var factor = Math.min(screen.width / w, screen.height / h);
                        w = Math.round(w * factor);
                        h = Math.round(h * factor)
                    }
                    if (Browser.resizeCanvas) {
                        if (canvas.width != w) canvas.width = w;
                        if (canvas.height != h) canvas.height = h;
                        if (typeof canvas.style != "undefined") {
                            canvas.style.removeProperty("width");
                            canvas.style.removeProperty("height")
                        }
                    } else {
                        if (canvas.width != wNative) canvas.width = wNative;
                        if (canvas.height != hNative) canvas.height = hNative;
                        if (typeof canvas.style != "undefined") {
                            if (w != wNative || h != hNative) {
                                canvas.style.setProperty("width", w + "px", "important");
                                canvas.style.setProperty("height", h + "px", "important")
                            } else {
                                canvas.style.removeProperty("width");
                                canvas.style.removeProperty("height")
                            }
                        }
                    }
                }
            };
            var _emscripten_run_preload_plugins = function(file, onload, onerror) {
                file >>>= 0;
                onload >>>= 0;
                onerror >>>= 0;
                var _file = UTF8ToString(file);
                var data = FS.analyzePath(_file);
                if (!data.exists) return -1;
                FS.createPreloadedFile(PATH.dirname(_file), PATH.basename(_file), new Uint8Array(data.object.contents), true, true, () => {
                    if (onload) getWasmTableEntry(onload)(file)
                }, () => {
                    if (onerror) getWasmTableEntry(onerror)(file)
                }, true);
                return 0
            };
            _emscripten_run_preload_plugins.sig = "ippp";
            var Browser_asyncPrepareDataCounter = 0;
            var _emscripten_run_preload_plugins_data = function(data, size, suffix, arg, onload, onerror) {
                data >>>= 0;
                suffix >>>= 0;
                arg >>>= 0;
                onload >>>= 0;
                onerror >>>= 0;
                var _suffix = UTF8ToString(suffix);
                var name = "prepare_data_" + Browser_asyncPrepareDataCounter++ + "." + _suffix;
                var cname = stringToNewUTF8(name);
                FS.createPreloadedFile("/", name, HEAPU8.subarray(data >>> 0, data + size >>> 0), true, true, () => {
                    if (onload) getWasmTableEntry(onload)(arg, cname)
                }, () => {
                    if (onerror) getWasmTableEntry(onerror)(arg)
                }, true)
            };
            _emscripten_run_preload_plugins_data.sig = "vpipppp";
            var _emscripten_async_run_script = function(script, millis) {
                script >>>= 0;
                safeSetTimeout(() => _emscripten_run_script(script), millis)
            };
            _emscripten_async_run_script.sig = "vpi";
            var _emscripten_async_load_script = function(url, onload, onerror) {
                url >>>= 0;
                onload >>>= 0;
                onerror >>>= 0;
                url = UTF8ToString(url);
                var loadDone = () => {
                    if (onload) {
                        var onloadCallback = () => callUserCallback(getWasmTableEntry(onload));
                        if (runDependencies > 0) {
                            dependenciesFulfilled = onloadCallback
                        } else {
                            onloadCallback()
                        }
                    }
                };
                var loadError = () => {
                    if (onerror) {
                        callUserCallback(getWasmTableEntry(onerror))
                    }
                };
                if (ENVIRONMENT_IS_NODE) {
                    readAsync(url, false).then(data => {
                        eval(data);
                        loadDone()
                    }, loadError);
                    return
                }
                var script = document.createElement("script");
                script.onload = loadDone;
                script.onerror = loadError;
                script.src = url;
                document.body.appendChild(script)
            };
            _emscripten_async_load_script.sig = "vppp";
            var safeRequestAnimationFrame = func => MainLoop.requestAnimationFrame(() => {
                callUserCallback(func)
            });

            function _emscripten_async_call(func, arg, millis) {
                func >>>= 0;
                arg >>>= 0;

                function wrapper() {
                    getWasmTableEntry(func)(arg)
                }
                if (millis >= 0 || ENVIRONMENT_IS_NODE) {
                    safeSetTimeout(wrapper, millis)
                } else {
                    safeRequestAnimationFrame(wrapper)
                }
            }
            _emscripten_async_call.sig = "vppi";

            function _emscripten_get_window_title() {
                var buflen = 256;
                if (!_emscripten_get_window_title.buffer) {
                    _emscripten_get_window_title.buffer = _malloc(buflen)
                }
                stringToUTF8(document.title, _emscripten_get_window_title.buffer, buflen);
                return _emscripten_get_window_title.buffer
            }
            _emscripten_get_window_title.sig = "p";

            function _emscripten_set_window_title(title) {
                title >>>= 0;
                return document.title = UTF8ToString(title)
            }
            _emscripten_set_window_title.sig = "vp";

            function _emscripten_get_screen_size(width, height) {
                width >>>= 0;
                height >>>= 0;
                HEAP32[width >>> 2 >>> 0] = screen.width;
                HEAP32[height >>> 2 >>> 0] = screen.height
            }
            _emscripten_get_screen_size.sig = "vpp";
            var _emscripten_hide_mouse = () => {
                var styleSheet = document.styleSheets[0];
                var rules = styleSheet.cssRules;
                for (var i = 0; i < rules.length; i++) {
                    if (rules[i].cssText.substr(0, 6) == "canvas") {
                        styleSheet.deleteRule(i);
                        i--
                    }
                }
                styleSheet.insertRule("canvas.emscripten { border: 1px solid black; cursor: none; }", 0)
            };
            _emscripten_hide_mouse.sig = "v";
            var _emscripten_set_canvas_size = (width, height) => {
                Browser.setCanvasSize(width, height)
            };
            _emscripten_set_canvas_size.sig = "vii";

            function _emscripten_get_canvas_size(width, height, isFullscreen) {
                width >>>= 0;
                height >>>= 0;
                isFullscreen >>>= 0;
                var canvas = Module["canvas"];
                HEAP32[width >>> 2 >>> 0] = canvas.width;
                HEAP32[height >>> 2 >>> 0] = canvas.height;
                HEAP32[isFullscreen >>> 2 >>> 0] = Browser.isFullscreen ? 1 : 0
            }
            _emscripten_get_canvas_size.sig = "vppp";

            function _emscripten_create_worker(url) {
                url >>>= 0;
                url = UTF8ToString(url);
                var id = Browser.workers.length;
                var info = {
                    worker: new Worker(url),
                    callbacks: [],
                    awaited: 0,
                    buffer: 0,
                    bufferSize: 0
                };
                info.worker.onmessage = function info_worker_onmessage(msg) {
                    if (ABORT) return;
                    var info = Browser.workers[id];
                    if (!info) return;
                    var callbackId = msg.data["callbackId"];
                    var callbackInfo = info.callbacks[callbackId];
                    if (!callbackInfo) return;
                    if (msg.data["finalResponse"]) {
                        info.awaited--;
                        info.callbacks[callbackId] = null
                    }
                    var data = msg.data["data"];
                    if (data) {
                        if (!data.byteLength) data = new Uint8Array(data);
                        if (!info.buffer || info.bufferSize < data.length) {
                            if (info.buffer) _free(info.buffer);
                            info.bufferSize = data.length;
                            info.buffer = _malloc(data.length)
                        }
                        HEAPU8.set(data, info.buffer >>> 0);
                        callbackInfo.func(info.buffer, data.length, callbackInfo.arg)
                    } else {
                        callbackInfo.func(0, 0, callbackInfo.arg)
                    }
                };
                Browser.workers.push(info);
                return id
            }
            _emscripten_create_worker.sig = "ip";
            var _emscripten_destroy_worker = id => {
                var info = Browser.workers[id];
                info.worker.terminate();
                if (info.buffer) _free(info.buffer);
                Browser.workers[id] = null
            };
            _emscripten_destroy_worker.sig = "vi";

            function _emscripten_call_worker(id, funcName, data, size, callback, arg) {
                funcName >>>= 0;
                data >>>= 0;
                callback >>>= 0;
                arg >>>= 0;
                funcName = UTF8ToString(funcName);
                var info = Browser.workers[id];
                var callbackId = -1;
                if (callback) {
                    callbackId = info.callbacks.length;
                    info.callbacks.push({
                        func: getWasmTableEntry(callback),
                        arg
                    });
                    info.awaited++
                }
                var transferObject = {
                    funcName,
                    callbackId,
                    data: data ? new Uint8Array(HEAPU8.subarray(data >>> 0, data + size >>> 0)) : 0
                };
                if (data) {
                    info.worker.postMessage(transferObject, [transferObject.data.buffer])
                } else {
                    info.worker.postMessage(transferObject)
                }
            }
            _emscripten_call_worker.sig = "vippipp";
            var _emscripten_get_worker_queue_size = id => {
                var info = Browser.workers[id];
                if (!info) return -1;
                return info.awaited
            };
            _emscripten_get_worker_queue_size.sig = "ii";
            var getPreloadedImageData = (path, w, h) => {
                path = PATH_FS.resolve(path);
                var canvas = preloadedImages[path];
                if (!canvas) return 0;
                var ctx = canvas.getContext("2d");
                var image = ctx.getImageData(0, 0, canvas.width, canvas.height);
                var buf = _malloc(canvas.width * canvas.height * 4);
                HEAPU8.set(image.data, buf >>> 0);
                HEAP32[w >>> 2 >>> 0] = canvas.width;
                HEAP32[h >>> 2 >>> 0] = canvas.height;
                return buf
            };

            function _emscripten_get_preloaded_image_data(path, w, h) {
                path >>>= 0;
                w >>>= 0;
                h >>>= 0;
                return getPreloadedImageData(UTF8ToString(path), w, h)
            }
            _emscripten_get_preloaded_image_data.sig = "pppp";
            var getPreloadedImageData__data = ["$PATH_FS", "malloc"];

            function _emscripten_get_preloaded_image_data_from_FILE(file, w, h) {
                file >>>= 0;
                w >>>= 0;
                h >>>= 0;
                var fd = _fileno(file);
                var stream = FS.getStream(fd);
                if (stream) {
                    return getPreloadedImageData(stream.path, w, h)
                }
                return 0
            }
            _emscripten_get_preloaded_image_data_from_FILE.sig = "pppp";
            var wget = {
                wgetRequests: {},
                nextWgetRequestHandle: 0,
                getNextWgetRequestHandle() {
                    var handle = wget.nextWgetRequestHandle;
                    wget.nextWgetRequestHandle++;
                    return handle
                }
            };
            var FS_mkdirTree = (path, mode) => FS.mkdirTree(path, mode);
            var FS_unlink = path => FS.unlink(path);
            var _emscripten_async_wget = function(url, file, onload, onerror) {
                url >>>= 0;
                file >>>= 0;
                onload >>>= 0;
                onerror >>>= 0;
                var _url = UTF8ToString(url);
                var _file = UTF8ToString(file);
                _file = PATH_FS.resolve(_file);

                function doCallback(callback) {
                    if (callback) {
                        callUserCallback(() => {
                            var sp = stackSave();
                            getWasmTableEntry(callback)(stringToUTF8OnStack(_file));
                            stackRestore(sp)
                        })
                    }
                }
                var destinationDirectory = PATH.dirname(_file);
                FS_createPreloadedFile(destinationDirectory, PATH.basename(_file), _url, true, true, () => doCallback(onload), () => doCallback(onerror), false, false, () => {
                    try {
                        FS_unlink(_file)
                    } catch (e) {}
                    FS_mkdirTree(destinationDirectory)
                })
            };
            _emscripten_async_wget.sig = "vpppp";
            var _emscripten_async_wget_data = function(url, userdata, onload, onerror) {
                url >>>= 0;
                userdata >>>= 0;
                onload >>>= 0;
                onerror >>>= 0;
                asyncLoad(UTF8ToString(url), byteArray => {
                    callUserCallback(() => {
                        var buffer = _malloc(byteArray.length);
                        HEAPU8.set(byteArray, buffer >>> 0);
                        getWasmTableEntry(onload)(userdata, buffer, byteArray.length);
                        _free(buffer)
                    })
                }, () => {
                    if (onerror) {
                        callUserCallback(() => {
                            getWasmTableEntry(onerror)(userdata)
                        })
                    }
                }, true)
            };
            _emscripten_async_wget_data.sig = "vpppp";
            var _emscripten_async_wget2 = function(url, file, request, param, userdata, onload, onerror, onprogress) {
                url >>>= 0;
                file >>>= 0;
                request >>>= 0;
                param >>>= 0;
                userdata >>>= 0;
                onload >>>= 0;
                onerror >>>= 0;
                onprogress >>>= 0;
                var _url = UTF8ToString(url);
                var _file = UTF8ToString(file);
                _file = PATH_FS.resolve(_file);
                var _request = UTF8ToString(request);
                var _param = UTF8ToString(param);
                var index = _file.lastIndexOf("/");
                var http = new XMLHttpRequest;
                http.open(_request, _url, true);
                http.responseType = "arraybuffer";
                var handle = wget.getNextWgetRequestHandle();
                var destinationDirectory = PATH.dirname(_file);
                http.onload = e => {
                    if (http.status >= 200 && http.status < 300) {
                        try {
                            FS.unlink(_file)
                        } catch (e) {}
                        FS.mkdirTree(destinationDirectory);
                        FS.createDataFile(_file.substr(0, index), _file.substr(index + 1), new Uint8Array(http.response), true, true, false);
                        if (onload) {
                            var sp = stackSave();
                            getWasmTableEntry(onload)(handle, userdata, stringToUTF8OnStack(_file));
                            stackRestore(sp)
                        }
                    } else {
                        if (onerror) getWasmTableEntry(onerror)(handle, userdata, http.status)
                    }
                    delete wget.wgetRequests[handle]
                };
                http.onerror = e => {
                    if (onerror) getWasmTableEntry(onerror)(handle, userdata, http.status);
                    delete wget.wgetRequests[handle]
                };
                http.onprogress = e => {
                    if (e.lengthComputable || e.lengthComputable === undefined && e.total != 0) {
                        var percentComplete = e.loaded / e.total * 100;
                        if (onprogress) getWasmTableEntry(onprogress)(handle, userdata, percentComplete)
                    }
                };
                http.onabort = e => {
                    delete wget.wgetRequests[handle]
                };
                if (_request == "POST") {
                    http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
                    http.send(_param)
                } else {
                    http.send(null)
                }
                wget.wgetRequests[handle] = http;
                return handle
            };
            _emscripten_async_wget2.sig = "ipppppppp";

            function _emscripten_async_wget2_data(url, request, param, userdata, free, onload, onerror, onprogress) {
                url >>>= 0;
                request >>>= 0;
                param >>>= 0;
                userdata >>>= 0;
                onload >>>= 0;
                onerror >>>= 0;
                onprogress >>>= 0;
                var _url = UTF8ToString(url);
                var _request = UTF8ToString(request);
                var _param = UTF8ToString(param);
                var http = new XMLHttpRequest;
                http.open(_request, _url, true);
                http.responseType = "arraybuffer";
                var handle = wget.getNextWgetRequestHandle();

                function onerrorjs() {
                    if (onerror) {
                        var sp = stackSave();
                        var statusText = 0;
                        if (http.statusText) {
                            statusText = stringToUTF8OnStack(http.statusText)
                        }
                        getWasmTableEntry(onerror)(handle, userdata, http.status, statusText);
                        stackRestore(sp)
                    }
                }
                http.onload = e => {
                    if (http.status >= 200 && http.status < 300 || http.status === 0 && _url.substr(0, 4).toLowerCase() != "http") {
                        var byteArray = new Uint8Array(http.response);
                        var buffer = _malloc(byteArray.length);
                        HEAPU8.set(byteArray, buffer >>> 0);
                        if (onload) getWasmTableEntry(onload)(handle, userdata, buffer, byteArray.length);
                        if (free) _free(buffer)
                    } else {
                        onerrorjs()
                    }
                    delete wget.wgetRequests[handle]
                };
                http.onerror = e => {
                    onerrorjs();
                    delete wget.wgetRequests[handle]
                };
                http.onprogress = e => {
                    if (onprogress) getWasmTableEntry(onprogress)(handle, userdata, e.loaded, e.lengthComputable || e.lengthComputable === undefined ? e.total : 0)
                };
                http.onabort = e => {
                    delete wget.wgetRequests[handle]
                };
                if (_request == "POST") {
                    http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
                    http.send(_param)
                } else {
                    http.send(null)
                }
                wget.wgetRequests[handle] = http;
                return handle
            }
            _emscripten_async_wget2_data.sig = "ippppippp";
            var _emscripten_async_wget2_abort = handle => {
                var http = wget.wgetRequests[handle];
                http?.abort()
            };
            _emscripten_async_wget2_abort.sig = "vi";

            function ___asctime_r(tmPtr, buf) {
                tmPtr >>>= 0;
                buf >>>= 0;
                var date = {
                    tm_sec: HEAP32[tmPtr >>> 2 >>> 0],
                    tm_min: HEAP32[tmPtr + 4 >>> 2 >>> 0],
                    tm_hour: HEAP32[tmPtr + 8 >>> 2 >>> 0],
                    tm_mday: HEAP32[tmPtr + 12 >>> 2 >>> 0],
                    tm_mon: HEAP32[tmPtr + 16 >>> 2 >>> 0],
                    tm_year: HEAP32[tmPtr + 20 >>> 2 >>> 0],
                    tm_wday: HEAP32[tmPtr + 24 >>> 2 >>> 0]
                };
                var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
                var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                var s = days[date.tm_wday] + " " + months[date.tm_mon] + (date.tm_mday < 10 ? "  " : " ") + date.tm_mday + (date.tm_hour < 10 ? " 0" : " ") + date.tm_hour + (date.tm_min < 10 ? ":0" : ":") + date.tm_min + (date.tm_sec < 10 ? ":0" : ":") + date.tm_sec + " " + (1900 + date.tm_year) + "\n";
                stringToUTF8(s, buf, 26);
                return buf
            }
            ___asctime_r.sig = "ppp";

            function _strptime_l(buf, format, tm, locale) {
                buf >>>= 0;
                format >>>= 0;
                tm >>>= 0;
                locale >>>= 0;
                return _strptime(buf, format, tm)
            }
            _strptime_l.sig = "ppppp";

            function ___syscall_shutdown(fd, how) {
                try {
                    getSocketFromFD(fd);
                    return -52
                } catch (e) {
                    if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                    return -e.errno
                }
            }
            Module["___syscall_shutdown"] = ___syscall_shutdown;
            ___syscall_shutdown.sig = "iiiiiii";

            function __dlsym_catchup_js(handle, symbolIndex) {
                handle >>>= 0;
                var lib = LDSO.loadedLibsByHandle[handle];
                var symDict = lib.exports;
                var symName = Object.keys(symDict)[symbolIndex];
                var sym = symDict[symName];
                var result = addFunction(sym, sym.sig);
                return result
            }
            __dlsym_catchup_js.sig = "ppi";
            var FS_createPath = FS.createPath;
            var FS_createDevice = FS.createDevice;
            var FS_readFile = FS.readFile;
            var FS_createLazyFile = FS.createLazyFile;
            var _setNetworkCallback = (event, userData, callback) => {
                function _callback(data) {
                    try {
                        if (event === "error") {
                            var sp = stackSave();
                            var msg = stringToUTF8OnStack(data[2]);
                            getWasmTableEntry(callback)(data[0], data[1], msg, userData);
                            stackRestore(sp)
                        } else {
                            getWasmTableEntry(callback)(data, userData)
                        }
                    } catch (e) {
                        if (!(e instanceof ExitStatus)) {
                            if (e && typeof e == "object" && e.stack) err("exception thrown: " + [e, e.stack]);
                            throw e
                        }
                    }
                }
                SOCKFS.on(event, callback ? _callback : null)
            };

            function _emscripten_set_socket_error_callback(userData, callback) {
                userData >>>= 0;
                callback >>>= 0;
                _setNetworkCallback("error", userData, callback)
            }
            _emscripten_set_socket_error_callback.sig = "vpp";

            function _emscripten_set_socket_open_callback(userData, callback) {
                userData >>>= 0;
                callback >>>= 0;
                _setNetworkCallback("open", userData, callback)
            }
            _emscripten_set_socket_open_callback.sig = "vpp";

            function _emscripten_set_socket_listen_callback(userData, callback) {
                userData >>>= 0;
                callback >>>= 0;
                _setNetworkCallback("listen", userData, callback)
            }
            _emscripten_set_socket_listen_callback.sig = "vpp";

            function _emscripten_set_socket_connection_callback(userData, callback) {
                userData >>>= 0;
                callback >>>= 0;
                _setNetworkCallback("connection", userData, callback)
            }
            _emscripten_set_socket_connection_callback.sig = "vpp";

            function _emscripten_set_socket_message_callback(userData, callback) {
                userData >>>= 0;
                callback >>>= 0;
                _setNetworkCallback("message", userData, callback)
            }
            _emscripten_set_socket_message_callback.sig = "vpp";

            function _emscripten_set_socket_close_callback(userData, callback) {
                userData >>>= 0;
                callback >>>= 0;
                _setNetworkCallback("close", userData, callback)
            }
            _emscripten_set_socket_close_callback.sig = "vpp";

            function _emscripten_webgl_enable_ANGLE_instanced_arrays(ctx) {
                ctx >>>= 0;
                return webgl_enable_ANGLE_instanced_arrays(GL.contexts[ctx].GLctx)
            }
            _emscripten_webgl_enable_ANGLE_instanced_arrays.sig = "ip";

            function _emscripten_webgl_enable_OES_vertex_array_object(ctx) {
                ctx >>>= 0;
                return webgl_enable_OES_vertex_array_object(GL.contexts[ctx].GLctx)
            }
            _emscripten_webgl_enable_OES_vertex_array_object.sig = "ip";

            function _emscripten_webgl_enable_WEBGL_draw_buffers(ctx) {
                ctx >>>= 0;
                return webgl_enable_WEBGL_draw_buffers(GL.contexts[ctx].GLctx)
            }
            _emscripten_webgl_enable_WEBGL_draw_buffers.sig = "ip";

            function _emscripten_webgl_enable_WEBGL_multi_draw(ctx) {
                ctx >>>= 0;
                return webgl_enable_WEBGL_multi_draw(GL.contexts[ctx].GLctx)
            }
            _emscripten_webgl_enable_WEBGL_multi_draw.sig = "ip";

            function _emscripten_webgl_enable_EXT_polygon_offset_clamp(ctx) {
                ctx >>>= 0;
                return webgl_enable_EXT_polygon_offset_clamp(GL.contexts[ctx].GLctx)
            }
            _emscripten_webgl_enable_EXT_polygon_offset_clamp.sig = "ip";

            function _emscripten_webgl_enable_EXT_clip_control(ctx) {
                ctx >>>= 0;
                return webgl_enable_EXT_clip_control(GL.contexts[ctx].GLctx)
            }
            _emscripten_webgl_enable_EXT_clip_control.sig = "ip";

            function _emscripten_webgl_enable_WEBGL_polygon_mode(ctx) {
                ctx >>>= 0;
                return webgl_enable_WEBGL_polygon_mode(GL.contexts[ctx].GLctx)
            }
            _emscripten_webgl_enable_WEBGL_polygon_mode.sig = "ip";

            function _glVertexPointer(size, type, stride, ptr) {
                ptr >>>= 0;
                throw "Legacy GL function (glVertexPointer) called. If you want legacy GL emulation, you need to compile with -sLEGACY_GL_EMULATION to enable legacy GL emulation."
            }
            _glVertexPointer.sig = "viiip";
            var _glMatrixMode = () => {
                throw "Legacy GL function (glMatrixMode) called. If you want legacy GL emulation, you need to compile with -sLEGACY_GL_EMULATION to enable legacy GL emulation."
            };
            _glMatrixMode.sig = "vi";
            var _glBegin = () => {
                throw "Legacy GL function (glBegin) called. If you want legacy GL emulation, you need to compile with -sLEGACY_GL_EMULATION to enable legacy GL emulation."
            };
            _glBegin.sig = "vi";
            var _glLoadIdentity = () => {
                throw "Legacy GL function (glLoadIdentity) called. If you want legacy GL emulation, you need to compile with -sLEGACY_GL_EMULATION to enable legacy GL emulation."
            };
            _glLoadIdentity.sig = "v";
            var _glVertexAttribDivisorNV = _glVertexAttribDivisor;
            var _glDrawArraysInstancedNV = _glDrawArraysInstanced;
            var _glDrawElementsInstancedNV = _glDrawElementsInstanced;
            var _glVertexAttribDivisorEXT = _glVertexAttribDivisor;
            var _glDrawArraysInstancedEXT = _glDrawArraysInstanced;
            var _glDrawElementsInstancedEXT = _glDrawElementsInstanced;
            var _glVertexAttribDivisorARB = _glVertexAttribDivisor;
            var _glDrawArraysInstancedARB = _glDrawArraysInstanced;
            var _glDrawElementsInstancedARB = _glDrawElementsInstanced;
            var _glDrawBuffersEXT = _glDrawBuffers;

            function _glMultiDrawArraysWEBGL(mode, firsts, counts, drawcount) {
                firsts >>>= 0;
                counts >>>= 0;
                GLctx.multiDrawWebgl["multiDrawArraysWEBGL"](mode, HEAP32, firsts >>> 2, HEAP32, counts >>> 2, drawcount)
            }
            _glMultiDrawArraysWEBGL.sig = "vippi";
            var _glMultiDrawArrays = _glMultiDrawArraysWEBGL;
            _glMultiDrawArrays.sig = "vippi";
            var _glMultiDrawArraysANGLE = _glMultiDrawArraysWEBGL;

            function _glMultiDrawArraysInstancedWEBGL(mode, firsts, counts, instanceCounts, drawcount) {
                firsts >>>= 0;
                counts >>>= 0;
                instanceCounts >>>= 0;
                GLctx.multiDrawWebgl["multiDrawArraysInstancedWEBGL"](mode, HEAP32, firsts >>> 2, HEAP32, counts >>> 2, HEAP32, instanceCounts >>> 2, drawcount)
            }
            _glMultiDrawArraysInstancedWEBGL.sig = "vipppi";
            var _glMultiDrawArraysInstancedANGLE = _glMultiDrawArraysInstancedWEBGL;

            function _glMultiDrawElementsWEBGL(mode, counts, type, offsets, drawcount) {
                counts >>>= 0;
                offsets >>>= 0;
                GLctx.multiDrawWebgl["multiDrawElementsWEBGL"](mode, HEAP32, counts >>> 2, type, HEAP32, offsets >>> 2, drawcount)
            }
            _glMultiDrawElementsWEBGL.sig = "vipipi";
            var _glMultiDrawElements = _glMultiDrawElementsWEBGL;
            _glMultiDrawElements.sig = "vipipi";
            var _glMultiDrawElementsANGLE = _glMultiDrawElementsWEBGL;

            function _glMultiDrawElementsInstancedWEBGL(mode, counts, type, offsets, instanceCounts, drawcount) {
                counts >>>= 0;
                offsets >>>= 0;
                instanceCounts >>>= 0;
                GLctx.multiDrawWebgl["multiDrawElementsInstancedWEBGL"](mode, HEAP32, counts >>> 2, type, HEAP32, offsets >>> 2, HEAP32, instanceCounts >>> 2, drawcount)
            }
            _glMultiDrawElementsInstancedWEBGL.sig = "vipippi";
            var _glMultiDrawElementsInstancedANGLE = _glMultiDrawElementsInstancedWEBGL;
            var _glClearDepth = x0 => GLctx.clearDepth(x0);
            _glClearDepth.sig = "vd";
            var _glDepthRange = (x0, x1) => GLctx.depthRange(x0, x1);
            _glDepthRange.sig = "vdd";
            var _emscripten_glGenVertexArrays = _glGenVertexArrays;
            _emscripten_glGenVertexArrays.sig = "vip";
            var _emscripten_glDeleteVertexArrays = _glDeleteVertexArrays;
            _emscripten_glDeleteVertexArrays.sig = "vip";
            var _emscripten_glBindVertexArray = _glBindVertexArray;
            _emscripten_glBindVertexArray.sig = "vi";
            var _emscripten_glIsVertexArray = _glIsVertexArray;
            _emscripten_glIsVertexArray.sig = "ii";
            var _emscripten_glVertexPointer = _glVertexPointer;
            _emscripten_glVertexPointer.sig = "viiip";
            var _emscripten_glMatrixMode = _glMatrixMode;
            _emscripten_glMatrixMode.sig = "vi";
            var _emscripten_glBegin = _glBegin;
            _emscripten_glBegin.sig = "vi";
            var _emscripten_glLoadIdentity = _glLoadIdentity;
            _emscripten_glLoadIdentity.sig = "v";
            var _emscripten_glVertexAttribDivisor = _glVertexAttribDivisor;
            _emscripten_glVertexAttribDivisor.sig = "vii";
            var _emscripten_glDrawArraysInstanced = _glDrawArraysInstanced;
            _emscripten_glDrawArraysInstanced.sig = "viiii";
            var _emscripten_glDrawElementsInstanced = _glDrawElementsInstanced;
            _emscripten_glDrawElementsInstanced.sig = "viiipi";
            var _emscripten_glVertexAttribDivisorNV = _glVertexAttribDivisorNV;
            var _emscripten_glDrawArraysInstancedNV = _glDrawArraysInstancedNV;
            var _emscripten_glDrawElementsInstancedNV = _glDrawElementsInstancedNV;
            var _emscripten_glVertexAttribDivisorEXT = _glVertexAttribDivisorEXT;
            var _emscripten_glDrawArraysInstancedEXT = _glDrawArraysInstancedEXT;
            var _emscripten_glDrawElementsInstancedEXT = _glDrawElementsInstancedEXT;
            var _emscripten_glVertexAttribDivisorARB = _glVertexAttribDivisorARB;
            var _emscripten_glDrawArraysInstancedARB = _glDrawArraysInstancedARB;
            var _emscripten_glDrawElementsInstancedARB = _glDrawElementsInstancedARB;
            var _emscripten_glDrawBuffers = _glDrawBuffers;
            _emscripten_glDrawBuffers.sig = "vip";
            var _emscripten_glDrawBuffersEXT = _glDrawBuffersEXT;
            var _emscripten_glMultiDrawArrays = _glMultiDrawArrays;
            _emscripten_glMultiDrawArrays.sig = "vippi";
            var _emscripten_glMultiDrawArraysANGLE = _glMultiDrawArraysANGLE;
            var _emscripten_glMultiDrawArraysWEBGL = _glMultiDrawArraysWEBGL;
            var _emscripten_glMultiDrawArraysInstancedANGLE = _glMultiDrawArraysInstancedANGLE;
            var _emscripten_glMultiDrawArraysInstancedWEBGL = _glMultiDrawArraysInstancedWEBGL;
            var _emscripten_glMultiDrawElements = _glMultiDrawElements;
            _emscripten_glMultiDrawElements.sig = "vipipi";
            var _emscripten_glMultiDrawElementsANGLE = _glMultiDrawElementsANGLE;
            var _emscripten_glMultiDrawElementsWEBGL = _glMultiDrawElementsWEBGL;
            var _emscripten_glMultiDrawElementsInstancedANGLE = _glMultiDrawElementsInstancedANGLE;
            var _emscripten_glMultiDrawElementsInstancedWEBGL = _glMultiDrawElementsInstancedWEBGL;
            var _emscripten_glClearDepth = _glClearDepth;
            _emscripten_glClearDepth.sig = "vd";
            var _emscripten_glDepthRange = _glDepthRange;
            _emscripten_glDepthRange.sig = "vdd";
            var writeGLArray = (arr, dst, dstLength, heapType) => {
                var len = arr.length;
                var writeLength = dstLength < len ? dstLength : len;
                var heap = heapType ? HEAPF32 : HEAP32;
                dst = dst >>> 2;
                for (var i = 0; i < writeLength; ++i) {
                    heap[dst + i >>> 0] = arr[i]
                }
                return len
            };
            var webglPowerPreferences = ["default", "low-power", "high-performance"];

            function _emscripten_webgl_do_create_context(target, attributes) {
                target >>>= 0;
                attributes >>>= 0;
                var attr32 = attributes >>> 2;
                var powerPreference = HEAP32[attr32 + (8 >> 2) >>> 0];
                var contextAttributes = {
                    alpha: !!HEAP8[attributes + 0 >>> 0],
                    depth: !!HEAP8[attributes + 1 >>> 0],
                    stencil: !!HEAP8[attributes + 2 >>> 0],
                    antialias: !!HEAP8[attributes + 3 >>> 0],
                    premultipliedAlpha: !!HEAP8[attributes + 4 >>> 0],
                    preserveDrawingBuffer: !!HEAP8[attributes + 5 >>> 0],
                    powerPreference: webglPowerPreferences[powerPreference],
                    failIfMajorPerformanceCaveat: !!HEAP8[attributes + 12 >>> 0],
                    majorVersion: HEAP32[attr32 + (16 >> 2) >>> 0],
                    minorVersion: HEAP32[attr32 + (20 >> 2) >>> 0],
                    enableExtensionsByDefault: HEAP8[attributes + 24 >>> 0],
                    explicitSwapControl: HEAP8[attributes + 25 >>> 0],
                    proxyContextToMainThread: HEAP32[attr32 + (28 >> 2) >>> 0],
                    renderViaOffscreenBackBuffer: HEAP8[attributes + 32 >>> 0]
                };
                var canvas = findCanvasEventTarget(target);
                if (!canvas) {
                    return 0
                }
                if (contextAttributes.explicitSwapControl) {
                    return 0
                }
                var contextHandle = GL.createContext(canvas, contextAttributes);
                return contextHandle
            }
            _emscripten_webgl_do_create_context.sig = "ppp";
            var _emscripten_webgl_create_context = _emscripten_webgl_do_create_context;
            _emscripten_webgl_create_context.sig = "ppp";

            function _emscripten_webgl_do_get_current_context() {
                return GL.currentContext ? GL.currentContext.handle : 0
            }
            _emscripten_webgl_do_get_current_context.sig = "p";
            var _emscripten_webgl_get_current_context = _emscripten_webgl_do_get_current_context;
            _emscripten_webgl_get_current_context.sig = "p";
            var _emscripten_webgl_do_commit_frame = () => {
                if (!GL.currentContext || !GL.currentContext.GLctx) {
                    return -3
                }
                if (!GL.currentContext.attributes.explicitSwapControl) {
                    return -3
                }
                return 0
            };
            _emscripten_webgl_do_commit_frame.sig = "i";
            var _emscripten_webgl_commit_frame = _emscripten_webgl_do_commit_frame;
            _emscripten_webgl_commit_frame.sig = "i";

            function _emscripten_webgl_make_context_current(contextHandle) {
                contextHandle >>>= 0;
                var success = GL.makeContextCurrent(contextHandle);
                return success ? 0 : -5
            }
            _emscripten_webgl_make_context_current.sig = "ip";

            function _emscripten_webgl_get_drawing_buffer_size(contextHandle, width, height) {
                contextHandle >>>= 0;
                width >>>= 0;
                height >>>= 0;
                var GLContext = GL.getContext(contextHandle);
                if (!GLContext || !GLContext.GLctx || !width || !height) {
                    return -5
                }
                HEAP32[width >>> 2 >>> 0] = GLContext.GLctx.drawingBufferWidth;
                HEAP32[height >>> 2 >>> 0] = GLContext.GLctx.drawingBufferHeight;
                return 0
            }
            _emscripten_webgl_get_drawing_buffer_size.sig = "ippp";

            function _emscripten_webgl_get_context_attributes(c, a) {
                c >>>= 0;
                a >>>= 0;
                if (!a) return -5;
                c = GL.contexts[c];
                if (!c) return -3;
                var t = c.GLctx;
                if (!t) return -3;
                t = t.getContextAttributes();
                HEAP8[a >>> 0] = t.alpha;
                HEAP8[a + 1 >>> 0] = t.depth;
                HEAP8[a + 2 >>> 0] = t.stencil;
                HEAP8[a + 3 >>> 0] = t.antialias;
                HEAP8[a + 4 >>> 0] = t.premultipliedAlpha;
                HEAP8[a + 5 >>> 0] = t.preserveDrawingBuffer;
                var power = t["powerPreference"] && webglPowerPreferences.indexOf(t["powerPreference"]);
                HEAP32[a + 8 >>> 2 >>> 0] = power;
                HEAP8[a + 12 >>> 0] = t.failIfMajorPerformanceCaveat;
                HEAP32[a + 16 >>> 2 >>> 0] = c.version;
                HEAP32[a + 20 >>> 2 >>> 0] = 0;
                HEAP8[a + 24 >>> 0] = c.attributes.enableExtensionsByDefault;
                return 0
            }
            _emscripten_webgl_get_context_attributes.sig = "ipp";

            function _emscripten_webgl_destroy_context(contextHandle) {
                contextHandle >>>= 0;
                if (GL.currentContext == contextHandle) GL.currentContext = 0;
                GL.deleteContext(contextHandle)
            }
            _emscripten_webgl_destroy_context.sig = "ip";

            function _emscripten_webgl_enable_extension(contextHandle, extension) {
                contextHandle >>>= 0;
                extension >>>= 0;
                var context = GL.getContext(contextHandle);
                var extString = UTF8ToString(extension);
                if (extString.startsWith("GL_")) extString = extString.substr(3);
                if (extString == "ANGLE_instanced_arrays") webgl_enable_ANGLE_instanced_arrays(GLctx);
                if (extString == "OES_vertex_array_object") webgl_enable_OES_vertex_array_object(GLctx);
                if (extString == "WEBGL_draw_buffers") webgl_enable_WEBGL_draw_buffers(GLctx);
                if (extString == "WEBGL_multi_draw") webgl_enable_WEBGL_multi_draw(GLctx);
                if (extString == "EXT_polygon_offset_clamp") webgl_enable_EXT_polygon_offset_clamp(GLctx);
                if (extString == "EXT_clip_control") webgl_enable_EXT_clip_control(GLctx);
                if (extString == "WEBGL_polygon_mode") webgl_enable_WEBGL_polygon_mode(GLctx);
                var ext = context.GLctx.getExtension(extString);
                return !!ext
            }
            _emscripten_webgl_enable_extension.sig = "ipp";
            var _emscripten_supports_offscreencanvas = () => 0;
            _emscripten_supports_offscreencanvas.sig = "i";
            var registerWebGlEventCallback = (target, userData, useCapture, callbackfunc, eventTypeId, eventTypeString, targetThread) => {
                var webGlEventHandlerFunc = (e = event) => {
                    if (getWasmTableEntry(callbackfunc)(eventTypeId, 0, userData)) e.preventDefault()
                };
                var eventHandler = {
                    target: findEventTarget(target),
                    eventTypeString,
                    callbackfunc,
                    handlerFunc: webGlEventHandlerFunc,
                    useCapture
                };
                JSEvents.registerOrRemoveHandler(eventHandler)
            };

            function _emscripten_set_webglcontextlost_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                registerWebGlEventCallback(target, userData, useCapture, callbackfunc, 31, "webglcontextlost", targetThread);
                return 0
            }
            _emscripten_set_webglcontextlost_callback_on_thread.sig = "ippipp";

            function _emscripten_set_webglcontextrestored_callback_on_thread(target, userData, useCapture, callbackfunc, targetThread) {
                target >>>= 0;
                userData >>>= 0;
                callbackfunc >>>= 0;
                targetThread >>>= 0;
                registerWebGlEventCallback(target, userData, useCapture, callbackfunc, 32, "webglcontextrestored", targetThread);
                return 0
            }
            _emscripten_set_webglcontextrestored_callback_on_thread.sig = "ippipp";

            function _emscripten_is_webgl_context_lost(contextHandle) {
                contextHandle >>>= 0;
                return !GL.contexts[contextHandle] || GL.contexts[contextHandle].GLctx.isContextLost()
            }
            _emscripten_is_webgl_context_lost.sig = "ip";

            function _emscripten_webgl_get_supported_extensions() {
                return stringToNewUTF8(GLctx.getSupportedExtensions().join(" "))
            }
            _emscripten_webgl_get_supported_extensions.sig = "p";
            var _emscripten_webgl_get_program_parameter_d = (program, param) => GLctx.getProgramParameter(GL.programs[program], param);
            _emscripten_webgl_get_program_parameter_d.sig = "dii";

            function _emscripten_webgl_get_program_info_log_utf8(program) {
                return stringToNewUTF8(GLctx.getProgramInfoLog(GL.programs[program]))
            }
            _emscripten_webgl_get_program_info_log_utf8.sig = "pi";
            var _emscripten_webgl_get_shader_parameter_d = (shader, param) => GLctx.getShaderParameter(GL.shaders[shader], param);
            _emscripten_webgl_get_shader_parameter_d.sig = "dii";

            function _emscripten_webgl_get_shader_info_log_utf8(shader) {
                return stringToNewUTF8(GLctx.getShaderInfoLog(GL.shaders[shader]))
            }
            _emscripten_webgl_get_shader_info_log_utf8.sig = "pi";

            function _emscripten_webgl_get_shader_source_utf8(shader) {
                return stringToNewUTF8(GLctx.getShaderSource(GL.shaders[shader]))
            }
            _emscripten_webgl_get_shader_source_utf8.sig = "pi";
            var _emscripten_webgl_get_vertex_attrib_d = (index, param) => GLctx.getVertexAttrib(index, param);
            _emscripten_webgl_get_vertex_attrib_d.sig = "dii";
            var _emscripten_webgl_get_vertex_attrib_o = (index, param) => {
                var obj = GLctx.getVertexAttrib(index, param);
                return obj?.name
            };
            _emscripten_webgl_get_vertex_attrib_o.sig = "iii";

            function _emscripten_webgl_get_vertex_attrib_v(index, param, dst, dstLength, dstType) {
                dst >>>= 0;
                return writeGLArray(GLctx.getVertexAttrib(index, param), dst, dstLength, dstType)
            }
            _emscripten_webgl_get_vertex_attrib_v.sig = "iiipii";
            var _emscripten_webgl_get_uniform_d = (program, location) => GLctx.getUniform(GL.programs[program], webglGetUniformLocation(location));
            _emscripten_webgl_get_uniform_d.sig = "dii";

            function _emscripten_webgl_get_uniform_v(program, location, dst, dstLength, dstType) {
                dst >>>= 0;
                return writeGLArray(GLctx.getUniform(GL.programs[program], webglGetUniformLocation(location)), dst, dstLength, dstType)
            }
            _emscripten_webgl_get_uniform_v.sig = "iiipii";

            function _emscripten_webgl_get_parameter_v(param, dst, dstLength, dstType) {
                dst >>>= 0;
                return writeGLArray(GLctx.getParameter(param), dst, dstLength, dstType)
            }
            _emscripten_webgl_get_parameter_v.sig = "iipii";
            var _emscripten_webgl_get_parameter_d = param => GLctx.getParameter(param);
            _emscripten_webgl_get_parameter_d.sig = "di";
            var _emscripten_webgl_get_parameter_o = param => {
                var obj = GLctx.getParameter(param);
                return obj?.name
            };
            _emscripten_webgl_get_parameter_o.sig = "ii";

            function _emscripten_webgl_get_parameter_utf8(param) {
                return stringToNewUTF8(GLctx.getParameter(param))
            }
            _emscripten_webgl_get_parameter_utf8.sig = "pi";

            function _emscripten_webgl_get_parameter_i64v(param, dst) {
                dst >>>= 0;
                return writeI53ToI64(dst, GLctx.getParameter(param))
            }
            _emscripten_webgl_get_parameter_i64v.sig = "vip";
            var _glutPostRedisplay = () => {
                if (GLUT.displayFunc && !GLUT.requestedAnimationFrame) {
                    GLUT.requestedAnimationFrame = true;
                    MainLoop.requestAnimationFrame(() => {
                        GLUT.requestedAnimationFrame = false;
                        MainLoop.runIter(() => getWasmTableEntry(GLUT.displayFunc)())
                    })
                }
            };
            _glutPostRedisplay.sig = "v";
            var GLUT = {
                initTime: null,
                idleFunc: null,
                displayFunc: null,
                keyboardFunc: null,
                keyboardUpFunc: null,
                specialFunc: null,
                specialUpFunc: null,
                reshapeFunc: null,
                motionFunc: null,
                passiveMotionFunc: null,
                mouseFunc: null,
                buttons: 0,
                modifiers: 0,
                initWindowWidth: 256,
                initWindowHeight: 256,
                initDisplayMode: 18,
                windowX: 0,
                windowY: 0,
                windowWidth: 0,
                windowHeight: 0,
                requestedAnimationFrame: false,
                saveModifiers: event => {
                    GLUT.modifiers = 0;
                    if (event["shiftKey"]) GLUT.modifiers += 1;
                    if (event["ctrlKey"]) GLUT.modifiers += 2;
                    if (event["altKey"]) GLUT.modifiers += 4
                },
                onMousemove: event => {
                    var lastX = Browser.mouseX;
                    var lastY = Browser.mouseY;
                    Browser.calculateMouseEvent(event);
                    var newX = Browser.mouseX;
                    var newY = Browser.mouseY;
                    if (newX == lastX && newY == lastY) return;
                    if (GLUT.buttons == 0 && event.target == Module["canvas"] && GLUT.passiveMotionFunc) {
                        event.preventDefault();
                        GLUT.saveModifiers(event);
                        getWasmTableEntry(GLUT.passiveMotionFunc)(lastX, lastY)
                    } else if (GLUT.buttons != 0 && GLUT.motionFunc) {
                        event.preventDefault();
                        GLUT.saveModifiers(event);
                        getWasmTableEntry(GLUT.motionFunc)(lastX, lastY)
                    }
                },
                getSpecialKey: keycode => {
                    var key = null;
                    switch (keycode) {
                        case 8:
                            key = 120;
                            break;
                        case 46:
                            key = 111;
                            break;
                        case 112:
                            key = 1;
                            break;
                        case 113:
                            key = 2;
                            break;
                        case 114:
                            key = 3;
                            break;
                        case 115:
                            key = 4;
                            break;
                        case 116:
                            key = 5;
                            break;
                        case 117:
                            key = 6;
                            break;
                        case 118:
                            key = 7;
                            break;
                        case 119:
                            key = 8;
                            break;
                        case 120:
                            key = 9;
                            break;
                        case 121:
                            key = 10;
                            break;
                        case 122:
                            key = 11;
                            break;
                        case 123:
                            key = 12;
                            break;
                        case 37:
                            key = 100;
                            break;
                        case 38:
                            key = 101;
                            break;
                        case 39:
                            key = 102;
                            break;
                        case 40:
                            key = 103;
                            break;
                        case 33:
                            key = 104;
                            break;
                        case 34:
                            key = 105;
                            break;
                        case 36:
                            key = 106;
                            break;
                        case 35:
                            key = 107;
                            break;
                        case 45:
                            key = 108;
                            break;
                        case 16:
                        case 5:
                            key = 112;
                            break;
                        case 6:
                            key = 113;
                            break;
                        case 17:
                        case 3:
                            key = 114;
                            break;
                        case 4:
                            key = 115;
                            break;
                        case 18:
                        case 2:
                            key = 116;
                            break;
                        case 1:
                            key = 117;
                            break
                    }
                    return key
                },
                getASCIIKey: event => {
                    if (event["ctrlKey"] || event["altKey"] || event["metaKey"]) return null;
                    var keycode = event["keyCode"];
                    if (48 <= keycode && keycode <= 57) return keycode;
                    if (65 <= keycode && keycode <= 90) return event["shiftKey"] ? keycode : keycode + 32;
                    if (96 <= keycode && keycode <= 105) return keycode - 48;
                    if (106 <= keycode && keycode <= 111) return keycode - 106 + 42;
                    switch (keycode) {
                        case 9:
                        case 13:
                        case 27:
                        case 32:
                        case 61:
                            return keycode
                    }
                    var s = event["shiftKey"];
                    switch (keycode) {
                        case 186:
                            return s ? 58 : 59;
                        case 187:
                            return s ? 43 : 61;
                        case 188:
                            return s ? 60 : 44;
                        case 189:
                            return s ? 95 : 45;
                        case 190:
                            return s ? 62 : 46;
                        case 191:
                            return s ? 63 : 47;
                        case 219:
                            return s ? 123 : 91;
                        case 220:
                            return s ? 124 : 47;
                        case 221:
                            return s ? 125 : 93;
                        case 222:
                            return s ? 34 : 39
                    }
                    return null
                },
                onKeydown: event => {
                    if (GLUT.specialFunc || GLUT.keyboardFunc) {
                        var key = GLUT.getSpecialKey(event["keyCode"]);
                        if (key !== null) {
                            if (GLUT.specialFunc) {
                                event.preventDefault();
                                GLUT.saveModifiers(event);
                                getWasmTableEntry(GLUT.specialFunc)(key, Browser.mouseX, Browser.mouseY)
                            }
                        } else {
                            key = GLUT.getASCIIKey(event);
                            if (key !== null && GLUT.keyboardFunc) {
                                event.preventDefault();
                                GLUT.saveModifiers(event);
                                getWasmTableEntry(GLUT.keyboardFunc)(key, Browser.mouseX, Browser.mouseY)
                            }
                        }
                    }
                },
                onKeyup: event => {
                    if (GLUT.specialUpFunc || GLUT.keyboardUpFunc) {
                        var key = GLUT.getSpecialKey(event["keyCode"]);
                        if (key !== null) {
                            if (GLUT.specialUpFunc) {
                                event.preventDefault();
                                GLUT.saveModifiers(event);
                                getWasmTableEntry(GLUT.specialUpFunc)(key, Browser.mouseX, Browser.mouseY)
                            }
                        } else {
                            key = GLUT.getASCIIKey(event);
                            if (key !== null && GLUT.keyboardUpFunc) {
                                event.preventDefault();
                                GLUT.saveModifiers(event);
                                getWasmTableEntry(GLUT.keyboardUpFunc)(key, Browser.mouseX, Browser.mouseY)
                            }
                        }
                    }
                },
                touchHandler: event => {
                    if (event.target != Module["canvas"]) {
                        return
                    }
                    var touches = event.changedTouches,
                        main = touches[0],
                        type = "";
                    switch (event.type) {
                        case "touchstart":
                            type = "mousedown";
                            break;
                        case "touchmove":
                            type = "mousemove";
                            break;
                        case "touchend":
                            type = "mouseup";
                            break;
                        default:
                            return
                    }
                    var simulatedEvent = document.createEvent("MouseEvent");
                    simulatedEvent.initMouseEvent(type, true, true, window, 1, main.screenX, main.screenY, main.clientX, main.clientY, false, false, false, false, 0, null);
                    main.target.dispatchEvent(simulatedEvent);
                    event.preventDefault()
                },
                onMouseButtonDown: event => {
                    Browser.calculateMouseEvent(event);
                    GLUT.buttons |= 1 << event["button"];
                    if (event.target == Module["canvas"] && GLUT.mouseFunc) {
                        try {
                            event.target.setCapture()
                        } catch (e) {}
                        event.preventDefault();
                        GLUT.saveModifiers(event);
                        getWasmTableEntry(GLUT.mouseFunc)(event["button"], 0, Browser.mouseX, Browser.mouseY)
                    }
                },
                onMouseButtonUp: event => {
                    Browser.calculateMouseEvent(event);
                    GLUT.buttons &= ~(1 << event["button"]);
                    if (GLUT.mouseFunc) {
                        event.preventDefault();
                        GLUT.saveModifiers(event);
                        getWasmTableEntry(GLUT.mouseFunc)(event["button"], 1, Browser.mouseX, Browser.mouseY)
                    }
                },
                onMouseWheel: event => {
                    Browser.calculateMouseEvent(event);
                    var e = window.event || event;
                    var delta = -Browser.getMouseWheelDelta(event);
                    delta = delta == 0 ? 0 : delta > 0 ? Math.max(delta, 1) : Math.min(delta, -1);
                    var button = 3;
                    if (delta < 0) {
                        button = 4
                    }
                    if (GLUT.mouseFunc) {
                        event.preventDefault();
                        GLUT.saveModifiers(event);
                        getWasmTableEntry(GLUT.mouseFunc)(button, 0, Browser.mouseX, Browser.mouseY)
                    }
                },
                onFullscreenEventChange: event => {
                    var width;
                    var height;
                    if (document["fullscreen"] || document["fullScreen"] || document["mozFullScreen"] || document["webkitIsFullScreen"]) {
                        width = screen["width"];
                        height = screen["height"]
                    } else {
                        width = GLUT.windowWidth;
                        height = GLUT.windowHeight;
                        document.removeEventListener("fullscreenchange", GLUT.onFullscreenEventChange, true);
                        document.removeEventListener("mozfullscreenchange", GLUT.onFullscreenEventChange, true);
                        document.removeEventListener("webkitfullscreenchange", GLUT.onFullscreenEventChange, true)
                    }
                    Browser.setCanvasSize(width, height, true);
                    if (GLUT.reshapeFunc) {
                        getWasmTableEntry(GLUT.reshapeFunc)(width, height)
                    }
                    _glutPostRedisplay()
                }
            };
            var _glutGetModifiers = () => GLUT.modifiers;
            _glutGetModifiers.sig = "i";

            function _glutInit(argcp, argv) {
                argcp >>>= 0;
                argv >>>= 0;
                GLUT.initTime = Date.now();
                var isTouchDevice = "ontouchstart" in document.documentElement;
                if (isTouchDevice) {
                    window.addEventListener("touchmove", GLUT.touchHandler, true);
                    window.addEventListener("touchstart", GLUT.touchHandler, true);
                    window.addEventListener("touchend", GLUT.touchHandler, true)
                }
                window.addEventListener("keydown", GLUT.onKeydown, true);
                window.addEventListener("keyup", GLUT.onKeyup, true);
                window.addEventListener("mousemove", GLUT.onMousemove, true);
                window.addEventListener("mousedown", GLUT.onMouseButtonDown, true);
                window.addEventListener("mouseup", GLUT.onMouseButtonUp, true);
                window.addEventListener("mousewheel", GLUT.onMouseWheel, true);
                window.addEventListener("DOMMouseScroll", GLUT.onMouseWheel, true);
                Browser.resizeListeners.push((width, height) => {
                    if (GLUT.reshapeFunc) {
                        getWasmTableEntry(GLUT.reshapeFunc)(width, height)
                    }
                });
                __ATEXIT__.push(() => {
                    if (isTouchDevice) {
                        window.removeEventListener("touchmove", GLUT.touchHandler, true);
                        window.removeEventListener("touchstart", GLUT.touchHandler, true);
                        window.removeEventListener("touchend", GLUT.touchHandler, true)
                    }
                    window.removeEventListener("keydown", GLUT.onKeydown, true);
                    window.removeEventListener("keyup", GLUT.onKeyup, true);
                    window.removeEventListener("mousemove", GLUT.onMousemove, true);
                    window.removeEventListener("mousedown", GLUT.onMouseButtonDown, true);
                    window.removeEventListener("mouseup", GLUT.onMouseButtonUp, true);
                    window.removeEventListener("mousewheel", GLUT.onMouseWheel, true);
                    window.removeEventListener("DOMMouseScroll", GLUT.onMouseWheel, true);
                    Module["canvas"].width = Module["canvas"].height = 1
                })
            }
            _glutInit.sig = "vpp";
            var _glutInitWindowSize = (width, height) => {
                Browser.setCanvasSize(GLUT.initWindowWidth = width, GLUT.initWindowHeight = height)
            };
            _glutInitWindowSize.sig = "vii";
            var _glutInitWindowPosition = (x, y) => {};
            _glutInitWindowPosition.sig = "vii";
            var _glutGet = type => {
                switch (type) {
                    case 100:
                        return 0;
                    case 101:
                        return 0;
                    case 102:
                        return Module["canvas"].width;
                    case 103:
                        return Module["canvas"].height;
                    case 200:
                        return Module["canvas"].width;
                    case 201:
                        return Module["canvas"].height;
                    case 500:
                        return 0;
                    case 501:
                        return 0;
                    case 502:
                        return GLUT.initWindowWidth;
                    case 503:
                        return GLUT.initWindowHeight;
                    case 700:
                        var now = Date.now();
                        return now - GLUT.initTime;
                    case 105:
                        return Module.ctx.getContextAttributes().stencil ? 8 : 0;
                    case 106:
                        return Module.ctx.getContextAttributes().depth ? 8 : 0;
                    case 110:
                        return Module.ctx.getContextAttributes().alpha ? 8 : 0;
                    case 120:
                        return Module.ctx.getContextAttributes().antialias ? 1 : 0;
                    default:
                        throw "glutGet(" + type + ") not implemented yet"
                }
            };
            _glutGet.sig = "ii";

            function _glutIdleFunc(func) {
                func >>>= 0;

                function callback() {
                    if (GLUT.idleFunc) {
                        getWasmTableEntry(GLUT.idleFunc)();
                        safeSetTimeout(callback, 4)
                    }
                }
                if (!GLUT.idleFunc) {
                    safeSetTimeout(callback, 0)
                }
                GLUT.idleFunc = func
            }
            _glutIdleFunc.sig = "vp";
            var _glutTimerFunc = function(msec, func, value) {
                func >>>= 0;
                return safeSetTimeout(() => getWasmTableEntry(func)(value), msec)
            };
            _glutTimerFunc.sig = "vipi";

            function _glutDisplayFunc(func) {
                func >>>= 0;
                GLUT.displayFunc = func
            }
            _glutDisplayFunc.sig = "vp";

            function _glutKeyboardFunc(func) {
                func >>>= 0;
                GLUT.keyboardFunc = func
            }
            _glutKeyboardFunc.sig = "vp";

            function _glutKeyboardUpFunc(func) {
                func >>>= 0;
                GLUT.keyboardUpFunc = func
            }
            _glutKeyboardUpFunc.sig = "vp";

            function _glutSpecialFunc(func) {
                func >>>= 0;
                GLUT.specialFunc = func
            }
            _glutSpecialFunc.sig = "vp";

            function _glutSpecialUpFunc(func) {
                func >>>= 0;
                GLUT.specialUpFunc = func
            }
            _glutSpecialUpFunc.sig = "vp";

            function _glutReshapeFunc(func) {
                func >>>= 0;
                GLUT.reshapeFunc = func
            }
            _glutReshapeFunc.sig = "vp";

            function _glutMotionFunc(func) {
                func >>>= 0;
                GLUT.motionFunc = func
            }
            _glutMotionFunc.sig = "vp";

            function _glutPassiveMotionFunc(func) {
                func >>>= 0;
                GLUT.passiveMotionFunc = func
            }
            _glutPassiveMotionFunc.sig = "vp";

            function _glutMouseFunc(func) {
                func >>>= 0;
                GLUT.mouseFunc = func
            }
            _glutMouseFunc.sig = "vp";
            var _glutSetCursor = cursor => {
                var cursorStyle = "auto";
                switch (cursor) {
                    case 0:
                        break;
                    case 1:
                        break;
                    case 2:
                        cursorStyle = "pointer";
                        break;
                    case 3:
                        break;
                    case 4:
                        cursorStyle = "help";
                        break;
                    case 5:
                        break;
                    case 6:
                        break;
                    case 7:
                        cursorStyle = "wait";
                        break;
                    case 8:
                        cursorStyle = "text";
                        break;
                    case 9:
                    case 102:
                        cursorStyle = "crosshair";
                        break;
                    case 10:
                        cursorStyle = "ns-resize";
                        break;
                    case 11:
                        cursorStyle = "ew-resize";
                        break;
                    case 12:
                        cursorStyle = "n-resize";
                        break;
                    case 13:
                        cursorStyle = "s-resize";
                        break;
                    case 14:
                        cursorStyle = "w-resize";
                        break;
                    case 15:
                        cursorStyle = "e-resize";
                        break;
                    case 16:
                        cursorStyle = "nw-resize";
                        break;
                    case 17:
                        cursorStyle = "ne-resize";
                        break;
                    case 18:
                        cursorStyle = "se-resize";
                        break;
                    case 19:
                        cursorStyle = "sw-resize";
                        break;
                    case 100:
                        break;
                    case 101:
                        cursorStyle = "none";
                        break;
                    default:
                        throw "glutSetCursor: Unknown cursor type: " + cursor
                }
                Module["canvas"].style.cursor = cursorStyle
            };
            _glutSetCursor.sig = "vi";

            function _glutCreateWindow(name) {
                name >>>= 0;
                var contextAttributes = {
                    antialias: (GLUT.initDisplayMode & 128) != 0,
                    depth: (GLUT.initDisplayMode & 16) != 0,
                    stencil: (GLUT.initDisplayMode & 32) != 0,
                    alpha: (GLUT.initDisplayMode & 8) != 0
                };
                Module.ctx = Browser.createContext(Module["canvas"], true, true, contextAttributes);
                return Module.ctx ? 1 : 0
            }
            _glutCreateWindow.sig = "ip";
            var _glutDestroyWindow = name => {
                delete Module.ctx;
                return 1
            };
            _glutDestroyWindow.sig = "vi";
            var _glutReshapeWindow = (width, height) => {
                Browser.exitFullscreen();
                Browser.setCanvasSize(width, height, true);
                if (GLUT.reshapeFunc) {
                    getWasmTableEntry(GLUT.reshapeFunc)(width, height)
                }
                _glutPostRedisplay()
            };
            _glutReshapeWindow.sig = "vii";
            var _glutPositionWindow = (x, y) => {
                Browser.exitFullscreen();
                _glutPostRedisplay()
            };
            _glutPositionWindow.sig = "vii";
            var _glutFullScreen = () => {
                GLUT.windowX = 0;
                GLUT.windowY = 0;
                GLUT.windowWidth = Module["canvas"].width;
                GLUT.windowHeight = Module["canvas"].height;
                document.addEventListener("fullscreenchange", GLUT.onFullscreenEventChange, true);
                document.addEventListener("mozfullscreenchange", GLUT.onFullscreenEventChange, true);
                document.addEventListener("webkitfullscreenchange", GLUT.onFullscreenEventChange, true);
                Browser.requestFullscreen(false, false)
            };
            _glutFullScreen.sig = "v";
            var _glutInitDisplayMode = mode => GLUT.initDisplayMode = mode;
            _glutInitDisplayMode.sig = "vi";
            var _glutSwapBuffers = () => {};
            _glutSwapBuffers.sig = "v";
            var _glutMainLoop = () => {
                _glutReshapeWindow(Module["canvas"].width, Module["canvas"].height);
                _glutPostRedisplay();
                throw "unwind"
            };
            _glutMainLoop.sig = "v";

            function _XOpenDisplay(name) {
                name >>>= 0;
                return 1
            }
            _XOpenDisplay.sig = "pp";

            function _XCreateWindow(display, parent, x, y, width, height, border_width, depth, class_, visual, valuemask, attributes) {
                display >>>= 0;
                parent >>>= 0;
                visual >>>= 0;
                valuemask >>>= 0;
                attributes >>>= 0;
                Browser.setCanvasSize(width, height);
                return 2
            }
            _XCreateWindow.sig = "pppiiiiiiippp";

            function _XChangeWindowAttributes(display, window, valuemask, attributes) {
                display >>>= 0;
                window >>>= 0;
                valuemask >>>= 0;
                attributes >>>= 0
            }
            _XChangeWindowAttributes.sig = "ipppp";

            function _XSetWMHints(display, win, hints) {
                display >>>= 0;
                win >>>= 0;
                hints >>>= 0
            }
            _XSetWMHints.sig = "ippp";

            function _XMapWindow(display, win) {
                display >>>= 0;
                win >>>= 0
            }
            _XMapWindow.sig = "ipp";

            function _XStoreName(display, win, name) {
                display >>>= 0;
                win >>>= 0;
                name >>>= 0
            }
            _XStoreName.sig = "ippp";

            function _XInternAtom(display, name_, hmm) {
                display >>>= 0;
                name_ >>>= 0;
                return 0
            }
            _XInternAtom.sig = "pppi";

            function _XSendEvent(display, win, propagate, event_mask, even_send) {
                display >>>= 0;
                win >>>= 0;
                event_mask >>>= 0;
                even_send >>>= 0
            }
            _XSendEvent.sig = "ippipp";

            function _XPending(display) {
                display >>>= 0;
                return 0
            }
            _XPending.sig = "ip";
            var EGL = {
                errorCode: 12288,
                defaultDisplayInitialized: false,
                currentContext: 0,
                currentReadSurface: 0,
                currentDrawSurface: 0,
                contextAttributes: {
                    alpha: false,
                    depth: false,
                    stencil: false,
                    antialias: false
                },
                stringCache: {},
                setErrorCode(code) {
                    EGL.errorCode = code
                },
                chooseConfig(display, attribList, config, config_size, numConfigs) {
                    if (display != 62e3) {
                        EGL.setErrorCode(12296);
                        return 0
                    }
                    if (attribList) {
                        for (;;) {
                            var param = HEAP32[attribList >>> 2 >>> 0];
                            if (param == 12321) {
                                var alphaSize = HEAP32[attribList + 4 >>> 2 >>> 0];
                                EGL.contextAttributes.alpha = alphaSize > 0
                            } else if (param == 12325) {
                                var depthSize = HEAP32[attribList + 4 >>> 2 >>> 0];
                                EGL.contextAttributes.depth = depthSize > 0
                            } else if (param == 12326) {
                                var stencilSize = HEAP32[attribList + 4 >>> 2 >>> 0];
                                EGL.contextAttributes.stencil = stencilSize > 0
                            } else if (param == 12337) {
                                var samples = HEAP32[attribList + 4 >>> 2 >>> 0];
                                EGL.contextAttributes.antialias = samples > 0
                            } else if (param == 12338) {
                                var samples = HEAP32[attribList + 4 >>> 2 >>> 0];
                                EGL.contextAttributes.antialias = samples == 1
                            } else if (param == 12544) {
                                var requestedPriority = HEAP32[attribList + 4 >>> 2 >>> 0];
                                EGL.contextAttributes.lowLatency = requestedPriority != 12547
                            } else if (param == 12344) {
                                break
                            }
                            attribList += 8
                        }
                    }
                    if ((!config || !config_size) && !numConfigs) {
                        EGL.setErrorCode(12300);
                        return 0
                    }
                    if (numConfigs) {
                        HEAP32[numConfigs >>> 2 >>> 0] = 1
                    }
                    if (config && config_size > 0) {
                        HEAPU32[config >>> 2 >>> 0] = 62002
                    }
                    EGL.setErrorCode(12288);
                    return 1
                }
            };

            function _eglGetDisplay(nativeDisplayType) {
                nativeDisplayType >>>= 0;
                EGL.setErrorCode(12288);
                if (nativeDisplayType != 0 && nativeDisplayType != 1) {
                    return 0
                }
                return 62e3
            }
            _eglGetDisplay.sig = "pp";

            function _eglInitialize(display, majorVersion, minorVersion) {
                display >>>= 0;
                majorVersion >>>= 0;
                minorVersion >>>= 0;
                if (display != 62e3) {
                    EGL.setErrorCode(12296);
                    return 0
                }
                if (majorVersion) {
                    HEAP32[majorVersion >>> 2 >>> 0] = 1
                }
                if (minorVersion) {
                    HEAP32[minorVersion >>> 2 >>> 0] = 4
                }
                EGL.defaultDisplayInitialized = true;
                EGL.setErrorCode(12288);
                return 1
            }
            _eglInitialize.sig = "ippp";

            function _eglTerminate(display) {
                display >>>= 0;
                if (display != 62e3) {
                    EGL.setErrorCode(12296);
                    return 0
                }
                EGL.currentContext = 0;
                EGL.currentReadSurface = 0;
                EGL.currentDrawSurface = 0;
                EGL.defaultDisplayInitialized = false;
                EGL.setErrorCode(12288);
                return 1
            }
            _eglTerminate.sig = "ip";

            function _eglGetConfigs(display, configs, config_size, numConfigs) {
                display >>>= 0;
                configs >>>= 0;
                numConfigs >>>= 0;
                return EGL.chooseConfig(display, 0, configs, config_size, numConfigs)
            }
            _eglGetConfigs.sig = "ippip";

            function _eglChooseConfig(display, attrib_list, configs, config_size, numConfigs) {
                display >>>= 0;
                attrib_list >>>= 0;
                configs >>>= 0;
                numConfigs >>>= 0;
                return EGL.chooseConfig(display, attrib_list, configs, config_size, numConfigs)
            }
            _eglChooseConfig.sig = "ipppip";

            function _eglGetConfigAttrib(display, config, attribute, value) {
                display >>>= 0;
                config >>>= 0;
                value >>>= 0;
                if (display != 62e3) {
                    EGL.setErrorCode(12296);
                    return 0
                }
                if (config != 62002) {
                    EGL.setErrorCode(12293);
                    return 0
                }
                if (!value) {
                    EGL.setErrorCode(12300);
                    return 0
                }
                EGL.setErrorCode(12288);
                switch (attribute) {
                    case 12320:
                        HEAP32[value >>> 2 >>> 0] = EGL.contextAttributes.alpha ? 32 : 24;
                        return 1;
                    case 12321:
                        HEAP32[value >>> 2 >>> 0] = EGL.contextAttributes.alpha ? 8 : 0;
                        return 1;
                    case 12322:
                        HEAP32[value >>> 2 >>> 0] = 8;
                        return 1;
                    case 12323:
                        HEAP32[value >>> 2 >>> 0] = 8;
                        return 1;
                    case 12324:
                        HEAP32[value >>> 2 >>> 0] = 8;
                        return 1;
                    case 12325:
                        HEAP32[value >>> 2 >>> 0] = EGL.contextAttributes.depth ? 24 : 0;
                        return 1;
                    case 12326:
                        HEAP32[value >>> 2 >>> 0] = EGL.contextAttributes.stencil ? 8 : 0;
                        return 1;
                    case 12327:
                        HEAP32[value >>> 2 >>> 0] = 12344;
                        return 1;
                    case 12328:
                        HEAP32[value >>> 2 >>> 0] = 62002;
                        return 1;
                    case 12329:
                        HEAP32[value >>> 2 >>> 0] = 0;
                        return 1;
                    case 12330:
                        HEAP32[value >>> 2 >>> 0] = 4096;
                        return 1;
                    case 12331:
                        HEAP32[value >>> 2 >>> 0] = 16777216;
                        return 1;
                    case 12332:
                        HEAP32[value >>> 2 >>> 0] = 4096;
                        return 1;
                    case 12333:
                        HEAP32[value >>> 2 >>> 0] = 0;
                        return 1;
                    case 12334:
                        HEAP32[value >>> 2 >>> 0] = 0;
                        return 1;
                    case 12335:
                        HEAP32[value >>> 2 >>> 0] = 12344;
                        return 1;
                    case 12337:
                        HEAP32[value >>> 2 >>> 0] = EGL.contextAttributes.antialias ? 4 : 0;
                        return 1;
                    case 12338:
                        HEAP32[value >>> 2 >>> 0] = EGL.contextAttributes.antialias ? 1 : 0;
                        return 1;
                    case 12339:
                        HEAP32[value >>> 2 >>> 0] = 4;
                        return 1;
                    case 12340:
                        HEAP32[value >>> 2 >>> 0] = 12344;
                        return 1;
                    case 12341:
                    case 12342:
                    case 12343:
                        HEAP32[value >>> 2 >>> 0] = -1;
                        return 1;
                    case 12345:
                    case 12346:
                        HEAP32[value >>> 2 >>> 0] = 0;
                        return 1;
                    case 12347:
                        HEAP32[value >>> 2 >>> 0] = 0;
                        return 1;
                    case 12348:
                        HEAP32[value >>> 2 >>> 0] = 1;
                        return 1;
                    case 12349:
                    case 12350:
                        HEAP32[value >>> 2 >>> 0] = 0;
                        return 1;
                    case 12351:
                        HEAP32[value >>> 2 >>> 0] = 12430;
                        return 1;
                    case 12352:
                        HEAP32[value >>> 2 >>> 0] = 4;
                        return 1;
                    case 12354:
                        HEAP32[value >>> 2 >>> 0] = 0;
                        return 1;
                    default:
                        EGL.setErrorCode(12292);
                        return 0
                }
            }
            _eglGetConfigAttrib.sig = "ippip";

            function _eglCreateWindowSurface(display, config, win, attrib_list) {
                display >>>= 0;
                config >>>= 0;
                attrib_list >>>= 0;
                if (display != 62e3) {
                    EGL.setErrorCode(12296);
                    return 0
                }
                if (config != 62002) {
                    EGL.setErrorCode(12293);
                    return 0
                }
                EGL.setErrorCode(12288);
                return 62006
            }
            _eglCreateWindowSurface.sig = "pppip";

            function _eglDestroySurface(display, surface) {
                display >>>= 0;
                surface >>>= 0;
                if (display != 62e3) {
                    EGL.setErrorCode(12296);
                    return 0
                }
                if (surface != 62006) {
                    EGL.setErrorCode(12301);
                    return 1
                }
                if (EGL.currentReadSurface == surface) {
                    EGL.currentReadSurface = 0
                }
                if (EGL.currentDrawSurface == surface) {
                    EGL.currentDrawSurface = 0
                }
                EGL.setErrorCode(12288);
                return 1
            }
            _eglDestroySurface.sig = "ipp";

            function _eglCreateContext(display, config, hmm, contextAttribs) {
                display >>>= 0;
                config >>>= 0;
                hmm >>>= 0;
                contextAttribs >>>= 0;
                if (display != 62e3) {
                    EGL.setErrorCode(12296);
                    return 0
                }
                var glesContextVersion = 1;
                for (;;) {
                    var param = HEAP32[contextAttribs >>> 2 >>> 0];
                    if (param == 12440) {
                        glesContextVersion = HEAP32[contextAttribs + 4 >>> 2 >>> 0]
                    } else if (param == 12344) {
                        break
                    } else {
                        EGL.setErrorCode(12292);
                        return 0
                    }
                    contextAttribs += 8
                }
                if (glesContextVersion != 2) {
                    EGL.setErrorCode(12293);
                    return 0
                }
                EGL.contextAttributes.majorVersion = glesContextVersion - 1;
                EGL.contextAttributes.minorVersion = 0;
                EGL.context = GL.createContext(Module["canvas"], EGL.contextAttributes);
                if (EGL.context != 0) {
                    EGL.setErrorCode(12288);
                    GL.makeContextCurrent(EGL.context);
                    Browser.useWebGL = true;
                    Browser.moduleContextCreatedCallbacks.forEach(callback => callback());
                    GL.makeContextCurrent(null);
                    return 62004
                } else {
                    EGL.setErrorCode(12297);
                    return 0
                }
            }
            _eglCreateContext.sig = "ppppp";

            function _eglDestroyContext(display, context) {
                display >>>= 0;
                context >>>= 0;
                if (display != 62e3) {
                    EGL.setErrorCode(12296);
                    return 0
                }
                if (context != 62004) {
                    EGL.setErrorCode(12294);
                    return 0
                }
                GL.deleteContext(EGL.context);
                EGL.setErrorCode(12288);
                if (EGL.currentContext == context) {
                    EGL.currentContext = 0
                }
                return 1
            }
            _eglDestroyContext.sig = "ipp";

            function _eglQuerySurface(display, surface, attribute, value) {
                display >>>= 0;
                surface >>>= 0;
                value >>>= 0;
                if (display != 62e3) {
                    EGL.setErrorCode(12296);
                    return 0
                }
                if (surface != 62006) {
                    EGL.setErrorCode(12301);
                    return 0
                }
                if (!value) {
                    EGL.setErrorCode(12300);
                    return 0
                }
                EGL.setErrorCode(12288);
                switch (attribute) {
                    case 12328:
                        HEAP32[value >>> 2 >>> 0] = 62002;
                        return 1;
                    case 12376:
                        return 1;
                    case 12375:
                        HEAP32[value >>> 2 >>> 0] = Module["canvas"].width;
                        return 1;
                    case 12374:
                        HEAP32[value >>> 2 >>> 0] = Module["canvas"].height;
                        return 1;
                    case 12432:
                        HEAP32[value >>> 2 >>> 0] = -1;
                        return 1;
                    case 12433:
                        HEAP32[value >>> 2 >>> 0] = -1;
                        return 1;
                    case 12434:
                        HEAP32[value >>> 2 >>> 0] = -1;
                        return 1;
                    case 12422:
                        HEAP32[value >>> 2 >>> 0] = 12420;
                        return 1;
                    case 12441:
                        HEAP32[value >>> 2 >>> 0] = 12442;
                        return 1;
                    case 12435:
                        HEAP32[value >>> 2 >>> 0] = 12437;
                        return 1;
                    case 12416:
                    case 12417:
                    case 12418:
                    case 12419:
                        return 1;
                    default:
                        EGL.setErrorCode(12292);
                        return 0
                }
            }
            _eglQuerySurface.sig = "ippip";

            function _eglQueryContext(display, context, attribute, value) {
                display >>>= 0;
                context >>>= 0;
                value >>>= 0;
                if (display != 62e3) {
                    EGL.setErrorCode(12296);
                    return 0
                }
                if (context != 62004) {
                    EGL.setErrorCode(12294);
                    return 0
                }
                if (!value) {
                    EGL.setErrorCode(12300);
                    return 0
                }
                EGL.setErrorCode(12288);
                switch (attribute) {
                    case 12328:
                        HEAP32[value >>> 2 >>> 0] = 62002;
                        return 1;
                    case 12439:
                        HEAP32[value >>> 2 >>> 0] = 12448;
                        return 1;
                    case 12440:
                        HEAP32[value >>> 2 >>> 0] = EGL.contextAttributes.majorVersion + 1;
                        return 1;
                    case 12422:
                        HEAP32[value >>> 2 >>> 0] = 12420;
                        return 1;
                    default:
                        EGL.setErrorCode(12292);
                        return 0
                }
            }
            _eglQueryContext.sig = "ippip";
            var _eglGetError = () => EGL.errorCode;
            _eglGetError.sig = "i";

            function _eglQueryString(display, name) {
                display >>>= 0;
                if (display != 62e3) {
                    EGL.setErrorCode(12296);
                    return 0
                }
                EGL.setErrorCode(12288);
                if (EGL.stringCache[name]) return EGL.stringCache[name];
                var ret;
                switch (name) {
                    case 12371:
                        ret = stringToNewUTF8("Emscripten");
                        break;
                    case 12372:
                        ret = stringToNewUTF8("1.4 Emscripten EGL");
                        break;
                    case 12373:
                        ret = stringToNewUTF8("");
                        break;
                    case 12429:
                        ret = stringToNewUTF8("OpenGL_ES");
                        break;
                    default:
                        EGL.setErrorCode(12300);
                        return 0
                }
                EGL.stringCache[name] = ret;
                return ret
            }
            _eglQueryString.sig = "ppi";
            var _eglBindAPI = api => {
                if (api == 12448) {
                    EGL.setErrorCode(12288);
                    return 1
                }
                EGL.setErrorCode(12300);
                return 0
            };
            _eglBindAPI.sig = "ii";
            var _eglQueryAPI = () => {
                EGL.setErrorCode(12288);
                return 12448
            };
            _eglQueryAPI.sig = "i";
            var _eglWaitClient = () => {
                EGL.setErrorCode(12288);
                return 1
            };
            _eglWaitClient.sig = "i";
            var _eglWaitNative = nativeEngineId => {
                EGL.setErrorCode(12288);
                return 1
            };
            _eglWaitNative.sig = "ii";
            var _eglWaitGL = _eglWaitClient;
            _eglWaitGL.sig = "i";

            function _eglSwapInterval(display, interval) {
                display >>>= 0;
                if (display != 62e3) {
                    EGL.setErrorCode(12296);
                    return 0
                }
                if (interval == 0) _emscripten_set_main_loop_timing(0, 0);
                else _emscripten_set_main_loop_timing(1, interval);
                EGL.setErrorCode(12288);
                return 1
            }
            _eglSwapInterval.sig = "ipi";

            function _eglMakeCurrent(display, draw, read, context) {
                display >>>= 0;
                draw >>>= 0;
                read >>>= 0;
                context >>>= 0;
                if (display != 62e3) {
                    EGL.setErrorCode(12296);
                    return 0
                }
                if (context != 0 && context != 62004) {
                    EGL.setErrorCode(12294);
                    return 0
                }
                if (read != 0 && read != 62006 || draw != 0 && draw != 62006) {
                    EGL.setErrorCode(12301);
                    return 0
                }
                GL.makeContextCurrent(context ? EGL.context : null);
                EGL.currentContext = context;
                EGL.currentDrawSurface = draw;
                EGL.currentReadSurface = read;
                EGL.setErrorCode(12288);
                return 1
            }
            _eglMakeCurrent.sig = "ipppp";

            function _eglGetCurrentContext() {
                return EGL.currentContext
            }
            _eglGetCurrentContext.sig = "p";

            function _eglGetCurrentSurface(readdraw) {
                if (readdraw == 12378) {
                    return EGL.currentReadSurface
                } else if (readdraw == 12377) {
                    return EGL.currentDrawSurface
                } else {
                    EGL.setErrorCode(12300);
                    return 0
                }
            }
            _eglGetCurrentSurface.sig = "pi";

            function _eglGetCurrentDisplay() {
                return EGL.currentContext ? 62e3 : 0
            }
            _eglGetCurrentDisplay.sig = "p";

            function _eglSwapBuffers(dpy, surface) {
                dpy >>>= 0;
                surface >>>= 0;
                if (!EGL.defaultDisplayInitialized) {
                    EGL.setErrorCode(12289)
                } else if (!Module.ctx) {
                    EGL.setErrorCode(12290)
                } else if (Module.ctx.isContextLost()) {
                    EGL.setErrorCode(12302)
                } else {
                    EGL.setErrorCode(12288);
                    return 1
                }
                return 0
            }
            _eglSwapBuffers.sig = "ipp";
            var _eglReleaseThread = () => {
                EGL.currentContext = 0;
                EGL.currentReadSurface = 0;
                EGL.currentDrawSurface = 0;
                EGL.setErrorCode(12288);
                return 1
            };
            _eglReleaseThread.sig = "i";

            function _uuid_clear(uu) {
                uu >>>= 0;
                return zeroMemory(uu, 16)
            }
            _uuid_clear.sig = "vp";

            function _uuid_compare(uu1, uu2) {
                uu1 >>>= 0;
                uu2 >>>= 0;
                return _memcmp(uu1, uu2, 16)
            }
            _uuid_compare.sig = "ipp";

            function _uuid_copy(dst, src) {
                dst >>>= 0;
                src >>>= 0;
                return _memcpy(dst, src, 16)
            }
            _uuid_copy.sig = "vpp";

            function _uuid_generate(out) {
                out >>>= 0;
                var uuid = null;
                if (ENVIRONMENT_IS_NODE) {
                    try {
                        var rb = require("crypto")["randomBytes"];
                        uuid = rb(16)
                    } catch (e) {}
                } else if (ENVIRONMENT_IS_WEB && typeof window.crypto != "undefined" && typeof window.crypto.getRandomValues != "undefined") {
                    uuid = new Uint8Array(16);
                    window.crypto.getRandomValues(uuid)
                }
                if (!uuid) {
                    uuid = new Array(16);
                    var d = (new Date).getTime();
                    for (var i = 0; i < 16; i++) {
                        var r = (d + Math.random() * 256) % 256 | 0;
                        d = d / 256 | 0;
                        uuid[i] = r
                    }
                }
                uuid[6] = uuid[6] & 15 | 64;
                uuid[8] = uuid[8] & 63 | 128;
                writeArrayToMemory(uuid, out)
            }
            _uuid_generate.sig = "vp";

            function _uuid_is_null(uu) {
                uu >>>= 0;
                for (var i = 0; i < 4; i++, uu = uu + 4 | 0) {
                    var val = HEAP32[uu >>> 2 >>> 0];
                    if (val) {
                        return 0
                    }
                }
                return 1
            }
            _uuid_is_null.sig = "ip";

            function _uuid_parse(inp, uu) {
                inp >>>= 0;
                uu >>>= 0;
                inp = UTF8ToString(inp);
                if (inp.length === 36) {
                    var i = 0;
                    var uuid = new Array(16);
                    inp.toLowerCase().replace(/[0-9a-f]{2}/g, function(byte) {
                        if (i < 16) {
                            uuid[i++] = parseInt(byte, 16)
                        }
                    });
                    if (i < 16) {
                        return -1
                    }
                    writeArrayToMemory(uuid, uu);
                    return 0
                }
                return -1
            }
            _uuid_parse.sig = "ipp";

            function _uuid_unparse(uu, out, upper) {
                uu >>>= 0;
                out >>>= 0;
                var i = 0;
                var uuid = "xxxx-xx-xx-xx-xxxxxx".replace(/[x]/g, function(c) {
                    var r = upper ? HEAPU8[uu + i >>> 0].toString(16).toUpperCase() : HEAPU8[uu + i >>> 0].toString(16);
                    r = r.length === 1 ? "0" + r : r;
                    i++;
                    return r
                });
                stringToUTF8(uuid, out, 37)
            }
            _uuid_unparse.sig = "vpp";

            function _uuid_unparse_lower(uu, out) {
                uu >>>= 0;
                out >>>= 0;
                _uuid_unparse(uu, out)
            }
            _uuid_unparse_lower.sig = "vpp";

            function _uuid_unparse_upper(uu, out) {
                uu >>>= 0;
                out >>>= 0;
                _uuid_unparse(uu, out, true)
            }
            _uuid_unparse_upper.sig = "vpp";

            function _uuid_type(uu) {
                uu >>>= 0;
                return 4
            }
            _uuid_type.sig = "ip";

            function _uuid_variant(uu) {
                uu >>>= 0;
                return 1
            }
            _uuid_variant.sig = "ip";
            var GLEW = {
                isLinaroFork: 1,
                extensions: null,
                error: {
                    0: null,
                    1: null,
                    2: null,
                    3: null,
                    4: null,
                    5: null,
                    6: null,
                    7: null,
                    8: null
                },
                version: {
                    1: null,
                    2: null,
                    3: null,
                    4: null
                },
                errorStringConstantFromCode(error) {
                    if (GLEW.isLinaroFork) {
                        switch (error) {
                            case 4:
                                return "OpenGL ES lib expected, found OpenGL lib";
                            case 5:
                                return "OpenGL lib expected, found OpenGL ES lib";
                            case 6:
                                return "Missing EGL version";
                            case 7:
                                return "EGL 1.1 and up are supported";
                            default:
                                break
                        }
                    }
                    switch (error) {
                        case 0:
                            return "No error";
                        case 1:
                            return "Missing GL version";
                        case 2:
                            return "GL 1.1 and up are supported";
                        case 3:
                            return "GLX 1.2 and up are supported";
                        default:
                            return null
                    }
                },
                errorString(error) {
                    if (!GLEW.error[error]) {
                        var string = GLEW.errorStringConstantFromCode(error);
                        if (!string) {
                            string = "Unknown error";
                            error = 8
                        }
                        GLEW.error[error] = stringToNewUTF8(string)
                    }
                    return GLEW.error[error]
                },
                versionStringConstantFromCode(name) {
                    switch (name) {
                        case 1:
                            return "1.10.0";
                        case 2:
                            return "1";
                        case 3:
                            return "10";
                        case 4:
                            return "0";
                        default:
                            return null
                    }
                },
                versionString(name) {
                    if (!GLEW.version[name]) {
                        var string = GLEW.versionStringConstantFromCode(name);
                        if (!string) return 0;
                        GLEW.version[name] = stringToNewUTF8(string)
                    }
                    return GLEW.version[name]
                },
                extensionIsSupported(name) {
                    GLEW.extensions ||= webglGetExtensions();
                    if (GLEW.extensions.includes(name)) return 1;
                    return GLEW.extensions.includes("GL_" + name)
                }
            };
            var _glewInit = () => 0;
            _glewInit.sig = "i";

            function _glewIsSupported(name) {
                name >>>= 0;
                var exts = UTF8ToString(name).split(" ");
                for (var i = 0; i < exts.length; ++i) {
                    if (!GLEW.extensionIsSupported(exts[i])) return 0
                }
                return 1
            }
            _glewIsSupported.sig = "ip";

            function _glewGetExtension(name) {
                name >>>= 0;
                return GLEW.extensionIsSupported(UTF8ToString(name))
            }
            _glewGetExtension.sig = "ip";

            function _glewGetErrorString(error) {
                return GLEW.errorString(error)
            }
            _glewGetErrorString.sig = "pi";

            function _glewGetString(name) {
                return GLEW.versionString(name)
            }
            _glewGetString.sig = "pi";
            var IDBStore = {
                indexedDB() {
                    if (typeof indexedDB != "undefined") return indexedDB;
                    var ret = null;
                    if (typeof window == "object") ret = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
                    assert(ret, "IDBStore used, but indexedDB not supported");
                    return ret
                },
                DB_VERSION: 22,
                DB_STORE_NAME: "FILE_DATA",
                dbs: {},
                blobs: [0],
                getDB(name, callback) {
                    var db = IDBStore.dbs[name];
                    if (db) {
                        return callback(null, db)
                    }
                    var req;
                    try {
                        req = IDBStore.indexedDB().open(name, IDBStore.DB_VERSION)
                    } catch (e) {
                        return callback(e)
                    }
                    req.onupgradeneeded = e => {
                        var db = e.target.result;
                        var transaction = e.target.transaction;
                        var fileStore;
                        if (db.objectStoreNames.contains(IDBStore.DB_STORE_NAME)) {
                            fileStore = transaction.objectStore(IDBStore.DB_STORE_NAME)
                        } else {
                            fileStore = db.createObjectStore(IDBStore.DB_STORE_NAME)
                        }
                    };
                    req.onsuccess = () => {
                        db = req.result;
                        IDBStore.dbs[name] = db;
                        callback(null, db)
                    };
                    req.onerror = function(event) {
                        callback(event.target.error || "unknown error");
                        event.preventDefault()
                    }
                },
                getStore(dbName, type, callback) {
                    IDBStore.getDB(dbName, (error, db) => {
                        if (error) return callback(error);
                        var transaction = db.transaction([IDBStore.DB_STORE_NAME], type);
                        transaction.onerror = event => {
                            callback(event.target.error || "unknown error");
                            event.preventDefault()
                        };
                        var store = transaction.objectStore(IDBStore.DB_STORE_NAME);
                        callback(null, store)
                    })
                },
                getFile(dbName, id, callback) {
                    IDBStore.getStore(dbName, "readonly", (err, store) => {
                        if (err) return callback(err);
                        var req = store.get(id);
                        req.onsuccess = event => {
                            var result = event.target.result;
                            if (!result) {
                                return callback(`file ${id} not found`)
                            }
                            return callback(null, result)
                        };
                        req.onerror = callback
                    })
                },
                setFile(dbName, id, data, callback) {
                    IDBStore.getStore(dbName, "readwrite", (err, store) => {
                        if (err) return callback(err);
                        var req = store.put(data, id);
                        req.onsuccess = event => callback();
                        req.onerror = callback
                    })
                },
                deleteFile(dbName, id, callback) {
                    IDBStore.getStore(dbName, "readwrite", (err, store) => {
                        if (err) return callback(err);
                        var req = store.delete(id);
                        req.onsuccess = event => callback();
                        req.onerror = callback
                    })
                },
                existsFile(dbName, id, callback) {
                    IDBStore.getStore(dbName, "readonly", (err, store) => {
                        if (err) return callback(err);
                        var req = store.count(id);
                        req.onsuccess = event => callback(null, event.target.result > 0);
                        req.onerror = callback
                    })
                },
                clearStore(dbName, callback) {
                    IDBStore.getStore(dbName, "readwrite", (err, store) => {
                        if (err) return callback(err);
                        var req = store.clear();
                        req.onsuccess = event => callback();
                        req.onerror = callback
                    })
                }
            };
            var _emscripten_idb_async_load = function(db, id, arg, onload, onerror) {
                db >>>= 0;
                id >>>= 0;
                arg >>>= 0;
                onload >>>= 0;
                onerror >>>= 0;
                IDBStore.getFile(UTF8ToString(db), UTF8ToString(id), (error, byteArray) => {
                    callUserCallback(() => {
                        if (error) {
                            if (onerror) getWasmTableEntry(onerror)(arg);
                            return
                        }
                        var buffer = _malloc(byteArray.length);
                        HEAPU8.set(byteArray, buffer >>> 0);
                        getWasmTableEntry(onload)(arg, buffer, byteArray.length);
                        _free(buffer)
                    })
                })
            };
            _emscripten_idb_async_load.sig = "vppppp";
            var _emscripten_idb_async_store = function(db, id, ptr, num, arg, onstore, onerror) {
                db >>>= 0;
                id >>>= 0;
                ptr >>>= 0;
                arg >>>= 0;
                onstore >>>= 0;
                onerror >>>= 0;
                IDBStore.setFile(UTF8ToString(db), UTF8ToString(id), new Uint8Array(HEAPU8.subarray(ptr >>> 0, ptr + num >>> 0)), error => {
                    callUserCallback(() => {
                        if (error) {
                            if (onerror) getWasmTableEntry(onerror)(arg);
                            return
                        }
                        if (onstore) getWasmTableEntry(onstore)(arg)
                    })
                })
            };
            _emscripten_idb_async_store.sig = "vpppippp";
            var _emscripten_idb_async_delete = function(db, id, arg, ondelete, onerror) {
                db >>>= 0;
                id >>>= 0;
                arg >>>= 0;
                ondelete >>>= 0;
                onerror >>>= 0;
                IDBStore.deleteFile(UTF8ToString(db), UTF8ToString(id), error => {
                    callUserCallback(() => {
                        if (error) {
                            if (onerror) getWasmTableEntry(onerror)(arg);
                            return
                        }
                        if (ondelete) getWasmTableEntry(ondelete)(arg)
                    })
                })
            };
            _emscripten_idb_async_delete.sig = "vppppp";
            var _emscripten_idb_async_exists = function(db, id, arg, oncheck, onerror) {
                db >>>= 0;
                id >>>= 0;
                arg >>>= 0;
                oncheck >>>= 0;
                onerror >>>= 0;
                IDBStore.existsFile(UTF8ToString(db), UTF8ToString(id), (error, exists) => {
                    callUserCallback(() => {
                        if (error) {
                            if (onerror) getWasmTableEntry(onerror)(arg);
                            return
                        }
                        if (oncheck) getWasmTableEntry(oncheck)(arg, exists)
                    })
                })
            };
            _emscripten_idb_async_exists.sig = "vppppp";
            var _emscripten_idb_async_clear = function(db, arg, onclear, onerror) {
                db >>>= 0;
                arg >>>= 0;
                onclear >>>= 0;
                onerror >>>= 0;
                IDBStore.clearStore(UTF8ToString(db), error => {
                    callUserCallback(() => {
                        if (error) {
                            if (onerror) getWasmTableEntry(onerror)(arg);
                            return
                        }
                        if (onclear) getWasmTableEntry(onclear)(arg)
                    })
                })
            };
            _emscripten_idb_async_clear.sig = "vpppp";

            function _emscripten_idb_load(db, id, pbuffer, pnum, perror) {
                db >>>= 0;
                id >>>= 0;
                pbuffer >>>= 0;
                pnum >>>= 0;
                perror >>>= 0;
                throw "Please compile your program with async support in order to use synchronous operations like emscripten_idb_load, etc."
            }
            _emscripten_idb_load.sig = "vppppp";

            function _emscripten_idb_store(db, id, ptr, num, perror) {
                db >>>= 0;
                id >>>= 0;
                ptr >>>= 0;
                perror >>>= 0;
                throw "Please compile your program with async support in order to use synchronous operations like emscripten_idb_store, etc."
            }
            _emscripten_idb_store.sig = "vpppip";

            function _emscripten_idb_delete(db, id, perror) {
                db >>>= 0;
                id >>>= 0;
                perror >>>= 0;
                throw "Please compile your program with async support in order to use synchronous operations like emscripten_idb_delete, etc."
            }
            _emscripten_idb_delete.sig = "vppp";

            function _emscripten_idb_exists(db, id, pexists, perror) {
                db >>>= 0;
                id >>>= 0;
                pexists >>>= 0;
                perror >>>= 0;
                throw "Please compile your program with async support in order to use synchronous operations like emscripten_idb_exists, etc."
            }
            _emscripten_idb_exists.sig = "vpppp";

            function _emscripten_idb_clear(db, perror) {
                db >>>= 0;
                perror >>>= 0;
                throw "Please compile your program with async support in order to use synchronous operations like emscripten_idb_clear, etc."
            }
            _emscripten_idb_clear.sig = "vpp";
            var runAndAbortIfError = func => {
                try {
                    return func()
                } catch (e) {
                    abort(e)
                }
            };
            var _emscripten_sleep = () => {
                throw "Please compile your program with async support in order to use asynchronous operations like emscripten_sleep"
            };
            _emscripten_sleep.sig = "vi";

            function _emscripten_wget(url, file) {
                url >>>= 0;
                file >>>= 0;
                throw "Please compile your program with async support in order to use asynchronous operations like emscripten_wget"
            }
            Module["_emscripten_wget"] = _emscripten_wget;
            _emscripten_wget.sig = "ipp";

            function _emscripten_scan_registers(func) {
                func >>>= 0;
                throw "Please compile your program with async support in order to use asynchronous operations like emscripten_scan_registers"
            }
            _emscripten_scan_registers.sig = "vp";

            function _emscripten_fiber_swap(oldFiber, newFiber) {
                oldFiber >>>= 0;
                newFiber >>>= 0;
                throw "Please compile your program with async support in order to use asynchronous operations like emscripten_fiber_swap"
            }
            _emscripten_fiber_swap.sig = "vpp";
            var _SDL_GetTicks = () => Date.now() - SDL.startTime | 0;
            _SDL_GetTicks.sig = "i";

            function _SDL_LockSurface(surf) {
                surf >>>= 0;
                var surfData = SDL.surfaces[surf];
                surfData.locked++;
                if (surfData.locked > 1) return 0;
                if (!surfData.buffer) {
                    surfData.buffer = _malloc(surfData.width * surfData.height * 4);
                    HEAPU32[surf + 20 >>> 2 >>> 0] = surfData.buffer
                }
                HEAPU32[surf + 20 >>> 2 >>> 0] = surfData.buffer;
                if (surf == SDL.screen && Module.screenIsReadOnly && surfData.image) return 0;
                if (SDL.defaults.discardOnLock) {
                    if (!surfData.image) {
                        surfData.image = surfData.ctx.createImageData(surfData.width, surfData.height)
                    }
                    if (!SDL.defaults.opaqueFrontBuffer) return
                } else {
                    surfData.image = surfData.ctx.getImageData(0, 0, surfData.width, surfData.height)
                }
                if (surf == SDL.screen && SDL.defaults.opaqueFrontBuffer) {
                    var data = surfData.image.data;
                    var num = data.length;
                    for (var i = 0; i < num / 4; i++) {
                        data[i * 4 + 3] = 255
                    }
                }
                if (SDL.defaults.copyOnLock && !SDL.defaults.discardOnLock) {
                    if (surfData.isFlagSet(2097152)) {
                        throw "CopyOnLock is not supported for SDL_LockSurface with SDL_HWPALETTE flag set" + (new Error).stack
                    } else {
                        HEAPU8.set(surfData.image.data, surfData.buffer >>> 0)
                    }
                }
                return 0
            }
            _SDL_LockSurface.sig = "ip";
            var SDL = {
                defaults: {
                    width: 320,
                    height: 200,
                    copyOnLock: true,
                    discardOnLock: false,
                    opaqueFrontBuffer: true
                },
                version: null,
                surfaces: {},
                canvasPool: [],
                events: [],
                fonts: [null],
                audios: [null],
                rwops: [null],
                music: {
                    audio: null,
                    volume: 1
                },
                mixerFrequency: 22050,
                mixerFormat: 32784,
                mixerNumChannels: 2,
                mixerChunkSize: 1024,
                channelMinimumNumber: 0,
                GL: false,
                glAttributes: {
                    0: 3,
                    1: 3,
                    2: 2,
                    3: 0,
                    4: 0,
                    5: 1,
                    6: 16,
                    7: 0,
                    8: 0,
                    9: 0,
                    10: 0,
                    11: 0,
                    12: 0,
                    13: 0,
                    14: 0,
                    15: 1,
                    16: 0,
                    17: 0,
                    18: 0
                },
                keyboardState: null,
                keyboardMap: {},
                canRequestFullscreen: false,
                isRequestingFullscreen: false,
                textInput: false,
                unicode: false,
                ttfContext: null,
                audio: null,
                startTime: null,
                initFlags: 0,
                buttonState: 0,
                modState: 0,
                DOMButtons: [0, 0, 0],
                DOMEventToSDLEvent: {},
                TOUCH_DEFAULT_ID: 0,
                eventHandler: null,
                eventHandlerContext: null,
                eventHandlerTemp: 0,
                keyCodes: {
                    16: 1249,
                    17: 1248,
                    18: 1250,
                    20: 1081,
                    33: 1099,
                    34: 1102,
                    35: 1101,
                    36: 1098,
                    37: 1104,
                    38: 1106,
                    39: 1103,
                    40: 1105,
                    44: 316,
                    45: 1097,
                    46: 127,
                    91: 1251,
                    93: 1125,
                    96: 1122,
                    97: 1113,
                    98: 1114,
                    99: 1115,
                    100: 1116,
                    101: 1117,
                    102: 1118,
                    103: 1119,
                    104: 1120,
                    105: 1121,
                    106: 1109,
                    107: 1111,
                    109: 1110,
                    110: 1123,
                    111: 1108,
                    112: 1082,
                    113: 1083,
                    114: 1084,
                    115: 1085,
                    116: 1086,
                    117: 1087,
                    118: 1088,
                    119: 1089,
                    120: 1090,
                    121: 1091,
                    122: 1092,
                    123: 1093,
                    124: 1128,
                    125: 1129,
                    126: 1130,
                    127: 1131,
                    128: 1132,
                    129: 1133,
                    130: 1134,
                    131: 1135,
                    132: 1136,
                    133: 1137,
                    134: 1138,
                    135: 1139,
                    144: 1107,
                    160: 94,
                    161: 33,
                    162: 34,
                    163: 35,
                    164: 36,
                    165: 37,
                    166: 38,
                    167: 95,
                    168: 40,
                    169: 41,
                    170: 42,
                    171: 43,
                    172: 124,
                    173: 45,
                    174: 123,
                    175: 125,
                    176: 126,
                    181: 127,
                    182: 129,
                    183: 128,
                    188: 44,
                    190: 46,
                    191: 47,
                    192: 96,
                    219: 91,
                    220: 92,
                    221: 93,
                    222: 39,
                    224: 1251
                },
                scanCodes: {
                    8: 42,
                    9: 43,
                    13: 40,
                    27: 41,
                    32: 44,
                    35: 204,
                    39: 53,
                    44: 54,
                    46: 55,
                    47: 56,
                    48: 39,
                    49: 30,
                    50: 31,
                    51: 32,
                    52: 33,
                    53: 34,
                    54: 35,
                    55: 36,
                    56: 37,
                    57: 38,
                    58: 203,
                    59: 51,
                    61: 46,
                    91: 47,
                    92: 49,
                    93: 48,
                    96: 52,
                    97: 4,
                    98: 5,
                    99: 6,
                    100: 7,
                    101: 8,
                    102: 9,
                    103: 10,
                    104: 11,
                    105: 12,
                    106: 13,
                    107: 14,
                    108: 15,
                    109: 16,
                    110: 17,
                    111: 18,
                    112: 19,
                    113: 20,
                    114: 21,
                    115: 22,
                    116: 23,
                    117: 24,
                    118: 25,
                    119: 26,
                    120: 27,
                    121: 28,
                    122: 29,
                    127: 76,
                    305: 224,
                    308: 226,
                    316: 70
                },
                loadRect(rect) {
                    return {
                        x: HEAP32[rect >>> 2 >>> 0],
                        y: HEAP32[rect + 4 >>> 2 >>> 0],
                        w: HEAP32[rect + 8 >>> 2 >>> 0],
                        h: HEAP32[rect + 12 >>> 2 >>> 0]
                    }
                },
                updateRect(rect, r) {
                    HEAP32[rect >>> 2 >>> 0] = r.x;
                    HEAP32[rect + 4 >>> 2 >>> 0] = r.y;
                    HEAP32[rect + 8 >>> 2 >>> 0] = r.w;
                    HEAP32[rect + 12 >>> 2 >>> 0] = r.h
                },
                intersectionOfRects(first, second) {
                    var leftX = Math.max(first.x, second.x);
                    var leftY = Math.max(first.y, second.y);
                    var rightX = Math.min(first.x + first.w, second.x + second.w);
                    var rightY = Math.min(first.y + first.h, second.y + second.h);
                    return {
                        x: leftX,
                        y: leftY,
                        w: Math.max(leftX, rightX) - leftX,
                        h: Math.max(leftY, rightY) - leftY
                    }
                },
                checkPixelFormat(fmt) {},
                loadColorToCSSRGB(color) {
                    var rgba = HEAP32[color >>> 2 >>> 0];
                    return "rgb(" + (rgba & 255) + "," + (rgba >> 8 & 255) + "," + (rgba >> 16 & 255) + ")"
                },
                loadColorToCSSRGBA(color) {
                    var rgba = HEAP32[color >>> 2 >>> 0];
                    return "rgba(" + (rgba & 255) + "," + (rgba >> 8 & 255) + "," + (rgba >> 16 & 255) + "," + (rgba >> 24 & 255) / 255 + ")"
                },
                translateColorToCSSRGBA: rgba => "rgba(" + (rgba & 255) + "," + (rgba >> 8 & 255) + "," + (rgba >> 16 & 255) + "," + (rgba >>> 24) / 255 + ")",
                translateRGBAToCSSRGBA: (r, g, b, a) => "rgba(" + (r & 255) + "," + (g & 255) + "," + (b & 255) + "," + (a & 255) / 255 + ")",
                translateRGBAToColor: (r, g, b, a) => r | g << 8 | b << 16 | a << 24,
                makeSurface(width, height, flags, usePageCanvas, source, rmask, gmask, bmask, amask) {
                    var is_SDL_HWSURFACE = flags & 1;
                    var is_SDL_HWPALETTE = flags & 2097152;
                    var is_SDL_OPENGL = flags & 67108864;
                    var surf = _malloc(60);
                    var pixelFormat = _malloc(44);
                    var bpp = is_SDL_HWPALETTE ? 1 : 4;
                    var buffer = 0;
                    if (!is_SDL_HWSURFACE && !is_SDL_OPENGL) {
                        buffer = _malloc(width * height * 4)
                    }
                    HEAP32[surf >>> 2 >>> 0] = flags;
                    HEAPU32[surf + 4 >>> 2 >>> 0] = pixelFormat;
                    HEAP32[surf + 8 >>> 2 >>> 0] = width;
                    HEAP32[surf + 12 >>> 2 >>> 0] = height;
                    HEAP32[surf + 16 >>> 2 >>> 0] = width * bpp;
                    HEAPU32[surf + 20 >>> 2 >>> 0] = buffer;
                    HEAP32[surf + 36 >>> 2 >>> 0] = 0;
                    HEAP32[surf + 40 >>> 2 >>> 0] = 0;
                    HEAP32[surf + 44 >>> 2 >>> 0] = Module["canvas"].width;
                    HEAP32[surf + 48 >>> 2 >>> 0] = Module["canvas"].height;
                    HEAP32[surf + 56 >>> 2 >>> 0] = 1;
                    HEAP32[pixelFormat >>> 2 >>> 0] = -2042224636;
                    HEAP32[pixelFormat + 4 >>> 2 >>> 0] = 0;
                    HEAP8[pixelFormat + 8 >>> 0] = bpp * 8;
                    HEAP8[pixelFormat + 9 >>> 0] = bpp;
                    HEAP32[pixelFormat + 12 >>> 2 >>> 0] = rmask || 255;
                    HEAP32[pixelFormat + 16 >>> 2 >>> 0] = gmask || 65280;
                    HEAP32[pixelFormat + 20 >>> 2 >>> 0] = bmask || 16711680;
                    HEAP32[pixelFormat + 24 >>> 2 >>> 0] = amask || 4278190080;
                    SDL.GL = SDL.GL || is_SDL_OPENGL;
                    var canvas;
                    if (!usePageCanvas) {
                        if (SDL.canvasPool.length > 0) {
                            canvas = SDL.canvasPool.pop()
                        } else {
                            canvas = document.createElement("canvas")
                        }
                        canvas.width = width;
                        canvas.height = height
                    } else {
                        canvas = Module["canvas"]
                    }
                    var webGLContextAttributes = {
                        antialias: SDL.glAttributes[13] != 0 && SDL.glAttributes[14] > 1,
                        depth: SDL.glAttributes[6] > 0,
                        stencil: SDL.glAttributes[7] > 0,
                        alpha: SDL.glAttributes[3] > 0
                    };
                    var ctx = Browser.createContext(canvas, is_SDL_OPENGL, usePageCanvas, webGLContextAttributes);
                    SDL.surfaces[surf] = {
                        width,
                        height,
                        canvas,
                        ctx,
                        surf,
                        buffer,
                        pixelFormat,
                        alpha: 255,
                        flags,
                        locked: 0,
                        usePageCanvas,
                        source,
                        isFlagSet: flag => flags & flag
                    };
                    return surf
                },
                copyIndexedColorData(surfData, rX, rY, rW, rH) {
                    if (!surfData.colors) {
                        return
                    }
                    var fullWidth = Module["canvas"].width;
                    var fullHeight = Module["canvas"].height;
                    var startX = rX || 0;
                    var startY = rY || 0;
                    var endX = (rW || fullWidth - startX) + startX;
                    var endY = (rH || fullHeight - startY) + startY;
                    var buffer = surfData.buffer;
                    if (!surfData.image.data32) {
                        surfData.image.data32 = new Uint32Array(surfData.image.data.buffer)
                    }
                    var data32 = surfData.image.data32;
                    var colors32 = surfData.colors32;
                    for (var y = startY; y < endY; ++y) {
                        var base = y * fullWidth;
                        for (var x = startX; x < endX; ++x) {
                            data32[base + x] = colors32[HEAPU8[buffer + (base + x) >>> 0]]
                        }
                    }
                },
                freeSurface(surf) {
                    var refcountPointer = surf + 56;
                    var refcount = HEAP32[refcountPointer >>> 2 >>> 0];
                    if (refcount > 1) {
                        HEAP32[refcountPointer >>> 2 >>> 0] = refcount - 1;
                        return
                    }
                    var info = SDL.surfaces[surf];
                    if (!info.usePageCanvas && info.canvas) SDL.canvasPool.push(info.canvas);
                    if (info.buffer) _free(info.buffer);
                    _free(info.pixelFormat);
                    _free(surf);
                    SDL.surfaces[surf] = null;
                    if (surf === SDL.screen) {
                        SDL.screen = null
                    }
                },
                blitSurface(src, srcrect, dst, dstrect, scale) {
                    var srcData = SDL.surfaces[src];
                    var dstData = SDL.surfaces[dst];
                    var sr, dr;
                    if (srcrect) {
                        sr = SDL.loadRect(srcrect)
                    } else {
                        sr = {
                            x: 0,
                            y: 0,
                            w: srcData.width,
                            h: srcData.height
                        }
                    }
                    if (dstrect) {
                        dr = SDL.loadRect(dstrect)
                    } else {
                        dr = {
                            x: 0,
                            y: 0,
                            w: srcData.width,
                            h: srcData.height
                        }
                    }
                    if (dstData.clipRect) {
                        var widthScale = !scale || sr.w === 0 ? 1 : sr.w / dr.w;
                        var heightScale = !scale || sr.h === 0 ? 1 : sr.h / dr.h;
                        dr = SDL.intersectionOfRects(dstData.clipRect, dr);
                        sr.w = dr.w * widthScale;
                        sr.h = dr.h * heightScale;
                        if (dstrect) {
                            SDL.updateRect(dstrect, dr)
                        }
                    }
                    var blitw, blith;
                    if (scale) {
                        blitw = dr.w;
                        blith = dr.h
                    } else {
                        blitw = sr.w;
                        blith = sr.h
                    }
                    if (sr.w === 0 || sr.h === 0 || blitw === 0 || blith === 0) {
                        return 0
                    }
                    var oldAlpha = dstData.ctx.globalAlpha;
                    dstData.ctx.globalAlpha = srcData.alpha / 255;
                    dstData.ctx.drawImage(srcData.canvas, sr.x, sr.y, sr.w, sr.h, dr.x, dr.y, blitw, blith);
                    dstData.ctx.globalAlpha = oldAlpha;
                    if (dst != SDL.screen) {
                        warnOnce("WARNING: copying canvas data to memory for compatibility");
                        _SDL_LockSurface(dst);
                        dstData.locked--
                    }
                    return 0
                },
                downFingers: {},
                savedKeydown: null,
                receiveEvent(event) {
                    function unpressAllPressedKeys() {
                        for (var code in SDL.keyboardMap) {
                            SDL.events.push({
                                type: "keyup",
                                keyCode: SDL.keyboardMap[code]
                            })
                        }
                    }
                    switch (event.type) {
                        case "touchstart":
                        case "touchmove": {
                            event.preventDefault();
                            var touches = [];
                            if (event.type === "touchstart") {
                                for (var i = 0; i < event.touches.length; i++) {
                                    var touch = event.touches[i];
                                    if (SDL.downFingers[touch.identifier] != true) {
                                        SDL.downFingers[touch.identifier] = true;
                                        touches.push(touch)
                                    }
                                }
                            } else {
                                touches = event.touches
                            }
                            var firstTouch = touches[0];
                            if (firstTouch) {
                                if (event.type == "touchstart") {
                                    SDL.DOMButtons[0] = 1
                                }
                                var mouseEventType;
                                switch (event.type) {
                                    case "touchstart":
                                        mouseEventType = "mousedown";
                                        break;
                                    case "touchmove":
                                        mouseEventType = "mousemove";
                                        break
                                }
                                var mouseEvent = {
                                    type: mouseEventType,
                                    button: 0,
                                    pageX: firstTouch.clientX,
                                    pageY: firstTouch.clientY
                                };
                                SDL.events.push(mouseEvent)
                            }
                            for (var i = 0; i < touches.length; i++) {
                                var touch = touches[i];
                                SDL.events.push({
                                    type: event.type,
                                    touch
                                })
                            }
                            break
                        }
                        case "touchend": {
                            event.preventDefault();
                            for (var i = 0; i < event.changedTouches.length; i++) {
                                var touch = event.changedTouches[i];
                                if (SDL.downFingers[touch.identifier] === true) {
                                    delete SDL.downFingers[touch.identifier]
                                }
                            }
                            var mouseEvent = {
                                type: "mouseup",
                                button: 0,
                                pageX: event.changedTouches[0].clientX,
                                pageY: event.changedTouches[0].clientY
                            };
                            SDL.DOMButtons[0] = 0;
                            SDL.events.push(mouseEvent);
                            for (var i = 0; i < event.changedTouches.length; i++) {
                                var touch = event.changedTouches[i];
                                SDL.events.push({
                                    type: "touchend",
                                    touch
                                })
                            }
                            break
                        }
                        case "DOMMouseScroll":
                        case "mousewheel":
                        case "wheel":
                            var delta = -Browser.getMouseWheelDelta(event);
                            delta = delta == 0 ? 0 : delta > 0 ? Math.max(delta, 1) : Math.min(delta, -1);
                            var button = delta > 0 ? 3 : 4;
                            SDL.events.push({
                                type: "mousedown",
                                button,
                                pageX: event.pageX,
                                pageY: event.pageY
                            });
                            SDL.events.push({
                                type: "mouseup",
                                button,
                                pageX: event.pageX,
                                pageY: event.pageY
                            });
                            SDL.events.push({
                                type: "wheel",
                                deltaX: 0,
                                deltaY: delta
                            });
                            event.preventDefault();
                            break;
                        case "mousemove":
                            if (SDL.DOMButtons[0] === 1) {
                                SDL.events.push({
                                    type: "touchmove",
                                    touch: {
                                        identifier: 0,
                                        deviceID: -1,
                                        pageX: event.pageX,
                                        pageY: event.pageY
                                    }
                                })
                            }
                            if (Browser.pointerLock) {
                                if ("mozMovementX" in event) {
                                    event["movementX"] = event["mozMovementX"];
                                    event["movementY"] = event["mozMovementY"]
                                }
                                if (event["movementX"] == 0 && event["movementY"] == 0) {
                                    event.preventDefault();
                                    return
                                }
                            }
                        case "keydown":
                        case "keyup":
                        case "keypress":
                        case "mousedown":
                        case "mouseup":
                            if (event.type !== "keydown" || !SDL.unicode && !SDL.textInput || (event.keyCode === 8 || event.keyCode === 9)) {
                                event.preventDefault()
                            }
                            if (event.type == "mousedown") {
                                SDL.DOMButtons[event.button] = 1;
                                SDL.events.push({
                                    type: "touchstart",
                                    touch: {
                                        identifier: 0,
                                        deviceID: -1,
                                        pageX: event.pageX,
                                        pageY: event.pageY
                                    }
                                })
                            } else if (event.type == "mouseup") {
                                if (!SDL.DOMButtons[event.button]) {
                                    return
                                }
                                SDL.events.push({
                                    type: "touchend",
                                    touch: {
                                        identifier: 0,
                                        deviceID: -1,
                                        pageX: event.pageX,
                                        pageY: event.pageY
                                    }
                                });
                                SDL.DOMButtons[event.button] = 0
                            }
                            if (event.type === "keydown" || event.type === "mousedown") {
                                SDL.canRequestFullscreen = true
                            } else if (event.type === "keyup" || event.type === "mouseup") {
                                if (SDL.isRequestingFullscreen) {
                                    Module["requestFullscreen"](true, true);
                                    SDL.isRequestingFullscreen = false
                                }
                                SDL.canRequestFullscreen = false
                            }
                            if (event.type === "keypress" && SDL.savedKeydown) {
                                SDL.savedKeydown.keypressCharCode = event.charCode;
                                SDL.savedKeydown = null
                            } else if (event.type === "keydown") {
                                SDL.savedKeydown = event
                            }
                            if (event.type !== "keypress" || SDL.textInput) {
                                SDL.events.push(event)
                            }
                            break;
                        case "mouseout":
                            for (var i = 0; i < 3; i++) {
                                if (SDL.DOMButtons[i]) {
                                    SDL.events.push({
                                        type: "mouseup",
                                        button: i,
                                        pageX: event.pageX,
                                        pageY: event.pageY
                                    });
                                    SDL.DOMButtons[i] = 0
                                }
                            }
                            event.preventDefault();
                            break;
                        case "focus":
                            SDL.events.push(event);
                            event.preventDefault();
                            break;
                        case "blur":
                            SDL.events.push(event);
                            unpressAllPressedKeys();
                            event.preventDefault();
                            break;
                        case "visibilitychange":
                            SDL.events.push({
                                type: "visibilitychange",
                                visible: !document.hidden
                            });
                            unpressAllPressedKeys();
                            event.preventDefault();
                            break;
                        case "unload":
                            if (MainLoop.runner) {
                                SDL.events.push(event);
                                MainLoop.runner()
                            }
                            return;
                        case "resize":
                            SDL.events.push(event);
                            if (event.preventDefault) {
                                event.preventDefault()
                            }
                            break
                    }
                    if (SDL.events.length >= 1e4) {
                        err("SDL event queue full, dropping events");
                        SDL.events = SDL.events.slice(0, 1e4)
                    }
                    SDL.flushEventsToHandler();
                    return
                },
                lookupKeyCodeForEvent(event) {
                    var code = event.keyCode;
                    if (code >= 65 && code <= 90) {
                        code += 32
                    } else {
                        code = SDL.keyCodes[event.keyCode] || event.keyCode;
                        if (event.location === 2 && code >= (224 | 1 << 10) && code <= (227 | 1 << 10)) {
                            code += 4
                        }
                    }
                    return code
                },
                handleEvent(event) {
                    if (event.handled) return;
                    event.handled = true;
                    switch (event.type) {
                        case "touchstart":
                        case "touchend":
                        case "touchmove": {
                            Browser.calculateMouseEvent(event);
                            break
                        }
                        case "keydown":
                        case "keyup": {
                            var down = event.type === "keydown";
                            var code = SDL.lookupKeyCodeForEvent(event);
                            HEAP8[SDL.keyboardState + code >>> 0] = down;
                            SDL.modState = (HEAP8[SDL.keyboardState + 1248 >>> 0] ? 64 : 0) | (HEAP8[SDL.keyboardState + 1249 >>> 0] ? 1 : 0) | (HEAP8[SDL.keyboardState + 1250 >>> 0] ? 256 : 0) | (HEAP8[SDL.keyboardState + 1252 >>> 0] ? 128 : 0) | (HEAP8[SDL.keyboardState + 1253 >>> 0] ? 2 : 0) | (HEAP8[SDL.keyboardState + 1254 >>> 0] ? 512 : 0);
                            if (down) {
                                SDL.keyboardMap[code] = event.keyCode
                            } else {
                                delete SDL.keyboardMap[code]
                            }
                            break
                        }
                        case "mousedown":
                        case "mouseup":
                            if (event.type == "mousedown") {
                                SDL.buttonState |= 1 << event.button
                            } else if (event.type == "mouseup") {
                                SDL.buttonState &= ~(1 << event.button)
                            }
                        case "mousemove": {
                            Browser.calculateMouseEvent(event);
                            break
                        }
                    }
                },
                flushEventsToHandler() {
                    if (!SDL.eventHandler) return;
                    while (SDL.pollEvent(SDL.eventHandlerTemp)) {
                        getWasmTableEntry(SDL.eventHandler)(SDL.eventHandlerContext, SDL.eventHandlerTemp)
                    }
                },
                pollEvent(ptr) {
                    if (SDL.initFlags & 512 && SDL.joystickEventState) {
                        SDL.queryJoysticks()
                    }
                    if (ptr) {
                        while (SDL.events.length > 0) {
                            if (SDL.makeCEvent(SDL.events.shift(), ptr) !== false) return 1
                        }
                        return 0
                    }
                    return SDL.events.length > 0
                },
                makeCEvent(event, ptr) {
                    if (typeof event == "number") {
                        _memcpy(ptr, event, 28);
                        _free(event);
                        return
                    }
                    SDL.handleEvent(event);
                    switch (event.type) {
                        case "keydown":
                        case "keyup": {
                            var down = event.type === "keydown";
                            var key = SDL.lookupKeyCodeForEvent(event);
                            var scan;
                            if (key >= 1024) {
                                scan = key - 1024
                            } else {
                                scan = SDL.scanCodes[key] || key
                            }
                            HEAP32[ptr >>> 2 >>> 0] = SDL.DOMEventToSDLEvent[event.type];
                            HEAP8[ptr + 8 >>> 0] = down ? 1 : 0;
                            HEAP8[ptr + 9 >>> 0] = 0;
                            HEAP32[ptr + 12 >>> 2 >>> 0] = scan;
                            HEAP32[ptr + 16 >>> 2 >>> 0] = key;
                            HEAP16[ptr + 20 >>> 1 >>> 0] = SDL.modState;
                            HEAP32[ptr + 24 >>> 2 >>> 0] = event.keypressCharCode || key;
                            break
                        }
                        case "keypress": {
                            HEAP32[ptr >>> 2 >>> 0] = SDL.DOMEventToSDLEvent[event.type];
                            var cStr = intArrayFromString(String.fromCharCode(event.charCode));
                            for (var i = 0; i < cStr.length; ++i) {
                                HEAP8[ptr + (8 + i) >>> 0] = cStr[i]
                            }
                            break
                        }
                        case "mousedown":
                        case "mouseup":
                        case "mousemove": {
                            if (event.type != "mousemove") {
                                var down = event.type === "mousedown";
                                HEAP32[ptr >>> 2 >>> 0] = SDL.DOMEventToSDLEvent[event.type];
                                HEAP32[ptr + 4 >>> 2 >>> 0] = 0;
                                HEAP32[ptr + 8 >>> 2 >>> 0] = 0;
                                HEAP32[ptr + 12 >>> 2 >>> 0] = 0;
                                HEAP8[ptr + 16 >>> 0] = event.button + 1;
                                HEAP8[ptr + 17 >>> 0] = down ? 1 : 0;
                                HEAP32[ptr + 20 >>> 2 >>> 0] = Browser.mouseX;
                                HEAP32[ptr + 24 >>> 2 >>> 0] = Browser.mouseY
                            } else {
                                HEAP32[ptr >>> 2 >>> 0] = SDL.DOMEventToSDLEvent[event.type];
                                HEAP32[ptr + 4 >>> 2 >>> 0] = 0;
                                HEAP32[ptr + 8 >>> 2 >>> 0] = 0;
                                HEAP32[ptr + 12 >>> 2 >>> 0] = 0;
                                HEAP32[ptr + 16 >>> 2 >>> 0] = SDL.buttonState;
                                HEAP32[ptr + 20 >>> 2 >>> 0] = Browser.mouseX;
                                HEAP32[ptr + 24 >>> 2 >>> 0] = Browser.mouseY;
                                HEAP32[ptr + 28 >>> 2 >>> 0] = Browser.mouseMovementX;
                                HEAP32[ptr + 32 >>> 2 >>> 0] = Browser.mouseMovementY
                            }
                            break
                        }
                        case "wheel": {
                            HEAP32[ptr >>> 2 >>> 0] = SDL.DOMEventToSDLEvent[event.type];
                            HEAP32[ptr + 16 >>> 2 >>> 0] = event.deltaX;
                            HEAP32[ptr + 20 >>> 2 >>> 0] = event.deltaY;
                            break
                        }
                        case "touchstart":
                        case "touchend":
                        case "touchmove": {
                            var touch = event.touch;
                            if (!Browser.touches[touch.identifier]) break;
                            var w = Module["canvas"].width;
                            var h = Module["canvas"].height;
                            var x = Browser.touches[touch.identifier].x / w;
                            var y = Browser.touches[touch.identifier].y / h;
                            var lx = Browser.lastTouches[touch.identifier].x / w;
                            var ly = Browser.lastTouches[touch.identifier].y / h;
                            var dx = x - lx;
                            var dy = y - ly;
                            if (touch["deviceID"] === undefined) touch.deviceID = SDL.TOUCH_DEFAULT_ID;
                            if (dx === 0 && dy === 0 && event.type === "touchmove") return false;
                            HEAP32[ptr >>> 2 >>> 0] = SDL.DOMEventToSDLEvent[event.type];
                            HEAP32[ptr + 4 >>> 2 >>> 0] = _SDL_GetTicks();
                            tempI64 = [touch.deviceID >>> 0, (tempDouble = touch.deviceID, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[ptr + 8 >>> 2 >>> 0] = tempI64[0], HEAP32[ptr + 12 >>> 2 >>> 0] = tempI64[1];
                            tempI64 = [touch.identifier >>> 0, (tempDouble = touch.identifier, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[ptr + 16 >>> 2 >>> 0] = tempI64[0], HEAP32[ptr + 20 >>> 2 >>> 0] = tempI64[1];
                            HEAPF32[ptr + 24 >>> 2 >>> 0] = x;
                            HEAPF32[ptr + 28 >>> 2 >>> 0] = y;
                            HEAPF32[ptr + 32 >>> 2 >>> 0] = dx;
                            HEAPF32[ptr + 36 >>> 2 >>> 0] = dy;
                            if (touch.force !== undefined) {
                                HEAPF32[ptr + 40 >>> 2 >>> 0] = touch.force
                            } else {
                                HEAPF32[ptr + 40 >>> 2 >>> 0] = event.type == "touchend" ? 0 : 1
                            }
                            break
                        }
                        case "unload": {
                            HEAP32[ptr >>> 2 >>> 0] = SDL.DOMEventToSDLEvent[event.type];
                            break
                        }
                        case "resize": {
                            HEAP32[ptr >>> 2 >>> 0] = SDL.DOMEventToSDLEvent[event.type];
                            HEAP32[ptr + 4 >>> 2 >>> 0] = event.w;
                            HEAP32[ptr + 8 >>> 2 >>> 0] = event.h;
                            break
                        }
                        case "joystick_button_up":
                        case "joystick_button_down": {
                            var state = event.type === "joystick_button_up" ? 0 : 1;
                            HEAP32[ptr >>> 2 >>> 0] = SDL.DOMEventToSDLEvent[event.type];
                            HEAP8[ptr + 4 >>> 0] = event.index;
                            HEAP8[ptr + 5 >>> 0] = event.button;
                            HEAP8[ptr + 6 >>> 0] = state;
                            break
                        }
                        case "joystick_axis_motion": {
                            HEAP32[ptr >>> 2 >>> 0] = SDL.DOMEventToSDLEvent[event.type];
                            HEAP8[ptr + 4 >>> 0] = event.index;
                            HEAP8[ptr + 5 >>> 0] = event.axis;
                            HEAP32[ptr + 8 >>> 2 >>> 0] = SDL.joystickAxisValueConversion(event.value);
                            break
                        }
                        case "focus": {
                            var SDL_WINDOWEVENT_FOCUS_GAINED = 12;
                            HEAP32[ptr >>> 2 >>> 0] = SDL.DOMEventToSDLEvent[event.type];
                            HEAP32[ptr + 4 >>> 2 >>> 0] = 0;
                            HEAP8[ptr + 8 >>> 0] = SDL_WINDOWEVENT_FOCUS_GAINED;
                            break
                        }
                        case "blur": {
                            var SDL_WINDOWEVENT_FOCUS_LOST = 13;
                            HEAP32[ptr >>> 2 >>> 0] = SDL.DOMEventToSDLEvent[event.type];
                            HEAP32[ptr + 4 >>> 2 >>> 0] = 0;
                            HEAP8[ptr + 8 >>> 0] = SDL_WINDOWEVENT_FOCUS_LOST;
                            break
                        }
                        case "visibilitychange": {
                            var SDL_WINDOWEVENT_SHOWN = 1;
                            var SDL_WINDOWEVENT_HIDDEN = 2;
                            var visibilityEventID = event.visible ? SDL_WINDOWEVENT_SHOWN : SDL_WINDOWEVENT_HIDDEN;
                            HEAP32[ptr >>> 2 >>> 0] = SDL.DOMEventToSDLEvent[event.type];
                            HEAP32[ptr + 4 >>> 2 >>> 0] = 0;
                            HEAP8[ptr + 8 >>> 0] = visibilityEventID;
                            break
                        }
                        default:
                            throw "Unhandled SDL event: " + event.type
                    }
                },
                makeFontString(height, fontName) {
                    if (fontName.charAt(0) != "'" && fontName.charAt(0) != '"') {
                        fontName = '"' + fontName + '"'
                    }
                    return height + "px " + fontName + ", serif"
                },
                estimateTextWidth(fontData, text) {
                    var h = fontData.size;
                    var fontString = SDL.makeFontString(h, fontData.name);
                    var tempCtx = SDL.ttfContext;
                    tempCtx.font = fontString;
                    var ret = tempCtx.measureText(text).width | 0;
                    return ret
                },
                allocateChannels(num) {
                    if (SDL.numChannels && SDL.numChannels >= num && num != 0) return;
                    SDL.numChannels = num;
                    SDL.channels = [];
                    for (var i = 0; i < num; i++) {
                        SDL.channels[i] = {
                            audio: null,
                            volume: 1
                        }
                    }
                },
                setGetVolume(info, volume) {
                    if (!info) return 0;
                    var ret = info.volume * 128;
                    if (volume != -1) {
                        info.volume = Math.min(Math.max(volume, 0), 128) / 128;
                        if (info.audio) {
                            try {
                                info.audio.volume = info.volume;
                                if (info.audio.webAudioGainNode) info.audio.webAudioGainNode["gain"]["value"] = info.volume
                            } catch (e) {
                                err(`setGetVolume failed to set audio volume: ${e}`)
                            }
                        }
                    }
                    return ret
                },
                setPannerPosition(info, x, y, z) {
                    if (!info) return;
                    if (info.audio) {
                        if (info.audio.webAudioPannerNode) {
                            info.audio.webAudioPannerNode["setPosition"](x, y, z)
                        }
                    }
                },
                playWebAudio(audio) {
                    if (!audio) return;
                    if (audio.webAudioNode) return;
                    if (!SDL.webAudioAvailable()) return;
                    try {
                        var webAudio = audio.resource.webAudio;
                        audio.paused = false;
                        if (!webAudio.decodedBuffer) {
                            if (webAudio.onDecodeComplete === undefined) abort("Cannot play back audio object that was not loaded");
                            webAudio.onDecodeComplete.push(() => {
                                if (!audio.paused) SDL.playWebAudio(audio)
                            });
                            return
                        }
                        audio.webAudioNode = SDL.audioContext["createBufferSource"]();
                        audio.webAudioNode["buffer"] = webAudio.decodedBuffer;
                        audio.webAudioNode["loop"] = audio.loop;
                        audio.webAudioNode["onended"] = audio["onended"];
                        audio.webAudioPannerNode = SDL.audioContext["createPanner"]();
                        audio.webAudioPannerNode["setPosition"](0, 0, -.5);
                        audio.webAudioPannerNode["panningModel"] = "equalpower";
                        audio.webAudioGainNode = SDL.audioContext["createGain"]();
                        audio.webAudioGainNode["gain"]["value"] = audio.volume;
                        audio.webAudioNode["connect"](audio.webAudioPannerNode);
                        audio.webAudioPannerNode["connect"](audio.webAudioGainNode);
                        audio.webAudioGainNode["connect"](SDL.audioContext["destination"]);
                        audio.webAudioNode["start"](0, audio.currentPosition);
                        audio.startTime = SDL.audioContext["currentTime"] - audio.currentPosition
                    } catch (e) {
                        err(`playWebAudio failed: ${e}`)
                    }
                },
                pauseWebAudio(audio) {
                    if (!audio) return;
                    if (audio.webAudioNode) {
                        try {
                            audio.currentPosition = (SDL.audioContext["currentTime"] - audio.startTime) % audio.resource.webAudio.decodedBuffer.duration;
                            audio.webAudioNode["onended"] = undefined;
                            audio.webAudioNode.stop(0);
                            audio.webAudioNode = undefined
                        } catch (e) {
                            err(`pauseWebAudio failed: ${e}`)
                        }
                    }
                    audio.paused = true
                },
                openAudioContext() {
                    if (!SDL.audioContext) {
                        if (typeof AudioContext != "undefined") SDL.audioContext = new AudioContext;
                        else if (typeof webkitAudioContext != "undefined") SDL.audioContext = new webkitAudioContext
                    }
                },
                webAudioAvailable: () => !!SDL.audioContext,
                fillWebAudioBufferFromHeap(heapPtr, sizeSamplesPerChannel, dstAudioBuffer) {
                    var audio = SDL.audio;
                    var numChannels = audio.channels;
                    for (var c = 0; c < numChannels; ++c) {
                        var channelData = dstAudioBuffer["getChannelData"](c);
                        if (channelData.length != sizeSamplesPerChannel) {
                            throw "Web Audio output buffer length mismatch! Destination size: " + channelData.length + " samples vs expected " + sizeSamplesPerChannel + " samples!"
                        }
                        if (audio.format == 32784) {
                            for (var j = 0; j < sizeSamplesPerChannel; ++j) {
                                channelData[j] = HEAP16[heapPtr + (j * numChannels + c) * 2 >>> 1 >>> 0] / 32768
                            }
                        } else if (audio.format == 8) {
                            for (var j = 0; j < sizeSamplesPerChannel; ++j) {
                                var v = HEAP8[heapPtr + (j * numChannels + c) >>> 0];
                                channelData[j] = (v >= 0 ? v - 128 : v + 128) / 128
                            }
                        } else if (audio.format == 33056) {
                            for (var j = 0; j < sizeSamplesPerChannel; ++j) {
                                channelData[j] = HEAPF32[heapPtr + (j * numChannels + c) * 4 >>> 2 >>> 0]
                            }
                        } else {
                            throw "Invalid SDL audio format " + audio.format + "!"
                        }
                    }
                },
                joystickEventState: 1,
                lastJoystickState: {},
                joystickNamePool: {},
                recordJoystickState(joystick, state) {
                    var buttons = new Array(state.buttons.length);
                    for (var i = 0; i < state.buttons.length; i++) {
                        buttons[i] = SDL.getJoystickButtonState(state.buttons[i])
                    }
                    SDL.lastJoystickState[joystick] = {
                        buttons,
                        axes: state.axes.slice(0),
                        timestamp: state.timestamp,
                        index: state.index,
                        id: state.id
                    }
                },
                getJoystickButtonState(button) {
                    if (typeof button == "object") {
                        return button["pressed"]
                    }
                    return button > 0
                },
                queryJoysticks() {
                    for (var joystick in SDL.lastJoystickState) {
                        var state = SDL.getGamepad(joystick - 1);
                        var prevState = SDL.lastJoystickState[joystick];
                        if (typeof state == "undefined") return;
                        if (state === null) return;
                        if (typeof state.timestamp != "number" || state.timestamp != prevState.timestamp || !state.timestamp) {
                            var i;
                            for (i = 0; i < state.buttons.length; i++) {
                                var buttonState = SDL.getJoystickButtonState(state.buttons[i]);
                                if (buttonState !== prevState.buttons[i]) {
                                    SDL.events.push({
                                        type: buttonState ? "joystick_button_down" : "joystick_button_up",
                                        joystick,
                                        index: joystick - 1,
                                        button: i
                                    })
                                }
                            }
                            for (i = 0; i < state.axes.length; i++) {
                                if (state.axes[i] !== prevState.axes[i]) {
                                    SDL.events.push({
                                        type: "joystick_axis_motion",
                                        joystick,
                                        index: joystick - 1,
                                        axis: i,
                                        value: state.axes[i]
                                    })
                                }
                            }
                            SDL.recordJoystickState(joystick, state)
                        }
                    }
                },
                joystickAxisValueConversion(value) {
                    value = Math.min(1, Math.max(value, -1));
                    return Math.ceil((value + 1) * 32767.5 - 32768)
                },
                getGamepads() {
                    var fcn = navigator.getGamepads || navigator.webkitGamepads || navigator.mozGamepads || navigator.gamepads || navigator.webkitGetGamepads;
                    if (fcn !== undefined) {
                        return fcn.apply(navigator)
                    }
                    return []
                },
                getGamepad(deviceIndex) {
                    var gamepads = SDL.getGamepads();
                    if (gamepads.length > deviceIndex && deviceIndex >= 0) {
                        return gamepads[deviceIndex]
                    }
                    return null
                }
            };

            function _SDL_Linked_Version() {
                if (SDL.version === null) {
                    SDL.version = _malloc(3);
                    HEAP8[SDL.version >>> 0] = 1;
                    HEAP8[SDL.version + 1 >>> 0] = 3;
                    HEAP8[SDL.version + 2 >>> 0] = 0
                }
                return SDL.version
            }
            _SDL_Linked_Version.sig = "p";
            var _SDL_Init = initFlags => {
                SDL.startTime = Date.now();
                SDL.initFlags = initFlags;
                if (!Module["doNotCaptureKeyboard"]) {
                    var keyboardListeningElement = Module["keyboardListeningElement"] || document;
                    keyboardListeningElement.addEventListener("keydown", SDL.receiveEvent);
                    keyboardListeningElement.addEventListener("keyup", SDL.receiveEvent);
                    keyboardListeningElement.addEventListener("keypress", SDL.receiveEvent);
                    window.addEventListener("focus", SDL.receiveEvent);
                    window.addEventListener("blur", SDL.receiveEvent);
                    document.addEventListener("visibilitychange", SDL.receiveEvent)
                }
                window.addEventListener("unload", SDL.receiveEvent);
                SDL.keyboardState = _calloc(65536, 1);
                SDL.DOMEventToSDLEvent["keydown"] = 768;
                SDL.DOMEventToSDLEvent["keyup"] = 769;
                SDL.DOMEventToSDLEvent["keypress"] = 771;
                SDL.DOMEventToSDLEvent["mousedown"] = 1025;
                SDL.DOMEventToSDLEvent["mouseup"] = 1026;
                SDL.DOMEventToSDLEvent["mousemove"] = 1024;
                SDL.DOMEventToSDLEvent["wheel"] = 1027;
                SDL.DOMEventToSDLEvent["touchstart"] = 1792;
                SDL.DOMEventToSDLEvent["touchend"] = 1793;
                SDL.DOMEventToSDLEvent["touchmove"] = 1794;
                SDL.DOMEventToSDLEvent["unload"] = 256;
                SDL.DOMEventToSDLEvent["resize"] = 28673;
                SDL.DOMEventToSDLEvent["visibilitychange"] = 512;
                SDL.DOMEventToSDLEvent["focus"] = 512;
                SDL.DOMEventToSDLEvent["blur"] = 512;
                SDL.DOMEventToSDLEvent["joystick_axis_motion"] = 1536;
                SDL.DOMEventToSDLEvent["joystick_button_down"] = 1539;
                SDL.DOMEventToSDLEvent["joystick_button_up"] = 1540;
                return 0
            };
            _SDL_Init.sig = "ii";
            var _SDL_WasInit = flags => {
                if (SDL.startTime === null) {
                    _SDL_Init(0)
                }
                return 1
            };
            _SDL_WasInit.sig = "ii";

            function _SDL_GetVideoInfo() {
                var ret = _calloc(20, 1);
                HEAP32[ret + 12 >>> 2 >>> 0] = Module["canvas"].width;
                HEAP32[ret + 16 >>> 2 >>> 0] = Module["canvas"].height;
                return ret
            }
            _SDL_GetVideoInfo.sig = "p";

            function _SDL_ListModes(format, flags) {
                format >>>= 0;
                return -1
            }
            _SDL_ListModes.sig = "ppi";
            var _SDL_VideoModeOK = (width, height, depth, flags) => depth;
            _SDL_VideoModeOK.sig = "iiiii";

            function _SDL_VideoDriverName(buf, max_size) {
                buf >>>= 0;
                if (SDL.startTime === null) {
                    return 0
                }
                var driverName = [101, 109, 115, 99, 114, 105, 112, 116, 101, 110, 95, 115, 100, 108, 95, 100, 114, 105, 118, 101, 114];
                var index = 0;
                var size = driverName.length;
                if (max_size <= size) {
                    size = max_size - 1
                }
                while (index < size) {
                    var value = driverName[index];
                    HEAP8[buf + index >>> 0] = value;
                    index++
                }
                HEAP8[buf + index >>> 0] = 0;
                return buf
            }
            _SDL_VideoDriverName.sig = "ppi";
            var _SDL_AudioDriverName = _SDL_VideoDriverName;
            _SDL_AudioDriverName.sig = "ppi";
            var _SDL_SetVideoMode = function(width, height, depth, flags) {
                ["touchstart", "touchend", "touchmove", "mousedown", "mouseup", "mousemove", "mousewheel", "wheel", "mouseout", "DOMMouseScroll"].forEach(e => Module["canvas"].addEventListener(e, SDL.receiveEvent, true));
                var canvas = Module["canvas"];
                if (width == 0 && height == 0) {
                    width = canvas.width;
                    height = canvas.height
                }
                if (!SDL.addedResizeListener) {
                    SDL.addedResizeListener = true;
                    Browser.resizeListeners.push((w, h) => {
                        if (!SDL.settingVideoMode) {
                            SDL.receiveEvent({
                                type: "resize",
                                w,
                                h
                            })
                        }
                    })
                }
                SDL.settingVideoMode = true;
                Browser.setCanvasSize(width, height);
                SDL.settingVideoMode = false;
                if (SDL.screen) {
                    SDL.freeSurface(SDL.screen);
                    assert(!SDL.screen)
                }
                if (SDL.GL) flags = flags | 67108864;
                SDL.screen = SDL.makeSurface(width, height, flags, true, "screen");
                return SDL.screen
            };
            _SDL_SetVideoMode.sig = "piiii";

            function _SDL_GetVideoSurface() {
                return SDL.screen
            }
            _SDL_GetVideoSurface.sig = "p";
            var _SDL_AudioQuit = () => {
                for (var i = 0; i < SDL.numChannels; ++i) {
                    var chan = SDL.channels[i];
                    if (chan.audio) {
                        chan.audio.pause();
                        chan.audio = undefined
                    }
                }
                var audio = SDL.music.audio;
                audio?.pause();
                SDL.music.audio = undefined
            };
            _SDL_AudioQuit.sig = "v";
            var _SDL_VideoQuit = () => out("SDL_VideoQuit called (and ignored)");
            _SDL_VideoQuit.sig = "v";
            var _SDL_QuitSubSystem = flags => out("SDL_QuitSubSystem called (and ignored)");
            _SDL_QuitSubSystem.sig = "vi";
            var _SDL_Quit = () => {
                _SDL_AudioQuit();
                out("SDL_Quit called (and ignored)")
            };
            _SDL_Quit.sig = "v";

            function _SDL_UnlockSurface(surf) {
                surf >>>= 0;
                assert(!SDL.GL);
                var surfData = SDL.surfaces[surf];
                if (!surfData.locked || --surfData.locked > 0) {
                    return
                }
                if (surfData.isFlagSet(2097152)) {
                    SDL.copyIndexedColorData(surfData)
                } else if (!surfData.colors) {
                    var data = surfData.image.data;
                    var buffer = surfData.buffer;
                    assert(buffer % 4 == 0, "Invalid buffer offset: " + buffer);
                    var src = buffer >>> 2;
                    var dst = 0;
                    var isScreen = surf == SDL.screen;
                    var num;
                    if (typeof CanvasPixelArray != "undefined" && data instanceof CanvasPixelArray) {
                        num = data.length;
                        while (dst < num) {
                            var val = HEAP32[src >>> 0];
                            data[dst] = val & 255;
                            data[dst + 1] = val >> 8 & 255;
                            data[dst + 2] = val >> 16 & 255;
                            data[dst + 3] = isScreen ? 255 : val >> 24 & 255;
                            src++;
                            dst += 4
                        }
                    } else {
                        var data32 = new Uint32Array(data.buffer);
                        if (isScreen && SDL.defaults.opaqueFrontBuffer) {
                            num = data32.length;
                            data32.set(HEAP32.subarray(src >>> 0, src + num >>> 0));
                            var data8 = new Uint8Array(data.buffer);
                            var i = 3;
                            var j = i + 4 * num;
                            if (num % 8 == 0) {
                                while (i < j) {
                                    data8[i] = 255;
                                    i = i + 4 | 0;
                                    data8[i] = 255;
                                    i = i + 4 | 0;
                                    data8[i] = 255;
                                    i = i + 4 | 0;
                                    data8[i] = 255;
                                    i = i + 4 | 0;
                                    data8[i] = 255;
                                    i = i + 4 | 0;
                                    data8[i] = 255;
                                    i = i + 4 | 0;
                                    data8[i] = 255;
                                    i = i + 4 | 0;
                                    data8[i] = 255;
                                    i = i + 4 | 0
                                }
                            } else {
                                while (i < j) {
                                    data8[i] = 255;
                                    i = i + 4 | 0
                                }
                            }
                        } else {
                            data32.set(HEAP32.subarray(src >>> 0, src + data32.length >>> 0))
                        }
                    }
                } else {
                    var width = Module["canvas"].width;
                    var height = Module["canvas"].height;
                    var s = surfData.buffer;
                    var data = surfData.image.data;
                    var colors = surfData.colors;
                    for (var y = 0; y < height; y++) {
                        var base = y * width * 4;
                        for (var x = 0; x < width; x++) {
                            var val = HEAPU8[s++ >>> 0] * 4;
                            var start = base + x * 4;
                            data[start] = colors[val];
                            data[start + 1] = colors[val + 1];
                            data[start + 2] = colors[val + 2]
                        }
                        s += width * 3
                    }
                }
                surfData.ctx.putImageData(surfData.image, 0, 0)
            }
            _SDL_UnlockSurface.sig = "vp";

            function _SDL_Flip(surf) {
                surf >>>= 0
            }
            _SDL_Flip.sig = "ip";

            function _SDL_UpdateRect(surf, x, y, w, h) {
                surf >>>= 0
            }
            _SDL_UpdateRect.sig = "vpiiii";

            function _SDL_UpdateRects(surf, numrects, rects) {
                surf >>>= 0;
                rects >>>= 0
            }
            _SDL_UpdateRects.sig = "vpip";
            var _SDL_Delay = delay => {
                if (!ENVIRONMENT_IS_WORKER) abort("SDL_Delay called on the main thread! Potential infinite loop, quitting. (consider building with async support like ASYNCIFY)");
                var now = Date.now();
                while (Date.now() - now < delay) {}
            };
            _SDL_Delay.sig = "vi";

            function _SDL_WM_SetCaption(title, icon) {
                title >>>= 0;
                icon >>>= 0;
                if (title) {
                    _emscripten_set_window_title(title)
                }
                icon &&= UTF8ToString(icon)
            }
            _SDL_WM_SetCaption.sig = "vpp";
            var _SDL_EnableKeyRepeat = (delay, interval) => {};
            _SDL_EnableKeyRepeat.sig = "iii";

            function _SDL_GetKeyboardState(numKeys) {
                numKeys >>>= 0;
                if (numKeys) {
                    HEAP32[numKeys >>> 2 >>> 0] = 65536
                }
                return SDL.keyboardState
            }
            _SDL_GetKeyboardState.sig = "pp";
            var _SDL_GetKeyState = () => _SDL_GetKeyboardState(0);

            function _SDL_GetKeyName(key) {
                SDL.keyName ||= stringToNewUTF8("unknown key");
                return SDL.keyName
            }
            _SDL_GetKeyName.sig = "pi";
            var _SDL_GetModState = () => SDL.modState;
            _SDL_GetModState.sig = "i";

            function _SDL_GetMouseState(x, y) {
                x >>>= 0;
                y >>>= 0;
                if (x) HEAP32[x >>> 2 >>> 0] = Browser.mouseX;
                if (y) HEAP32[y >>> 2 >>> 0] = Browser.mouseY;
                return SDL.buttonState
            }
            _SDL_GetMouseState.sig = "ipp";
            var _SDL_WarpMouse = (x, y) => {};
            _SDL_WarpMouse.sig = "vii";
            var _SDL_ShowCursor = toggle => {
                switch (toggle) {
                    case 0:
                        if (Browser.isFullscreen) {
                            Module["canvas"].requestPointerLock();
                            return 0
                        }
                        return 1;
                    case 1:
                        Module["canvas"].exitPointerLock();
                        return 1;
                    case -1:
                        return !Browser.pointerLock;
                    default:
                        err(`SDL_ShowCursor called with unknown toggle parameter value: ${toggle}`);
                        break
                }
            };
            _SDL_ShowCursor.sig = "ii";

            function _SDL_GetError() {
                SDL.errorMessage ||= stringToNewUTF8("unknown SDL-emscripten error");
                return SDL.errorMessage
            }
            _SDL_GetError.sig = "p";

            function _SDL_SetError(fmt, varargs) {
                fmt >>>= 0;
                varargs >>>= 0
            }
            _SDL_SetError.sig = "vpp";

            function _SDL_CreateRGBSurface(flags, width, height, depth, rmask, gmask, bmask, amask) {
                return SDL.makeSurface(width, height, flags, false, "CreateRGBSurface", rmask, gmask, bmask, amask)
            }
            _SDL_CreateRGBSurface.sig = "piiiiiiii";

            function _SDL_CreateRGBSurfaceFrom(pixels, width, height, depth, pitch, rmask, gmask, bmask, amask) {
                pixels >>>= 0;
                var surf = SDL.makeSurface(width, height, 0, false, "CreateRGBSurfaceFrom", rmask, gmask, bmask, amask);
                if (depth !== 32) {
                    err("TODO: Partially unimplemented SDL_CreateRGBSurfaceFrom called!");
                    return surf
                }
                var data = SDL.surfaces[surf];
                var image = data.ctx.createImageData(width, height);
                var pitchOfDst = width * 4;
                for (var row = 0; row < height; ++row) {
                    var baseOfSrc = row * pitch;
                    var baseOfDst = row * pitchOfDst;
                    for (var col = 0; col < width * 4; ++col) {
                        image.data[baseOfDst + col] = HEAPU8[pixels + (baseOfDst + col) >>> 0]
                    }
                }
                data.ctx.putImageData(image, 0, 0);
                return surf
            }
            _SDL_CreateRGBSurfaceFrom.sig = "ppiiiiiiii";

            function _SDL_ConvertSurface(surf, format, flags) {
                surf >>>= 0;
                format >>>= 0;
                if (format) {
                    SDL.checkPixelFormat(format)
                }
                var oldData = SDL.surfaces[surf];
                var ret = SDL.makeSurface(oldData.width, oldData.height, oldData.flags, false, "copy:" + oldData.source);
                var newData = SDL.surfaces[ret];
                newData.ctx.globalCompositeOperation = "copy";
                newData.ctx.drawImage(oldData.canvas, 0, 0);
                newData.ctx.globalCompositeOperation = oldData.ctx.globalCompositeOperation;
                return ret
            }
            _SDL_ConvertSurface.sig = "pppi";

            function _SDL_DisplayFormatAlpha(surf) {
                surf >>>= 0;
                return _SDL_ConvertSurface(surf, 0, 0)
            }
            _SDL_DisplayFormatAlpha.sig = "pp";

            function _SDL_FreeSurface(surf) {
                surf >>>= 0;
                if (surf) SDL.freeSurface(surf)
            }
            _SDL_FreeSurface.sig = "vp";

            function _SDL_UpperBlit(src, srcrect, dst, dstrect) {
                src >>>= 0;
                srcrect >>>= 0;
                dst >>>= 0;
                dstrect >>>= 0;
                return SDL.blitSurface(src, srcrect, dst, dstrect, false)
            }
            _SDL_UpperBlit.sig = "ipppp";

            function _SDL_UpperBlitScaled(src, srcrect, dst, dstrect) {
                src >>>= 0;
                srcrect >>>= 0;
                dst >>>= 0;
                dstrect >>>= 0;
                return SDL.blitSurface(src, srcrect, dst, dstrect, true)
            }
            _SDL_UpperBlitScaled.sig = "ipppp";
            var _SDL_LowerBlit = _SDL_UpperBlit;
            _SDL_LowerBlit.sig = "ipppp";
            var _SDL_LowerBlitScaled = _SDL_UpperBlitScaled;
            _SDL_LowerBlitScaled.sig = "ipppp";

            function _SDL_GetClipRect(surf, rect) {
                surf >>>= 0;
                rect >>>= 0;
                assert(rect);
                var surfData = SDL.surfaces[surf];
                var r = surfData.clipRect || {
                    x: 0,
                    y: 0,
                    w: surfData.width,
                    h: surfData.height
                };
                SDL.updateRect(rect, r)
            }
            _SDL_GetClipRect.sig = "vpp";

            function _SDL_SetClipRect(surf, rect) {
                surf >>>= 0;
                rect >>>= 0;
                var surfData = SDL.surfaces[surf];
                if (rect) {
                    surfData.clipRect = SDL.intersectionOfRects({
                        x: 0,
                        y: 0,
                        w: surfData.width,
                        h: surfData.height
                    }, SDL.loadRect(rect))
                } else {
                    delete surfData.clipRect
                }
            }
            _SDL_SetClipRect.sig = "ipp";

            function _SDL_FillRect(surf, rect, color) {
                surf >>>= 0;
                rect >>>= 0;
                var surfData = SDL.surfaces[surf];
                assert(!surfData.locked);
                if (surfData.isFlagSet(2097152)) {
                    color = surfData.colors32[color]
                }
                var r = rect ? SDL.loadRect(rect) : {
                    x: 0,
                    y: 0,
                    w: surfData.width,
                    h: surfData.height
                };
                if (surfData.clipRect) {
                    r = SDL.intersectionOfRects(surfData.clipRect, r);
                    if (rect) {
                        SDL.updateRect(rect, r)
                    }
                }
                surfData.ctx.save();
                surfData.ctx.fillStyle = SDL.translateColorToCSSRGBA(color);
                surfData.ctx.fillRect(r.x, r.y, r.w, r.h);
                surfData.ctx.restore();
                return 0
            }
            _SDL_FillRect.sig = "ippi";

            function _zoomSurface(src, x, y, smooth) {
                src >>>= 0;
                var srcData = SDL.surfaces[src];
                var w = srcData.width * x;
                var h = srcData.height * y;
                var ret = SDL.makeSurface(Math.abs(w), Math.abs(h), srcData.flags, false, "zoomSurface");
                var dstData = SDL.surfaces[ret];
                if (x >= 0 && y >= 0) dstData.ctx.drawImage(srcData.canvas, 0, 0, w, h);
                else {
                    dstData.ctx.save();
                    dstData.ctx.scale(x < 0 ? -1 : 1, y < 0 ? -1 : 1);
                    dstData.ctx.drawImage(srcData.canvas, w < 0 ? w : 0, h < 0 ? h : 0, Math.abs(w), Math.abs(h));
                    dstData.ctx.restore()
                }
                return ret
            }
            _zoomSurface.sig = "ppddi";

            function _rotozoomSurface(src, angle, zoom, smooth) {
                src >>>= 0;
                if (angle % 360 === 0) {
                    return _zoomSurface(src, zoom, zoom, smooth)
                }
                var srcData = SDL.surfaces[src];
                var w = srcData.width * zoom;
                var h = srcData.height * zoom;
                var diagonal = Math.ceil(Math.sqrt(Math.pow(w, 2) + Math.pow(h, 2)));
                var ret = SDL.makeSurface(diagonal, diagonal, srcData.flags, false, "rotozoomSurface");
                var dstData = SDL.surfaces[ret];
                dstData.ctx.translate(diagonal / 2, diagonal / 2);
                dstData.ctx.rotate(-angle * Math.PI / 180);
                dstData.ctx.drawImage(srcData.canvas, -w / 2, -h / 2, w, h);
                return ret
            }
            _rotozoomSurface.sig = "ppddi";

            function _SDL_SetAlpha(surf, flag, alpha) {
                surf >>>= 0;
                var surfData = SDL.surfaces[surf];
                surfData.alpha = alpha;
                if (!(flag & 65536)) {
                    surfData.alpha = 255
                }
            }
            _SDL_SetAlpha.sig = "ipii";

            function _SDL_SetColorKey(surf, flag, key) {
                surf >>>= 0;
                warnOnce("SDL_SetColorKey is a no-op for performance reasons");
                return 0
            }
            _SDL_SetColorKey.sig = "ipii";

            function _SDL_PollEvent(ptr) {
                ptr >>>= 0;
                return SDL.pollEvent(ptr)
            }
            _SDL_PollEvent.sig = "ip";

            function _SDL_PushEvent(ptr) {
                ptr >>>= 0;
                var copy = _malloc(28);
                _memcpy(copy, ptr, 28);
                SDL.events.push(copy);
                return 0
            }
            _SDL_PushEvent.sig = "ip";

            function _SDL_PeepEvents(events, requestedEventCount, action, from, to) {
                events >>>= 0;
                switch (action) {
                    case 2: {
                        assert(requestedEventCount == 1);
                        var index = 0;
                        var retrievedEventCount = 0;
                        while (index < SDL.events.length && retrievedEventCount < requestedEventCount) {
                            var event = SDL.events[index];
                            var type = SDL.DOMEventToSDLEvent[event.type];
                            if (from <= type && type <= to) {
                                if (SDL.makeCEvent(event, events) === false) {
                                    index++
                                } else {
                                    SDL.events.splice(index, 1);
                                    retrievedEventCount++
                                }
                            } else {
                                index++
                            }
                        }
                        return retrievedEventCount
                    }
                    default:
                        throw "SDL_PeepEvents does not yet support that action: " + action
                }
            }
            _SDL_PeepEvents.sig = "ipiiii";
            var _SDL_PumpEvents = () => SDL.events.forEach(SDL.handleEvent);
            _SDL_PumpEvents.sig = "v";

            function _emscripten_SDL_SetEventHandler(handler, userdata) {
                handler >>>= 0;
                userdata >>>= 0;
                SDL.eventHandler = handler;
                SDL.eventHandlerContext = userdata;
                SDL.eventHandlerTemp ||= _malloc(28)
            }
            _emscripten_SDL_SetEventHandler.sig = "vpp";

            function _SDL_SetColors(surf, colors, firstColor, nColors) {
                surf >>>= 0;
                colors >>>= 0;
                var surfData = SDL.surfaces[surf];
                if (!surfData.colors) {
                    var buffer = new ArrayBuffer(256 * 4);
                    surfData.colors = new Uint8Array(buffer);
                    surfData.colors32 = new Uint32Array(buffer)
                }
                for (var i = 0; i < nColors; ++i) {
                    var index = (firstColor + i) * 4;
                    surfData.colors[index] = HEAPU8[colors + i * 4 >>> 0];
                    surfData.colors[index + 1] = HEAPU8[colors + (i * 4 + 1) >>> 0];
                    surfData.colors[index + 2] = HEAPU8[colors + (i * 4 + 2) >>> 0];
                    surfData.colors[index + 3] = 255
                }
                return 1
            }
            _SDL_SetColors.sig = "ippii";

            function _SDL_SetPalette(surf, flags, colors, firstColor, nColors) {
                surf >>>= 0;
                colors >>>= 0;
                return _SDL_SetColors(surf, colors, firstColor, nColors)
            }
            _SDL_SetPalette.sig = "ipipii";

            function _SDL_MapRGB(fmt, r, g, b) {
                fmt >>>= 0;
                SDL.checkPixelFormat(fmt);
                return r & 255 | (g & 255) << 8 | (b & 255) << 16 | 4278190080
            }
            _SDL_MapRGB.sig = "ipiii";

            function _SDL_MapRGBA(fmt, r, g, b, a) {
                fmt >>>= 0;
                SDL.checkPixelFormat(fmt);
                return r & 255 | (g & 255) << 8 | (b & 255) << 16 | (a & 255) << 24
            }
            _SDL_MapRGBA.sig = "ipiiii";

            function _SDL_GetRGB(pixel, fmt, r, g, b) {
                fmt >>>= 0;
                r >>>= 0;
                g >>>= 0;
                b >>>= 0;
                SDL.checkPixelFormat(fmt);
                if (r) {
                    HEAP8[r >>> 0] = pixel & 255
                }
                if (g) {
                    HEAP8[g >>> 0] = pixel >> 8 & 255
                }
                if (b) {
                    HEAP8[b >>> 0] = pixel >> 16 & 255
                }
            }
            _SDL_GetRGB.sig = "vipppp";

            function _SDL_GetRGBA(pixel, fmt, r, g, b, a) {
                fmt >>>= 0;
                r >>>= 0;
                g >>>= 0;
                b >>>= 0;
                a >>>= 0;
                SDL.checkPixelFormat(fmt);
                if (r) {
                    HEAP8[r >>> 0] = pixel & 255
                }
                if (g) {
                    HEAP8[g >>> 0] = pixel >> 8 & 255
                }
                if (b) {
                    HEAP8[b >>> 0] = pixel >> 16 & 255
                }
                if (a) {
                    HEAP8[a >>> 0] = pixel >> 24 & 255
                }
            }
            _SDL_GetRGBA.sig = "vippppp";
            var _SDL_GetAppState = () => {
                var state = 0;
                if (Browser.pointerLock) {
                    state |= 1
                }
                if (document.hasFocus()) {
                    state |= 2
                }
                state |= 4;
                return state
            };
            _SDL_GetAppState.sig = "i";
            var _SDL_WM_GrabInput = () => {};
            _SDL_WM_GrabInput.sig = "ii";

            function _SDL_WM_ToggleFullScreen(surf) {
                surf >>>= 0;
                if (Browser.exitFullscreen()) {
                    return 1
                }
                if (!SDL.canRequestFullscreen) {
                    return 0
                }
                SDL.isRequestingFullscreen = true;
                return 1
            }
            _SDL_WM_ToggleFullScreen.sig = "ip";
            var _IMG_Init = flags => flags;
            _IMG_Init.sig = "ii";

            function _SDL_FreeRW(rwopsID) {
                rwopsID >>>= 0;
                SDL.rwops[rwopsID] = null;
                while (SDL.rwops.length > 0 && SDL.rwops[SDL.rwops.length - 1] === null) {
                    SDL.rwops.pop()
                }
            }
            _SDL_FreeRW.sig = "vp";
            var _IMG_Load_RW = function(rwopsID, freeSrc) {
                rwopsID >>>= 0;
                var sp = stackSave();
                try {
                    var cleanup = () => {
                        stackRestore(sp);
                        if (rwops && freeSrc) _SDL_FreeRW(rwopsID)
                    };
                    var addCleanup = func => {
                        var old = cleanup;
                        cleanup = () => {
                            old();
                            func()
                        }
                    };
                    var callStbImage = (func, params) => {
                        var x = stackAlloc(4);
                        var y = stackAlloc(4);
                        var comp = stackAlloc(4);
                        var data = Module["_" + func](...params, x, y, comp, 0);
                        if (!data) return null;
                        addCleanup(() => Module["_stbi_image_free"](data));
                        return {
                            rawData: true,
                            data,
                            width: HEAP32[x >>> 2 >>> 0],
                            height: HEAP32[y >>> 2 >>> 0],
                            size: HEAP32[x >>> 2 >>> 0] * HEAP32[y >>> 2 >>> 0] * HEAP32[comp >>> 2 >>> 0],
                            bpp: HEAP32[comp >>> 2 >>> 0]
                        }
                    };
                    var rwops = SDL.rwops[rwopsID];
                    if (rwops === undefined) {
                        return 0
                    }
                    var raw;
                    var filename = rwops.filename;
                    if (filename === undefined) {
                        warnOnce("Only file names that have been preloaded are supported for IMG_Load_RW. Consider using STB_IMAGE=1 if you want synchronous image decoding (see settings.js), or package files with --use-preload-plugins");
                        return 0
                    }
                    if (!raw) {
                        filename = PATH_FS.resolve(filename);
                        raw = preloadedImages[filename];
                        if (!raw) {
                            if (raw === null) err("Trying to reuse preloaded image, but freePreloadedMediaOnUse is set!");
                            warnOnce("Cannot find preloaded image " + filename);
                            warnOnce("Cannot find preloaded image " + filename + ". Consider using STB_IMAGE=1 if you want synchronous image decoding (see settings.js), or package files with --use-preload-plugins");
                            return 0
                        } else if (Module["freePreloadedMediaOnUse"]) {
                            preloadedImages[filename] = null
                        }
                    }
                    var surf = SDL.makeSurface(raw.width, raw.height, 0, false, "load:" + filename);
                    var surfData = SDL.surfaces[surf];
                    surfData.ctx.globalCompositeOperation = "copy";
                    if (!raw.rawData) {
                        surfData.ctx.drawImage(raw, 0, 0, raw.width, raw.height, 0, 0, raw.width, raw.height)
                    } else {
                        var imageData = surfData.ctx.getImageData(0, 0, surfData.width, surfData.height);
                        if (raw.bpp == 4) {
                            imageData.data.set(HEAPU8.subarray(raw.data >>> 0, raw.data + raw.size >>> 0))
                        } else if (raw.bpp == 3) {
                            var pixels = raw.size / 3;
                            var data = imageData.data;
                            var sourcePtr = raw.data;
                            var destPtr = 0;
                            for (var i = 0; i < pixels; i++) {
                                data[destPtr++] = HEAPU8[sourcePtr++ >>> 0];
                                data[destPtr++] = HEAPU8[sourcePtr++ >>> 0];
                                data[destPtr++] = HEAPU8[sourcePtr++ >>> 0];
                                data[destPtr++] = 255
                            }
                        } else if (raw.bpp == 2) {
                            var pixels = raw.size;
                            var data = imageData.data;
                            var sourcePtr = raw.data;
                            var destPtr = 0;
                            for (var i = 0; i < pixels; i++) {
                                var gray = HEAPU8[sourcePtr++ >>> 0];
                                var alpha = HEAPU8[sourcePtr++ >>> 0];
                                data[destPtr++] = gray;
                                data[destPtr++] = gray;
                                data[destPtr++] = gray;
                                data[destPtr++] = alpha
                            }
                        } else if (raw.bpp == 1) {
                            var pixels = raw.size;
                            var data = imageData.data;
                            var sourcePtr = raw.data;
                            var destPtr = 0;
                            for (var i = 0; i < pixels; i++) {
                                var value = HEAPU8[sourcePtr++ >>> 0];
                                data[destPtr++] = value;
                                data[destPtr++] = value;
                                data[destPtr++] = value;
                                data[destPtr++] = 255
                            }
                        } else {
                            err(`cannot handle bpp ${raw.bpp}`);
                            return 0
                        }
                        surfData.ctx.putImageData(imageData, 0, 0)
                    }
                    surfData.ctx.globalCompositeOperation = "source-over";
                    _SDL_LockSurface(surf);
                    surfData.locked--;
                    if (SDL.GL) {
                        surfData.canvas = surfData.ctx = null
                    }
                    return surf
                } finally {
                    cleanup()
                }
            };
            _IMG_Load_RW.sig = "ppi";
            var _SDL_LoadBMP_RW = _IMG_Load_RW;
            _SDL_LoadBMP_RW.sig = "ppi";

            function _SDL_RWFromFile(_name, mode) {
                _name >>>= 0;
                mode >>>= 0;
                var id = SDL.rwops.length;
                var filename = UTF8ToString(_name);
                SDL.rwops.push({
                    filename,
                    mimetype: Browser.getMimetype(filename)
                });
                return id
            }
            _SDL_RWFromFile.sig = "ppp";

            function _IMG_Load(filename) {
                filename >>>= 0;
                var rwops = _SDL_RWFromFile(filename, 0);
                var result = _IMG_Load_RW(rwops, 1);
                return result
            }
            _IMG_Load.sig = "pp";
            var _IMG_Quit = () => out("IMG_Quit called (and ignored)");
            _IMG_Quit.sig = "v";

            function _SDL_OpenAudio(desired, obtained) {
                desired >>>= 0;
                obtained >>>= 0;
                try {
                    SDL.audio = {
                        freq: HEAPU32[desired >>> 2 >>> 0],
                        format: HEAPU16[desired + 4 >>> 1 >>> 0],
                        channels: HEAPU8[desired + 6 >>> 0],
                        samples: HEAPU16[desired + 8 >>> 1 >>> 0],
                        callback: HEAPU32[desired + 16 >>> 2 >>> 0],
                        userdata: HEAPU32[desired + 20 >>> 2 >>> 0],
                        paused: true,
                        timer: null
                    };
                    if (SDL.audio.format == 8) {
                        SDL.audio.silence = 128
                    } else if (SDL.audio.format == 32784) {
                        SDL.audio.silence = 0
                    } else if (SDL.audio.format == 33056) {
                        SDL.audio.silence = 0
                    } else {
                        throw "Invalid SDL audio format " + SDL.audio.format + "!"
                    }
                    if (SDL.audio.freq <= 0) {
                        throw "Unsupported sound frequency " + SDL.audio.freq + "!"
                    } else if (SDL.audio.freq <= 22050) {
                        SDL.audio.freq = 22050
                    } else if (SDL.audio.freq <= 32e3) {
                        SDL.audio.freq = 32e3
                    } else if (SDL.audio.freq <= 44100) {
                        SDL.audio.freq = 44100
                    } else if (SDL.audio.freq <= 48e3) {
                        SDL.audio.freq = 48e3
                    } else if (SDL.audio.freq <= 96e3) {
                        SDL.audio.freq = 96e3
                    } else {
                        throw `Unsupported sound frequency ${SDL.audio.freq}!`
                    }
                    if (SDL.audio.channels == 0) {
                        SDL.audio.channels = 1
                    } else if (SDL.audio.channels < 0 || SDL.audio.channels > 32) {
                        throw `Unsupported number of audio channels for SDL audio: ${SDL.audio.channels}!`
                    } else if (SDL.audio.channels != 1 && SDL.audio.channels != 2) {
                        out(`Warning: Using untested number of audio channels ${SDL.audio.channels}`)
                    }
                    if (SDL.audio.samples < 128 || SDL.audio.samples > 524288) {
                        throw `Unsupported audio callback buffer size ${SDL.audio.samples}!`
                    } else if ((SDL.audio.samples & SDL.audio.samples - 1) != 0) {
                        throw `Audio callback buffer size ${SDL.audio.samples} must be a power-of-two!`
                    }
                    var totalSamples = SDL.audio.samples * SDL.audio.channels;
                    if (SDL.audio.format == 8) {
                        SDL.audio.bytesPerSample = 1
                    } else if (SDL.audio.format == 32784) {
                        SDL.audio.bytesPerSample = 2
                    } else if (SDL.audio.format == 33056) {
                        SDL.audio.bytesPerSample = 4
                    } else {
                        throw `Invalid SDL audio format ${SDL.audio.format}!`
                    }
                    SDL.audio.bufferSize = totalSamples * SDL.audio.bytesPerSample;
                    SDL.audio.bufferDurationSecs = SDL.audio.bufferSize / SDL.audio.bytesPerSample / SDL.audio.channels / SDL.audio.freq;
                    SDL.audio.bufferingDelay = 50 / 1e3;
                    SDL.audio.buffer = _malloc(SDL.audio.bufferSize);
                    SDL.audio.numSimultaneouslyQueuedBuffers = Module["SDL_numSimultaneouslyQueuedBuffers"] || 5;
                    SDL.audio.queueNewAudioData = () => {
                        if (!SDL.audio) return;
                        for (var i = 0; i < SDL.audio.numSimultaneouslyQueuedBuffers; ++i) {
                            var secsUntilNextPlayStart = SDL.audio.nextPlayTime - SDL.audioContext["currentTime"];
                            if (secsUntilNextPlayStart >= SDL.audio.bufferingDelay + SDL.audio.bufferDurationSecs * SDL.audio.numSimultaneouslyQueuedBuffers) return;
                            getWasmTableEntry(SDL.audio.callback)(SDL.audio.userdata, SDL.audio.buffer, SDL.audio.bufferSize);
                            SDL.audio.pushAudio(SDL.audio.buffer, SDL.audio.bufferSize)
                        }
                    };
                    SDL.audio.caller = () => {
                        if (!SDL.audio) return;
                        --SDL.audio.numAudioTimersPending;
                        SDL.audio.queueNewAudioData();
                        var secsUntilNextPlayStart = SDL.audio.nextPlayTime - SDL.audioContext["currentTime"];
                        var preemptBufferFeedSecs = SDL.audio.bufferDurationSecs / 2;
                        if (SDL.audio.numAudioTimersPending < SDL.audio.numSimultaneouslyQueuedBuffers) {
                            ++SDL.audio.numAudioTimersPending;
                            SDL.audio.timer = safeSetTimeout(SDL.audio.caller, Math.max(0, 1e3 * (secsUntilNextPlayStart - preemptBufferFeedSecs)));
                            if (SDL.audio.numAudioTimersPending < SDL.audio.numSimultaneouslyQueuedBuffers) {
                                ++SDL.audio.numAudioTimersPending;
                                safeSetTimeout(SDL.audio.caller, 1)
                            }
                        }
                    };
                    SDL.audio.audioOutput = new Audio;
                    SDL.openAudioContext();
                    if (!SDL.audioContext) throw "Web Audio API is not available!";
                    autoResumeAudioContext(SDL.audioContext);
                    SDL.audio.nextPlayTime = 0;
                    SDL.audio.pushAudio = (ptr, sizeBytes) => {
                        try {
                            if (SDL.audio.paused) return;
                            var sizeSamples = sizeBytes / SDL.audio.bytesPerSample;
                            var sizeSamplesPerChannel = sizeSamples / SDL.audio.channels;
                            if (sizeSamplesPerChannel != SDL.audio.samples) {
                                throw "Received mismatching audio buffer size!"
                            }
                            var source = SDL.audioContext["createBufferSource"]();
                            var soundBuffer = SDL.audioContext["createBuffer"](SDL.audio.channels, sizeSamplesPerChannel, SDL.audio.freq);
                            source["connect"](SDL.audioContext["destination"]);
                            SDL.fillWebAudioBufferFromHeap(ptr, sizeSamplesPerChannel, soundBuffer);
                            source["buffer"] = soundBuffer;
                            var curtime = SDL.audioContext["currentTime"];
                            var playtime = Math.max(curtime + SDL.audio.bufferingDelay, SDL.audio.nextPlayTime);
                            if (typeof source["start"] != "undefined") {
                                source["start"](playtime)
                            } else if (typeof source["noteOn"] != "undefined") {
                                source["noteOn"](playtime)
                            }
                            SDL.audio.nextPlayTime = playtime + SDL.audio.bufferDurationSecs
                        } catch (e) {
                            err(`Web Audio API error playing back audio: ${e.toString()}`)
                        }
                    };
                    if (obtained) {
                        HEAP32[obtained >>> 2 >>> 0] = SDL.audio.freq;
                        HEAP16[obtained + 4 >>> 1 >>> 0] = SDL.audio.format;
                        HEAP8[obtained + 6 >>> 0] = SDL.audio.channels;
                        HEAP8[obtained + 7 >>> 0] = SDL.audio.silence;
                        HEAP16[obtained + 8 >>> 1 >>> 0] = SDL.audio.samples;
                        HEAPU32[obtained + 16 >>> 2 >>> 0] = SDL.audio.callback;
                        HEAPU32[obtained + 20 >>> 2 >>> 0] = SDL.audio.userdata
                    }
                    SDL.allocateChannels(32)
                } catch (e) {
                    err(`Initializing SDL audio threw an exception: "${e.toString()}"! Continuing without audio`);
                    SDL.audio = null;
                    SDL.allocateChannels(0);
                    if (obtained) {
                        HEAP32[obtained >>> 2 >>> 0] = 0;
                        HEAP16[obtained + 4 >>> 1 >>> 0] = 0;
                        HEAP8[obtained + 6 >>> 0] = 0;
                        HEAP8[obtained + 7 >>> 0] = 0;
                        HEAP16[obtained + 8 >>> 1 >>> 0] = 0;
                        HEAPU32[obtained + 16 >>> 2 >>> 0] = 0;
                        HEAPU32[obtained + 20 >>> 2 >>> 0] = 0
                    }
                }
                if (!SDL.audio) {
                    return -1
                }
                return 0
            }
            _SDL_OpenAudio.sig = "ipp";
            var _SDL_PauseAudio = pauseOn => {
                if (!SDL.audio) {
                    return
                }
                if (pauseOn) {
                    if (SDL.audio.timer !== undefined) {
                        clearTimeout(SDL.audio.timer);
                        SDL.audio.numAudioTimersPending = 0;
                        SDL.audio.timer = undefined
                    }
                } else if (!SDL.audio.timer) {
                    SDL.audio.numAudioTimersPending = 1;
                    SDL.audio.timer = safeSetTimeout(SDL.audio.caller, 1)
                }
                SDL.audio.paused = pauseOn
            };
            _SDL_PauseAudio.sig = "vi";
            var _SDL_CloseAudio = () => {
                if (SDL.audio) {
                    if (SDL.audio.callbackRemover) {
                        SDL.audio.callbackRemover();
                        SDL.audio.callbackRemover = null
                    }
                    _SDL_PauseAudio(1);
                    _free(SDL.audio.buffer);
                    SDL.audio = null;
                    SDL.allocateChannels(0)
                }
            };
            _SDL_CloseAudio.sig = "v";
            var _SDL_LockAudio = () => {};
            _SDL_LockAudio.sig = "v";
            var _SDL_UnlockAudio = () => {};
            _SDL_UnlockAudio.sig = "v";

            function _SDL_CreateMutex() {
                return 0
            }
            _SDL_CreateMutex.sig = "p";

            function _SDL_mutexP(mutex) {
                mutex >>>= 0;
                return 0
            }
            _SDL_mutexP.sig = "ip";

            function _SDL_mutexV(mutex) {
                mutex >>>= 0;
                return 0
            }
            _SDL_mutexV.sig = "ip";

            function _SDL_DestroyMutex(mutex) {
                mutex >>>= 0
            }
            _SDL_DestroyMutex.sig = "vp";

            function _SDL_CreateCond() {
                return 0
            }
            _SDL_CreateCond.sig = "p";

            function _SDL_CondSignal(cond) {
                cond >>>= 0
            }
            _SDL_CondSignal.sig = "ip";

            function _SDL_CondWait(cond, mutex) {
                cond >>>= 0;
                mutex >>>= 0
            }
            _SDL_CondWait.sig = "ipp";

            function _SDL_DestroyCond(cond) {
                cond >>>= 0
            }
            _SDL_DestroyCond.sig = "vp";
            var _SDL_StartTextInput = () => {
                SDL.textInput = true
            };
            _SDL_StartTextInput.sig = "v";
            var _SDL_StopTextInput = () => {
                SDL.textInput = false
            };
            _SDL_StopTextInput.sig = "v";
            var _Mix_Init = flags => {
                if (!flags) return 0;
                return 8
            };
            _Mix_Init.sig = "ii";
            var _Mix_Quit = () => {};
            _Mix_Quit.sig = "v";
            var _Mix_OpenAudio = (frequency, format, channels, chunksize) => {
                SDL.openAudioContext();
                autoResumeAudioContext(SDL.audioContext);
                SDL.allocateChannels(32);
                SDL.mixerFrequency = frequency;
                SDL.mixerFormat = format;
                SDL.mixerNumChannels = channels;
                SDL.mixerChunkSize = chunksize;
                return 0
            };
            _Mix_OpenAudio.sig = "iiiii";
            var _Mix_CloseAudio = _SDL_CloseAudio;
            _Mix_CloseAudio.sig = "v";
            var _Mix_AllocateChannels = num => {
                SDL.allocateChannels(num);
                return num
            };
            _Mix_AllocateChannels.sig = "ii";

            function _Mix_ChannelFinished(func) {
                func >>>= 0;
                SDL.channelFinished = func
            }
            _Mix_ChannelFinished.sig = "vp";
            var _Mix_Volume = (channel, volume) => {
                if (channel == -1) {
                    for (var i = 0; i < SDL.numChannels - 1; i++) {
                        _Mix_Volume(i, volume)
                    }
                    return _Mix_Volume(SDL.numChannels - 1, volume)
                }
                return SDL.setGetVolume(SDL.channels[channel], volume)
            };
            _Mix_Volume.sig = "iii";
            var _Mix_SetPanning = (channel, left, right) => {
                left /= 255;
                right /= 255;
                SDL.setPannerPosition(SDL.channels[channel], right - left, 0, .1);
                return 1
            };
            _Mix_SetPanning.sig = "iiii";

            function _Mix_LoadWAV_RW(rwopsID, freesrc) {
                rwopsID >>>= 0;
                var rwops = SDL.rwops[rwopsID];
                if (rwops === undefined) return 0;
                var filename = "";
                var audio;
                var webAudio;
                var bytes;
                if (rwops.filename !== undefined) {
                    filename = PATH_FS.resolve(rwops.filename);
                    var raw = preloadedAudios[filename];
                    if (!raw) {
                        if (raw === null) err("Trying to reuse preloaded audio, but freePreloadedMediaOnUse is set!");
                        if (!Module["noAudioDecoding"]) warnOnce("Cannot find preloaded audio " + filename);
                        try {
                            bytes = FS.readFile(filename)
                        } catch (e) {
                            err(`Couldn't find file for: ${filename}`);
                            return 0
                        }
                    }
                    if (Module["freePreloadedMediaOnUse"]) {
                        preloadedAudios[filename] = null
                    }
                    audio = raw
                } else if (rwops.bytes !== undefined) {
                    if (SDL.webAudioAvailable()) bytes = HEAPU8.buffer.slice(rwops.bytes, rwops.bytes + rwops.count);
                    else bytes = HEAPU8.subarray(rwops.bytes >>> 0, rwops.bytes + rwops.count >>> 0)
                } else {
                    return 0
                }
                var arrayBuffer = bytes ? bytes.buffer || bytes : bytes;
                var canPlayWithWebAudio = Module["SDL_canPlayWithWebAudio"] === undefined || Module["SDL_canPlayWithWebAudio"](filename, arrayBuffer);
                if (bytes !== undefined && SDL.webAudioAvailable() && canPlayWithWebAudio) {
                    audio = undefined;
                    webAudio = {};
                    webAudio.onDecodeComplete = [];
                    var onDecodeComplete = data => {
                        webAudio.decodedBuffer = data;
                        webAudio.onDecodeComplete.forEach(e => e());
                        webAudio.onDecodeComplete = undefined
                    };
                    SDL.audioContext["decodeAudioData"](arrayBuffer, onDecodeComplete)
                } else if (audio === undefined && bytes) {
                    var blob = new Blob([bytes], {
                        type: rwops.mimetype
                    });
                    var url = URL.createObjectURL(blob);
                    audio = new Audio;
                    audio.src = url;
                    audio.mozAudioChannelType = "content"
                }
                var id = SDL.audios.length;
                SDL.audios.push({
                    source: filename,
                    audio,
                    webAudio
                });
                return id
            }
            _Mix_LoadWAV_RW.sig = "ppi";

            function _Mix_LoadWAV(filename) {
                filename >>>= 0;
                var rwops = _SDL_RWFromFile(filename, 0);
                var result = _Mix_LoadWAV_RW(rwops, 0);
                _SDL_FreeRW(rwops);
                return result
            }
            _Mix_LoadWAV.sig = "pp";

            function _Mix_QuickLoad_RAW(mem, len) {
                mem >>>= 0;
                var audio;
                var webAudio;
                var numSamples = len >> 1;
                var buffer = new Float32Array(numSamples);
                for (var i = 0; i < numSamples; ++i) {
                    buffer[i] = HEAP16[mem + i * 2 >>> 1 >>> 0] / 32768
                }
                if (SDL.webAudioAvailable()) {
                    webAudio = {};
                    webAudio.decodedBuffer = buffer
                } else {
                    audio = new Audio;
                    audio.mozAudioChannelType = "content";
                    audio.numChannels = SDL.mixerNumChannels;
                    audio.frequency = SDL.mixerFrequency
                }
                var id = SDL.audios.length;
                SDL.audios.push({
                    source: "",
                    audio,
                    webAudio,
                    buffer
                });
                return id
            }
            _Mix_QuickLoad_RAW.sig = "ppi";

            function _Mix_FreeChunk(id) {
                id >>>= 0;
                SDL.audios[id] = null
            }
            _Mix_FreeChunk.sig = "vp";
            var _Mix_ReserveChannels = num => {
                SDL.channelMinimumNumber = num
            };
            _Mix_ReserveChannels.sig = "ii";
            var _Mix_HaltChannel = channel => {
                function halt(channel) {
                    var info = SDL.channels[channel];
                    if (info.audio) {
                        info.audio.pause();
                        info.audio = null
                    }
                    if (SDL.channelFinished) {
                        getWasmTableEntry(SDL.channelFinished)(channel)
                    }
                }
                if (channel != -1) {
                    halt(channel)
                } else {
                    for (var i = 0; i < SDL.channels.length; ++i) halt(i)
                }
                return 0
            };
            _Mix_HaltChannel.sig = "ii";

            function _Mix_PlayChannelTimed(channel, id, loops, ticks) {
                id >>>= 0;
                assert(ticks == -1);
                var info = SDL.audios[id];
                if (!info) return -1;
                if (!info.audio && !info.webAudio) return -1;
                if (channel == -1) {
                    for (var i = SDL.channelMinimumNumber; i < SDL.numChannels; i++) {
                        if (!SDL.channels[i].audio) {
                            channel = i;
                            break
                        }
                    }
                    if (channel == -1) {
                        err(`All ${SDL.numChannels}  channels in use!`);
                        return -1
                    }
                }
                var channelInfo = SDL.channels[channel];
                var audio;
                if (info.webAudio) {
                    audio = {};
                    audio.resource = info;
                    audio.paused = false;
                    audio.currentPosition = 0;
                    audio.play = function() {
                        SDL.playWebAudio(this)
                    };
                    audio.pause = function() {
                        SDL.pauseWebAudio(this)
                    }
                } else {
                    audio = info.audio.cloneNode(true);
                    audio.numChannels = info.audio.numChannels;
                    audio.frequency = info.audio.frequency
                }
                audio["onended"] = function() {
                    if (channelInfo.audio === this || channelInfo.audio.webAudioNode === this) {
                        channelInfo.audio.paused = true;
                        channelInfo.audio = null
                    }
                    if (SDL.channelFinished) getWasmTableEntry(SDL.channelFinished)(channel)
                };
                if (channelInfo.audio) {
                    _Mix_HaltChannel(channel)
                }
                channelInfo.audio = audio;
                audio.loop = loops != 0;
                audio.volume = channelInfo.volume;
                audio.play();
                return channel
            }
            _Mix_PlayChannelTimed.sig = "iipii";
            var _Mix_FadingChannel = channel => 0;
            _Mix_FadingChannel.sig = "ii";
            var _Mix_HaltMusic = () => {
                var audio = SDL.music.audio;
                if (audio) {
                    audio.src = audio.src;
                    audio.currentPosition = 0;
                    audio.pause()
                }
                SDL.music.audio = null;
                if (SDL.hookMusicFinished) {
                    getWasmTableEntry(SDL.hookMusicFinished)()
                }
                return 0
            };
            _Mix_HaltMusic.sig = "i";

            function _Mix_HookMusicFinished(func) {
                func >>>= 0;
                SDL.hookMusicFinished = func;
                if (SDL.music.audio) {
                    SDL.music.audio["onended"] = _Mix_HaltMusic
                }
            }
            _Mix_HookMusicFinished.sig = "vp";
            var _Mix_VolumeMusic = volume => SDL.setGetVolume(SDL.music, volume);
            _Mix_VolumeMusic.sig = "ii";

            function _Mix_LoadMUS_RW(filename) {
                filename >>>= 0;
                return _Mix_LoadWAV_RW(filename, 0)
            }
            _Mix_LoadMUS_RW.sig = "pp";

            function _Mix_LoadMUS(filename) {
                filename >>>= 0;
                var rwops = _SDL_RWFromFile(filename, 0);
                var result = _Mix_LoadMUS_RW(rwops);
                _SDL_FreeRW(rwops);
                return result
            }
            _Mix_LoadMUS.sig = "pp";
            var _Mix_FreeMusic = _Mix_FreeChunk;
            _Mix_FreeMusic.sig = "vp";

            function _Mix_PlayMusic(id, loops) {
                id >>>= 0;
                if (SDL.music.audio) {
                    if (!SDL.music.audio.paused) err(`Music is already playing. ${SDL.music.source}`);
                    SDL.music.audio.pause()
                }
                var info = SDL.audios[id];
                var audio;
                if (info.webAudio) {
                    audio = {};
                    audio.resource = info;
                    audio.paused = false;
                    audio.currentPosition = 0;
                    audio.play = function() {
                        SDL.playWebAudio(this)
                    };
                    audio.pause = function() {
                        SDL.pauseWebAudio(this)
                    }
                } else if (info.audio) {
                    audio = info.audio
                }
                audio["onended"] = function() {
                    if (SDL.music.audio === this || SDL.music.audio?.webAudioNode === this) {
                        _Mix_HaltMusic()
                    }
                };
                audio.loop = loops != 0 && loops != 1;
                audio.volume = SDL.music.volume;
                SDL.music.audio = audio;
                audio.play();
                return 0
            }
            _Mix_PlayMusic.sig = "ipi";
            var _Mix_PauseMusic = () => {
                var audio = SDL.music.audio;
                audio?.pause()
            };
            _Mix_PauseMusic.sig = "v";
            var _Mix_ResumeMusic = () => {
                var audio = SDL.music.audio;
                audio?.play()
            };
            _Mix_ResumeMusic.sig = "v";
            var _Mix_FadeInMusicPos = _Mix_PlayMusic;
            _Mix_FadeInMusicPos.sig = "ipiid";
            var _Mix_FadeOutMusic = _Mix_HaltMusic;
            _Mix_FadeOutMusic.sig = "ii";
            var _Mix_PlayingMusic = () => SDL.music.audio && !SDL.music.audio.paused ? 1 : 0;
            _Mix_PlayingMusic.sig = "i";
            var _Mix_Playing = channel => {
                if (channel === -1) {
                    var count = 0;
                    for (var i = 0; i < SDL.channels.length; i++) {
                        count += _Mix_Playing(i)
                    }
                    return count
                }
                var info = SDL.channels[channel];
                if (info?.audio && !info.audio.paused) {
                    return 1
                }
                return 0
            };
            _Mix_Playing.sig = "ii";
            var _Mix_Pause = channel => {
                if (channel === -1) {
                    for (var i = 0; i < SDL.channels.length; i++) {
                        _Mix_Pause(i)
                    }
                    return
                }
                var info = SDL.channels[channel];
                if (info?.audio) {
                    info.audio.pause()
                } else {}
            };
            _Mix_Pause.sig = "vi";
            var _Mix_Paused = channel => {
                if (channel === -1) {
                    var pausedCount = 0;
                    for (var i = 0; i < SDL.channels.length; i++) {
                        pausedCount += _Mix_Paused(i)
                    }
                    return pausedCount
                }
                var info = SDL.channels[channel];
                if (info?.audio?.paused) {
                    return 1
                }
                return 0
            };
            _Mix_Paused.sig = "ii";
            var _Mix_PausedMusic = () => SDL.music.audio?.paused ? 1 : 0;
            _Mix_PausedMusic.sig = "i";
            var _Mix_Resume = channel => {
                if (channel === -1) {
                    for (var i = 0; i < SDL.channels.length; i++) {
                        _Mix_Resume(i)
                    }
                    return
                }
                var info = SDL.channels[channel];
                if (info?.audio) info.audio.play()
            };
            _Mix_Resume.sig = "vi";
            var _TTF_Init = () => {
                try {
                    var offscreenCanvas = new OffscreenCanvas(0, 0);
                    SDL.ttfContext = offscreenCanvas.getContext("2d");
                    if (typeof SDL.ttfContext.measureText != "function") {
                        throw "bad context"
                    }
                } catch (ex) {
                    var canvas = document.createElement("canvas");
                    SDL.ttfContext = canvas.getContext("2d")
                }
                return 0
            };
            _TTF_Init.sig = "i";

            function _TTF_OpenFont(name, size) {
                name >>>= 0;
                name = PATH.normalize(UTF8ToString(name));
                var id = SDL.fonts.length;
                SDL.fonts.push({
                    name,
                    size
                });
                return id
            }
            _TTF_OpenFont.sig = "ppi";

            function _TTF_CloseFont(font) {
                font >>>= 0;
                SDL.fonts[font] = null
            }
            _TTF_CloseFont.sig = "vp";

            function _TTF_RenderText_Solid(font, text, color) {
                font >>>= 0;
                text >>>= 0;
                color >>>= 0;
                text = UTF8ToString(text) || " ";
                var fontData = SDL.fonts[font];
                var w = SDL.estimateTextWidth(fontData, text);
                var h = fontData.size;
                color = SDL.loadColorToCSSRGB(color);
                var fontString = SDL.makeFontString(h, fontData.name);
                var surf = SDL.makeSurface(w, h, 0, false, "text:" + text);
                var surfData = SDL.surfaces[surf];
                surfData.ctx.save();
                surfData.ctx.fillStyle = color;
                surfData.ctx.font = fontString;
                surfData.ctx.textBaseline = "bottom";
                surfData.ctx.fillText(text, 0, h | 0);
                surfData.ctx.restore();
                return surf
            }
            _TTF_RenderText_Solid.sig = "pppp";
            var _TTF_RenderText_Blended = _TTF_RenderText_Solid;
            _TTF_RenderText_Blended.sig = "pppp";
            var _TTF_RenderText_Shaded = _TTF_RenderText_Solid;
            _TTF_RenderText_Shaded.sig = "ppppp";
            var _TTF_RenderUTF8_Solid = _TTF_RenderText_Solid;
            _TTF_RenderUTF8_Solid.sig = "pppp";

            function _TTF_SizeText(font, text, w, h) {
                font >>>= 0;
                text >>>= 0;
                w >>>= 0;
                h >>>= 0;
                var fontData = SDL.fonts[font];
                if (w) {
                    HEAP32[w >>> 2 >>> 0] = SDL.estimateTextWidth(fontData, UTF8ToString(text))
                }
                if (h) {
                    HEAP32[h >>> 2 >>> 0] = fontData.size
                }
                return 0
            }
            _TTF_SizeText.sig = "ipppp";
            var _TTF_SizeUTF8 = _TTF_SizeText;
            _TTF_SizeUTF8.sig = "ipppp";

            function _TTF_GlyphMetrics(font, ch, minx, maxx, miny, maxy, advance) {
                font >>>= 0;
                minx >>>= 0;
                maxx >>>= 0;
                miny >>>= 0;
                maxy >>>= 0;
                advance >>>= 0;
                var fontData = SDL.fonts[font];
                var width = SDL.estimateTextWidth(fontData, String.fromCharCode(ch));
                if (advance) {
                    HEAP32[advance >>> 2 >>> 0] = width
                }
                if (minx) {
                    HEAP32[minx >>> 2 >>> 0] = 0
                }
                if (maxx) {
                    HEAP32[maxx >>> 2 >>> 0] = width
                }
                if (miny) {
                    HEAP32[miny >>> 2 >>> 0] = 0
                }
                if (maxy) {
                    HEAP32[maxy >>> 2 >>> 0] = fontData.size
                }
            }
            _TTF_GlyphMetrics.sig = "ipippppp";

            function _TTF_FontAscent(font) {
                font >>>= 0;
                var fontData = SDL.fonts[font];
                return fontData.size * .98 | 0
            }
            _TTF_FontAscent.sig = "ip";

            function _TTF_FontDescent(font) {
                font >>>= 0;
                var fontData = SDL.fonts[font];
                return fontData.size * .02 | 0
            }
            _TTF_FontDescent.sig = "ip";

            function _TTF_FontHeight(font) {
                font >>>= 0;
                var fontData = SDL.fonts[font];
                return fontData.size
            }
            _TTF_FontHeight.sig = "ip";
            var _TTF_FontLineSkip = _TTF_FontHeight;
            _TTF_FontLineSkip.sig = "ip";
            var _TTF_Quit = () => out("TTF_Quit called (and ignored)");
            _TTF_Quit.sig = "v";
            var SDL_gfx = {
                drawRectangle: (surf, x1, y1, x2, y2, action, cssColor) => {
                    x1 = x1 << 16 >> 16;
                    y1 = y1 << 16 >> 16;
                    x2 = x2 << 16 >> 16;
                    y2 = y2 << 16 >> 16;
                    var surfData = SDL.surfaces[surf];
                    assert(!surfData.locked);
                    var x = x1 < x2 ? x1 : x2;
                    var y = y1 < y2 ? y1 : y2;
                    var w = Math.abs(x2 - x1);
                    var h = Math.abs(y2 - y1);
                    surfData.ctx.save();
                    surfData.ctx[action + "Style"] = cssColor;
                    surfData.ctx[action + "Rect"](x, y, w, h);
                    surfData.ctx.restore()
                },
                drawLine: (surf, x1, y1, x2, y2, cssColor) => {
                    x1 = x1 << 16 >> 16;
                    y1 = y1 << 16 >> 16;
                    x2 = x2 << 16 >> 16;
                    y2 = y2 << 16 >> 16;
                    var surfData = SDL.surfaces[surf];
                    assert(!surfData.locked);
                    surfData.ctx.save();
                    surfData.ctx.strokeStyle = cssColor;
                    surfData.ctx.beginPath();
                    surfData.ctx.moveTo(x1, y1);
                    surfData.ctx.lineTo(x2, y2);
                    surfData.ctx.stroke();
                    surfData.ctx.restore()
                },
                drawEllipse: (surf, x, y, rx, ry, action, cssColor) => {
                    x = x << 16 >> 16;
                    y = y << 16 >> 16;
                    rx = rx << 16 >> 16;
                    ry = ry << 16 >> 16;
                    var surfData = SDL.surfaces[surf];
                    assert(!surfData.locked);
                    surfData.ctx.save();
                    surfData.ctx.beginPath();
                    surfData.ctx.translate(x, y);
                    surfData.ctx.scale(rx, ry);
                    surfData.ctx.arc(0, 0, 1, 0, 2 * Math.PI);
                    surfData.ctx.restore();
                    surfData.ctx.save();
                    surfData.ctx[action + "Style"] = cssColor;
                    surfData.ctx[action]();
                    surfData.ctx.restore()
                },
                translateColorToCSSRGBA: rgba => `rgba(${rgba>>>24},${rgba>>16&255},${rgba>>8&255},${rgba&255})`
            };

            function _boxColor(surf, x1, y1, x2, y2, color) {
                surf >>>= 0;
                return SDL_gfx.drawRectangle(surf, x1, y1, x2, y2, "fill", SDL_gfx.translateColorToCSSRGBA(color))
            }
            _boxColor.sig = "ipiiiii";

            function _boxRGBA(surf, x1, y1, x2, y2, r, g, b, a) {
                surf >>>= 0;
                return SDL_gfx.drawRectangle(surf, x1, y1, x2, y2, "fill", SDL.translateRGBAToCSSRGBA(r, g, b, a))
            }
            _boxRGBA.sig = "ipiiiiiiii";

            function _rectangleColor(surf, x1, y1, x2, y2, color) {
                surf >>>= 0;
                return SDL_gfx.drawRectangle(surf, x1, y1, x2, y2, "stroke", SDL_gfx.translateColorToCSSRGBA(color))
            }
            _rectangleColor.sig = "ipiiiii";

            function _rectangleRGBA(surf, x1, y1, x2, y2, r, g, b, a) {
                surf >>>= 0;
                return SDL_gfx.drawRectangle(surf, x1, y1, x2, y2, "stroke", SDL.translateRGBAToCSSRGBA(r, g, b, a))
            }
            _rectangleRGBA.sig = "ipiiiiiiii";

            function _ellipseColor(surf, x, y, rx, ry, color) {
                surf >>>= 0;
                return SDL_gfx.drawEllipse(surf, x, y, rx, ry, "stroke", SDL_gfx.translateColorToCSSRGBA(color))
            }
            _ellipseColor.sig = "ipiiiii";

            function _ellipseRGBA(surf, x, y, rx, ry, r, g, b, a) {
                surf >>>= 0;
                return SDL_gfx.drawEllipse(surf, x, y, rx, ry, "stroke", SDL.translateRGBAToCSSRGBA(r, g, b, a))
            }
            _ellipseRGBA.sig = "ipiiiiiiii";

            function _filledEllipseColor(surf, x, y, rx, ry, color) {
                surf >>>= 0;
                return SDL_gfx.drawEllipse(surf, x, y, rx, ry, "fill", SDL_gfx.translateColorToCSSRGBA(color))
            }
            _filledEllipseColor.sig = "ipiiiii";

            function _filledEllipseRGBA(surf, x, y, rx, ry, r, g, b, a) {
                surf >>>= 0;
                return SDL_gfx.drawEllipse(surf, x, y, rx, ry, "fill", SDL.translateRGBAToCSSRGBA(r, g, b, a))
            }
            _filledEllipseRGBA.sig = "ipiiiiiiii";

            function _lineColor(surf, x1, y1, x2, y2, color) {
                surf >>>= 0;
                return SDL_gfx.drawLine(surf, x1, y1, x2, y2, SDL_gfx.translateColorToCSSRGBA(color))
            }
            _lineColor.sig = "ipiiiii";

            function _lineRGBA(surf, x1, y1, x2, y2, r, g, b, a) {
                surf >>>= 0;
                return SDL_gfx.drawLine(surf, x1, y1, x2, y2, SDL.translateRGBAToCSSRGBA(r, g, b, a))
            }
            _lineRGBA.sig = "ipiiiiiiii";

            function _pixelRGBA(surf, x1, y1, r, g, b, a) {
                surf >>>= 0;
                return _boxRGBA(surf, x1, y1, x1, y1, r, g, b, a)
            }
            _pixelRGBA.sig = "ipiiiiii";
            var _SDL_GL_SetAttribute = (attr, value) => {
                if (!(attr in SDL.glAttributes)) {
                    abort("Unknown SDL GL attribute (" + attr + "). Please check if your SDL version is supported.")
                }
                SDL.glAttributes[attr] = value
            };
            _SDL_GL_SetAttribute.sig = "iii";

            function _SDL_GL_GetAttribute(attr, value) {
                value >>>= 0;
                if (!(attr in SDL.glAttributes)) {
                    abort("Unknown SDL GL attribute (" + attr + "). Please check if your SDL version is supported.")
                }
                if (value) HEAP32[value >>> 2 >>> 0] = SDL.glAttributes[attr];
                return 0
            }
            _SDL_GL_GetAttribute.sig = "iip";
            var _SDL_GL_SwapBuffers = () => {
                Browser.doSwapBuffers?.()
            };
            _SDL_GL_SwapBuffers.sig = "v";

            function _SDL_GL_ExtensionSupported(extension) {
                extension >>>= 0;
                return Module.ctx.getExtension(extension) | 0
            }
            _SDL_GL_ExtensionSupported.sig = "ip";

            function _SDL_DestroyWindow(window) {
                window >>>= 0
            }
            _SDL_DestroyWindow.sig = "vp";

            function _SDL_DestroyRenderer(renderer) {
                renderer >>>= 0
            }
            _SDL_DestroyRenderer.sig = "vp";

            function _SDL_GetWindowFlags(window) {
                window >>>= 0;
                if (Browser.isFullscreen) {
                    return 1
                }
                return 0
            }
            _SDL_GetWindowFlags.sig = "ip";

            function _SDL_GL_SwapWindow(window) {
                window >>>= 0
            }
            _SDL_GL_SwapWindow.sig = "vp";

            function _SDL_GL_MakeCurrent(window, context) {
                window >>>= 0;
                context >>>= 0
            }
            _SDL_GL_MakeCurrent.sig = "ipp";

            function _SDL_GL_DeleteContext(context) {
                context >>>= 0
            }
            _SDL_GL_DeleteContext.sig = "vp";
            var _SDL_GL_GetSwapInterval = () => {
                if (MainLoop.timingMode == 1) return MainLoop.timingValue;
                else return 0
            };
            _SDL_GL_GetSwapInterval.sig = "i";
            var _SDL_GL_SetSwapInterval = state => {
                _emscripten_set_main_loop_timing(1, state)
            };
            _SDL_GL_SetSwapInterval.sig = "ii";

            function _SDL_SetWindowTitle(window, title) {
                window >>>= 0;
                title >>>= 0;
                if (title) document.title = UTF8ToString(title)
            }
            _SDL_SetWindowTitle.sig = "vpp";

            function _SDL_GetWindowSize(window, width, height) {
                window >>>= 0;
                width >>>= 0;
                height >>>= 0;
                var w = Module["canvas"].width;
                var h = Module["canvas"].height;
                if (width) HEAP32[width >>> 2 >>> 0] = w;
                if (height) HEAP32[height >>> 2 >>> 0] = h
            }
            _SDL_GetWindowSize.sig = "vppp";

            function _SDL_LogSetOutputFunction(callback, userdata) {
                callback >>>= 0;
                userdata >>>= 0
            }
            _SDL_LogSetOutputFunction.sig = "vpp";

            function _SDL_SetWindowFullscreen(window, fullscreen) {
                window >>>= 0;
                if (Browser.isFullscreen) {
                    Module["canvas"].exitFullscreen();
                    return 1
                }
                return 0
            }
            _SDL_SetWindowFullscreen.sig = "ipi";
            var _SDL_ClearError = () => {};
            _SDL_ClearError.sig = "v";
            var _SDL_SetGamma = (r, g, b) => -1;
            _SDL_SetGamma.sig = "ifff";

            function _SDL_SetGammaRamp(redTable, greenTable, blueTable) {
                redTable >>>= 0;
                greenTable >>>= 0;
                blueTable >>>= 0;
                return -1
            }
            _SDL_SetGammaRamp.sig = "ippp";
            var _SDL_NumJoysticks = () => {
                var count = 0;
                var gamepads = SDL.getGamepads();
                for (var i = 0; i < gamepads.length; i++) {
                    if (gamepads[i] !== undefined) count++
                }
                return count
            };
            _SDL_NumJoysticks.sig = "i";

            function _SDL_JoystickName(deviceIndex) {
                var gamepad = SDL.getGamepad(deviceIndex);
                if (gamepad) {
                    var name = gamepad.id;
                    if (SDL.joystickNamePool.hasOwnProperty(name)) {
                        return SDL.joystickNamePool[name]
                    }
                    return SDL.joystickNamePool[name] = stringToNewUTF8(name)
                }
                return 0
            }
            _SDL_JoystickName.sig = "pi";

            function _SDL_JoystickOpen(deviceIndex) {
                var gamepad = SDL.getGamepad(deviceIndex);
                if (gamepad) {
                    var joystick = deviceIndex + 1;
                    SDL.recordJoystickState(joystick, gamepad);
                    return joystick
                }
                return 0
            }
            _SDL_JoystickOpen.sig = "pi";
            var _SDL_JoystickOpened = deviceIndex => SDL.lastJoystickState.hasOwnProperty(deviceIndex + 1) ? 1 : 0;
            _SDL_JoystickOpened.sig = "ii";

            function _SDL_JoystickIndex(joystick) {
                joystick >>>= 0;
                return joystick - 1
            }
            _SDL_JoystickIndex.sig = "ip";

            function _SDL_JoystickNumAxes(joystick) {
                joystick >>>= 0;
                var gamepad = SDL.getGamepad(joystick - 1);
                if (gamepad) {
                    return gamepad.axes.length
                }
                return 0
            }
            _SDL_JoystickNumAxes.sig = "ip";

            function _SDL_JoystickNumBalls(joystick) {
                joystick >>>= 0;
                return 0
            }
            _SDL_JoystickNumBalls.sig = "ip";

            function _SDL_JoystickNumHats(joystick) {
                joystick >>>= 0;
                return 0
            }
            _SDL_JoystickNumHats.sig = "ip";

            function _SDL_JoystickNumButtons(joystick) {
                joystick >>>= 0;
                var gamepad = SDL.getGamepad(joystick - 1);
                if (gamepad) {
                    return gamepad.buttons.length
                }
                return 0
            }
            _SDL_JoystickNumButtons.sig = "ip";
            var _SDL_JoystickUpdate = () => SDL.queryJoysticks();
            _SDL_JoystickUpdate.sig = "v";
            var _SDL_JoystickEventState = state => {
                if (state < 0) {
                    return SDL.joystickEventState
                }
                return SDL.joystickEventState = state
            };
            _SDL_JoystickEventState.sig = "ii";

            function _SDL_JoystickGetAxis(joystick, axis) {
                joystick >>>= 0;
                var gamepad = SDL.getGamepad(joystick - 1);
                if (gamepad && gamepad.axes.length > axis) {
                    return SDL.joystickAxisValueConversion(gamepad.axes[axis])
                }
                return 0
            }
            _SDL_JoystickGetAxis.sig = "ipi";

            function _SDL_JoystickGetHat(joystick, hat) {
                joystick >>>= 0;
                return 0
            }
            _SDL_JoystickGetHat.sig = "ipi";

            function _SDL_JoystickGetBall(joystick, ball, dxptr, dyptr) {
                joystick >>>= 0;
                dxptr >>>= 0;
                dyptr >>>= 0;
                return -1
            }
            _SDL_JoystickGetBall.sig = "ipipp";

            function _SDL_JoystickGetButton(joystick, button) {
                joystick >>>= 0;
                var gamepad = SDL.getGamepad(joystick - 1);
                if (gamepad && gamepad.buttons.length > button) {
                    return SDL.getJoystickButtonState(gamepad.buttons[button]) ? 1 : 0
                }
                return 0
            }
            _SDL_JoystickGetButton.sig = "ipi";

            function _SDL_JoystickClose(joystick) {
                joystick >>>= 0;
                delete SDL.lastJoystickState[joystick]
            }
            _SDL_JoystickClose.sig = "vp";
            var _SDL_InitSubSystem = flags => 0;
            _SDL_InitSubSystem.sig = "ii";

            function _SDL_RWFromConstMem(mem, size) {
                mem >>>= 0;
                var id = SDL.rwops.length;
                SDL.rwops.push({
                    bytes: mem,
                    count: size
                });
                return id
            }
            _SDL_RWFromConstMem.sig = "ppi";
            var _SDL_RWFromMem = _SDL_RWFromConstMem;
            _SDL_RWFromMem.sig = "ppi";
            var _SDL_GetNumAudioDrivers = () => 1;
            _SDL_GetNumAudioDrivers.sig = "i";

            function _SDL_GetCurrentAudioDriver() {
                return stringToNewUTF8("Emscripten Audio")
            }
            _SDL_GetCurrentAudioDriver.sig = "p";
            var _SDL_GetScancodeFromKey = key => SDL.scanCodes[key];
            _SDL_GetScancodeFromKey.sig = "ii";

            function _SDL_GetAudioDriver(index) {
                return _SDL_GetCurrentAudioDriver()
            }
            _SDL_GetAudioDriver.sig = "pi";
            var _SDL_EnableUNICODE = on => {
                var ret = SDL.unicode || 0;
                SDL.unicode = on;
                return ret
            };
            _SDL_EnableUNICODE.sig = "ii";
            var _SDL_AddTimer = function(interval, callback, param) {
                callback >>>= 0;
                param >>>= 0;
                return safeSetTimeout(() => getWasmTableEntry(callback)(interval, param), interval)
            };
            _SDL_AddTimer.sig = "iipp";
            var _SDL_RemoveTimer = id => {
                clearTimeout(id);
                return true
            };
            _SDL_RemoveTimer.sig = "ii";

            function _SDL_CreateThread(fs, data, pfnBeginThread, pfnEndThread) {
                fs >>>= 0;
                data >>>= 0;
                throw "SDL threads cannot be supported in the web platform because they assume shared state. See emscripten_create_worker etc. for a message-passing concurrency model that does let you run code in another thread."
            }
            _SDL_CreateThread.sig = "ppp";

            function _SDL_WaitThread(thread, status) {
                thread >>>= 0;
                status >>>= 0;
                throw "SDL_WaitThread"
            }
            _SDL_WaitThread.sig = "vpp";

            function _SDL_GetThreadID(thread) {
                thread >>>= 0;
                throw "SDL_GetThreadID"
            }
            _SDL_GetThreadID.sig = "pp";

            function _SDL_ThreadID() {
                return 0
            }
            _SDL_ThreadID.sig = "p";

            function _SDL_AllocRW() {
                throw "SDL_AllocRW: TODO"
            }
            _SDL_AllocRW.sig = "p";

            function _SDL_CondBroadcast(cond) {
                cond >>>= 0;
                throw "SDL_CondBroadcast: TODO"
            }
            _SDL_CondBroadcast.sig = "ip";

            function _SDL_CondWaitTimeout(cond, mutex, ms) {
                cond >>>= 0;
                mutex >>>= 0;
                throw "SDL_CondWaitTimeout: TODO"
            }
            _SDL_CondWaitTimeout.sig = "ippi";
            var _SDL_WM_IconifyWindow = () => {
                throw "SDL_WM_IconifyWindow TODO"
            };
            _SDL_WM_IconifyWindow.sig = "i";

            function _Mix_SetPostMix(func, arg) {
                func >>>= 0;
                arg >>>= 0;
                return warnOnce("Mix_SetPostMix: TODO")
            }
            _Mix_SetPostMix.sig = "vpp";

            function _Mix_VolumeChunk(chunk, volume) {
                chunk >>>= 0;
                throw "Mix_VolumeChunk: TODO"
            }
            _Mix_VolumeChunk.sig = "ipi";
            var _Mix_SetPosition = (channel, angle, distance) => {
                throw "Mix_SetPosition: TODO"
            };
            _Mix_SetPosition.sig = "iiii";

            function _Mix_QuerySpec(frequency, format, channels) {
                frequency >>>= 0;
                format >>>= 0;
                channels >>>= 0;
                throw "Mix_QuerySpec: TODO"
            }
            _Mix_QuerySpec.sig = "ippp";

            function _Mix_FadeInChannelTimed(channel, chunk, loop, ms, ticks) {
                chunk >>>= 0;
                throw "Mix_FadeInChannelTimed"
            }
            _Mix_FadeInChannelTimed.sig = "iipiii";
            var _Mix_FadeOutChannel = () => {
                throw "Mix_FadeOutChannel"
            };
            _Mix_FadeOutChannel.sig = "iii";

            function _Mix_Linked_Version() {
                throw "Mix_Linked_Version: TODO"
            }
            _Mix_Linked_Version.sig = "p";

            function _SDL_SaveBMP_RW(surface, dst, freedst) {
                surface >>>= 0;
                dst >>>= 0;
                throw "SDL_SaveBMP_RW: TODO"
            }
            _SDL_SaveBMP_RW.sig = "ippi";

            function _SDL_WM_SetIcon(icon, mask) {
                icon >>>= 0;
                mask >>>= 0
            }
            _SDL_WM_SetIcon.sig = "vpp";
            var _SDL_HasRDTSC = () => 0;
            _SDL_HasRDTSC.sig = "i";
            var _SDL_HasMMX = () => 0;
            _SDL_HasMMX.sig = "i";
            var _SDL_HasMMXExt = () => 0;
            _SDL_HasMMXExt.sig = "i";
            var _SDL_Has3DNow = () => 0;
            _SDL_Has3DNow.sig = "i";
            var _SDL_Has3DNowExt = () => 0;
            _SDL_Has3DNowExt.sig = "i";
            var _SDL_HasSSE = () => 0;
            _SDL_HasSSE.sig = "i";
            var _SDL_HasSSE2 = () => 0;
            _SDL_HasSSE2.sig = "i";
            var _SDL_HasAltiVec = () => 0;
            _SDL_HasAltiVec.sig = "i";
            var ALLOC_NORMAL = 0;
            var ALLOC_STACK = 1;
            var allocate = (slab, allocator) => {
                var ret;
                if (allocator == ALLOC_STACK) {
                    ret = stackAlloc(slab.length)
                } else {
                    ret = _malloc(slab.length)
                }
                if (!slab.subarray && !slab.slice) {
                    slab = new Uint8Array(slab)
                }
                HEAPU8.set(slab, ret >>> 0);
                return ret
            };
            var writeStringToMemory = (string, buffer, dontAddNull) => {
                warnOnce("writeStringToMemory is deprecated and should not be called! Use stringToUTF8() instead!");
                var lastChar, end;
                if (dontAddNull) {
                    end = buffer + lengthBytesUTF8(string);
                    lastChar = HEAP8[end >>> 0]
                }
                stringToUTF8(string, buffer, Infinity);
                if (dontAddNull) HEAP8[end >>> 0] = lastChar
            };
            var writeAsciiToMemory = (str, buffer, dontAddNull) => {
                for (var i = 0; i < str.length; ++i) {
                    HEAP8[buffer++ >>> 0] = str.charCodeAt(i)
                }
                if (!dontAddNull) HEAP8[buffer >>> 0] = 0
            };
            var allocateUTF8 = stringToNewUTF8;
            var allocateUTF8OnStack = stringToUTF8OnStack;
            var setErrNo = value => {
                HEAP32[___errno_location() >>> 2 >>> 0] = value;
                return value
            };
            var demangle = func => {
                demangle.recursionGuard = (demangle.recursionGuard | 0) + 1;
                if (demangle.recursionGuard > 1) return func;
                return withStackSave(() => {
                    try {
                        var s = func;
                        if (s.startsWith("__Z")) s = s.substr(1);
                        var buf = stringToUTF8OnStack(s);
                        var status = stackAlloc(4);
                        var ret = ___cxa_demangle(buf, 0, 0, status);
                        if (HEAP32[status >>> 2 >>> 0] === 0 && ret) {
                            return UTF8ToString(ret)
                        }
                    } catch (e) {} finally {
                        _free(ret);
                        if (demangle.recursionGuard < 2) --demangle.recursionGuard
                    }
                    return func
                })
            };
            var stackTrace = () => {
                var js = jsStackTrace();
                if (Module["extraStackTrace"]) js += "\n" + Module["extraStackTrace"]();
                return js
            };
            var print = out;
            var printErr = err;
            var _emscripten_is_main_browser_thread = () => !ENVIRONMENT_IS_WORKER;
            var tupleRegistrations = {};
            var structRegistrations = {};
            var getFunctionName = signature => {
                signature = signature.trim();
                const argsIndex = signature.indexOf("(");
                if (argsIndex !== -1) {
                    return signature.substr(0, argsIndex)
                } else {
                    return signature
                }
            };
            var getFunctionArgsName = signature => {
                signature = signature.trim();
                const argsIndex = signature.indexOf("(") + 1;
                if (argsIndex !== 0) {
                    return signature.substr(argsIndex, signature.length - argsIndex - 1).replaceAll(" ", "").split(",").filter(n => n.length)
                } else {
                    return []
                }
            };
            var heap32VectorToArray = (count, firstElement) => {
                var array = [];
                for (var i = 0; i < count; i++) {
                    array.push(HEAPU32[firstElement + i * 4 >>> 2 >>> 0])
                }
                return array
            };

            function usesDestructorStack(argTypes) {
                for (var i = 1; i < argTypes.length; ++i) {
                    if (argTypes[i] !== null && argTypes[i].destructorFunction === undefined) {
                        return true
                    }
                }
                return false
            }

            function createJsInvokerSignature(argTypes, isClassMethodFunc, returns, isAsync) {
                const signature = [isClassMethodFunc ? "t" : "f", returns ? "t" : "f", isAsync ? "t" : "f"];
                for (let i = isClassMethodFunc ? 1 : 2; i < argTypes.length; ++i) {
                    const arg = argTypes[i];
                    let destructorSig = "";
                    if (arg.destructorFunction === undefined) {
                        destructorSig = "u"
                    } else if (arg.destructorFunction === null) {
                        destructorSig = "n"
                    } else {
                        destructorSig = "t"
                    }
                    signature.push(destructorSig)
                }
                return signature.join("")
            }

            function checkArgCount(numArgs, minArgs, maxArgs, humanName, throwBindingError) {
                if (numArgs < minArgs || numArgs > maxArgs) {
                    var argCountMessage = minArgs == maxArgs ? minArgs : `${minArgs} to ${maxArgs}`;
                    throwBindingError(`function ${humanName} called with ${numArgs} arguments, expected ${argCountMessage}`)
                }
            }

            function getRequiredArgCount(argTypes) {
                var requiredArgCount = argTypes.length - 2;
                for (var i = argTypes.length - 1; i >= 2; --i) {
                    if (!argTypes[i].optional) {
                        break
                    }
                    requiredArgCount--
                }
                return requiredArgCount
            }

            function createJsInvoker(argTypes, isClassMethodFunc, returns, isAsync) {
                var needsDestructorStack = usesDestructorStack(argTypes);
                var argCount = argTypes.length - 2;
                var argsList = [];
                var argsListWired = ["fn"];
                if (isClassMethodFunc) {
                    argsListWired.push("thisWired")
                }
                for (var i = 0; i < argCount; ++i) {
                    argsList.push(`arg${i}`);
                    argsListWired.push(`arg${i}Wired`)
                }
                argsList = argsList.join(",");
                argsListWired = argsListWired.join(",");
                var invokerFnBody = `return function (${argsList}) {\n`;
                if (needsDestructorStack) {
                    invokerFnBody += "var destructors = [];\n"
                }
                var dtorStack = needsDestructorStack ? "destructors" : "null";
                var args1 = ["humanName", "throwBindingError", "invoker", "fn", "runDestructors", "retType", "classParam"];
                if (isClassMethodFunc) {
                    invokerFnBody += `var thisWired = classParam['toWireType'](${dtorStack}, this);\n`
                }
                for (var i = 0; i < argCount; ++i) {
                    invokerFnBody += `var arg${i}Wired = argType${i}['toWireType'](${dtorStack}, arg${i});\n`;
                    args1.push(`argType${i}`)
                }
                invokerFnBody += (returns || isAsync ? "var rv = " : "") + `invoker(${argsListWired});\n`;
                var returnVal = returns ? "rv" : "";
                if (needsDestructorStack) {
                    invokerFnBody += "runDestructors(destructors);\n"
                } else {
                    for (var i = isClassMethodFunc ? 1 : 2; i < argTypes.length; ++i) {
                        var paramName = i === 1 ? "thisWired" : "arg" + (i - 2) + "Wired";
                        if (argTypes[i].destructorFunction !== null) {
                            invokerFnBody += `${paramName}_dtor(${paramName});\n`;
                            args1.push(`${paramName}_dtor`)
                        }
                    }
                }
                if (returns) {
                    invokerFnBody += "var ret = retType['fromWireType'](rv);\n" + "return ret;\n"
                } else {}
                invokerFnBody += "}\n";
                return [args1, invokerFnBody]
            }
            var extendError = (baseErrorType, errorName) => {
                var errorClass = createNamedFunction(errorName, function(message) {
                    this.name = errorName;
                    this.message = message;
                    var stack = new Error(message).stack;
                    if (stack !== undefined) {
                        this.stack = this.toString() + "\n" + stack.replace(/^Error(:[^\n]*)?\n/, "")
                    }
                });
                errorClass.prototype = Object.create(baseErrorType.prototype);
                errorClass.prototype.constructor = errorClass;
                errorClass.prototype.toString = function() {
                    if (this.message === undefined) {
                        return this.name
                    } else {
                        return `${this.name}: ${this.message}`
                    }
                };
                return errorClass
            };
            var UnboundTypeError;
            var PureVirtualError;
            var EmValOptionalType = Object.assign({
                optional: true
            }, EmValType);
            var throwUnboundTypeError = (message, types) => {
                var unboundTypes = [];
                var seen = {};

                function visit(type) {
                    if (seen[type]) {
                        return
                    }
                    if (registeredTypes[type]) {
                        return
                    }
                    if (typeDependencies[type]) {
                        typeDependencies[type].forEach(visit);
                        return
                    }
                    unboundTypes.push(type);
                    seen[type] = true
                }
                types.forEach(visit);
                throw new UnboundTypeError(`${message}: ` + unboundTypes.map(getTypeName).join([", "]))
            };
            var ensureOverloadTable = (proto, methodName, humanName) => {
                if (undefined === proto[methodName].overloadTable) {
                    var prevFunc = proto[methodName];
                    proto[methodName] = function(...args) {
                        if (!proto[methodName].overloadTable.hasOwnProperty(args.length)) {
                            throwBindingError(`Function '${humanName}' called with an invalid number of arguments (${args.length}) - expects one of (${proto[methodName].overloadTable})!`)
                        }
                        return proto[methodName].overloadTable[args.length].apply(this, args)
                    };
                    proto[methodName].overloadTable = [];
                    proto[methodName].overloadTable[prevFunc.argCount] = prevFunc
                }
            };
            var exposePublicSymbol = (name, value, numArguments) => {
                if (Module.hasOwnProperty(name)) {
                    if (undefined === numArguments || undefined !== Module[name].overloadTable && undefined !== Module[name].overloadTable[numArguments]) {
                        throwBindingError(`Cannot register public name '${name}' twice`)
                    }
                    ensureOverloadTable(Module, name, name);
                    if (Module[name].overloadTable.hasOwnProperty(numArguments)) {
                        throwBindingError(`Cannot register multiple overloads of a function with the same number of arguments (${numArguments})!`)
                    }
                    Module[name].overloadTable[numArguments] = value
                } else {
                    Module[name] = value;
                    Module[name].argCount = numArguments
                }
            };
            var replacePublicSymbol = (name, value, numArguments) => {
                if (!Module.hasOwnProperty(name)) {
                    throwInternalError("Replacing nonexistent public symbol")
                }
                if (undefined !== Module[name].overloadTable && undefined !== numArguments) {
                    Module[name].overloadTable[numArguments] = value
                } else {
                    Module[name] = value;
                    Module[name].argCount = numArguments
                }
            };
            var registeredInstances = {};
            var getBasestPointer = (class_, ptr) => {
                if (ptr === undefined) {
                    throwBindingError("ptr should not be undefined")
                }
                while (class_.baseClass) {
                    ptr = class_.upcast(ptr);
                    class_ = class_.baseClass
                }
                return ptr
            };
            var registerInheritedInstance = (class_, ptr, instance) => {
                ptr = getBasestPointer(class_, ptr);
                if (registeredInstances.hasOwnProperty(ptr)) {
                    throwBindingError(`Tried to register registered instance: ${ptr}`)
                } else {
                    registeredInstances[ptr] = instance
                }
            };
            var unregisterInheritedInstance = (class_, ptr) => {
                ptr = getBasestPointer(class_, ptr);
                if (registeredInstances.hasOwnProperty(ptr)) {
                    delete registeredInstances[ptr]
                } else {
                    throwBindingError(`Tried to unregister unregistered instance: ${ptr}`)
                }
            };
            var getInheritedInstance = (class_, ptr) => {
                ptr = getBasestPointer(class_, ptr);
                return registeredInstances[ptr]
            };
            var getInheritedInstanceCount = () => Object.keys(registeredInstances).length;
            var getLiveInheritedInstances = () => {
                var rv = [];
                for (var k in registeredInstances) {
                    if (registeredInstances.hasOwnProperty(k)) {
                        rv.push(registeredInstances[k])
                    }
                }
                return rv
            };
            var registeredPointers = {};
            var enumReadValueFromPointer = (name, width, signed) => {
                switch (width) {
                    case 1:
                        return signed ? function(pointer) {
                            return this["fromWireType"](HEAP8[pointer >>> 0])
                        } : function(pointer) {
                            return this["fromWireType"](HEAPU8[pointer >>> 0])
                        };
                    case 2:
                        return signed ? function(pointer) {
                            return this["fromWireType"](HEAP16[pointer >>> 1 >>> 0])
                        } : function(pointer) {
                            return this["fromWireType"](HEAPU16[pointer >>> 1 >>> 0])
                        };
                    case 4:
                        return signed ? function(pointer) {
                            return this["fromWireType"](HEAP32[pointer >>> 2 >>> 0])
                        } : function(pointer) {
                            return this["fromWireType"](HEAPU32[pointer >>> 2 >>> 0])
                        };
                    default:
                        throw new TypeError(`invalid integer width (${width}): ${name}`)
                }
            };

            function __embind_register_user_type(rawType, name) {
                rawType >>>= 0;
                name >>>= 0;
                __embind_register_emval(rawType)
            }
            __embind_register_user_type.sig = "vpp";

            function __embind_register_optional(rawOptionalType, rawType) {
                rawOptionalType >>>= 0;
                rawType >>>= 0;
                registerType(rawOptionalType, EmValOptionalType)
            }
            __embind_register_optional.sig = "vpp";

            function craftInvokerFunction(humanName, argTypes, classType, cppInvokerFunc, cppTargetFunc, isAsync) {
                var argCount = argTypes.length;
                if (argCount < 2) {
                    throwBindingError("argTypes array size mismatch! Must at least get return value and 'this' types!")
                }
                var isClassMethodFunc = argTypes[1] !== null && classType !== null;
                var needsDestructorStack = usesDestructorStack(argTypes);
                var returns = argTypes[0].name !== "void";
                var expectedArgCount = argCount - 2;
                var closureArgs = [humanName, throwBindingError, cppInvokerFunc, cppTargetFunc, runDestructors, argTypes[0], argTypes[1]];
                for (var i = 0; i < argCount - 2; ++i) {
                    closureArgs.push(argTypes[i + 2])
                }
                if (!needsDestructorStack) {
                    for (var i = isClassMethodFunc ? 1 : 2; i < argTypes.length; ++i) {
                        if (argTypes[i].destructorFunction !== null) {
                            closureArgs.push(argTypes[i].destructorFunction)
                        }
                    }
                }
                let [args, invokerFnBody] = createJsInvoker(argTypes, isClassMethodFunc, returns, isAsync);
                args.push(invokerFnBody);
                var invokerFn = newFunc(Function, args)(...closureArgs);
                return createNamedFunction(humanName, invokerFn)
            }
            var embind__requireFunction = (signature, rawFunction) => {
                signature = readLatin1String(signature);

                function makeDynCaller() {
                    if (signature.includes("j")) {
                        return getDynCaller(signature, rawFunction)
                    }
                    if (signature.includes("p")) {
                        return getDynCaller(signature, rawFunction)
                    }
                    return getWasmTableEntry(rawFunction)
                }
                var fp = makeDynCaller();
                if (typeof fp != "function") {
                    throwBindingError(`unknown function pointer with signature ${signature}: ${rawFunction}`)
                }
                return fp
            };

            function __embind_register_function(name, argCount, rawArgTypesAddr, signature, rawInvoker, fn, isAsync, isNonnullReturn) {
                name >>>= 0;
                rawArgTypesAddr >>>= 0;
                signature >>>= 0;
                rawInvoker >>>= 0;
                fn >>>= 0;
                var argTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
                name = readLatin1String(name);
                name = getFunctionName(name);
                rawInvoker = embind__requireFunction(signature, rawInvoker);
                exposePublicSymbol(name, function() {
                    throwUnboundTypeError(`Cannot call ${name} due to unbound types`, argTypes)
                }, argCount - 1);
                whenDependentTypesAreResolved([], argTypes, argTypes => {
                    var invokerArgsArray = [argTypes[0], null].concat(argTypes.slice(1));
                    replacePublicSymbol(name, craftInvokerFunction(name, invokerArgsArray, null, rawInvoker, fn, isAsync), argCount - 1);
                    return []
                })
            }
            __embind_register_function.sig = "vpippppii";

            function __embind_register_value_array(rawType, name, constructorSignature, rawConstructor, destructorSignature, rawDestructor) {
                rawType >>>= 0;
                name >>>= 0;
                constructorSignature >>>= 0;
                rawConstructor >>>= 0;
                destructorSignature >>>= 0;
                rawDestructor >>>= 0;
                tupleRegistrations[rawType] = {
                    name: readLatin1String(name),
                    rawConstructor: embind__requireFunction(constructorSignature, rawConstructor),
                    rawDestructor: embind__requireFunction(destructorSignature, rawDestructor),
                    elements: []
                }
            }
            __embind_register_value_array.sig = "vpppppp";

            function __embind_register_value_array_element(rawTupleType, getterReturnType, getterSignature, getter, getterContext, setterArgumentType, setterSignature, setter, setterContext) {
                rawTupleType >>>= 0;
                getterReturnType >>>= 0;
                getterSignature >>>= 0;
                getter >>>= 0;
                getterContext >>>= 0;
                setterArgumentType >>>= 0;
                setterSignature >>>= 0;
                setter >>>= 0;
                setterContext >>>= 0;
                tupleRegistrations[rawTupleType].elements.push({
                    getterReturnType,
                    getter: embind__requireFunction(getterSignature, getter),
                    getterContext,
                    setterArgumentType,
                    setter: embind__requireFunction(setterSignature, setter),
                    setterContext
                })
            }
            __embind_register_value_array_element.sig = "vppppppppp";
            var __embind_finalize_value_array = function(rawTupleType) {
                rawTupleType >>>= 0;
                var reg = tupleRegistrations[rawTupleType];
                delete tupleRegistrations[rawTupleType];
                var elements = reg.elements;
                var elementsLength = elements.length;
                var elementTypes = elements.map(elt => elt.getterReturnType).concat(elements.map(elt => elt.setterArgumentType));
                var rawConstructor = reg.rawConstructor;
                var rawDestructor = reg.rawDestructor;
                whenDependentTypesAreResolved([rawTupleType], elementTypes, elementTypes => {
                    elements.forEach((elt, i) => {
                        var getterReturnType = elementTypes[i];
                        var getter = elt.getter;
                        var getterContext = elt.getterContext;
                        var setterArgumentType = elementTypes[i + elementsLength];
                        var setter = elt.setter;
                        var setterContext = elt.setterContext;
                        elt.read = ptr => getterReturnType["fromWireType"](getter(getterContext, ptr));
                        elt.write = (ptr, o) => {
                            var destructors = [];
                            setter(setterContext, ptr, setterArgumentType["toWireType"](destructors, o));
                            runDestructors(destructors)
                        }
                    });
                    return [{
                        name: reg.name,
                        fromWireType: ptr => {
                            var rv = new Array(elementsLength);
                            for (var i = 0; i < elementsLength; ++i) {
                                rv[i] = elements[i].read(ptr)
                            }
                            rawDestructor(ptr);
                            return rv
                        },
                        toWireType: (destructors, o) => {
                            if (elementsLength !== o.length) {
                                throw new TypeError(`Incorrect number of tuple elements for ${reg.name}: expected=${elementsLength}, actual=${o.length}`)
                            }
                            var ptr = rawConstructor();
                            for (var i = 0; i < elementsLength; ++i) {
                                elements[i].write(ptr, o[i])
                            }
                            if (destructors !== null) {
                                destructors.push(rawDestructor, ptr)
                            }
                            return ptr
                        },
                        argPackAdvance: GenericWireTypeSize,
                        readValueFromPointer: readPointer,
                        destructorFunction: rawDestructor
                    }]
                })
            };
            __embind_finalize_value_array.sig = "vp";

            function __embind_register_value_object(rawType, name, constructorSignature, rawConstructor, destructorSignature, rawDestructor) {
                rawType >>>= 0;
                name >>>= 0;
                constructorSignature >>>= 0;
                rawConstructor >>>= 0;
                destructorSignature >>>= 0;
                rawDestructor >>>= 0;
                structRegistrations[rawType] = {
                    name: readLatin1String(name),
                    rawConstructor: embind__requireFunction(constructorSignature, rawConstructor),
                    rawDestructor: embind__requireFunction(destructorSignature, rawDestructor),
                    fields: []
                }
            }
            __embind_register_value_object.sig = "vpppppp";

            function __embind_register_value_object_field(structType, fieldName, getterReturnType, getterSignature, getter, getterContext, setterArgumentType, setterSignature, setter, setterContext) {
                structType >>>= 0;
                fieldName >>>= 0;
                getterReturnType >>>= 0;
                getterSignature >>>= 0;
                getter >>>= 0;
                getterContext >>>= 0;
                setterArgumentType >>>= 0;
                setterSignature >>>= 0;
                setter >>>= 0;
                setterContext >>>= 0;
                structRegistrations[structType].fields.push({
                    fieldName: readLatin1String(fieldName),
                    getterReturnType,
                    getter: embind__requireFunction(getterSignature, getter),
                    getterContext,
                    setterArgumentType,
                    setter: embind__requireFunction(setterSignature, setter),
                    setterContext
                })
            }
            __embind_register_value_object_field.sig = "vpppppppppp";
            var __embind_finalize_value_object = function(structType) {
                structType >>>= 0;
                var reg = structRegistrations[structType];
                delete structRegistrations[structType];
                var rawConstructor = reg.rawConstructor;
                var rawDestructor = reg.rawDestructor;
                var fieldRecords = reg.fields;
                var fieldTypes = fieldRecords.map(field => field.getterReturnType).concat(fieldRecords.map(field => field.setterArgumentType));
                whenDependentTypesAreResolved([structType], fieldTypes, fieldTypes => {
                    var fields = {};
                    fieldRecords.forEach((field, i) => {
                        var fieldName = field.fieldName;
                        var getterReturnType = fieldTypes[i];
                        var getter = field.getter;
                        var getterContext = field.getterContext;
                        var setterArgumentType = fieldTypes[i + fieldRecords.length];
                        var setter = field.setter;
                        var setterContext = field.setterContext;
                        fields[fieldName] = {
                            read: ptr => getterReturnType["fromWireType"](getter(getterContext, ptr)),
                            write: (ptr, o) => {
                                var destructors = [];
                                setter(setterContext, ptr, setterArgumentType["toWireType"](destructors, o));
                                runDestructors(destructors)
                            }
                        }
                    });
                    return [{
                        name: reg.name,
                        fromWireType: ptr => {
                            var rv = {};
                            for (var i in fields) {
                                rv[i] = fields[i].read(ptr)
                            }
                            rawDestructor(ptr);
                            return rv
                        },
                        toWireType: (destructors, o) => {
                            for (var fieldName in fields) {
                                if (!(fieldName in o)) {
                                    throw new TypeError(`Missing field: "${fieldName}"`)
                                }
                            }
                            var ptr = rawConstructor();
                            for (fieldName in fields) {
                                fields[fieldName].write(ptr, o[fieldName])
                            }
                            if (destructors !== null) {
                                destructors.push(rawDestructor, ptr)
                            }
                            return ptr
                        },
                        argPackAdvance: GenericWireTypeSize,
                        readValueFromPointer: readPointer,
                        destructorFunction: rawDestructor
                    }]
                })
            };
            __embind_finalize_value_object.sig = "vp";
            var upcastPointer = (ptr, ptrClass, desiredClass) => {
                while (ptrClass !== desiredClass) {
                    if (!ptrClass.upcast) {
                        throwBindingError(`Expected null or instance of ${desiredClass.name}, got an instance of ${ptrClass.name}`)
                    }
                    ptr = ptrClass.upcast(ptr);
                    ptrClass = ptrClass.baseClass
                }
                return ptr
            };

            function genericPointerToWireType(destructors, handle) {
                var ptr;
                if (handle === null) {
                    if (this.isReference) {
                        throwBindingError(`null is not a valid ${this.name}`)
                    }
                    if (this.isSmartPointer) {
                        ptr = this.rawConstructor();
                        if (destructors !== null) {
                            destructors.push(this.rawDestructor, ptr)
                        }
                        return ptr
                    } else {
                        return 0
                    }
                }
                if (!handle || !handle.$$) {
                    throwBindingError(`Cannot pass "${embindRepr(handle)}" as a ${this.name}`)
                }
                if (!handle.$$.ptr) {
                    throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`)
                }
                if (!this.isConst && handle.$$.ptrType.isConst) {
                    throwBindingError(`Cannot convert argument of type ${handle.$$.smartPtrType?handle.$$.smartPtrType.name:handle.$$.ptrType.name} to parameter type ${this.name}`)
                }
                var handleClass = handle.$$.ptrType.registeredClass;
                ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
                if (this.isSmartPointer) {
                    if (undefined === handle.$$.smartPtr) {
                        throwBindingError("Passing raw pointer to smart pointer is illegal")
                    }
                    switch (this.sharingPolicy) {
                        case 0:
                            if (handle.$$.smartPtrType === this) {
                                ptr = handle.$$.smartPtr
                            } else {
                                throwBindingError(`Cannot convert argument of type ${handle.$$.smartPtrType?handle.$$.smartPtrType.name:handle.$$.ptrType.name} to parameter type ${this.name}`)
                            }
                            break;
                        case 1:
                            ptr = handle.$$.smartPtr;
                            break;
                        case 2:
                            if (handle.$$.smartPtrType === this) {
                                ptr = handle.$$.smartPtr
                            } else {
                                var clonedHandle = handle["clone"]();
                                ptr = this.rawShare(ptr, Emval.toHandle(() => clonedHandle["delete"]()));
                                if (destructors !== null) {
                                    destructors.push(this.rawDestructor, ptr)
                                }
                            }
                            break;
                        default:
                            throwBindingError("Unsupporting sharing policy")
                    }
                }
                return ptr
            }

            function constNoSmartPtrRawPointerToWireType(destructors, handle) {
                if (handle === null) {
                    if (this.isReference) {
                        throwBindingError(`null is not a valid ${this.name}`)
                    }
                    return 0
                }
                if (!handle.$$) {
                    throwBindingError(`Cannot pass "${embindRepr(handle)}" as a ${this.name}`)
                }
                if (!handle.$$.ptr) {
                    throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`)
                }
                var handleClass = handle.$$.ptrType.registeredClass;
                var ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
                return ptr
            }

            function nonConstNoSmartPtrRawPointerToWireType(destructors, handle) {
                if (handle === null) {
                    if (this.isReference) {
                        throwBindingError(`null is not a valid ${this.name}`)
                    }
                    return 0
                }
                if (!handle.$$) {
                    throwBindingError(`Cannot pass "${embindRepr(handle)}" as a ${this.name}`)
                }
                if (!handle.$$.ptr) {
                    throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`)
                }
                if (handle.$$.ptrType.isConst) {
                    throwBindingError(`Cannot convert argument of type ${handle.$$.ptrType.name} to parameter type ${this.name}`)
                }
                var handleClass = handle.$$.ptrType.registeredClass;
                var ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
                return ptr
            }

            function RegisteredPointer(name, registeredClass, isReference, isConst, isSmartPointer, pointeeType, sharingPolicy, rawGetPointee, rawConstructor, rawShare, rawDestructor) {
                this.name = name;
                this.registeredClass = registeredClass;
                this.isReference = isReference;
                this.isConst = isConst;
                this.isSmartPointer = isSmartPointer;
                this.pointeeType = pointeeType;
                this.sharingPolicy = sharingPolicy;
                this.rawGetPointee = rawGetPointee;
                this.rawConstructor = rawConstructor;
                this.rawShare = rawShare;
                this.rawDestructor = rawDestructor;
                if (!isSmartPointer && registeredClass.baseClass === undefined) {
                    if (isConst) {
                        this["toWireType"] = constNoSmartPtrRawPointerToWireType;
                        this.destructorFunction = null
                    } else {
                        this["toWireType"] = nonConstNoSmartPtrRawPointerToWireType;
                        this.destructorFunction = null
                    }
                } else {
                    this["toWireType"] = genericPointerToWireType
                }
            }
            var downcastPointer = (ptr, ptrClass, desiredClass) => {
                if (ptrClass === desiredClass) {
                    return ptr
                }
                if (undefined === desiredClass.baseClass) {
                    return null
                }
                var rv = downcastPointer(ptr, ptrClass, desiredClass.baseClass);
                if (rv === null) {
                    return null
                }
                return desiredClass.downcast(rv)
            };
            var finalizationRegistry = false;
            var detachFinalizer = handle => {};
            var runDestructor = $$ => {
                if ($$.smartPtr) {
                    $$.smartPtrType.rawDestructor($$.smartPtr)
                } else {
                    $$.ptrType.registeredClass.rawDestructor($$.ptr)
                }
            };
            var releaseClassHandle = $$ => {
                $$.count.value -= 1;
                var toDelete = 0 === $$.count.value;
                if (toDelete) {
                    runDestructor($$)
                }
            };
            var attachFinalizer = handle => {
                if ("undefined" === typeof FinalizationRegistry) {
                    attachFinalizer = handle => handle;
                    return handle
                }
                finalizationRegistry = new FinalizationRegistry(info => {
                    releaseClassHandle(info.$$)
                });
                attachFinalizer = handle => {
                    var $$ = handle.$$;
                    var hasSmartPtr = !!$$.smartPtr;
                    if (hasSmartPtr) {
                        var info = {
                            $$
                        };
                        finalizationRegistry.register(handle, info, handle)
                    }
                    return handle
                };
                detachFinalizer = handle => finalizationRegistry.unregister(handle);
                return attachFinalizer(handle)
            };
            var makeClassHandle = (prototype, record) => {
                if (!record.ptrType || !record.ptr) {
                    throwInternalError("makeClassHandle requires ptr and ptrType")
                }
                var hasSmartPtrType = !!record.smartPtrType;
                var hasSmartPtr = !!record.smartPtr;
                if (hasSmartPtrType !== hasSmartPtr) {
                    throwInternalError("Both smartPtrType and smartPtr must be specified")
                }
                record.count = {
                    value: 1
                };
                return attachFinalizer(Object.create(prototype, {
                    $$: {
                        value: record,
                        writable: true
                    }
                }))
            };

            function RegisteredPointer_fromWireType(ptr) {
                var rawPointer = this.getPointee(ptr);
                if (!rawPointer) {
                    this.destructor(ptr);
                    return null
                }
                var registeredInstance = getInheritedInstance(this.registeredClass, rawPointer);
                if (undefined !== registeredInstance) {
                    if (0 === registeredInstance.$$.count.value) {
                        registeredInstance.$$.ptr = rawPointer;
                        registeredInstance.$$.smartPtr = ptr;
                        return registeredInstance["clone"]()
                    } else {
                        var rv = registeredInstance["clone"]();
                        this.destructor(ptr);
                        return rv
                    }
                }

                function makeDefaultHandle() {
                    if (this.isSmartPointer) {
                        return makeClassHandle(this.registeredClass.instancePrototype, {
                            ptrType: this.pointeeType,
                            ptr: rawPointer,
                            smartPtrType: this,
                            smartPtr: ptr
                        })
                    } else {
                        return makeClassHandle(this.registeredClass.instancePrototype, {
                            ptrType: this,
                            ptr
                        })
                    }
                }
                var actualType = this.registeredClass.getActualType(rawPointer);
                var registeredPointerRecord = registeredPointers[actualType];
                if (!registeredPointerRecord) {
                    return makeDefaultHandle.call(this)
                }
                var toType;
                if (this.isConst) {
                    toType = registeredPointerRecord.constPointerType
                } else {
                    toType = registeredPointerRecord.pointerType
                }
                var dp = downcastPointer(rawPointer, this.registeredClass, toType.registeredClass);
                if (dp === null) {
                    return makeDefaultHandle.call(this)
                }
                if (this.isSmartPointer) {
                    return makeClassHandle(toType.registeredClass.instancePrototype, {
                        ptrType: toType,
                        ptr: dp,
                        smartPtrType: this,
                        smartPtr: ptr
                    })
                } else {
                    return makeClassHandle(toType.registeredClass.instancePrototype, {
                        ptrType: toType,
                        ptr: dp
                    })
                }
            }
            var init_RegisteredPointer = () => {
                Object.assign(RegisteredPointer.prototype, {
                    getPointee(ptr) {
                        if (this.rawGetPointee) {
                            ptr = this.rawGetPointee(ptr)
                        }
                        return ptr
                    },
                    destructor(ptr) {
                        this.rawDestructor?.(ptr)
                    },
                    argPackAdvance: GenericWireTypeSize,
                    readValueFromPointer: readPointer,
                    fromWireType: RegisteredPointer_fromWireType
                })
            };
            var detachFinalizer_deps = ["$finalizationRegistry"];

            function ClassHandle() {}
            var shallowCopyInternalPointer = o => ({
                count: o.count,
                deleteScheduled: o.deleteScheduled,
                preservePointerOnDelete: o.preservePointerOnDelete,
                ptr: o.ptr,
                ptrType: o.ptrType,
                smartPtr: o.smartPtr,
                smartPtrType: o.smartPtrType
            });
            var throwInstanceAlreadyDeleted = obj => {
                function getInstanceTypeName(handle) {
                    return handle.$$.ptrType.registeredClass.name
                }
                throwBindingError(getInstanceTypeName(obj) + " instance already deleted")
            };
            var deletionQueue = [];
            var flushPendingDeletes = () => {
                while (deletionQueue.length) {
                    var obj = deletionQueue.pop();
                    obj.$$.deleteScheduled = false;
                    obj["delete"]()
                }
            };
            var delayFunction;
            var init_ClassHandle = () => {
                Object.assign(ClassHandle.prototype, {
                    isAliasOf(other) {
                        if (!(this instanceof ClassHandle)) {
                            return false
                        }
                        if (!(other instanceof ClassHandle)) {
                            return false
                        }
                        var leftClass = this.$$.ptrType.registeredClass;
                        var left = this.$$.ptr;
                        other.$$ = other.$$;
                        var rightClass = other.$$.ptrType.registeredClass;
                        var right = other.$$.ptr;
                        while (leftClass.baseClass) {
                            left = leftClass.upcast(left);
                            leftClass = leftClass.baseClass
                        }
                        while (rightClass.baseClass) {
                            right = rightClass.upcast(right);
                            rightClass = rightClass.baseClass
                        }
                        return leftClass === rightClass && left === right
                    },
                    clone() {
                        if (!this.$$.ptr) {
                            throwInstanceAlreadyDeleted(this)
                        }
                        if (this.$$.preservePointerOnDelete) {
                            this.$$.count.value += 1;
                            return this
                        } else {
                            var clone = attachFinalizer(Object.create(Object.getPrototypeOf(this), {
                                $$: {
                                    value: shallowCopyInternalPointer(this.$$)
                                }
                            }));
                            clone.$$.count.value += 1;
                            clone.$$.deleteScheduled = false;
                            return clone
                        }
                    },
                    delete() {
                        if (!this.$$.ptr) {
                            throwInstanceAlreadyDeleted(this)
                        }
                        if (this.$$.deleteScheduled && !this.$$.preservePointerOnDelete) {
                            throwBindingError("Object already scheduled for deletion")
                        }
                        detachFinalizer(this);
                        releaseClassHandle(this.$$);
                        if (!this.$$.preservePointerOnDelete) {
                            this.$$.smartPtr = undefined;
                            this.$$.ptr = undefined
                        }
                    },
                    isDeleted() {
                        return !this.$$.ptr
                    },
                    deleteLater() {
                        if (!this.$$.ptr) {
                            throwInstanceAlreadyDeleted(this)
                        }
                        if (this.$$.deleteScheduled && !this.$$.preservePointerOnDelete) {
                            throwBindingError("Object already scheduled for deletion")
                        }
                        deletionQueue.push(this);
                        if (deletionQueue.length === 1 && delayFunction) {
                            delayFunction(flushPendingDeletes)
                        }
                        this.$$.deleteScheduled = true;
                        return this
                    }
                })
            };
            var setDelayFunction = fn => {
                delayFunction = fn;
                if (deletionQueue.length && delayFunction) {
                    delayFunction(flushPendingDeletes)
                }
            };

            function RegisteredClass(name, constructor, instancePrototype, rawDestructor, baseClass, getActualType, upcast, downcast) {
                this.name = name;
                this.constructor = constructor;
                this.instancePrototype = instancePrototype;
                this.rawDestructor = rawDestructor;
                this.baseClass = baseClass;
                this.getActualType = getActualType;
                this.upcast = upcast;
                this.downcast = downcast;
                this.pureVirtualFunctions = []
            }
            var char_0 = 48;
            var char_9 = 57;
            var makeLegalFunctionName = name => {
                name = name.replace(/[^a-zA-Z0-9_]/g, "$");
                var f = name.charCodeAt(0);
                if (f >= char_0 && f <= char_9) {
                    return `_${name}`
                }
                return name
            };

            function __embind_register_class(rawType, rawPointerType, rawConstPointerType, baseClassRawType, getActualTypeSignature, getActualType, upcastSignature, upcast, downcastSignature, downcast, name, destructorSignature, rawDestructor) {
                rawType >>>= 0;
                rawPointerType >>>= 0;
                rawConstPointerType >>>= 0;
                baseClassRawType >>>= 0;
                getActualTypeSignature >>>= 0;
                getActualType >>>= 0;
                upcastSignature >>>= 0;
                upcast >>>= 0;
                downcastSignature >>>= 0;
                downcast >>>= 0;
                name >>>= 0;
                destructorSignature >>>= 0;
                rawDestructor >>>= 0;
                name = readLatin1String(name);
                getActualType = embind__requireFunction(getActualTypeSignature, getActualType);
                upcast &&= embind__requireFunction(upcastSignature, upcast);
                downcast &&= embind__requireFunction(downcastSignature, downcast);
                rawDestructor = embind__requireFunction(destructorSignature, rawDestructor);
                var legalFunctionName = makeLegalFunctionName(name);
                exposePublicSymbol(legalFunctionName, function() {
                    throwUnboundTypeError(`Cannot construct ${name} due to unbound types`, [baseClassRawType])
                });
                whenDependentTypesAreResolved([rawType, rawPointerType, rawConstPointerType], baseClassRawType ? [baseClassRawType] : [], base => {
                    base = base[0];
                    var baseClass;
                    var basePrototype;
                    if (baseClassRawType) {
                        baseClass = base.registeredClass;
                        basePrototype = baseClass.instancePrototype
                    } else {
                        basePrototype = ClassHandle.prototype
                    }
                    var constructor = createNamedFunction(name, function(...args) {
                        if (Object.getPrototypeOf(this) !== instancePrototype) {
                            throw new BindingError("Use 'new' to construct " + name)
                        }
                        if (undefined === registeredClass.constructor_body) {
                            throw new BindingError(name + " has no accessible constructor")
                        }
                        var body = registeredClass.constructor_body[args.length];
                        if (undefined === body) {
                            throw new BindingError(`Tried to invoke ctor of ${name} with invalid number of parameters (${args.length}) - expected (${Object.keys(registeredClass.constructor_body).toString()}) parameters instead!`)
                        }
                        return body.apply(this, args)
                    });
                    var instancePrototype = Object.create(basePrototype, {
                        constructor: {
                            value: constructor
                        }
                    });
                    constructor.prototype = instancePrototype;
                    var registeredClass = new RegisteredClass(name, constructor, instancePrototype, rawDestructor, baseClass, getActualType, upcast, downcast);
                    if (registeredClass.baseClass) {
                        registeredClass.baseClass.__derivedClasses ??= [];
                        registeredClass.baseClass.__derivedClasses.push(registeredClass)
                    }
                    var referenceConverter = new RegisteredPointer(name, registeredClass, true, false, false);
                    var pointerConverter = new RegisteredPointer(name + "*", registeredClass, false, false, false);
                    var constPointerConverter = new RegisteredPointer(name + " const*", registeredClass, false, true, false);
                    registeredPointers[rawType] = {
                        pointerType: pointerConverter,
                        constPointerType: constPointerConverter
                    };
                    replacePublicSymbol(legalFunctionName, constructor);
                    return [referenceConverter, pointerConverter, constPointerConverter]
                })
            }
            __embind_register_class.sig = "vppppppppppppp";
            var __embind_register_class_constructor = function(rawClassType, argCount, rawArgTypesAddr, invokerSignature, invoker, rawConstructor) {
                rawClassType >>>= 0;
                rawArgTypesAddr >>>= 0;
                invokerSignature >>>= 0;
                invoker >>>= 0;
                rawConstructor >>>= 0;
                var rawArgTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
                invoker = embind__requireFunction(invokerSignature, invoker);
                var args = [rawConstructor];
                var destructors = [];
                whenDependentTypesAreResolved([], [rawClassType], classType => {
                    classType = classType[0];
                    var humanName = `constructor ${classType.name}`;
                    if (undefined === classType.registeredClass.constructor_body) {
                        classType.registeredClass.constructor_body = []
                    }
                    if (undefined !== classType.registeredClass.constructor_body[argCount - 1]) {
                        throw new BindingError(`Cannot register multiple constructors with identical number of parameters (${argCount-1}) for class '${classType.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`)
                    }
                    classType.registeredClass.constructor_body[argCount - 1] = () => {
                        throwUnboundTypeError(`Cannot construct ${classType.name} due to unbound types`, rawArgTypes)
                    };
                    whenDependentTypesAreResolved([], rawArgTypes, argTypes => {
                        argTypes.splice(1, 0, null);
                        classType.registeredClass.constructor_body[argCount - 1] = craftInvokerFunction(humanName, argTypes, null, invoker, rawConstructor);
                        return []
                    });
                    return []
                })
            };
            __embind_register_class_constructor.sig = "vpipppp";
            var validateThis = (this_, classType, humanName) => {
                if (!(this_ instanceof Object)) {
                    throwBindingError(`${humanName} with invalid "this": ${this_}`)
                }
                if (!(this_ instanceof classType.registeredClass.constructor)) {
                    throwBindingError(`${humanName} incompatible with "this" of type ${this_.constructor.name}`)
                }
                if (!this_.$$.ptr) {
                    throwBindingError(`cannot call emscripten binding method ${humanName} on deleted object`)
                }
                return upcastPointer(this_.$$.ptr, this_.$$.ptrType.registeredClass, classType.registeredClass)
            };
            var __embind_register_class_function = function(rawClassType, methodName, argCount, rawArgTypesAddr, invokerSignature, rawInvoker, context, isPureVirtual, isAsync, isNonnullReturn) {
                rawClassType >>>= 0;
                methodName >>>= 0;
                rawArgTypesAddr >>>= 0;
                invokerSignature >>>= 0;
                rawInvoker >>>= 0;
                context >>>= 0;
                var rawArgTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
                methodName = readLatin1String(methodName);
                methodName = getFunctionName(methodName);
                rawInvoker = embind__requireFunction(invokerSignature, rawInvoker);
                whenDependentTypesAreResolved([], [rawClassType], classType => {
                    classType = classType[0];
                    var humanName = `${classType.name}.${methodName}`;
                    if (methodName.startsWith("@@")) {
                        methodName = Symbol[methodName.substring(2)]
                    }
                    if (isPureVirtual) {
                        classType.registeredClass.pureVirtualFunctions.push(methodName)
                    }

                    function unboundTypesHandler() {
                        throwUnboundTypeError(`Cannot call ${humanName} due to unbound types`, rawArgTypes)
                    }
                    var proto = classType.registeredClass.instancePrototype;
                    var method = proto[methodName];
                    if (undefined === method || undefined === method.overloadTable && method.className !== classType.name && method.argCount === argCount - 2) {
                        unboundTypesHandler.argCount = argCount - 2;
                        unboundTypesHandler.className = classType.name;
                        proto[methodName] = unboundTypesHandler
                    } else {
                        ensureOverloadTable(proto, methodName, humanName);
                        proto[methodName].overloadTable[argCount - 2] = unboundTypesHandler
                    }
                    whenDependentTypesAreResolved([], rawArgTypes, argTypes => {
                        var memberFunction = craftInvokerFunction(humanName, argTypes, classType, rawInvoker, context, isAsync);
                        if (undefined === proto[methodName].overloadTable) {
                            memberFunction.argCount = argCount - 2;
                            proto[methodName] = memberFunction
                        } else {
                            proto[methodName].overloadTable[argCount - 2] = memberFunction
                        }
                        return []
                    });
                    return []
                })
            };
            __embind_register_class_function.sig = "vppippppiii";
            var __embind_register_class_property = function(classType, fieldName, getterReturnType, getterSignature, getter, getterContext, setterArgumentType, setterSignature, setter, setterContext) {
                classType >>>= 0;
                fieldName >>>= 0;
                getterReturnType >>>= 0;
                getterSignature >>>= 0;
                getter >>>= 0;
                getterContext >>>= 0;
                setterArgumentType >>>= 0;
                setterSignature >>>= 0;
                setter >>>= 0;
                setterContext >>>= 0;
                fieldName = readLatin1String(fieldName);
                getter = embind__requireFunction(getterSignature, getter);
                whenDependentTypesAreResolved([], [classType], classType => {
                    classType = classType[0];
                    var humanName = `${classType.name}.${fieldName}`;
                    var desc = {
                        get() {
                            throwUnboundTypeError(`Cannot access ${humanName} due to unbound types`, [getterReturnType, setterArgumentType])
                        },
                        enumerable: true,
                        configurable: true
                    };
                    if (setter) {
                        desc.set = () => throwUnboundTypeError(`Cannot access ${humanName} due to unbound types`, [getterReturnType, setterArgumentType])
                    } else {
                        desc.set = v => throwBindingError(humanName + " is a read-only property")
                    }
                    Object.defineProperty(classType.registeredClass.instancePrototype, fieldName, desc);
                    whenDependentTypesAreResolved([], setter ? [getterReturnType, setterArgumentType] : [getterReturnType], types => {
                        var getterReturnType = types[0];
                        var desc = {
                            get() {
                                var ptr = validateThis(this, classType, humanName + " getter");
                                return getterReturnType["fromWireType"](getter(getterContext, ptr))
                            },
                            enumerable: true
                        };
                        if (setter) {
                            setter = embind__requireFunction(setterSignature, setter);
                            var setterArgumentType = types[1];
                            desc.set = function(v) {
                                var ptr = validateThis(this, classType, humanName + " setter");
                                var destructors = [];
                                setter(setterContext, ptr, setterArgumentType["toWireType"](destructors, v));
                                runDestructors(destructors)
                            }
                        }
                        Object.defineProperty(classType.registeredClass.instancePrototype, fieldName, desc);
                        return []
                    });
                    return []
                })
            };
            __embind_register_class_property.sig = "vpppppppppp";
            var __embind_register_class_class_function = function(rawClassType, methodName, argCount, rawArgTypesAddr, invokerSignature, rawInvoker, fn, isAsync, isNonnullReturn) {
                rawClassType >>>= 0;
                methodName >>>= 0;
                rawArgTypesAddr >>>= 0;
                invokerSignature >>>= 0;
                rawInvoker >>>= 0;
                fn >>>= 0;
                var rawArgTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
                methodName = readLatin1String(methodName);
                methodName = getFunctionName(methodName);
                rawInvoker = embind__requireFunction(invokerSignature, rawInvoker);
                whenDependentTypesAreResolved([], [rawClassType], classType => {
                    classType = classType[0];
                    var humanName = `${classType.name}.${methodName}`;

                    function unboundTypesHandler() {
                        throwUnboundTypeError(`Cannot call ${humanName} due to unbound types`, rawArgTypes)
                    }
                    if (methodName.startsWith("@@")) {
                        methodName = Symbol[methodName.substring(2)]
                    }
                    var proto = classType.registeredClass.constructor;
                    if (undefined === proto[methodName]) {
                        unboundTypesHandler.argCount = argCount - 1;
                        proto[methodName] = unboundTypesHandler
                    } else {
                        ensureOverloadTable(proto, methodName, humanName);
                        proto[methodName].overloadTable[argCount - 1] = unboundTypesHandler
                    }
                    whenDependentTypesAreResolved([], rawArgTypes, argTypes => {
                        var invokerArgsArray = [argTypes[0], null].concat(argTypes.slice(1));
                        var func = craftInvokerFunction(humanName, invokerArgsArray, null, rawInvoker, fn, isAsync);
                        if (undefined === proto[methodName].overloadTable) {
                            func.argCount = argCount - 1;
                            proto[methodName] = func
                        } else {
                            proto[methodName].overloadTable[argCount - 1] = func
                        }
                        if (classType.registeredClass.__derivedClasses) {
                            for (const derivedClass of classType.registeredClass.__derivedClasses) {
                                if (!derivedClass.constructor.hasOwnProperty(methodName)) {
                                    derivedClass.constructor[methodName] = func
                                }
                            }
                        }
                        return []
                    });
                    return []
                })
            };
            __embind_register_class_class_function.sig = "vppippppii";
            var __embind_register_class_class_property = function(rawClassType, fieldName, rawFieldType, rawFieldPtr, getterSignature, getter, setterSignature, setter) {
                rawClassType >>>= 0;
                fieldName >>>= 0;
                rawFieldType >>>= 0;
                rawFieldPtr >>>= 0;
                getterSignature >>>= 0;
                getter >>>= 0;
                setterSignature >>>= 0;
                setter >>>= 0;
                fieldName = readLatin1String(fieldName);
                getter = embind__requireFunction(getterSignature, getter);
                whenDependentTypesAreResolved([], [rawClassType], classType => {
                    classType = classType[0];
                    var humanName = `${classType.name}.${fieldName}`;
                    var desc = {
                        get() {
                            throwUnboundTypeError(`Cannot access ${humanName} due to unbound types`, [rawFieldType])
                        },
                        enumerable: true,
                        configurable: true
                    };
                    if (setter) {
                        desc.set = () => {
                            throwUnboundTypeError(`Cannot access ${humanName} due to unbound types`, [rawFieldType])
                        }
                    } else {
                        desc.set = v => {
                            throwBindingError(`${humanName} is a read-only property`)
                        }
                    }
                    Object.defineProperty(classType.registeredClass.constructor, fieldName, desc);
                    whenDependentTypesAreResolved([], [rawFieldType], fieldType => {
                        fieldType = fieldType[0];
                        var desc = {
                            get() {
                                return fieldType["fromWireType"](getter(rawFieldPtr))
                            },
                            enumerable: true
                        };
                        if (setter) {
                            setter = embind__requireFunction(setterSignature, setter);
                            desc.set = v => {
                                var destructors = [];
                                setter(rawFieldPtr, fieldType["toWireType"](destructors, v));
                                runDestructors(destructors)
                            }
                        }
                        Object.defineProperty(classType.registeredClass.constructor, fieldName, desc);
                        return []
                    });
                    return []
                })
            };
            __embind_register_class_class_property.sig = "vpppppppp";

            function __embind_create_inheriting_constructor(constructorName, wrapperType, properties) {
                constructorName >>>= 0;
                wrapperType >>>= 0;
                properties >>>= 0;
                constructorName = readLatin1String(constructorName);
                wrapperType = requireRegisteredType(wrapperType, "wrapper");
                properties = Emval.toValue(properties);
                var registeredClass = wrapperType.registeredClass;
                var wrapperPrototype = registeredClass.instancePrototype;
                var baseClass = registeredClass.baseClass;
                var baseClassPrototype = baseClass.instancePrototype;
                var baseConstructor = registeredClass.baseClass.constructor;
                var ctor = createNamedFunction(constructorName, function(...args) {
                    registeredClass.baseClass.pureVirtualFunctions.forEach(function(name) {
                        if (this[name] === baseClassPrototype[name]) {
                            throw new PureVirtualError(`Pure virtual function ${name} must be implemented in JavaScript`)
                        }
                    }.bind(this));
                    Object.defineProperty(this, "__parent", {
                        value: wrapperPrototype
                    });
                    this["__construct"](...args)
                });
                wrapperPrototype["__construct"] = function __construct(...args) {
                    if (this === wrapperPrototype) {
                        throwBindingError("Pass correct 'this' to __construct")
                    }
                    var inner = baseConstructor["implement"](this, ...args);
                    detachFinalizer(inner);
                    var $$ = inner.$$;
                    inner["notifyOnDestruction"]();
                    $$.preservePointerOnDelete = true;
                    Object.defineProperties(this, {
                        $$: {
                            value: $$
                        }
                    });
                    attachFinalizer(this);
                    registerInheritedInstance(registeredClass, $$.ptr, this)
                };
                wrapperPrototype["__destruct"] = function __destruct() {
                    if (this === wrapperPrototype) {
                        throwBindingError("Pass correct 'this' to __destruct")
                    }
                    detachFinalizer(this);
                    unregisterInheritedInstance(registeredClass, this.$$.ptr)
                };
                ctor.prototype = Object.create(wrapperPrototype);
                Object.assign(ctor.prototype, properties);
                return Emval.toHandle(ctor)
            }
            __embind_create_inheriting_constructor.sig = "pppp";
            var __embind_register_smart_ptr = function(rawType, rawPointeeType, name, sharingPolicy, getPointeeSignature, rawGetPointee, constructorSignature, rawConstructor, shareSignature, rawShare, destructorSignature, rawDestructor) {
                rawType >>>= 0;
                rawPointeeType >>>= 0;
                name >>>= 0;
                getPointeeSignature >>>= 0;
                rawGetPointee >>>= 0;
                constructorSignature >>>= 0;
                rawConstructor >>>= 0;
                shareSignature >>>= 0;
                rawShare >>>= 0;
                destructorSignature >>>= 0;
                rawDestructor >>>= 0;
                name = readLatin1String(name);
                rawGetPointee = embind__requireFunction(getPointeeSignature, rawGetPointee);
                rawConstructor = embind__requireFunction(constructorSignature, rawConstructor);
                rawShare = embind__requireFunction(shareSignature, rawShare);
                rawDestructor = embind__requireFunction(destructorSignature, rawDestructor);
                whenDependentTypesAreResolved([rawType], [rawPointeeType], pointeeType => {
                    pointeeType = pointeeType[0];
                    var registeredPointer = new RegisteredPointer(name, pointeeType.registeredClass, false, false, true, pointeeType, sharingPolicy, rawGetPointee, rawConstructor, rawShare, rawDestructor);
                    return [registeredPointer]
                })
            };
            __embind_register_smart_ptr.sig = "vpppipppppppp";

            function __embind_register_enum(rawType, name, size, isSigned) {
                rawType >>>= 0;
                name >>>= 0;
                size >>>= 0;
                name = readLatin1String(name);

                function ctor() {}
                ctor.values = {};
                registerType(rawType, {
                    name,
                    constructor: ctor,
                    fromWireType: function(c) {
                        return this.constructor.values[c]
                    },
                    toWireType: (destructors, c) => c.value,
                    argPackAdvance: GenericWireTypeSize,
                    readValueFromPointer: enumReadValueFromPointer(name, size, isSigned),
                    destructorFunction: null
                });
                exposePublicSymbol(name, ctor)
            }
            __embind_register_enum.sig = "vpppi";

            function __embind_register_enum_value(rawEnumType, name, enumValue) {
                rawEnumType >>>= 0;
                name >>>= 0;
                var enumType = requireRegisteredType(rawEnumType, "enum");
                name = readLatin1String(name);
                var Enum = enumType.constructor;
                var Value = Object.create(enumType.constructor.prototype, {
                    value: {
                        value: enumValue
                    },
                    constructor: {
                        value: createNamedFunction(`${enumType.name}_${name}`, function() {})
                    }
                });
                Enum.values[enumValue] = Value;
                Enum[name] = Value
            }
            __embind_register_enum_value.sig = "vppi";
            var __embind_register_constant = function(name, type, value) {
                name >>>= 0;
                type >>>= 0;
                name = readLatin1String(name);
                whenDependentTypesAreResolved([], [type], type => {
                    type = type[0];
                    Module[name] = type["fromWireType"](value);
                    return []
                })
            };
            __embind_register_constant.sig = "vppd";

            function __emval_register_symbol(address) {
                address >>>= 0;
                emval_symbols[address] = readLatin1String(address)
            }
            __emval_register_symbol.sig = "vp";

            function __emval_incref(handle) {
                handle >>>= 0;
                if (handle > 9) {
                    emval_handles[handle + 1] += 1
                }
            }
            __emval_incref.sig = "vp";

            function __emval_new_array() {
                return Emval.toHandle([])
            }
            __emval_new_array.sig = "p";

            function __emval_new_array_from_memory_view(view) {
                view >>>= 0;
                view = Emval.toValue(view);
                var a = new Array(view.length);
                for (var i = 0; i < view.length; i++) a[i] = view[i];
                return Emval.toHandle(a)
            }
            __emval_new_array_from_memory_view.sig = "pp";

            function __emval_new_object() {
                return Emval.toHandle({})
            }
            __emval_new_object.sig = "p";

            function __emval_new_cstring(v) {
                v >>>= 0;
                return Emval.toHandle(getStringOrSymbol(v))
            }
            __emval_new_cstring.sig = "pp";

            function __emval_new_u8string(v) {
                v >>>= 0;
                return Emval.toHandle(UTF8ToString(v))
            }
            __emval_new_u8string.sig = "pp";

            function __emval_new_u16string(v) {
                v >>>= 0;
                return Emval.toHandle(UTF16ToString(v))
            }
            __emval_new_u16string.sig = "pp";

            function __emval_take_value(type, arg) {
                type >>>= 0;
                arg >>>= 0;
                type = requireRegisteredType(type, "_emval_take_value");
                var v = type["readValueFromPointer"](arg);
                return Emval.toHandle(v)
            }
            __emval_take_value.sig = "ppp";

            function __emval_get_module_property(name) {
                name >>>= 0;
                name = getStringOrSymbol(name);
                return Emval.toHandle(Module[name])
            }
            __emval_get_module_property.sig = "pp";

            function __emval_get_property(handle, key) {
                handle >>>= 0;
                key >>>= 0;
                handle = Emval.toValue(handle);
                key = Emval.toValue(key);
                return Emval.toHandle(handle[key])
            }
            __emval_get_property.sig = "ppp";

            function __emval_set_property(handle, key, value) {
                handle >>>= 0;
                key >>>= 0;
                value >>>= 0;
                handle = Emval.toValue(handle);
                key = Emval.toValue(key);
                value = Emval.toValue(value);
                handle[key] = value
            }
            __emval_set_property.sig = "vppp";

            function __emval_as(handle, returnType, destructorsRef) {
                handle >>>= 0;
                returnType >>>= 0;
                destructorsRef >>>= 0;
                handle = Emval.toValue(handle);
                returnType = requireRegisteredType(returnType, "emval::as");
                return emval_returnValue(returnType, destructorsRef, handle)
            }
            __emval_as.sig = "dppp";

            function __emval_as_int64(handle, returnType) {
                handle >>>= 0;
                returnType >>>= 0;
                handle = Emval.toValue(handle);
                returnType = requireRegisteredType(returnType, "emval::as");
                return returnType["toWireType"](null, handle)
            }
            __emval_as_int64.sig = "ipp";

            function __emval_as_uint64(handle, returnType) {
                handle >>>= 0;
                returnType >>>= 0;
                handle = Emval.toValue(handle);
                returnType = requireRegisteredType(returnType, "emval::as");
                return returnType["toWireType"](null, handle)
            }
            __emval_as_uint64.sig = "ipp";

            function __emval_equals(first, second) {
                first >>>= 0;
                second >>>= 0;
                first = Emval.toValue(first);
                second = Emval.toValue(second);
                return first == second
            }
            __emval_equals.sig = "ipp";

            function __emval_strictly_equals(first, second) {
                first >>>= 0;
                second >>>= 0;
                first = Emval.toValue(first);
                second = Emval.toValue(second);
                return first === second
            }
            __emval_strictly_equals.sig = "ipp";

            function __emval_greater_than(first, second) {
                first >>>= 0;
                second >>>= 0;
                first = Emval.toValue(first);
                second = Emval.toValue(second);
                return first > second
            }
            __emval_greater_than.sig = "ipp";

            function __emval_less_than(first, second) {
                first >>>= 0;
                second >>>= 0;
                first = Emval.toValue(first);
                second = Emval.toValue(second);
                return first < second
            }
            __emval_less_than.sig = "ipp";

            function __emval_not(object) {
                object >>>= 0;
                object = Emval.toValue(object);
                return !object
            }
            __emval_not.sig = "ip";

            function __emval_call(caller, handle, destructorsRef, args) {
                caller >>>= 0;
                handle >>>= 0;
                destructorsRef >>>= 0;
                args >>>= 0;
                caller = emval_methodCallers[caller];
                handle = Emval.toValue(handle);
                return caller(null, handle, destructorsRef, args)
            }
            __emval_call.sig = "dpppp";

            function __emval_typeof(handle) {
                handle >>>= 0;
                handle = Emval.toValue(handle);
                return Emval.toHandle(typeof handle)
            }
            __emval_typeof.sig = "pp";

            function __emval_instanceof(object, constructor) {
                object >>>= 0;
                constructor >>>= 0;
                object = Emval.toValue(object);
                constructor = Emval.toValue(constructor);
                return object instanceof constructor
            }
            __emval_instanceof.sig = "ipp";

            function __emval_is_number(handle) {
                handle >>>= 0;
                handle = Emval.toValue(handle);
                return typeof handle == "number"
            }
            __emval_is_number.sig = "ip";

            function __emval_is_string(handle) {
                handle >>>= 0;
                handle = Emval.toValue(handle);
                return typeof handle == "string"
            }
            __emval_is_string.sig = "ip";

            function __emval_in(item, object) {
                item >>>= 0;
                object >>>= 0;
                item = Emval.toValue(item);
                object = Emval.toValue(object);
                return item in object
            }
            __emval_in.sig = "ipp";

            function __emval_delete(object, property) {
                object >>>= 0;
                property >>>= 0;
                object = Emval.toValue(object);
                property = Emval.toValue(property);
                return delete object[property]
            }
            __emval_delete.sig = "ipp";

            function __emval_throw(object) {
                object >>>= 0;
                object = Emval.toValue(object);
                throw object
            }
            __emval_throw.sig = "ip";

            function __emval_iter_begin(iterable) {
                iterable >>>= 0;
                iterable = Emval.toValue(iterable);
                return Emval.toHandle(iterable[Symbol.iterator]())
            }
            __emval_iter_begin.sig = "pp";

            function __emval_iter_next(iterator) {
                iterator >>>= 0;
                iterator = Emval.toValue(iterator);
                var result = iterator.next();
                return result.done ? 0 : Emval.toHandle(result.value)
            }
            __emval_iter_next.sig = "pp";
            var __emval_coro_suspend = function(promiseHandle, awaiterPtr) {
                promiseHandle >>>= 0;
                awaiterPtr >>>= 0;
                Emval.toValue(promiseHandle).then(result => {
                    __emval_coro_resume(awaiterPtr, Emval.toHandle(result))
                })
            };
            __emval_coro_suspend.sig = "vpp";
            var __emval_coro_make_promise = function(resolveHandlePtr, rejectHandlePtr) {
                resolveHandlePtr >>>= 0;
                rejectHandlePtr >>>= 0;
                return Emval.toHandle(new Promise((resolve, reject) => {
                    const rejectWithCurrentException = () => {
                        try {
                            ___cxa_rethrow()
                        } catch (e) {
                            reject(e)
                        }
                    };
                    HEAPU32[resolveHandlePtr >>> 2 >>> 0] = Emval.toHandle(resolve);
                    HEAPU32[rejectHandlePtr >>> 2 >>> 0] = Emval.toHandle(rejectWithCurrentException)
                }))
            };
            __emval_coro_make_promise.sig = "ppp";

            function _duckdb_web_fs_file_sync(fileId) {
                return globalThis.DUCKDB_RUNTIME.syncFile(Module, fileId)
            }
            _duckdb_web_fs_file_sync.sig = "vi";

            function _duckdb_web_fs_file_get_last_modified_time(fileId) {
                return globalThis.DUCKDB_RUNTIME.getLastFileModificationTime(Module, fileId)
            }
            _duckdb_web_fs_file_get_last_modified_time.sig = "di";

            function _duckdb_web_fs_file_remove(path, pathLen) {
                return globalThis.DUCKDB_RUNTIME.removeFile(Module, path, pathLen)
            }
            registerWasmPlugin();
            FS.createPreloadedFile = FS_createPreloadedFile;
            FS.staticInit();
            embind_init_charCodes();
            BindingError = Module["BindingError"] = class BindingError extends Error {
                constructor(message) {
                    super(message);
                    this.name = "BindingError"
                }
            };
            InternalError = Module["InternalError"] = class InternalError extends Error {
                constructor(message) {
                    super(message);
                    this.name = "InternalError"
                }
            };
            init_emval();
            Module["requestAnimationFrame"] = MainLoop.requestAnimationFrame;
            Module["pauseMainLoop"] = MainLoop.pause;
            Module["resumeMainLoop"] = MainLoop.resume;
            MainLoop.init();
            for (var i = 0; i < 32; ++i) tempFixedLengthArray.push(new Array(i));
            var miniTempWebGLFloatBuffersStorage = new Float32Array(288);
            for (var i = 0; i <= 288; ++i) {
                miniTempWebGLFloatBuffers[i] = miniTempWebGLFloatBuffersStorage.subarray(0, i)
            }
            var miniTempWebGLIntBuffersStorage = new Int32Array(288);
            for (var i = 0; i <= 288; ++i) {
                miniTempWebGLIntBuffers[i] = miniTempWebGLIntBuffersStorage.subarray(0, i)
            }
            var emSetImmediate;
            var emClearImmediate;
            if (typeof setImmediate != "undefined") {
                emSetImmediate = setImmediateWrapped;
                emClearImmediate = clearImmediateWrapped
            } else if (typeof addEventListener == "function") {
                var __setImmediate_id_counter = 0;
                var __setImmediate_queue = [];
                var __setImmediate_message_id = "_si";
                var __setImmediate_cb = e => {
                    if (e.data === __setImmediate_message_id) {
                        e.stopPropagation();
                        __setImmediate_queue.shift()();
                        ++__setImmediate_id_counter
                    }
                };
                addEventListener("message", __setImmediate_cb, true);
                emSetImmediate = func => {
                    postMessage(__setImmediate_message_id, "*");
                    return __setImmediate_id_counter + __setImmediate_queue.push(func) - 1
                };
                emClearImmediate = id => {
                    var index = id - __setImmediate_id_counter;
                    if (index >= 0 && index < __setImmediate_queue.length) __setImmediate_queue[index] = () => {}
                }
            }
            Module["requestFullscreen"] = Browser.requestFullscreen;
            Module["setCanvasSize"] = Browser.setCanvasSize;
            Module["getUserMedia"] = Browser.getUserMedia;
            Module["createContext"] = Browser.createContext;
            var preloadedImages = {};
            var preloadedAudios = {};
            registerPostMainLoop(() => SDL.audio?.queueNewAudioData?.());
            UnboundTypeError = Module["UnboundTypeError"] = extendError(Error, "UnboundTypeError");
            PureVirtualError = Module["PureVirtualError"] = extendError(Error, "PureVirtualError");
            init_RegisteredPointer();
            init_ClassHandle();
            var wasmImports = {
                IMG_Init: _IMG_Init,
                IMG_Load: _IMG_Load,
                IMG_Load_RW: _IMG_Load_RW,
                IMG_Quit: _IMG_Quit,
                Mix_AllocateChannels: _Mix_AllocateChannels,
                Mix_ChannelFinished: _Mix_ChannelFinished,
                Mix_CloseAudio: _Mix_CloseAudio,
                Mix_FadeInChannelTimed: _Mix_FadeInChannelTimed,
                Mix_FadeInMusicPos: _Mix_FadeInMusicPos,
                Mix_FadeOutChannel: _Mix_FadeOutChannel,
                Mix_FadeOutMusic: _Mix_FadeOutMusic,
                Mix_FadingChannel: _Mix_FadingChannel,
                Mix_FreeChunk: _Mix_FreeChunk,
                Mix_FreeMusic: _Mix_FreeMusic,
                Mix_HaltChannel: _Mix_HaltChannel,
                Mix_HaltMusic: _Mix_HaltMusic,
                Mix_HookMusicFinished: _Mix_HookMusicFinished,
                Mix_Init: _Mix_Init,
                Mix_Linked_Version: _Mix_Linked_Version,
                Mix_LoadMUS: _Mix_LoadMUS,
                Mix_LoadMUS_RW: _Mix_LoadMUS_RW,
                Mix_LoadWAV: _Mix_LoadWAV,
                Mix_LoadWAV_RW: _Mix_LoadWAV_RW,
                Mix_OpenAudio: _Mix_OpenAudio,
                Mix_Pause: _Mix_Pause,
                Mix_PauseMusic: _Mix_PauseMusic,
                Mix_Paused: _Mix_Paused,
                Mix_PausedMusic: _Mix_PausedMusic,
                Mix_PlayChannelTimed: _Mix_PlayChannelTimed,
                Mix_PlayMusic: _Mix_PlayMusic,
                Mix_Playing: _Mix_Playing,
                Mix_PlayingMusic: _Mix_PlayingMusic,
                Mix_QuerySpec: _Mix_QuerySpec,
                Mix_QuickLoad_RAW: _Mix_QuickLoad_RAW,
                Mix_Quit: _Mix_Quit,
                Mix_ReserveChannels: _Mix_ReserveChannels,
                Mix_Resume: _Mix_Resume,
                Mix_ResumeMusic: _Mix_ResumeMusic,
                Mix_SetPanning: _Mix_SetPanning,
                Mix_SetPosition: _Mix_SetPosition,
                Mix_SetPostMix: _Mix_SetPostMix,
                Mix_Volume: _Mix_Volume,
                Mix_VolumeChunk: _Mix_VolumeChunk,
                Mix_VolumeMusic: _Mix_VolumeMusic,
                SDL_AddTimer: _SDL_AddTimer,
                SDL_AllocRW: _SDL_AllocRW,
                SDL_AudioDriverName: _SDL_AudioDriverName,
                SDL_AudioQuit: _SDL_AudioQuit,
                SDL_ClearError: _SDL_ClearError,
                SDL_CloseAudio: _SDL_CloseAudio,
                SDL_CondBroadcast: _SDL_CondBroadcast,
                SDL_CondSignal: _SDL_CondSignal,
                SDL_CondWait: _SDL_CondWait,
                SDL_CondWaitTimeout: _SDL_CondWaitTimeout,
                SDL_ConvertSurface: _SDL_ConvertSurface,
                SDL_CreateCond: _SDL_CreateCond,
                SDL_CreateMutex: _SDL_CreateMutex,
                SDL_CreateRGBSurface: _SDL_CreateRGBSurface,
                SDL_CreateRGBSurfaceFrom: _SDL_CreateRGBSurfaceFrom,
                SDL_CreateThread: _SDL_CreateThread,
                SDL_Delay: _SDL_Delay,
                SDL_DestroyCond: _SDL_DestroyCond,
                SDL_DestroyMutex: _SDL_DestroyMutex,
                SDL_DestroyRenderer: _SDL_DestroyRenderer,
                SDL_DestroyWindow: _SDL_DestroyWindow,
                SDL_DisplayFormatAlpha: _SDL_DisplayFormatAlpha,
                SDL_EnableKeyRepeat: _SDL_EnableKeyRepeat,
                SDL_EnableUNICODE: _SDL_EnableUNICODE,
                SDL_FillRect: _SDL_FillRect,
                SDL_Flip: _SDL_Flip,
                SDL_FreeRW: _SDL_FreeRW,
                SDL_FreeSurface: _SDL_FreeSurface,
                SDL_GL_DeleteContext: _SDL_GL_DeleteContext,
                SDL_GL_ExtensionSupported: _SDL_GL_ExtensionSupported,
                SDL_GL_GetAttribute: _SDL_GL_GetAttribute,
                SDL_GL_GetSwapInterval: _SDL_GL_GetSwapInterval,
                SDL_GL_MakeCurrent: _SDL_GL_MakeCurrent,
                SDL_GL_SetAttribute: _SDL_GL_SetAttribute,
                SDL_GL_SetSwapInterval: _SDL_GL_SetSwapInterval,
                SDL_GL_SwapBuffers: _SDL_GL_SwapBuffers,
                SDL_GL_SwapWindow: _SDL_GL_SwapWindow,
                SDL_GetAppState: _SDL_GetAppState,
                SDL_GetAudioDriver: _SDL_GetAudioDriver,
                SDL_GetClipRect: _SDL_GetClipRect,
                SDL_GetCurrentAudioDriver: _SDL_GetCurrentAudioDriver,
                SDL_GetError: _SDL_GetError,
                SDL_GetKeyName: _SDL_GetKeyName,
                SDL_GetKeyState: _SDL_GetKeyState,
                SDL_GetKeyboardState: _SDL_GetKeyboardState,
                SDL_GetModState: _SDL_GetModState,
                SDL_GetMouseState: _SDL_GetMouseState,
                SDL_GetNumAudioDrivers: _SDL_GetNumAudioDrivers,
                SDL_GetRGB: _SDL_GetRGB,
                SDL_GetRGBA: _SDL_GetRGBA,
                SDL_GetScancodeFromKey: _SDL_GetScancodeFromKey,
                SDL_GetThreadID: _SDL_GetThreadID,
                SDL_GetTicks: _SDL_GetTicks,
                SDL_GetVideoInfo: _SDL_GetVideoInfo,
                SDL_GetVideoSurface: _SDL_GetVideoSurface,
                SDL_GetWindowFlags: _SDL_GetWindowFlags,
                SDL_GetWindowSize: _SDL_GetWindowSize,
                SDL_Has3DNow: _SDL_Has3DNow,
                SDL_Has3DNowExt: _SDL_Has3DNowExt,
                SDL_HasAltiVec: _SDL_HasAltiVec,
                SDL_HasMMX: _SDL_HasMMX,
                SDL_HasMMXExt: _SDL_HasMMXExt,
                SDL_HasRDTSC: _SDL_HasRDTSC,
                SDL_HasSSE: _SDL_HasSSE,
                SDL_HasSSE2: _SDL_HasSSE2,
                SDL_Init: _SDL_Init,
                SDL_InitSubSystem: _SDL_InitSubSystem,
                SDL_JoystickClose: _SDL_JoystickClose,
                SDL_JoystickEventState: _SDL_JoystickEventState,
                SDL_JoystickGetAxis: _SDL_JoystickGetAxis,
                SDL_JoystickGetBall: _SDL_JoystickGetBall,
                SDL_JoystickGetButton: _SDL_JoystickGetButton,
                SDL_JoystickGetHat: _SDL_JoystickGetHat,
                SDL_JoystickIndex: _SDL_JoystickIndex,
                SDL_JoystickName: _SDL_JoystickName,
                SDL_JoystickNumAxes: _SDL_JoystickNumAxes,
                SDL_JoystickNumBalls: _SDL_JoystickNumBalls,
                SDL_JoystickNumButtons: _SDL_JoystickNumButtons,
                SDL_JoystickNumHats: _SDL_JoystickNumHats,
                SDL_JoystickOpen: _SDL_JoystickOpen,
                SDL_JoystickOpened: _SDL_JoystickOpened,
                SDL_JoystickUpdate: _SDL_JoystickUpdate,
                SDL_Linked_Version: _SDL_Linked_Version,
                SDL_ListModes: _SDL_ListModes,
                SDL_LoadBMP_RW: _SDL_LoadBMP_RW,
                SDL_LockAudio: _SDL_LockAudio,
                SDL_LockSurface: _SDL_LockSurface,
                SDL_LogSetOutputFunction: _SDL_LogSetOutputFunction,
                SDL_LowerBlit: _SDL_LowerBlit,
                SDL_LowerBlitScaled: _SDL_LowerBlitScaled,
                SDL_MapRGB: _SDL_MapRGB,
                SDL_MapRGBA: _SDL_MapRGBA,
                SDL_NumJoysticks: _SDL_NumJoysticks,
                SDL_OpenAudio: _SDL_OpenAudio,
                SDL_PauseAudio: _SDL_PauseAudio,
                SDL_PeepEvents: _SDL_PeepEvents,
                SDL_PollEvent: _SDL_PollEvent,
                SDL_PumpEvents: _SDL_PumpEvents,
                SDL_PushEvent: _SDL_PushEvent,
                SDL_Quit: _SDL_Quit,
                SDL_QuitSubSystem: _SDL_QuitSubSystem,
                SDL_RWFromConstMem: _SDL_RWFromConstMem,
                SDL_RWFromFile: _SDL_RWFromFile,
                SDL_RWFromMem: _SDL_RWFromMem,
                SDL_RemoveTimer: _SDL_RemoveTimer,
                SDL_SaveBMP_RW: _SDL_SaveBMP_RW,
                SDL_SetAlpha: _SDL_SetAlpha,
                SDL_SetClipRect: _SDL_SetClipRect,
                SDL_SetColorKey: _SDL_SetColorKey,
                SDL_SetColors: _SDL_SetColors,
                SDL_SetError: _SDL_SetError,
                SDL_SetGamma: _SDL_SetGamma,
                SDL_SetGammaRamp: _SDL_SetGammaRamp,
                SDL_SetPalette: _SDL_SetPalette,
                SDL_SetVideoMode: _SDL_SetVideoMode,
                SDL_SetWindowFullscreen: _SDL_SetWindowFullscreen,
                SDL_SetWindowTitle: _SDL_SetWindowTitle,
                SDL_ShowCursor: _SDL_ShowCursor,
                SDL_StartTextInput: _SDL_StartTextInput,
                SDL_StopTextInput: _SDL_StopTextInput,
                SDL_ThreadID: _SDL_ThreadID,
                SDL_UnlockAudio: _SDL_UnlockAudio,
                SDL_UnlockSurface: _SDL_UnlockSurface,
                SDL_UpdateRect: _SDL_UpdateRect,
                SDL_UpdateRects: _SDL_UpdateRects,
                SDL_UpperBlit: _SDL_UpperBlit,
                SDL_UpperBlitScaled: _SDL_UpperBlitScaled,
                SDL_VideoDriverName: _SDL_VideoDriverName,
                SDL_VideoModeOK: _SDL_VideoModeOK,
                SDL_VideoQuit: _SDL_VideoQuit,
                SDL_WM_GrabInput: _SDL_WM_GrabInput,
                SDL_WM_IconifyWindow: _SDL_WM_IconifyWindow,
                SDL_WM_SetCaption: _SDL_WM_SetCaption,
                SDL_WM_SetIcon: _SDL_WM_SetIcon,
                SDL_WM_ToggleFullScreen: _SDL_WM_ToggleFullScreen,
                SDL_WaitThread: _SDL_WaitThread,
                SDL_WarpMouse: _SDL_WarpMouse,
                SDL_WasInit: _SDL_WasInit,
                SDL_mutexP: _SDL_mutexP,
                SDL_mutexV: _SDL_mutexV,
                TTF_CloseFont: _TTF_CloseFont,
                TTF_FontAscent: _TTF_FontAscent,
                TTF_FontDescent: _TTF_FontDescent,
                TTF_FontHeight: _TTF_FontHeight,
                TTF_FontLineSkip: _TTF_FontLineSkip,
                TTF_GlyphMetrics: _TTF_GlyphMetrics,
                TTF_Init: _TTF_Init,
                TTF_OpenFont: _TTF_OpenFont,
                TTF_Quit: _TTF_Quit,
                TTF_RenderText_Blended: _TTF_RenderText_Blended,
                TTF_RenderText_Shaded: _TTF_RenderText_Shaded,
                TTF_RenderText_Solid: _TTF_RenderText_Solid,
                TTF_RenderUTF8_Solid: _TTF_RenderUTF8_Solid,
                TTF_SizeText: _TTF_SizeText,
                TTF_SizeUTF8: _TTF_SizeUTF8,
                XChangeWindowAttributes: _XChangeWindowAttributes,
                XCreateWindow: _XCreateWindow,
                XInternAtom: _XInternAtom,
                XMapWindow: _XMapWindow,
                XOpenDisplay: _XOpenDisplay,
                XPending: _XPending,
                XSendEvent: _XSendEvent,
                XSetWMHints: _XSetWMHints,
                XStoreName: _XStoreName,
                _Unwind_Backtrace: __Unwind_Backtrace,
                _Unwind_FindEnclosingFunction: __Unwind_FindEnclosingFunction,
                _Unwind_GetIPInfo: __Unwind_GetIPInfo,
                __asctime_r: ___asctime_r,
                __assert_fail: ___assert_fail,
                __c_longjmp: ___c_longjmp,
                __call_sighandler: ___call_sighandler,
                __cpp_exception: ___cpp_exception,
                __global_base: ___global_base,
                __heap_base: ___heap_base,
                __indirect_function_table: wasmTable,
                __memory_base: ___memory_base,
                __stack_high: ___stack_high,
                __stack_low: ___stack_low,
                __stack_pointer: ___stack_pointer,
                __syscall__newselect: ___syscall__newselect,
                __syscall_accept4: ___syscall_accept4,
                __syscall_bind: ___syscall_bind,
                __syscall_chdir: ___syscall_chdir,
                __syscall_chmod: ___syscall_chmod,
                __syscall_connect: ___syscall_connect,
                __syscall_dup: ___syscall_dup,
                __syscall_dup3: ___syscall_dup3,
                __syscall_faccessat: ___syscall_faccessat,
                __syscall_fadvise64: ___syscall_fadvise64,
                __syscall_fallocate: ___syscall_fallocate,
                __syscall_fchdir: ___syscall_fchdir,
                __syscall_fchmod: ___syscall_fchmod,
                __syscall_fchmodat2: ___syscall_fchmodat2,
                __syscall_fchown32: ___syscall_fchown32,
                __syscall_fchownat: ___syscall_fchownat,
                __syscall_fcntl64: ___syscall_fcntl64,
                __syscall_fdatasync: ___syscall_fdatasync,
                __syscall_fstat64: ___syscall_fstat64,
                __syscall_fstatfs64: ___syscall_fstatfs64,
                __syscall_ftruncate64: ___syscall_ftruncate64,
                __syscall_getcwd: ___syscall_getcwd,
                __syscall_getdents64: ___syscall_getdents64,
                __syscall_getpeername: ___syscall_getpeername,
                __syscall_getsockname: ___syscall_getsockname,
                __syscall_getsockopt: ___syscall_getsockopt,
                __syscall_ioctl: ___syscall_ioctl,
                __syscall_listen: ___syscall_listen,
                __syscall_lstat64: ___syscall_lstat64,
                __syscall_mkdirat: ___syscall_mkdirat,
                __syscall_mknodat: ___syscall_mknodat,
                __syscall_newfstatat: ___syscall_newfstatat,
                __syscall_openat: ___syscall_openat,
                __syscall_pipe: ___syscall_pipe,
                __syscall_poll: ___syscall_poll,
                __syscall_readlinkat: ___syscall_readlinkat,
                __syscall_recvfrom: ___syscall_recvfrom,
                __syscall_recvmsg: ___syscall_recvmsg,
                __syscall_renameat: ___syscall_renameat,
                __syscall_rmdir: ___syscall_rmdir,
                __syscall_sendmsg: ___syscall_sendmsg,
                __syscall_sendto: ___syscall_sendto,
                __syscall_socket: ___syscall_socket,
                __syscall_stat64: ___syscall_stat64,
                __syscall_statfs64: ___syscall_statfs64,
                __syscall_symlink: ___syscall_symlink,
                __syscall_symlinkat: ___syscall_symlinkat,
                __syscall_truncate64: ___syscall_truncate64,
                __syscall_unlinkat: ___syscall_unlinkat,
                __syscall_utimensat: ___syscall_utimensat,
                __table_base: ___table_base,
                _abort_js: __abort_js,
                _dlopen_js: __dlopen_js,
                _dlsym_catchup_js: __dlsym_catchup_js,
                _dlsym_js: __dlsym_js,
                _embind_create_inheriting_constructor: __embind_create_inheriting_constructor,
                _embind_finalize_value_array: __embind_finalize_value_array,
                _embind_finalize_value_object: __embind_finalize_value_object,
                _embind_register_bigint: __embind_register_bigint,
                _embind_register_bool: __embind_register_bool,
                _embind_register_class: __embind_register_class,
                _embind_register_class_class_function: __embind_register_class_class_function,
                _embind_register_class_class_property: __embind_register_class_class_property,
                _embind_register_class_constructor: __embind_register_class_constructor,
                _embind_register_class_function: __embind_register_class_function,
                _embind_register_class_property: __embind_register_class_property,
                _embind_register_constant: __embind_register_constant,
                _embind_register_emval: __embind_register_emval,
                _embind_register_enum: __embind_register_enum,
                _embind_register_enum_value: __embind_register_enum_value,
                _embind_register_float: __embind_register_float,
                _embind_register_function: __embind_register_function,
                _embind_register_integer: __embind_register_integer,
                _embind_register_memory_view: __embind_register_memory_view,
                _embind_register_optional: __embind_register_optional,
                _embind_register_smart_ptr: __embind_register_smart_ptr,
                _embind_register_std_string: __embind_register_std_string,
                _embind_register_std_wstring: __embind_register_std_wstring,
                _embind_register_user_type: __embind_register_user_type,
                _embind_register_value_array: __embind_register_value_array,
                _embind_register_value_array_element: __embind_register_value_array_element,
                _embind_register_value_object: __embind_register_value_object,
                _embind_register_value_object_field: __embind_register_value_object_field,
                _embind_register_void: __embind_register_void,
                _emscripten_dlopen_js: __emscripten_dlopen_js,
                _emscripten_fs_load_embedded_files: __emscripten_fs_load_embedded_files,
                _emscripten_get_now_is_monotonic: __emscripten_get_now_is_monotonic,
                _emscripten_get_progname: __emscripten_get_progname,
                _emscripten_lookup_name: __emscripten_lookup_name,
                _emscripten_memcpy_js: __emscripten_memcpy_js,
                _emscripten_push_main_loop_blocker: __emscripten_push_main_loop_blocker,
                _emscripten_push_uncounted_main_loop_blocker: __emscripten_push_uncounted_main_loop_blocker,
                _emscripten_runtime_keepalive_clear: __emscripten_runtime_keepalive_clear,
                _emscripten_set_offscreencanvas_size: __emscripten_set_offscreencanvas_size,
                _emscripten_system: __emscripten_system,
                _emval_as: __emval_as,
                _emval_as_int64: __emval_as_int64,
                _emval_as_uint64: __emval_as_uint64,
                _emval_call: __emval_call,
                _emval_call_method: __emval_call_method,
                _emval_coro_make_promise: __emval_coro_make_promise,
                _emval_coro_suspend: __emval_coro_suspend,
                _emval_decref: __emval_decref,
                _emval_delete: __emval_delete,
                _emval_equals: __emval_equals,
                _emval_get_global: __emval_get_global,
                _emval_get_method_caller: __emval_get_method_caller,
                _emval_get_module_property: __emval_get_module_property,
                _emval_get_property: __emval_get_property,
                _emval_greater_than: __emval_greater_than,
                _emval_in: __emval_in,
                _emval_incref: __emval_incref,
                _emval_instanceof: __emval_instanceof,
                _emval_is_number: __emval_is_number,
                _emval_is_string: __emval_is_string,
                _emval_iter_begin: __emval_iter_begin,
                _emval_iter_next: __emval_iter_next,
                _emval_less_than: __emval_less_than,
                _emval_new_array: __emval_new_array,
                _emval_new_array_from_memory_view: __emval_new_array_from_memory_view,
                _emval_new_cstring: __emval_new_cstring,
                _emval_new_object: __emval_new_object,
                _emval_new_u16string: __emval_new_u16string,
                _emval_new_u8string: __emval_new_u8string,
                _emval_not: __emval_not,
                _emval_register_symbol: __emval_register_symbol,
                _emval_run_destructors: __emval_run_destructors,
                _emval_set_property: __emval_set_property,
                _emval_strictly_equals: __emval_strictly_equals,
                _emval_take_value: __emval_take_value,
                _emval_throw: __emval_throw,
                _emval_typeof: __emval_typeof,
                _glGetActiveAttribOrUniform: __glGetActiveAttribOrUniform,
                _gmtime_js: __gmtime_js,
                _localtime_js: __localtime_js,
                _mktime_js: __mktime_js,
                _mmap_js: __mmap_js,
                _msync_js: __msync_js,
                _munmap_js: __munmap_js,
                _setitimer_js: __setitimer_js,
                _timegm_js: __timegm_js,
                _tzset_js: __tzset_js,
                alBuffer3f: _alBuffer3f,
                alBuffer3i: _alBuffer3i,
                alBufferData: _alBufferData,
                alBufferf: _alBufferf,
                alBufferfv: _alBufferfv,
                alBufferi: _alBufferi,
                alBufferiv: _alBufferiv,
                alDeleteBuffers: _alDeleteBuffers,
                alDeleteSources: _alDeleteSources,
                alDisable: _alDisable,
                alDistanceModel: _alDistanceModel,
                alDopplerFactor: _alDopplerFactor,
                alDopplerVelocity: _alDopplerVelocity,
                alEnable: _alEnable,
                alGenBuffers: _alGenBuffers,
                alGenSources: _alGenSources,
                alGetBoolean: _alGetBoolean,
                alGetBooleanv: _alGetBooleanv,
                alGetBuffer3f: _alGetBuffer3f,
                alGetBuffer3i: _alGetBuffer3i,
                alGetBufferf: _alGetBufferf,
                alGetBufferfv: _alGetBufferfv,
                alGetBufferi: _alGetBufferi,
                alGetBufferiv: _alGetBufferiv,
                alGetDouble: _alGetDouble,
                alGetDoublev: _alGetDoublev,
                alGetEnumValue: _alGetEnumValue,
                alGetError: _alGetError,
                alGetFloat: _alGetFloat,
                alGetFloatv: _alGetFloatv,
                alGetInteger: _alGetInteger,
                alGetIntegerv: _alGetIntegerv,
                alGetListener3f: _alGetListener3f,
                alGetListener3i: _alGetListener3i,
                alGetListenerf: _alGetListenerf,
                alGetListenerfv: _alGetListenerfv,
                alGetListeneri: _alGetListeneri,
                alGetListeneriv: _alGetListeneriv,
                alGetSource3f: _alGetSource3f,
                alGetSource3i: _alGetSource3i,
                alGetSourcef: _alGetSourcef,
                alGetSourcefv: _alGetSourcefv,
                alGetSourcei: _alGetSourcei,
                alGetSourceiv: _alGetSourceiv,
                alGetString: _alGetString,
                alIsBuffer: _alIsBuffer,
                alIsEnabled: _alIsEnabled,
                alIsExtensionPresent: _alIsExtensionPresent,
                alIsSource: _alIsSource,
                alListener3f: _alListener3f,
                alListener3i: _alListener3i,
                alListenerf: _alListenerf,
                alListenerfv: _alListenerfv,
                alListeneri: _alListeneri,
                alListeneriv: _alListeneriv,
                alSource3f: _alSource3f,
                alSource3i: _alSource3i,
                alSourcePause: _alSourcePause,
                alSourcePausev: _alSourcePausev,
                alSourcePlay: _alSourcePlay,
                alSourcePlayv: _alSourcePlayv,
                alSourceQueueBuffers: _alSourceQueueBuffers,
                alSourceRewind: _alSourceRewind,
                alSourceRewindv: _alSourceRewindv,
                alSourceStop: _alSourceStop,
                alSourceStopv: _alSourceStopv,
                alSourceUnqueueBuffers: _alSourceUnqueueBuffers,
                alSourcef: _alSourcef,
                alSourcefv: _alSourcefv,
                alSourcei: _alSourcei,
                alSourceiv: _alSourceiv,
                alSpeedOfSound: _alSpeedOfSound,
                alcCaptureCloseDevice: _alcCaptureCloseDevice,
                alcCaptureOpenDevice: _alcCaptureOpenDevice,
                alcCaptureSamples: _alcCaptureSamples,
                alcCaptureStart: _alcCaptureStart,
                alcCaptureStop: _alcCaptureStop,
                alcCloseDevice: _alcCloseDevice,
                alcCreateContext: _alcCreateContext,
                alcDestroyContext: _alcDestroyContext,
                alcGetContextsDevice: _alcGetContextsDevice,
                alcGetCurrentContext: _alcGetCurrentContext,
                alcGetEnumValue: _alcGetEnumValue,
                alcGetError: _alcGetError,
                alcGetIntegerv: _alcGetIntegerv,
                alcGetString: _alcGetString,
                alcIsExtensionPresent: _alcIsExtensionPresent,
                alcMakeContextCurrent: _alcMakeContextCurrent,
                alcOpenDevice: _alcOpenDevice,
                alcProcessContext: _alcProcessContext,
                alcSuspendContext: _alcSuspendContext,
                boxColor: _boxColor,
                boxRGBA: _boxRGBA,
                clock_res_get: _clock_res_get,
                clock_time_get: _clock_time_get,
                duckdb_web_fs_directory_create: _duckdb_web_fs_directory_create,
                duckdb_web_fs_directory_exists: _duckdb_web_fs_directory_exists,
                duckdb_web_fs_directory_list_files: _duckdb_web_fs_directory_list_files,
                duckdb_web_fs_directory_remove: _duckdb_web_fs_directory_remove,
                duckdb_web_fs_file_close: _duckdb_web_fs_file_close,
                duckdb_web_fs_file_drop_file: _duckdb_web_fs_file_drop_file,
                duckdb_web_fs_file_exists: _duckdb_web_fs_file_exists,
                duckdb_web_fs_file_get_last_modified_time: _duckdb_web_fs_file_get_last_modified_time,
                duckdb_web_fs_file_move: _duckdb_web_fs_file_move,
                duckdb_web_fs_file_open: _duckdb_web_fs_file_open,
                duckdb_web_fs_file_read: _duckdb_web_fs_file_read,
                duckdb_web_fs_file_remove: _duckdb_web_fs_file_remove,
                duckdb_web_fs_file_sync: _duckdb_web_fs_file_sync,
                duckdb_web_fs_file_truncate: _duckdb_web_fs_file_truncate,
                duckdb_web_fs_file_write: _duckdb_web_fs_file_write,
                duckdb_web_fs_get_default_data_protocol: _duckdb_web_fs_get_default_data_protocol,
                duckdb_web_fs_glob: _duckdb_web_fs_glob,
                duckdb_web_test_platform_feature: _duckdb_web_test_platform_feature,
                duckdb_web_udf_scalar_call: _duckdb_web_udf_scalar_call,
                eglBindAPI: _eglBindAPI,
                eglChooseConfig: _eglChooseConfig,
                eglCreateContext: _eglCreateContext,
                eglCreateWindowSurface: _eglCreateWindowSurface,
                eglDestroyContext: _eglDestroyContext,
                eglDestroySurface: _eglDestroySurface,
                eglGetConfigAttrib: _eglGetConfigAttrib,
                eglGetConfigs: _eglGetConfigs,
                eglGetCurrentContext: _eglGetCurrentContext,
                eglGetCurrentDisplay: _eglGetCurrentDisplay,
                eglGetCurrentSurface: _eglGetCurrentSurface,
                eglGetDisplay: _eglGetDisplay,
                eglGetError: _eglGetError,
                eglInitialize: _eglInitialize,
                eglMakeCurrent: _eglMakeCurrent,
                eglQueryAPI: _eglQueryAPI,
                eglQueryContext: _eglQueryContext,
                eglQueryString: _eglQueryString,
                eglQuerySurface: _eglQuerySurface,
                eglReleaseThread: _eglReleaseThread,
                eglSwapBuffers: _eglSwapBuffers,
                eglSwapInterval: _eglSwapInterval,
                eglTerminate: _eglTerminate,
                eglWaitClient: _eglWaitClient,
                eglWaitGL: _eglWaitGL,
                eglWaitNative: _eglWaitNative,
                ellipseColor: _ellipseColor,
                ellipseRGBA: _ellipseRGBA,
                emscripten_SDL_SetEventHandler: _emscripten_SDL_SetEventHandler,
                emscripten_alcDevicePauseSOFT: _emscripten_alcDevicePauseSOFT,
                emscripten_alcDeviceResumeSOFT: _emscripten_alcDeviceResumeSOFT,
                emscripten_alcGetStringiSOFT: _emscripten_alcGetStringiSOFT,
                emscripten_alcResetDeviceSOFT: _emscripten_alcResetDeviceSOFT,
                emscripten_asm_const_async_on_main_thread: _emscripten_asm_const_async_on_main_thread,
                emscripten_asm_const_double: _emscripten_asm_const_double,
                emscripten_asm_const_double_sync_on_main_thread: _emscripten_asm_const_double_sync_on_main_thread,
                emscripten_asm_const_int: _emscripten_asm_const_int,
                emscripten_asm_const_int_sync_on_main_thread: _emscripten_asm_const_int_sync_on_main_thread,
                emscripten_asm_const_ptr: _emscripten_asm_const_ptr,
                emscripten_asm_const_ptr_sync_on_main_thread: _emscripten_asm_const_ptr_sync_on_main_thread,
                emscripten_async_call: _emscripten_async_call,
                emscripten_async_load_script: _emscripten_async_load_script,
                emscripten_async_run_script: _emscripten_async_run_script,
                emscripten_async_wget: _emscripten_async_wget,
                emscripten_async_wget2: _emscripten_async_wget2,
                emscripten_async_wget2_abort: _emscripten_async_wget2_abort,
                emscripten_async_wget2_data: _emscripten_async_wget2_data,
                emscripten_async_wget_data: _emscripten_async_wget_data,
                emscripten_call_worker: _emscripten_call_worker,
                emscripten_cancel_animation_frame: _emscripten_cancel_animation_frame,
                emscripten_cancel_main_loop: _emscripten_cancel_main_loop,
                emscripten_clear_immediate: _emscripten_clear_immediate,
                emscripten_clear_interval: _emscripten_clear_interval,
                emscripten_clear_timeout: _emscripten_clear_timeout,
                emscripten_console_error: _emscripten_console_error,
                emscripten_console_log: _emscripten_console_log,
                emscripten_console_trace: _emscripten_console_trace,
                emscripten_console_warn: _emscripten_console_warn,
                emscripten_create_worker: _emscripten_create_worker,
                emscripten_date_now: _emscripten_date_now,
                emscripten_debugger: _emscripten_debugger,
                emscripten_destroy_worker: _emscripten_destroy_worker,
                emscripten_enter_soft_fullscreen: _emscripten_enter_soft_fullscreen,
                emscripten_err: _emscripten_err,
                emscripten_errn: _emscripten_errn,
                emscripten_exit_fullscreen: _emscripten_exit_fullscreen,
                emscripten_exit_pointerlock: _emscripten_exit_pointerlock,
                emscripten_exit_soft_fullscreen: _emscripten_exit_soft_fullscreen,
                emscripten_exit_with_live_runtime: _emscripten_exit_with_live_runtime,
                emscripten_fiber_swap: _emscripten_fiber_swap,
                emscripten_force_exit: _emscripten_force_exit,
                emscripten_get_battery_status: _emscripten_get_battery_status,
                emscripten_get_callstack: _emscripten_get_callstack,
                emscripten_get_canvas_element_size: _emscripten_get_canvas_element_size,
                emscripten_get_canvas_size: _emscripten_get_canvas_size,
                emscripten_get_compiler_setting: _emscripten_get_compiler_setting,
                emscripten_get_device_pixel_ratio: _emscripten_get_device_pixel_ratio,
                emscripten_get_devicemotion_status: _emscripten_get_devicemotion_status,
                emscripten_get_deviceorientation_status: _emscripten_get_deviceorientation_status,
                emscripten_get_element_css_size: _emscripten_get_element_css_size,
                emscripten_get_fullscreen_status: _emscripten_get_fullscreen_status,
                emscripten_get_gamepad_status: _emscripten_get_gamepad_status,
                emscripten_get_heap_max: _emscripten_get_heap_max,
                emscripten_get_main_loop_timing: _emscripten_get_main_loop_timing,
                emscripten_get_mouse_status: _emscripten_get_mouse_status,
                emscripten_get_now: _emscripten_get_now,
                emscripten_get_now_res: _emscripten_get_now_res,
                emscripten_get_num_gamepads: _emscripten_get_num_gamepads,
                emscripten_get_orientation_status: _emscripten_get_orientation_status,
                emscripten_get_pointerlock_status: _emscripten_get_pointerlock_status,
                emscripten_get_preloaded_image_data: _emscripten_get_preloaded_image_data,
                emscripten_get_preloaded_image_data_from_FILE: _emscripten_get_preloaded_image_data_from_FILE,
                emscripten_get_screen_size: _emscripten_get_screen_size,
                emscripten_get_visibility_status: _emscripten_get_visibility_status,
                emscripten_get_window_title: _emscripten_get_window_title,
                emscripten_get_worker_queue_size: _emscripten_get_worker_queue_size,
                emscripten_glActiveTexture: _emscripten_glActiveTexture,
                emscripten_glAttachShader: _emscripten_glAttachShader,
                emscripten_glBegin: _emscripten_glBegin,
                emscripten_glBeginQueryEXT: _emscripten_glBeginQueryEXT,
                emscripten_glBindAttribLocation: _emscripten_glBindAttribLocation,
                emscripten_glBindBuffer: _emscripten_glBindBuffer,
                emscripten_glBindFramebuffer: _emscripten_glBindFramebuffer,
                emscripten_glBindRenderbuffer: _emscripten_glBindRenderbuffer,
                emscripten_glBindTexture: _emscripten_glBindTexture,
                emscripten_glBindVertexArray: _emscripten_glBindVertexArray,
                emscripten_glBindVertexArrayOES: _emscripten_glBindVertexArrayOES,
                emscripten_glBlendColor: _emscripten_glBlendColor,
                emscripten_glBlendEquation: _emscripten_glBlendEquation,
                emscripten_glBlendEquationSeparate: _emscripten_glBlendEquationSeparate,
                emscripten_glBlendFunc: _emscripten_glBlendFunc,
                emscripten_glBlendFuncSeparate: _emscripten_glBlendFuncSeparate,
                emscripten_glBufferData: _emscripten_glBufferData,
                emscripten_glBufferSubData: _emscripten_glBufferSubData,
                emscripten_glCheckFramebufferStatus: _emscripten_glCheckFramebufferStatus,
                emscripten_glClear: _emscripten_glClear,
                emscripten_glClearColor: _emscripten_glClearColor,
                emscripten_glClearDepth: _emscripten_glClearDepth,
                emscripten_glClearDepthf: _emscripten_glClearDepthf,
                emscripten_glClearStencil: _emscripten_glClearStencil,
                emscripten_glClipControlEXT: _emscripten_glClipControlEXT,
                emscripten_glColorMask: _emscripten_glColorMask,
                emscripten_glCompileShader: _emscripten_glCompileShader,
                emscripten_glCompressedTexImage2D: _emscripten_glCompressedTexImage2D,
                emscripten_glCompressedTexSubImage2D: _emscripten_glCompressedTexSubImage2D,
                emscripten_glCopyTexImage2D: _emscripten_glCopyTexImage2D,
                emscripten_glCopyTexSubImage2D: _emscripten_glCopyTexSubImage2D,
                emscripten_glCreateProgram: _emscripten_glCreateProgram,
                emscripten_glCreateShader: _emscripten_glCreateShader,
                emscripten_glCullFace: _emscripten_glCullFace,
                emscripten_glDeleteBuffers: _emscripten_glDeleteBuffers,
                emscripten_glDeleteFramebuffers: _emscripten_glDeleteFramebuffers,
                emscripten_glDeleteProgram: _emscripten_glDeleteProgram,
                emscripten_glDeleteQueriesEXT: _emscripten_glDeleteQueriesEXT,
                emscripten_glDeleteRenderbuffers: _emscripten_glDeleteRenderbuffers,
                emscripten_glDeleteShader: _emscripten_glDeleteShader,
                emscripten_glDeleteTextures: _emscripten_glDeleteTextures,
                emscripten_glDeleteVertexArrays: _emscripten_glDeleteVertexArrays,
                emscripten_glDeleteVertexArraysOES: _emscripten_glDeleteVertexArraysOES,
                emscripten_glDepthFunc: _emscripten_glDepthFunc,
                emscripten_glDepthMask: _emscripten_glDepthMask,
                emscripten_glDepthRange: _emscripten_glDepthRange,
                emscripten_glDepthRangef: _emscripten_glDepthRangef,
                emscripten_glDetachShader: _emscripten_glDetachShader,
                emscripten_glDisable: _emscripten_glDisable,
                emscripten_glDisableVertexAttribArray: _emscripten_glDisableVertexAttribArray,
                emscripten_glDrawArrays: _emscripten_glDrawArrays,
                emscripten_glDrawArraysInstanced: _emscripten_glDrawArraysInstanced,
                emscripten_glDrawArraysInstancedANGLE: _emscripten_glDrawArraysInstancedANGLE,
                emscripten_glDrawArraysInstancedARB: _emscripten_glDrawArraysInstancedARB,
                emscripten_glDrawArraysInstancedEXT: _emscripten_glDrawArraysInstancedEXT,
                emscripten_glDrawArraysInstancedNV: _emscripten_glDrawArraysInstancedNV,
                emscripten_glDrawBuffers: _emscripten_glDrawBuffers,
                emscripten_glDrawBuffersEXT: _emscripten_glDrawBuffersEXT,
                emscripten_glDrawBuffersWEBGL: _emscripten_glDrawBuffersWEBGL,
                emscripten_glDrawElements: _emscripten_glDrawElements,
                emscripten_glDrawElementsInstanced: _emscripten_glDrawElementsInstanced,
                emscripten_glDrawElementsInstancedANGLE: _emscripten_glDrawElementsInstancedANGLE,
                emscripten_glDrawElementsInstancedARB: _emscripten_glDrawElementsInstancedARB,
                emscripten_glDrawElementsInstancedEXT: _emscripten_glDrawElementsInstancedEXT,
                emscripten_glDrawElementsInstancedNV: _emscripten_glDrawElementsInstancedNV,
                emscripten_glEnable: _emscripten_glEnable,
                emscripten_glEnableVertexAttribArray: _emscripten_glEnableVertexAttribArray,
                emscripten_glEndQueryEXT: _emscripten_glEndQueryEXT,
                emscripten_glFinish: _emscripten_glFinish,
                emscripten_glFlush: _emscripten_glFlush,
                emscripten_glFramebufferRenderbuffer: _emscripten_glFramebufferRenderbuffer,
                emscripten_glFramebufferTexture2D: _emscripten_glFramebufferTexture2D,
                emscripten_glFrontFace: _emscripten_glFrontFace,
                emscripten_glGenBuffers: _emscripten_glGenBuffers,
                emscripten_glGenFramebuffers: _emscripten_glGenFramebuffers,
                emscripten_glGenQueriesEXT: _emscripten_glGenQueriesEXT,
                emscripten_glGenRenderbuffers: _emscripten_glGenRenderbuffers,
                emscripten_glGenTextures: _emscripten_glGenTextures,
                emscripten_glGenVertexArrays: _emscripten_glGenVertexArrays,
                emscripten_glGenVertexArraysOES: _emscripten_glGenVertexArraysOES,
                emscripten_glGenerateMipmap: _emscripten_glGenerateMipmap,
                emscripten_glGetActiveAttrib: _emscripten_glGetActiveAttrib,
                emscripten_glGetActiveUniform: _emscripten_glGetActiveUniform,
                emscripten_glGetAttachedShaders: _emscripten_glGetAttachedShaders,
                emscripten_glGetAttribLocation: _emscripten_glGetAttribLocation,
                emscripten_glGetBooleanv: _emscripten_glGetBooleanv,
                emscripten_glGetBufferParameteriv: _emscripten_glGetBufferParameteriv,
                emscripten_glGetError: _emscripten_glGetError,
                emscripten_glGetFloatv: _emscripten_glGetFloatv,
                emscripten_glGetFramebufferAttachmentParameteriv: _emscripten_glGetFramebufferAttachmentParameteriv,
                emscripten_glGetIntegerv: _emscripten_glGetIntegerv,
                emscripten_glGetProgramInfoLog: _emscripten_glGetProgramInfoLog,
                emscripten_glGetProgramiv: _emscripten_glGetProgramiv,
                emscripten_glGetQueryObjecti64vEXT: _emscripten_glGetQueryObjecti64vEXT,
                emscripten_glGetQueryObjectivEXT: _emscripten_glGetQueryObjectivEXT,
                emscripten_glGetQueryObjectui64vEXT: _emscripten_glGetQueryObjectui64vEXT,
                emscripten_glGetQueryObjectuivEXT: _emscripten_glGetQueryObjectuivEXT,
                emscripten_glGetQueryivEXT: _emscripten_glGetQueryivEXT,
                emscripten_glGetRenderbufferParameteriv: _emscripten_glGetRenderbufferParameteriv,
                emscripten_glGetShaderInfoLog: _emscripten_glGetShaderInfoLog,
                emscripten_glGetShaderPrecisionFormat: _emscripten_glGetShaderPrecisionFormat,
                emscripten_glGetShaderSource: _emscripten_glGetShaderSource,
                emscripten_glGetShaderiv: _emscripten_glGetShaderiv,
                emscripten_glGetString: _emscripten_glGetString,
                emscripten_glGetTexParameterfv: _emscripten_glGetTexParameterfv,
                emscripten_glGetTexParameteriv: _emscripten_glGetTexParameteriv,
                emscripten_glGetUniformLocation: _emscripten_glGetUniformLocation,
                emscripten_glGetUniformfv: _emscripten_glGetUniformfv,
                emscripten_glGetUniformiv: _emscripten_glGetUniformiv,
                emscripten_glGetVertexAttribPointerv: _emscripten_glGetVertexAttribPointerv,
                emscripten_glGetVertexAttribfv: _emscripten_glGetVertexAttribfv,
                emscripten_glGetVertexAttribiv: _emscripten_glGetVertexAttribiv,
                emscripten_glHint: _emscripten_glHint,
                emscripten_glIsBuffer: _emscripten_glIsBuffer,
                emscripten_glIsEnabled: _emscripten_glIsEnabled,
                emscripten_glIsFramebuffer: _emscripten_glIsFramebuffer,
                emscripten_glIsProgram: _emscripten_glIsProgram,
                emscripten_glIsQueryEXT: _emscripten_glIsQueryEXT,
                emscripten_glIsRenderbuffer: _emscripten_glIsRenderbuffer,
                emscripten_glIsShader: _emscripten_glIsShader,
                emscripten_glIsTexture: _emscripten_glIsTexture,
                emscripten_glIsVertexArray: _emscripten_glIsVertexArray,
                emscripten_glIsVertexArrayOES: _emscripten_glIsVertexArrayOES,
                emscripten_glLineWidth: _emscripten_glLineWidth,
                emscripten_glLinkProgram: _emscripten_glLinkProgram,
                emscripten_glLoadIdentity: _emscripten_glLoadIdentity,
                emscripten_glMatrixMode: _emscripten_glMatrixMode,
                emscripten_glMultiDrawArrays: _emscripten_glMultiDrawArrays,
                emscripten_glMultiDrawArraysANGLE: _emscripten_glMultiDrawArraysANGLE,
                emscripten_glMultiDrawArraysInstancedANGLE: _emscripten_glMultiDrawArraysInstancedANGLE,
                emscripten_glMultiDrawArraysInstancedWEBGL: _emscripten_glMultiDrawArraysInstancedWEBGL,
                emscripten_glMultiDrawArraysWEBGL: _emscripten_glMultiDrawArraysWEBGL,
                emscripten_glMultiDrawElements: _emscripten_glMultiDrawElements,
                emscripten_glMultiDrawElementsANGLE: _emscripten_glMultiDrawElementsANGLE,
                emscripten_glMultiDrawElementsInstancedANGLE: _emscripten_glMultiDrawElementsInstancedANGLE,
                emscripten_glMultiDrawElementsInstancedWEBGL: _emscripten_glMultiDrawElementsInstancedWEBGL,
                emscripten_glMultiDrawElementsWEBGL: _emscripten_glMultiDrawElementsWEBGL,
                emscripten_glPixelStorei: _emscripten_glPixelStorei,
                emscripten_glPolygonModeWEBGL: _emscripten_glPolygonModeWEBGL,
                emscripten_glPolygonOffset: _emscripten_glPolygonOffset,
                emscripten_glPolygonOffsetClampEXT: _emscripten_glPolygonOffsetClampEXT,
                emscripten_glQueryCounterEXT: _emscripten_glQueryCounterEXT,
                emscripten_glReadPixels: _emscripten_glReadPixels,
                emscripten_glReleaseShaderCompiler: _emscripten_glReleaseShaderCompiler,
                emscripten_glRenderbufferStorage: _emscripten_glRenderbufferStorage,
                emscripten_glSampleCoverage: _emscripten_glSampleCoverage,
                emscripten_glScissor: _emscripten_glScissor,
                emscripten_glShaderBinary: _emscripten_glShaderBinary,
                emscripten_glShaderSource: _emscripten_glShaderSource,
                emscripten_glStencilFunc: _emscripten_glStencilFunc,
                emscripten_glStencilFuncSeparate: _emscripten_glStencilFuncSeparate,
                emscripten_glStencilMask: _emscripten_glStencilMask,
                emscripten_glStencilMaskSeparate: _emscripten_glStencilMaskSeparate,
                emscripten_glStencilOp: _emscripten_glStencilOp,
                emscripten_glStencilOpSeparate: _emscripten_glStencilOpSeparate,
                emscripten_glTexImage2D: _emscripten_glTexImage2D,
                emscripten_glTexParameterf: _emscripten_glTexParameterf,
                emscripten_glTexParameterfv: _emscripten_glTexParameterfv,
                emscripten_glTexParameteri: _emscripten_glTexParameteri,
                emscripten_glTexParameteriv: _emscripten_glTexParameteriv,
                emscripten_glTexSubImage2D: _emscripten_glTexSubImage2D,
                emscripten_glUniform1f: _emscripten_glUniform1f,
                emscripten_glUniform1fv: _emscripten_glUniform1fv,
                emscripten_glUniform1i: _emscripten_glUniform1i,
                emscripten_glUniform1iv: _emscripten_glUniform1iv,
                emscripten_glUniform2f: _emscripten_glUniform2f,
                emscripten_glUniform2fv: _emscripten_glUniform2fv,
                emscripten_glUniform2i: _emscripten_glUniform2i,
                emscripten_glUniform2iv: _emscripten_glUniform2iv,
                emscripten_glUniform3f: _emscripten_glUniform3f,
                emscripten_glUniform3fv: _emscripten_glUniform3fv,
                emscripten_glUniform3i: _emscripten_glUniform3i,
                emscripten_glUniform3iv: _emscripten_glUniform3iv,
                emscripten_glUniform4f: _emscripten_glUniform4f,
                emscripten_glUniform4fv: _emscripten_glUniform4fv,
                emscripten_glUniform4i: _emscripten_glUniform4i,
                emscripten_glUniform4iv: _emscripten_glUniform4iv,
                emscripten_glUniformMatrix2fv: _emscripten_glUniformMatrix2fv,
                emscripten_glUniformMatrix3fv: _emscripten_glUniformMatrix3fv,
                emscripten_glUniformMatrix4fv: _emscripten_glUniformMatrix4fv,
                emscripten_glUseProgram: _emscripten_glUseProgram,
                emscripten_glValidateProgram: _emscripten_glValidateProgram,
                emscripten_glVertexAttrib1f: _emscripten_glVertexAttrib1f,
                emscripten_glVertexAttrib1fv: _emscripten_glVertexAttrib1fv,
                emscripten_glVertexAttrib2f: _emscripten_glVertexAttrib2f,
                emscripten_glVertexAttrib2fv: _emscripten_glVertexAttrib2fv,
                emscripten_glVertexAttrib3f: _emscripten_glVertexAttrib3f,
                emscripten_glVertexAttrib3fv: _emscripten_glVertexAttrib3fv,
                emscripten_glVertexAttrib4f: _emscripten_glVertexAttrib4f,
                emscripten_glVertexAttrib4fv: _emscripten_glVertexAttrib4fv,
                emscripten_glVertexAttribDivisor: _emscripten_glVertexAttribDivisor,
                emscripten_glVertexAttribDivisorANGLE: _emscripten_glVertexAttribDivisorANGLE,
                emscripten_glVertexAttribDivisorARB: _emscripten_glVertexAttribDivisorARB,
                emscripten_glVertexAttribDivisorEXT: _emscripten_glVertexAttribDivisorEXT,
                emscripten_glVertexAttribDivisorNV: _emscripten_glVertexAttribDivisorNV,
                emscripten_glVertexAttribPointer: _emscripten_glVertexAttribPointer,
                emscripten_glVertexPointer: _emscripten_glVertexPointer,
                emscripten_glViewport: _emscripten_glViewport,
                emscripten_has_asyncify: _emscripten_has_asyncify,
                emscripten_hide_mouse: _emscripten_hide_mouse,
                emscripten_html5_remove_all_event_listeners: _emscripten_html5_remove_all_event_listeners,
                emscripten_idb_async_clear: _emscripten_idb_async_clear,
                emscripten_idb_async_delete: _emscripten_idb_async_delete,
                emscripten_idb_async_exists: _emscripten_idb_async_exists,
                emscripten_idb_async_load: _emscripten_idb_async_load,
                emscripten_idb_async_store: _emscripten_idb_async_store,
                emscripten_idb_clear: _emscripten_idb_clear,
                emscripten_idb_delete: _emscripten_idb_delete,
                emscripten_idb_exists: _emscripten_idb_exists,
                emscripten_idb_load: _emscripten_idb_load,
                emscripten_idb_store: _emscripten_idb_store,
                emscripten_is_main_browser_thread: _emscripten_is_main_browser_thread,
                emscripten_is_webgl_context_lost: _emscripten_is_webgl_context_lost,
                emscripten_lock_orientation: _emscripten_lock_orientation,
                emscripten_log: _emscripten_log,
                emscripten_math_acos: _emscripten_math_acos,
                emscripten_math_acosh: _emscripten_math_acosh,
                emscripten_math_asin: _emscripten_math_asin,
                emscripten_math_asinh: _emscripten_math_asinh,
                emscripten_math_atan: _emscripten_math_atan,
                emscripten_math_atan2: _emscripten_math_atan2,
                emscripten_math_atanh: _emscripten_math_atanh,
                emscripten_math_cbrt: _emscripten_math_cbrt,
                emscripten_math_cos: _emscripten_math_cos,
                emscripten_math_cosh: _emscripten_math_cosh,
                emscripten_math_exp: _emscripten_math_exp,
                emscripten_math_expm1: _emscripten_math_expm1,
                emscripten_math_fmod: _emscripten_math_fmod,
                emscripten_math_hypot: _emscripten_math_hypot,
                emscripten_math_log: _emscripten_math_log,
                emscripten_math_log10: _emscripten_math_log10,
                emscripten_math_log1p: _emscripten_math_log1p,
                emscripten_math_log2: _emscripten_math_log2,
                emscripten_math_pow: _emscripten_math_pow,
                emscripten_math_random: _emscripten_math_random,
                emscripten_math_round: _emscripten_math_round,
                emscripten_math_sign: _emscripten_math_sign,
                emscripten_math_sin: _emscripten_math_sin,
                emscripten_math_sinh: _emscripten_math_sinh,
                emscripten_math_sqrt: _emscripten_math_sqrt,
                emscripten_math_tan: _emscripten_math_tan,
                emscripten_math_tanh: _emscripten_math_tanh,
                emscripten_notify_memory_growth: _emscripten_notify_memory_growth,
                emscripten_out: _emscripten_out,
                emscripten_outn: _emscripten_outn,
                emscripten_pause_main_loop: _emscripten_pause_main_loop,
                emscripten_pc_get_column: _emscripten_pc_get_column,
                emscripten_pc_get_file: _emscripten_pc_get_file,
                emscripten_pc_get_function: _emscripten_pc_get_function,
                emscripten_pc_get_line: _emscripten_pc_get_line,
                emscripten_performance_now: _emscripten_performance_now,
                emscripten_print_double: _emscripten_print_double,
                emscripten_promise_all: _emscripten_promise_all,
                emscripten_promise_all_settled: _emscripten_promise_all_settled,
                emscripten_promise_any: _emscripten_promise_any,
                emscripten_promise_await: _emscripten_promise_await,
                emscripten_promise_create: _emscripten_promise_create,
                emscripten_promise_destroy: _emscripten_promise_destroy,
                emscripten_promise_race: _emscripten_promise_race,
                emscripten_promise_resolve: _emscripten_promise_resolve,
                emscripten_promise_then: _emscripten_promise_then,
                emscripten_random: _emscripten_random,
                emscripten_request_animation_frame: _emscripten_request_animation_frame,
                emscripten_request_animation_frame_loop: _emscripten_request_animation_frame_loop,
                emscripten_request_fullscreen: _emscripten_request_fullscreen,
                emscripten_request_fullscreen_strategy: _emscripten_request_fullscreen_strategy,
                emscripten_request_pointerlock: _emscripten_request_pointerlock,
                emscripten_resize_heap: _emscripten_resize_heap,
                emscripten_resume_main_loop: _emscripten_resume_main_loop,
                emscripten_return_address: _emscripten_return_address,
                emscripten_run_preload_plugins: _emscripten_run_preload_plugins,
                emscripten_run_preload_plugins_data: _emscripten_run_preload_plugins_data,
                emscripten_run_script: _emscripten_run_script,
                emscripten_run_script_int: _emscripten_run_script_int,
                emscripten_run_script_string: _emscripten_run_script_string,
                emscripten_runtime_keepalive_check: _emscripten_runtime_keepalive_check,
                emscripten_runtime_keepalive_pop: _emscripten_runtime_keepalive_pop,
                emscripten_runtime_keepalive_push: _emscripten_runtime_keepalive_push,
                emscripten_sample_gamepad_data: _emscripten_sample_gamepad_data,
                emscripten_scan_registers: _emscripten_scan_registers,
                emscripten_set_batterychargingchange_callback_on_thread: _emscripten_set_batterychargingchange_callback_on_thread,
                emscripten_set_batterylevelchange_callback_on_thread: _emscripten_set_batterylevelchange_callback_on_thread,
                emscripten_set_beforeunload_callback_on_thread: _emscripten_set_beforeunload_callback_on_thread,
                emscripten_set_blur_callback_on_thread: _emscripten_set_blur_callback_on_thread,
                emscripten_set_canvas_element_size: _emscripten_set_canvas_element_size,
                emscripten_set_canvas_size: _emscripten_set_canvas_size,
                emscripten_set_click_callback_on_thread: _emscripten_set_click_callback_on_thread,
                emscripten_set_dblclick_callback_on_thread: _emscripten_set_dblclick_callback_on_thread,
                emscripten_set_devicemotion_callback_on_thread: _emscripten_set_devicemotion_callback_on_thread,
                emscripten_set_deviceorientation_callback_on_thread: _emscripten_set_deviceorientation_callback_on_thread,
                emscripten_set_element_css_size: _emscripten_set_element_css_size,
                emscripten_set_focus_callback_on_thread: _emscripten_set_focus_callback_on_thread,
                emscripten_set_focusin_callback_on_thread: _emscripten_set_focusin_callback_on_thread,
                emscripten_set_focusout_callback_on_thread: _emscripten_set_focusout_callback_on_thread,
                emscripten_set_fullscreenchange_callback_on_thread: _emscripten_set_fullscreenchange_callback_on_thread,
                emscripten_set_gamepadconnected_callback_on_thread: _emscripten_set_gamepadconnected_callback_on_thread,
                emscripten_set_gamepaddisconnected_callback_on_thread: _emscripten_set_gamepaddisconnected_callback_on_thread,
                emscripten_set_immediate: _emscripten_set_immediate,
                emscripten_set_immediate_loop: _emscripten_set_immediate_loop,
                emscripten_set_interval: _emscripten_set_interval,
                emscripten_set_keydown_callback_on_thread: _emscripten_set_keydown_callback_on_thread,
                emscripten_set_keypress_callback_on_thread: _emscripten_set_keypress_callback_on_thread,
                emscripten_set_keyup_callback_on_thread: _emscripten_set_keyup_callback_on_thread,
                emscripten_set_main_loop: _emscripten_set_main_loop,
                emscripten_set_main_loop_arg: _emscripten_set_main_loop_arg,
                emscripten_set_main_loop_expected_blockers: _emscripten_set_main_loop_expected_blockers,
                emscripten_set_main_loop_timing: _emscripten_set_main_loop_timing,
                emscripten_set_mousedown_callback_on_thread: _emscripten_set_mousedown_callback_on_thread,
                emscripten_set_mouseenter_callback_on_thread: _emscripten_set_mouseenter_callback_on_thread,
                emscripten_set_mouseleave_callback_on_thread: _emscripten_set_mouseleave_callback_on_thread,
                emscripten_set_mousemove_callback_on_thread: _emscripten_set_mousemove_callback_on_thread,
                emscripten_set_mouseout_callback_on_thread: _emscripten_set_mouseout_callback_on_thread,
                emscripten_set_mouseover_callback_on_thread: _emscripten_set_mouseover_callback_on_thread,
                emscripten_set_mouseup_callback_on_thread: _emscripten_set_mouseup_callback_on_thread,
                emscripten_set_orientationchange_callback_on_thread: _emscripten_set_orientationchange_callback_on_thread,
                emscripten_set_pointerlockchange_callback_on_thread: _emscripten_set_pointerlockchange_callback_on_thread,
                emscripten_set_pointerlockerror_callback_on_thread: _emscripten_set_pointerlockerror_callback_on_thread,
                emscripten_set_resize_callback_on_thread: _emscripten_set_resize_callback_on_thread,
                emscripten_set_scroll_callback_on_thread: _emscripten_set_scroll_callback_on_thread,
                emscripten_set_socket_close_callback: _emscripten_set_socket_close_callback,
                emscripten_set_socket_connection_callback: _emscripten_set_socket_connection_callback,
                emscripten_set_socket_error_callback: _emscripten_set_socket_error_callback,
                emscripten_set_socket_listen_callback: _emscripten_set_socket_listen_callback,
                emscripten_set_socket_message_callback: _emscripten_set_socket_message_callback,
                emscripten_set_socket_open_callback: _emscripten_set_socket_open_callback,
                emscripten_set_timeout: _emscripten_set_timeout,
                emscripten_set_timeout_loop: _emscripten_set_timeout_loop,
                emscripten_set_touchcancel_callback_on_thread: _emscripten_set_touchcancel_callback_on_thread,
                emscripten_set_touchend_callback_on_thread: _emscripten_set_touchend_callback_on_thread,
                emscripten_set_touchmove_callback_on_thread: _emscripten_set_touchmove_callback_on_thread,
                emscripten_set_touchstart_callback_on_thread: _emscripten_set_touchstart_callback_on_thread,
                emscripten_set_visibilitychange_callback_on_thread: _emscripten_set_visibilitychange_callback_on_thread,
                emscripten_set_webglcontextlost_callback_on_thread: _emscripten_set_webglcontextlost_callback_on_thread,
                emscripten_set_webglcontextrestored_callback_on_thread: _emscripten_set_webglcontextrestored_callback_on_thread,
                emscripten_set_wheel_callback_on_thread: _emscripten_set_wheel_callback_on_thread,
                emscripten_set_window_title: _emscripten_set_window_title,
                emscripten_sleep: _emscripten_sleep,
                emscripten_stack_snapshot: _emscripten_stack_snapshot,
                emscripten_stack_unwind_buffer: _emscripten_stack_unwind_buffer,
                emscripten_supports_offscreencanvas: _emscripten_supports_offscreencanvas,
                emscripten_throw_number: _emscripten_throw_number,
                emscripten_throw_string: _emscripten_throw_string,
                emscripten_unlock_orientation: _emscripten_unlock_orientation,
                emscripten_unwind_to_js_event_loop: _emscripten_unwind_to_js_event_loop,
                emscripten_vibrate: _emscripten_vibrate,
                emscripten_vibrate_pattern: _emscripten_vibrate_pattern,
                emscripten_webgl_commit_frame: _emscripten_webgl_commit_frame,
                emscripten_webgl_create_context: _emscripten_webgl_create_context,
                emscripten_webgl_destroy_context: _emscripten_webgl_destroy_context,
                emscripten_webgl_do_commit_frame: _emscripten_webgl_do_commit_frame,
                emscripten_webgl_do_create_context: _emscripten_webgl_do_create_context,
                emscripten_webgl_do_get_current_context: _emscripten_webgl_do_get_current_context,
                emscripten_webgl_enable_ANGLE_instanced_arrays: _emscripten_webgl_enable_ANGLE_instanced_arrays,
                emscripten_webgl_enable_EXT_clip_control: _emscripten_webgl_enable_EXT_clip_control,
                emscripten_webgl_enable_EXT_polygon_offset_clamp: _emscripten_webgl_enable_EXT_polygon_offset_clamp,
                emscripten_webgl_enable_OES_vertex_array_object: _emscripten_webgl_enable_OES_vertex_array_object,
                emscripten_webgl_enable_WEBGL_draw_buffers: _emscripten_webgl_enable_WEBGL_draw_buffers,
                emscripten_webgl_enable_WEBGL_multi_draw: _emscripten_webgl_enable_WEBGL_multi_draw,
                emscripten_webgl_enable_WEBGL_polygon_mode: _emscripten_webgl_enable_WEBGL_polygon_mode,
                emscripten_webgl_enable_extension: _emscripten_webgl_enable_extension,
                emscripten_webgl_get_context_attributes: _emscripten_webgl_get_context_attributes,
                emscripten_webgl_get_current_context: _emscripten_webgl_get_current_context,
                emscripten_webgl_get_drawing_buffer_size: _emscripten_webgl_get_drawing_buffer_size,
                emscripten_webgl_get_parameter_d: _emscripten_webgl_get_parameter_d,
                emscripten_webgl_get_parameter_i64v: _emscripten_webgl_get_parameter_i64v,
                emscripten_webgl_get_parameter_o: _emscripten_webgl_get_parameter_o,
                emscripten_webgl_get_parameter_utf8: _emscripten_webgl_get_parameter_utf8,
                emscripten_webgl_get_parameter_v: _emscripten_webgl_get_parameter_v,
                emscripten_webgl_get_program_info_log_utf8: _emscripten_webgl_get_program_info_log_utf8,
                emscripten_webgl_get_program_parameter_d: _emscripten_webgl_get_program_parameter_d,
                emscripten_webgl_get_shader_info_log_utf8: _emscripten_webgl_get_shader_info_log_utf8,
                emscripten_webgl_get_shader_parameter_d: _emscripten_webgl_get_shader_parameter_d,
                emscripten_webgl_get_shader_source_utf8: _emscripten_webgl_get_shader_source_utf8,
                emscripten_webgl_get_supported_extensions: _emscripten_webgl_get_supported_extensions,
                emscripten_webgl_get_uniform_d: _emscripten_webgl_get_uniform_d,
                emscripten_webgl_get_uniform_v: _emscripten_webgl_get_uniform_v,
                emscripten_webgl_get_vertex_attrib_d: _emscripten_webgl_get_vertex_attrib_d,
                emscripten_webgl_get_vertex_attrib_o: _emscripten_webgl_get_vertex_attrib_o,
                emscripten_webgl_get_vertex_attrib_v: _emscripten_webgl_get_vertex_attrib_v,
                emscripten_webgl_make_context_current: _emscripten_webgl_make_context_current,
                emscripten_wget_data: _emscripten_wget_data,
                endprotoent: _endprotoent,
                environ_get: _environ_get,
                environ_sizes_get: _environ_sizes_get,
                exit: _exit,
                fd_close: _fd_close,
                fd_fdstat_get: _fd_fdstat_get,
                fd_pread: _fd_pread,
                fd_pwrite: _fd_pwrite,
                fd_read: _fd_read,
                fd_seek: _fd_seek,
                fd_sync: _fd_sync,
                fd_write: _fd_write,
                filledEllipseColor: _filledEllipseColor,
                filledEllipseRGBA: _filledEllipseRGBA,
                getaddrinfo: _getaddrinfo,
                getnameinfo: _getnameinfo,
                getprotobyname: _getprotobyname,
                getprotobynumber: _getprotobynumber,
                getprotoent: _getprotoent,
                glActiveTexture: _glActiveTexture,
                glAttachShader: _glAttachShader,
                glBegin: _glBegin,
                glBeginQueryEXT: _glBeginQueryEXT,
                glBindAttribLocation: _glBindAttribLocation,
                glBindBuffer: _glBindBuffer,
                glBindFramebuffer: _glBindFramebuffer,
                glBindRenderbuffer: _glBindRenderbuffer,
                glBindTexture: _glBindTexture,
                glBindVertexArray: _glBindVertexArray,
                glBindVertexArrayOES: _glBindVertexArrayOES,
                glBlendColor: _glBlendColor,
                glBlendEquation: _glBlendEquation,
                glBlendEquationSeparate: _glBlendEquationSeparate,
                glBlendFunc: _glBlendFunc,
                glBlendFuncSeparate: _glBlendFuncSeparate,
                glBufferData: _glBufferData,
                glBufferSubData: _glBufferSubData,
                glCheckFramebufferStatus: _glCheckFramebufferStatus,
                glClear: _glClear,
                glClearColor: _glClearColor,
                glClearDepth: _glClearDepth,
                glClearDepthf: _glClearDepthf,
                glClearStencil: _glClearStencil,
                glClipControlEXT: _glClipControlEXT,
                glColorMask: _glColorMask,
                glCompileShader: _glCompileShader,
                glCompressedTexImage2D: _glCompressedTexImage2D,
                glCompressedTexSubImage2D: _glCompressedTexSubImage2D,
                glCopyTexImage2D: _glCopyTexImage2D,
                glCopyTexSubImage2D: _glCopyTexSubImage2D,
                glCreateProgram: _glCreateProgram,
                glCreateShader: _glCreateShader,
                glCullFace: _glCullFace,
                glDeleteBuffers: _glDeleteBuffers,
                glDeleteFramebuffers: _glDeleteFramebuffers,
                glDeleteProgram: _glDeleteProgram,
                glDeleteQueriesEXT: _glDeleteQueriesEXT,
                glDeleteRenderbuffers: _glDeleteRenderbuffers,
                glDeleteShader: _glDeleteShader,
                glDeleteTextures: _glDeleteTextures,
                glDeleteVertexArrays: _glDeleteVertexArrays,
                glDeleteVertexArraysOES: _glDeleteVertexArraysOES,
                glDepthFunc: _glDepthFunc,
                glDepthMask: _glDepthMask,
                glDepthRange: _glDepthRange,
                glDepthRangef: _glDepthRangef,
                glDetachShader: _glDetachShader,
                glDisable: _glDisable,
                glDisableVertexAttribArray: _glDisableVertexAttribArray,
                glDrawArrays: _glDrawArrays,
                glDrawArraysInstanced: _glDrawArraysInstanced,
                glDrawArraysInstancedANGLE: _glDrawArraysInstancedANGLE,
                glDrawArraysInstancedARB: _glDrawArraysInstancedARB,
                glDrawArraysInstancedEXT: _glDrawArraysInstancedEXT,
                glDrawArraysInstancedNV: _glDrawArraysInstancedNV,
                glDrawBuffers: _glDrawBuffers,
                glDrawBuffersEXT: _glDrawBuffersEXT,
                glDrawBuffersWEBGL: _glDrawBuffersWEBGL,
                glDrawElements: _glDrawElements,
                glDrawElementsInstanced: _glDrawElementsInstanced,
                glDrawElementsInstancedANGLE: _glDrawElementsInstancedANGLE,
                glDrawElementsInstancedARB: _glDrawElementsInstancedARB,
                glDrawElementsInstancedEXT: _glDrawElementsInstancedEXT,
                glDrawElementsInstancedNV: _glDrawElementsInstancedNV,
                glEnable: _glEnable,
                glEnableVertexAttribArray: _glEnableVertexAttribArray,
                glEndQueryEXT: _glEndQueryEXT,
                glFinish: _glFinish,
                glFlush: _glFlush,
                glFramebufferRenderbuffer: _glFramebufferRenderbuffer,
                glFramebufferTexture2D: _glFramebufferTexture2D,
                glFrontFace: _glFrontFace,
                glGenBuffers: _glGenBuffers,
                glGenFramebuffers: _glGenFramebuffers,
                glGenQueriesEXT: _glGenQueriesEXT,
                glGenRenderbuffers: _glGenRenderbuffers,
                glGenTextures: _glGenTextures,
                glGenVertexArrays: _glGenVertexArrays,
                glGenVertexArraysOES: _glGenVertexArraysOES,
                glGenerateMipmap: _glGenerateMipmap,
                glGetActiveAttrib: _glGetActiveAttrib,
                glGetActiveUniform: _glGetActiveUniform,
                glGetAttachedShaders: _glGetAttachedShaders,
                glGetAttribLocation: _glGetAttribLocation,
                glGetBooleanv: _glGetBooleanv,
                glGetBufferParameteriv: _glGetBufferParameteriv,
                glGetError: _glGetError,
                glGetFloatv: _glGetFloatv,
                glGetFramebufferAttachmentParameteriv: _glGetFramebufferAttachmentParameteriv,
                glGetIntegerv: _glGetIntegerv,
                glGetProgramInfoLog: _glGetProgramInfoLog,
                glGetProgramiv: _glGetProgramiv,
                glGetQueryObjecti64vEXT: _glGetQueryObjecti64vEXT,
                glGetQueryObjectivEXT: _glGetQueryObjectivEXT,
                glGetQueryObjectui64vEXT: _glGetQueryObjectui64vEXT,
                glGetQueryObjectuivEXT: _glGetQueryObjectuivEXT,
                glGetQueryivEXT: _glGetQueryivEXT,
                glGetRenderbufferParameteriv: _glGetRenderbufferParameteriv,
                glGetShaderInfoLog: _glGetShaderInfoLog,
                glGetShaderPrecisionFormat: _glGetShaderPrecisionFormat,
                glGetShaderSource: _glGetShaderSource,
                glGetShaderiv: _glGetShaderiv,
                glGetString: _glGetString,
                glGetTexParameterfv: _glGetTexParameterfv,
                glGetTexParameteriv: _glGetTexParameteriv,
                glGetUniformLocation: _glGetUniformLocation,
                glGetUniformfv: _glGetUniformfv,
                glGetUniformiv: _glGetUniformiv,
                glGetVertexAttribPointerv: _glGetVertexAttribPointerv,
                glGetVertexAttribfv: _glGetVertexAttribfv,
                glGetVertexAttribiv: _glGetVertexAttribiv,
                glHint: _glHint,
                glIsBuffer: _glIsBuffer,
                glIsEnabled: _glIsEnabled,
                glIsFramebuffer: _glIsFramebuffer,
                glIsProgram: _glIsProgram,
                glIsQueryEXT: _glIsQueryEXT,
                glIsRenderbuffer: _glIsRenderbuffer,
                glIsShader: _glIsShader,
                glIsTexture: _glIsTexture,
                glIsVertexArray: _glIsVertexArray,
                glIsVertexArrayOES: _glIsVertexArrayOES,
                glLineWidth: _glLineWidth,
                glLinkProgram: _glLinkProgram,
                glLoadIdentity: _glLoadIdentity,
                glMatrixMode: _glMatrixMode,
                glMultiDrawArrays: _glMultiDrawArrays,
                glMultiDrawArraysANGLE: _glMultiDrawArraysANGLE,
                glMultiDrawArraysInstancedANGLE: _glMultiDrawArraysInstancedANGLE,
                glMultiDrawArraysInstancedWEBGL: _glMultiDrawArraysInstancedWEBGL,
                glMultiDrawArraysWEBGL: _glMultiDrawArraysWEBGL,
                glMultiDrawElements: _glMultiDrawElements,
                glMultiDrawElementsANGLE: _glMultiDrawElementsANGLE,
                glMultiDrawElementsInstancedANGLE: _glMultiDrawElementsInstancedANGLE,
                glMultiDrawElementsInstancedWEBGL: _glMultiDrawElementsInstancedWEBGL,
                glMultiDrawElementsWEBGL: _glMultiDrawElementsWEBGL,
                glPixelStorei: _glPixelStorei,
                glPolygonModeWEBGL: _glPolygonModeWEBGL,
                glPolygonOffset: _glPolygonOffset,
                glPolygonOffsetClampEXT: _glPolygonOffsetClampEXT,
                glQueryCounterEXT: _glQueryCounterEXT,
                glReadPixels: _glReadPixels,
                glReleaseShaderCompiler: _glReleaseShaderCompiler,
                glRenderbufferStorage: _glRenderbufferStorage,
                glSampleCoverage: _glSampleCoverage,
                glScissor: _glScissor,
                glShaderBinary: _glShaderBinary,
                glShaderSource: _glShaderSource,
                glStencilFunc: _glStencilFunc,
                glStencilFuncSeparate: _glStencilFuncSeparate,
                glStencilMask: _glStencilMask,
                glStencilMaskSeparate: _glStencilMaskSeparate,
                glStencilOp: _glStencilOp,
                glStencilOpSeparate: _glStencilOpSeparate,
                glTexImage2D: _glTexImage2D,
                glTexParameterf: _glTexParameterf,
                glTexParameterfv: _glTexParameterfv,
                glTexParameteri: _glTexParameteri,
                glTexParameteriv: _glTexParameteriv,
                glTexSubImage2D: _glTexSubImage2D,
                glUniform1f: _glUniform1f,
                glUniform1fv: _glUniform1fv,
                glUniform1i: _glUniform1i,
                glUniform1iv: _glUniform1iv,
                glUniform2f: _glUniform2f,
                glUniform2fv: _glUniform2fv,
                glUniform2i: _glUniform2i,
                glUniform2iv: _glUniform2iv,
                glUniform3f: _glUniform3f,
                glUniform3fv: _glUniform3fv,
                glUniform3i: _glUniform3i,
                glUniform3iv: _glUniform3iv,
                glUniform4f: _glUniform4f,
                glUniform4fv: _glUniform4fv,
                glUniform4i: _glUniform4i,
                glUniform4iv: _glUniform4iv,
                glUniformMatrix2fv: _glUniformMatrix2fv,
                glUniformMatrix3fv: _glUniformMatrix3fv,
                glUniformMatrix4fv: _glUniformMatrix4fv,
                glUseProgram: _glUseProgram,
                glValidateProgram: _glValidateProgram,
                glVertexAttrib1f: _glVertexAttrib1f,
                glVertexAttrib1fv: _glVertexAttrib1fv,
                glVertexAttrib2f: _glVertexAttrib2f,
                glVertexAttrib2fv: _glVertexAttrib2fv,
                glVertexAttrib3f: _glVertexAttrib3f,
                glVertexAttrib3fv: _glVertexAttrib3fv,
                glVertexAttrib4f: _glVertexAttrib4f,
                glVertexAttrib4fv: _glVertexAttrib4fv,
                glVertexAttribDivisor: _glVertexAttribDivisor,
                glVertexAttribDivisorANGLE: _glVertexAttribDivisorANGLE,
                glVertexAttribDivisorARB: _glVertexAttribDivisorARB,
                glVertexAttribDivisorEXT: _glVertexAttribDivisorEXT,
                glVertexAttribDivisorNV: _glVertexAttribDivisorNV,
                glVertexAttribPointer: _glVertexAttribPointer,
                glVertexPointer: _glVertexPointer,
                glViewport: _glViewport,
                glewGetErrorString: _glewGetErrorString,
                glewGetExtension: _glewGetExtension,
                glewGetString: _glewGetString,
                glewInit: _glewInit,
                glewIsSupported: _glewIsSupported,
                glutCreateWindow: _glutCreateWindow,
                glutDestroyWindow: _glutDestroyWindow,
                glutDisplayFunc: _glutDisplayFunc,
                glutFullScreen: _glutFullScreen,
                glutGet: _glutGet,
                glutGetModifiers: _glutGetModifiers,
                glutIdleFunc: _glutIdleFunc,
                glutInit: _glutInit,
                glutInitDisplayMode: _glutInitDisplayMode,
                glutInitWindowPosition: _glutInitWindowPosition,
                glutInitWindowSize: _glutInitWindowSize,
                glutKeyboardFunc: _glutKeyboardFunc,
                glutKeyboardUpFunc: _glutKeyboardUpFunc,
                glutMainLoop: _glutMainLoop,
                glutMotionFunc: _glutMotionFunc,
                glutMouseFunc: _glutMouseFunc,
                glutPassiveMotionFunc: _glutPassiveMotionFunc,
                glutPositionWindow: _glutPositionWindow,
                glutPostRedisplay: _glutPostRedisplay,
                glutReshapeFunc: _glutReshapeFunc,
                glutReshapeWindow: _glutReshapeWindow,
                glutSetCursor: _glutSetCursor,
                glutSpecialFunc: _glutSpecialFunc,
                glutSpecialUpFunc: _glutSpecialUpFunc,
                glutSwapBuffers: _glutSwapBuffers,
                glutTimerFunc: _glutTimerFunc,
                lineColor: _lineColor,
                lineRGBA: _lineRGBA,
                memory: wasmMemory,
                pixelRGBA: _pixelRGBA,
                proc_exit: _proc_exit,
                pthread_kill: _pthread_kill,
                random_get: _random_get,
                rectangleColor: _rectangleColor,
                rectangleRGBA: _rectangleRGBA,
                rotozoomSurface: _rotozoomSurface,
                setNetworkCallback: _setNetworkCallback,
                setprotoent: _setprotoent,
                stackAlloc: _stackAlloc,
                stackRestore: _stackRestore,
                stackSave: _stackSave,
                strptime: _strptime,
                strptime_l: _strptime_l,
                uuid_clear: _uuid_clear,
                uuid_compare: _uuid_compare,
                uuid_copy: _uuid_copy,
                uuid_generate: _uuid_generate,
                uuid_is_null: _uuid_is_null,
                uuid_parse: _uuid_parse,
                uuid_type: _uuid_type,
                uuid_unparse: _uuid_unparse,
                uuid_unparse_lower: _uuid_unparse_lower,
                uuid_unparse_upper: _uuid_unparse_upper,
                uuid_variant: _uuid_variant,
                zoomSurface: _zoomSurface
            };
            var wasmExports = createWasm();
            var __emval_coro_resume = (a0, a1) => (__emval_coro_resume = wasmExports["_emval_coro_resume"])(a0, a1);
            var _main = Module["_main"] = (a0, a1) => (_main = Module["_main"] = wasmExports["main"])(a0, a1);
            var _duckdb_web_fs_glob_add_path = Module["_duckdb_web_fs_glob_add_path"] = a0 => (_duckdb_web_fs_glob_add_path = Module["_duckdb_web_fs_glob_add_path"] = wasmExports["duckdb_web_fs_glob_add_path"])(a0);
            var _duckdb_web_clear_response = Module["_duckdb_web_clear_response"] = () => (_duckdb_web_clear_response = Module["_duckdb_web_clear_response"] = wasmExports["duckdb_web_clear_response"])();
            var _duckdb_web_fail_with = Module["_duckdb_web_fail_with"] = a0 => (_duckdb_web_fail_with = Module["_duckdb_web_fail_with"] = wasmExports["duckdb_web_fail_with"])(a0);
            var _duckdb_web_reset = Module["_duckdb_web_reset"] = a0 => (_duckdb_web_reset = Module["_duckdb_web_reset"] = wasmExports["duckdb_web_reset"])(a0);
            var _duckdb_web_connect = Module["_duckdb_web_connect"] = () => (_duckdb_web_connect = Module["_duckdb_web_connect"] = wasmExports["duckdb_web_connect"])();
            var _duckdb_web_disconnect = Module["_duckdb_web_disconnect"] = a0 => (_duckdb_web_disconnect = Module["_duckdb_web_disconnect"] = wasmExports["duckdb_web_disconnect"])(a0);
            var _duckdb_web_flush_files = Module["_duckdb_web_flush_files"] = () => (_duckdb_web_flush_files = Module["_duckdb_web_flush_files"] = wasmExports["duckdb_web_flush_files"])();
            var _duckdb_web_flush_file = Module["_duckdb_web_flush_file"] = a0 => (_duckdb_web_flush_file = Module["_duckdb_web_flush_file"] = wasmExports["duckdb_web_flush_file"])(a0);
            var _duckdb_web_open = Module["_duckdb_web_open"] = (a0, a1) => (_duckdb_web_open = Module["_duckdb_web_open"] = wasmExports["duckdb_web_open"])(a0, a1);
            var _duckdb_web_get_global_file_info = Module["_duckdb_web_get_global_file_info"] = (a0, a1) => (_duckdb_web_get_global_file_info = Module["_duckdb_web_get_global_file_info"] = wasmExports["duckdb_web_get_global_file_info"])(a0, a1);
            var _duckdb_web_collect_file_stats = Module["_duckdb_web_collect_file_stats"] = (a0, a1, a2) => (_duckdb_web_collect_file_stats = Module["_duckdb_web_collect_file_stats"] = wasmExports["duckdb_web_collect_file_stats"])(a0, a1, a2);
            var _duckdb_web_export_file_stats = Module["_duckdb_web_export_file_stats"] = (a0, a1) => (_duckdb_web_export_file_stats = Module["_duckdb_web_export_file_stats"] = wasmExports["duckdb_web_export_file_stats"])(a0, a1);
            var _duckdb_web_fs_drop_file = Module["_duckdb_web_fs_drop_file"] = (a0, a1) => (_duckdb_web_fs_drop_file = Module["_duckdb_web_fs_drop_file"] = wasmExports["duckdb_web_fs_drop_file"])(a0, a1);
            var _duckdb_web_fs_drop_files = Module["_duckdb_web_fs_drop_files"] = (a0, a1, a2) => (_duckdb_web_fs_drop_files = Module["_duckdb_web_fs_drop_files"] = wasmExports["duckdb_web_fs_drop_files"])(a0, a1, a2);
            var _duckdb_web_fs_glob_file_infos = Module["_duckdb_web_fs_glob_file_infos"] = (a0, a1) => (_duckdb_web_fs_glob_file_infos = Module["_duckdb_web_fs_glob_file_infos"] = wasmExports["duckdb_web_fs_glob_file_infos"])(a0, a1);
            var _duckdb_web_fs_get_file_info_by_id = Module["_duckdb_web_fs_get_file_info_by_id"] = (a0, a1, a2) => (_duckdb_web_fs_get_file_info_by_id = Module["_duckdb_web_fs_get_file_info_by_id"] = wasmExports["duckdb_web_fs_get_file_info_by_id"])(a0, a1, a2);
            var _duckdb_web_fs_get_file_info_by_name = Module["_duckdb_web_fs_get_file_info_by_name"] = (a0, a1, a2) => (_duckdb_web_fs_get_file_info_by_name = Module["_duckdb_web_fs_get_file_info_by_name"] = wasmExports["duckdb_web_fs_get_file_info_by_name"])(a0, a1, a2);
            var _duckdb_web_fs_register_file_url = Module["_duckdb_web_fs_register_file_url"] = (a0, a1, a2, a3, a4) => (_duckdb_web_fs_register_file_url = Module["_duckdb_web_fs_register_file_url"] = wasmExports["duckdb_web_fs_register_file_url"])(a0, a1, a2, a3, a4);
            var _duckdb_web_fs_register_file_buffer = Module["_duckdb_web_fs_register_file_buffer"] = (a0, a1, a2, a3) => (_duckdb_web_fs_register_file_buffer = Module["_duckdb_web_fs_register_file_buffer"] = wasmExports["duckdb_web_fs_register_file_buffer"])(a0, a1, a2, a3);
            var _duckdb_web_copy_file_to_buffer = Module["_duckdb_web_copy_file_to_buffer"] = (a0, a1) => (_duckdb_web_copy_file_to_buffer = Module["_duckdb_web_copy_file_to_buffer"] = wasmExports["duckdb_web_copy_file_to_buffer"])(a0, a1);
            var _duckdb_web_copy_file_to_path = Module["_duckdb_web_copy_file_to_path"] = (a0, a1, a2) => (_duckdb_web_copy_file_to_path = Module["_duckdb_web_copy_file_to_path"] = wasmExports["duckdb_web_copy_file_to_path"])(a0, a1, a2);
            var _duckdb_web_get_version = Module["_duckdb_web_get_version"] = a0 => (_duckdb_web_get_version = Module["_duckdb_web_get_version"] = wasmExports["duckdb_web_get_version"])(a0);
            var _duckdb_web_get_feature_flags = Module["_duckdb_web_get_feature_flags"] = () => (_duckdb_web_get_feature_flags = Module["_duckdb_web_get_feature_flags"] = wasmExports["duckdb_web_get_feature_flags"])();
            var _duckdb_web_tokenize = Module["_duckdb_web_tokenize"] = (a0, a1) => (_duckdb_web_tokenize = Module["_duckdb_web_tokenize"] = wasmExports["duckdb_web_tokenize"])(a0, a1);
            var _duckdb_web_tokenize_buffer = Module["_duckdb_web_tokenize_buffer"] = (a0, a1, a2) => (_duckdb_web_tokenize_buffer = Module["_duckdb_web_tokenize_buffer"] = wasmExports["duckdb_web_tokenize_buffer"])(a0, a1, a2);
            var _duckdb_web_udf_scalar_create = Module["_duckdb_web_udf_scalar_create"] = (a0, a1, a2) => (_duckdb_web_udf_scalar_create = Module["_duckdb_web_udf_scalar_create"] = wasmExports["duckdb_web_udf_scalar_create"])(a0, a1, a2);
            var _duckdb_web_prepared_create = Module["_duckdb_web_prepared_create"] = (a0, a1, a2) => (_duckdb_web_prepared_create = Module["_duckdb_web_prepared_create"] = wasmExports["duckdb_web_prepared_create"])(a0, a1, a2);
            var _duckdb_web_prepared_create_buffer = Module["_duckdb_web_prepared_create_buffer"] = (a0, a1, a2, a3) => (_duckdb_web_prepared_create_buffer = Module["_duckdb_web_prepared_create_buffer"] = wasmExports["duckdb_web_prepared_create_buffer"])(a0, a1, a2, a3);
            var _duckdb_web_prepared_close = Module["_duckdb_web_prepared_close"] = (a0, a1, a2) => (_duckdb_web_prepared_close = Module["_duckdb_web_prepared_close"] = wasmExports["duckdb_web_prepared_close"])(a0, a1, a2);
            var _duckdb_web_prepared_run = Module["_duckdb_web_prepared_run"] = (a0, a1, a2, a3) => (_duckdb_web_prepared_run = Module["_duckdb_web_prepared_run"] = wasmExports["duckdb_web_prepared_run"])(a0, a1, a2, a3);
            var _duckdb_web_prepared_send = Module["_duckdb_web_prepared_send"] = (a0, a1, a2, a3) => (_duckdb_web_prepared_send = Module["_duckdb_web_prepared_send"] = wasmExports["duckdb_web_prepared_send"])(a0, a1, a2, a3);
            var _duckdb_web_query_run = Module["_duckdb_web_query_run"] = (a0, a1, a2) => (_duckdb_web_query_run = Module["_duckdb_web_query_run"] = wasmExports["duckdb_web_query_run"])(a0, a1, a2);
            var _duckdb_web_query_run_buffer = Module["_duckdb_web_query_run_buffer"] = (a0, a1, a2, a3) => (_duckdb_web_query_run_buffer = Module["_duckdb_web_query_run_buffer"] = wasmExports["duckdb_web_query_run_buffer"])(a0, a1, a2, a3);
            var _duckdb_web_pending_query_start = Module["_duckdb_web_pending_query_start"] = (a0, a1, a2, a3) => (_duckdb_web_pending_query_start = Module["_duckdb_web_pending_query_start"] = wasmExports["duckdb_web_pending_query_start"])(a0, a1, a2, a3);
            var _duckdb_web_pending_query_start_buffer = Module["_duckdb_web_pending_query_start_buffer"] = (a0, a1, a2, a3, a4) => (_duckdb_web_pending_query_start_buffer = Module["_duckdb_web_pending_query_start_buffer"] = wasmExports["duckdb_web_pending_query_start_buffer"])(a0, a1, a2, a3, a4);
            var _duckdb_web_pending_query_poll = Module["_duckdb_web_pending_query_poll"] = (a0, a1, a2) => (_duckdb_web_pending_query_poll = Module["_duckdb_web_pending_query_poll"] = wasmExports["duckdb_web_pending_query_poll"])(a0, a1, a2);
            var _duckdb_web_pending_query_cancel = Module["_duckdb_web_pending_query_cancel"] = (a0, a1) => (_duckdb_web_pending_query_cancel = Module["_duckdb_web_pending_query_cancel"] = wasmExports["duckdb_web_pending_query_cancel"])(a0, a1);
            var _duckdb_web_query_fetch_results = Module["_duckdb_web_query_fetch_results"] = (a0, a1) => (_duckdb_web_query_fetch_results = Module["_duckdb_web_query_fetch_results"] = wasmExports["duckdb_web_query_fetch_results"])(a0, a1);
            var _duckdb_web_get_tablenames = Module["_duckdb_web_get_tablenames"] = (a0, a1, a2) => (_duckdb_web_get_tablenames = Module["_duckdb_web_get_tablenames"] = wasmExports["duckdb_web_get_tablenames"])(a0, a1, a2);
            var _duckdb_web_get_tablenames_buffer = Module["_duckdb_web_get_tablenames_buffer"] = (a0, a1, a2, a3) => (_duckdb_web_get_tablenames_buffer = Module["_duckdb_web_get_tablenames_buffer"] = wasmExports["duckdb_web_get_tablenames_buffer"])(a0, a1, a2, a3);
            var _duckdb_web_insert_arrow_from_ipc_stream = Module["_duckdb_web_insert_arrow_from_ipc_stream"] = (a0, a1, a2, a3, a4) => (_duckdb_web_insert_arrow_from_ipc_stream = Module["_duckdb_web_insert_arrow_from_ipc_stream"] = wasmExports["duckdb_web_insert_arrow_from_ipc_stream"])(a0, a1, a2, a3, a4);
            var _duckdb_web_insert_csv_from_path = Module["_duckdb_web_insert_csv_from_path"] = (a0, a1, a2, a3) => (_duckdb_web_insert_csv_from_path = Module["_duckdb_web_insert_csv_from_path"] = wasmExports["duckdb_web_insert_csv_from_path"])(a0, a1, a2, a3);
            var _duckdb_web_insert_json_from_path = Module["_duckdb_web_insert_json_from_path"] = (a0, a1, a2, a3) => (_duckdb_web_insert_json_from_path = Module["_duckdb_web_insert_json_from_path"] = wasmExports["duckdb_web_insert_json_from_path"])(a0, a1, a2, a3);
            var ___dl_seterr = (a0, a1) => (___dl_seterr = wasmExports["__dl_seterr"])(a0, a1);
            var __emscripten_timeout = (a0, a1) => (__emscripten_timeout = wasmExports["_emscripten_timeout"])(a0, a1);
            var _malloc = Module["_malloc"] = a0 => (_malloc = Module["_malloc"] = wasmExports["malloc"])(a0);
            var _free = Module["_free"] = a0 => (_free = Module["_free"] = wasmExports["free"])(a0);
            var _calloc = Module["_calloc"] = (a0, a1) => (_calloc = Module["_calloc"] = wasmExports["calloc"])(a0, a1);
            var _emscripten_builtin_memalign = (a0, a1) => (_emscripten_builtin_memalign = wasmExports["emscripten_builtin_memalign"])(a0, a1);
            var __emscripten_tempret_set = a0 => (__emscripten_tempret_set = wasmExports["_emscripten_tempret_set"])(a0);
            var __emscripten_tempret_get = () => (__emscripten_tempret_get = wasmExports["_emscripten_tempret_get"])();
            var __emscripten_stack_restore = a0 => (__emscripten_stack_restore = wasmExports["_emscripten_stack_restore"])(a0);
            var __emscripten_stack_alloc = a0 => (__emscripten_stack_alloc = wasmExports["_emscripten_stack_alloc"])(a0);
            var _emscripten_stack_get_current = () => (_emscripten_stack_get_current = wasmExports["emscripten_stack_get_current"])();

            function applySignatureConversions(wasmExports) {
                wasmExports = Object.assign({}, wasmExports);
                var makeWrapper_pp = f => a0 => f(a0) >>> 0;
                var makeWrapper_p = f => () => f() >>> 0;
                var makeWrapper_pppp = f => (a0, a1, a2) => f(a0, a1, a2) >>> 0;
                var makeWrapper_ppp = f => (a0, a1) => f(a0, a1) >>> 0;
                var makeWrapper_p_ = f => a0 => f(a0) >>> 0;
                var makeWrapper_pP = f => a0 => f(a0) >>> 0;
                wasmExports["__getTypeName"] = makeWrapper_pp(wasmExports["__getTypeName"]);
                wasmExports["pthread_self"] = makeWrapper_p(wasmExports["pthread_self"]);
                wasmExports["memcpy"] = makeWrapper_pppp(wasmExports["memcpy"]);
                wasmExports["malloc"] = makeWrapper_pp(wasmExports["malloc"]);
                wasmExports["calloc"] = makeWrapper_ppp(wasmExports["calloc"]);
                wasmExports["__errno_location"] = makeWrapper_p(wasmExports["__errno_location"]);
                wasmExports["strerror"] = makeWrapper_p_(wasmExports["strerror"]);
                wasmExports["emscripten_builtin_malloc"] = makeWrapper_pp(wasmExports["emscripten_builtin_malloc"]);
                wasmExports["emscripten_stack_get_base"] = makeWrapper_p(wasmExports["emscripten_stack_get_base"]);
                wasmExports["emscripten_stack_get_end"] = makeWrapper_p(wasmExports["emscripten_stack_get_end"]);
                wasmExports["emscripten_builtin_memalign"] = makeWrapper_ppp(wasmExports["emscripten_builtin_memalign"]);
                wasmExports["emscripten_stack_get_current"] = makeWrapper_p(wasmExports["emscripten_stack_get_current"]);
                wasmExports["emscripten_main_runtime_thread_id"] = makeWrapper_p(wasmExports["emscripten_main_runtime_thread_id"]);
                wasmExports["sbrk"] = makeWrapper_pP(wasmExports["sbrk"]);
                wasmExports["memalign"] = makeWrapper_ppp(wasmExports["memalign"]);
                wasmExports["emscripten_builtin_calloc"] = makeWrapper_ppp(wasmExports["emscripten_builtin_calloc"]);
                wasmExports["_emscripten_stack_alloc"] = makeWrapper_pp(wasmExports["_emscripten_stack_alloc"]);
                wasmExports["__cxa_get_exception_ptr"] = makeWrapper_pp(wasmExports["__cxa_get_exception_ptr"]);
                return wasmExports
            }
            Module["stackSave"] = stackSave;
            Module["stackRestore"] = stackRestore;
            Module["stackAlloc"] = stackAlloc;
            Module["getTempRet0"] = getTempRet0;
            Module["setTempRet0"] = setTempRet0;
            Module["ccall"] = ccall;
            Module["createDyncallWrapper"] = createDyncallWrapper;
            var calledRun;
            dependenciesFulfilled = function runCaller() {
                if (!calledRun) run();
                if (!calledRun) dependenciesFulfilled = runCaller
            };

            function callMain(args = []) {
                var entryFunction = resolveGlobalSymbol("main").sym;
                if (!entryFunction) return;
                args.unshift(thisProgram);
                var argc = args.length;
                var argv = stackAlloc((argc + 1) * 4);
                var argv_ptr = argv;
                args.forEach(arg => {
                    HEAPU32[argv_ptr >>> 2 >>> 0] = stringToUTF8OnStack(arg);
                    argv_ptr += 4
                });
                HEAPU32[argv_ptr >>> 2 >>> 0] = 0;
                try {
                    var ret = entryFunction(argc, argv);
                    exitJS(ret, true);
                    return ret
                } catch (e) {
                    return handleException(e)
                }
            }

            function run(args = arguments_) {
                if (runDependencies > 0) {
                    return
                }
                preRun();
                if (runDependencies > 0) {
                    return
                }

                function doRun() {
                    if (calledRun) return;
                    calledRun = true;
                    Module["calledRun"] = true;
                    if (ABORT) return;
                    initRuntime();
                    preMain();
                    readyPromiseResolve(Module);
                    Module["onRuntimeInitialized"]?.();
                    if (shouldRunNow) callMain(args);
                    postRun()
                }
                if (Module["setStatus"]) {
                    Module["setStatus"]("Running...");
                    setTimeout(() => {
                        setTimeout(() => Module["setStatus"](""), 1);
                        doRun()
                    }, 1)
                } else {
                    doRun()
                }
            }
            if (Module["preInit"]) {
                if (typeof Module["preInit"] == "function") Module["preInit"] = [Module["preInit"]];
                while (Module["preInit"].length > 0) {
                    Module["preInit"].pop()()
                }
            }
            var shouldRunNow = true;
            if (Module["noInitialRun"]) shouldRunNow = false;
            run();
            moduleRtn = readyPromise;


            return moduleRtn;
        }
    );
})();
if (typeof exports === 'object' && typeof module === 'object')
    module.exports = DuckDB;
else if (typeof define === 'function' && define['amd'])
    define([], () => DuckDB);
